// *****************************************************************************
// Hello 👋
//
// This file is automatically generated via the `yarn gql:update` command
//
// Please update the .graphql files inside src/graphql and then run that yarn
// command to refresh this file
// *****************************************************************************
import * as Apollo from '@apollo/client';
import {type DocumentNode as DocumentNode} from 'graphql';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>};
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {[_ in K]?: never};
export type Incremental<T> =
  T | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
const defaultOptions = {} as const;
type JSONValue = string | number | boolean | {[x: string]: JSONValue} | Array<JSONValue> | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {input: string; output: string};
  String: {input: string; output: string};
  Boolean: {input: boolean; output: boolean};
  Int: {input: number; output: number};
  Float: {input: number; output: number};
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: {input: string; output: string};
  /** iso8601 Date-only string, e.g. 2017-12-14 */
  Date: {input: string; output: string};
  /** iso8601 formatted date & timestamp */
  DateTime: {input: string; output: string};
  /** An ISO 8601-encoded date */
  ISO8601Date: {input: string; output: string};
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: {input: string; output: string};
  /** Represents untyped JSON */
  JSON: {input: JSONValue; output: JSONValue};
  /** Local time without timezone, e.g. 2:45pm would be 14:45:00 */
  LocalTime: {input: string; output: string};
  /** Integers from 0 onwards */
  NonNegativeInt: {input: number; output: number};
  /** Integers from 1 onwards */
  PositiveInt: {input: number; output: number};
  /** An ISO 8601-encoded date string with microsecond precision. */
  PreciseDateTime: {input: any; output: any};
  /** Local military time without timezone, e.g. 2:45pm would be 1445 */
  TimeWithoutZone: {input: number; output: number};
  /** iso8601 formatted date & timestamp in UTC */
  UTCTimestamp: {input: string; output: string};
  /** Universally unique identifier as defined by RFC 4122 */
  UUID: {input: string; output: string};
};

/** Autogenerated input type of ActivateRelishEmployee */
export type ActivateRelishEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of the Relish employee */
  employeeId: Scalars['ID']['input'];
};

/** Allowed values for activities category filter */
export enum ActivitiesCategoryFilterEnum {
  Adjustment = 'ADJUSTMENT',
  AppliedToInvoiceBalance = 'APPLIED_TO_INVOICE_BALANCE',
  CreditForCancelledOrder = 'CREDIT_FOR_CANCELLED_ORDER',
  CreditForModifiedOrder = 'CREDIT_FOR_MODIFIED_ORDER',
  Expired = 'EXPIRED',
  GivenForAccountCreation = 'GIVEN_FOR_ACCOUNT_CREATION',
  GivenForAppDownload = 'GIVEN_FOR_APP_DOWNLOAD',
  GivenForCatererSave = 'GIVEN_FOR_CATERER_SAVE',
  GivenForCatererSuggestion = 'GIVEN_FOR_CATERER_SUGGESTION',
  GivenForFirstMobileAppOrderPromo = 'GIVEN_FOR_FIRST_MOBILE_APP_ORDER_PROMO',
  GivenForIphoneAppRating = 'GIVEN_FOR_IPHONE_APP_RATING',
  GivenForOrderByCaterer = 'GIVEN_FOR_ORDER_BY_CATERER',
  GivenForOrderByEzcater = 'GIVEN_FOR_ORDER_BY_EZCATER',
  GivenForOrderThruReferral = 'GIVEN_FOR_ORDER_THRU_REFERRAL',
  GivenForRating = 'GIVEN_FOR_RATING',
  GivenForReferral = 'GIVEN_FOR_REFERRAL',
  GivenForReorder = 'GIVEN_FOR_REORDER',
  GivenForReview = 'GIVEN_FOR_REVIEW',
  GivenForTrustPilot = 'GIVEN_FOR_TRUST_PILOT',
  InvoiceBalanceAdjustment = 'INVOICE_BALANCE_ADJUSTMENT',
  PooledToCorpAccount = 'POOLED_TO_CORP_ACCOUNT',
  RedeemedViaCheque = 'REDEEMED_VIA_CHEQUE',
  ReviewRejected = 'REVIEW_REJECTED',
  UsedOnFood = 'USED_ON_FOOD',
  UsedOnGiftCard = 'USED_ON_GIFT_CARD',
}

/** Allowed values for ezRewards activity types */
export enum ActivityCategory {
  Adjustment = 'ADJUSTMENT',
  AppliedToInvoiceBalance = 'APPLIED_TO_INVOICE_BALANCE',
  CreditForCancelledOrder = 'CREDIT_FOR_CANCELLED_ORDER',
  CreditForModifiedOrder = 'CREDIT_FOR_MODIFIED_ORDER',
  Expired = 'EXPIRED',
  GivenForAccountCreation = 'GIVEN_FOR_ACCOUNT_CREATION',
  GivenForAppDownload = 'GIVEN_FOR_APP_DOWNLOAD',
  GivenForCatererSave = 'GIVEN_FOR_CATERER_SAVE',
  GivenForCatererSuggestion = 'GIVEN_FOR_CATERER_SUGGESTION',
  GivenForFirstMobileAppOrderPromo = 'GIVEN_FOR_FIRST_MOBILE_APP_ORDER_PROMO',
  GivenForIphoneAppRating = 'GIVEN_FOR_IPHONE_APP_RATING',
  GivenForOrderByCaterer = 'GIVEN_FOR_ORDER_BY_CATERER',
  GivenForOrderByEzcater = 'GIVEN_FOR_ORDER_BY_EZCATER',
  GivenForOrderThruReferral = 'GIVEN_FOR_ORDER_THRU_REFERRAL',
  GivenForRating = 'GIVEN_FOR_RATING',
  GivenForReferral = 'GIVEN_FOR_REFERRAL',
  GivenForReorder = 'GIVEN_FOR_REORDER',
  GivenForReview = 'GIVEN_FOR_REVIEW',
  GivenForTrustPilot = 'GIVEN_FOR_TRUST_PILOT',
  InvoiceBalanceAdjustment = 'INVOICE_BALANCE_ADJUSTMENT',
  PooledToCorpAccount = 'POOLED_TO_CORP_ACCOUNT',
  RedeemedViaCheque = 'REDEEMED_VIA_CHEQUE',
  ReviewRejected = 'REVIEW_REJECTED',
  UsedOnFood = 'USED_ON_FOOD',
  UsedOnGiftCard = 'USED_ON_GIFT_CARD',
}

/** The list of all possible activity types */
export enum ActivityTypeEnum {
  ChangeLog = 'CHANGE_LOG',
  Note = 'NOTE',
}

/** The role of the person performing an action or viewing data */
export enum ActorTypes {
  /** admin user */
  AdminUser = 'ADMIN_USER',
  /** caterer account */
  CatererAccount = 'CATERER_ACCOUNT',
  /** customer account */
  Customer = 'CUSTOMER',
  /** system */
  System = 'SYSTEM',
}

/** Input arguments required to attach a customer to a house account */
export type AddCustomerToHouseAccountInput = {
  customerId: Scalars['ID']['input'];
  houseAccountId: Scalars['ID']['input'];
};

/** Input arguments required to attach a lead to a house account */
export type AddLeadToHouseAccountInput = {
  houseAccountId: Scalars['ID']['input'];
  leadId: Scalars['ID']['input'];
};

/** Secondary issues that can be reported by a user */
export enum AdditionalIssue {
  DeliveryTime = 'DELIVERY_TIME',
  FoodQualityOrPreparation = 'FOOD_QUALITY_OR_PREPARATION',
  MissingOrIncorrectItems = 'MISSING_OR_INCORRECT_ITEMS',
  ProblemWithDriver = 'PROBLEM_WITH_DRIVER',
  SomethingElse = 'SOMETHING_ELSE',
}

/** Allowed values for address filtering */
export enum AddressFilterEnum {
  All = 'ALL',
  ConsumerAccount = 'CONSUMER_ACCOUNT',
  CorporateAccount = 'CORPORATE_ACCOUNT',
}

/** Input arguments required to create an address */
export type AddressInput = {
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

/** Allowed values for sorting a list of address objects. */
export enum AddressSortFields {
  LastUsedAt = 'LAST_USED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
}

/** Allowed values for the app field */
export enum AppIdentifier {
  AndroidConsumer = 'android_consumer',
  IosConsumer = 'ios_consumer',
}

/** Autogenerated input type of AssignCompanyAdmin */
export type AssignCompanyAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of the Relish employee */
  employeeId: Scalars['ID']['input'];
};

/** Autogenerated input type of AssignDriver */
export type AssignDriverInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery to be assigned to */
  deliveryId: Scalars['ID']['input'];
  /** ID of the driver to be assigned */
  driverId: Scalars['ID']['input'];
  /** The source of where the driver assignment occured */
  source?: InputMaybe<SelfAssignSource>;
};

/** Autogenerated input type of AssignDropAdmin */
export type AssignDropAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of a Relish drop */
  dropId: Scalars['ID']['input'];
  /** ID of the Relish employee */
  employeeId: Scalars['ID']['input'];
};

/** Whether a caterer has auto-accept enabled or disabled */
export enum AutoAcceptStatusEnum {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
}

/** Auto bidding goal for campaign optimization */
export enum AutoBidGoalEnum {
  /** Balanced approach */
  Balanced = 'BALANCED',
  /** Conservative spend with high return */
  Efficiency = 'EFFICIENCY',
  /** Aggressive spend for higher reach */
  Visibility = 'VISIBILITY',
}

/** The status of potential auto intervention based on performance metrics */
export enum AutoInterventionStatusType {
  Active = 'ACTIVE',
  Paused = 'PAUSED',
  Unpaused = 'UNPAUSED',
  Warned = 'WARNED',
}

/** Required and optional fields used to build a company */
export type BankAccountCompanyInput = {
  name: Scalars['String']['input'];
};

/** The type of legal filing for the business. */
export enum BankAccountIncorporation {
  Inc = 'INC',
  Llc = 'LLC',
  Llp = 'LLP',
  Ltd = 'LTD',
  NonProfit = 'NON_PROFIT',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
}

/** Required and optional fields used to build an individual bank account */
export type BankAccountIndividualInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
};

/** Required and optional fields used to create a new BankAccount */
export type BankAccountInput = {
  accountNumber: Scalars['String']['input'];
  address: AddressInput;
  bankAccountOwnerUuid: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  company?: InputMaybe<BankAccountCompanyInput>;
  individual?: InputMaybe<BankAccountIndividualInput>;
  purpose: BankAccountPurpose;
  routingNumber: Scalars['String']['input'];
  type: BankAccountType;
};

/** Required and optional fields used to build a company bank account owner */
export type BankAccountOwnerCompanyInput = {
  incorporationType: BankAccountIncorporation;
};

/** Required and optional fields used to build an individual bank account owner */
export type BankAccountOwnerIndividualInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

/** Required and optional fields used to create a new bank account owner */
export type BankAccountOwnerInput = {
  address: AddressInput;
  businessName: Scalars['String']['input'];
  company?: InputMaybe<BankAccountOwnerCompanyInput>;
  federalTaxId: Scalars['String']['input'];
  individual?: InputMaybe<BankAccountOwnerIndividualInput>;
  type: BankAccountOwnerType;
};

/** The type of payee. */
export enum BankAccountOwnerType {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL',
}

/** The payment vendor used to process the payment */
export enum BankAccountPaymentVendor {
  Hyperwallet = 'HYPERWALLET',
  Payoneer = 'PAYONEER',
}

/** Bank Account Purpose */
export enum BankAccountPurpose {
  Checking = 'CHECKING',
  Savings = 'SAVINGS',
}

/** The type of bank account. */
export enum BankAccountType {
  Business = 'BUSINESS',
  Individual = 'INDIVIDUAL',
}

/** The status of the payment */
export enum BankAccountVendorPaymentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotTransmitted = 'NOT_TRANSMITTED',
  PaymentFailed = 'PAYMENT_FAILED',
  RequestFailed = 'REQUEST_FAILED',
  Transmitted = 'TRANSMITTED',
}

/** The registration status of the bank account at a payment vendor */
export enum BankAccountVendorStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Error = 'ERROR',
  Pending = 'PENDING',
  PendingKyc = 'PENDING_KYC',
}

export type BenchmarkFilterInput = {
  endDate: Scalars['Date']['input'];
  entityIds: Array<Scalars['ID']['input']>;
  entityType: EntityTypeEnum;
  startDate: Scalars['Date']['input'];
};

/** Budget types that are available to concierge customers */
export enum Budget {
  FlatRate = 'FLAT_RATE',
  PerPerson = 'PER_PERSON',
}

/** Which copy treatment the UI should render alongside a budget recommendation */
export enum BudgetRecommendationCopyVariantEnum {
  /** The store has no order history to anchor against */
  ColdStart = 'COLD_START',
  /** The recommendation covers more than one selected store */
  MultiStore = 'MULTI_STORE',
  /** The store has enough order history to anchor the recommendation to itself */
  SelfAnchored = 'SELF_ANCHORED',
}

/** Which advice category a campaign budget nudge's recommendation belongs to */
export enum CampaignBudgetAdviceCategoryEnum {
  /** Raise a campaign's weekly spending limit */
  BudgetIncrease = 'BUDGET_INCREASE',
  /** Combine campaigns into a single campaign with a recommended weekly spending limit */
  BudgetIncreaseConsolidation = 'BUDGET_INCREASE_CONSOLIDATION',
  /** Change a campaign's spending strategy */
  SpendingStrategy = 'SPENDING_STRATEGY',
  /** Combine campaigns into a single campaign under a shared spending strategy */
  SpendingStrategyConsolidation = 'SPENDING_STRATEGY_CONSOLIDATION',
}

/** Status of a campaign */
export enum CampaignStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

/** Allowed values for sorting campaign stores */
export enum CampaignStoreSortField {
  AdSales = 'AD_SALES',
  AdSpend = 'AD_SPEND',
  Brand = 'BRAND',
  ConversionRate = 'CONVERSION_RATE',
  Orders = 'ORDERS',
  Roas = 'ROAS',
  State = 'STATE',
  StoreAddress = 'STORE_ADDRESS',
  StoreNumber = 'STORE_NUMBER',
}

/** Arguments for sorting campaign stores */
export type CampaignStoreSortInput = {
  direction: SortDirection;
  field: CampaignStoreSortField;
};

/** Autogenerated input type of CancelAllRequests */
export type CancelAllRequestsInput = {
  cancelledById?: InputMaybe<Scalars['ID']['input']>;
  cancelledByType?: InputMaybe<ActorTypes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  /** @deprecated use cancelledById instead */
  requesterId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated use cancelledByType instead */
  requesterType?: InputMaybe<ActorTypes>;
};

/** Autogenerated input type of CancelCompanyCoupon */
export type CancelCompanyCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Relish company coupon */
  companyCouponId: Scalars['ID']['input'];
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
};

/** Autogenerated input type of CancelEmployeeOrder */
export type CancelEmployeeOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of the Relish employee order */
  employeeOrderId: Scalars['ID']['input'];
};

/** Autogenerated input type of CancelRequest */
export type CancelRequestInput = {
  cancelledById?: InputMaybe<Scalars['ID']['input']>;
  cancelledByType?: InputMaybe<ActorTypes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
  /** @deprecated use cancelledById instead */
  requesterId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated use cancelledByType instead */
  requesterType?: InputMaybe<ActorTypes>;
};

/** Entities that can cancel an order */
export enum CancelledByEnum {
  Caterer = 'CATERER',
  Customer = 'CUSTOMER',
  Ezcater = 'EZCATER',
  TpdPartner = 'TPD_PARTNER',
}

/** Reasons an order was cancelled */
export enum CancelledByReasonEnum {
  AssignNewDoordashDriver = 'ASSIGN_NEW_DOORDASH_DRIVER',
  AttendanceChange = 'ATTENDANCE_CHANGE',
  AtDailyCapacity = 'AT_DAILY_CAPACITY',
  AtHourlyCapacity = 'AT_HOURLY_CAPACITY',
  BetterOptionFound = 'BETTER_OPTION_FOUND',
  BudgetReasons = 'BUDGET_REASONS',
  CancelledAccount = 'CANCELLED_ACCOUNT',
  CatererRequestedToCancelEzdispatchLessThan_2HoursOut = 'CATERER_REQUESTED_TO_CANCEL_EZDISPATCH_LESS_THAN_2_HOURS_OUT',
  CatererUnableToApproveLastMinModification = 'CATERER_UNABLE_TO_APPROVE_LAST_MIN_MODIFICATION',
  ChangedMind = 'CHANGED_MIND',
  ChangeFromDeliveryToTakeout = 'CHANGE_FROM_DELIVERY_TO_TAKEOUT',
  ChangeInEventDate = 'CHANGE_IN_EVENT_DATE',
  CommissionOrFeesTooHigh = 'COMMISSION_OR_FEES_TOO_HIGH',
  CustomerApprovalNotReceived = 'CUSTOMER_APPROVAL_NOT_RECEIVED',
  CustomerDoesNotWantEzDispatch = 'CUSTOMER_DOES_NOT_WANT_EZ_DISPATCH',
  DateChangeNoDupeNeeded = 'DATE_CHANGE_NO_DUPE_NEEDED',
  DidNotMeanToOrder = 'DID_NOT_MEAN_TO_ORDER',
  DistanceTooFar = 'DISTANCE_TOO_FAR',
  DoesNotOfferTakeOutOrDelivery = 'DOES_NOT_OFFER_TAKE_OUT_OR_DELIVERY',
  DoesNotRememberSigningUpForEzcater = 'DOES_NOT_REMEMBER_SIGNING_UP_FOR_EZCATER',
  DontRememberSigningUpForEzcater = 'DONT_REMEMBER_SIGNING_UP_FOR_EZCATER',
  EmergencyClosure = 'EMERGENCY_CLOSURE',
  EventCancelled = 'EVENT_CANCELLED',
  FoundDifferentCaterer = 'FOUND_DIFFERENT_CATERER',
  Fraudulent = 'FRAUDULENT',
  FraudulentCp = 'FRAUDULENT_CP',
  FraudulentCustomer = 'FRAUDULENT_CUSTOMER',
  HolidayClosure = 'HOLIDAY_CLOSURE',
  LackOfInventory = 'LACK_OF_INVENTORY',
  LeadTimeTooShortToDeliver = 'LEAD_TIME_TOO_SHORT_TO_DELIVER',
  LeadTimeTooShortToPrepare = 'LEAD_TIME_TOO_SHORT_TO_PREPARE',
  LegacyOrder = 'LEGACY_ORDER',
  LocationClosed = 'LOCATION_CLOSED',
  LowerOfferFromRestaurant = 'LOWER_OFFER_FROM_RESTAURANT',
  MenuChangeOrUpcharge = 'MENU_CHANGE_OR_UPCHARGE',
  MenuIncorrect = 'MENU_INCORRECT',
  MissingCustomerContactInformation = 'MISSING_CUSTOMER_CONTACT_INFORMATION',
  ModificationNeeded = 'MODIFICATION_NEEDED',
  NegativeEzcaterExperience = 'NEGATIVE_EZCATER_EXPERIENCE',
  NoneProvided = 'NONE_PROVIDED',
  NotEnoughDrivers = 'NOT_ENOUGH_DRIVERS',
  NotEnoughNotice = 'NOT_ENOUGH_NOTICE',
  NotEnoughNoticeToDeliver = 'NOT_ENOUGH_NOTICE_TO_DELIVER',
  NotEnoughNoticeToPrepare = 'NOT_ENOUGH_NOTICE_TO_PREPARE',
  NoDriversAvailable = 'NO_DRIVERS_AVAILABLE',
  NoDriverAvailable = 'NO_DRIVER_AVAILABLE',
  NoTip = 'NO_TIP',
  OnVacation = 'ON_VACATION',
  Other = 'OTHER',
  OutOfBusiness = 'OUT_OF_BUSINESS',
  OwnershipChanged = 'OWNERSHIP_CHANGED',
  PaymentIssues = 'PAYMENT_ISSUES',
  /** @deprecated use out_of_business instead */
  PermanentlyClosed = 'PERMANENTLY_CLOSED',
  ReasonNotListed = 'REASON_NOT_LISTED',
  ReasonNotProvided = 'REASON_NOT_PROVIDED',
  RemoveEzdispatchFromTheOrder = 'REMOVE_EZDISPATCH_FROM_THE_ORDER',
  RestaurantCannotAccommodate = 'RESTAURANT_CANNOT_ACCOMMODATE',
  SickOrIllness = 'SICK_OR_ILLNESS',
  StaffShortage = 'STAFF_SHORTAGE',
  StoreChange = 'STORE_CHANGE',
  TechnicalIssue = 'TECHNICAL_ISSUE',
  TemporarilyClosed = 'TEMPORARILY_CLOSED',
  TooBusy = 'TOO_BUSY',
  TooFar = 'TOO_FAR',
  UnableToDeliver = 'UNABLE_TO_DELIVER',
  UnableToPrepare = 'UNABLE_TO_PREPARE',
  UnforeseenCircumstances = 'UNFORESEEN_CIRCUMSTANCES',
  UnprofessionalCaterer = 'UNPROFESSIONAL_CATERER',
  UnprofessionalDriver = 'UNPROFESSIONAL_DRIVER',
  UnresponsiveCaterer = 'UNRESPONSIVE_CATERER',
  Weather = 'WEATHER',
  WrongDeliveryFee = 'WRONG_DELIVERY_FEE',
  WrongDeliveryTime = 'WRONG_DELIVERY_TIME',
  WrongHours = 'WRONG_HOURS',
  WrongMenuPrices = 'WRONG_MENU_PRICES',
  WrongMinimum = 'WRONG_MINIMUM',
  WrongOrderInfo = 'WRONG_ORDER_INFO',
  WrongStoreHours = 'WRONG_STORE_HOURS',
}

/** Allowed values for capacity limit types */
export enum CapacityLimit {
  Daily = 'DAILY',
  MealTime = 'MEAL_TIME',
}

/** Allowed values credit card type field */
export enum CardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Blank = 'BLANK',
  Discover = 'DISCOVER',
  Master = 'MASTER',
  Visa = 'VISA',
}

/** Defines the type of carousel based on its scheduling and display behavior */
export enum CarouselType {
  /** Carousels used for experiments */
  Experiment = 'EXPERIMENT',
  /** Carousels that appear on a schedule */
  Scheduled = 'SCHEDULED',
}

/** The category of a menu item, such as dietary entree, side, dessert, or drink. */
export enum Category {
  Dessert = 'DESSERT',
  DietaryEntree = 'DIETARY_ENTREE',
  Drink = 'DRINK',
  Entree = 'ENTREE',
  Other = 'OTHER',
  Side = 'SIDE',
}

/** Allowed values for filtering a list of a caterer's customers. */
export enum CatererAccountCustomersFilter {
  Happy = 'HAPPY',
  LastYearLargeOrder = 'LAST_YEAR_LARGE_ORDER',
  Sleepy = 'SLEEPY',
  TopSpenders = 'TOP_SPENDERS',
  Unhappy = 'UNHAPPY',
}

/** Allowed values for sorting a caterer account's customers data. */
export enum CatererAccountCustomersSortField {
  Email = 'EMAIL',
  FirstOrderDate = 'FIRST_ORDER_DATE',
  FirstOrderSource = 'FIRST_ORDER_SOURCE',
  Name = 'NAME',
  OrderCount = 'ORDER_COUNT',
}

/** Arguments for sorting a list of customers for a caterer account. */
export type CatererAccountCustomersSortInput = {
  direction: SortDirection;
  field: CatererAccountCustomersSortField;
};

/** Allowed values for sorting a caterer account's list of stores */
export enum CatererAccountStoreSortField {
  Address = 'ADDRESS',
  AutoAcceptStatus = 'AUTO_ACCEPT_STATUS',
  AvailableCredits = 'AVAILABLE_CREDITS',
  BrandName = 'BRAND_NAME',
  /**
   * Sorts by cancellation fee percentage (lowest first in ASC, highest first in
   * DESC). Caterers with no cancellation policy row sort as if they have the
   * default fee of 25%, consistent with the value shown in the UI.
   */
  CancellationPolicy = 'CANCELLATION_POLICY',
  /**
   * Sorts by upper bound capacity across all days, then by lower bound. No-max
   * (unlimited) bounds sort as the highest value (last in ASC, first in DESC), so
   * a store with no max on both bounds sorts ahead of one with only an unlimited
   * upper bound. Remaining ties sort by store id.
   */
  CapacityLimit = 'CAPACITY_LIMIT',
  City = 'CITY',
  /**
   * Sorts by whether the store has a sponsored listing campaign running today,
   * matching activeSupplierMarketingCampaigns. Stores with no active campaign sort
   * first in ASC, last in DESC.
   */
  HasSponsoredListingCampaign = 'HAS_SPONSORED_LISTING_CAMPAIGN',
  /** Sorts by the count of holiday closures. */
  HolidayClosures = 'HOLIDAY_CLOSURES',
  /**
   * Sorts by the most recent in-scope settings edit (oldest first in ASC, newest
   * first in DESC). Stores with no edit history sort by their onboarding date
   * (live_commissioned_on) instead, consistent with the value shown in the UI;
   * stores with neither sort last in both directions (NULLS LAST). Orders on the
   * raw UTC instant, never a timezone-localized value, so sort order can't diverge
   * from the displayed date (localization is display-only).
   */
  LastEdited = 'LAST_EDITED',
  /**
   * Sorts stores by effective lead time, soonest to latest, across all lead-time
   * styles (same-day, multiple-days, and cutoff-time "Day before"). Ascending
   * orders soonest -> latest; descending is the exact reverse.
   */
  LeadTime = 'LEAD_TIME',
  /**
   * Sorts by modification_cutoff_hours (shortest window first in ASC, longest
   * first in DESC). Caterers with no modification policy row sort as if they have
   * the default cutoff of 6 hours, consistent with the value shown in the UI.
   */
  ModificationCutoff = 'MODIFICATION_CUTOFF',
  Nickname = 'NICKNAME',
  State = 'STATE',
  StoreNumber = 'STORE_NUMBER',
  /**
   * Sorts by the count of current and upcoming marketplace temporary closures
   * (fewest first in ASC, most first in DESC). Relish-only closures are not
   * counted, matching the Temporary closures column in the store-settings table.
   */
  TemporaryClosures = 'TEMPORARY_CLOSURES',
  UpdatedAt = 'UPDATED_AT',
  Zip = 'ZIP',
}

/** Arguments for sorting a list of stores for a caterer account. */
export type CatererAccountStoreSortInput = {
  direction: SortDirection;
  field: CatererAccountStoreSortField;
};

/** The available methods for caterer_confirmation notifications and whether or not the user is subscribed */
export type CatererConfirmationNotificationSubscriptionsInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Status of a caterer dispute */
export enum CatererDisputeStatus {
  /** Dispute has been approved */
  Approved = 'APPROVED',
  /** Dispute has been denied */
  Denied = 'DENIED',
  /** Dispute resulted in a partial outcome */
  Partial = 'PARTIAL',
  /** Dispute resulted in a partial refund */
  PartialRefund = 'PARTIAL_REFUND',
  /** Dispute is pending review */
  Pending = 'PENDING',
}

/** Different types of information messages that can be displayed on an order */
export enum CatererOrderMessagesEnum {
  CancellationConfirmedByCaterer = 'CANCELLATION_CONFIRMED_BY_CATERER',
  /** @deprecated This is being deprecated without any alternative. */
  NeedsAcceptanceAfterThirdPartyDeliveryFailed = 'NEEDS_ACCEPTANCE_AFTER_THIRD_PARTY_DELIVERY_FAILED',
  Note = 'NOTE',
  PcpTrialExpired = 'PCP_TRIAL_EXPIRED',
  Rejected = 'REJECTED',
  Revised = 'REVISED',
  StandardGroupOrder = 'STANDARD_GROUP_ORDER',
  /** @deprecated This is being deprecated without any alternative. */
  ThirdPartyDeliveryRequested = 'THIRD_PARTY_DELIVERY_REQUESTED',
  /** @deprecated This is being deprecated without any alternative. Only orders fulfilled before 2020-07-21 have the potential to contain this. */
  ThirdPartyDeliveryRequestAccepted = 'THIRD_PARTY_DELIVERY_REQUEST_ACCEPTED',
}

/** Allowed values for the order sort field */
export enum CatererOrderSortField {
  EventAt = 'EVENT_AT',
}

/** Allowed values for an order's status */
export enum CatererOrderStatusEnum {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  ChangesRequested = 'changes_requested',
  Completed = 'completed',
  FoodDelivered = 'food_delivered',
  FoodPrepped = 'food_prepped',
  NeedsAcceptance = 'needs_acceptance',
  NeedsAcknowledgement = 'needs_acknowledgement',
  NeedsConfirmCancellation = 'needs_confirm_cancellation',
  NeedsConfirmModification = 'needs_confirm_modification',
  NeedsDriverAssignment = 'needs_driver_assignment',
  NeedsFoodPrep = 'needs_food_prep',
  New = 'new',
  Paid = 'paid',
  PaymentFailed = 'payment_failed',
  PendingPayment = 'pending_payment',
  Rejected = 'rejected',
  /** @deprecated This is being deprecated without any alternative. */
  ThirdPartyDeliveryRequested = 'third_party_delivery_requested',
}

/** The reasons for pausing a caterer */
export enum CatererPauseReasons {
  Cancellations = 'CANCELLATIONS',
  Compliance = 'COMPLIANCE',
  FoodNotReady = 'FOOD_NOT_READY',
  LienNegotiations = 'LIEN_NEGOTIATIONS',
  MetricsReset = 'METRICS_RESET',
  OwnershipTransfer = 'OWNERSHIP_TRANSFER',
  PaymentUpdates = 'PAYMENT_UPDATES',
  Performance = 'PERFORMANCE',
  ProlongedTempClosure = 'PROLONGED_TEMP_CLOSURE',
  Rejections = 'REJECTIONS',
  SuspectedFraud = 'SUSPECTED_FRAUD',
  SuspectedNonCommercialKitchen = 'SUSPECTED_NON_COMMERCIAL_KITCHEN',
  SuspectedOob = 'SUSPECTED_OOB',
  SuspectedOobCancelReject = 'SUSPECTED_OOB_CANCEL_REJECT',
  SuspectedOobGoogle = 'SUSPECTED_OOB_GOOGLE',
  SuspectedOobYelp = 'SUSPECTED_OOB_YELP',
  Timeliness = 'TIMELINESS',
  VirtualBrand = 'VIRTUAL_BRAND',
}

/** The current status of a caterer report */
export enum CatererReportStatus {
  Completed = 'COMPLETED',
  Downloaded = 'DOWNLOADED',
  Processing = 'PROCESSING',
}

/** Why a caterer appears in the retargeting carousel */
export enum CatererRetargetingCategoryEnum {
  RecentlyOrdered = 'RECENTLY_ORDERED',
  RecentlyViewed = 'RECENTLY_VIEWED',
  Saved = 'SAVED',
}

/** Required and optional fields used to build an address */
export type CatererSearchAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Allowed values for extended service options */
export enum CatererSearchExtendedServiceOption {
  OnSiteAttendant = 'ON_SITE_ATTENDANT',
  TakedownService = 'TAKEDOWN_SERVICE',
}

/** Caterer Search filter options */
export enum CatererSearchFilter {
  All = 'ALL',
  /** Caterers that are open and have food that can be served to meet the deadline */
  Available = 'AVAILABLE',
  /** Caterers that are Available and have food that pass the search filters (dietary, price, etc) */
  Viewable = 'VIEWABLE',
}

/** Allowed values for order type */
export enum CatererSearchOrderType {
  Delivery = 'DELIVERY',
  Takeout = 'TAKEOUT',
}

/** Allowed values for the CPP rewards filter in caterer search */
export enum CatererSearchRewardsLevel {
  Five = 'FIVE',
  Four = 'FOUR',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO',
}

/** Allowed values for the star rating filter in caterer search */
export enum CatererSearchStarRating {
  Five = 'FIVE',
  Four = 'FOUR',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO',
}

/** Allowed values for sorting a list of caterer objects. */
export enum CatererSortFields {
  Address = 'ADDRESS',
  BrandName = 'BRAND_NAME',
  City = 'CITY',
  State = 'STATE',
  StoreNickname = 'STORE_NICKNAME',
  StoreNumber = 'STORE_NUMBER',
  UpdatedAt = 'UPDATED_AT',
  Zip = 'ZIP',
}

/** Input used to sort a list of caterer objects. */
export type CatererSortInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<CatererSortFields>;
};

/** Allowed values for a CatererSubmittedOrderMetadatum payment method */
export enum CatererSubmittedOrderMetadatumPaymentMethod {
  CreditCard = 'CREDIT_CARD',
  HouseAccount = 'HOUSE_ACCOUNT',
  Invoice = 'INVOICE',
  InStore = 'IN_STORE',
  LineOfCredit = 'LINE_OF_CREDIT',
}

/** Allowed values for payment method type */
export enum CatererVendorPaymentTypeEnum {
  Ach = 'ACH',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD',
  ManualCheck = 'MANUAL_CHECK',
  NoPayment = 'NO_PAYMENT',
  OneOffCheck = 'ONE_OFF_CHECK',
}

/** Allowed selections for the desired meal type while generating catering packages. (DEPRECATED) */
export enum CateringPackageMeal {
  Breakfast = 'BREAKFAST',
  Lunch = 'LUNCH',
}

/** Autogenerated input type of ChangeDriver */
export type ChangeDriverInput = {
  /** ID of the driver to be assigned */
  assignDriverId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery to be assigned to */
  deliveryId: Scalars['ID']['input'];
  /** ID of the driver to be unassigned */
  unassignDriverId: Scalars['ID']['input'];
};

/** The list of events logged in the change log */
export enum ChangeLogEventTypeEnum {
  Create = 'create',
  Destroy = 'destroy',
  LeadConvertedToCustomer = 'lead_converted_to_customer',
  Update = 'update',
}

/** Allowed values for the channel name field */
export enum ChannelNameEnum {
  ClubSoda = 'CLUB_SODA',
  DirectEntry = 'DIRECT_ENTRY',
  EzOrdering = 'EZ_ORDERING',
  Give = 'GIVE',
  Marketplace = 'MARKETPLACE',
}

/** Allowed values for checkout error code. */
export enum CheckoutErrorCode {
  CatererClosed = 'CATERER_CLOSED',
  CatererNotLive = 'CATERER_NOT_LIVE',
  ChoiceUnavailable = 'CHOICE_UNAVAILABLE',
  ClosedForHoliday = 'CLOSED_FOR_HOLIDAY',
  ClosedForVacation = 'CLOSED_FOR_VACATION',
  CreditCardMissingZipCode = 'CREDIT_CARD_MISSING_ZIP_CODE',
  EventInPast = 'EVENT_IN_PAST',
  EzRewardsDisabled = 'EZ_REWARDS_DISABLED',
  FraudCheckFailed = 'FRAUD_CHECK_FAILED',
  ItemUnavailable = 'ITEM_UNAVAILABLE',
  ModificationOrderCancelled = 'MODIFICATION_ORDER_CANCELLED',
  NoAddressCity = 'NO_ADDRESS_CITY',
  NoAddressOfficeName = 'NO_ADDRESS_OFFICE_NAME',
  NoAddressOnsiteName = 'NO_ADDRESS_ONSITE_NAME',
  NoAddressOnsitePhone = 'NO_ADDRESS_ONSITE_PHONE',
  NoAddressState = 'NO_ADDRESS_STATE',
  NoAddressStreet1 = 'NO_ADDRESS_STREET1',
  NoAddressZip = 'NO_ADDRESS_ZIP',
  NoBusinessOrders = 'NO_BUSINESS_ORDERS',
  NoEventAt = 'NO_EVENT_AT',
  NoEventDate = 'NO_EVENT_DATE',
  NoEventTime = 'NO_EVENT_TIME',
  NoPaymentMethod = 'NO_PAYMENT_METHOD',
  NoResidentialOrders = 'NO_RESIDENTIAL_ORDERS',
  NoShortNoticeChoice = 'NO_SHORT_NOTICE_CHOICE',
  NoUserAssigned = 'NO_USER_ASSIGNED',
  OrderAlreadySubmitted = 'ORDER_ALREADY_SUBMITTED',
  OutOfDeliveryArea = 'OUT_OF_DELIVERY_AREA',
  OverCorpSpendingLimit = 'OVER_CORP_SPENDING_LIMIT',
  OverGroupOrderTotalBudget = 'OVER_GROUP_ORDER_TOTAL_BUDGET',
  PastApprovalDeadline = 'PAST_APPROVAL_DEADLINE',
  PastCatererCutoff = 'PAST_CATERER_CUTOFF',
  PastItemCutoff = 'PAST_ITEM_CUTOFF',
  PaymentGroupNotAuthorized = 'PAYMENT_GROUP_NOT_AUTHORIZED',
  PaymentNotAuthorized = 'PAYMENT_NOT_AUTHORIZED',
  PaymentNotAvailable = 'PAYMENT_NOT_AVAILABLE',
  PromoInvalid = 'PROMO_INVALID',
  SubmitFailed = 'SUBMIT_FAILED',
  TakeoutOnly = 'TAKEOUT_ONLY',
  TaxExemptionInvalid = 'TAX_EXEMPTION_INVALID',
  UnderCatererMinimum = 'UNDER_CATERER_MINIMUM',
  Unknown = 'UNKNOWN',
}

/** Available communication roles that can be assigned to contacts */
export enum CommunicationRoleEnum {
  /** Compensation Contact */
  CompensationContact = 'COMPENSATION_CONTACT',
}

export enum ComparatorTargetEnum {
  NearbyRestaurants = 'NEARBY_RESTAURANTS',
  PriorYear = 'PRIOR_YEAR',
}

/** Autogenerated input type of CompleteMessageThread */
export type CompleteMessageThreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completedById: Scalars['ID']['input'];
  completedByType: ActorTypes;
  orderInfo: OrderInfoInput;
};

/** Autogenerated input type of CompleteRequest */
export type CompleteRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
};

/** Add-ons that are available to concierge customers */
export enum ConciergeAddOn {
  Desserts = 'DESSERTS',
  Drinks = 'DRINKS',
  Ice = 'ICE',
  Tableware = 'TABLEWARE',
}

/** The status of a user in their corporate account's Concur Enterprise system */
export enum ConcurEnterpriseUserStatus {
  /** User has been found in Concur Enterprise */
  Found = 'FOUND',
  /** User was checked but not found in Concur Enterprise */
  NotFound = 'NOT_FOUND',
  /** User has not yet been checked in Concur Enterprise */
  Unknown = 'UNKNOWN',
}

/** How likely it is that a user has a concur account and why */
export enum ConcurLikeliness {
  CorpAccount = 'CORP_ACCOUNT',
  Definite = 'DEFINITE',
  EmailDomain = 'EMAIL_DOMAIN',
  Unknown = 'UNKNOWN',
}

/** Allowed Concur order statuses */
export enum ConcurOrderStatus {
  Available = 'AVAILABLE',
  Failed = 'FAILED',
  PaidWithCreditLine = 'PAID_WITH_CREDIT_LINE',
  Pending = 'PENDING',
  Sent = 'SENT',
  TooOld = 'TOO_OLD',
}

/**
 * Normalized filter-value type for a Concur roster sync filterable attribute.
 * Concur's capitalized FormFields data types are normalized to these values.
 */
export enum ConcurRosterSyncFilterDataType {
  Boolean = 'BOOLEAN',
  Integer = 'INTEGER',
  /** Backed by a Concur list; filter values are list-item UUIDs. */
  List = 'LIST',
  String = 'STRING',
}

/** A single Concur roster-sync filter: an attribute and the values a user must match to be included */
export type ConcurRosterSyncFilterInput = {
  /** Concur data type for the attribute (e.g. string, list, integer, boolean) */
  dataType: Scalars['String']['input'];
  /** Human-readable label for the attribute */
  fieldLabel: Scalars['String']['input'];
  /**
   * Attribute identifier from concurRosterSyncFilterableAttributes (SCIM path for
   * standard attributes, Concur field id for custom fields)
   */
  filterAttribute: Scalars['String']['input'];
  /** Whether this is a custom Concur (Spend) field rather than a standard SCIM attribute */
  isCustomField: Scalars['Boolean']['input'];
  /** Values a user must match for this attribute (OR'd within the attribute) */
  values: Array<ConcurRosterSyncFilterValueInput>;
};

/** A selectable value for a Concur roster-sync filter */
export type ConcurRosterSyncFilterValueInput = {
  /** Human-readable display label for the value */
  label: Scalars['String']['input'];
  /** Filter operand persisted for matching (list-item UUID for list fields, literal value otherwise) */
  value: Scalars['String']['input'];
};

/** For creating ConsumerCartItems and associating with a ConsumerCart */
export type ConsumerCartAddItemInput = {
  /** The UUID of the caterer menu item. */
  menuItemId: Scalars['ID']['input'];
  modifiers?: InputMaybe<Array<ConsumerCartModifierInput>>;
  options?: InputMaybe<Array<ConsumerCartOptionInput>>;
  /** The price of a single unit of this item */
  price?: InputMaybe<MoneyInput>;
  productCatalog?: InputMaybe<ProductCatalog>;
  quantity: Scalars['Int']['input'];
  /** The size selected from the catering menu items sizes. */
  size: Scalars['String']['input'];
  /** Special instructions for item preparation. */
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  vegetarianQuantity?: InputMaybe<Scalars['Int']['input']>;
};

/** For creating a ConsumerCart and a FulfillmentDetail. */
export type ConsumerCartAndFulfillmentDetailCreateInput = {
  consumerCartCreateInput: ConsumerCartCreateInput;
  fulfillmentDetailCreateInput: FulfillmentDetailCreateInput;
};

/** Input type for a choice */
export type ConsumerCartChoiceInput = {
  menuChoiceId: Scalars['ID']['input'];
  subQuantityPercentage?: InputMaybe<Scalars['Int']['input']>;
};

/** For creating a ConsumerCart. */
export type ConsumerCartCreateInput = {
  /** The department code for the order. If nil on update, this will clear the existing department code. */
  corporateDepartmentCode?: InputMaybe<Scalars['String']['input']>;
  corporateOrderReferenceCodes?: InputMaybe<Array<ConsumerCartOrderReferenceCodeInput>>;
  experience: ConsumerCartExperience;
  /**
   * Free tableware items to include on the cart (menuevo menus only; classic
   * tableware is managed separately). Pass the full list from the menu's
   * freeTablewareItems field. Default quantity is determined by the caterer's jurisdiction.
   */
  freeTablewareItems?: InputMaybe<Array<ConsumerCartFreeTablewareItemInput>>;
  items?: InputMaybe<Array<ConsumerCartAddItemInput>>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the order which this cart was reordered from. */
  reorderId?: InputMaybe<Scalars['ID']['input']>;
  tip?: InputMaybe<ConsumerCartTipInput>;
  useEzRewardsPoints?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The types of customer message codes that can appear on a consumer cart */
export enum ConsumerCartCustomerMessageCode {
  CatererClosed = 'CATERER_CLOSED',
  CatererClosedForVacation = 'CATERER_CLOSED_FOR_VACATION',
  CatererDeliveryOnly = 'CATERER_DELIVERY_ONLY',
  CatererNotInStore = 'CATERER_NOT_IN_STORE',
  CatererNoBusinessOrders = 'CATERER_NO_BUSINESS_ORDERS',
  CatererNoResidentialOrders = 'CATERER_NO_RESIDENTIAL_ORDERS',
  CatererOutOfRange = 'CATERER_OUT_OF_RANGE',
  CatererTakeoutOnly = 'CATERER_TAKEOUT_ONLY',
  CreditCardMissingZipCode = 'CREDIT_CARD_MISSING_ZIP_CODE',
  EarlyDeliveryTime = 'EARLY_DELIVERY_TIME',
  ImpreciseOrderAddress = 'IMPRECISE_ORDER_ADDRESS',
  InvalidOrderAddress = 'INVALID_ORDER_ADDRESS',
  ItemsPastCutoff = 'ITEMS_PAST_CUTOFF',
  NoCaterer = 'NO_CATERER',
  NoOrderEventDateTime = 'NO_ORDER_EVENT_DATE_TIME',
  NoPaymentMethod = 'NO_PAYMENT_METHOD',
  /** @deprecated Short notice is sunset (FUNC-481). Removal tracked in FUNC-539. */
  NoShortNoticeChoice = 'NO_SHORT_NOTICE_CHOICE',
  OrderEventDatePassed = 'ORDER_EVENT_DATE_PASSED',
  OrderEventPastCutoff = 'ORDER_EVENT_PAST_CUTOFF',
  OrderIsModification = 'ORDER_IS_MODIFICATION',
  OrderItemsNotAvailable = 'ORDER_ITEMS_NOT_AVAILABLE',
  OrderMayBeDuplicate = 'ORDER_MAY_BE_DUPLICATE',
  OrderOverCorpSpendingLimit = 'ORDER_OVER_CORP_SPENDING_LIMIT',
  OrderOverGroupBudget = 'ORDER_OVER_GROUP_BUDGET',
  OrderUnderMinimum = 'ORDER_UNDER_MINIMUM',
}

/** The available ezCater cart experiences */
export enum ConsumerCartExperience {
  EzOrdering = 'EZ_ORDERING',
  Marketplace = 'MARKETPLACE',
}

/** Arguments for filtering consumer carts */
export type ConsumerCartFilterInput = {
  catererUrlId?: InputMaybe<Scalars['ID']['input']>;
  fulfillmentDetailId?: InputMaybe<Scalars['ID']['input']>;
  submitted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A free tableware item to include on the cart. */
export type ConsumerCartFreeTablewareItemInput = {
  /** The item ID from the menu's freeTablewareItems list. */
  menuItemId: Scalars['ID']['input'];
};

/** An input type for updating a free tableware item's included status. */
export type ConsumerCartFreeTablewareItemUpdateInput = {
  /** The OrderItem UUID. */
  id: Scalars['ID']['input'];
  /** Whether to include this tableware item with the order. */
  isIncluded: Scalars['Boolean']['input'];
};

/** For creating a Group Order and associating with a ConsumerCart */
export type ConsumerCartGroupOrderInput = {
  perPersonBudget?: InputMaybe<MoneyInput>;
};

/** Input type for an invite to pay ConsumerCartInvitation */
export type ConsumerCartInviteUserToPayInput = {
  /** An email to send the invitation to. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** An additional message for the invitee. */
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Allowed values for line item type. */
export enum ConsumerCartLineItemTypeEnum {
  Adjustment = 'ADJUSTMENT',
  CatererFundedPromo = 'CATERER_FUNDED_PROMO',
  Commission = 'COMMISSION',
  CreditCardFee = 'CREDIT_CARD_FEE',
  CustomerPricingFee = 'CUSTOMER_PRICING_FEE',
  DeliveryFee = 'DELIVERY_FEE',
  DeliveryFeeCommission = 'DELIVERY_FEE_COMMISSION',
  Discount = 'DISCOUNT',
  ExternalIntegrationFee = 'EXTERNAL_INTEGRATION_FEE',
  EzRewardsCredit = 'EZ_REWARDS_CREDIT',
  Gratuity = 'GRATUITY',
  MarketplaceFeesTax = 'MARKETPLACE_FEES_TAX',
  MiscFee = 'MISC_FEE',
  PointOfSaleIntegrationFee = 'POINT_OF_SALE_INTEGRATION_FEE',
  Promo = 'PROMO',
  RetailDeliveryFee = 'RETAIL_DELIVERY_FEE',
  RetailDeliveryFeeRemittance = 'RETAIL_DELIVERY_FEE_REMITTANCE',
  SalesTax = 'SALES_TAX',
  SalesTaxAdjustment = 'SALES_TAX_ADJUSTMENT',
  SalesTaxRemittance = 'SALES_TAX_REMITTANCE',
}

/** Input for a selected modifier for an item. */
export type ConsumerCartModifierGroupInput = {
  /** The menu's identifier for the group of a specific modifier. */
  id: Scalars['ID']['input'];
  /** The menu's identifier for the group of a specific modifier. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The input for a modifier for an item. */
export type ConsumerCartModifierInput = {
  /** Information about the group of the selected modifier. */
  modifierGroup: ConsumerCartModifierGroupInput;
  modifiers?: InputMaybe<Array<ConsumerCartModifierInput>>;
  name: Scalars['String']['input'];
  /** The price of a single unit of this modifier. */
  price: MoneyInput;
  quantity: Scalars['Int']['input'];
  supplierProductId: Scalars['UUID']['input'];
};

/** Input type for an option */
export type ConsumerCartOptionInput = {
  choices: Array<ConsumerCartChoiceInput>;
  menuOptionId: Scalars['ID']['input'];
};

/** For collecting corporate reference codes for a ConsumerCart. */
export type ConsumerCartOrderReferenceCodeInput = {
  corporateReferenceCodeId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/** For updating the payment method on a ConsumerCart. */
export type ConsumerCartPaymentMethodUpdateInput = {
  paymentMethod: PaymentMethodInputType;
};

/** For removing ConsumerCartItems. */
export type ConsumerCartRemoveItemInput = {
  id: Scalars['ID']['input'];
};

/** For collecting input from the customer about the short-notice information (action and instructions). */
export type ConsumerCartShortNoticeInput = {
  /** The action specified by the customer that the caterer can take for a last-minute order. */
  action: OrderShortNoticeActions;
  /** Specific instructions given by the customer to the caterer about last-minute decisions. */
  instructions?: InputMaybe<Scalars['String']['input']>;
};

/** Allowed values for sorting a list of consumer cart objects. */
export enum ConsumerCartSortFields {
  CreatedAt = 'CREATED_AT',
}

/** The stage of ConsumerCart process. */
export enum ConsumerCartStage {
  Checkout = 'CHECKOUT',
  Menu = 'MENU',
}

/** An input type representing a tableware choice. */
export type ConsumerCartTablewareChoiceInput = {
  id: Scalars['ID']['input'];
  isIncluded?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input type representing tableware */
export type ConsumerCartTablewareInput = {
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  tablewareChoices?: InputMaybe<Array<ConsumerCartTablewareChoiceInput>>;
};

/**
 * For collecting input from the customer about a tip/gratuity for a ConsumerCart.
 * A tip can be added as either a fixed amount or a percentage of the order total.
 */
export type ConsumerCartTipInput = {
  fixedAmount?: InputMaybe<MoneyInput>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating the number of ezrewards points applied to consumer cart. */
export type ConsumerCartUpdateEzRewardsPointsToApplyInput = {
  ezRewardsPointsToApply?: InputMaybe<Scalars['Int']['input']>;
};

/** For updating attributes on a ConsumerCart. */
export type ConsumerCartUpdateInput = {
  /** The department code for the order. If nil on update, this will clear the existing department code. */
  corporateDepartmentCode?: InputMaybe<Scalars['String']['input']>;
  corporateOrderReferenceCodes?: InputMaybe<Array<ConsumerCartOrderReferenceCodeInput>>;
  createBrandCommunicationOptInOnSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated This argument has moved to a new mutation, consumerCartPaymentMethodUpdate */
  paymentMethod?: InputMaybe<PaymentMethodInputType>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the order which this cart was reordered from. */
  reorderId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Short notice is sunset (FUNC-481). Removal tracked in FUNC-539. */
  shortNotice?: InputMaybe<ConsumerCartShortNoticeInput>;
  tableware?: InputMaybe<ConsumerCartTablewareInput>;
  /** @deprecated The tip is now updated via the consumerCartUpdateTip mutation. */
  tip?: InputMaybe<ConsumerCartTipInput>;
  useEzRewardsPoints?: InputMaybe<Scalars['Boolean']['input']>;
  utensilsSelection?: InputMaybe<UtensilsSelectionEnum>;
};

/** For updating ConsumerCartItems. */
export type ConsumerCartUpdateItemInput = {
  id: Scalars['ID']['input'];
  modifiers?: InputMaybe<Array<ConsumerCartModifierInput>>;
  options?: InputMaybe<Array<ConsumerCartOptionInput>>;
  /** The price of a single unit of this item */
  price?: InputMaybe<MoneyInput>;
  productCatalog?: InputMaybe<ProductCatalog>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  vegetarianQuantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating the tip on a consumer cart. */
export type ConsumerCartUpdateTipInput = {
  tip: ConsumerCartTipInput;
};

/** For creating or updating a ConsumerCart. */
export type ConsumerCartUpsertInput = {
  /** The department code for the order. If nil on update, this will clear the existing department code. */
  corporateDepartmentCode?: InputMaybe<Scalars['String']['input']>;
  corporateOrderReferenceCodes?: InputMaybe<Array<ConsumerCartOrderReferenceCodeInput>>;
  experience: ConsumerCartExperience;
  /**
   * Free tableware items to include on the cart (menuevo menus only; classic
   * tableware is managed separately). Pass the full list from the menu's
   * freeTablewareItems field. Default quantity is determined by the caterer's
   * jurisdiction. Only applied when creating a new cart; ignored on subsequent
   * upserts to an existing cart.
   */
  freeTablewareItems?: InputMaybe<Array<ConsumerCartFreeTablewareItemInput>>;
  items?: InputMaybe<Array<ConsumerCartAddItemInput>>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the order which this cart was reordered from. */
  reorderId?: InputMaybe<Scalars['ID']['input']>;
  tip?: InputMaybe<ConsumerCartTipInput>;
  useEzRewardsPoints?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Payment methods that can are accepted to pay for an Order. Some Orders will only be payable with
 * specific payment methods.
 */
export enum ConsumerPaymentMethodsEnum {
  CorpCreditLine = 'CORP_CREDIT_LINE',
  CreditCard = 'CREDIT_CARD',
  EzRewards = 'EZ_REWARDS',
}

/** Allowed values for a Contact's account status */
export enum ContactAccountStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  NeedsActivation = 'NEEDS_ACTIVATION',
  NoAccount = 'NO_ACCOUNT',
  PasswordReset = 'PASSWORD_RESET',
}

/** Attribute that is used to lookup the account */
export enum ContactIdentifierTypeEnum {
  /** Lookup using phone, including mobile phone and office phone */
  Phone = 'PHONE',
  TrackingId = 'TRACKING_ID',
}

/** The types of transmission methods that can be used to reach out to a caterer contact. */
export enum ContactOrderNotificationMethodEnum {
  Email = 'EMAIL',
  Fax = 'FAX',
  Phone = 'PHONE',
  Text = 'TEXT',
}

/** Descriptive labels for how a particular contact phone number is used. */
export enum ContactPhoneNumberTypesEnum {
  Catering = 'CATERING',
  Directentry = 'DIRECTENTRY',
  Home = 'HOME',
  Kitchen = 'KITCHEN',
  Mobile = 'MOBILE',
  None = 'NONE',
  Office = 'OFFICE',
  Phone = 'PHONE',
  Store = 'STORE',
  Work = 'WORK',
}

/** Arguments for sorting a contact */
export type ContactSort = {
  direction: SortDirection;
  field: ContactSortFields;
};

/** Allowed values for sorting a list of contact objects. */
export enum ContactSortFields {
  Id = 'ID',
  Name = 'NAME',
  PortalStatus = 'PORTAL_STATUS',
}

/** Types of content filters that may have triggered for a given message */
export enum ContentFilterTypes {
  /** Affects ezCater’s business, business model, or reputation */
  BusinessConcerns = 'BUSINESS_CONCERNS',
  /** Using offensive terms or phrases */
  Inappropriateness = 'INAPPROPRIATENESS',
  /** Content intended for/should be looked at by a CS agent */
  Misdirection = 'MISDIRECTION',
  /** Content indicating tension, frustration, or anger */
  Tone = 'TONE',
}

/** How a domain claimed by a corporate account came to be trusted */
export enum CorpAccountDomainProvenance {
  DnsVerified = 'DNS_VERIFIED',
  Legacy = 'LEGACY',
}

/** Verification state of a domain claimed by a corporate account */
export enum CorpAccountDomainState {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Removed = 'REMOVED',
  Verified = 'VERIFIED',
}

export type CorpAddressInput = {
  city: Scalars['String']['input'];
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  driverAskFor?: InputMaybe<Scalars['String']['input']>;
  geocodePrecision?: InputMaybe<Scalars['String']['input']>;
  geocoder?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

/** Allowed types for a corp credit line share display type value */
export enum CorpCreditLineShareDisplay {
  CorpAccount = 'corp_account',
  Group = 'group',
  Person = 'person',
}

export type CorpCreditLineShareInput = {
  groupIds: Array<Scalars['ID']['input']>;
  shareWithCorpAccount: Scalars['Boolean']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

/** Allowed types for the entity with whom a corp credit line has been shared */
export enum CorpCreditLineSharedWith {
  CorpAccount = 'CorpAccount',
  CorpDeptCode = 'CorpDeptCode',
  CorpUser = 'CorpUser',
}

/** Allowed html input types (text, dropdown, etc) for a custom checkout field */
export enum CorpCustomCheckoutFieldEntry {
  DropdownSelector = 'dropdown_selector',
  TextEntry = 'text_entry',
}

export type CorpCustomCheckoutFieldInput = {
  active: Scalars['Boolean']['input'];
  entryType: CorpCustomCheckoutFieldEntry;
  name: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  showOnPdfInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Possible values the custom checkout field can have */
  values: Array<Scalars['String']['input']>;
};

export type CorpDeptCodeInput = {
  code: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CorpGroupCategoryInput = {
  name: Scalars['String']['input'];
  requiredOnCheckout: Scalars['Boolean']['input'];
};

/** Allowed fields for sorting invoices in a corp account */
export enum CorpInvoiceSortFields {
  Amount = 'amount',
  InvoiceNumber = 'invoiceNumber',
  InvoicedStatus = 'invoicedStatus',
  PaymentDueOn = 'paymentDueOn',
  PeriodEndAt = 'periodEndAt',
  PeriodStartAt = 'periodStartAt',
  SetName = 'setName',
}

export type CorpMembershipInput = {
  corpDeptCodeId?: InputMaybe<Scalars['ID']['input']>;
  corpPolicyId?: InputMaybe<Scalars['ID']['input']>;
  corpRole: CorpRole;
};

/** Allowed values for the selected unit of time for a corp metric */
export enum CorpMetricTimeUnit {
  Months = 'months',
}

/** A write-once lifecycle milestone in the self-serve onboarding guide. */
export enum CorpOnboardingMilestone {
  FirstSeen = 'FIRST_SEEN',
  Resolved = 'RESOLVED',
}

/** A set-up section in the self-serve onboarding guide. */
export enum CorpOnboardingSection {
  CustomCheckoutField = 'CUSTOM_CHECKOUT_FIELD',
  InviteTeamMembers = 'INVITE_TEAM_MEMBERS',
  SharedCreditCard = 'SHARED_CREDIT_CARD',
  SharedDeliveryAddress = 'SHARED_DELIVERY_ADDRESS',
  SpendingPolicy = 'SPENDING_POLICY',
}

export type CorpOrderFiltersInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  corpDeptCodeId?: InputMaybe<Scalars['ID']['input']>;
  /** The final date, corresponding with an order's event_on, that a user wants to filter orders by */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  /** The payment type a user wants to filter orders by */
  paymentMethodType?: InputMaybe<OrderPaymentMethodTypeEnum>;
  /** Option to include draft orders in the orders query */
  showDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  /** The first date, corresponding with an order's event_on, that a user wants to filter orders by */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<CorpOrderStatusFilter>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpOrderInput = {
  corpDeptCodeId?: InputMaybe<Scalars['ID']['input']>;
  customCheckoutFields: Array<OrderCustomCheckoutFieldInput>;
};

/** Allowed fields for sorting orders/receipts in a corp account */
export enum CorpOrderSortFields {
  Address = 'address',
  Caterer = 'caterer',
  Department = 'department',
  EventDate = 'eventDate',
  Host = 'host',
  Order = 'order',
  OrderSubmitted = 'orderSubmitted',
  PaymentMethodType = 'paymentMethodType',
  Status = 'status',
  Total = 'total',
}

/** Displayable statuses for corp account orders */
export enum CorpOrderStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  Draft = 'draft',
  PendingApproval = 'pending_approval',
  Scheduled = 'scheduled',
}

/** Filterable statuses for corp account orders */
export enum CorpOrderStatusFilter {
  All = 'all',
  Canceled = 'canceled',
  Completed = 'completed',
  Draft = 'draft',
  PendingApproval = 'pending_approval',
  Scheduled = 'scheduled',
}

export type CorpPolicyWithSpendingLimitsInput = {
  companyWide?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  spendingLimits: Array<CorpSpendingLimitInput>;
  /** UUIDs of account members this policy applies to */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A post-completion prompt section in the self-serve onboarding guide. */
export enum CorpPostResolvedSection {
  Integrations = 'INTEGRATIONS',
  MealProgram = 'MEAL_PROGRAM',
  TaxExempt = 'TAX_EXEMPT',
}

/** The type of interaction with a post-completion prompt section. */
export enum CorpPostResolvedSectionInteraction {
  Deferred = 'DEFERRED',
  Engaged = 'ENGAGED',
}

export type CorpReportInput = {
  additionalCorpAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  corpAccountIdsForReport?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['Date']['input'];
  name: Scalars['String']['input'];
  reportType: CorpReportType;
  startDate: Scalars['Date']['input'];
};

/** Allowed fields for sorting reports in a corp account */
export enum CorpReportSortField {
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  Name = 'name',
  ReportType = 'reportType',
  RowCount = 'rowCount',
  StartDate = 'startDate',
}

/** Allowed corp report types */
export enum CorpReportType {
  Group = 'group',
  Order = 'order',
  OwnershipDiversity = 'ownership_diversity',
  Person = 'person',
}

/** Roles for user management under a corp account */
export enum CorpRole {
  Admin = 'admin',
  Orderer = 'orderer',
  Viewer = 'viewer',
}

export type CorpSpendingLimitInput = {
  /** Whether or not orders over spending limit are prevented or a warning is shown */
  enforce: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  limit: MoneyInput;
  limitMethod: LimitMethod;
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Allowed statuses for a user in a corp account */
export enum CorpStatus {
  Customer = 'CUSTOMER',
  InviteExpired = 'INVITE_EXPIRED',
  InviteRejected = 'INVITE_REJECTED',
  InviteSent = 'INVITE_SENT',
  None = 'NONE',
  Pending = 'PENDING',
  Registered = 'REGISTERED',
  Removed = 'REMOVED',
  Unverified = 'UNVERIFIED',
}

export type CorpUserFiltersInput = {
  corpDeptCode?: InputMaybe<Scalars['ID']['input']>;
  corpPolicy?: InputMaybe<Scalars['ID']['input']>;
  corpStatus?: InputMaybe<CorpStatus>;
  /** Search for a user across a set of fields (name, email, phone) */
  freetext?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpUserInput = {
  corpDeptCodeId?: InputMaybe<Scalars['ID']['input']>;
  corpPolicyId?: InputMaybe<Scalars['ID']['input']>;
  corpRole: CorpRole;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
};

/** Allowed fields for sorting users in a corp account */
export enum CorpUserSortFields {
  CorpDeptCode = 'corpDeptCode',
  CorpPolicy = 'corpPolicy',
  CorpRoleId = 'corpRoleId',
  CorpStatusKey = 'corpStatusKey',
  InviteSentAt = 'inviteSentAt',
  LastActivityAt = 'lastActivityAt',
  Name = 'name',
  Orders = 'orders',
}

/** The different types of spending limits a corporate account can have for its users */
export enum CorporateAccountSpendingLimitTypes {
  AnnualBudget = 'ANNUAL_BUDGET',
  DailyBudget = 'DAILY_BUDGET',
  DeliveryFee = 'DELIVERY_FEE',
  DeliveryFeePerHead = 'DELIVERY_FEE_PER_HEAD',
  FoodCostPerHead = 'FOOD_COST_PER_HEAD',
  MinimumTipPercentage = 'MINIMUM_TIP_PERCENTAGE',
  MonthlyBudget = 'MONTHLY_BUDGET',
  QuarterlyBudget = 'QUARTERLY_BUDGET',
  Tip = 'TIP',
  TipPercentage = 'TIP_PERCENTAGE',
  TipPerHead = 'TIP_PER_HEAD',
  Total = 'TOTAL',
  TotalCostPerHead = 'TOTAL_COST_PER_HEAD',
  WeeklyBudget = 'WEEKLY_BUDGET',
}

/** Autogenerated input type of CreateBillingGroupContact */
export type CreateBillingGroupContactInput = {
  /** ID of a billing group */
  billingGroupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** Email address of new billing contact */
  contactEmail: Scalars['String']['input'];
};

/** Autogenerated input type of CreateBulkUserInvitation */
export type CreateBulkUserInvitationInput = {
  bulkUserInvitationEntry: RelishBulkUserInvitationInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateCompanyCoupon */
export type CreateCompanyCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  couponCreationEntry: RelishCompanyCouponInput;
  /** Hash ID of a Relish drop */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
};

/** Input object required to create a customer management promo */
export type CreateCustomerManagementPromoInput = {
  catererUuids: Array<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  deliveryOnly: Scalars['Boolean']['input'];
  discountAmount: Scalars['Int']['input'];
  discountType: CustomerManagementPromoDiscountTypeEnum;
  expiresOn: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  orderMinimum?: InputMaybe<Scalars['Int']['input']>;
  singleUsePerUser: Scalars['Boolean']['input'];
  weekdayOnly: Scalars['Boolean']['input'];
};

/** Autogenerated input type of CreateDropContact */
export type CreateDropContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** Hash ID of a Relish drop */
  dropHashid: Scalars['ID']['input'];
  /** ID of the Relish employee */
  employeeId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateDropTemporaryClosure */
export type CreateDropTemporaryClosureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  temporaryClosureInput: RelishDropTemporaryClosureInput;
};

/** Input arguments required to create a house account */
export type CreateHouseAccount = {
  address?: InputMaybe<AddressInput>;
  catererId?: InputMaybe<Scalars['ID']['input']>;
  catererIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyName: Scalars['String']['input'];
  contactFirstName: Scalars['String']['input'];
  contactLastName: Scalars['String']['input'];
  contactsToAssociate?: InputMaybe<Array<HouseAccountContactInput>>;
  email: Scalars['String']['input'];
  paymentTermsInDays: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  taxIdNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input arguments required to create an invoice */
export type CreateInvoiceInput = {
  body: Scalars['String']['input'];
  houseAccountId: Scalars['ID']['input'];
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  replyTo: Scalars['String']['input'];
  sendTo: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

/** Input arguments required to create a lead */
export type CreateLeadInput = {
  address?: InputMaybe<AddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  industry?: InputMaybe<IndustryTypeEnum>;
  lastName: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxIdNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input arguments required to create a note for a given entity's activity timeline */
export type CreateNoteInput = {
  id: Scalars['ID']['input'];
  merged: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};

/** Input type for creating an order reference code */
export type CreateOrderReferenceCodeInputType = {
  corpReferenceCodeId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/** Autogenerated input type of CreateRelishCompanyAdminRequest */
export type CreateRelishCompanyAdminRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  relishCompanyAdminRequestInput: RelishCompanyAdminRequestInput;
};

/** Autogenerated input type of CreateRelishCompanyReport */
export type CreateRelishCompanyReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  reportInput: RelishCompanyReportInput;
};

/** Autogenerated input type of CreateRelishEmployeeInvitation */
export type CreateRelishEmployeeInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  employeeInvitationInput: RelishEmployeeInvitationInput;
};

/** Autogenerated input type of CreateRelishMealPlan */
export type CreateRelishMealPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of the company */
  companyHashid: Scalars['ID']['input'];
  /** Hash ID of the drop for the meal plan */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
  mealPlanInput: RelishMealPlanInput;
};

/** Autogenerated input type of CreateRelishOrderFulfillmentIssue */
export type CreateRelishOrderFulfillmentIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  fulfillmentIssueInput: RelishOrderFulfillmentIssueInput;
};

/** Autogenerated input type of CreateRelishPaymentMethod */
export type CreateRelishPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  paymentMethodInput: RelishPaymentMethodInput;
};

/** The source page from which a credit card is being added */
export enum CreditCardAddSource {
  Checkout = 'CHECKOUT',
  /** @deprecated Use corpAccountAddSharedCreditCard */
  CorpAdmin = 'CORP_ADMIN',
  PaymentMethod = 'PAYMENT_METHOD',
}

/** Which confirmation applies when deleting a payment method */
export enum CreditCardDeleteConfirmationKind {
  BlockedActiveOrder = 'BLOCKED_ACTIVE_ORDER',
  DefaultCard = 'DEFAULT_CARD',
  Generic = 'GENERIC',
  Shared = 'SHARED',
  SharedWithActiveOrders = 'SHARED_WITH_ACTIVE_ORDERS',
}

/** Indicates how many distinct expiration dates exist across a contact's active credit lots */
export enum CreditExpirationTypeEnum {
  Multiple = 'MULTIPLE',
  None = 'NONE',
  Single = 'SINGLE',
}

/** Describes how a credit line may be used for checkout */
export enum CreditLineAllowedUse {
  /** Credit line can be used for any order */
  Any = 'ANY',
  /** Credit line can only be used for punchout orders */
  PunchoutOnly = 'PUNCHOUT_ONLY',
}

/** Allowed values for ImageCrop */
export enum CropName {
  DesktopHero = 'DESKTOP_HERO',
  DesktopMenuItem = 'DESKTOP_MENU_ITEM',
  DesktopMItem = 'DESKTOP_M_ITEM',
  MobileAbout = 'MOBILE_ABOUT',
  MobileHero = 'MOBILE_HERO',
  MobileSearch = 'MOBILE_SEARCH',
  RetinaMobileAbout = 'RETINA_MOBILE_ABOUT',
  RetinaMobileHero = 'RETINA_MOBILE_HERO',
  RetinaMobileMItem = 'RETINA_MOBILE_M_ITEM',
  RetinaMobileSearch = 'RETINA_MOBILE_SEARCH',
}

/** Allowed values for cuisine options */
export enum CuisineOptionEnum {
  African = 'AFRICAN',
  American = 'AMERICAN',
  Asian = 'ASIAN',
  Bbq = 'BBQ',
  Bowls = 'BOWLS',
  Breakfast = 'BREAKFAST',
  Burgers = 'BURGERS',
  Cajun = 'CAJUN',
  Caribbean = 'CARIBBEAN',
  Chicken = 'CHICKEN',
  Chinese = 'CHINESE',
  Cuban = 'CUBAN',
  Deli = 'DELI',
  Diner = 'DINER',
  EasternEuropeanRussian = 'EASTERN_EUROPEAN_RUSSIAN',
  ExtendedService = 'EXTENDED_SERVICE',
  French = 'FRENCH',
  German = 'GERMAN',
  Greek = 'GREEK',
  Healthy = 'HEALTHY',
  HorsDOeuvres = 'HORS_D_OEUVRES',
  HotCatering = 'HOT_CATERING',
  Indian = 'INDIAN',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  Mediterranean = 'MEDITERRANEAN',
  Mexican = 'MEXICAN',
  MiddleEastern = 'MIDDLE_EASTERN',
  Pizza = 'PIZZA',
  Salads = 'SALADS',
  Sandwiches = 'SANDWICHES',
  Seafood = 'SEAFOOD',
  Snacks = 'SNACKS',
  Soups = 'SOUPS',
  Southern = 'SOUTHERN',
  SouthLatinAmerican = 'SOUTH_LATIN_AMERICAN',
  SpanishTapas = 'SPANISH_TAPAS',
  SpecialtyBeverages = 'SPECIALTY_BEVERAGES',
  Steakhouse = 'STEAKHOUSE',
  Sushi = 'SUSHI',
  Thai = 'THAI',
  Treats = 'TREATS',
  Vietnamese = 'VIETNAMESE',
}

/** Allowed values for names of currently implemented curated lists */
export enum CuratedListName {
  ReliabilityRockstar = 'RELIABILITY_ROCKSTAR',
}

/** Allowed currency values for money */
export enum Currency {
  Usd = 'USD',
}

/** Allowed values for discounts on customer management promos */
export enum CustomerManagementPromoDiscountTypeEnum {
  DollarOff = 'DOLLAR_OFF',
  PercentOff = 'PERCENT_OFF',
}

/** Allowed values for the funding source on customer management promos */
export enum CustomerManagementPromoFundingSourceTypeEnum {
  CatererFunded = 'CATERER_FUNDED',
  EzcaterFunded = 'EZCATER_FUNDED',
}

/** The types of customer message actions that can appear on an order */
export enum CustomerMessageAction {
  CatererClosed = 'CATERER_CLOSED',
  CatererClosedForVacation = 'CATERER_CLOSED_FOR_VACATION',
  CatererDeliveryOnly = 'CATERER_DELIVERY_ONLY',
  CatererNotInStore = 'CATERER_NOT_IN_STORE',
  CatererNoBusinessOrders = 'CATERER_NO_BUSINESS_ORDERS',
  CatererNoResidentialOrders = 'CATERER_NO_RESIDENTIAL_ORDERS',
  CatererOutOfRange = 'CATERER_OUT_OF_RANGE',
  CatererTakeoutOnly = 'CATERER_TAKEOUT_ONLY',
  CreditCardMissingZipCode = 'CREDIT_CARD_MISSING_ZIP_CODE',
  EarlyDeliveryTime = 'EARLY_DELIVERY_TIME',
  GroupOrderInfo = 'GROUP_ORDER_INFO',
  ImpreciseOrderAddress = 'IMPRECISE_ORDER_ADDRESS',
  InvalidOrderAddress = 'INVALID_ORDER_ADDRESS',
  ItemsPastCutoff = 'ITEMS_PAST_CUTOFF',
  NoCaterer = 'NO_CATERER',
  NoOrderEventDateTime = 'NO_ORDER_EVENT_DATE_TIME',
  NoPaymentMethod = 'NO_PAYMENT_METHOD',
  OrderEventDatePassed = 'ORDER_EVENT_DATE_PASSED',
  OrderEventPastCutoff = 'ORDER_EVENT_PAST_CUTOFF',
  OrderIsModification = 'ORDER_IS_MODIFICATION',
  OrderItemsNotAvailable = 'ORDER_ITEMS_NOT_AVAILABLE',
  OrderNeedsReview = 'ORDER_NEEDS_REVIEW',
  OrderOverCorpSpendingLimit = 'ORDER_OVER_CORP_SPENDING_LIMIT',
  OrderOverGroupBudget = 'ORDER_OVER_GROUP_BUDGET',
  OrderSubmitted = 'ORDER_SUBMITTED',
  OrderUnderMinimum = 'ORDER_UNDER_MINIMUM',
  PromoCodeInfo = 'PROMO_CODE_INFO',
}

/** Action code for a customer message */
export enum CustomerMessageActionCode {
  ChangeCaterer = 'change_caterer',
  ChangeCatererOrEventDatetime = 'change_caterer_or_event_datetime',
  ChangeCatererOrOrderType = 'change_caterer_or_order_type',
  ChangeCatererOrSwitchToDelivery = 'change_caterer_or_switch_to_delivery',
  ChangeCatererOrSwitchToTakeout = 'change_caterer_or_switch_to_takeout',
  EditEventAddress = 'edit_event_address',
  EditEventDate = 'edit_event_date',
  EditEventDatetime = 'edit_event_datetime',
  EditEventTime = 'edit_event_time',
  EditInvalidEventDatetime = 'edit_invalid_event_datetime',
  OrderMessageGroupOrder = 'order_message_group_order',
  OrderMessageLinkToCart = 'order_message_link_to_cart',
  OrderMessageLinkToPayment = 'order_message_link_to_payment',
  OrderMessageLinkToPromo = 'order_message_link_to_promo',
  OrderMessageLinkToReview = 'order_message_link_to_review',
  OrderMessageLinkToSearch = 'order_message_link_to_search',
  OrderMessageModification = 'order_message_modification',
  /** @deprecated Short notice is sunset (FUNC-481). Removal tracked in FUNC-539. */
  OrderMessageShortNotice = 'order_message_short_notice',
  OrderMessageStatic = 'order_message_static',
  OrderSubmitted = 'order_submitted',
}

/** Area for a customer message */
export enum CustomerMessageArea {
  Cart = 'cart',
  CatererSearch = 'caterer_search',
  EventDetails = 'event_details',
  Menu = 'menu',
  MyAccountOrderShow = 'my_account_order_show',
  Payment = 'payment',
  ReviewOrder = 'review_order',
}

/** Error level for a customer message */
export enum CustomerMessageErrorLevel {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
}

/** Type of a customer message */
export enum CustomerMessageTypeEnum {
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

/** A list of values representing actions that a customer can take on an order. */
export enum CustomerOrderActions {
  Cancel = 'CANCEL',
  Continue = 'CONTINUE',
  Delete = 'DELETE',
  Edit = 'EDIT',
  Pdf = 'PDF',
  Reorder = 'REORDER',
  Review = 'REVIEW',
}

/** A selection of available filters to apply to the customers list */
export enum CustomersFilterTypeEnum {
  All = 'ALL',
  Sleepy = 'SLEEPY',
}

/** The types of fields that can be sorted by on a customer */
export enum CustomersSortFieldTypeEnum {
  Id = 'ID',
  Name = 'NAME',
  OrderCount = 'ORDER_COUNT',
}

/** Allowed values for days of the week */
export enum DaysOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

/** Types of Direct Connect events present in a history */
export enum DcEventTypes {
  /** a request was cancelled */
  Cancellation = 'CANCELLATION',
  /** a decision was made */
  Decision = 'DECISION',
  /** a message was sent */
  Message = 'MESSAGE',
  /** a request was placed */
  Request = 'REQUEST',
}

/** Autogenerated input type of DeactivateRelishEmployee */
export type DeactivateRelishEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of the Relish employee */
  employeeId: Scalars['ID']['input'];
};

/** Allowed values for the dei owned business taxonomy field in caterer search */
export enum DeiOwnedBusinessTaxonomy {
  Aapi = 'AAPI',
  BlackOwnedBusiness = 'BLACK_OWNED_BUSINESS',
  DisabilityOwnedBusiness = 'DISABILITY_OWNED_BUSINESS',
  HispanicLatineOwnedBusiness = 'HISPANIC_LATINE_OWNED_BUSINESS',
  Indigenous = 'INDIGENOUS',
  LgbtqOwnedBusiness = 'LGBTQ_OWNED_BUSINESS',
  Mena = 'MENA',
  Sdvob = 'SDVOB',
  VeteranOwnedBusiness = 'VETERAN_OWNED_BUSINESS',
  WomanOwnedBusiness = 'WOMAN_OWNED_BUSINESS',
}

/** Autogenerated input type of DeleteBillingGroupContact */
export type DeleteBillingGroupContactInput = {
  /** ID of a billing group */
  billingGroupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** Email address of billing contact to delete */
  contactEmail: Scalars['String']['input'];
};

/** Autogenerated input type of DeleteCompanyAdminPermission */
export type DeleteCompanyAdminPermissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of the Relish employee */
  employeeId: Scalars['ID']['input'];
};

/** Input arguments required to delete customers */
export type DeleteCustomersInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated input type of DeleteDropAdminPermission */
export type DeleteDropAdminPermissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of a Relish drop */
  dropHashid: Scalars['ID']['input'];
  /** ID of the Relish employee */
  employeeId: Scalars['ID']['input'];
};

/** Autogenerated input type of DeleteDropContact */
export type DeleteDropContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of a Relish drop contact */
  dropContactId: Scalars['ID']['input'];
  /** ID of a Relish drop */
  dropHashid: Scalars['ID']['input'];
};

/** Input arguments required to delete a house account */
export type DeleteHouseAccountInput = {
  id: Scalars['ID']['input'];
};

/** Input arguments required to delete leads */
export type DeleteLeadsInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Input arguments required to delete a note for a given entity's activity timeline */
export type DeleteNoteInput = {
  id: Scalars['ID']['input'];
  merged: Scalars['Boolean']['input'];
};

/** Autogenerated input type of DeleteRelishMealPlan */
export type DeleteRelishMealPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of the Relish meal plan */
  mealPlanId: Scalars['ID']['input'];
};

/** Autogenerated input type of DeleteRelishPaymentMethod */
export type DeleteRelishPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of the payment method */
  paymentMethodId: Scalars['ID']['input'];
};

export enum DeliveryFeeFeeTypeEnum {
  Custom = 'CUSTOM',
  Fixed = 'FIXED',
  PercentOfFood = 'PERCENT_OF_FOOD',
  PerMile = 'PER_MILE',
}

/** Allowed values for sorting delivery performance order information. */
export enum DeliveryPerformanceOrderSortField {
  /** The name of the driver who delivered the order. */
  DriverName = 'DRIVER_NAME',
  /** The full event datetime of the order in the caterer's local time zone. */
  EventAt = 'EVENT_AT',
  /** The store number associated with the order. */
  StoreNumber = 'STORE_NUMBER',
}

/** Arguments for sorting delivery performance order information. */
export type DeliveryPerformanceOrderSortInput = {
  /** The direction in which to sort delivery performance order information. */
  direction: SortDirection;
  /** Field by which to sort delivery performance order information. */
  field: DeliveryPerformanceOrderSortField;
};

/** Allowed values for the review delivery professional feedback field */
export enum DeliveryProfessionalismFeedback {
  HighlyProfessional = 'HIGHLY_PROFESSIONAL',
  HighlyUnprofessional = 'HIGHLY_UNPROFESSIONAL',
  Neutral = 'NEUTRAL',
  Professional = 'PROFESSIONAL',
  Unprofessional = 'UNPROFESSIONAL',
}

/** Allowed values for delivery setup */
export enum DeliverySetup {
  /** The customer declined delivery setup */
  None = 'NONE',
  /** The customer was not prompted for a delivery setup */
  NoResponse = 'NO_RESPONSE',
  /** The customer requested delivery setup */
  Required = 'REQUIRED',
}

/** Allowed values for sorting a list of delivery objects */
export enum DeliverySortFields {
  DriverName = 'DRIVER_NAME',
  EventAt = 'EVENT_AT',
}

/** Allowed values for the review delivery time feedback field */
export enum DeliveryTimeFeedback {
  Early = 'EARLY',
  Late = 'LATE',
  OnTime = 'ON_TIME',
}

/** Options for delivery time issues */
export enum DeliveryTimeSelection {
  FifteenToThirtyMinEarly = 'FIFTEEN_TO_THIRTY_MIN_EARLY',
  FifteenToThirtyMinLate = 'FIFTEEN_TO_THIRTY_MIN_LATE',
  MoreThanSixtyMinEarly = 'MORE_THAN_SIXTY_MIN_EARLY',
  MoreThanSixtyMinLate = 'MORE_THAN_SIXTY_MIN_LATE',
  ThirtyToSixtyMinEarly = 'THIRTY_TO_SIXTY_MIN_EARLY',
  ThirtyToSixtyMinLate = 'THIRTY_TO_SIXTY_MIN_LATE',
  ZeroToFifteenMinLate = 'ZERO_TO_FIFTEEN_MIN_LATE',
}

/** The possible statuses for evaluating the delivery tracking data. */
export enum DeliveryTrackingEvaluationStatus {
  /** The delivery has tracking data but the data quality does not meet minimum requirements. */
  InvalidData = 'INVALID_DATA',
  /** The delivery did not receive all the required tracking data. */
  MissingRequiredData = 'MISSING_REQUIRED_DATA',
  /** The delivery is fully tracked. */
  Tracked = 'TRACKED',
  /** The delivery has no delivery tracking data. */
  Untracked = 'UNTRACKED',
}

/** The tracking statuses that a delivery can have. */
export enum DeliveryTrackingStatus {
  /** The delivery was fully tracked but the data does not meet our quality standards. */
  InvalidData = 'INVALID_DATA',
  /** The delivery is missing some of the required tracking data. */
  MissingRequiredData = 'MISSING_REQUIRED_DATA',
  /** The delivery was fully tracked and the data meets our quality standards. */
  Tracked = 'TRACKED',
  /** The delivery does not have any tracking data. */
  Untracked = 'UNTRACKED',
}

/** The available methods for delivery_update notifications and whether or not the user is subscribed */
export type DeliveryUpdateNotificationSubscriptionsInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  push?: InputMaybe<Scalars['Boolean']['input']>;
  txt?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DeliveryZoneZoneTypeEnum {
  Circle = 'CIRCLE',
  City = 'CITY',
  Distance = 'DISTANCE',
  Polygon = 'POLYGON',
  Rectangle = 'RECTANGLE',
  ZipCode = 'ZIP_CODE',
}

/** Allowed values for dietary allergy */
export enum DietaryAllergy {
  Egg = 'EGG',
  FinFish = 'FIN_FISH',
  Milk = 'MILK',
  None = 'NONE',
  Peanut = 'PEANUT',
  Sesame = 'SESAME',
  Shellfish = 'SHELLFISH',
  Soy = 'SOY',
  TreeNut = 'TREE_NUT',
  Unknown = 'UNKNOWN',
  Wheat = 'WHEAT',
}

/** Allowed values for dietary options */
export enum DietaryOptionEnum {
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  Kosher = 'KOSHER',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN',
}

export type DietaryPollRespondInput = {
  /** The access code to authorize the invited user to view the poll. Required unless the current user is the owner of the poll. */
  accessCode?: InputMaybe<Scalars['String']['input']>;
  dietaryAllergies: Array<DietaryAllergy>;
  dietaryAllergyOther?: InputMaybe<Scalars['String']['input']>;
  dietaryPreferenceOther?: InputMaybe<Scalars['String']['input']>;
  dietaryPreferences: Array<DietaryPreference>;
  /** Email of the user who is responding to the poll. Required for guest users but not for logged in users. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Name of the user who is responding to the poll. Required for guest users but not for logged in users. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Whether or not a dietary poll can be answered. */
export enum DietaryPollStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

/** Allowed values for dietary preference */
export enum DietaryPreference {
  DairyFree = 'DAIRY_FREE',
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  Kosher = 'KOSHER',
  None = 'NONE',
  Paleo = 'PALEO',
  Pescatarian = 'PESCATARIAN',
  Unknown = 'UNKNOWN',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN',
}

export enum DietaryRestriction {
  GlutenFree = 'gluten_free',
  Halal = 'halal',
  Kosher = 'kosher',
  Vegan = 'vegan',
  Vegetarian = 'vegetarian',
}

/** Allowed values for discount types */
export enum DiscountTypeEnum {
  DollarOff = 'dollar_off',
  PercentOff = 'percent_off',
}

/** The delivery event creation source, whether directly or indirectly. */
export enum DmDeliveryEventSource {
  /** This is the default event source and any events that don't match other sources will be set to this. */
  DeliveryManagement = 'DELIVERY_MANAGEMENT',
  /** The event is directly from or a byproduct of a delivery partner. */
  DeliveryPartner = 'DELIVERY_PARTNER',
  /** The event is directly from or a byproduct of an ezDispatch process. */
  Ezdispatch = 'EZDISPATCH',
  /** The event was created from driver geolocation. */
  Geolocation = 'GEOLOCATION',
  /** The event was created from a 1st Party Delivery API integration. */
  PublicDeliveryApi = 'PUBLIC_DELIVERY_API',
}

/** The event type for any given event */
export enum DmDeliveryEventTypes {
  /** The ezDispatch request has been accepted - either programatically or by a third party delivery partner */
  Accepted = 'accepted',
  /** ezDispatch has cancelled the assignment to a third party delivery partner */
  AssignmentCancelled = 'assignment_cancelled',
  /** ezDispatch has assigned the delivery to a third party delivery partner */
  AssignmentCreated = 'assignment_created',
  /** The delivery has been cancelled completely */
  Cancelled = 'cancelled',
  /** A delivery record has been created in either delivery management or ezDispatch */
  Created = 'created',
  /** A driver has arrived at the dropoff location */
  DriverArrivedAtDropoff = 'driver_arrived_at_dropoff',
  /** A driver has arrived to pickup the food */
  DriverArrivedAtPickup = 'driver_arrived_at_pickup',
  /** A driver has been assigned - either by a catering partner or a third party delivery partner */
  DriverAssigned = 'driver_assigned',
  /** A driver has dropped of the food */
  DriverDroppedOff = 'driver_dropped_off',
  /** A driver is on the way to the customer */
  DriverEnRouteToDropoff = 'driver_en_route_to_dropoff',
  /** A driver is on the way to pickup the food */
  DriverEnRouteToPickup = 'driver_en_route_to_pickup',
  /** A driver has picked the food */
  DriverPickedUp = 'driver_picked_up',
  /** A driver has given feedback after completing a delivery */
  DriverProvidedFeedback = 'driver_provided_feedback',
  /**
   * A driver has reported that they are behind schedule
   * @deprecated This is being deprecated without any alternative. No delivery events have been created with this event type since 2022-02-09.
   */
  DriverReportedLateness = 'driver_reported_lateness',
  /**
   * A gps location has been reported for a driver
   * @deprecated Replaced by the `driverTrackingEventCreate` mutation. No delivery events have been created with this event type since 2021.
   */
  DriverReportedLocation = 'driver_reported_location',
  /** A driver has been unassigned - either by a catering partner or third party delivery partner */
  DriverUnassigned = 'driver_unassigned',
  /** The delivery was not completed at least two hours after the scheduled event */
  Expired = 'expired',
  /** Some sort of issue has been reported with the delivery. */
  Issue = 'issue',
  /** Delivery related information has changed */
  Modified = 'modified',
  /** The delivery has been rejected by ezDispatch or an assignment has been rejected by a third party delivery partner */
  Rejected = 'rejected',
  /** ezDispatch request was deleted by the caterer. */
  RequestDeletedByCaterer = 'request_deleted_by_caterer',
  /** ezDispatch request was deleted by the customer. */
  RequestDeletedByCustomer = 'request_deleted_by_customer',
  /** ezDispatch request was deleted by the delivery partner. */
  RequestDeletedByDeliveryPartner = 'request_deleted_by_delivery_partner',
}

/** The priority level of an ezDispatch delivery. */
export enum DmDeliveryPriority {
  /** A delivery that needs higher priority. */
  High = 'HIGH',
  /** A normal delivery priority. This is the default. */
  Normal = 'NORMAL',
}

/** Current state - unassigned, assigned, in_progress, completed or expired - based on associated delivery events */
export enum DmDeliveryStatus {
  Assigned = 'assigned',
  Completed = 'completed',
  Expired = 'expired',
  InProgress = 'in_progress',
  Unassigned = 'unassigned',
}

/** The vendor hosting the image. */
export enum DmDriverImageVendor {
  Filestack = 'FILESTACK',
}

/** The input fields for creating or updating a caterer's delivery driver. */
export type DmDriverInput = {
  /** A list of globally unique identifiers for the Caterers that the driver delivers for. */
  ezcaterStoreIds: Array<Scalars['String']['input']>;
  /** The driver's first name. */
  firstName: Scalars['String']['input'];
  /** The driver's last name. */
  lastName: Scalars['String']['input'];
  /** The driver's vehicle make and model. */
  makeModel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Internal notes about the driver for management purposes. This information is
   * not displayed to the driver or ezCater customers.
   */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The driver's mobile phone number. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Driver current SMS opt in status - no opt in decision, opted in, opted out */
export enum DmDriverOptInStatus {
  NoOptInDecision = 'NO_OPT_IN_DECISION',
  OptedIn = 'OPTED_IN',
  OptedOut = 'OPTED_OUT',
}

/** Autogenerated input type of DriverCreate */
export type DriverCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  driver: DmDriverInput;
};

/** Autogenerated input type of DriverDelete */
export type DriverDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the driver to be deleted */
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of DriverEdit */
export type DriverEditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  driver: DmDriverInput;
  /** ID of the driver to be edited */
  id: Scalars['ID']['input'];
};

/** Input arguments required to edit a note for a given entity's activity timeline */
export type EditNoteInput = {
  id: Scalars['ID']['input'];
  merged: Scalars['Boolean']['input'];
  newText: Scalars['String']['input'];
};

export enum EmployeeOrderStatus {
  Cancelled = 'cancelled',
  Draft = 'draft',
  Submitted = 'submitted',
}

export type EndCustomerManagementPromoInput = {
  /** The ID of the promo to end. */
  id: Scalars['ID']['input'];
};

export enum EntityTypeEnum {
  /** Brand */
  Brand = 'brand',
  /** Caterer */
  Caterer = 'caterer',
}

/** The event specific properties used when tracking events */
export type EventPropsInput = {
  appName: Scalars['String']['input'];
  browserHeight?: InputMaybe<Scalars['Int']['input']>;
  browserWidth?: InputMaybe<Scalars['Int']['input']>;
  category: Scalars['String']['input'];
  event: Scalars['String']['input'];
  experimentResult?: InputMaybe<Scalars['String']['input']>;
  experimentTest?: InputMaybe<Scalars['String']['input']>;
  miscJson?: InputMaybe<Scalars['JSON']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  pixelRatio?: InputMaybe<Scalars['Float']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** The ezDispatch delivery lifecycle status. */
export enum EzDispatchDeliveryStatus {
  /** ezDispatch delivery is accepted. */
  Accepted = 'ACCEPTED',
  /** ezDispatch delivery is cancelled due to order cancellation. */
  Cancelled = 'CANCELLED',
  /** ezDispatch was requested, but the request was deleted. */
  Deleted = 'DELETED',
  /** ezDispatch delivery is pending acceptance. */
  Pending = 'PENDING',
  /** ezDispatch delivery is rejected. */
  Rejected = 'REJECTED',
}

/** Allowed values for EzManageScopedActivationPermission error field */
export enum EzManageScopedActivationPermissionError {
  BrandAdmin = 'BRAND_ADMIN',
  MissingStores = 'MISSING_STORES',
  NotAuthorized = 'NOT_AUTHORIZED',
}

/** Delivery types that Relish supports */
export enum EzcaterOrderDeliveryTypeEnum {
  /** Delivery method is 'ezDispatch' */
  Ezdispatch = 'ezdispatch',
  /** Delivery method is 'On-site' */
  PopUp = 'pop_up',
  /** Delivery method is 'Self' */
  Restaurant = 'restaurant',
  /** Delivery method is 'Third party' */
  Tpd = 'tpd',
}

/** Allowed values to filter credits or deductions by type */
export enum FeeOrDiscountType {
  Adjustment = 'ADJUSTMENT',
  DeliveryFee = 'DELIVERY_FEE',
  Discount = 'DISCOUNT',
  MiscFee = 'MISC_FEE',
}

export type FilterInput = {
  comparatorTarget: ComparatorTargetEnum;
  endDate: Scalars['Date']['input'];
  entityIds: Array<Scalars['ID']['input']>;
  entityType: EntityTypeEnum;
  ezcaterSourceName: Array<SourceNameEnum>;
  granularity: GranularityEnum;
  startDate: Scalars['Date']['input'];
};

/** The input for filtering search results */
export type FilteredCatererListInput = {
  /** The client-provided ID used to identify the list */
  id: Scalars['ID']['input'];
  /** The key value pairs of the {taxonomy: taxon} to filter on. Multiple pairs will return the intersection of all taxons. */
  taxonomiesAndTaxons?: InputMaybe<SearchTaxonomiesAndTaxonsInput>;
  /** The key value pairs of the {taxonomy: taxon} to filter on. Multiple pairs will return the intersection of all taxons. */
  type?: InputMaybe<TaxonFilterInput>;
};

/** Twilio Studio Flow names with Twilio SID as the value */
export enum FlowEnum {
  GeneralSupportVoiceIvr = 'general_support_voice_ivr',
}

export type FulfillmentDetailAddressInput = {
  /** A list of key attendees' names. */
  attendees?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  driverAskFor?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Arguments for filtering the consumer carts associated with a particular fulfillment detail */
export type FulfillmentDetailConsumerCartsFilterInput = {
  /** Excludes carts that are order modifications (order_state = 'modification'). */
  excludeModificationCarts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNonEmptyCarts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FulfillmentDetailCreateInput = {
  address?: InputMaybe<FulfillmentDetailAddressInput>;
  /**
   * The address book entry address uuid to associate with for default attributes,
   * attributes in the address argument will override.
   */
  addressId?: InputMaybe<Scalars['ID']['input']>;
  /** The corporate account that will own the event's order. */
  corpAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** The customer's preference for delivery setup. */
  deliverySetup?: InputMaybe<DeliverySetup>;
  /** The local time that the event will take place, in the time zone of the address. */
  eventLocalTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** The name given to the event by the customer. */
  eventName?: InputMaybe<Scalars['String']['input']>;
  /** The date that the event will take place. */
  eventOn?: InputMaybe<Scalars['Date']['input']>;
  /** The number of people being fed by the event. */
  headcount?: InputMaybe<Scalars['Int']['input']>;
  strategy: FulfillmentDetailStrategy;
};

/** Arguments for filtering FulfillmentDetails. */
export type FulfillmentDetailFilterInput = {
  /** Excludes fulfillment details whose only carts are order modifications. */
  excludeModificationCarts?: InputMaybe<Scalars['Boolean']['input']>;
  hasDateAndTime?: InputMaybe<Scalars['Boolean']['input']>;
  includeUneditable?: InputMaybe<Scalars['Boolean']['input']>;
  isInFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Only return fulfillment details that have at least one consumer cart, whether
   * or not any cart has items. Use instead of `onlyNonEmptyCarts` to include
   * fulfillment details whose carts are all empty.
   */
  onlyFulfillmentDetailsWithCarts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyGeocodedAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNonEmptyCarts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The type of Order. */
export enum FulfillmentDetailStrategy {
  Delivery = 'DELIVERY',
  Takeout = 'TAKEOUT',
}

export type FulfillmentDetailUpdateInput = {
  address?: InputMaybe<FulfillmentDetailAddressInput>;
  /**
   * The address book entry address uuid to associate with for default attributes,
   * attributes in the address argument will override.
   */
  addressId?: InputMaybe<Scalars['ID']['input']>;
  /** The corporate account that will own the event's order. */
  corpAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** The customer's preference for delivery setup. */
  deliverySetup?: InputMaybe<DeliverySetup>;
  /** The local time that the event will take place, in the time zone of the address. */
  eventLocalTime?: InputMaybe<Scalars['LocalTime']['input']>;
  /** The name given to the event by the customer. */
  eventName?: InputMaybe<Scalars['String']['input']>;
  /** The date that the event will take place. */
  eventOn?: InputMaybe<Scalars['Date']['input']>;
  /** The number of people being fed by the event. */
  headcount?: InputMaybe<Scalars['Int']['input']>;
  strategy?: InputMaybe<FulfillmentDetailStrategy>;
};

/** Categories of fulfillment issues */
export enum FulfillmentIssueCategory {
  AccuracyIssue = 'ACCURACY_ISSUE',
  DeliveryIssue = 'DELIVERY_ISSUE',
  FoodWasNotReadyForDelivery = 'FOOD_WAS_NOT_READY_FOR_DELIVERY',
  MissingFood = 'MISSING_FOOD',
  Other = 'OTHER',
  OtherDeliveryIssue = 'OTHER_DELIVERY_ISSUE',
  TimingIssue = 'TIMING_ISSUE',
  Tracking = 'TRACKING',
  Uncategorized = 'UNCATEGORIZED',
  UndeliveredOrder = 'UNDELIVERED_ORDER',
}

/** The codes associated with fulfillment issues */
export enum FulfillmentIssueCode {
  ActOfGod = 'ACT_OF_GOD',
  CatererMiscommunication = 'CATERER_MISCOMMUNICATION',
  CustomerMiscommunication = 'CUSTOMER_MISCOMMUNICATION',
  CustomerUnprofessional = 'CUSTOMER_UNPROFESSIONAL',
  DeliveryInstructionsNotFollowed = 'DELIVERY_INSTRUCTIONS_NOT_FOLLOWED',
  DeliveryOutsourced = 'DELIVERY_OUTSOURCED',
  DeliveryPartiallyTracked = 'DELIVERY_PARTIALLY_TRACKED',
  DeliveryUntracked = 'DELIVERY_UNTRACKED',
  DietaryRequestsNotAccommodated = 'DIETARY_REQUESTS_NOT_ACCOMMODATED',
  DriverDidNotAdhereFoodSafetyRegulations = 'DRIVER_DID_NOT_ADHERE_FOOD_SAFETY_REGULATIONS',
  DriverMissingDeliveryEquipment = 'DRIVER_MISSING_DELIVERY_EQUIPMENT',
  DroppedOffToWrongLocation = 'DROPPED_OFF_TO_WRONG_LOCATION',
  Early = 'EARLY',
  EzcaterMiscommunication = 'EZCATER_MISCOMMUNICATION',
  EzcaterTechnologyIssue = 'EZCATER_TECHNOLOGY_ISSUE',
  EzdCatererFulfilledOrder = 'EZD_CATERER_FULFILLED_ORDER',
  EzdDriverLateToPickup = 'EZD_DRIVER_LATE_TO_PICKUP',
  EzdDriverLateToPickupFifteenToThirtyMinutesLate = 'EZD_DRIVER_LATE_TO_PICKUP_FIFTEEN_TO_THIRTY_MINUTES_LATE',
  EzdDriverLateToPickupFortyFiveToSixtyMinutesLate = 'EZD_DRIVER_LATE_TO_PICKUP_FORTY_FIVE_TO_SIXTY_MINUTES_LATE',
  EzdDriverLateToPickupSixtyPlusMinutesLate = 'EZD_DRIVER_LATE_TO_PICKUP_SIXTY_PLUS_MINUTES_LATE',
  EzdDriverLateToPickupThirtyToFortyFiveMinutesLate = 'EZD_DRIVER_LATE_TO_PICKUP_THIRTY_TO_FORTY_FIVE_MINUTES_LATE',
  EzdDriverLateToPickupZeroToFifteenMinutesLate = 'EZD_DRIVER_LATE_TO_PICKUP_ZERO_TO_FIFTEEN_MINUTES_LATE',
  EzdDriverNoShowForPickup = 'EZD_DRIVER_NO_SHOW_FOR_PICKUP',
  EzdFoodNotReadyForPickup = 'EZD_FOOD_NOT_READY_FOR_PICKUP',
  EzdFoodNotReadyForPickupFifteenToThirtyMinutesLate = 'EZD_FOOD_NOT_READY_FOR_PICKUP_FIFTEEN_TO_THIRTY_MINUTES_LATE',
  EzdFoodNotReadyForPickupFortyFiveToSixtyMinutesLate = 'EZD_FOOD_NOT_READY_FOR_PICKUP_FORTY_FIVE_TO_SIXTY_MINUTES_LATE',
  EzdFoodNotReadyForPickupSixtyPlusMinutesLate = 'EZD_FOOD_NOT_READY_FOR_PICKUP_SIXTY_PLUS_MINUTES_LATE',
  EzdFoodNotReadyForPickupThirtyToFortyFiveMinutesLate = 'EZD_FOOD_NOT_READY_FOR_PICKUP_THIRTY_TO_FORTY_FIVE_MINUTES_LATE',
  EzdFoodNotReadyForPickupZeroToFifteenMinutesLate = 'EZD_FOOD_NOT_READY_FOR_PICKUP_ZERO_TO_FIFTEEN_MINUTES_LATE',
  FifteenToThirtyMinLate = 'FIFTEEN_TO_THIRTY_MIN_LATE',
  FoodBadOrInedible = 'FOOD_BAD_OR_INEDIBLE',
  FoodNotIndividuallyPackaged = 'FOOD_NOT_INDIVIDUALLY_PACKAGED',
  IncorrectPreparation = 'INCORRECT_PREPARATION',
  LastMinuteModification = 'LAST_MINUTE_MODIFICATION',
  Late = 'LATE',
  LateDelivery = 'LATE_DELIVERY',
  LostDriver = 'LOST_DRIVER',
  MissingFood = 'MISSING_FOOD',
  MissingOrderItems = 'MISSING_ORDER_ITEMS',
  MissingUtensilsOrOtherEquipment = 'MISSING_UTENSILS_OR_OTHER_EQUIPMENT',
  MoreThanFifteenMinEarly = 'MORE_THAN_FIFTEEN_MIN_EARLY',
  MoreThanSixtyMinLate = 'MORE_THAN_SIXTY_MIN_LATE',
  NeverFulfilled = 'NEVER_FULFILLED',
  NotLabeledAsRequested = 'NOT_LABELED_AS_REQUESTED',
  NotPackagedAsRequested = 'NOT_PACKAGED_AS_REQUESTED',
  OrderDidNotArrive = 'ORDER_DID_NOT_ARRIVE',
  OrderNotSetup = 'ORDER_NOT_SETUP',
  PackagingBadOrDamaged = 'PACKAGING_BAD_OR_DAMAGED',
  ThirtyToSixtyMinLate = 'THIRTY_TO_SIXTY_MIN_LATE',
  TooEarly = 'TOO_EARLY',
  TooLate = 'TOO_LATE',
  TpdIssue = 'TPD_ISSUE',
  UnprofessionalDriver = 'UNPROFESSIONAL_DRIVER',
  UnresponsiveCaterer = 'UNRESPONSIVE_CATERER',
  WrongOrderDelivered = 'WRONG_ORDER_DELIVERED',
  ZeroToFifteenMinLate = 'ZERO_TO_FIFTEEN_MIN_LATE',
}

/** Sources from where a fulfillment issue can be reported */
export enum FulfillmentIssueReportedBySource {
  /** FulfillmentIssue report originates from the automated */
  Automated = 'automated',
  /** FulfillmentIssue report originates from the company portal */
  CompanyPortal = 'company_portal',
  /** FulfillmentIssue report originates from the support dash */
  SupportDash = 'support_dash',
}

/** Entities that can report a fulfillment issue */
export enum FulfillmentIssueReporter {
  Caterer = 'CATERER',
  Customer = 'CUSTOMER',
  Ezcater = 'EZCATER',
  NlpCustomerReview = 'NLP_CUSTOMER_REVIEW',
  TpdPartner = 'TPD_PARTNER',
  Unknown = 'UNKNOWN',
}

/** Sources from whom a fulfillment issue can be reported. */
export enum FulfillmentIssueSource {
  /** FulfillmentIssue report originates from caterer */
  Caterer = 'caterer',
  /** FulfillmentIssue report originates from customer */
  Customer = 'customer',
  /** FulfillmentIssue report originates from ezcater */
  Ezcater = 'ezcater',
  /** FulfillmentIssue report originates from ezd */
  Ezd = 'ezd',
}

/** Filters that control which fulfillment issues are returned for an order */
export enum FulfillmentIssuesFilter {
  CpVisible = 'CP_VISIBLE',
}

/** The gender options for a demographic profile */
export enum GenderDemographic {
  DeclineAnswer = 'DECLINE_ANSWER',
  DifferentDescription = 'DIFFERENT_DESCRIPTION',
  Man = 'MAN',
  NonBinary = 'NON_BINARY',
  Woman = 'WOMAN',
}

export enum GranularityEnum {
  /** Daily granularity */
  Day = 'day',
  /** Monthly granularity */
  Month = 'month',
  /** Weekly granularity */
  Week = 'week',
  /** Yearly granularity */
  Year = 'year',
}

/** Gratuity types that are available to concierge customers */
export enum Gratuity {
  FlatRatePerOrder = 'FLAT_RATE_PER_ORDER',
  OrderPercentage = 'ORDER_PERCENTAGE',
}

/** Type of campaign group distribution strategy */
export enum GroupTypeEnum {
  DistributeByDemand = 'DISTRIBUTE_BY_DEMAND',
  DistributeEvenly = 'DISTRIBUTE_EVENLY',
}

export type GuestUserInput = {
  /** Email of the guest user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Name of the guest user. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The channel of onboarding type to create the draft submission for. */
export enum GuidedOnboardingChannelType {
  DirectOnboarding = 'DIRECT_ONBOARDING',
  GuidedOnboarding = 'GUIDED_ONBOARDING',
}

/** The headcount for an order */
export type Headcount = {
  /** The headcount for gluten-free eaters */
  glutenFree?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** The headcount for halal eaters */
  halal?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** The headcount for kosher eaters */
  kosher?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** The headcount for non-dietary restricted eaters */
  unrestricted?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** The headcount for vegan eaters */
  vegan?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** The headcount for vegetarian eaters */
  vegetarian?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/** Whether a customer gave the new home page a thumbs up or a thumbs down */
export enum HomeFeedbackRating {
  Down = 'DOWN',
  Up = 'UP',
}

/** A predefined reason a customer picks to explain their home page feedback rating */
export enum HomeFeedbackReason {
  ConfusingFiltersIcons = 'CONFUSING_FILTERS_ICONS',
  CuisineFilterShortcuts = 'CUISINE_FILTER_SHORTCUTS',
  DiscoveringRestaurants = 'DISCOVERING_RESTAURANTS',
  EasierReorder = 'EASIER_REORDER',
  FeelsCluttered = 'FEELS_CLUTTERED',
  FeelsPersonalized = 'FEELS_PERSONALIZED',
  HardToFindPrevious = 'HARD_TO_FIND_PREVIOUS',
  SlowToLoad = 'SLOW_TO_LOAD',
  TooMuchScrolling = 'TOO_MUCH_SCROLLING',
  TrackingOrders = 'TRACKING_ORDERS',
}

/** Input arguments required to authorize a lead or a customer to a house account */
export type HouseAccountContactInput = {
  contactId: Scalars['ID']['input'];
  contactType: HouseAccountContactTypeEnum;
};

/** The types of contacts that can be associated with a house account */
export enum HouseAccountContactTypeEnum {
  Customer = 'CUSTOMER',
  Lead = 'LEAD',
}

/** The types of fields that can be sorted by on a house account */
export enum HouseAccountsSortFieldTypeEnum {
  AccountId = 'ACCOUNT_ID',
  BillingContact = 'BILLING_CONTACT',
  CompanyName = 'COMPANY_NAME',
  Id = 'ID',
  LastOrdered = 'LAST_ORDERED',
}

/** Indicates whether a menu item will be, can be, or cannot be individually wrapped */
export enum IndividualWrapStatus {
  /** Item cannot be individually wrapped */
  CannotBeIndividuallyWrapped = 'CANNOT_BE_INDIVIDUALLY_WRAPPED',
  /** Item can be individually wrapped through modifier selection */
  CanBeIndividuallyWrapped = 'CAN_BE_INDIVIDUALLY_WRAPPED',
  /** Item will be individually wrapped */
  WillBeIndividuallyWrapped = 'WILL_BE_INDIVIDUALLY_WRAPPED',
}

/** Industries a contact is able to be associated with */
export enum IndustryTypeEnum {
  Accounting = 'accounting',
  Advertising = 'advertising',
  Construction = 'construction',
  Consulting = 'consulting',
  Education = 'education',
  Financial = 'financial',
  Healthcare = 'healthcare',
  Manufacturing = 'manufacturing',
  NonProfit = 'non_profit',
  Other = 'other',
  Pharma = 'pharma',
  RealEstate = 'real_estate',
  Retail = 'retail',
  Technology = 'technology',
  Utility = 'utility',
}

/** Whether an interaction is inbound or outbound */
export enum InteractionDirections {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND',
}

/** Allowed values for the source type of InteractionOrderActivities */
export enum InteractionOrderActivitySource {
  TwilioTextMessage = 'TwilioTextMessage',
  WebChatEvent = 'WebChatEvent',
}

/** Allowed values for an Invitation's access scope. */
export enum InvitationAccessScope {
  AddItems = 'ADD_ITEMS',
  Checkout = 'CHECKOUT',
  ModifyAddress = 'MODIFY_ADDRESS',
  ModifyCartFields = 'MODIFY_CART_FIELDS',
  ModifyDatetime = 'MODIFY_DATETIME',
  ModifyOwnItems = 'MODIFY_OWN_ITEMS',
  Pay = 'PAY',
  View = 'VIEW',
}

/** A destination an account's invoices are routed to */
export enum InvoiceDeliveryDestination {
  Email = 'EMAIL',
  ProcurementSystem = 'PROCUREMENT_SYSTEM',
}

/** Payment statuses for an invoice */
export enum InvoicePaymentStatus {
  Paid = 'paid',
  Unpaid = 'unpaid',
  Voided = 'voided',
}

/** The various statuses an invoice can have */
export enum InvoiceStatusType {
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Sent = 'SENT',
}

/** Issues selected by the user on the self-reported fulfillment issues form */
export enum IssueSelection {
  DeliveryInstructionsNotFollowed = 'DELIVERY_INSTRUCTIONS_NOT_FOLLOWED',
  DietaryRequestsNotAccommodated = 'DIETARY_REQUESTS_NOT_ACCOMMODATED',
  DriverDidNotAdhereFoodSafetyRegulations = 'DRIVER_DID_NOT_ADHERE_FOOD_SAFETY_REGULATIONS',
  DriverMissingDeliveryEquipment = 'DRIVER_MISSING_DELIVERY_EQUIPMENT',
  DroppedOffToWrongLocation = 'DROPPED_OFF_TO_WRONG_LOCATION',
  FoodBadOrInedible = 'FOOD_BAD_OR_INEDIBLE',
  IncorrectPreparation = 'INCORRECT_PREPARATION',
  MissingFood = 'MISSING_FOOD',
  MissingFoodPartial = 'MISSING_FOOD_PARTIAL',
  MissingUtensilsOrOtherEquipment = 'MISSING_UTENSILS_OR_OTHER_EQUIPMENT',
  NotLabeledAsRequested = 'NOT_LABELED_AS_REQUESTED',
  OrderDidNotArrive = 'ORDER_DID_NOT_ARRIVE',
  SomethingElse = 'SOMETHING_ELSE',
  TooEarly = 'TOO_EARLY',
  TooHotOrTooCold = 'TOO_HOT_OR_TOO_COLD',
  TooLate = 'TOO_LATE',
  UnprofessionalDriver = 'UNPROFESSIONAL_DRIVER',
  WrongOrderDelivered = 'WRONG_ORDER_DELIVERED',
}

/** Attributes for each order item change */
export type ItemChangeInput = {
  changeType: OrderItemChangeTypes;
  originalItemJson: Scalars['String']['input'];
  proposedItemJson: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Category of a caterer's lead time requirement */
export enum LeadTimeCategory {
  /** Order must be placed by a cutoff time the day before */
  DayBefore = 'DAY_BEFORE',
  /** Order requires more than 720 minutes (12 hours) of notice */
  MultipleDays = 'MULTIPLE_DAYS',
  /** Order can be placed same-day (notice <= 720 minutes) */
  SameDay = 'SAME_DAY',
}

/** The types of fields that can be sorted by on a lead */
export enum LeadsSortFieldTypeEnum {
  Email = 'EMAIL',
  Id = 'ID',
  Industry = 'INDUSTRY',
  Name = 'NAME',
}

/** Types of legal requests under CCPA */
export enum LegalRequest {
  /** Information about how you collect, use, and share my personal information */
  DataCollectionInfo = 'DATA_COLLECTION_INFO',
  /** Provide you with information about the financial incentives that we have to offer you, if any */
  FinancialIncentives = 'FINANCIAL_INCENTIVES',
  /**
   * Opt out of the processing of your personal information for purposes of
   * profiling in furtherance of decisions that produce legal or similarly
   * significant effects, if applicable.
   */
  OptOut = 'OPT_OUT',
  /** Access to the personal information you store about me */
  PersonalDataAccess = 'PERSONAL_DATA_ACCESS',
  /** Correct the personal information you store about me */
  PersonalDataCorrection = 'PERSONAL_DATA_CORRECTION',
  /** Deletion of the personal information you store about me */
  PersonalDataDeletion = 'PERSONAL_DATA_DELETION',
}

/** Input for submitting a legal request (CCPA Data Rights, Offline Disclosure Opt Out, etc.) */
export type LegalRequestInput = {
  authorizedAgentAuthorizationProofKey?: InputMaybe<Scalars['String']['input']>;
  authorizedAgentName?: InputMaybe<Scalars['String']['input']>;
  authorizedAgentRelationship?: InputMaybe<Scalars['String']['input']>;
  infoCertification: Scalars['Boolean']['input'];
  personEmail: Scalars['String']['input'];
  personName: Scalars['String']['input'];
  personPhoneNumber: Scalars['String']['input'];
  personType: LegalRequestPerson;
  typeOfReq?: InputMaybe<Array<LegalRequest>>;
};

/** Who the legal request is being submitted for */
export enum LegalRequestPerson {
  /** Request for oneself */
  Myself = 'MYSELF',
  /** Request on behalf of someone else (authorized agent) */
  SomeoneElse = 'SOMEONE_ELSE',
}

/** Allowed limit methods for a spending policy */
export enum LimitMethod {
  /** annual_budget */
  AnnualBudget = 'annual_budget',
  /** daily_budget */
  DailyBudget = 'daily_budget',
  /** delivery_fee */
  DeliveryFee = 'delivery_fee',
  /** delivery_fee_per_head */
  DeliveryFeePerHead = 'delivery_fee_per_head',
  /** food_cost_per_head */
  FoodCostPerHead = 'food_cost_per_head',
  /** monthly_budget */
  MonthlyBudget = 'monthly_budget',
  /** quarterly_budget */
  QuarterlyBudget = 'quarterly_budget',
  /** tip */
  Tip = 'tip',
  /** tip_per_head */
  TipPerHead = 'tip_per_head',
  /** tip_percentage_max */
  TipPercentageMax = 'tip_percentage_max',
  /** tip_percentage_min */
  TipPercentageMin = 'tip_percentage_min',
  /** total */
  Total = 'total',
  /** total_cost_per_head */
  TotalCostPerHead = 'total_cost_per_head',
  /** weekly_budget */
  WeeklyBudget = 'weekly_budget',
}

/** Allowed values for a line item's percent type */
export enum LineItemPercentTypeEnum {
  Food = 'FOOD',
}

/** Allowed values for line item type */
export enum LineItemTypeEnum {
  Adjustment = 'ADJUSTMENT',
  CatererFundedPromo = 'CATERER_FUNDED_PROMO',
  Commission = 'COMMISSION',
  CreditCardFee = 'CREDIT_CARD_FEE',
  CustomerPricingFee = 'CUSTOMER_PRICING_FEE',
  DeliveryFee = 'DELIVERY_FEE',
  DeliveryFeeCommission = 'DELIVERY_FEE_COMMISSION',
  Discount = 'DISCOUNT',
  ExternalIntegrationFee = 'EXTERNAL_INTEGRATION_FEE',
  EzRewardsCredit = 'EZ_REWARDS_CREDIT',
  MarketplaceFeesTax = 'MARKETPLACE_FEES_TAX',
  MiscFee = 'MISC_FEE',
  PointOfSaleIntegrationFee = 'POINT_OF_SALE_INTEGRATION_FEE',
  Promo = 'PROMO',
  RetailDeliveryFee = 'RETAIL_DELIVERY_FEE',
  RetailDeliveryFeeRemittance = 'RETAIL_DELIVERY_FEE_REMITTANCE',
  SalesTax = 'SALES_TAX',
  SalesTaxAdjustment = 'SALES_TAX_ADJUSTMENT',
  SalesTaxRemittance = 'SALES_TAX_REMITTANCE',
}

/** Allowed values for delivery tracking layout modifiers. */
export enum LiveDeliveryTrackingLayout {
  /**
   * Specifies that the delivery tracking page will be shown in an app webview.
   * This layout will prevent the web chat widget from being displayed.
   */
  AppWebview = 'APP_WEBVIEW',
  /**
   * Specifies that the delivery tracking page will only display the map component
   * (i.e. UI for the header, timeline, etc. are hidden). This is useful for
   * iframing the app.
   */
  MapOnly = 'MAP_ONLY',
}

/** Input arguments required to mark an invoice as paid */
export type MarkInvoicePaidInput = {
  invoiceId: Scalars['ID']['input'];
};

/** Input arguments required to mark an invoice as unpaid */
export type MarkInvoiceUnpaidInput = {
  invoiceId: Scalars['ID']['input'];
};

/** Allowed values for marketing types */
export enum Marketing {
  Promo = 'PROMO',
  SponsoredListing = 'SPONSORED_LISTING',
}

/** Arguments for sorting marketing activities */
export type MarketingActivitySortInputType = {
  direction: SortDirection;
  field: SupplierMarketingActivitySortField;
};

/** Arguments for sorting marketing activity summaries */
export type MarketingActivitySummarySort = {
  direction: SortDirection;
  field: MarketingActivitySummarySortField;
};

/** Allowed values for sorting marketing activity summaries */
export enum MarketingActivitySummarySortField {
  AverageCostPerOrder = 'AVERAGE_COST_PER_ORDER',
  CampaignGroupName = 'CAMPAIGN_GROUP_NAME',
  Discount = 'DISCOUNT',
  MarketingTax = 'MARKETING_TAX',
  NetCharges = 'NET_CHARGES',
  OrderCount = 'ORDER_COUNT',
  TotalCharges = 'TOTAL_CHARGES',
}

/** Transaction type of a marketing activity */
export enum MarketingActivityTransactionTypeEnum {
  CanceledOrderCredit = 'CANCELED_ORDER_CREDIT',
  Charge = 'CHARGE',
  Payment = 'PAYMENT',
}

/** Required and optional fields used to search for caterers */
export type MarketplaceCatererSearchFilter = {
  budgetPerPerson?: InputMaybe<MoneyInput>;
  cuisineOption?: InputMaybe<CuisineOptionEnum>;
  deliveryFee?: InputMaybe<MoneyInput>;
  dietaryOptions?: InputMaybe<Array<DietaryOptionEnum>>;
  /** The caterers' distance in miles from the provided address */
  distance?: InputMaybe<Scalars['Int']['input']>;
  extendedServices?: InputMaybe<Array<CatererSearchExtendedServiceOption>>;
  individualPackaging?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderMinimum?: InputMaybe<MoneyInput>;
  reliabilityRockstar?: InputMaybe<Scalars['Boolean']['input']>;
  rewardsLevel?: InputMaybe<CatererSearchRewardsLevel>;
  starRating?: InputMaybe<CatererSearchStarRating>;
  taxonomiesAndTaxons?: InputMaybe<SearchTaxonomiesAndTaxonsInput>;
  /** Deprecated: use taxonomies_and_taxons instead */
  taxons?: InputMaybe<TaxonFilterInput>;
};

/** Allowed values for user type */
export enum MarketplaceSearchUserType {
  Existing = 'EXISTING',
  New = 'NEW',
}

/** Allowed values for marketplace status field for Google Analytics 4 tracking */
export enum MarketplaceStatusEnum {
  Existing = 'existing',
  New = 'new',
}

/** Meal types that are available to concierge customers */
export enum Meal {
  Breakfast = 'BREAKFAST',
  Dessert = 'DESSERT',
  Dinner = 'DINNER',
  Lunch = 'LUNCH',
  Snacks = 'SNACKS',
  SpecialEvent = 'SPECIAL_EVENT',
}

export enum MealName {
  Breakfast = 'breakfast',
  Dinner = 'dinner',
  Lunch = 'lunch',
}

/** Which parts of the order are required, allowed, and excluded */
export type MealParts = {
  desserts?: InputMaybe<OrderGenerationMealPartStatus>;
  drinks?: InputMaybe<OrderGenerationMealPartStatus>;
  entrees?: InputMaybe<OrderGenerationMealPartStatus>;
  sides?: InputMaybe<OrderGenerationMealPartStatus>;
};

/** Menu category filter options */
export enum MenuCategoryFilter {
  All = 'ALL',
  Displayable = 'DISPLAYABLE',
}

/** Channels for menu visibility */
export enum MenuChannel {
  /** Marketplace channel */
  Marketplace = 'MARKETPLACE',
  /** Relish channel */
  Relish = 'RELISH',
}

/** Channels for menu visibility (input) */
export enum MenuChannelInput {
  /** Marketplace channel */
  Marketplace = 'MARKETPLACE',
  /** Relish channel */
  Relish = 'RELISH',
}

/** An enumeration of the different types of disclaimers that apply to a menu */
export enum MenuDisclaimerKey {
  /**
   * ezCater menu prices may vary from, and be higher than, restaurant's menu
   * prices in-store or elsewhere and may reflect delivery-related fees.
   */
  DisclaimerPricing = 'DISCLAIMER_PRICING',
}

/** Dietary tags for menu items */
export enum MenuItemDietaryTag {
  /** Gluten-free dietary option */
  GlutenFree = 'GLUTEN_FREE',
  /** Halal dietary option */
  Halal = 'HALAL',
  /** Kosher dietary option */
  Kosher = 'KOSHER',
  /** Vegan dietary option */
  Vegan = 'VEGAN',
  /** Vegetarian dietary option */
  Vegetarian = 'VEGETARIAN',
}

/** MItem filter options */
export enum MenuItemFilter {
  All = 'ALL',
  Catering = 'CATERING',
  Live = 'LIVE',
}

/** Allowed values for reporting period for a caterer account's menu item sales analysis. */
export enum MenuItemSalesAnalysisReportingPeriod {
  NinetyDays = 'NINETY_DAYS',
  SevenDays = 'SEVEN_DAYS',
  ThirtyDays = 'THIRTY_DAYS',
}

/** Allowed values for sorting a caterer account's list of menu item sales analyses. */
export enum MenuItemSalesAnalysisSort {
  ItemsPrice = 'ITEMS_PRICE',
  ItemsSold = 'ITEMS_SOLD',
  ItemsSoldPctChg = 'ITEMS_SOLD_PCT_CHG',
  ItemRevenue = 'ITEM_REVENUE',
  ItemRevenuePctChg = 'ITEM_REVENUE_PCT_CHG',
  MenuItemName = 'MENU_ITEM_NAME',
  OrdersWithItem = 'ORDERS_WITH_ITEM',
  OrdersWithItemPctChg = 'ORDERS_WITH_ITEM_PCT_CHG',
}

/** Arguments for sorting a list menu item sales analyses. */
export type MenuItemSalesAnalysisSortInput = {
  direction: SortDirection;
  field: MenuItemSalesAnalysisSort;
};

export enum MenuItemSizeStatus {
  Hidden = 'HIDDEN',
  Show = 'SHOW',
  Unavailable = 'UNAVAILABLE',
}

/** Values for the weight field of a MenuTagOverride. */
export enum MenuTagOverrideWeight {
  Invalid = 'INVALID',
  Valid = 'VALID',
}

/** Possible menuevo enablement states for a supplier on classic */
export enum MenuevoEnablementClassicValue {
  Available = 'AVAILABLE',
  Deprecated = 'DEPRECATED',
  No = 'NO',
}

/** Possible menuevo enablement states for a supplier on menuevo */
export enum MenuevoEnablementMenuevoValue {
  InTransition = 'IN_TRANSITION',
  No = 'NO',
  Ready = 'READY',
}

/** Non-dietary classifiers for menu items */
export enum MenuevoItemClassifier {
  /** Dessert item */
  Dessert = 'DESSERT',
  /** Drink item */
  Drink = 'DRINK',
  /** Spicy item */
  Spicy = 'SPICY',
}

/** Units used for menu items */
export enum MenuevoUnit {
  /** Bar */
  Bar = 'BAR',
  /** Bottle */
  Bottle = 'BOTTLE',
  /** Bowl */
  Bowl = 'BOWL',
  /** Box */
  Box = 'BOX',
  /** Buffet */
  Buffet = 'BUFFET',
  /** Cake */
  Cake = 'CAKE',
  /** Can */
  Can = 'CAN',
  /** Carafe */
  Carafe = 'CARAFE',
  /** Dozen */
  Dozen = 'DOZEN',
  /** Foot */
  Foot = 'FOOT',
  /** Full pan */
  FullPan = 'FULL_PAN',
  /** Gallon */
  Gallon = 'GALLON',
  /** Half gallon */
  HalfGallon = 'HALF_GALLON',
  /** Half pan */
  HalfPan = 'HALF_PAN',
  /** Item */
  Item = 'ITEM',
  /** Kit */
  Kit = 'KIT',
  /** Liter */
  Liter = 'LITER',
  /** Package */
  Package = 'PACKAGE',
  /** Pan */
  Pan = 'PAN',
  /** Person */
  Person = 'PERSON',
  /** Pie */
  Pie = 'PIE',
  /** Piece */
  Piece = 'PIECE',
  /** Pint */
  Pint = 'PINT',
  /** Pizza */
  Pizza = 'PIZZA',
  /** Platter */
  Platter = 'PLATTER',
  /** Pound */
  Pound = 'POUND',
  /** Quart */
  Quart = 'QUART',
  /** Roll */
  Roll = 'ROLL',
  /** 6-pack */
  SixPack = 'SIX_PACK',
  /** Skewer */
  Skewer = 'SKEWER',
  /** Slider */
  Slider = 'SLIDER',
  /** Taco */
  Taco = 'TACO',
  /** Tray */
  Tray = 'TRAY',
  /** 12-pack */
  TwelvePack = 'TWELVE_PACK',
  /** 2-liter */
  TwoLiter = 'TWO_LITER',
}

/** States that a message may be in */
export enum MessageStatus {
  /** approved */
  Approved = 'APPROVED',
  /** blocked */
  Blocked = 'BLOCKED',
  /** flagged */
  Flagged = 'FLAGGED',
  /** pending */
  Pending = 'PENDING',
}

/** Why the metrics window starts when it does */
export enum MetricsWindowStartReason {
  /** The window starts 90 days ago (standard rolling window) */
  Default = 'DEFAULT',
  /** The window starts at the caterer's marketplace join date */
  Join = 'JOIN',
  /** The window starts at the end of the most recent qualifying performance pause */
  PauseReset = 'PAUSE_RESET',
}

/** Types of modifier groups */
export enum ModifierGroupType {
  /** Size-based modifier group */
  Sizes = 'SIZES',
  /** Standard modifier group */
  Standard = 'STANDARD',
}

/** How a Menuevo modifier group constrains selection quantities */
export enum ModifierQuantityRules {
  /** Per-modifier quantities (a quantity-select group) */
  Incremental = 'INCREMENTAL',
  /** Several modifiers, each at quantity 1 */
  MultipleSelection = 'MULTIPLE_SELECTION',
  /** Pick at most one modifier from the group */
  SingleSelection = 'SINGLE_SELECTION',
}

export type MoneyInput = {
  currency?: InputMaybe<Currency>;
  subunits: Scalars['Int']['input'];
};

/** Primary nature of the issue selected by the user on the self-reported fulfillment issues form */
export enum NatureOfIssue {
  DeliveryTime = 'DELIVERY_TIME',
  FoodQualityOrPreparation = 'FOOD_QUALITY_OR_PREPARATION',
  MissingOrIncorrectItems = 'MISSING_OR_INCORRECT_ITEMS',
  ProblemWithDriver = 'PROBLEM_WITH_DRIVER',
  SomethingElse = 'SOMETHING_ELSE',
}

/** Notification types for Credit Line notices */
export enum Notice {
  ApproachingLimit = 'approaching_limit',
  AuthFailure = 'auth_failure',
  NearLimit = 'near_limit',
  OverLimit = 'over_limit',
}

/** Severity levels for Credit Line Notices */
export enum NotificationSeverity {
  Critical = 'critical',
  Info = 'info',
  Warning = 'warning',
}

/** Available onboarding form pages with UI page header titles */
export enum OnboardingFormPageEnum {
  /** Hours & delivery (1 of 2) */
  HoursAndDelivery_1 = 'HOURS_AND_DELIVERY_1',
  /** Hours & delivery (2 of 2) */
  HoursAndDelivery_2 = 'HOURS_AND_DELIVERY_2',
  /** Menu */
  Menu = 'MENU',
  /** Payment info (1 of 2) */
  PaymentInfo_1 = 'PAYMENT_INFO_1',
  /** Payment info (2 of 2) */
  PaymentInfo_2 = 'PAYMENT_INFO_2',
  /** Store & contact info (1 of 2) */
  StoreAndContactInfo_1 = 'STORE_AND_CONTACT_INFO_1',
  /** Store & contact info (2 of 2) */
  StoreAndContactInfo_2 = 'STORE_AND_CONTACT_INFO_2',
}

/** Allowed values for source of operating hours */
export enum OperatingHoursSource {
  Api = 'API',
  Human = 'HUMAN',
}

/** Allowed values for sorting a caterer account's list of stores */
export enum OperationalMetricsStoreSortField {
  AdjustedAvgStarRating = 'ADJUSTED_AVG_STAR_RATING',
  AutoInterventionStatus = 'AUTO_INTERVENTION_STATUS',
  CancelPercentRolling_90Days = 'CANCEL_PERCENT_ROLLING_90_DAYS',
  FoodReadyPercentRolling_90Days = 'FOOD_READY_PERCENT_ROLLING_90_DAYS',
  IsReliabilityRockstar = 'IS_RELIABILITY_ROCKSTAR',
  OntimePercentRolling_90Days = 'ONTIME_PERCENT_ROLLING_90_DAYS',
  OrderAccuratePercentRolling_90Days = 'ORDER_ACCURATE_PERCENT_ROLLING_90_DAYS',
  RejectPercentRolling_90Days = 'REJECT_PERCENT_ROLLING_90_DAYS',
  ResponsivenessPercentRolling_90Days = 'RESPONSIVENESS_PERCENT_ROLLING_90_DAYS',
  TrackedDeliveryPercentRolling_90Days = 'TRACKED_DELIVERY_PERCENT_ROLLING_90_DAYS',
}

/** Arguments for sorting a list of stores for a caterer account on the operational metrics page. */
export type OperationalMetricsStoreSortInput = {
  direction: SortDirection;
  field: OperationalMetricsStoreSortField;
};

/** Allowed values for the metric name field in an Operational Performance Metric */
export enum OperationalPerformanceMetricName {
  AdjustedAvgStarRating = 'ADJUSTED_AVG_STAR_RATING',
  CancelPercentRolling_90Days = 'CANCEL_PERCENT_ROLLING_90_DAYS',
  FoodReadyPercentRolling_90Days = 'FOOD_READY_PERCENT_ROLLING_90_DAYS',
  OntimePercentRolling_90Days = 'ONTIME_PERCENT_ROLLING_90_DAYS',
  OrderAccuratePercentRolling_90Days = 'ORDER_ACCURATE_PERCENT_ROLLING_90_DAYS',
  RejectPercentRolling_90Days = 'REJECT_PERCENT_ROLLING_90_DAYS',
  ResponsivenessPercentRolling_90Days = 'RESPONSIVENESS_PERCENT_ROLLING_90_DAYS',
  TrackedDeliveryPercentRolling_90Days = 'TRACKED_DELIVERY_PERCENT_ROLLING_90_DAYS',
}

/** Allowed order action values */
export enum OrderActionsEnum {
  AcceptAction = 'accept_action',
  AcknowledgeAction = 'acknowledge_action',
  CancelAction = 'cancel_action',
  CatererSubmittedRefundAction = 'caterer_submitted_refund_action',
  ChangeRejectAction = 'change_reject_action',
  CompleteExternalPaymentAction = 'complete_external_payment_action',
  ConfirmCancellationAction = 'confirm_cancellation_action',
  ConfirmModificationAction = 'confirm_modification_action',
  DriverAssignAction = 'driver_assign_action',
  EditAction = 'edit_action',
  FoodPrepAction = 'food_prep_action',
  RejectAction = 'reject_action',
  RequestEzdispatchAction = 'request_ezdispatch_action',
  RequestModificationAction = 'request_modification_action',
  UndoCompleteExternalPaymentAction = 'undo_complete_external_payment_action',
}

/** Status of an order in the context of order attribution */
export enum OrderAttributionOrderStatusEnum {
  Cancelled = 'cancelled',
  Fulfilled = 'fulfilled',
  Rejected = 'rejected',
  Upcoming = 'upcoming',
}

/** Input object for updating custom checkout field values on an order */
export type OrderCustomCheckoutFieldInput = {
  customCheckoutFieldId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Dietary restrictions available for order generation */
export enum OrderGenerationDietaryRestriction {
  /** Gluten-free dietary restriction */
  GlutenFree = 'GLUTEN_FREE',
  /** Halal dietary restriction */
  Halal = 'HALAL',
  /** Kosher dietary restriction */
  Kosher = 'KOSHER',
  /** Vegan dietary restriction */
  Vegan = 'VEGAN',
  /** Vegetarian dietary restriction */
  Vegetarian = 'VEGETARIAN',
}

/** Acceptable statuses for a meal part */
export enum OrderGenerationMealPartStatus {
  Allowed = 'ALLOWED',
  Excluded = 'EXCLUDED',
  Required = 'REQUIRED',
}

/** The status of the solver when the order was generated */
export enum OrderGenerationSolverStatusEnum {
  Cached = 'CACHED',
  Feasible = 'FEASIBLE',
  Infeasible = 'INFEASIBLE',
  ModelInvalid = 'MODEL_INVALID',
  Optimal = 'OPTIMAL',
  Skipped = 'SKIPPED',
  Unknown = 'UNKNOWN',
}

/** Attributes for order detail information */
export type OrderInfoInput = {
  brandName: Scalars['String']['input'];
  eventAt: Scalars['ISO8601DateTime']['input'];
  /** may be a valid TZ name or an ISO offset */
  eventTimeZone?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPickup?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumber: Scalars['String']['input'];
  userUuid: Scalars['ID']['input'];
};

/** Ways in which an order item may be changed */
export enum OrderItemChangeTypes {
  /** addition */
  Addition = 'ADDITION',
  /** deletion */
  Deletion = 'DELETION',
  /** modification */
  Modification = 'MODIFICATION',
  /** substitution */
  Substitution = 'SUBSTITUTION',
}

export enum OrderOrdinalFilterEnum {
  NotCancelled = 'NOT_CANCELLED',
  Submitted = 'SUBMITTED',
  WithoutCatererSubmitted = 'WITHOUT_CATERER_SUBMITTED',
}

export enum OrderOrdinalScopeEnum {
  Consumer = 'CONSUMER',
}

export enum OrderOrdinalSortedByEnum {
  SubmittedAt = 'SUBMITTED_AT',
}

/** Allowed values for order payment method type */
export enum OrderPaymentMethodTypeEnum {
  CorpCreditLine = 'corp_credit_line',
  CreditCard = 'credit_card',
  Refund = 'refund',
}

/** For updating corporate reference codes on an Order. */
export type OrderReferenceCodeInput = {
  corporateReferenceCodeId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/** A section of the store-next orders dropdown. Keys match OrderSections::Sectioner rules. */
export enum OrderSectionKey {
  /** Orders completed within the review window (45 days) */
  RecentlyCompleted = 'RECENTLY_COMPLETED',
  /** Scheduled orders whose event is today, in the event address's timezone */
  Today = 'TODAY',
  /** All other scheduled orders */
  Upcoming = 'UPCOMING',
}

/**
 * A mode of the store-next orders dropdown. Each mode has its own population, sort
 * and OrderSections::Sectioner::RULES_BY_MODE entry; its rule order is section priority.
 */
export enum OrderSectionMode {
  /** The orders page's PAST population within the review window (45 days), newest first: RECENTLY_COMPLETED */
  Completed = 'COMPLETED',
  /** The orders page's UPCOMING population: TODAY first, then UPCOMING, soonest first */
  Scheduled = 'SCHEDULED',
}

/** Allowed values for short-notice action */
export enum OrderShortNoticeActions {
  Cancel = 'CANCEL',
  None = 'NONE',
  Substitute = 'SUBSTITUTE',
  Takeout = 'TAKEOUT',
}

/** Arguments for sorting orders */
export type OrderSortInputType = {
  direction: SortDirection;
  field: CatererOrderSortField;
};

/** Allowed values for order sources. An order source represents what user flow the order originated from */
export enum OrderSource {
  ClubSoda = 'CLUB_SODA',
  DirectEntry = 'DIRECT_ENTRY',
  EzOrdering = 'EZ_ORDERING',
  Marketplace = 'MARKETPLACE',
}

/** Allowed values for order state filtering */
export enum OrderStateFilterEnum {
  All = 'ALL',
  Cancelled = 'CANCELLED',
  CancelledNotRejected = 'CANCELLED_NOT_REJECTED',
  Draft = 'DRAFT',
  FulfilledAndUnpaid = 'FULFILLED_AND_UNPAID',
  Past = 'PAST',
  PendingApproval = 'PENDING_APPROVAL',
  PendingReview = 'PENDING_REVIEW',
  Receipt = 'RECEIPT',
  Rejected = 'REJECTED',
  Reviewable = 'REVIEWABLE',
  Submitted = 'SUBMITTED',
  SubmittedNotCancelled = 'SUBMITTED_NOT_CANCELLED',
  Unpaid = 'UNPAID',
  Upcoming = 'UPCOMING',
  UpcomingAndDrafts = 'UPCOMING_AND_DRAFTS',
  UpcomingNotPendingApproval = 'UPCOMING_NOT_PENDING_APPROVAL',
}

/** Allowed values for order task state filtering */
export enum OrderTaskFilter {
  Actionable = 'ACTIONABLE',
  All = 'ALL',
  Scheduled = 'SCHEDULED',
}

/** Class names for order task instruction polymorphic association */
export enum OrderTaskInstructionsObject {
  Brand = 'BRAND',
  BusinessGroup = 'BUSINESS_GROUP',
  Caterer = 'CATERER',
  CatererGroup = 'CATERER_GROUP',
  ContactsBlock = 'CONTACTS_BLOCK',
  User = 'USER',
}

/** Issue types for an order task */
export enum OrderTaskIssue {
  Blocked = 'BLOCKED',
  Paused = 'PAUSED',
  Processing = 'PROCESSING',
  Snoozing = 'SNOOZING',
  TooSoon = 'TOO_SOON',
}

/** Allowed values for order type */
export enum OrderTypeEnum {
  Delivery = 'DELIVERY',
  Takeout = 'TAKEOUT',
  ThirdPartyDelivery = 'THIRD_PARTY_DELIVERY',
}

/** Allowed values for an order type perspective */
export enum OrderTypePerspective {
  Caterer = 'CATERER',
  Customer = 'CUSTOMER',
  Ezcater = 'EZCATER',
}

/** Menu item crop size options. */
export enum OrderingMenuItemCrop {
  /** Crop size for a menu item on desktop. */
  Desktop = 'DESKTOP',
  /** Crop size for a menu item on mobile. */
  MobileRetina = 'MOBILE_RETINA',
}

/** Outage message type with audio file URL as the value */
export enum OutageMessageEnum {
  /** All channels (phones, webchat and SMS) are experiencing longer than normal wait-times */
  AllChannelsSlow = 'all_channels_slow',
  /** Only the phone service is degraded */
  OnlyPhonesDegraded = 'only_phones_degraded',
  /** Only phones are totally down */
  OnlyPhonesDown = 'only_phones_down',
  /** Phones are experiencing longer than normal wait-times */
  OnlyPhonesSlow = 'only_phones_slow',
  /** Both phones and chats are down */
  PhonesAndChatsDown = 'phones_and_chats_down',
  /** Phones are down for scheduled maintenance */
  ScheduledMaintenance = 'scheduled_maintenance',
}

/** The overall tracking statuses that an order can have. */
export enum OverallTrackingStatus {
  /** The delivery does not have complete tracking data that meets our quality standards. */
  PartiallyTracked = 'PARTIALLY_TRACKED',
  /** The delivery was fully tracked and the data meets our quality standards. */
  Tracked = 'TRACKED',
  /** The delivery does not have any tracking data. */
  Untracked = 'UNTRACKED',
}

/** The ownership category options for a demographic profile */
export enum OwnershipCategoryDemographic {
  CorporateOffice = 'CORPORATE_OFFICE',
  FranchiseGroup = 'FRANCHISE_GROUP',
  IndependentEntity = 'INDEPENDENT_ENTITY',
  IndependentFranchisee = 'INDEPENDENT_FRANCHISEE',
}

/** The ownership percentage options for a demographic profile */
export enum OwnershipPercentageDemographic {
  BuisnessOwnerUnknown = 'BUISNESS_OWNER_UNKNOWN',
  NoMajorityOwner = 'NO_MAJORITY_OWNER',
  OnePersonOwnsAtLeast_50Percent = 'ONE_PERSON_OWNS_AT_LEAST_50_PERCENT',
  TwoPeopleOwn_50Percent = 'TWO_PEOPLE_OWN_50_PERCENT',
}

/** Type of payees on the billing blocks */
export enum PayeeTypeEnum {
  Business = 'BUSINESS',
  Individual = 'INDIVIDUAL',
}

/** Type of payment method on Billing Blocks */
export enum PaymentMethodEnum {
  Ach = 'ACH',
  Check = 'CHECK',
}

export type PaymentMethodInputType = {
  id: Scalars['ID']['input'];
  type: PaymentMethodTypeEnum;
};

export enum PaymentMethodStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
}

/** Allowed values for payment method type */
export enum PaymentMethodTypeEnum {
  CreditCard = 'CreditCard',
  CreditLine = 'CreditLine',
}

/** Representation of the type of status in terms of how it should be displayed */
export enum PaymentStatusDisplay {
  Error = 'ERROR',
  Warning = 'WARNING',
}

export enum PayoneerStatus {
  Approved = 'approved',
  Declined = 'declined',
  InProgress = 'in_progress',
  NotRegistered = 'not_registered',
}

export type PerDaySubsidyEntry = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  friday?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  monday?: InputMaybe<Scalars['Float']['input']>;
  saturday?: InputMaybe<Scalars['Float']['input']>;
  sunday?: InputMaybe<Scalars['Float']['input']>;
  thursday?: InputMaybe<Scalars['Float']['input']>;
  tuesday?: InputMaybe<Scalars['Float']['input']>;
  wednesday?: InputMaybe<Scalars['Float']['input']>;
};

export type PerMealSubsidyEntry = {
  breakfastAmount?: InputMaybe<Scalars['Float']['input']>;
  dinnerAmount?: InputMaybe<Scalars['Float']['input']>;
  fridayBreakfast?: InputMaybe<Scalars['Float']['input']>;
  fridayDinner?: InputMaybe<Scalars['Float']['input']>;
  fridayLunch?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lunchAmount?: InputMaybe<Scalars['Float']['input']>;
  mondayBreakfast?: InputMaybe<Scalars['Float']['input']>;
  mondayDinner?: InputMaybe<Scalars['Float']['input']>;
  mondayLunch?: InputMaybe<Scalars['Float']['input']>;
  saturdayBreakfast?: InputMaybe<Scalars['Float']['input']>;
  saturdayDinner?: InputMaybe<Scalars['Float']['input']>;
  saturdayLunch?: InputMaybe<Scalars['Float']['input']>;
  sundayBreakfast?: InputMaybe<Scalars['Float']['input']>;
  sundayDinner?: InputMaybe<Scalars['Float']['input']>;
  sundayLunch?: InputMaybe<Scalars['Float']['input']>;
  thursdayBreakfast?: InputMaybe<Scalars['Float']['input']>;
  thursdayDinner?: InputMaybe<Scalars['Float']['input']>;
  thursdayLunch?: InputMaybe<Scalars['Float']['input']>;
  tuesdayBreakfast?: InputMaybe<Scalars['Float']['input']>;
  tuesdayDinner?: InputMaybe<Scalars['Float']['input']>;
  tuesdayLunch?: InputMaybe<Scalars['Float']['input']>;
  wednesdayBreakfast?: InputMaybe<Scalars['Float']['input']>;
  wednesdayDinner?: InputMaybe<Scalars['Float']['input']>;
  wednesdayLunch?: InputMaybe<Scalars['Float']['input']>;
};

export type PerWeekSubsidyEntry = {
  amount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PercentSubsidyEntry = {
  /** Percentage of order that will be applied to the subsidy */
  amount: Scalars['Float']['input'];
  /** Optional daily cap dollar limit for subsidy */
  dailyCap?: InputMaybe<Scalars['Float']['input']>;
  /** Unique identifier for subsidy */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Amount that an order must meet before subsidy is applied */
  spendFloor?: InputMaybe<Scalars['Float']['input']>;
  /** Optional weekly cap dollar limit for subsidy */
  weeklyCap?: InputMaybe<Scalars['Float']['input']>;
};

/** Allowed values for sorting caterers by their performance metrics */
export enum PerformanceMetricsCatererSortField {
  AverageOrderValue = 'AVERAGE_ORDER_VALUE',
  CatererTotalDue = 'CATERER_TOTAL_DUE',
  Nickname = 'NICKNAME',
  OrderCount = 'ORDER_COUNT',
  StoreNumber = 'STORE_NUMBER',
  TotalSales = 'TOTAL_SALES',
}

/** Arguments for sorting stores by their performance metrics fetched from the DAAS API */
export type PerformanceMetricsCatererSortInput = {
  direction: SortDirection;
  field: PerformanceMetricsCatererSortField;
};

/** Allowed values for the performance status field */
export enum PerformanceStatus {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW',
}

/** ezCater defined holidays for caterers to opt into being closed every year */
export enum PredefinedHolidayType {
  ChristmasDay = 'CHRISTMAS_DAY',
  ChristmasEve = 'CHRISTMAS_EVE',
  CincoDeMayo = 'CINCO_DE_MAYO',
  EarthDay = 'EARTH_DAY',
  EasterSunday = 'EASTER_SUNDAY',
  FatherSDay = 'FATHER_S_DAY',
  Halloween = 'HALLOWEEN',
  IndependenceDay = 'INDEPENDENCE_DAY',
  IndigenousPeopleSDay = 'INDIGENOUS_PEOPLE_S_DAY',
  Juneteenth = 'JUNETEENTH',
  LaborDay = 'LABOR_DAY',
  MardiGras = 'MARDI_GRAS',
  MartinLutherKingJrDay = 'MARTIN_LUTHER_KING_JR_DAY',
  MemorialDay = 'MEMORIAL_DAY',
  MotherSDay = 'MOTHER_S_DAY',
  NewYearSDay = 'NEW_YEAR_S_DAY',
  NewYearSEve = 'NEW_YEAR_S_EVE',
  StPatrickSDay = 'ST_PATRICK_S_DAY',
  Thanksgiving = 'THANKSGIVING',
  VeteransDay = 'VETERANS_DAY',
}

/** Different methods used when calculating a cart's price per head value. */
export enum PricePerHeadCalculationMethod {
  CustomerTotal = 'CUSTOMER_TOTAL',
  Food = 'FOOD',
}

/** Procurement systems a corp account can request an integration with */
export enum ProcurementSystem {
  Coupa = 'COUPA',
  Jaggaer = 'JAGGAER',
  SapAriba = 'SAP_ARIBA',
}

/** The menu system */
export enum ProductCatalog {
  /** The classic menu system: m_item, m_option, m_choice */
  Classic = 'CLASSIC',
  /** The menus core system */
  Menuevo = 'MENUEVO',
}

/** The requested profile for generating an order: full or essentials */
export enum Profile {
  Essentials = 'ESSENTIALS',
  Full = 'FULL',
}

/** The available funding sources for promos */
export enum PromoFundingTypeEnum {
  /** This promotion is funded by the caterer */
  CatererFunded = 'caterer_funded',
  /** This promotion is funded by ezCater */
  EzcaterFunded = 'ezcater_funded',
}

/** Allowed values for the order sort field */
export enum PromoOrderSortField {
  SubmittedAt = 'SUBMITTED_AT',
}

/** Arguments for sorting orders for a promo */
export type PromoOrderSortType = {
  direction: SortDirection;
  field: PromoOrderSortField;
};

/** The status of a promotion */
export enum PromoStatusEnum {
  /** The promotion is active */
  Active = 'ACTIVE',
  /** The promotion has expired */
  Expired = 'EXPIRED',
}

/** All the available statuses in which a promo can be */
export enum PromoStatusTypeEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
}

/** The channels that this promo is applicable to. */
export enum PromoTargetChannelEnum {
  All = 'ALL',
  Marketplace = 'MARKETPLACE',
  PrivateStore = 'PRIVATE_STORE',
}

/** Publicly accessible taxonomies */
export enum PublicTaxonomies {
  /** Promotions taxonomy */
  PromotionsTaxonomy = 'PROMOTIONS_TAXONOMY',
  /** Service capabilities taxonomy */
  ServiceCapabilitiesTaxonomy = 'SERVICE_CAPABILITIES_TAXONOMY',
}

/** The race options for a demographic profile */
export enum RaceDemographic {
  AsianNativeHawaiianPacificIslander = 'ASIAN_NATIVE_HAWAIIAN_PACIFIC_ISLANDER',
  BlackOrAfricanDescent = 'BLACK_OR_AFRICAN_DESCENT',
  DeclineAnswer = 'DECLINE_ANSWER',
  DifferentDescription = 'DIFFERENT_DESCRIPTION',
  HispanicLatinxSpanish = 'HISPANIC_LATINX_SPANISH',
  IndigenousAmericanIndianAlaskanNative = 'INDIGENOUS_AMERICAN_INDIAN_ALASKAN_NATIVE',
  MiddleEasternNorthAfrican = 'MIDDLE_EASTERN_NORTH_AFRICAN',
  WhiteOrEuropean = 'WHITE_OR_EUROPEAN',
}

/** Filters captured for a recent search, matching store-next's URL query params. */
export type RecentSearchParams = {
  budgetAmount?: InputMaybe<Scalars['Int']['input']>;
  businessSizingTaxonomy?: InputMaybe<Scalars['String']['input']>;
  businessTypeTaxonomy?: InputMaybe<Scalars['String']['input']>;
  cuisineOption?: InputMaybe<Scalars['String']['input']>;
  cuisineTaxonomy?: InputMaybe<Scalars['String']['input']>;
  deiOwnedBusinessTaxonomy?: InputMaybe<Scalars['String']['input']>;
  deliveryCapabilitiesTaxonomy?: InputMaybe<Scalars['String']['input']>;
  deliveryFee?: InputMaybe<Scalars['Int']['input']>;
  dietaryCapabilitiesTaxonomy?: InputMaybe<Scalars['String']['input']>;
  dietaryOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  distance?: InputMaybe<Scalars['Int']['input']>;
  extendedServices?: InputMaybe<Array<Scalars['String']['input']>>;
  generatedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  individualPackaging?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  mealTypeTaxonomy?: InputMaybe<Scalars['String']['input']>;
  orderMinimum?: InputMaybe<Scalars['Int']['input']>;
  packagingTaxonomy?: InputMaybe<Scalars['String']['input']>;
  promotionsTaxonomy?: InputMaybe<Scalars['String']['input']>;
  reliabilityRockstar?: InputMaybe<Scalars['Boolean']['input']>;
  rewardsLevel?: InputMaybe<Scalars['String']['input']>;
  serviceCapabilitiesTaxonomy?: InputMaybe<Scalars['String']['input']>;
  starRating?: InputMaybe<Scalars['String']['input']>;
  suitabilityTaxonomy?: InputMaybe<Scalars['String']['input']>;
};

/** Budget mode for a consolidated campaign recommendation */
export enum RecommendedBudgetModeEnum {
  /** Campaign has no weekly spending limit (unlimited) */
  NoBudget = 'NO_BUDGET',
  /** Campaign has a weekly spending limit */
  Standard = 'STANDARD',
}

/** Autogenerated input type of RecordDecision */
export type RecordDecisionInput = {
  adminUserUuid?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  decisionUuid: Scalars['ID']['input'];
  /** @deprecated use comment instead */
  responderComment?: InputMaybe<Scalars['String']['input']>;
  response: Scalars['Boolean']['input'];
};

/** Autogenerated input type of RecordLibertyTaskCompleted */
export type RecordLibertyTaskCompletedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskAttributeJson: Scalars['String']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of RecordMessage */
export type RecordMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  /** @deprecated use sentByType instead */
  initiatorType?: InputMaybe<ActorTypes>;
  /** @deprecated use sentById instead */
  initiatorUuid?: InputMaybe<Scalars['ID']['input']>;
  orderInfo: OrderInfoInput;
  sentById?: InputMaybe<Scalars['ID']['input']>;
  sentByType?: InputMaybe<ActorTypes>;
};

/** Days that are available for recurring concierge orders */
export enum RecurringDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

/** Allowed values for the referral status type status field */
export enum ReferFromUserIdStatus {
  Error = 'Error',
  Success = 'Success',
}

/** Status of a referral attempt */
export enum ReferralAttemptStatus {
  /** The referral failed with an error */
  Error = 'ERROR',
  /** The referral was successfully created */
  Success = 'SUCCESS',
}

/** Allowed values for referral reminder status */
export enum ReferralReminderStatusTypeEnum {
  Enabled = 'ENABLED',
  PermanentlyDisabled = 'PERMANENTLY_DISABLED',
  TemporarilyDisabled = 'TEMPORARILY_DISABLED',
}

/** Allowed values for referral reminder type */
export enum ReferralReminderTypeEnum {
  Nudge = 'NUDGE',
  Resend = 'RESEND',
}

/** Allowed values for the referral status field */
export enum ReferralStatusEnum {
  Deleted = 'Deleted',
  Invited = 'Invited',
  Joined = 'Joined',
  Ordered = 'Ordered',
}

/** Allowed values for referral status filter */
export enum ReferralStatusFilterEnum {
  Invited = 'INVITED',
  Joined = 'JOINED',
}

/** Autogenerated input type of RefreshInvoiceUrl */
export type RefreshInvoiceUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of the Relish invoice */
  invoiceId: Scalars['ID']['input'];
};

export type RelishBulkUserInvitationInput = {
  /** Identifier for associated ActiveStorage::Blob */
  blobKey: Scalars['ID']['input'];
};

/** Invitation processing status of a Relish bulk user invitation */
export enum RelishBulkUserInvitationStatus {
  Completed = 'completed',
  Error = 'error',
  Pending = 'pending',
  Processing = 'processing',
}

export type RelishCompanyAdminRequestInput = {
  /** Notes provided by requester */
  companyAdminNotes?: InputMaybe<Scalars['String']['input']>;
  /** Delivery time for this request. Only used for requests with an ad_hoc_service request type. */
  deliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Delivery date for request */
  deliveryOn: Scalars['Date']['input'];
  /** Hashid for drop associated with this request */
  dropHashid: Scalars['ID']['input'];
  /** How many people to accomodate with service request. Only used for requests with an ad_hoc_service request type. */
  headcount?: InputMaybe<Scalars['Int']['input']>;
  /** Meal type associated with this request. Only used for requests with a ad_hoc_service request type. */
  mealType?: InputMaybe<MealName>;
  /** Type of the request. Can be either `ad_hod_service` or `store_change`. */
  requestType: RelishCompanyAdminRequestType;
  /** Schedule entry associated with this request. Only used for requests with a store_change request type. */
  scheduleEntryId?: InputMaybe<Scalars['ID']['input']>;
  /** Reason for requesting a store change. Only used for requests with a store_change request type */
  storeChangeRequestReason?: InputMaybe<RelishCompanyAdminRequestStoreChangeRequestReason>;
};

/** Reasons for requesting a store change for an already-scheduled Relish day */
export enum RelishCompanyAdminRequestStoreChangeRequestReason {
  Cost = 'cost',
  DeliveryConcerns = 'delivery_concerns',
  DietaryPreference = 'dietary_preference',
  LackOfVariety = 'lack_of_variety',
  Other = 'other',
  QualityConcerns = 'quality_concerns',
}

/** Possible request types for company admin requests */
export enum RelishCompanyAdminRequestType {
  AdHocService = 'ad_hoc_service',
  StoreChange = 'store_change',
}

export type RelishCompanyCouponInput = {
  /** This coupon will expire on this date at midnight. */
  expiresOn: Scalars['Date']['input'];
  /** Name for this coupon. */
  name: Scalars['String']['input'];
  /** Drops for which it's users will have access to this coupon. */
  redeemableDropIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Users which will have access to this coupon. */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount in dollars that this coupon is worth. */
  value: Scalars['Float']['input'];
};

export type RelishCompanyCouponsFiltersInput = {
  /**
   * Drop to filter company coupons by
   * @deprecated Moved to RelishScheduleEntryFiltersInput
   */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
  /** Free text search for company coupons */
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Possible groups who can redeem coupons */
export enum RelishCompanyCouponsRedeemableBy {
  Company = 'company',
  Drop = 'drop',
  Global = 'global',
  User = 'user',
}

/** Fields to sort relish company coupons by */
export enum RelishCompanyCouponsSortFields {
  Code = 'code',
  Name = 'name',
  Recipient = 'recipient',
}

export type RelishCompanyMealMinimumCommitmentFiltersInput = {
  dropHashid?: InputMaybe<Scalars['String']['input']>;
  /** Date of the minimum commitment record */
  orderDeliveryOn?: InputMaybe<Scalars['Date']['input']>;
};

export type RelishCompanyReportFiltersInput = {
  /** Drop hashid to filter reports by */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
};

export type RelishCompanyReportInput = {
  /** Hash ID of a Relish drop */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
  /** End date of the report */
  endDate: Scalars['Date']['input'];
  /** Name of the report */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the report */
  startDate: Scalars['Date']['input'];
};

/** File generation status of a Relish company report */
export enum RelishCompanyReportStatus {
  Failed = 'failed',
  Generated = 'generated',
  Pending = 'pending',
}

export type RelishDropFiltersInput = {
  /** Drop hashid to filter drops by */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
};

export type RelishDropHolidayClosureInput = {
  /** Hash ID of a Relish drop */
  dropHashid: Scalars['ID']['input'];
  /** ID of holiday record to be associated with Relish drop */
  holidayId: Scalars['ID']['input'];
};

export type RelishDropInput = {
  /** Delivery instructions for the drop */
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish drop */
  dropHashid: Scalars['ID']['input'];
};

export type RelishDropTemporaryClosureInput = {
  /** Hash ID of a Relish drop */
  dropHashid: Scalars['ID']['input'];
  /** End date of the temporary closure */
  endOn: Scalars['Date']['input'];
  /** Notes for the temporary closure */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Reason for the temporary closure */
  reason: RelishDropTemporaryClosureReason;
  /** Start date of the temporary closure */
  startOn: Scalars['Date']['input'];
};

/** Possible reasons for drop to be temporarily closed */
export enum RelishDropTemporaryClosureReason {
  InclementWeather = 'inclement_weather',
  NotEnoughPeopleInTheOffice = 'not_enough_people_in_the_office',
  Other = 'other',
  ScheduledOfficeClosure = 'scheduled_office_closure',
  SpecialEvent = 'special_event',
  SuddenOfficeClosure = 'sudden_office_closure',
}

export type RelishEmployeeFiltersInput = {
  /** Filter for employees who are deactivated */
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Drop hashid to filter employees by */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
  /** Filter for employees for which this meal plan applies */
  mealPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** Free text search for employees */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Filter for specific employee by their user id */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RelishEmployeeInput = {
  /** The value of the user's custom field. This is not optional if the RelishCompany requires a custom field. */
  companyCustomField?: InputMaybe<Scalars['String']['input']>;
  /** Employee's current location */
  currentDropId?: InputMaybe<Scalars['ID']['input']>;
  /** Employee's email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Employee's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Employee's home location. Can be null if employee's company does not support home/away locations. */
  homeCompanyDropHashid?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Employee's home location. Can be null if employee's company does not support home/away locations.
   * @deprecated This field is deprecated. Please use `home_company_drop_hashid`
   */
  homeDropId?: InputMaybe<Scalars['ID']['input']>;
  /** Employee's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Employee's current meal plan */
  mealPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** Employee's phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RelishEmployeeInvitationInput = {
  /** Employee's email address */
  email: Scalars['String']['input'];
  /** Employee's first name */
  firstName: Scalars['String']['input'];
  /** Employee's first name */
  lastName: Scalars['String']['input'];
};

export type RelishEmployeeOrderFiltersInput = {
  /**
   * Filter orders by delivery date
   * @deprecated Moved to RelishScheduleEntryFiltersInput
   */
  deliveryOn?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Drop to filter orders by
   * @deprecated Moved to RelishScheduleEntryFiltersInput
   */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
  /** Schedule entry search criteria */
  scheduleEntries?: InputMaybe<RelishScheduleEntryFiltersInput>;
  /** Filter orders by associated store */
  storeId?: InputMaybe<Scalars['ID']['input']>;
  /** Find orders for user */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Fields to sort employee orders by */
export enum RelishEmployeeOrdersSortFields {
  Employee = 'employee',
  ItemDetails = 'itemDetails',
  Labels = 'labels',
  Location = 'location',
  Store = 'store',
  Total = 'total',
}

/** Fields to sort employees by */
export enum RelishEmployeesSortFields {
  Email = 'email',
  Name = 'name',
  SignUp = 'signUp',
}

/** The cadence at which a Relish company is invoiced */
export enum RelishInvoiceCadence {
  Monthly = 'monthly',
  Semimonthly = 'semimonthly',
  Weekly = 'weekly',
}

export type RelishMealPlanInput = {
  /** Hashid of the Relish meal plan to update (optional for create operations) */
  mealPlanHashid?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the meal plan */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Subsidy schedule configuration */
  subsidyScheduleAttributes: SubsidyScheduleEntry;
};

/** Person responsible for completing this checklist item, either company admin or internal ezCater admin */
export enum RelishOnboardingChecklistItemOwner {
  Client = 'client',
  Ezcater = 'ezcater',
}

export type RelishOrderFiltersInput = {
  /** Filter orders by delivery date */
  deliveryOn?: InputMaybe<Scalars['Date']['input']>;
  /** Drop to filter orders by */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
};

export type RelishOrderFulfillmentIssueInput = {
  /** List of fulfillment issues reported for the Relish order */
  fulfillmentIssues: Array<Scalars['String']['input']>;
  /** Notes for the issue */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for a relish order */
  relishOrderId: Scalars['ID']['input'];
  /** Sources from where a fulfillment issue can be reported */
  reportedBySource?: InputMaybe<FulfillmentIssueReportedBySource>;
  /** Sources from whom a fulfillment issue can be reported */
  source: FulfillmentIssueSource;
};

/** Fields to sort relish orders by */
export enum RelishOrdersSortFields {
  CutoffAt = 'cutoffAt',
  DeliveryAt = 'deliveryAt',
  DeliveryEta = 'deliveryEta',
  Location = 'location',
  Status = 'status',
  Store = 'store',
}

export type RelishPaymentMethodInput = {
  /** ID of the billing group to which this payment method should be associated */
  billingGroupId: Scalars['ID']['input'];
  /** Payment method nonce from Braintree acquired on client */
  paymentMethodNonce: Scalars['String']['input'];
};

/** The payment terms for a Relish billing group */
export enum RelishPaymentTerms {
  Net0 = 'net0',
  Net7 = 'net7',
  Net15 = 'net15',
  Net30 = 'net30',
  Net45 = 'net45',
  Net55 = 'net55',
  Net60 = 'net60',
  Net75 = 'net75',
  Net90 = 'net90',
  Net120 = 'net120',
}

export type RelishScheduleEntryFiltersInput = {
  /** Filter orders by delivery date */
  deliveryOn?: InputMaybe<Scalars['Date']['input']>;
  /** Drop to filter orders by */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters for relish schedule queries */
export type RelishScheduleFiltersInput = {
  /** Drop hashid to filter orders by */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Reference date used to determine the period. For week view, returns Sun-Sat
   * containing this date. For month view, returns the containing month
   */
  referenceDate: Scalars['Date']['input'];
};

export type RelishScheduledOrderFiltersInput = {
  /** Drop hashid to filter orders by */
  dropHashid?: InputMaybe<Scalars['ID']['input']>;
  /** Sunday of the week orders will be queried by */
  weekOf: Scalars['Date']['input'];
};

/** Tip type options for Relish, percent or dollars */
export enum RelishTipType {
  Dollars = 'dollars',
  Percent = 'percent',
}

/** Input arguments required to remove a customer from a house account */
export type RemoveCustomerFromHouseAccountInput = {
  customerId: Scalars['ID']['input'];
  houseAccountId: Scalars['ID']['input'];
};

/** Input arguments required to remove a lead from a house account */
export type RemoveLeadFromHouseAccountInput = {
  houseAccountId: Scalars['ID']['input'];
  leadId: Scalars['ID']['input'];
};

/** The statusses in which a report can be */
export enum ReportStatusEnum {
  Complete = 'COMPLETE',
  Processing = 'PROCESSING',
}

/** The types of available reports */
export enum ReportTypeEnum {
  Customers = 'CUSTOMERS',
}

/**
 * Issue categories for filtering reported issues orders. Select specific
 * categories to filter by those issues. When all categories are selected, returns
 * orders with any issue. When none are selected, returns all orders regardless of issues.
 */
export enum ReportedIssuesCategory {
  /** Orders cancelled by the supplier. */
  Cancelled = 'CANCELLED',
  /** Delivery tracking issues on self-delivered orders. */
  DeliveryTracking = 'DELIVERY_TRACKING',
  /** Food not ready issues on third-party delivery orders. */
  FoodNotReady = 'FOOD_NOT_READY',
  /** Order accuracy fulfillment issues. */
  OrderAccuracy = 'ORDER_ACCURACY',
  /** Orders rejected by the supplier. */
  Rejected = 'REJECTED',
  /** Timeliness issues on self-delivered orders. */
  Timeliness = 'TIMELINESS',
}

/** Timeliness issue categories for self-delivered orders. */
export enum ReportedIssuesDeliveryTimelinessIssue {
  Early = 'EARLY',
  FifteenToThirtyMinutesLate = 'FIFTEEN_TO_THIRTY_MINUTES_LATE',
  Late = 'LATE',
  MoreThanFifteenMinutesEarly = 'MORE_THAN_FIFTEEN_MINUTES_EARLY',
  MoreThanSixtyMinutesLate = 'MORE_THAN_SIXTY_MINUTES_LATE',
  OrderDidNotArrive = 'ORDER_DID_NOT_ARRIVE',
  ThirtyToSixtyMinutesLate = 'THIRTY_TO_SIXTY_MINUTES_LATE',
  ZeroToFifteenMinutesLate = 'ZERO_TO_FIFTEEN_MINUTES_LATE',
}

/** Delivery tracking issue types for self-delivered orders. */
export enum ReportedIssuesDeliveryTrackingIssue {
  Outsourced = 'OUTSOURCED',
  PartiallyTracked = 'PARTIALLY_TRACKED',
  Untracked = 'UNTRACKED',
}

/** Food not ready time buckets for third-party delivery orders. */
export enum ReportedIssuesFoodNotReadyIssue {
  FoodNotReadyFifteenToThirty = 'FOOD_NOT_READY_FIFTEEN_TO_THIRTY',
  FoodNotReadyFortyFiveToSixty = 'FOOD_NOT_READY_FORTY_FIVE_TO_SIXTY',
  FoodNotReadySixtyPlus = 'FOOD_NOT_READY_SIXTY_PLUS',
  FoodNotReadyThirtyToFortyFive = 'FOOD_NOT_READY_THIRTY_TO_FORTY_FIVE',
  FoodNotReadyZeroToFifteen = 'FOOD_NOT_READY_ZERO_TO_FIFTEEN',
}

/** Order accuracy fulfillment issue types. */
export enum ReportedIssuesOrderAccuracyIssue {
  DietaryRequestsNotAccommodated = 'DIETARY_REQUESTS_NOT_ACCOMMODATED',
  FoodBadOrInedible = 'FOOD_BAD_OR_INEDIBLE',
  FoodNotIndividuallyPackaged = 'FOOD_NOT_INDIVIDUALLY_PACKAGED',
  MissingOrderItems = 'MISSING_ORDER_ITEMS',
  MissingUtensilsOrEquipment = 'MISSING_UTENSILS_OR_EQUIPMENT',
  NotLabeledAsRequested = 'NOT_LABELED_AS_REQUESTED',
  NotPackagedAsRequested = 'NOT_PACKAGED_AS_REQUESTED',
  PackagingBadOrDamaged = 'PACKAGING_BAD_OR_DAMAGED',
}

/** Allowed values for sorting reported issues order information. */
export enum ReportedIssuesOrderSortField {
  /** The name of the driver who delivered the order. */
  DriverName = 'DRIVER_NAME',
  /** The full event datetime of the order in the supplier's local time zone. */
  EventAt = 'EVENT_AT',
  /** The store number associated with the order. */
  StoreNumber = 'STORE_NUMBER',
}

/** Arguments for sorting reported issues order information. */
export type ReportedIssuesOrderSortInput = {
  /** The direction in which to sort reported issues order information. */
  direction: SortDirection;
  /** Field by which to sort reported issues order information. */
  field: ReportedIssuesOrderSortField;
};

/** Supplier cancellation and rejection reason codes. */
export enum ReportedIssuesSupplierCancelRejectReason {
  AtDailyCapacity = 'AT_DAILY_CAPACITY',
  AtHourlyCapacity = 'AT_HOURLY_CAPACITY',
  CommissionOrFeesTooHigh = 'COMMISSION_OR_FEES_TOO_HIGH',
  DistanceTooFar = 'DISTANCE_TOO_FAR',
  DoesNotOfferTakeOutOrDelivery = 'DOES_NOT_OFFER_TAKE_OUT_OR_DELIVERY',
  DoesNotRememberSigningUpForEzcater = 'DOES_NOT_REMEMBER_SIGNING_UP_FOR_EZCATER',
  EmergencyClosure = 'EMERGENCY_CLOSURE',
  HolidayClosure = 'HOLIDAY_CLOSURE',
  LackOfInventory = 'LACK_OF_INVENTORY',
  LeadTimeTooShortToDeliver = 'LEAD_TIME_TOO_SHORT_TO_DELIVER',
  LeadTimeTooShortToPrepare = 'LEAD_TIME_TOO_SHORT_TO_PREPARE',
  MenuIncorrect = 'MENU_INCORRECT',
  NoDriversAvailable = 'NO_DRIVERS_AVAILABLE',
  NoTip = 'NO_TIP',
  OutOfBusiness = 'OUT_OF_BUSINESS',
  OwnershipChanged = 'OWNERSHIP_CHANGED',
  ReasonNotProvided = 'REASON_NOT_PROVIDED',
  StaffShortage = 'STAFF_SHORTAGE',
  TemporarilyClosed = 'TEMPORARILY_CLOSED',
  UnresponsiveCaterer = 'UNRESPONSIVE_CATERER',
  Weather = 'WEATHER',
  WrongHours = 'WRONG_HOURS',
}

/** Autogenerated input type of RequestDeliveryTimeChangeCP */
export type RequestDeliveryTimeChangeCpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use requestedById instead */
  contactUuid?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  orderInfo: OrderInfoInput;
  originalEventAt: Scalars['ISO8601DateTime']['input'];
  proposedEventAt: Scalars['ISO8601DateTime']['input'];
  reason: Scalars['String']['input'];
  requestedById?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of RequestOrderItemChangeCP */
export type RequestOrderItemChangeCpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use requestedById instead */
  contactUuid?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  itemChanges: Array<ItemChangeInput>;
  orderInfo: OrderInfoInput;
  reason?: InputMaybe<Scalars['String']['input']>;
  requestedById?: InputMaybe<Scalars['ID']['input']>;
};

/** States that a change request may be in */
export enum RequestStatus {
  /** accepted */
  Accepted = 'ACCEPTED',
  /** cancelled */
  Cancelled = 'CANCELLED',
  /** completed */
  Completed = 'COMPLETED',
  /** in_progress */
  InProgress = 'IN_PROGRESS',
  /** pending */
  Pending = 'PENDING',
  /** rejected */
  Rejected = 'REJECTED',
}

/** Input arguments required to resend an invoice */
export type ResendInvoiceInput = {
  body: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
  replyTo: Scalars['String']['input'];
  sendTo: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

/** The resolved tracking status of an order, taking into account fulfillment issues. */
export enum ResolvedTrackingStatus {
  /** The delivery was outsourced to an unapproved delivery service provider. */
  Outsourced = 'OUTSOURCED',
  /** The delivery was initially partially tracked or untracked, but was successfully disputed. */
  Overturned = 'OVERTURNED',
  /** The delivery does not have complete tracking data that meets our quality standards. */
  PartiallyTracked = 'PARTIALLY_TRACKED',
  /** The delivery was fully tracked and the data meets our quality standards. */
  Tracked = 'TRACKED',
  /** The delivery does not have any tracking data. */
  Untracked = 'UNTRACKED',
}

/** Allowed values for the business sizing taxonomy field in caterer search */
export enum SearchBusinessSizingTaxonomy {
  IndependentlyOwnedBusiness = 'INDEPENDENTLY_OWNED_BUSINESS',
  IndependentlyOwnedFranchise = 'INDEPENDENTLY_OWNED_FRANCHISE',
  SmallBusiness = 'SMALL_BUSINESS',
}

/** Allowed values for the business type taxonomy field in caterer search */
export enum SearchBusinessTypeTaxonomy {
  BrickMortar = 'BRICK_MORTAR',
  CateringCompany = 'CATERING_COMPANY',
  CommissaryKitchen = 'COMMISSARY_KITCHEN',
  FoodTruck = 'FOOD_TRUCK',
  GhostKitchenVirtual = 'GHOST_KITCHEN_VIRTUAL',
  GroceryConvenience = 'GROCERY_CONVENIENCE',
  Other = 'OTHER',
}

/** Allowed values for the cuisine taxonomy field in caterer search */
export enum SearchCuisineTaxonomy {
  African = 'AFRICAN',
  American = 'AMERICAN',
  Asian = 'ASIAN',
  Bagels = 'BAGELS',
  Bakery = 'BAKERY',
  Bbq = 'BBQ',
  Bowls = 'BOWLS',
  Breakfast = 'BREAKFAST',
  Burgers = 'BURGERS',
  Cajun = 'CAJUN',
  Caribbean = 'CARIBBEAN',
  Chicken = 'CHICKEN',
  Chinese = 'CHINESE',
  CoffeeTea = 'COFFEE_TEA',
  Cuban = 'CUBAN',
  Deli = 'DELI',
  Diner = 'DINER',
  EasternEuropeanRussian = 'EASTERN_EUROPEAN_RUSSIAN',
  Filipino = 'FILIPINO',
  French = 'FRENCH',
  German = 'GERMAN',
  Greek = 'GREEK',
  Hawaiian = 'HAWAIIAN',
  Healthy = 'HEALTHY',
  Indian = 'INDIAN',
  Irish = 'IRISH',
  Italian = 'ITALIAN',
  Jamaican = 'JAMAICAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  Mediterranean = 'MEDITERRANEAN',
  Mexican = 'MEXICAN',
  MiddleEastern = 'MIDDLE_EASTERN',
  Peruvian = 'PERUVIAN',
  Pizza = 'PIZZA',
  Poke = 'POKE',
  Salads = 'SALADS',
  Sandwiches = 'SANDWICHES',
  Seafood = 'SEAFOOD',
  SmoothiesFruitBowls = 'SMOOTHIES_FRUIT_BOWLS',
  Snacks = 'SNACKS',
  SoulFood = 'SOUL_FOOD',
  Soups = 'SOUPS',
  Southern = 'SOUTHERN',
  SouthLatinAmerican = 'SOUTH_LATIN_AMERICAN',
  SpanishTapas = 'SPANISH_TAPAS',
  SpecialtyBeverages = 'SPECIALTY_BEVERAGES',
  Steakhouse = 'STEAKHOUSE',
  Sushi = 'SUSHI',
  Thai = 'THAI',
  Treats = 'TREATS',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN',
  Vietnamese = 'VIETNAMESE',
}

/** Allowed values for the delivery capabilities taxonomy field in caterer search */
export enum SearchDeliveryCapabilitiesTaxonomy {
  DeliveryTracking = 'DELIVERY_TRACKING',
  Takeout = 'TAKEOUT',
  TrueSelfDelivery = 'TRUE_SELF_DELIVERY',
}

/** Allowed values for the dietary capabilities taxonomy field in caterer search */
export enum SearchDietaryCapabilitiesTaxonomy {
  DairyFree = 'DAIRY_FREE',
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  Healthy = 'HEALTHY',
  Kosher = 'KOSHER',
  NutFree = 'NUT_FREE',
  VeganFriendly = 'VEGAN_FRIENDLY',
  VegetarianFriendly = 'VEGETARIAN_FRIENDLY',
}

/** Allowed values for the meal type taxonomy field in caterer search */
export enum SearchMealTypeTaxonomy {
  AlcoholicBeverages = 'ALCOHOLIC_BEVERAGES',
  Breakfast = 'BREAKFAST',
  Dinner = 'DINNER',
  HappyHour = 'HAPPY_HOUR',
  HorsDOeuvres = 'HORS_D_OEUVRES',
  Lunch = 'LUNCH',
  SmallPlatesTapas = 'SMALL_PLATES_TAPAS',
}

/** Allowed values for the packaging taxonomy field in caterer search */
export enum SearchPackagingTaxonomy {
  BoxedBrownBagLunch = 'BOXED_BROWN_BAG_LUNCH',
  IndividualPackaging = 'INDIVIDUAL_PACKAGING',
  TrayCatering = 'TRAY_CATERING',
}

/** Allowed values for the promotions taxonomy field in caterer search */
export enum SearchPromotionsTaxonomy {
  Dealicious = 'DEALICIOUS',
  Sfp_5P_0 = 'SFP_5_P_0',
  Sfp_10D_0 = 'SFP_10_D_0',
  Sfp_10D_100 = 'SFP_10_D_100',
  Sfp_10D_150 = 'SFP_10_D_150',
  Sfp_10D_200 = 'SFP_10_D_200',
  Sfp_10D_250 = 'SFP_10_D_250',
  Sfp_10D_300 = 'SFP_10_D_300',
  Sfp_10D_350 = 'SFP_10_D_350',
  Sfp_10D_500 = 'SFP_10_D_500',
  Sfp_10P_0 = 'SFP_10_P_0',
  Sfp_15D_0 = 'SFP_15_D_0',
  Sfp_15D_100 = 'SFP_15_D_100',
  Sfp_15D_150 = 'SFP_15_D_150',
  Sfp_15D_200 = 'SFP_15_D_200',
  Sfp_15D_250 = 'SFP_15_D_250',
  Sfp_15D_300 = 'SFP_15_D_300',
  Sfp_15D_350 = 'SFP_15_D_350',
  Sfp_15D_500 = 'SFP_15_D_500',
  Sfp_15P_0 = 'SFP_15_P_0',
  Sfp_20D_0 = 'SFP_20_D_0',
  Sfp_20D_100 = 'SFP_20_D_100',
  Sfp_20D_150 = 'SFP_20_D_150',
  Sfp_20D_200 = 'SFP_20_D_200',
  Sfp_20D_250 = 'SFP_20_D_250',
  Sfp_20D_300 = 'SFP_20_D_300',
  Sfp_20D_350 = 'SFP_20_D_350',
  Sfp_20D_500 = 'SFP_20_D_500',
  Sfp_20P_0 = 'SFP_20_P_0',
  Sfp_25D_0 = 'SFP_25_D_0',
  Sfp_25D_100 = 'SFP_25_D_100',
  Sfp_25D_150 = 'SFP_25_D_150',
  Sfp_25D_200 = 'SFP_25_D_200',
  Sfp_25D_250 = 'SFP_25_D_250',
  Sfp_25D_300 = 'SFP_25_D_300',
  Sfp_25D_350 = 'SFP_25_D_350',
  Sfp_25D_500 = 'SFP_25_D_500',
  Sfp_25P_0 = 'SFP_25_P_0',
  Sfp_50D_0 = 'SFP_50_D_0',
  Sfp_50D_100 = 'SFP_50_D_100',
  Sfp_50D_150 = 'SFP_50_D_150',
  Sfp_50D_200 = 'SFP_50_D_200',
  Sfp_50D_250 = 'SFP_50_D_250',
  Sfp_50D_300 = 'SFP_50_D_300',
  Sfp_50D_350 = 'SFP_50_D_350',
  Sfp_50D_500 = 'SFP_50_D_500',
  SupplierFundedPromo = 'SUPPLIER_FUNDED_PROMO',
}

/** Error messages for why a search rank address ranking cannot be calculated */
export enum SearchRankAddressRankingError {
  AnotherStoreInBrand = 'ANOTHER_STORE_IN_BRAND',
  OutOfDeliveryArea = 'OUT_OF_DELIVERY_AREA',
}

/** Allowed values for the service capabilities taxonomy field in caterer search */
export enum SearchServiceCapabilitiesTaxonomy {
  EcoFriendlyPackaging = 'ECO_FRIENDLY_PACKAGING',
  ExtendedService = 'EXTENDED_SERVICE',
  FreeUtensilsIncluded = 'FREE_UTENSILS_INCLUDED',
  GroupOrdering = 'GROUP_ORDERING',
  /** Indicates if the caterer is good for holiday gifting */
  HolidayGifting = 'HOLIDAY_GIFTING',
  HotCatering = 'HOT_CATERING',
  LastMinuteOrder = 'LAST_MINUTE_ORDER',
  /** Indicates if the caterer has a seasonal specials menu category or is good for seasonal menu items */
  SeasonalSpecials = 'SEASONAL_SPECIALS',
  SetupService = 'SETUP_SERVICE',
  StaffedService = 'STAFFED_SERVICE',
}

/** Allowed values for the suitability taxonomy field in caterer search */
export enum SearchSuitabilityTaxonomy {
  HighOpportunityScore = 'HIGH_OPPORTUNITY_SCORE',
  NewBusiness = 'NEW_BUSINESS',
}

/** The input for filtering search results on taxons from different taxonomies */
export type SearchTaxonomiesAndTaxonsInput = {
  businessSizingTaxonomy?: InputMaybe<SearchBusinessSizingTaxonomy>;
  businessTypeTaxonomy?: InputMaybe<SearchBusinessTypeTaxonomy>;
  cuisineTaxonomy?: InputMaybe<SearchCuisineTaxonomy>;
  deiOwnedBusinessTaxonomy?: InputMaybe<DeiOwnedBusinessTaxonomy>;
  deliveryCapabilitiesTaxonomy?: InputMaybe<SearchDeliveryCapabilitiesTaxonomy>;
  dietaryCapabilitiesTaxonomy?: InputMaybe<SearchDietaryCapabilitiesTaxonomy>;
  mealTypeTaxonomy?: InputMaybe<SearchMealTypeTaxonomy>;
  packagingTaxonomy?: InputMaybe<SearchPackagingTaxonomy>;
  promotionsTaxonomy?: InputMaybe<SearchPromotionsTaxonomy>;
  serviceCapabilitiesTaxonomy?: InputMaybe<SearchServiceCapabilitiesTaxonomy>;
  suitabilityTaxonomy?: InputMaybe<SearchSuitabilityTaxonomy>;
};

/** Sources from where the driver initiated the self assign */
export enum SelfAssignSource {
  /** Via the flash message on Order Details */
  Alert = 'alert',
  /** Via the caterer accept flow */
  CatererAccept = 'caterer_accept',
  /** Via the food prep flow */
  FoodPrep = 'food_prep',
  /** Via the QR Code on the Order PDF */
  Qrcode = 'qrcode',
  /** Via an SMS with a link to sign up */
  Sms = 'sms',
}

/** Required and optional fields used to report a fulfillment issue */
export type SelfReportedFulfillmentIssueInput = {
  additionalIssues: Array<AdditionalIssue>;
  deliveryTimeSelection?: InputMaybe<DeliveryTimeSelection>;
  issuesDetailSelectionAdditionalDetails?: InputMaybe<Scalars['String']['input']>;
  issuesSelected: Array<IssueSelection>;
  loggedInIssuesReviewAdditionalDetails?: InputMaybe<Scalars['String']['input']>;
  natureOfIssue: NatureOfIssue;
  orderId: Scalars['ID']['input'];
  somethingElseField?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of SendCompanyCouponReminders */
export type SendCompanyCouponRemindersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  relishCompanyCouponId: Scalars['ID']['input'];
};

/** Autogenerated input type of SendDeliveryNotification */
export type SendDeliveryNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  relishOrderId: Scalars['ID']['input'];
};

/** The kind of location a metro neighborhood represents */
export enum SeoMetroNeighborhoodLocation {
  Locality = 'LOCALITY',
  Neighborhood = 'NEIGHBORHOOD',
}

/** Autogenerated input type of SetMessageStatus */
export type SetMessageStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
  reviewedById: Scalars['ID']['input'];
  reviewedByType: ActorTypes;
  status: MessageStatus;
};

/** Arguments for sharing payment methods with a particular type */
export type ShareTarget = {
  id: Scalars['ID']['input'];
  type: ShareTargetType;
};

export enum ShareTargetType {
  CorpDeptCode = 'CORP_DEPT_CODE',
  User = 'USER',
}

/** The current status of whether the owner of a phone number has consented to receive certain SMS messages at that number. */
export enum SmsConsentStatusEnum {
  /**
   * The user has texted 'STOP' to an ezCater number and is blocked from receiving
   * messages through our provider (Twilio). The only way to opt back in is to send
   * 'START' to the same number.
   */
  OptedOut = 'opted_out',
  /** No consent status is known; the user still needs to be presented with the terms of service and either opt in or out. */
  Pending = 'pending',
  /** The user has accepted the terms of service and is opted in to receive messages. */
  TermsAccepted = 'terms_accepted',
  /**
   * The user did not accept the terms of service and will not receive messages.
   * They could opt back in by accepting the terms through an ezCater UI.
   */
  TermsRejected = 'terms_rejected',
}

/** Allowed values for query sorting */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** The directions that a field can be sorted in */
export enum SortDirectionTypeEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SourceNameEnum {
  /** Direct entry source */
  DirectEntry = 'direct_entry',
  /** EZO source */
  Ezo = 'ezo',
  /** Marketplace source */
  Marketplace = 'marketplace',
  /** Relish source */
  Relish = 'relish',
}

/** Allowed values for the review stars field */
export enum StarRating {
  Five = 'FIVE',
  Four = 'FOUR',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO',
  Zero = 'ZERO',
}

/**
 * Allowed values for the source of the star rating. The 'mixed' value is used when
 * the aggregated data comes from both 'stars' and 'blended' sources.
 */
export enum StarRatingSource {
  Blended = 'BLENDED',
  Mixed = 'MIXED',
  Stars = 'STARS',
}

/** Google Static Maps pin size. Omit for Google's default (normal) size. */
export enum StaticMapMarkerSize {
  Mid = 'MID',
  Small = 'SMALL',
  Tiny = 'TINY',
}

/** Generic enum for status types */
export enum StatusEnum {
  Failure = 'failure',
  Success = 'success',
}

/** Arguments for filtering search results, loosely based on CatererSearch filters */
export type StoreSearchResultFilter = {
  /** Food Type ID */
  foodType?: InputMaybe<Scalars['ID']['input']>;
};

export type SubsidyScheduleEntry = {
  perDaySubsidy?: InputMaybe<PerDaySubsidyEntry>;
  perMealSubsidy?: InputMaybe<PerMealSubsidyEntry>;
  perWeekSubsidy?: InputMaybe<PerWeekSubsidyEntry>;
  percentSubsidy?: InputMaybe<PercentSubsidyEntry>;
};

/** Allowed values for the marketing activities sort field */
export enum SupplierMarketingActivitySortField {
  AverageCostPerOrder = 'AVERAGE_COST_PER_ORDER',
  CampaignName = 'CAMPAIGN_NAME',
  Date = 'DATE',
  /** @deprecated Sorting not supported */
  Description = 'DESCRIPTION',
  Discounts = 'DISCOUNTS',
  MarketingTax = 'MARKETING_TAX',
  NetCharges = 'NET_CHARGES',
  OrderCount = 'ORDER_COUNT',
  StoreAddress = 'STORE_ADDRESS',
  /** @deprecated Use TOTAL_CHARGES instead */
  Total = 'TOTAL',
  TotalCharges = 'TOTAL_CHARGES',
  /** @deprecated Sorting not supported */
  TransactionType = 'TRANSACTION_TYPE',
}

/** Why a support message could not be submitted */
export enum SupportCaseFailureReason {
  NotConfigured = 'not_configured',
  RateLimited = 'rate_limited',
  SalesforceRejected = 'salesforce_rejected',
  SalesforceUnavailable = 'salesforce_unavailable',
}

/** Input for submitting a customer support message (creates a Salesforce Case) */
export type SupportCaseInput = {
  categoryLevel1: Scalars['String']['input'];
  categoryLevel2: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  orderNumbers?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<SupportCaseSource>;
};

/** Channel a support message was filed from */
export enum SupportCaseSource {
  ContactUsModal = 'contact_us_modal',
  ContactUsPage = 'contact_us_page',
  NativeAndroid = 'native_android',
  NativeIos = 'native_ios',
  StandaloneRoute = 'standalone_route',
}

/** The user group to target for a sponsored listing campaign: new, existing, lapsed or all customers */
export enum TargetEngagementStatusEnum {
  Existing = 'existing',
  Lapsed = 'lapsed',
  New = 'new',
}

/** Represents a Twilio task */
export type TaskGroupOrderInteraction = {
  dateCreated?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  direction?: InputMaybe<InteractionDirections>;
  from?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  sourceType: TwilioWorkerTaskInteraction;
  taskSid: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Arguments based on Twilio task source object */
export type TaskSource = {
  reservationSid: Scalars['String']['input'];
  sid: Scalars['String']['input'];
};

/** Allowed custom twilio task types */
export enum TaskTypes {
  AcceptedRequest = 'ACCEPTED_REQUEST',
  HelpRequested = 'HELP_REQUESTED',
  NoResponse = 'NO_RESPONSE',
  RejectedRequest = 'REJECTED_REQUEST',
  ReviewMessage = 'REVIEW_MESSAGE',
}

/** Possible values for tax exemption certificate status relating to a cart. */
export enum TaxExemptionCertificateStatus {
  ExpiredCertificate = 'EXPIRED_CERTIFICATE',
  NoCertificateAvailable = 'NO_CERTIFICATE_AVAILABLE',
  ValidCertificateAvailable = 'VALID_CERTIFICATE_AVAILABLE',
}

/** Allowed statuses for a tax exemption certificate */
export enum TaxExemptionStatus {
  Expired = 'expired',
  PendingApproval = 'pending_approval',
  Valid = 'valid',
}

export enum TaxFormStatus {
  Approved = 'approved',
  Expired = 'expired',
  NotStarted = 'not_started',
  Pending = 'pending',
  Submitted = 'submitted',
  SubmittedForReview = 'submitted_for_review',
  Unregistered = 'unregistered',
}

/** The input for filtering search results on taxons from different taxonomies */
export type TaxonFilterInput = {
  businessSizingTaxonomy?: InputMaybe<Scalars['String']['input']>;
  businessTypeTaxonomy?: InputMaybe<Scalars['String']['input']>;
  cuisineTaxonomy?: InputMaybe<Scalars['String']['input']>;
  deiOwnedBusinessTaxonomy?: InputMaybe<Scalars['String']['input']>;
  deiOwnedFranchiseTaxonomy?: InputMaybe<Scalars['String']['input']>;
  deliveryCapabilitiesTaxonomy?: InputMaybe<Scalars['String']['input']>;
  dietaryCapabilitiesTaxonomy?: InputMaybe<Scalars['String']['input']>;
  dietaryOptionsTaxonomy?: InputMaybe<Scalars['String']['input']>;
  mealTypeTaxonomy?: InputMaybe<Scalars['String']['input']>;
  packagingTaxonomy?: InputMaybe<Scalars['String']['input']>;
  promotionsTaxonomy?: InputMaybe<Scalars['String']['input']>;
  serviceCapabilitiesTaxonomy?: InputMaybe<Scalars['String']['input']>;
  suitabilityTaxonomy?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of TestMutation */
export type TestMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['String']['input']>;
};

/** Range of timestamps */
export type TimeRangeInput = {
  ending: Scalars['ISO8601DateTime']['input'];
  starting: Scalars['ISO8601DateTime']['input'];
};

/** The overall timeliness result for the order. */
export enum TimelinessResult {
  /** The delivery was between 15 and 30 minutes late. */
  FifteenToThirtyMinutesLate = 'FIFTEEN_TO_THIRTY_MINUTES_LATE',
  /** The delivery was more than 15 minutes early. */
  MoreThanFifteenMinutesEarly = 'MORE_THAN_FIFTEEN_MINUTES_EARLY',
  /** The delivery was more than 60 minutes late. */
  MoreThanSixtyMinutesLate = 'MORE_THAN_SIXTY_MINUTES_LATE',
  /** The delivery was between 1 and 15 minutes late. */
  OneToFifteenMinutesLate = 'ONE_TO_FIFTEEN_MINUTES_LATE',
  /** The delivery was on time. */
  OnTime = 'ON_TIME',
  /** The delivery was between 30 and 60 minutes late. */
  ThirtyToSixtyMinutesLate = 'THIRTY_TO_SIXTY_MINUTES_LATE',
}

/** Reasons a tip cannot be changed */
export enum TipImmutableReason {
  CatererDisabledTipping = 'CATERER_DISABLED_TIPPING',
  TippingExpired = 'TIPPING_EXPIRED',
}

/** Autogenerated input type of ToggleDropHolidayClosure */
export type ToggleDropHolidayClosureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  dropHolidayClosureInput: RelishDropHolidayClosureInput;
};

/** Autogenerated input type of ToggleOnboardingChecklistItem */
export type ToggleOnboardingChecklistItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of the onboarding checklist item */
  onboardingChecklistItemId: Scalars['ID']['input'];
};

/** Allowed types for a twilio worker task */
export enum TwilioWorkerTaskInteraction {
  Call = 'CALL',
  OrderRequest = 'ORDER_REQUEST',
  OrderTask = 'ORDER_TASK',
  Sms = 'SMS',
  Webchat = 'WEBCHAT',
}

/** Allowed two factor verification methods */
export enum TwoFactorVerificationMethod {
  Email = 'EMAIL',
  MobilePhone = 'MOBILE_PHONE',
}

export enum TypeaheadDocType {
  Caterer = 'CATERER',
  Cuisine = 'CUISINE',
  Diversity = 'DIVERSITY',
}

/** Autogenerated input type of UnassignDriver */
export type UnassignDriverInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery to be unassigned */
  deliveryId: Scalars['ID']['input'];
  /** ID of the driver to be unassigned */
  driverId: Scalars['ID']['input'];
};

/** Reasons a brand may be unavailable for ordering */
export enum UnavailabilityReason {
  DayBeforeCutoff = 'DAY_BEFORE_CUTOFF',
  Holiday = 'HOLIDAY',
  LeadTime = 'LEAD_TIME',
  OperatingSchedule = 'OPERATING_SCHEDULE',
  /** @deprecated Use OUT_OF_METRO instead */
  OutOfArea = 'OUT_OF_AREA',
  OutOfMetro = 'OUT_OF_METRO',
  OutOfNetwork = 'OUT_OF_NETWORK',
  Pause = 'PAUSE',
  Vacation = 'VACATION',
}

/** Upcoming order's lifecycle status */
export enum UpcomingOrderStatusEnum {
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Nearby = 'NEARBY',
  OnTheWay = 'ON_THE_WAY',
  Placed = 'PLACED',
}

/** Required and optional fields used to update a BankAccount */
export type UpdateBankAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<BankAccountCompanyInput>;
  individual?: InputMaybe<BankAccountIndividualInput>;
  purpose?: InputMaybe<BankAccountPurpose>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankAccountType>;
  uuid: Scalars['ID']['input'];
};

/** Required and optional fields used to update a BankAccountOwner */
export type UpdateBankAccountOwnerInput = {
  address: AddressInput;
  businessName: Scalars['String']['input'];
  federalTaxId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Input arguments that can be updated on an existing customer */
export type UpdateCustomerInput = {
  id: Scalars['ID']['input'];
  merged?: InputMaybe<Scalars['Boolean']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input arguments that can be updated for existing customers */
export type UpdateCustomersInput = {
  customers: Array<UpdateCustomerInput>;
};

/** Autogenerated input type of UpdateDropPrimaryContact */
export type UpdateDropPrimaryContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of a Relish drop contact */
  dropContactId: Scalars['ID']['input'];
  /** ID of a Relish drop */
  dropHashid: Scalars['ID']['input'];
};

/** Input arguments required to update a house account */
export type UpdateHouseAccount = {
  address?: InputMaybe<AddressInput>;
  catererId?: InputMaybe<Scalars['ID']['input']>;
  catererIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyName: Scalars['String']['input'];
  contactFirstName: Scalars['String']['input'];
  contactLastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  houseAccountId: Scalars['String']['input'];
  paymentTermsInDays: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  taxIdNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input arguments that can be updated for an existing lead */
export type UpdateLeadInput = {
  address?: InputMaybe<AddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  industry?: InputMaybe<IndustryTypeEnum>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  merged?: InputMaybe<Scalars['Boolean']['input']>;
  omsContactId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxIdNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input arguments that can be updated for existing leads */
export type UpdateLeadsInput = {
  leads: Array<UpdateLeadInput>;
};

/** Autogenerated input type of UpdateRelishDrop */
export type UpdateRelishDropInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  dropInput: RelishDropInput;
};

/** Autogenerated input type of UpdateRelishEmployee */
export type UpdateRelishEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Hash ID of a Relish company */
  companyHashid: Scalars['ID']['input'];
  /** ID of the Relish employee */
  employeeId: Scalars['ID']['input'];
  employeeInput: RelishEmployeeInput;
};

/** Autogenerated input type of UpdateRelishMealPlan */
export type UpdateRelishMealPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyHashid: Scalars['ID']['input'];
  mealPlanInput: RelishMealPlanInput;
};

/** Valid statuses for user connection invitations */
export enum UserConnectionInvitationStatus {
  Accepted = 'ACCEPTED',
  Ignored = 'IGNORED',
  Pending = 'PENDING',
}

/** Allowed values for user industry field */
export enum UserIndustryEnum {
  Advertising = 'ADVERTISING',
  Blank = 'BLANK',
  Business = 'BUSINESS',
  Construction = 'CONSTRUCTION',
  Education = 'EDUCATION',
  Financial = 'FINANCIAL',
  Legal = 'LEGAL',
  Manufacturing = 'MANUFACTURING',
  None = 'NONE',
  Other = 'OTHER',
  Pharma = 'PHARMA',
  Pr = 'PR',
  Publishing = 'PUBLISHING',
  RealEstate = 'REAL_ESTATE',
}

/** Allowed values for user order_confirm_method field */
export enum UserOrderConfirmMethodEnum {
  Email = 'EMAIL',
  None = 'NONE',
  Txt = 'TXT',
}

/** Allowed values for user status field */
export enum UserRegistrationStatusEnum {
  /** @deprecated This user status is no longer valid */
  CatererCreated = 'CATERER_CREATED',
  CorpPending = 'CORP_PENDING',
  Customer = 'CUSTOMER',
  Deleted = 'DELETED',
  /** @deprecated This user status is no longer valid */
  Disqualified = 'DISQUALIFIED',
  /** @deprecated This user status is no longer valid */
  Empty = 'EMPTY',
  /** @deprecated This user status is no longer valid */
  Lead = 'LEAD',
  /** @deprecated This user status is no longer valid */
  None = 'NONE',
  /** @deprecated This user status is no longer valid */
  NotYetQualified = 'NOT_YET_QUALIFIED',
  /** @deprecated This user status is no longer valid */
  Qualified = 'QUALIFIED',
  Registered = 'REGISTERED',
  /** @deprecated This user status is no longer valid */
  SignedUp = 'SIGNED_UP',
  /** @deprecated This user status is no longer valid */
  Unverified = 'UNVERIFIED',
  /** @deprecated This user status is no longer valid */
  Verified = 'VERIFIED',
}

/** Allowed values for user_type field for Google Analytics 4 tracking */
export enum UserTypeEnum {
  Caterer = 'caterer',
  Corporate = 'corporate',
  EzOPrivateStore = 'ezO_private_store',
  Marketplace = 'marketplace',
  NoOrder = 'no_order',
}

/** Possible values for utensils selection. */
export enum UtensilsSelectionEnum {
  NotSelected = 'NOT_SELECTED',
  OptedIn = 'OPTED_IN',
  OptedOut = 'OPTED_OUT',
}

/** Allowed values for vacation period channels */
export enum VacationPeriodChannels {
  Marketplace = 'marketplace',
  Relish = 'relish',
}

/** Values for the reasons a vendor payment is being held */
export enum VendorPaymentHoldReasonEnum {
  MinimumPaymentAmount = 'MINIMUM_PAYMENT_AMOUNT',
}

/** Allowed values for the vendor payment item sort field */
export enum VendorPaymentItemSortFieldEnum {
  AddressName = 'ADDRESS_NAME',
  AddressStreet = 'ADDRESS_STREET',
  AmountPaid = 'AMOUNT_PAID',
  EventAt = 'EVENT_AT',
  OrderNumber = 'ORDER_NUMBER',
  OrderSource = 'ORDER_SOURCE',
}

/** Arguments for sorting a vendor payment's items */
export type VendorPaymentItemSortType = {
  direction: SortDirection;
  field: VendorPaymentItemSortFieldEnum;
};

/** Input for filtering vendor payments by recipient */
export type VendorPaymentRecipientInput = {
  /** Recipient ID */
  id: Scalars['ID']['input'];
  /** Recipient type */
  type: VendorPaymentRecipientTypeEnum;
};

/** Vendor payment recipient type */
export enum VendorPaymentRecipientTypeEnum {
  /** Billing block recipient */
  BillingBlock = 'BILLING_BLOCK',
  /** Caterer recipient */
  Caterer = 'CATERER',
}

/** Allowed values for vendor payment sort field */
export enum VendorPaymentSortField {
  Amount = 'AMOUNT',
  ExpectedExecutionDate = 'EXPECTED_EXECUTION_DATE',
  Method = 'METHOD',
  SentOn = 'SENT_ON',
}

/** Arguments for sorting vendor payments */
export type VendorPaymentSortInput = {
  direction: SortDirection;
  field: VendorPaymentSortField;
};

export type AddressBookAddressFragment = {
  __typename?: 'Address';
  id: string;
  uuid: string;
  name?: string | null;
  street: string;
  street2?: string | null;
  city: string;
  state: string;
  zip?: string | null;
  fullAddress: string;
  addressBookEntryId?: number | null;
  addressBookEntry?: {__typename?: 'AddressBookEntry'; id: string; corporate: boolean} | null;
  orders?: {
    __typename?: 'OrderConnection';
    totalCount: number;
    nodes?: Array<{__typename?: 'Order'; id: string; submittedAt?: string | null} | null> | null;
  } | null;
};

export type CartFragment = {
  __typename?: 'Order';
  id: string;
  cart?: {
    __typename?: 'Cart';
    id: string;
    productCatalog: ProductCatalog;
    lineItems: Array<{
      __typename?: 'LineItem';
      id: string;
      name?: string | null;
      type?: LineItemTypeEnum | null;
      cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    }>;
    orderItems: Array<{
      __typename?: 'OrderItem';
      id: string;
      name?: string | null;
      price?: number | null;
      quantity: number;
      size?: string | null;
      sizeLabel?: string | null;
      specialInstructions?: string | null;
      vegetarianQuantity?: number | null;
      serves?: number | null;
      groupOrderPersonName?: string | null;
      belongsToAnyEater: boolean;
      totalInSubunits?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      orderItemOptions?: Array<{
        __typename?: 'OrderItemOption';
        id: string;
        catererLabel?: string | null;
        itemChoices: Array<{
          __typename?: 'OrderItemChoice';
          id: string;
          name?: string | null;
          price?: number | null;
        }>;
      } | null> | null;
      modifiers?: Array<{
        __typename?: 'LineItemModifier';
        id: string;
        name: string;
        quantity: number;
        modifiers?: Array<{
          __typename?: 'LineItemModifier';
          id: string;
          name: string;
          quantity: number;
          modifiers?: Array<{
            __typename?: 'LineItemModifier';
            id: string;
            name: string;
            quantity: number;
            modifiers?: Array<{
              __typename?: 'LineItemModifier';
              id: string;
              name: string;
              quantity: number;
              modifiers?: Array<{
                __typename?: 'LineItemModifier';
                id: string;
                name: string;
                quantity: number;
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                modifierGroup: {
                  __typename?: 'LineItemModifierGroup';
                  id: string;
                  name?: string | null;
                };
              }> | null;
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              modifierGroup: {
                __typename?: 'LineItemModifierGroup';
                id: string;
                name?: string | null;
              };
            }> | null;
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
          }> | null;
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
        }> | null;
        price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
      }> | null;
    }>;
    tip: {__typename?: 'Tip'; id: string; amount?: number | null};
  } | null;
};

export type CatererFragment = {
  __typename?: 'Order';
  id: string;
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    uuid: string;
    name: string;
    urlId: string;
    nickname?: string | null;
    isSavedCaterer: boolean;
    address?: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      city: string;
      street: string;
      street2?: string | null;
      state: string;
      zip?: string | null;
    } | null;
    brand?: {
      __typename?: 'Brand';
      id: string;
      uuid: string;
      name: string;
      logoUrl?: string | null;
    } | null;
  } | null;
};

export type CateringMenuAboutUsCatererFragment = {
  __typename?: 'Caterer';
  id: string;
  name: string;
  onEzCaterSince?: string | null;
  hasOtherLocations: boolean;
  cancellationFeeDescription?: string | null;
  hideStreetAddress: boolean;
  modificationPolicy: {__typename?: 'ModificationPolicy'; modificationCutoffHours: number};
  brand?: {__typename?: 'Brand'; id: string; description?: string | null; urlId: string} | null;
  storeHours?: {
    __typename?: 'CatererStoreHours';
    deliveryHoursDisplay?: string | null;
    takeoutHoursDisplay?: string | null;
  } | null;
  address?: {
    __typename?: 'Address';
    id: string;
    street: string;
    city: string;
    state: string;
    zip?: string | null;
  } | null;
  minimumDeliveryFee: {
    __typename?: 'MinimumDeliveryFee';
    isFixed: boolean;
    amount: {__typename?: 'Money'; currency: Currency; subunits: number};
    minimumOrderSubTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  };
  takeoutMinimum?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
};

export type CateringMenuCatererFragment = {
  __typename?: 'Caterer';
  id: string;
  uuid: string;
  urlId: string;
  name: string;
  isSavedCaterer: boolean;
  tippingAllowed: boolean;
  rewardsLevel?: number | null;
  hideSpecialInstructions: boolean;
  hideStreetAddress: boolean;
  starRating?: number | null;
  reviewCount: number;
  shouldShowReviews: boolean;
  lastOrderAt?: string | null;
  hasDeliveryHours: boolean;
  hasTakeoutHours: boolean;
  hasOtherLocations: boolean;
  isReliabilityRockstar: boolean;
  isVisibleInStore: boolean;
  isVisibleInPrivateStore: boolean;
  hasGroupOrderingEnabled: boolean;
  address?: {
    __typename?: 'Address';
    id: string;
    street: string;
    state: string;
    stateName?: string | null;
    city: string;
    zip?: string | null;
    timeZoneIdentifier: string;
    latitude?: number | null;
    longitude?: number | null;
    fullAddress: string;
  } | null;
  brand?: {
    __typename?: 'Brand';
    id: string;
    uuid: string;
    urlId: string;
    logoUrl?: string | null;
    name: string;
    description?: string | null;
    heroImage?: {
      __typename?: 'Image';
      uuid: string;
      desktopHeroUrl?: string | null;
      mobileHeroUrl?: string | null;
      fullImagePath?: string | null;
    } | null;
    customStyle?: {
      __typename?: 'CustomStyle';
      id: string;
      primaryAccentColor?: string | null;
      primaryColor?: string | null;
      secondaryAccentColor?: string | null;
      secondaryColor?: string | null;
    } | null;
    customBranding?: {__typename?: 'CustomBranding'; id: string; footerText?: string | null} | null;
  } | null;
  minimumDeliveryFee: {
    __typename?: 'MinimumDeliveryFee';
    isFixed: boolean;
    amount: {__typename?: 'Money'; currency: Currency; subunits: number};
    minimumOrderSubTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  };
  takeoutMinimum?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
  publicCatererFulfillmentReportCard?: {
    __typename?: 'PublicCatererFulfillmentReportCard';
    onTimeRating?: number | null;
  } | null;
  advanceNotice?:
    | {__typename: 'DayBeforeCutoffTime'; dayBeforeCutoffTime: number}
    | {__typename: 'LeadTime'; leadTimeInMinutes: number}
    | null;
  cuisineTypes?: Array<{__typename?: 'CatererCuisine'; id: string; name: string}> | null;
  sponsoredPromos?: Array<{
    __typename?: 'Promo';
    id: string;
    title: string;
    name?: string | null;
    discountAmount?: number | null;
    description: string;
    finePrint?: string | null;
    expiresOn?: string | null;
    weekdayOnly: boolean;
    termsAndConditionsUrl?: string | null;
    promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
  }> | null;
  publicTaxonomiesWithTaxons: Array<{
    __typename?: 'CatererTaxonomyWithTaxons';
    taxonomy: PublicTaxonomies;
    taxons: Array<string>;
  }>;
};

export type CateringMenuConsumerCartAndFulfillmentDetailLookupFragment = {
  __typename?: 'ConsumerCart';
  id: string;
  fulfillmentDetail: {__typename?: 'FulfillmentDetail'; id: string};
};

export type CateringMenuConsumerCartFragment = {
  __typename?: 'ConsumerCart';
  id: string;
  approvalDeadline?: string | null;
  currentUserAccessScopes: Array<InvitationAccessScope>;
  currentUserIsOwner: boolean;
  cutoffTime?: string | null;
  defaultTipExperimentVariant: string;
  experience: ConsumerCartExperience;
  formattedOrderNumber?: string | null;
  hasPunchout: boolean;
  isMissingDessert: boolean;
  isMissingDrinks: boolean;
  isModifiable?: boolean | null;
  isModification: boolean;
  isPunchoutEdit: boolean;
  modificationCutoffTime?: string | null;
  qualifiesForFreeDelivery: boolean;
  tippingAllowed: boolean;
  utensilsSelection: UtensilsSelectionEnum;
  authorizedUsers: Array<{
    __typename?: 'ConsumerCartAuthorizedUser';
    id: string;
    name: string;
    remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
    total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
  }>;
  customerMessages: Array<
    | {
        __typename: 'ConsumerCartItemsNotAvailable';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartItemsPastCutoff';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartOrderMayBeDuplicate';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartOverCorpSpendingLimit';
        enforce: boolean;
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {__typename: 'GenericCustomerMessage'; code: ConsumerCartCustomerMessageCode; message: string}
  >;
  deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
  ezRewards: {
    __typename?: 'ConsumerCartEzRewards';
    bonusPointsEarnable: number;
    payableWithEzRewards: boolean;
    pointsEarnable: number;
    pointsToApply: number;
    maxDeductible: {
      __typename?: 'ConsumerCartDeductibleEzRewards';
      points: number;
      amount: {__typename?: 'Money'; currency: Currency; subunits: number};
    };
  };
  groupOrder?: {
    __typename?: 'GroupOrder';
    eventDate?: string | null;
    eventTime?: string | null;
    invitationUrl: string;
    ownerName: string;
    caterer: {__typename?: 'Caterer'; id: string; name: string};
    perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
  } | null;
  items: Array<{
    __typename?: 'ConsumerCartItem';
    id: string;
    menuItemUuid?: string | null;
    name?: string | null;
    productCatalog?: ProductCatalog | null;
    quantity: number;
    serves?: number | null;
    size: string;
    specialInstructions?: string | null;
    vegetarianQuantity?: number | null;
    modifiers?: Array<{
      __typename?: 'Modifier';
      id: string;
      name: string;
      quantity: number;
      supplierProductId?: string | null;
      modifiers?: Array<{
        __typename?: 'Modifier';
        id: string;
        name: string;
        quantity: number;
        supplierProductId?: string | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
        price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      }> | null;
      modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
      price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
    }> | null;
    options: Array<{
      __typename?: 'ConsumerCartItemOption';
      id: string;
      menuOptionUuid?: string | null;
      prefixLabel?: string | null;
      minimumChoicesAllowed?: number | null;
      maximumChoicesAllowed?: number | null;
      choices: Array<{
        __typename?: 'ConsumerCartItemOptionChoice';
        id: string;
        isGlutenFree: boolean;
        menuChoiceUuid?: string | null;
        name: string;
        subQuantityPercentage?: number | null;
      }>;
    }>;
    shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
    total: {__typename?: 'Money'; currency: Currency; subunits: number};
  }>;
  lineItems: Array<
    | {
        __typename?: 'DeliveryFeeLineItem';
        id: string;
        isThirdPartyDeliveryOnly: boolean;
        name: string;
        type?: ConsumerCartLineItemTypeEnum | null;
        cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }
    | {
        __typename?: 'GenericLineItem';
        id: string;
        name: string;
        type?: ConsumerCartLineItemTypeEnum | null;
        cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }
    | {
        __typename?: 'PromoLineItem';
        id: string;
        name: string;
        type?: ConsumerCartLineItemTypeEnum | null;
        cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        promoApplicationStatus: {
          __typename?: 'PromoApplicationStatus';
          id?: string | null;
          isSuccessfullyApplied: boolean;
          missingRequirements: string;
        };
      }
  >;
  orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
  pricePerHead: {
    __typename?: 'ConsumerCartPricePerHead';
    customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
    foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  };
  subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  freeTablewareItems: Array<{
    __typename?: 'ConsumerCartFreeTablewareItem';
    id: string;
    isIncluded: boolean;
    name: string;
  }>;
  tableware: {
    __typename?: 'ConsumerCartTableware';
    id: string;
    specialInstructions?: string | null;
    tablewareChoices: Array<{
      __typename?: 'ConsumerCartTablewareChoice';
      id: string;
      isIncluded: boolean;
      name: string;
    }>;
  };
  tip: {
    __typename?: 'ConsumerCartTip';
    percentage?: number | null;
    fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
  };
  preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
  totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
  promoCode?: {
    __typename?: 'PromoCode';
    id: string;
    code: string;
    promo: {
      __typename?: 'Promo';
      id: string;
      title: string;
      description: string;
      finePrint?: string | null;
      discountAmount?: number | null;
    };
  } | null;
};

export type CateringMenuConsumerCartPastCutoffFragment = {
  __typename?: 'ConsumerCart';
  id: string;
  customerMessages: Array<
    | {__typename: 'ConsumerCartItemsNotAvailable'; code: ConsumerCartCustomerMessageCode}
    | {
        __typename: 'ConsumerCartItemsPastCutoff';
        code: ConsumerCartCustomerMessageCode;
        pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
      }
    | {__typename: 'ConsumerCartOrderMayBeDuplicate'; code: ConsumerCartCustomerMessageCode}
    | {__typename: 'ConsumerCartOverCorpSpendingLimit'; code: ConsumerCartCustomerMessageCode}
    | {__typename: 'GenericCustomerMessage'; code: ConsumerCartCustomerMessageCode}
  >;
};

export type CateringMenuFulfillmentDetailWithMessagesFragment = {
  __typename?: 'FulfillmentDetail';
  id: string;
  editable: boolean;
  eventAt?: string | null;
  eventLocalTime?: string | null;
  eventName?: string | null;
  eventOn?: string | null;
  headcount?: number | null;
  strategy: FulfillmentDetailStrategy;
  corpAccount?: {
    __typename?: 'CorporateAccount';
    id: string;
    uuid: string;
    isParent?: boolean | null;
    name: string;
    displayName?: string | null;
    collectsAllEzRewards: boolean;
    logoIconUrl?: string | null;
    procurementSettings?: {__typename?: 'ProcurementSettings'; cartEditsEnabled: boolean} | null;
    deliverySettings?: {
      __typename?: 'DeliverySettings';
      deliveryFeeCapEnabled: boolean;
      deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    } | null;
  } | null;
  customerMessages: Array<
    | {
        __typename: 'ConsumerCartItemsNotAvailable';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartItemsPastCutoff';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartOrderMayBeDuplicate';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartOverCorpSpendingLimit';
        enforce: boolean;
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {__typename: 'GenericCustomerMessage'; code: ConsumerCartCustomerMessageCode; message: string}
  >;
  address: {
    __typename?: 'Address';
    id: string;
    name?: string | null;
    street: string;
    city: string;
    state: string;
    zip?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    fullAddress: string;
    metropolitanStatisticalArea?: string | null;
    timeZoneIdentifier: string;
  };
};

export type CateringMenuOtherLocationsFragment = {
  __typename?: 'Caterer';
  id: string;
  urlId: string;
  hideStreetAddress: boolean;
  address?: {
    __typename?: 'Address';
    id: string;
    city: string;
    street: string;
    state: string;
  } | null;
};

export type CateringMenuOtherLocationsWithDistanceFragment = {
  __typename?: 'CatererLocationWithDistance';
  distanceMiles?: number | null;
  caterer: {
    __typename?: 'Caterer';
    id: string;
    uuid: string;
    urlId: string;
    name: string;
    hideStreetAddress: boolean;
    address?: {
      __typename?: 'Address';
      id: string;
      city: string;
      street: string;
      state: string;
    } | null;
  };
};

export type CheckoutConsumerCartFragment = {
  __typename?: 'ConsumerCart';
  id: string;
  approvalDeadline?: string | null;
  currentUserAccessScopes: Array<InvitationAccessScope>;
  currentUserIsOwner: boolean;
  defaultTipExperimentVariant: string;
  experience: ConsumerCartExperience;
  userCanAccessEzRewards: boolean;
  formattedOrderNumber?: string | null;
  hasPunchout: boolean;
  isMissingDessert: boolean;
  isMissingDrinks: boolean;
  isModification: boolean;
  isPunchoutEdit: boolean;
  qualifiesForFreeDelivery: boolean;
  tippingAllowed: boolean;
  utensilsSelection: UtensilsSelectionEnum;
  requiresProcurementCheckout: boolean;
  authorizedUsers: Array<{
    __typename?: 'ConsumerCartAuthorizedUser';
    id: string;
    name: string;
    remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
    total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
  }>;
  corporateOrderReferenceCodes: Array<{
    __typename?: 'OrderReferenceCode';
    id: string;
    name: string;
    value?: string | null;
  }>;
  corporateReferenceCodes: Array<{
    __typename?: 'CorporateReferenceCode';
    id: string;
    active: boolean;
    currentValue?: string | null;
    name: string;
    values: Array<string>;
    required: boolean;
    type: CorpCustomCheckoutFieldEntry;
    requiresCreditLine: boolean;
    procurement: boolean;
  }>;
  customerMessages: Array<
    | {
        __typename: 'ConsumerCartItemsNotAvailable';
        code: ConsumerCartCustomerMessageCode;
        message: string;
        missingItems: Array<{__typename?: 'ConsumerCartItem'; id: string; name?: string | null}>;
        missingChoices: Array<{
          __typename?: 'ConsumerCartItemOptionChoice';
          id: string;
          name: string;
        }>;
      }
    | {
        __typename: 'ConsumerCartItemsPastCutoff';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartOrderMayBeDuplicate';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartOverCorpSpendingLimit';
        enforce: boolean;
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {__typename: 'GenericCustomerMessage'; code: ConsumerCartCustomerMessageCode; message: string}
  >;
  deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
  ezRewards: {
    __typename?: 'ConsumerCartEzRewards';
    bonusPointsEarnable: number;
    extraPointsToApply: number;
    payableWithEzRewards: boolean;
    pointsEarnable: number;
    pointsToApply: number;
    combined: {
      __typename?: 'ConsumerCartCombinedEzRewards';
      dollarsToApply: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalRemaining: {
        __typename?: 'ConsumerCartTotalRemainingEzRewards';
        points: number;
        amount: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
    };
    maxDeductible: {
      __typename?: 'ConsumerCartDeductibleEzRewards';
      points: number;
      amount: {__typename?: 'Money'; currency: Currency; subunits: number};
      boosted: {
        __typename?: 'ConsumerCartBoostedDeductibleEzRewards';
        points: number;
        amount: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
    };
  };
  fulfillmentDetail: {
    __typename?: 'FulfillmentDetail';
    id: string;
    deliverySetup: DeliverySetup;
    editable: boolean;
    eventAt?: string | null;
    eventLocalTime?: string | null;
    eventName?: string | null;
    eventOn?: string | null;
    headcount?: number | null;
    strategy: FulfillmentDetailStrategy;
    customerMessages: Array<
      | {
          __typename: 'ConsumerCartItemsNotAvailable';
          code: ConsumerCartCustomerMessageCode;
          message: string;
          missingItems: Array<{__typename?: 'ConsumerCartItem'; id: string; name?: string | null}>;
          missingChoices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            name: string;
          }>;
        }
      | {
          __typename: 'ConsumerCartItemsPastCutoff';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOrderMayBeDuplicate';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOverCorpSpendingLimit';
          enforce: boolean;
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'GenericCustomerMessage';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
    >;
    address: {
      __typename?: 'Address';
      id: string;
      deliveryInstructions?: string | null;
      driverAskFor?: string | null;
      phone?: string | null;
      staticMapUrl?: string | null;
      street2?: string | null;
      name?: string | null;
      street: string;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      fullAddress: string;
      metropolitanStatisticalArea?: string | null;
      timeZoneIdentifier: string;
    };
    corpAccount?: {
      __typename?: 'CorporateAccount';
      id: string;
      uuid: string;
      isParent?: boolean | null;
      name: string;
      displayName?: string | null;
      collectsAllEzRewards: boolean;
      logoIconUrl?: string | null;
      procurementSettings?: {
        __typename?: 'ProcurementSettings';
        cartEditsEnabled: boolean;
        creditCardPaymentAllowed: boolean;
      } | null;
      deliverySettings?: {
        __typename?: 'DeliverySettings';
        deliveryFeeCapEnabled: boolean;
        deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
    } | null;
  };
  groupOrder?: {
    __typename?: 'GroupOrder';
    eventDate?: string | null;
    eventTime?: string | null;
    invitationUrl: string;
    ownerName: string;
    caterer: {__typename?: 'Caterer'; id: string; name: string};
    perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
  } | null;
  items: Array<{
    __typename?: 'ConsumerCartItem';
    id: string;
    menuItemUuid?: string | null;
    productCatalog?: ProductCatalog | null;
    name?: string | null;
    quantity: number;
    serves?: number | null;
    size: string;
    specialInstructions?: string | null;
    vegetarianQuantity?: number | null;
    modifiers?: Array<{
      __typename?: 'Modifier';
      id: string;
      name: string;
      quantity: number;
      supplierProductId?: string | null;
      modifiers?: Array<{
        __typename?: 'Modifier';
        id: string;
        name: string;
        quantity: number;
        supplierProductId?: string | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
        price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      }> | null;
      modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
      price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
    }> | null;
    options: Array<{
      __typename?: 'ConsumerCartItemOption';
      id: string;
      menuOptionUuid?: string | null;
      prefixLabel?: string | null;
      choices: Array<{
        __typename?: 'ConsumerCartItemOptionChoice';
        id: string;
        isGlutenFree: boolean;
        menuChoiceUuid?: string | null;
        name: string;
        subQuantityPercentage?: number | null;
      }>;
    }>;
    shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
    total: {__typename?: 'Money'; currency: Currency; subunits: number};
  }>;
  lineItems: Array<
    | {
        __typename?: 'DeliveryFeeLineItem';
        id: string;
        isThirdPartyDeliveryOnly: boolean;
        name: string;
        type?: ConsumerCartLineItemTypeEnum | null;
        cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }
    | {
        __typename?: 'GenericLineItem';
        id: string;
        name: string;
        type?: ConsumerCartLineItemTypeEnum | null;
        cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }
    | {
        __typename?: 'PromoLineItem';
        id: string;
        name: string;
        type?: ConsumerCartLineItemTypeEnum | null;
        cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        promoApplicationStatus: {
          __typename?: 'PromoApplicationStatus';
          id?: string | null;
          isSuccessfullyApplied: boolean;
          missingRequirements: string;
        };
      }
  >;
  orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
  pricePerHead: {
    __typename?: 'ConsumerCartPricePerHead';
    customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  };
  subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  freeTablewareItems: Array<{
    __typename?: 'ConsumerCartFreeTablewareItem';
    id: string;
    isIncluded: boolean;
    name: string;
  }>;
  tableware: {
    __typename?: 'ConsumerCartTableware';
    id: string;
    specialInstructions?: string | null;
    tablewareChoices: Array<{
      __typename?: 'ConsumerCartTablewareChoice';
      id: string;
      isIncluded: boolean;
      name: string;
    }>;
  };
  tip: {
    __typename?: 'ConsumerCartTip';
    percentage?: number | null;
    fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
  };
  preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
  totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
  promoCode?: {
    __typename?: 'PromoCode';
    id: string;
    code: string;
    promo: {
      __typename?: 'Promo';
      id: string;
      title: string;
      description: string;
      finePrint?: string | null;
      discountAmount?: number | null;
    };
  } | null;
  user?: {__typename?: 'ConsumerCartUser'; id: string; fullName?: string | null} | null;
};

export type CheckoutPageFulfillmentDetailFragment = {
  __typename?: 'FulfillmentDetail';
  id: string;
  deliverySetup: DeliverySetup;
  editable: boolean;
  eventAt?: string | null;
  eventLocalTime?: string | null;
  eventName?: string | null;
  eventOn?: string | null;
  headcount?: number | null;
  strategy: FulfillmentDetailStrategy;
  address: {
    __typename?: 'Address';
    id: string;
    deliveryInstructions?: string | null;
    driverAskFor?: string | null;
    phone?: string | null;
    staticMapUrl?: string | null;
    street2?: string | null;
    name?: string | null;
    street: string;
    city: string;
    state: string;
    zip?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    fullAddress: string;
    metropolitanStatisticalArea?: string | null;
    timeZoneIdentifier: string;
  };
  corpAccount?: {
    __typename?: 'CorporateAccount';
    id: string;
    uuid: string;
    isParent?: boolean | null;
    name: string;
    displayName?: string | null;
    collectsAllEzRewards: boolean;
    logoIconUrl?: string | null;
    procurementSettings?: {
      __typename?: 'ProcurementSettings';
      cartEditsEnabled: boolean;
      creditCardPaymentAllowed: boolean;
    } | null;
    deliverySettings?: {
      __typename?: 'DeliverySettings';
      deliveryFeeCapEnabled: boolean;
      deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    } | null;
  } | null;
};

export type CheckoutWalkthroughFragment = {
  __typename?: 'ConsumerCart';
  id: string;
  hasPunchout: boolean;
  paymentMethodUserId?: string | null;
  qualifiesForFreeDelivery: boolean;
  requiresProcurementCheckout: boolean;
  corporateOrderReferenceCodes: Array<{
    __typename?: 'OrderReferenceCode';
    id: string;
    name: string;
    value?: string | null;
  }>;
  corporateReferenceCodes: Array<{
    __typename?: 'CorporateReferenceCode';
    id: string;
    active: boolean;
    currentValue?: string | null;
    name: string;
    values: Array<string>;
    required: boolean;
    type: CorpCustomCheckoutFieldEntry;
    requiresCreditLine: boolean;
    procurement: boolean;
  }>;
  customerMessages: Array<
    | {
        __typename: 'ConsumerCartItemsNotAvailable';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartItemsPastCutoff';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartOrderMayBeDuplicate';
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {
        __typename: 'ConsumerCartOverCorpSpendingLimit';
        enforce: boolean;
        code: ConsumerCartCustomerMessageCode;
        message: string;
      }
    | {__typename: 'GenericCustomerMessage'; code: ConsumerCartCustomerMessageCode; message: string}
  >;
  fulfillmentDetail: {
    __typename?: 'FulfillmentDetail';
    id: string;
    eventLocalTime?: string | null;
    eventOn?: string | null;
    strategy: FulfillmentDetailStrategy;
    address: {
      __typename?: 'Address';
      id: string;
      city: string;
      driverAskFor?: string | null;
      name?: string | null;
      phone?: string | null;
      state: string;
      street: string;
      zip?: string | null;
    };
    corpAccount?: {
      __typename?: 'CorporateAccount';
      id: string;
      uuid: string;
      procurementSettings?: {
        __typename?: 'ProcurementSettings';
        creditCardPaymentAllowed: boolean;
      } | null;
    } | null;
    customerMessages: Array<
      | {
          __typename: 'ConsumerCartItemsNotAvailable';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartItemsPastCutoff';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOrderMayBeDuplicate';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOverCorpSpendingLimit';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'GenericCustomerMessage';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
    >;
  };
  paymentMethod?:
    | {__typename: 'CreditCard'; id: string}
    | {__typename: 'CreditLine'; id: string; allowedUse: CreditLineAllowedUse}
    | null;
  authorizedUsers: Array<{__typename?: 'ConsumerCartAuthorizedUser'; id: string; name: string}>;
};

type ConsumerCartModifierFragment_LineItemModifier = {
  __typename?: 'LineItemModifier';
  id: string;
  name: string;
  quantity: number;
  supplierProductId?: string | null;
  modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
};

type ConsumerCartModifierFragment_Modifier = {
  __typename?: 'Modifier';
  id: string;
  name: string;
  quantity: number;
  supplierProductId?: string | null;
  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
};

export type ConsumerCartModifierFragment =
  ConsumerCartModifierFragment_LineItemModifier | ConsumerCartModifierFragment_Modifier;

export type ConsumerHasSubmittedOrderFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  submittedOrders?: {__typename?: 'OrderConnection'; totalCount: number} | null;
};

export type ConsumerReferralFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  giftCardRedemptionAllowed?: boolean | null;
  referAFriendEligible: boolean;
  referralUrl?: string | null;
  referralCode?: string | null;
};

export type ContactUsModalOrderFragment = {
  __typename?: 'Order';
  id: string;
  uuid: string;
  formattedOrderNumber?: string | null;
  event?: {
    __typename?: 'Event';
    id: string;
    timestamp?: string | null;
    timeZoneOffset?: string | null;
    address?: {__typename?: 'Address'; id: string; nameOrLocation: string} | null;
  } | null;
  caterer?: {__typename?: 'Caterer'; id: string; name: string} | null;
};

export type ContactUsOrderFragment = {
  __typename?: 'Order';
  id: string;
  uuid: string;
  formattedOrderNumber?: string | null;
  event?: {
    __typename?: 'Event';
    id: string;
    timestamp?: string | null;
    timeZoneOffset?: string | null;
    address?: {__typename?: 'Address'; id: string; nameOrLocation: string} | null;
  } | null;
  caterer?: {__typename?: 'Caterer'; id: string; name: string} | null;
};

type ContinuityCardFragment_DraftOrderContinuityCard = {
  __typename?: 'DraftOrderContinuityCard';
  url: string;
  eventAt?: string | null;
  eventName?: string | null;
  strategy: FulfillmentDetailStrategy;
  headcount?: number | null;
  image?: {__typename?: 'Image'; uuid: string; desktopHeroUrl?: string | null} | null;
  address?: {
    __typename?: 'Address';
    id: string;
    city: string;
    state: string;
    timeZoneIdentifier: string;
  } | null;
};

type ContinuityCardFragment_SearchContinuityCard = {
  __typename?: 'SearchContinuityCard';
  url: string;
  eventAt?: string | null;
  eventName?: string | null;
  strategy: FulfillmentDetailStrategy;
  headcount?: number | null;
  image?: {__typename?: 'Image'; uuid: string; desktopHeroUrl?: string | null} | null;
  address?: {
    __typename?: 'Address';
    id: string;
    city: string;
    state: string;
    timeZoneIdentifier: string;
  } | null;
};

export type ContinuityCardFragment =
  ContinuityCardFragment_DraftOrderContinuityCard | ContinuityCardFragment_SearchContinuityCard;

export type CustomerOrderStatusFragment = {
  __typename?: 'Order';
  id: string;
  customerOrderStatus?: {
    __typename?: 'CustomerOrderStatus';
    id: string;
    isSubmitted?: boolean | null;
    isDraft: boolean;
    submittedAt?: string | null;
    isAccepted?: boolean | null;
    isReconfirmed?: boolean | null;
    isFulfilled?: boolean | null;
    fulfilledAt?: string | null;
    isCustomerPaymentCaptured?: boolean | null;
    isModifiable?: boolean | null;
    modificationCutoffTime?: string | null;
    isCancellable?: boolean | null;
    isCancelled?: boolean | null;
    cancelledAt?: string | null;
    isPendingApproval: boolean;
  } | null;
};

export type DeliveryDetailsFulfillmentFragment = {
  __typename?: 'ConsumerCart';
  id: string;
  fulfillmentDetail: {
    __typename?: 'FulfillmentDetail';
    id: string;
    deliverySetup: DeliverySetup;
    address: {
      __typename?: 'Address';
      id: string;
      city: string;
      deliveryInstructions?: string | null;
      driverAskFor?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      name?: string | null;
      phone?: string | null;
      state: string;
      street: string;
      street2?: string | null;
      zip?: string | null;
    };
    customerMessages: Array<
      | {
          __typename: 'ConsumerCartItemsNotAvailable';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartItemsPastCutoff';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOrderMayBeDuplicate';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOverCorpSpendingLimit';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'GenericCustomerMessage';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
    >;
  };
};

export type DeliveryFeeExperimentFragment = {
  __typename?: 'Query';
  graphExperiments?: {
    __typename?: 'GraphExperiments';
    deliveryFeeExperiment: {
      __typename?: 'DeliveryFeeExperimentVersions';
      v2?: {
        __typename?: 'DeliveryFeeExperimentAssignmentV2';
        flagKey: string;
        allocationKey: string;
        experimentKey: string;
        variation: string;
        pricingModel:
          | {
              __typename: 'CappedDeliveryFeePricingModel';
              cap: {__typename?: 'Money'; subunits: number; currency: Currency};
            }
          | {__typename: 'StandardDeliveryFeePricingModel'};
      } | null;
    };
  } | null;
};

export type DraftCartTrackingFragment = {
  __typename?: 'ConsumerCart';
  id: string;
  isModification: boolean;
  items: Array<{__typename?: 'ConsumerCartItem'; id: string; quantity: number}>;
};

export type DraftOrderContinuityCardFragment = {
  __typename?: 'DraftOrderContinuityCard';
  id: string;
  catererName: string;
  itemCount: number;
  cutoffTime?: string | null;
  isGroupOrder: boolean;
  url: string;
  eventAt?: string | null;
  eventName?: string | null;
  strategy: FulfillmentDetailStrategy;
  headcount?: number | null;
  orderTotal: {__typename?: 'Money'; subunits: number};
  image?: {__typename?: 'Image'; uuid: string; desktopHeroUrl?: string | null} | null;
  address?: {
    __typename?: 'Address';
    id: string;
    city: string;
    state: string;
    timeZoneIdentifier: string;
  } | null;
};

export type EventFragment = {
  __typename?: 'Order';
  id: string;
  event?: {
    __typename?: 'Event';
    id: string;
    headcount?: number | null;
    customerProvidedName?: string | null;
    deliverySetup: DeliverySetup;
    isTakeout: boolean;
    orderType: OrderTypeEnum;
    timestamp?: string | null;
    timeZoneIdentifier?: string | null;
    timeZoneOffset?: string | null;
    address?: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      city: string;
      street: string;
      street2?: string | null;
      state: string;
      zip?: string | null;
      deliveryInstructions?: string | null;
      driverAskFor?: string | null;
      phone?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type FirstOrderDetailsFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  firstOrderDetails: {
    __typename?: 'FirstOrderDetails';
    id: string;
    submittedFeedback: boolean;
    order?: {
      __typename?: 'Order';
      id: string;
      caterer?: {__typename?: 'Caterer'; id: string; name: string} | null;
    } | null;
  };
};

export type FirstOrderReferenceCodeFragment = {
  __typename?: 'Order';
  id: string;
  firstOrderReferenceCode?: {
    __typename?: 'OrderReferenceCode';
    id: string;
    value?: string | null;
    corporateReferenceCode?: {
      __typename?: 'CorporateReferenceCode';
      id: string;
      name: string;
    } | null;
  } | null;
};

export type ForceEmailUpdateFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  email: string;
  isCurrentDeviceRecognized?: boolean | null;
  mobilePhoneLastTwo?: string | null;
};

export type FulfillmentDetailFragment = {
  __typename?: 'FulfillmentDetail';
  id: string;
  editable: boolean;
  eventAt?: string | null;
  eventLocalTime?: string | null;
  eventName?: string | null;
  eventOn?: string | null;
  headcount?: number | null;
  strategy: FulfillmentDetailStrategy;
  address: {
    __typename?: 'Address';
    id: string;
    name?: string | null;
    street: string;
    city: string;
    state: string;
    zip?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    fullAddress: string;
    metropolitanStatisticalArea?: string | null;
    timeZoneIdentifier: string;
  };
  corpAccount?: {
    __typename?: 'CorporateAccount';
    id: string;
    uuid: string;
    isParent?: boolean | null;
    name: string;
    displayName?: string | null;
    collectsAllEzRewards: boolean;
    logoIconUrl?: string | null;
    deliverySettings?: {
      __typename?: 'DeliverySettings';
      deliveryFeeCapEnabled: boolean;
      deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    } | null;
  } | null;
};

export type GetMoreOutOfEzCaterConstantsFragment = {
  __typename?: 'Constants';
  ezRewards?: {
    __typename?: 'EzRewardsConstants';
    minimumPointsForGiftCardRedemption?: number | null;
  } | null;
};

export type GetMoreOutOfEzCaterConsumerAccountFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  giftCardRedemptionAllowed?: boolean | null;
  isCorporate?: boolean | null;
  ezRewardsAccount?: {
    __typename?: 'EzRewardsAccount';
    id: string;
    balance?: number | null;
    giftCardRedemptions?: {__typename?: 'EzRewardsActivityConnection'; totalCount: number} | null;
  } | null;
};

export type HomeBannersConsumerAccountFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  showInvalidEmailBanner: boolean;
  email: string;
  needsCorporateEmailVerification?: boolean | null;
};

export type IdentityFragment = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type IdentityRecommendedAddressFragment = {
  __typename?: 'Query';
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type InvalidEmailBannerFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  showInvalidEmailBanner: boolean;
};

export type JumpBackInCartFragment = {
  __typename?: 'ConsumerCart';
  id: string;
  updatedAt: string;
  caterer: {
    __typename?: 'Caterer';
    id: string;
    name: string;
    urlId: string;
    live: boolean;
    activePauses?: Array<{__typename?: 'CatererPause'; id: string}> | null;
    brand?: {
      __typename?: 'Brand';
      id: string;
      heroImage?: {__typename?: 'Image'; uuid: string; mobileSearchUrl?: string | null} | null;
    } | null;
  };
  items: Array<{__typename?: 'ConsumerCartItem'; id: string; quantity: number}>;
  totalDue: {__typename?: 'Money'; subunits: number};
};

export type JumpBackInFulfillmentDetailFragment = {
  __typename?: 'FulfillmentDetail';
  id: string;
  editable: boolean;
  eventAt?: string | null;
  eventLocalTime?: string | null;
  eventName?: string | null;
  eventOn?: string | null;
  headcount?: number | null;
  strategy: FulfillmentDetailStrategy;
  consumerCarts: Array<{
    __typename?: 'ConsumerCart';
    id: string;
    updatedAt: string;
    caterer: {
      __typename?: 'Caterer';
      id: string;
      name: string;
      urlId: string;
      live: boolean;
      activePauses?: Array<{__typename?: 'CatererPause'; id: string}> | null;
      brand?: {
        __typename?: 'Brand';
        id: string;
        heroImage?: {__typename?: 'Image'; uuid: string; mobileSearchUrl?: string | null} | null;
      } | null;
    };
    items: Array<{__typename?: 'ConsumerCartItem'; id: string; quantity: number}>;
    totalDue: {__typename?: 'Money'; subunits: number};
  }>;
  address: {
    __typename?: 'Address';
    id: string;
    name?: string | null;
    street: string;
    city: string;
    state: string;
    zip?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    fullAddress: string;
    metropolitanStatisticalArea?: string | null;
    timeZoneIdentifier: string;
  };
  corpAccount?: {
    __typename?: 'CorporateAccount';
    id: string;
    uuid: string;
    isParent?: boolean | null;
    name: string;
    displayName?: string | null;
    collectsAllEzRewards: boolean;
    logoIconUrl?: string | null;
    deliverySettings?: {
      __typename?: 'DeliverySettings';
      deliveryFeeCapEnabled: boolean;
      deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    } | null;
  } | null;
};

export type LineItemModifierFragment = {
  __typename?: 'LineItemModifier';
  id: string;
  name: string;
  quantity: number;
  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
  modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
};

export type MenuevoModifierFragment = {
  __typename?: 'MenuevoModifier';
  defaultQuantity: number;
  description?: string | null;
  id: string;
  name: string;
  preselected?: boolean | null;
  sortIndex: number;
  servings?: {__typename?: 'ServingsRange'; max?: number | null; min: number} | null;
  calories?: {__typename?: 'CalorieRange'; max?: number | null; min: number} | null;
  price: {__typename?: 'Money'; currency: Currency; subunits: number; subunitsV2: string};
};

export type MenuevoModifierGroupFragment = {
  __typename?: 'MenuevoModifierGroup';
  customerPrompt?: string | null;
  description?: string | null;
  fulfillmentLabel?: string | null;
  id: string;
  maxAggregateQuantity?: number | null;
  maxModifierQuantity?: number | null;
  maxSelections?: number | null;
  minAggregateQuantity?: number | null;
  minModifierQuantity?: number | null;
  minSelections?: number | null;
  name: string;
  sortIndex: number;
};

export type OrderCancellationPolicyDisplayFragment = {
  __typename?: 'OrderCancellationPolicyDisplay';
  hasCancellationFee: boolean;
  feePercentage: number;
  cancelWithoutPenaltyUntil?: string | null;
  cancellationWindowHours: number;
  isWaiverEligible: boolean;
  feeAmount?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
};

export type OrderCardFragment = {
  __typename?: 'Order';
  id: string;
  uuid: string;
  isStandardGroupOrder: boolean;
  customerOrderStatus?: {
    __typename?: 'CustomerOrderStatus';
    id: string;
    isFulfilled?: boolean | null;
    isCancelled?: boolean | null;
  } | null;
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    uuid: string;
    urlId: string;
    name: string;
    brand?: {
      __typename?: 'Brand';
      id: string;
      uuid: string;
      heroImage?: {__typename?: 'Image'; uuid: string; mobileHeroUrl?: string | null} | null;
    } | null;
    address?: {__typename?: 'Address'; id: string; fullAddress: string} | null;
  } | null;
  event?: {
    __typename?: 'Event';
    id: string;
    timestamp?: string | null;
    timeZoneIdentifier?: string | null;
    timeZoneOffset?: string | null;
    isTakeout: boolean;
    address?: {__typename?: 'Address'; id: string; nameOrLocation: string} | null;
  } | null;
};

export type OrderFragment = {
  __typename?: 'Order';
  id: string;
  canBeReviewed?: boolean | null;
  formattedOrderNumber?: string | null;
  isStandardGroupOrder: boolean;
  uuid: string;
  approvalDeadline?: string | null;
  delivery?: {
    __typename?: 'DmDelivery';
    id: string;
    estimatedDropoffTime?: string | null;
    tracking?: {__typename?: 'DmDeliveryTracking'; url: string} | null;
    deliveryEvents: Array<{
      __typename?: 'DmDeliveryEvent';
      id: string;
      eventType: DmDeliveryEventTypes;
      time: string;
    }>;
  } | null;
  review?: {
    __typename?: 'Review';
    id?: string | null;
    text?: string | null;
    rating?: StarRating | null;
    deliveryTimeFeedback?: DeliveryTimeFeedback | null;
    deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
    penName?: string | null;
  } | null;
  tableware: {
    __typename?: 'TablewareSummary';
    specialInstructions?: string | null;
    includedUtensils: Array<string>;
    omittedUtensils: Array<string>;
  };
  corporateOrderReferenceCodes?: Array<{
    __typename?: 'OrderReferenceCode';
    id: string;
    name: string;
    value?: string | null;
    corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
  }> | null;
  corporateReferenceCodes: Array<{
    __typename?: 'CorporateReferenceCode';
    id: string;
    active: boolean;
    name: string;
    required: boolean;
    requiresCreditLine: boolean;
    type: CorpCustomCheckoutFieldEntry;
    values: Array<string>;
    procurement: boolean;
    currentValue?: string | null;
  }>;
  cart?: {
    __typename?: 'Cart';
    id: string;
    productCatalog: ProductCatalog;
    lineItems: Array<{
      __typename?: 'LineItem';
      id: string;
      name?: string | null;
      type?: LineItemTypeEnum | null;
      cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    }>;
    orderItems: Array<{
      __typename?: 'OrderItem';
      id: string;
      name?: string | null;
      price?: number | null;
      quantity: number;
      size?: string | null;
      sizeLabel?: string | null;
      specialInstructions?: string | null;
      vegetarianQuantity?: number | null;
      serves?: number | null;
      groupOrderPersonName?: string | null;
      belongsToAnyEater: boolean;
      totalInSubunits?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      orderItemOptions?: Array<{
        __typename?: 'OrderItemOption';
        id: string;
        catererLabel?: string | null;
        itemChoices: Array<{
          __typename?: 'OrderItemChoice';
          id: string;
          name?: string | null;
          price?: number | null;
        }>;
      } | null> | null;
      modifiers?: Array<{
        __typename?: 'LineItemModifier';
        id: string;
        name: string;
        quantity: number;
        modifiers?: Array<{
          __typename?: 'LineItemModifier';
          id: string;
          name: string;
          quantity: number;
          modifiers?: Array<{
            __typename?: 'LineItemModifier';
            id: string;
            name: string;
            quantity: number;
            modifiers?: Array<{
              __typename?: 'LineItemModifier';
              id: string;
              name: string;
              quantity: number;
              modifiers?: Array<{
                __typename?: 'LineItemModifier';
                id: string;
                name: string;
                quantity: number;
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                modifierGroup: {
                  __typename?: 'LineItemModifierGroup';
                  id: string;
                  name?: string | null;
                };
              }> | null;
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              modifierGroup: {
                __typename?: 'LineItemModifierGroup';
                id: string;
                name?: string | null;
              };
            }> | null;
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
          }> | null;
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
        }> | null;
        price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
      }> | null;
    }>;
    tip: {__typename?: 'Tip'; id: string; amount?: number | null};
  } | null;
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    uuid: string;
    name: string;
    urlId: string;
    nickname?: string | null;
    isSavedCaterer: boolean;
    address?: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      city: string;
      street: string;
      street2?: string | null;
      state: string;
      zip?: string | null;
    } | null;
    brand?: {
      __typename?: 'Brand';
      id: string;
      uuid: string;
      name: string;
      logoUrl?: string | null;
    } | null;
  } | null;
  customerOrderStatus?: {
    __typename?: 'CustomerOrderStatus';
    id: string;
    isSubmitted?: boolean | null;
    isDraft: boolean;
    submittedAt?: string | null;
    isAccepted?: boolean | null;
    isReconfirmed?: boolean | null;
    isFulfilled?: boolean | null;
    fulfilledAt?: string | null;
    isCustomerPaymentCaptured?: boolean | null;
    isModifiable?: boolean | null;
    modificationCutoffTime?: string | null;
    isCancellable?: boolean | null;
    isCancelled?: boolean | null;
    cancelledAt?: string | null;
    isPendingApproval: boolean;
  } | null;
  firstOrderReferenceCode?: {
    __typename?: 'OrderReferenceCode';
    id: string;
    value?: string | null;
    corporateReferenceCode?: {
      __typename?: 'CorporateReferenceCode';
      id: string;
      name: string;
    } | null;
  } | null;
  event?: {
    __typename?: 'Event';
    id: string;
    headcount?: number | null;
    customerProvidedName?: string | null;
    deliverySetup: DeliverySetup;
    isTakeout: boolean;
    orderType: OrderTypeEnum;
    timestamp?: string | null;
    timeZoneIdentifier?: string | null;
    timeZoneOffset?: string | null;
    address?: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      city: string;
      street: string;
      street2?: string | null;
      state: string;
      zip?: string | null;
      deliveryInstructions?: string | null;
      driverAskFor?: string | null;
      phone?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  totals?: {
    __typename?: 'OrderTotals';
    customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
    subTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    preDeliveryDiscountDeliveryFee?: {
      __typename?: 'Money';
      currency: Currency;
      subunits: number;
    } | null;
    preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  } | null;
};

export type OrderPlacedConsumerFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  email: string;
  marketplaceStatus: MarketplaceStatusEnum;
  userType: UserTypeEnum;
  industry?: UserIndustryEnum | null;
  referralUrl?: string | null;
  canEarnReferralRewards?: boolean | null;
  enterpriseLeadEligible: boolean;
  referralCode?: string | null;
  hasLoggedIntoIphoneApp: boolean;
  hasLoggedIntoAndroidApp: boolean;
  canAccessEzRewards: boolean;
  submittedOrdersCount: number;
  daysSinceFirstMarketplaceOrder?: number | null;
  assignedPromoCode?: {
    __typename?: 'UserPromoCodeAssignment';
    promo: {
      __typename?: 'Promo';
      id: string;
      title: string;
      description: string;
      finePrint?: string | null;
      termsAndConditionsUrl?: string | null;
    };
  } | null;
};

export type OrderPlacedOrderFragment = {
  __typename?: 'Order';
  id: string;
  uuid: string;
  formattedOrderNumber?: string | null;
  isEzOrderingOrder: boolean;
  isStandardGroupOrder: boolean;
  orderSourceType?: OrderSource | null;
  ezRewardsPointsEarnable: number;
  predictedLtv?: number | null;
  isResidentialOrder: boolean;
  orderRank: {
    __typename?: 'OrderRank';
    submittedMarketplace?: number | null;
    submittedEzOrdering?: number | null;
  };
  cart?: {
    __typename?: 'Cart';
    id: string;
    productCatalog: ProductCatalog;
    orderItems: Array<{
      __typename?: 'OrderItem';
      id: string;
      name?: string | null;
      quantity: number;
      menuItemId?: string | null;
      price?: number | null;
      size?: string | null;
      specialInstructions?: string | null;
      serves?: number | null;
      vegetarianQuantity?: number | null;
      groupOrderPersonName?: string | null;
      totalInSubunits?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      orderItemOptions?: Array<{
        __typename?: 'OrderItemOption';
        id: string;
        catererLabel?: string | null;
        itemChoices: Array<{
          __typename?: 'OrderItemChoice';
          id: string;
          name?: string | null;
          price?: number | null;
        }>;
      } | null> | null;
      modifiers?: Array<{
        __typename?: 'LineItemModifier';
        id: string;
        name: string;
        quantity: number;
        modifiers?: Array<{
          __typename?: 'LineItemModifier';
          id: string;
          name: string;
          quantity: number;
          modifiers?: Array<{
            __typename?: 'LineItemModifier';
            id: string;
            name: string;
            quantity: number;
            modifiers?: Array<{
              __typename?: 'LineItemModifier';
              id: string;
              name: string;
              quantity: number;
              modifiers?: Array<{
                __typename?: 'LineItemModifier';
                id: string;
                name: string;
                quantity: number;
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                modifierGroup: {
                  __typename?: 'LineItemModifierGroup';
                  id: string;
                  name?: string | null;
                };
              }> | null;
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              modifierGroup: {
                __typename?: 'LineItemModifierGroup';
                id: string;
                name?: string | null;
              };
            }> | null;
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
          }> | null;
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
        }> | null;
        price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
      }> | null;
    }>;
    lineItems: Array<{
      __typename?: 'LineItem';
      id: string;
      name?: string | null;
      type?: LineItemTypeEnum | null;
      isGratuity: boolean;
      isPromo: boolean;
      cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    }>;
  } | null;
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    uuid: string;
    name: string;
    urlId: string;
    isSavedCaterer: boolean;
    starRating?: number | null;
    address?: {
      __typename?: 'Address';
      id: string;
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      staticMapUrl?: string | null;
    } | null;
    brand?: {
      __typename?: 'Brand';
      id: string;
      uuid: string;
      name: string;
      logoUrl?: string | null;
    } | null;
  } | null;
  customerOrderStatus?: {
    __typename?: 'CustomerOrderStatus';
    id: string;
    isSubmitted?: boolean | null;
    isAccepted?: boolean | null;
    isReconfirmed?: boolean | null;
    isFulfilled?: boolean | null;
    isModifiable?: boolean | null;
    isCancellable?: boolean | null;
    isCancelled?: boolean | null;
    isDraft: boolean;
    isPendingApproval: boolean;
    modificationCutoffTime?: string | null;
  } | null;
  orderCustomer?: {__typename?: 'OrderCustomer'; id: string} | null;
  delivery?: {
    __typename?: 'DmDelivery';
    id: string;
    deliveryEvents: Array<{
      __typename?: 'DmDeliveryEvent';
      id: string;
      eventType: DmDeliveryEventTypes;
    }>;
  } | null;
  event?: {
    __typename?: 'Event';
    id: string;
    timestamp?: string | null;
    timeZoneOffset?: string | null;
    timeZoneIdentifier?: string | null;
    name?: string | null;
    customerProvidedName?: string | null;
    orderType: OrderTypeEnum;
    headcount?: number | null;
    deliverySetup: DeliverySetup;
    address?: {
      __typename?: 'Address';
      id: string;
      fullAddress: string;
      name?: string | null;
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      phone?: string | null;
      driverAskFor?: string | null;
      deliveryInstructions?: string | null;
      staticMapUrl?: string | null;
    } | null;
  } | null;
  paymentMethod?:
    | {__typename?: 'CreditCard'; id: string; last4?: string | null; cardType?: CardType | null}
    | {__typename?: 'CreditLine'; id: string; corpAccountName?: string | null}
    | null;
  totals?: {
    __typename?: 'OrderTotals';
    tip?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    salesTax: {__typename?: 'Money'; currency: Currency; subunits: number};
    subTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
    preDeliveryDiscountDeliveryFee?: {
      __typename?: 'Money';
      currency: Currency;
      subunits: number;
    } | null;
    preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  } | null;
  corpAccount?: {
    __typename?: 'CorporateAccount';
    id: string;
    deliverySettings?: {
      __typename?: 'DeliverySettings';
      deliveryFeeCapEnabled: boolean;
      deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    } | null;
    procurementSettings?: {__typename?: 'ProcurementSettings'; cartEditsEnabled: boolean} | null;
  } | null;
  tableware: {
    __typename?: 'TablewareSummary';
    includedUtensils: Array<string>;
    omittedUtensils: Array<string>;
    specialInstructions?: string | null;
  };
  cancellationPolicyDisplay?: {
    __typename?: 'OrderCancellationPolicyDisplay';
    hasCancellationFee: boolean;
    feePercentage: number;
    cancelWithoutPenaltyUntil?: string | null;
    cancellationWindowHours: number;
    isWaiverEligible: boolean;
    feeAmount?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
  } | null;
};

export type OrdersTableOrderFragment = {
  __typename?: 'Order';
  id: string;
  uuid: string;
  isPaymentPending?: boolean | null;
  isEzOrderingOrder: boolean;
  formattedOrderNumber?: string | null;
  canBeReviewed?: boolean | null;
  state?: string | null;
  isStandardGroupOrder: boolean;
  notificationsEnabled: boolean;
  firstOrderReferenceCode?: {
    __typename?: 'OrderReferenceCode';
    id: string;
    value?: string | null;
    corporateReferenceCode?: {
      __typename?: 'CorporateReferenceCode';
      id: string;
      name: string;
    } | null;
  } | null;
  event?: {
    __typename?: 'Event';
    id: string;
    timestamp?: string | null;
    timeZoneOffset?: string | null;
    isTakeout: boolean;
    headcount?: number | null;
    customerProvidedName?: string | null;
    address?: {
      __typename?: 'Address';
      id: string;
      nameOrLocation: string;
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    isSavedCaterer: boolean;
    uuid: string;
    name: string;
    starRating?: number | null;
    urlId: string;
    address?: {__typename?: 'Address'; id: string; fullAddress: string} | null;
    minimumDeliveryFee: {
      __typename?: 'MinimumDeliveryFee';
      amount: {__typename?: 'Money'; subunits: number};
    };
    takeoutMinimum?: {__typename?: 'Money'; subunits: number} | null;
    brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
  } | null;
  customerOrderStatus?: {
    __typename?: 'CustomerOrderStatus';
    id: string;
    currentStatusDisplay: string;
    isCancellable?: boolean | null;
    isCancelled?: boolean | null;
    isDraft: boolean;
    isFulfilled?: boolean | null;
    isModifiable?: boolean | null;
    modificationCutoffTime?: string | null;
    isSubmitted?: boolean | null;
    isPendingApproval: boolean;
  } | null;
  totals?: {
    __typename?: 'OrderTotals';
    customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
  } | null;
  review?: {
    __typename?: 'Review';
    id?: string | null;
    text?: string | null;
    rating?: StarRating | null;
    deliveryTimeFeedback?: DeliveryTimeFeedback | null;
    deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
    penName?: string | null;
  } | null;
  cart?: {
    __typename?: 'Cart';
    id: string;
    orderItems: Array<{__typename?: 'OrderItem'; id: string; belongsToAnyEater: boolean}>;
  } | null;
  corpAccount?: {__typename?: 'CorporateAccount'; id: string; name: string} | null;
  orderCustomer?: {__typename?: 'OrderCustomer'; id: string; fullName?: string | null} | null;
  cancellationPolicyDisplay?: {
    __typename?: 'OrderCancellationPolicyDisplay';
    hasCancellationFee: boolean;
    feePercentage: number;
    cancelWithoutPenaltyUntil?: string | null;
    cancellationWindowHours: number;
    isWaiverEligible: boolean;
    feeAmount?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
  } | null;
};

export type PaymentMethodsFragment = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    adminAccount?: {__typename?: 'AdminAccount'; id: string} | null;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      email: string;
      firstName?: string | null;
      lastName?: string | null;
      mobilePhone?: string | null;
      isCorporate?: boolean | null;
      corporateAccountVerified: boolean;
      canUpdateCorpPortal: boolean;
      paymentMethods?: {
        __typename?: 'PaymentMethodConnection';
        nodes?: Array<
          | {
              __typename?: 'CreditCard';
              id: string;
              cardType?: CardType | null;
              cardholderName: string;
              expMonth?: number | null;
              expYear?: number | null;
              isDefaultCard?: boolean | null;
              isExpired?: boolean | null;
              isExpiringSoon?: boolean | null;
              last4?: string | null;
              nickname?: string | null;
              missingZipCode: boolean;
              sharedWithCount?: number | null;
              sharedBy?: {
                __typename?: 'ConsumerAccount';
                id: string;
                email: string;
                fullName?: string | null;
              } | null;
            }
          | {
              __typename?: 'CreditLine';
              id: string;
              allowedUse: CreditLineAllowedUse;
              corpAccountName?: string | null;
              isDefault?: boolean | null;
              logoImageUrl?: string | null;
            }
          | null
        > | null;
      } | null;
    } | null;
  } | null;
};

export type PaymentMethodsRootFragment = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      isCurrentDeviceRecognized?: boolean | null;
      mobilePhoneLastTwo?: string | null;
      email: string;
    } | null;
    adminAccount?: {__typename?: 'AdminAccount'; id: string; isMasquerading: boolean} | null;
  } | null;
};

export type PreviouslyEngagedCaterersFragment = {
  __typename?: 'CatererSearchResult';
  cacheKey: string;
  name: string;
  id: string;
  imageSrc?: string | null;
  isReliabilityRockstar: boolean;
  isSavedCaterer: boolean;
  urlId: string;
  uuid: string;
  searchResultBrand: {__typename?: 'SearchResultBrand'; id: string; uuid?: string | null};
  previousEngagement?:
    | {__typename?: 'BrandEngagement'; id: string; lastOrderedFrom?: string | null}
    | {__typename?: 'CatererEngagement'; id: string; lastOrderedFrom?: string | null}
    | {__typename?: 'CorpAccountEngagement'; id: string; lastOrderedFrom?: string | null}
    | null;
};

export type ReceiptsQueryConsumerAccountFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  email: string;
  trackingId: string;
  canAccessConcur: boolean;
  isCorporate?: boolean | null;
  corpDeptCodesVisible?: boolean | null;
  concurAccount?: {
    __typename?: 'ConcurAccount';
    id: string;
    areReceiptsAutomated: boolean;
    createdAt: string;
    updatedAt: string;
  } | null;
  corporateAccount?: {
    __typename?: 'CorporateAccount';
    id: string;
    showCorpReferenceCodes?: boolean | null;
    corpReferenceCodes?: Array<{
      __typename?: 'CorporateReferenceCode';
      id: string;
      name: string;
      values: Array<string>;
      required: boolean;
    }> | null;
    corpDeptCodes?: Array<{
      __typename?: 'CorporateDepartment';
      id: string;
      name?: string | null;
      code?: string | null;
    }> | null;
  } | null;
  ownedCorporateAccounts?: Array<{__typename?: 'CorpAccount'; id: string}> | null;
};

export type ReceiptsQueryOrderFragment = {
  __typename?: 'OrderConnection';
  totalCount: number;
  totalCustomerSpend: {__typename?: 'Money'; currency: Currency; subunits: number};
  edges: Array<{
    __typename?: 'OrderEdge';
    node?: {
      __typename?: 'Order';
      id: string;
      uuid: string;
      formattedOrderNumber?: string | null;
      canBeReviewed?: boolean | null;
      isCorporate?: boolean | null;
      isPaymentPending?: boolean | null;
      hasCorpDeptCode?: boolean | null;
      concurOrderStatus?: ConcurOrderStatus | null;
      paidByUserId?: string | null;
      caterer?: {
        __typename?: 'Caterer';
        id: string;
        name: string;
        urlId: string;
        uuid: string;
        isSavedCaterer: boolean;
        brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
      } | null;
      customerOrderStatus?: {
        __typename?: 'CustomerOrderStatus';
        id: string;
        isCancelled?: boolean | null;
        currentStatusDisplay: string;
        isCustomerPaymentCaptured?: boolean | null;
      } | null;
      firstOrderReferenceCode?: {
        __typename?: 'OrderReferenceCode';
        id: string;
        corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
      } | null;
      review?: {
        __typename?: 'Review';
        id?: string | null;
        text?: string | null;
        rating?: StarRating | null;
        deliveryTimeFeedback?: DeliveryTimeFeedback | null;
        deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
        penName?: string | null;
      } | null;
      totals?: {
        __typename?: 'OrderTotals';
        customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      } | null;
      event?: {
        __typename?: 'Event';
        id: string;
        isTakeout: boolean;
        timestamp?: string | null;
        headcount?: number | null;
        address?: {
          __typename?: 'Address';
          id: string;
          nameOrLocation: string;
          street: string;
          street2?: string | null;
          city: string;
          state: string;
          zip?: string | null;
          latitude?: number | null;
          longitude?: number | null;
        } | null;
      } | null;
      orderReferenceCodes?: Array<{
        __typename?: 'OrderReferenceCode';
        id: string;
        name: string;
        value?: string | null;
        corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
      }> | null;
      corpAccount?: {__typename?: 'CorporateAccount'; id: string; name: string} | null;
      corporateDepartment?: {
        __typename?: 'CorporateDepartment';
        id: string;
        code?: string | null;
      } | null;
    } | null;
  }>;
};

export type RecentAddressesFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  recentAddresses?: {
    __typename?: 'AddressConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'AddressEdge';
      node?: {
        __typename?: 'Address';
        id: string;
        uuid: string;
        name?: string | null;
        street: string;
        street2?: string | null;
        city: string;
        state: string;
        zip?: string | null;
        fullAddress: string;
        addressBookEntryId?: number | null;
      } | null;
    }>;
  } | null;
};

export type RecommendedDefaultAddressFragment = {
  __typename?: 'GeocodedAddressResult';
  street: string;
  street2?: string | null;
  city: string;
  state: string;
  zip?: string | null;
  latitude?: number | null;
  longitude?: number | null;
};

export type RecommendedOrdersRecentAddressesFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  recentAddressesByLastUsed?: {
    __typename?: 'AddressConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'AddressEdge';
      node?: {
        __typename?: 'Address';
        id: string;
        city: string;
        latitude?: number | null;
        longitude?: number | null;
        state: string;
        street: string;
        street2?: string | null;
        uuid: string;
        zip?: string | null;
      } | null;
    }>;
  } | null;
};

export type ResendVerificationEmailFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  email: string;
  needsCorporateEmailVerification?: boolean | null;
};

export type ReviewableOrderFragment = {
  __typename?: 'Order';
  id: string;
  uuid: string;
  daysLeftToReview?: number | null;
  isReviewDeadlineApproaching?: boolean | null;
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    isSavedCaterer: boolean;
    uuid: string;
    name: string;
    brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
  } | null;
  review?: {
    __typename?: 'Review';
    id?: string | null;
    text?: string | null;
    rating?: StarRating | null;
    deliveryTimeFeedback?: DeliveryTimeFeedback | null;
    deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
    penName?: string | null;
  } | null;
  event?: {
    __typename?: 'Event';
    id: string;
    timestamp?: string | null;
    isTakeout: boolean;
    address?: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      city: string;
      state: string;
      nameOrLocation: string;
    } | null;
  } | null;
};

export type ReviewableOrdersFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  reviewableOrders?: {
    __typename?: 'OrderConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'OrderEdge';
      node?: {
        __typename?: 'Order';
        id: string;
        uuid: string;
        daysLeftToReview?: number | null;
        isReviewDeadlineApproaching?: boolean | null;
        caterer?: {
          __typename?: 'Caterer';
          id: string;
          isSavedCaterer: boolean;
          uuid: string;
          name: string;
          brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
        } | null;
        review?: {
          __typename?: 'Review';
          id?: string | null;
          text?: string | null;
          rating?: StarRating | null;
          deliveryTimeFeedback?: DeliveryTimeFeedback | null;
          deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
          penName?: string | null;
        } | null;
        event?: {
          __typename?: 'Event';
          id: string;
          timestamp?: string | null;
          isTakeout: boolean;
          address?: {
            __typename?: 'Address';
            id: string;
            name?: string | null;
            city: string;
            state: string;
            nameOrLocation: string;
          } | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type SavedCatererFragment = {
  __typename?: 'Caterer';
  id: string;
  uuid: string;
  name: string;
  isSavedCaterer: boolean;
  isReliabilityRockstar: boolean;
  isNew: boolean;
  urlId: string;
  starRating?: number | null;
  rewardsLevel?: number | null;
  address?: {__typename?: 'Address'; id: string; fullAddress: string} | null;
  minimumDeliveryFee: {
    __typename?: 'MinimumDeliveryFee';
    amount: {__typename?: 'Money'; subunits: number};
  };
  takeoutMinimum?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
  brand?: {
    __typename?: 'Brand';
    id: string;
    uuid: string;
    heroImage?: {__typename?: 'Image'; uuid: string; mobileSearchUrl?: string | null} | null;
  } | null;
};

export type SearchContinuityCardFragment = {
  __typename?: 'SearchContinuityCard';
  id: string;
  keyword?: string | null;
  cuisineOption?: string | null;
  url: string;
  eventAt?: string | null;
  eventName?: string | null;
  strategy: FulfillmentDetailStrategy;
  headcount?: number | null;
  image?: {__typename?: 'Image'; uuid: string; desktopHeroUrl?: string | null} | null;
  address?: {
    __typename?: 'Address';
    id: string;
    city: string;
    state: string;
    timeZoneIdentifier: string;
  } | null;
};

export type SearchPageFulfillmentDetailFragment = {
  __typename?: 'FulfillmentDetail';
  id: string;
  editable: boolean;
  eventAt?: string | null;
  eventLocalTime?: string | null;
  eventName?: string | null;
  eventOn?: string | null;
  headcount?: number | null;
  strategy: FulfillmentDetailStrategy;
  address: {
    __typename?: 'Address';
    id: string;
    name?: string | null;
    street: string;
    city: string;
    state: string;
    zip?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    fullAddress: string;
    metropolitanStatisticalArea?: string | null;
    timeZoneIdentifier: string;
  };
  corpAccount?: {
    __typename?: 'CorporateAccount';
    id: string;
    uuid: string;
    isParent?: boolean | null;
    name: string;
    displayName?: string | null;
    collectsAllEzRewards: boolean;
    logoIconUrl?: string | null;
    deliverySettings?: {
      __typename?: 'DeliverySettings';
      deliveryFeeCapEnabled: boolean;
      deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    } | null;
  } | null;
};

export type SearchResultFragment = {
  __typename?: 'CatererSearchResult';
  id: string;
  uuid: string;
  name: string;
  imageSrc?: string | null;
  urlId: string;
  distance: number;
  isNew: boolean;
  isSavedCaterer: boolean;
  isReliabilityRockstar: boolean;
  priceRating?: number | null;
  starRating?: number | null;
  topsortProductId: string;
  cacheKey: string;
  reviewCount: number;
  variableDeliveryFee?: boolean | null;
  onTimeRating?: number | null;
  lastOrderAt?: string | null;
  latestBrandReviewText?: string | null;
  latestBrandReviewAt?: string | null;
  latestReviewText?: string | null;
  latestReviewAt?: string | null;
  repeatUserRate?: number | null;
  rewardsLevel: number;
  sponsoredPromoTitles?: Array<string | null> | null;
  searchResultBrand: {
    __typename?: 'SearchResultBrand';
    id: string;
    uuid?: string | null;
    logoImageSrc?: string | null;
  };
  slotReservation:
    | {__typename?: 'NoReservation'}
    | {__typename?: 'SponsoredListingReservation'; topsortBidId?: string | null};
  deliveryMinimum: {__typename?: 'Money'; subunits: number; currency: Currency};
  deliveryFee: {__typename?: 'Money'; subunits: number; currency: Currency};
  takeoutMinimum?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
};

export type TotalsFragment = {
  __typename?: 'Order';
  id: string;
  totals?: {
    __typename?: 'OrderTotals';
    customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
    subTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    preDeliveryDiscountDeliveryFee?: {
      __typename?: 'Money';
      currency: Currency;
      subunits: number;
    } | null;
    preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
  } | null;
};

export type TrackingIdentityFragment = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {__typename?: 'ConsumerAccount'; id: string; email: string} | null;
  } | null;
};

export type UpcomingOrderFragment = {
  __typename?: 'Order';
  id: string;
  uuid: string;
  customerOrderStatus?: {
    __typename?: 'CustomerOrderStatus';
    id: string;
    isDraft: boolean;
    isPendingApproval: boolean;
  } | null;
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    name: string;
    urlId: string;
    address?: {__typename?: 'Address'; id: string; timeZoneIdentifier: string} | null;
  } | null;
  event?: {
    __typename?: 'Event';
    id: string;
    isTakeout: boolean;
    timestamp?: string | null;
    timeZoneIdentifier?: string | null;
    timeZoneOffset?: string | null;
    headcount?: number | null;
    estimatedHeadcount?: number | null;
    address?: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      street: string;
      timeZoneIdentifier: string;
    } | null;
  } | null;
  corpAccount?: {__typename?: 'CorporateAccount'; id: string; uuid: string; name: string} | null;
};

export type UpcomingOrdersFragment = {
  __typename?: 'ConsumerAccount';
  id: string;
  upcomingOrders?: {
    __typename?: 'OrderConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'OrderEdge';
      node?: {
        __typename?: 'Order';
        id: string;
        uuid: string;
        customerOrderStatus?: {
          __typename?: 'CustomerOrderStatus';
          id: string;
          isDraft: boolean;
          isPendingApproval: boolean;
        } | null;
        caterer?: {
          __typename?: 'Caterer';
          id: string;
          name: string;
          urlId: string;
          address?: {__typename?: 'Address'; id: string; timeZoneIdentifier: string} | null;
        } | null;
        event?: {
          __typename?: 'Event';
          id: string;
          isTakeout: boolean;
          timestamp?: string | null;
          timeZoneIdentifier?: string | null;
          timeZoneOffset?: string | null;
          headcount?: number | null;
          estimatedHeadcount?: number | null;
          address?: {
            __typename?: 'Address';
            id: string;
            name?: string | null;
            street: string;
            timeZoneIdentifier: string;
          } | null;
        } | null;
        corpAccount?: {
          __typename?: 'CorporateAccount';
          id: string;
          uuid: string;
          name: string;
        } | null;
      } | null;
    }>;
  } | null;
  draftOrders?: {__typename?: 'OrderConnection'; totalCount: number} | null;
  receiptOrders?: {__typename?: 'OrderConnection'; totalCount: number} | null;
};

export type AddressBookEntryCreateMutationVariables = Exact<{
  street1: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  driverAskFor?: InputMaybe<Scalars['String']['input']>;
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  geocoder?: InputMaybe<Scalars['String']['input']>;
  geocodePrecision?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddressBookEntryCreateMutation = {
  __typename?: 'Mutation';
  createNewAddressBookEntry?: {
    __typename?: 'CreateNewAddressBookEntryPayload';
    address?: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      driverAskFor?: string | null;
      deliveryInstructions?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      staticMapUrl?: string | null;
      addressBookEntryId?: number | null;
    } | null;
    proposedAddresses?: Array<{
      __typename?: 'ProposedAddress';
      street?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      geocoder?: string | null;
      geocodePrecision?: string | null;
    }> | null;
  } | null;
};

export type AddressBookEntryCreateFromRevisionMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  revisedAddressId: Scalars['ID']['input'];
}>;

export type AddressBookEntryCreateFromRevisionMutation = {
  __typename?: 'Mutation';
  createNewAddressBookEntryFromRevision?: {
    __typename?: 'CreateNewAddressBookEntryFromRevisionPayload';
    success: boolean;
  } | null;
};

export type AddressBookEntryDeleteMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;

export type AddressBookEntryDeleteMutation = {
  __typename?: 'Mutation';
  deleteAddressBookEntry?: {__typename?: 'DeleteAddressBookEntryPayload'; success: boolean} | null;
};

export type AddressBookEntryUpdateMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  street: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  driverAskFor?: InputMaybe<Scalars['String']['input']>;
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  skipGeocoding?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddressBookEntryUpdateMutation = {
  __typename?: 'Mutation';
  updateAddress?: {
    __typename?: 'UpdateAddressPayload';
    address?: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      phone?: string | null;
      driverAskFor?: string | null;
      deliveryInstructions?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      addressBookEntryId?: number | null;
      revision?: {
        __typename?: 'AddressRevision';
        id: string;
        revisionDeltas: Array<{
          __typename?: 'AddressRevisionDelta';
          field: string;
          currentValue?: JSONValue | null;
          newValue?: JSONValue | null;
        }>;
      } | null;
    } | null;
    proposedAddresses?: Array<{
      __typename?: 'ProposedAddress';
      street?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: string | null;
    }> | null;
  } | null;
};

export type AddressRevisionAcceptMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  revisedAddressId: Scalars['ID']['input'];
}>;

export type AddressRevisionAcceptMutation = {
  __typename?: 'Mutation';
  acceptAddressRevisions?: {__typename?: 'AcceptAddressRevisionsPayload'; success: boolean} | null;
};

export type AddressRevisionRejectMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;

export type AddressRevisionRejectMutation = {
  __typename?: 'Mutation';
  rejectAddressRevision?: {__typename?: 'RejectAddressRevisionPayload'; success: boolean} | null;
};

export type AllDraftOrdersDeleteMutationVariables = Exact<{[key: string]: never}>;

export type AllDraftOrdersDeleteMutation = {
  __typename?: 'Mutation';
  deleteAllDraftOrders?: {__typename?: 'DeleteAllDraftOrdersPayload'; success: boolean} | null;
};

export type AutomatedReceiptsToggleMutationVariables = Exact<{
  areReceiptsAutomated: Scalars['Boolean']['input'];
}>;

export type AutomatedReceiptsToggleMutation = {
  __typename?: 'Mutation';
  toggleConcurAutomatedReceipts?: {
    __typename?: 'ToggleConcurAutomatedReceiptsPayload';
    concurAccount: {__typename?: 'ConcurAccount'; id: string; areReceiptsAutomated: boolean};
  } | null;
};

export type CatererSaveMutationVariables = Exact<{
  brandId: Scalars['ID']['input'];
  catererId: Scalars['ID']['input'];
}>;

export type CatererSaveMutation = {
  __typename?: 'Mutation';
  catererSave?: {
    __typename?: 'CatererSavePayload';
    ezRewardsPointsGiven?: number | null;
    caterer?: {__typename?: 'Caterer'; id: string; isSavedCaterer: boolean; name: string} | null;
    userErrors: Array<
      | {__typename?: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename?: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type CatererUnsaveMutationVariables = Exact<{
  brandId: Scalars['ID']['input'];
  catererId: Scalars['ID']['input'];
}>;

export type CatererUnsaveMutation = {
  __typename?: 'Mutation';
  catererUnsave?: {
    __typename?: 'CatererUnsavePayload';
    caterer?: {__typename?: 'Caterer'; id: string; isSavedCaterer: boolean} | null;
    userErrors: Array<
      | {__typename?: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename?: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type ConsumerCartAddItemsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Array<ConsumerCartAddItemInput> | ConsumerCartAddItemInput;
  experience: ConsumerCartExperience;
}>;

export type ConsumerCartAddItemsMutation = {
  __typename?: 'Mutation';
  consumerCartAddItems?: {
    __typename?: 'ConsumerCartAddItemsPayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      currentUserAccessScopes: Array<InvitationAccessScope>;
      currentUserIsOwner: boolean;
      cutoffTime?: string | null;
      defaultTipExperimentVariant: string;
      experience: ConsumerCartExperience;
      formattedOrderNumber?: string | null;
      hasPunchout: boolean;
      isMissingDessert: boolean;
      isMissingDrinks: boolean;
      isModifiable?: boolean | null;
      isModification: boolean;
      isPunchoutEdit: boolean;
      modificationCutoffTime?: string | null;
      qualifiesForFreeDelivery: boolean;
      tippingAllowed: boolean;
      utensilsSelection: UtensilsSelectionEnum;
      fulfillmentDetail: {
        __typename?: 'FulfillmentDetail';
        id: string;
        customerMessages: Array<
          | {
              __typename: 'ConsumerCartItemsNotAvailable';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartItemsPastCutoff';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOrderMayBeDuplicate';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOverCorpSpendingLimit';
              enforce: boolean;
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'GenericCustomerMessage';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
        >;
      };
      authorizedUsers: Array<{
        __typename?: 'ConsumerCartAuthorizedUser';
        id: string;
        name: string;
        remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
      ezRewards: {
        __typename?: 'ConsumerCartEzRewards';
        bonusPointsEarnable: number;
        payableWithEzRewards: boolean;
        pointsEarnable: number;
        pointsToApply: number;
        maxDeductible: {
          __typename?: 'ConsumerCartDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
      };
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        invitationUrl: string;
        ownerName: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      items: Array<{
        __typename?: 'ConsumerCartItem';
        id: string;
        menuItemUuid?: string | null;
        name?: string | null;
        productCatalog?: ProductCatalog | null;
        quantity: number;
        serves?: number | null;
        size: string;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        options: Array<{
          __typename?: 'ConsumerCartItemOption';
          id: string;
          menuOptionUuid?: string | null;
          prefixLabel?: string | null;
          minimumChoicesAllowed?: number | null;
          maximumChoicesAllowed?: number | null;
          choices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            isGlutenFree: boolean;
            menuChoiceUuid?: string | null;
            name: string;
            subQuantityPercentage?: number | null;
          }>;
        }>;
        shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
        total: {__typename?: 'Money'; currency: Currency; subunits: number};
      }>;
      lineItems: Array<
        | {
            __typename?: 'DeliveryFeeLineItem';
            id: string;
            isThirdPartyDeliveryOnly: boolean;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'GenericLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'PromoLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            promoApplicationStatus: {
              __typename?: 'PromoApplicationStatus';
              id?: string | null;
              isSuccessfullyApplied: boolean;
              missingRequirements: string;
            };
          }
      >;
      orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
      pricePerHead: {
        __typename?: 'ConsumerCartPricePerHead';
        customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
        foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
      subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      freeTablewareItems: Array<{
        __typename?: 'ConsumerCartFreeTablewareItem';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
      tableware: {
        __typename?: 'ConsumerCartTableware';
        id: string;
        specialInstructions?: string | null;
        tablewareChoices: Array<{
          __typename?: 'ConsumerCartTablewareChoice';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
      };
      tip: {
        __typename?: 'ConsumerCartTip';
        percentage?: number | null;
        fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      };
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      promoCode?: {
        __typename?: 'PromoCode';
        id: string;
        code: string;
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          discountAmount?: number | null;
        };
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type CateringMenuConsumerCartAndFulfillmentDetailCreateMutationVariables = Exact<{
  input: ConsumerCartAndFulfillmentDetailCreateInput;
  catererId: Scalars['ID']['input'];
  catererUrlId?: InputMaybe<Scalars['ID']['input']>;
  experience: ConsumerCartExperience;
}>;

export type CateringMenuConsumerCartAndFulfillmentDetailCreateMutation = {
  __typename?: 'Mutation';
  consumerCartAndFulfillmentDetailCreate?: {
    __typename?: 'ConsumerCartAndFulfillmentDetailCreatePayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      currentUserAccessScopes: Array<InvitationAccessScope>;
      currentUserIsOwner: boolean;
      cutoffTime?: string | null;
      defaultTipExperimentVariant: string;
      experience: ConsumerCartExperience;
      formattedOrderNumber?: string | null;
      hasPunchout: boolean;
      isMissingDessert: boolean;
      isMissingDrinks: boolean;
      isModifiable?: boolean | null;
      isModification: boolean;
      isPunchoutEdit: boolean;
      modificationCutoffTime?: string | null;
      qualifiesForFreeDelivery: boolean;
      tippingAllowed: boolean;
      utensilsSelection: UtensilsSelectionEnum;
      fulfillmentDetail: {
        __typename?: 'FulfillmentDetail';
        id: string;
        editable: boolean;
        eventAt?: string | null;
        eventLocalTime?: string | null;
        eventName?: string | null;
        eventOn?: string | null;
        headcount?: number | null;
        strategy: FulfillmentDetailStrategy;
        corpAccount?: {
          __typename?: 'CorporateAccount';
          id: string;
          uuid: string;
          isParent?: boolean | null;
          name: string;
          displayName?: string | null;
          collectsAllEzRewards: boolean;
          logoIconUrl?: string | null;
          procurementSettings?: {
            __typename?: 'ProcurementSettings';
            cartEditsEnabled: boolean;
          } | null;
          deliverySettings?: {
            __typename?: 'DeliverySettings';
            deliveryFeeCapEnabled: boolean;
            deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          } | null;
        } | null;
        customerMessages: Array<
          | {
              __typename: 'ConsumerCartItemsNotAvailable';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartItemsPastCutoff';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOrderMayBeDuplicate';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOverCorpSpendingLimit';
              enforce: boolean;
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'GenericCustomerMessage';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
        >;
        address: {
          __typename?: 'Address';
          id: string;
          name?: string | null;
          street: string;
          city: string;
          state: string;
          zip?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          fullAddress: string;
          metropolitanStatisticalArea?: string | null;
          timeZoneIdentifier: string;
        };
      };
      authorizedUsers: Array<{
        __typename?: 'ConsumerCartAuthorizedUser';
        id: string;
        name: string;
        remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
      ezRewards: {
        __typename?: 'ConsumerCartEzRewards';
        bonusPointsEarnable: number;
        payableWithEzRewards: boolean;
        pointsEarnable: number;
        pointsToApply: number;
        maxDeductible: {
          __typename?: 'ConsumerCartDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
      };
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        invitationUrl: string;
        ownerName: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      items: Array<{
        __typename?: 'ConsumerCartItem';
        id: string;
        menuItemUuid?: string | null;
        name?: string | null;
        productCatalog?: ProductCatalog | null;
        quantity: number;
        serves?: number | null;
        size: string;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        options: Array<{
          __typename?: 'ConsumerCartItemOption';
          id: string;
          menuOptionUuid?: string | null;
          prefixLabel?: string | null;
          minimumChoicesAllowed?: number | null;
          maximumChoicesAllowed?: number | null;
          choices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            isGlutenFree: boolean;
            menuChoiceUuid?: string | null;
            name: string;
            subQuantityPercentage?: number | null;
          }>;
        }>;
        shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
        total: {__typename?: 'Money'; currency: Currency; subunits: number};
      }>;
      lineItems: Array<
        | {
            __typename?: 'DeliveryFeeLineItem';
            id: string;
            isThirdPartyDeliveryOnly: boolean;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'GenericLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'PromoLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            promoApplicationStatus: {
              __typename?: 'PromoApplicationStatus';
              id?: string | null;
              isSuccessfullyApplied: boolean;
              missingRequirements: string;
            };
          }
      >;
      orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
      pricePerHead: {
        __typename?: 'ConsumerCartPricePerHead';
        customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
        foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
      subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      freeTablewareItems: Array<{
        __typename?: 'ConsumerCartFreeTablewareItem';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
      tableware: {
        __typename?: 'ConsumerCartTableware';
        id: string;
        specialInstructions?: string | null;
        tablewareChoices: Array<{
          __typename?: 'ConsumerCartTablewareChoice';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
      };
      tip: {
        __typename?: 'ConsumerCartTip';
        percentage?: number | null;
        fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      };
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      promoCode?: {
        __typename?: 'PromoCode';
        id: string;
        code: string;
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          discountAmount?: number | null;
        };
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type CateringMenuConsumerCartCreateMutationVariables = Exact<{
  input: ConsumerCartCreateInput;
  catererId: Scalars['ID']['input'];
  fulfillmentDetailId: Scalars['ID']['input'];
}>;

export type CateringMenuConsumerCartCreateMutation = {
  __typename?: 'Mutation';
  consumerCartCreate?: {
    __typename?: 'ConsumerCartCreatePayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      currentUserAccessScopes: Array<InvitationAccessScope>;
      currentUserIsOwner: boolean;
      cutoffTime?: string | null;
      defaultTipExperimentVariant: string;
      experience: ConsumerCartExperience;
      formattedOrderNumber?: string | null;
      hasPunchout: boolean;
      isMissingDessert: boolean;
      isMissingDrinks: boolean;
      isModifiable?: boolean | null;
      isModification: boolean;
      isPunchoutEdit: boolean;
      modificationCutoffTime?: string | null;
      qualifiesForFreeDelivery: boolean;
      tippingAllowed: boolean;
      utensilsSelection: UtensilsSelectionEnum;
      fulfillmentDetail: {__typename?: 'FulfillmentDetail'; id: string};
      authorizedUsers: Array<{
        __typename?: 'ConsumerCartAuthorizedUser';
        id: string;
        name: string;
        remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
      ezRewards: {
        __typename?: 'ConsumerCartEzRewards';
        bonusPointsEarnable: number;
        payableWithEzRewards: boolean;
        pointsEarnable: number;
        pointsToApply: number;
        maxDeductible: {
          __typename?: 'ConsumerCartDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
      };
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        invitationUrl: string;
        ownerName: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      items: Array<{
        __typename?: 'ConsumerCartItem';
        id: string;
        menuItemUuid?: string | null;
        name?: string | null;
        productCatalog?: ProductCatalog | null;
        quantity: number;
        serves?: number | null;
        size: string;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        options: Array<{
          __typename?: 'ConsumerCartItemOption';
          id: string;
          menuOptionUuid?: string | null;
          prefixLabel?: string | null;
          minimumChoicesAllowed?: number | null;
          maximumChoicesAllowed?: number | null;
          choices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            isGlutenFree: boolean;
            menuChoiceUuid?: string | null;
            name: string;
            subQuantityPercentage?: number | null;
          }>;
        }>;
        shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
        total: {__typename?: 'Money'; currency: Currency; subunits: number};
      }>;
      lineItems: Array<
        | {
            __typename?: 'DeliveryFeeLineItem';
            id: string;
            isThirdPartyDeliveryOnly: boolean;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'GenericLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'PromoLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            promoApplicationStatus: {
              __typename?: 'PromoApplicationStatus';
              id?: string | null;
              isSuccessfullyApplied: boolean;
              missingRequirements: string;
            };
          }
      >;
      orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
      pricePerHead: {
        __typename?: 'ConsumerCartPricePerHead';
        customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
        foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
      subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      freeTablewareItems: Array<{
        __typename?: 'ConsumerCartFreeTablewareItem';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
      tableware: {
        __typename?: 'ConsumerCartTableware';
        id: string;
        specialInstructions?: string | null;
        tablewareChoices: Array<{
          __typename?: 'ConsumerCartTablewareChoice';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
      };
      tip: {
        __typename?: 'ConsumerCartTip';
        percentage?: number | null;
        fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      };
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      promoCode?: {
        __typename?: 'PromoCode';
        id: string;
        code: string;
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          discountAmount?: number | null;
        };
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type ConsumerCartRemoveItemsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Array<ConsumerCartRemoveItemInput> | ConsumerCartRemoveItemInput;
}>;

export type ConsumerCartRemoveItemsMutation = {
  __typename?: 'Mutation';
  consumerCartRemoveItems?: {
    __typename?: 'ConsumerCartRemoveItemsPayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      currentUserAccessScopes: Array<InvitationAccessScope>;
      currentUserIsOwner: boolean;
      cutoffTime?: string | null;
      defaultTipExperimentVariant: string;
      experience: ConsumerCartExperience;
      formattedOrderNumber?: string | null;
      hasPunchout: boolean;
      isMissingDessert: boolean;
      isMissingDrinks: boolean;
      isModifiable?: boolean | null;
      isModification: boolean;
      isPunchoutEdit: boolean;
      modificationCutoffTime?: string | null;
      qualifiesForFreeDelivery: boolean;
      tippingAllowed: boolean;
      utensilsSelection: UtensilsSelectionEnum;
      authorizedUsers: Array<{
        __typename?: 'ConsumerCartAuthorizedUser';
        id: string;
        name: string;
        remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
      ezRewards: {
        __typename?: 'ConsumerCartEzRewards';
        bonusPointsEarnable: number;
        payableWithEzRewards: boolean;
        pointsEarnable: number;
        pointsToApply: number;
        maxDeductible: {
          __typename?: 'ConsumerCartDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
      };
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        invitationUrl: string;
        ownerName: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      items: Array<{
        __typename?: 'ConsumerCartItem';
        id: string;
        menuItemUuid?: string | null;
        name?: string | null;
        productCatalog?: ProductCatalog | null;
        quantity: number;
        serves?: number | null;
        size: string;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        options: Array<{
          __typename?: 'ConsumerCartItemOption';
          id: string;
          menuOptionUuid?: string | null;
          prefixLabel?: string | null;
          minimumChoicesAllowed?: number | null;
          maximumChoicesAllowed?: number | null;
          choices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            isGlutenFree: boolean;
            menuChoiceUuid?: string | null;
            name: string;
            subQuantityPercentage?: number | null;
          }>;
        }>;
        shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
        total: {__typename?: 'Money'; currency: Currency; subunits: number};
      }>;
      lineItems: Array<
        | {
            __typename?: 'DeliveryFeeLineItem';
            id: string;
            isThirdPartyDeliveryOnly: boolean;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'GenericLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'PromoLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            promoApplicationStatus: {
              __typename?: 'PromoApplicationStatus';
              id?: string | null;
              isSuccessfullyApplied: boolean;
              missingRequirements: string;
            };
          }
      >;
      orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
      pricePerHead: {
        __typename?: 'ConsumerCartPricePerHead';
        customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
        foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
      subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      freeTablewareItems: Array<{
        __typename?: 'ConsumerCartFreeTablewareItem';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
      tableware: {
        __typename?: 'ConsumerCartTableware';
        id: string;
        specialInstructions?: string | null;
        tablewareChoices: Array<{
          __typename?: 'ConsumerCartTablewareChoice';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
      };
      tip: {
        __typename?: 'ConsumerCartTip';
        percentage?: number | null;
        fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      };
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      promoCode?: {
        __typename?: 'PromoCode';
        id: string;
        code: string;
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          discountAmount?: number | null;
        };
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type ConsumerCartUpdateItemsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Array<ConsumerCartUpdateItemInput> | ConsumerCartUpdateItemInput;
}>;

export type ConsumerCartUpdateItemsMutation = {
  __typename?: 'Mutation';
  consumerCartUpdateItems?: {
    __typename?: 'ConsumerCartUpdateItemsPayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      currentUserAccessScopes: Array<InvitationAccessScope>;
      currentUserIsOwner: boolean;
      cutoffTime?: string | null;
      defaultTipExperimentVariant: string;
      experience: ConsumerCartExperience;
      formattedOrderNumber?: string | null;
      hasPunchout: boolean;
      isMissingDessert: boolean;
      isMissingDrinks: boolean;
      isModifiable?: boolean | null;
      isModification: boolean;
      isPunchoutEdit: boolean;
      modificationCutoffTime?: string | null;
      qualifiesForFreeDelivery: boolean;
      tippingAllowed: boolean;
      utensilsSelection: UtensilsSelectionEnum;
      authorizedUsers: Array<{
        __typename?: 'ConsumerCartAuthorizedUser';
        id: string;
        name: string;
        remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
      ezRewards: {
        __typename?: 'ConsumerCartEzRewards';
        bonusPointsEarnable: number;
        payableWithEzRewards: boolean;
        pointsEarnable: number;
        pointsToApply: number;
        maxDeductible: {
          __typename?: 'ConsumerCartDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
      };
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        invitationUrl: string;
        ownerName: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      items: Array<{
        __typename?: 'ConsumerCartItem';
        id: string;
        menuItemUuid?: string | null;
        name?: string | null;
        productCatalog?: ProductCatalog | null;
        quantity: number;
        serves?: number | null;
        size: string;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        options: Array<{
          __typename?: 'ConsumerCartItemOption';
          id: string;
          menuOptionUuid?: string | null;
          prefixLabel?: string | null;
          minimumChoicesAllowed?: number | null;
          maximumChoicesAllowed?: number | null;
          choices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            isGlutenFree: boolean;
            menuChoiceUuid?: string | null;
            name: string;
            subQuantityPercentage?: number | null;
          }>;
        }>;
        shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
        total: {__typename?: 'Money'; currency: Currency; subunits: number};
      }>;
      lineItems: Array<
        | {
            __typename?: 'DeliveryFeeLineItem';
            id: string;
            isThirdPartyDeliveryOnly: boolean;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'GenericLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'PromoLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            promoApplicationStatus: {
              __typename?: 'PromoApplicationStatus';
              id?: string | null;
              isSuccessfullyApplied: boolean;
              missingRequirements: string;
            };
          }
      >;
      orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
      pricePerHead: {
        __typename?: 'ConsumerCartPricePerHead';
        customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
        foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
      subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      freeTablewareItems: Array<{
        __typename?: 'ConsumerCartFreeTablewareItem';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
      tableware: {
        __typename?: 'ConsumerCartTableware';
        id: string;
        specialInstructions?: string | null;
        tablewareChoices: Array<{
          __typename?: 'ConsumerCartTablewareChoice';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
      };
      tip: {
        __typename?: 'ConsumerCartTip';
        percentage?: number | null;
        fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      };
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      promoCode?: {
        __typename?: 'PromoCode';
        id: string;
        code: string;
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          discountAmount?: number | null;
        };
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type CateringMenuFulfillmentDetailCreateMutationVariables = Exact<{
  input: FulfillmentDetailCreateInput;
  catererUrlId?: InputMaybe<Scalars['ID']['input']>;
  experience: ConsumerCartExperience;
}>;

export type CateringMenuFulfillmentDetailCreateMutation = {
  __typename?: 'Mutation';
  fulfillmentDetailCreate?: {
    __typename?: 'FulfillmentDetailCreatePayload';
    fulfillmentDetail?: {
      __typename?: 'FulfillmentDetail';
      id: string;
      editable: boolean;
      eventAt?: string | null;
      eventLocalTime?: string | null;
      eventName?: string | null;
      eventOn?: string | null;
      headcount?: number | null;
      strategy: FulfillmentDetailStrategy;
      corpAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        uuid: string;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        collectsAllEzRewards: boolean;
        logoIconUrl?: string | null;
        procurementSettings?: {
          __typename?: 'ProcurementSettings';
          cartEditsEnabled: boolean;
        } | null;
        deliverySettings?: {
          __typename?: 'DeliverySettings';
          deliveryFeeCapEnabled: boolean;
          deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        } | null;
      } | null;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      address: {
        __typename?: 'Address';
        id: string;
        name?: string | null;
        street: string;
        city: string;
        state: string;
        zip?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        fullAddress: string;
        metropolitanStatisticalArea?: string | null;
        timeZoneIdentifier: string;
      };
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type CateringMenuFulfillmentDetailUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  consumerCartId?: InputMaybe<Scalars['ID']['input']>;
  input: FulfillmentDetailUpdateInput;
  catererUrlId?: InputMaybe<Scalars['ID']['input']>;
  experience: ConsumerCartExperience;
}>;

export type CateringMenuFulfillmentDetailUpdateMutation = {
  __typename?: 'Mutation';
  fulfillmentDetailUpdate?: {
    __typename?: 'FulfillmentDetailUpdatePayload';
    fulfillmentDetail?: {
      __typename?: 'FulfillmentDetail';
      id: string;
      editable: boolean;
      eventAt?: string | null;
      eventLocalTime?: string | null;
      eventName?: string | null;
      eventOn?: string | null;
      headcount?: number | null;
      strategy: FulfillmentDetailStrategy;
      corpAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        uuid: string;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        collectsAllEzRewards: boolean;
        logoIconUrl?: string | null;
        procurementSettings?: {
          __typename?: 'ProcurementSettings';
          cartEditsEnabled: boolean;
        } | null;
        deliverySettings?: {
          __typename?: 'DeliverySettings';
          deliveryFeeCapEnabled: boolean;
          deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        } | null;
      } | null;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      address: {
        __typename?: 'Address';
        id: string;
        name?: string | null;
        street: string;
        city: string;
        state: string;
        zip?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        fullAddress: string;
        metropolitanStatisticalArea?: string | null;
        timeZoneIdentifier: string;
      };
    } | null;
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      currentUserAccessScopes: Array<InvitationAccessScope>;
      currentUserIsOwner: boolean;
      cutoffTime?: string | null;
      defaultTipExperimentVariant: string;
      experience: ConsumerCartExperience;
      formattedOrderNumber?: string | null;
      hasPunchout: boolean;
      isMissingDessert: boolean;
      isMissingDrinks: boolean;
      isModifiable?: boolean | null;
      isModification: boolean;
      isPunchoutEdit: boolean;
      modificationCutoffTime?: string | null;
      qualifiesForFreeDelivery: boolean;
      tippingAllowed: boolean;
      utensilsSelection: UtensilsSelectionEnum;
      authorizedUsers: Array<{
        __typename?: 'ConsumerCartAuthorizedUser';
        id: string;
        name: string;
        remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
      ezRewards: {
        __typename?: 'ConsumerCartEzRewards';
        bonusPointsEarnable: number;
        payableWithEzRewards: boolean;
        pointsEarnable: number;
        pointsToApply: number;
        maxDeductible: {
          __typename?: 'ConsumerCartDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
      };
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        invitationUrl: string;
        ownerName: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      items: Array<{
        __typename?: 'ConsumerCartItem';
        id: string;
        menuItemUuid?: string | null;
        name?: string | null;
        productCatalog?: ProductCatalog | null;
        quantity: number;
        serves?: number | null;
        size: string;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        options: Array<{
          __typename?: 'ConsumerCartItemOption';
          id: string;
          menuOptionUuid?: string | null;
          prefixLabel?: string | null;
          minimumChoicesAllowed?: number | null;
          maximumChoicesAllowed?: number | null;
          choices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            isGlutenFree: boolean;
            menuChoiceUuid?: string | null;
            name: string;
            subQuantityPercentage?: number | null;
          }>;
        }>;
        shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
        total: {__typename?: 'Money'; currency: Currency; subunits: number};
      }>;
      lineItems: Array<
        | {
            __typename?: 'DeliveryFeeLineItem';
            id: string;
            isThirdPartyDeliveryOnly: boolean;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'GenericLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'PromoLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            promoApplicationStatus: {
              __typename?: 'PromoApplicationStatus';
              id?: string | null;
              isSuccessfullyApplied: boolean;
              missingRequirements: string;
            };
          }
      >;
      orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
      pricePerHead: {
        __typename?: 'ConsumerCartPricePerHead';
        customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
        foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
      subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      freeTablewareItems: Array<{
        __typename?: 'ConsumerCartFreeTablewareItem';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
      tableware: {
        __typename?: 'ConsumerCartTableware';
        id: string;
        specialInstructions?: string | null;
        tablewareChoices: Array<{
          __typename?: 'ConsumerCartTablewareChoice';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
      };
      tip: {
        __typename?: 'ConsumerCartTip';
        percentage?: number | null;
        fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      };
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      promoCode?: {
        __typename?: 'PromoCode';
        id: string;
        code: string;
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          discountAmount?: number | null;
        };
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityLocked'}
      | {__typename: 'EntityNotFound'}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type CheckoutConsumerCartUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ConsumerCartUpdateInput;
}>;

export type CheckoutConsumerCartUpdateMutation = {
  __typename?: 'Mutation';
  consumerCartUpdate?: {
    __typename?: 'ConsumerCartUpdatePayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      currentUserAccessScopes: Array<InvitationAccessScope>;
      currentUserIsOwner: boolean;
      defaultTipExperimentVariant: string;
      experience: ConsumerCartExperience;
      userCanAccessEzRewards: boolean;
      formattedOrderNumber?: string | null;
      hasPunchout: boolean;
      isMissingDessert: boolean;
      isMissingDrinks: boolean;
      isModification: boolean;
      isPunchoutEdit: boolean;
      qualifiesForFreeDelivery: boolean;
      tippingAllowed: boolean;
      utensilsSelection: UtensilsSelectionEnum;
      requiresProcurementCheckout: boolean;
      authorizedUsers: Array<{
        __typename?: 'ConsumerCartAuthorizedUser';
        id: string;
        name: string;
        remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      corporateOrderReferenceCodes: Array<{
        __typename?: 'OrderReferenceCode';
        id: string;
        name: string;
        value?: string | null;
      }>;
      corporateReferenceCodes: Array<{
        __typename?: 'CorporateReferenceCode';
        id: string;
        active: boolean;
        currentValue?: string | null;
        name: string;
        values: Array<string>;
        required: boolean;
        type: CorpCustomCheckoutFieldEntry;
        requiresCreditLine: boolean;
        procurement: boolean;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            missingItems: Array<{
              __typename?: 'ConsumerCartItem';
              id: string;
              name?: string | null;
            }>;
            missingChoices: Array<{
              __typename?: 'ConsumerCartItemOptionChoice';
              id: string;
              name: string;
            }>;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
      ezRewards: {
        __typename?: 'ConsumerCartEzRewards';
        bonusPointsEarnable: number;
        extraPointsToApply: number;
        payableWithEzRewards: boolean;
        pointsEarnable: number;
        pointsToApply: number;
        combined: {
          __typename?: 'ConsumerCartCombinedEzRewards';
          dollarsToApply: {__typename?: 'Money'; currency: Currency; subunits: number};
          totalRemaining: {
            __typename?: 'ConsumerCartTotalRemainingEzRewards';
            points: number;
            amount: {__typename?: 'Money'; currency: Currency; subunits: number};
          };
        };
        maxDeductible: {
          __typename?: 'ConsumerCartDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
          boosted: {
            __typename?: 'ConsumerCartBoostedDeductibleEzRewards';
            points: number;
            amount: {__typename?: 'Money'; currency: Currency; subunits: number};
          };
        };
      };
      fulfillmentDetail: {
        __typename?: 'FulfillmentDetail';
        id: string;
        deliverySetup: DeliverySetup;
        editable: boolean;
        eventAt?: string | null;
        eventLocalTime?: string | null;
        eventName?: string | null;
        eventOn?: string | null;
        headcount?: number | null;
        strategy: FulfillmentDetailStrategy;
        customerMessages: Array<
          | {
              __typename: 'ConsumerCartItemsNotAvailable';
              code: ConsumerCartCustomerMessageCode;
              message: string;
              missingItems: Array<{
                __typename?: 'ConsumerCartItem';
                id: string;
                name?: string | null;
              }>;
              missingChoices: Array<{
                __typename?: 'ConsumerCartItemOptionChoice';
                id: string;
                name: string;
              }>;
            }
          | {
              __typename: 'ConsumerCartItemsPastCutoff';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOrderMayBeDuplicate';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOverCorpSpendingLimit';
              enforce: boolean;
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'GenericCustomerMessage';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
        >;
        address: {
          __typename?: 'Address';
          id: string;
          deliveryInstructions?: string | null;
          driverAskFor?: string | null;
          phone?: string | null;
          staticMapUrl?: string | null;
          street2?: string | null;
          name?: string | null;
          street: string;
          city: string;
          state: string;
          zip?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          fullAddress: string;
          metropolitanStatisticalArea?: string | null;
          timeZoneIdentifier: string;
        };
        corpAccount?: {
          __typename?: 'CorporateAccount';
          id: string;
          uuid: string;
          isParent?: boolean | null;
          name: string;
          displayName?: string | null;
          collectsAllEzRewards: boolean;
          logoIconUrl?: string | null;
          procurementSettings?: {
            __typename?: 'ProcurementSettings';
            cartEditsEnabled: boolean;
            creditCardPaymentAllowed: boolean;
          } | null;
          deliverySettings?: {
            __typename?: 'DeliverySettings';
            deliveryFeeCapEnabled: boolean;
            deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          } | null;
        } | null;
      };
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        invitationUrl: string;
        ownerName: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      items: Array<{
        __typename?: 'ConsumerCartItem';
        id: string;
        menuItemUuid?: string | null;
        productCatalog?: ProductCatalog | null;
        name?: string | null;
        quantity: number;
        serves?: number | null;
        size: string;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        options: Array<{
          __typename?: 'ConsumerCartItemOption';
          id: string;
          menuOptionUuid?: string | null;
          prefixLabel?: string | null;
          choices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            isGlutenFree: boolean;
            menuChoiceUuid?: string | null;
            name: string;
            subQuantityPercentage?: number | null;
          }>;
        }>;
        shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
        total: {__typename?: 'Money'; currency: Currency; subunits: number};
      }>;
      lineItems: Array<
        | {
            __typename?: 'DeliveryFeeLineItem';
            id: string;
            isThirdPartyDeliveryOnly: boolean;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'GenericLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'PromoLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            promoApplicationStatus: {
              __typename?: 'PromoApplicationStatus';
              id?: string | null;
              isSuccessfullyApplied: boolean;
              missingRequirements: string;
            };
          }
      >;
      orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
      pricePerHead: {
        __typename?: 'ConsumerCartPricePerHead';
        customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
      subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      freeTablewareItems: Array<{
        __typename?: 'ConsumerCartFreeTablewareItem';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
      tableware: {
        __typename?: 'ConsumerCartTableware';
        id: string;
        specialInstructions?: string | null;
        tablewareChoices: Array<{
          __typename?: 'ConsumerCartTablewareChoice';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
      };
      tip: {
        __typename?: 'ConsumerCartTip';
        percentage?: number | null;
        fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      };
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      promoCode?: {
        __typename?: 'PromoCode';
        id: string;
        code: string;
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          discountAmount?: number | null;
        };
      } | null;
      user?: {__typename?: 'ConsumerCartUser'; id: string; fullName?: string | null} | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type ConcurDisconnectMutationVariables = Exact<{[key: string]: never}>;

export type ConcurDisconnectMutation = {
  __typename?: 'Mutation';
  disconnectFromConcur?: {__typename?: 'DisconnectFromConcurPayload'; success: boolean} | null;
};

export type ConsumerCartAttachPunchoutMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  punchoutId: Scalars['ID']['input'];
}>;

export type ConsumerCartAttachPunchoutMutation = {
  __typename?: 'Mutation';
  consumerCartAttachPunchout?: {
    __typename?: 'ConsumerCartAttachPunchoutPayload';
    consumerCart?: {__typename?: 'ConsumerCart'; id: string; hasPunchout: boolean} | null;
    userErrors: Array<{__typename: 'ValidationError'; message: string; path: Array<string>}>;
  } | null;
};

export type ConsumerCartDeleteMutationVariables = Exact<{
  consumerCartDeleteId: Scalars['ID']['input'];
}>;

export type ConsumerCartDeleteMutation = {
  __typename?: 'Mutation';
  consumerCartDelete?: {
    __typename?: 'ConsumerCartDeletePayload';
    userErrors: Array<{__typename?: 'EntityNotFound'; message: string; path: Array<string>}>;
  } | null;
};

export type ConsumerCartFinalizeModificationMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  forterToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ConsumerCartFinalizeModificationMutation = {
  __typename?: 'Mutation';
  consumerCartFinalizeModification?: {
    __typename?: 'ConsumerCartFinalizeModificationPayload';
    order?: {__typename?: 'Order'; id: string; uuid: string} | null;
    userErrors: Array<
      | {__typename: 'CheckoutError'; code: CheckoutErrorCode; message: string; path: Array<string>}
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type ConsumerCartGenerateInviteToPayLinkMutationVariables = Exact<{
  consumerCartId: Scalars['ID']['input'];
  input?: InputMaybe<ConsumerCartInviteUserToPayInput>;
}>;

export type ConsumerCartGenerateInviteToPayLinkMutation = {
  __typename?: 'Mutation';
  consumerCartInviteUserToPay?: {
    __typename?: 'ConsumerCartInviteUserToPayPayload';
    consumerCartInvitation?: {
      __typename?: 'ConsumerCartInvitation';
      id: string;
      invitationUrl?: string | null;
    } | null;
  } | null;
};

export type ConsumerCartGroupOrderUpsertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<ConsumerCartGroupOrderInput>;
}>;

export type ConsumerCartGroupOrderUpsertMutation = {
  __typename?: 'Mutation';
  consumerCartGroupOrderUpsert?: {
    __typename?: 'ConsumerCartGroupOrderUpsertPayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      cutoffTime?: string | null;
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        ownerName: string;
        invitationUrl: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      } | null;
    } | null;
    userErrors: Array<
      | {__typename?: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename?: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type ConsumerCartInvitationAcceptMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  accessCode: Scalars['String']['input'];
}>;

export type ConsumerCartInvitationAcceptMutation = {
  __typename?: 'Mutation';
  consumerCartInvitationAccept?: {
    __typename?: 'ConsumerCartInvitationAcceptPayload';
    consumerCart: {__typename?: 'ConsumerCart'; id: string};
  } | null;
};

export type ConsumerCartModificationCreateMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type ConsumerCartModificationCreateMutation = {
  __typename?: 'Mutation';
  consumerCartModificationCreate?: {
    __typename?: 'ConsumerCartModificationCreatePayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      fulfillmentDetail: {__typename?: 'FulfillmentDetail'; id: string};
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type ConsumerCartModificationDeleteMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type ConsumerCartModificationDeleteMutation = {
  __typename?: 'Mutation';
  consumerCartModificationDelete?: {
    __typename?: 'ConsumerCartModificationDeletePayload';
    id?: string | null;
    parentOrderId?: string | null;
    userErrors: Array<
      | {__typename?: 'EntityNotFound'; path: Array<string>; message: string}
      | {__typename?: 'ValidationError'; path: Array<string>; message: string}
    >;
  } | null;
};

export type ConsumerCartPaymentMethodUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ConsumerCartPaymentMethodUpdateInput;
  catererUrlId?: InputMaybe<Scalars['ID']['input']>;
  experience: ConsumerCartExperience;
}>;

export type ConsumerCartPaymentMethodUpdateMutation = {
  __typename?: 'Mutation';
  consumerCartPaymentMethodUpdate?: {
    __typename?: 'ConsumerCartPaymentMethodUpdatePayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      corporateReferenceCodes: Array<{
        __typename?: 'CorporateReferenceCode';
        id: string;
        active: boolean;
        currentValue?: string | null;
        name: string;
        values: Array<string>;
        required: boolean;
        type: CorpCustomCheckoutFieldEntry;
        requiresCreditLine: boolean;
        procurement: boolean;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      fulfillmentDetail: {
        __typename?: 'FulfillmentDetail';
        id: string;
        customerMessages: Array<
          | {
              __typename: 'ConsumerCartItemsNotAvailable';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartItemsPastCutoff';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOrderMayBeDuplicate';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOverCorpSpendingLimit';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'GenericCustomerMessage';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
        >;
      };
      paymentMethod?:
        | {
            __typename: 'CreditCard';
            id: string;
            cardholderName: string;
            cardType?: CardType | null;
            expMonth?: number | null;
            expYear?: number | null;
            isDefaultCard?: boolean | null;
            last4?: string | null;
            nickname?: string | null;
            zip?: string | null;
          }
        | {
            __typename: 'CreditLine';
            id: string;
            allowedUse: CreditLineAllowedUse;
            corpAccountName?: string | null;
          }
        | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type ConsumerCartSubmitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  marketingSmsOptin?: InputMaybe<Scalars['Boolean']['input']>;
  brandCommunicationOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  forterToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ConsumerCartSubmitMutation = {
  __typename?: 'Mutation';
  consumerCartSubmit?: {
    __typename?: 'ConsumerCartSubmitPayload';
    order?: {__typename?: 'Order'; id: string; uuid: string} | null;
    userErrors: Array<
      | {__typename: 'CheckoutError'; code: CheckoutErrorCode; message: string; path: Array<string>}
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type ConsumerCartUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ConsumerCartUpdateInput;
}>;

export type ConsumerCartUpdateMutation = {
  __typename?: 'Mutation';
  consumerCartUpdate?: {
    __typename?: 'ConsumerCartUpdatePayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      currentUserAccessScopes: Array<InvitationAccessScope>;
      currentUserIsOwner: boolean;
      cutoffTime?: string | null;
      defaultTipExperimentVariant: string;
      experience: ConsumerCartExperience;
      formattedOrderNumber?: string | null;
      hasPunchout: boolean;
      isMissingDessert: boolean;
      isMissingDrinks: boolean;
      isModifiable?: boolean | null;
      isModification: boolean;
      isPunchoutEdit: boolean;
      modificationCutoffTime?: string | null;
      qualifiesForFreeDelivery: boolean;
      tippingAllowed: boolean;
      utensilsSelection: UtensilsSelectionEnum;
      authorizedUsers: Array<{
        __typename?: 'ConsumerCartAuthorizedUser';
        id: string;
        name: string;
        remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
      ezRewards: {
        __typename?: 'ConsumerCartEzRewards';
        bonusPointsEarnable: number;
        payableWithEzRewards: boolean;
        pointsEarnable: number;
        pointsToApply: number;
        maxDeductible: {
          __typename?: 'ConsumerCartDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
      };
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        invitationUrl: string;
        ownerName: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      items: Array<{
        __typename?: 'ConsumerCartItem';
        id: string;
        menuItemUuid?: string | null;
        name?: string | null;
        productCatalog?: ProductCatalog | null;
        quantity: number;
        serves?: number | null;
        size: string;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        options: Array<{
          __typename?: 'ConsumerCartItemOption';
          id: string;
          menuOptionUuid?: string | null;
          prefixLabel?: string | null;
          minimumChoicesAllowed?: number | null;
          maximumChoicesAllowed?: number | null;
          choices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            isGlutenFree: boolean;
            menuChoiceUuid?: string | null;
            name: string;
            subQuantityPercentage?: number | null;
          }>;
        }>;
        shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
        total: {__typename?: 'Money'; currency: Currency; subunits: number};
      }>;
      lineItems: Array<
        | {
            __typename?: 'DeliveryFeeLineItem';
            id: string;
            isThirdPartyDeliveryOnly: boolean;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'GenericLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'PromoLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            promoApplicationStatus: {
              __typename?: 'PromoApplicationStatus';
              id?: string | null;
              isSuccessfullyApplied: boolean;
              missingRequirements: string;
            };
          }
      >;
      orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
      pricePerHead: {
        __typename?: 'ConsumerCartPricePerHead';
        customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
        foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
      subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      freeTablewareItems: Array<{
        __typename?: 'ConsumerCartFreeTablewareItem';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
      tableware: {
        __typename?: 'ConsumerCartTableware';
        id: string;
        specialInstructions?: string | null;
        tablewareChoices: Array<{
          __typename?: 'ConsumerCartTablewareChoice';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
      };
      tip: {
        __typename?: 'ConsumerCartTip';
        percentage?: number | null;
        fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      };
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      promoCode?: {
        __typename?: 'PromoCode';
        id: string;
        code: string;
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          discountAmount?: number | null;
        };
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type ConsumerCartUpdateEzRewardsPointsToApplyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ConsumerCartUpdateEzRewardsPointsToApplyInput;
}>;

export type ConsumerCartUpdateEzRewardsPointsToApplyMutation = {
  __typename?: 'Mutation';
  consumerCartUpdateEzRewardsPointsToApply?: {
    __typename?: 'ConsumerCartUpdateEzRewardsPointsToApplyPayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      currentUserAccessScopes: Array<InvitationAccessScope>;
      currentUserIsOwner: boolean;
      defaultTipExperimentVariant: string;
      experience: ConsumerCartExperience;
      userCanAccessEzRewards: boolean;
      formattedOrderNumber?: string | null;
      hasPunchout: boolean;
      isMissingDessert: boolean;
      isMissingDrinks: boolean;
      isModification: boolean;
      isPunchoutEdit: boolean;
      qualifiesForFreeDelivery: boolean;
      tippingAllowed: boolean;
      utensilsSelection: UtensilsSelectionEnum;
      requiresProcurementCheckout: boolean;
      authorizedUsers: Array<{
        __typename?: 'ConsumerCartAuthorizedUser';
        id: string;
        name: string;
        remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      corporateOrderReferenceCodes: Array<{
        __typename?: 'OrderReferenceCode';
        id: string;
        name: string;
        value?: string | null;
      }>;
      corporateReferenceCodes: Array<{
        __typename?: 'CorporateReferenceCode';
        id: string;
        active: boolean;
        currentValue?: string | null;
        name: string;
        values: Array<string>;
        required: boolean;
        type: CorpCustomCheckoutFieldEntry;
        requiresCreditLine: boolean;
        procurement: boolean;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            missingItems: Array<{
              __typename?: 'ConsumerCartItem';
              id: string;
              name?: string | null;
            }>;
            missingChoices: Array<{
              __typename?: 'ConsumerCartItemOptionChoice';
              id: string;
              name: string;
            }>;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
      ezRewards: {
        __typename?: 'ConsumerCartEzRewards';
        bonusPointsEarnable: number;
        extraPointsToApply: number;
        payableWithEzRewards: boolean;
        pointsEarnable: number;
        pointsToApply: number;
        combined: {
          __typename?: 'ConsumerCartCombinedEzRewards';
          dollarsToApply: {__typename?: 'Money'; currency: Currency; subunits: number};
          totalRemaining: {
            __typename?: 'ConsumerCartTotalRemainingEzRewards';
            points: number;
            amount: {__typename?: 'Money'; currency: Currency; subunits: number};
          };
        };
        maxDeductible: {
          __typename?: 'ConsumerCartDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
          boosted: {
            __typename?: 'ConsumerCartBoostedDeductibleEzRewards';
            points: number;
            amount: {__typename?: 'Money'; currency: Currency; subunits: number};
          };
        };
      };
      fulfillmentDetail: {
        __typename?: 'FulfillmentDetail';
        id: string;
        deliverySetup: DeliverySetup;
        editable: boolean;
        eventAt?: string | null;
        eventLocalTime?: string | null;
        eventName?: string | null;
        eventOn?: string | null;
        headcount?: number | null;
        strategy: FulfillmentDetailStrategy;
        customerMessages: Array<
          | {
              __typename: 'ConsumerCartItemsNotAvailable';
              code: ConsumerCartCustomerMessageCode;
              message: string;
              missingItems: Array<{
                __typename?: 'ConsumerCartItem';
                id: string;
                name?: string | null;
              }>;
              missingChoices: Array<{
                __typename?: 'ConsumerCartItemOptionChoice';
                id: string;
                name: string;
              }>;
            }
          | {
              __typename: 'ConsumerCartItemsPastCutoff';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOrderMayBeDuplicate';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOverCorpSpendingLimit';
              enforce: boolean;
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'GenericCustomerMessage';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
        >;
        address: {
          __typename?: 'Address';
          id: string;
          deliveryInstructions?: string | null;
          driverAskFor?: string | null;
          phone?: string | null;
          staticMapUrl?: string | null;
          street2?: string | null;
          name?: string | null;
          street: string;
          city: string;
          state: string;
          zip?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          fullAddress: string;
          metropolitanStatisticalArea?: string | null;
          timeZoneIdentifier: string;
        };
        corpAccount?: {
          __typename?: 'CorporateAccount';
          id: string;
          uuid: string;
          isParent?: boolean | null;
          name: string;
          displayName?: string | null;
          collectsAllEzRewards: boolean;
          logoIconUrl?: string | null;
          procurementSettings?: {
            __typename?: 'ProcurementSettings';
            cartEditsEnabled: boolean;
            creditCardPaymentAllowed: boolean;
          } | null;
          deliverySettings?: {
            __typename?: 'DeliverySettings';
            deliveryFeeCapEnabled: boolean;
            deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          } | null;
        } | null;
      };
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        invitationUrl: string;
        ownerName: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      items: Array<{
        __typename?: 'ConsumerCartItem';
        id: string;
        menuItemUuid?: string | null;
        productCatalog?: ProductCatalog | null;
        name?: string | null;
        quantity: number;
        serves?: number | null;
        size: string;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        options: Array<{
          __typename?: 'ConsumerCartItemOption';
          id: string;
          menuOptionUuid?: string | null;
          prefixLabel?: string | null;
          choices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            isGlutenFree: boolean;
            menuChoiceUuid?: string | null;
            name: string;
            subQuantityPercentage?: number | null;
          }>;
        }>;
        shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
        total: {__typename?: 'Money'; currency: Currency; subunits: number};
      }>;
      lineItems: Array<
        | {
            __typename?: 'DeliveryFeeLineItem';
            id: string;
            isThirdPartyDeliveryOnly: boolean;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'GenericLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'PromoLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            promoApplicationStatus: {
              __typename?: 'PromoApplicationStatus';
              id?: string | null;
              isSuccessfullyApplied: boolean;
              missingRequirements: string;
            };
          }
      >;
      orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
      pricePerHead: {
        __typename?: 'ConsumerCartPricePerHead';
        customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
      subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      freeTablewareItems: Array<{
        __typename?: 'ConsumerCartFreeTablewareItem';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
      tableware: {
        __typename?: 'ConsumerCartTableware';
        id: string;
        specialInstructions?: string | null;
        tablewareChoices: Array<{
          __typename?: 'ConsumerCartTablewareChoice';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
      };
      tip: {
        __typename?: 'ConsumerCartTip';
        percentage?: number | null;
        fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      };
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      promoCode?: {
        __typename?: 'PromoCode';
        id: string;
        code: string;
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          discountAmount?: number | null;
        };
      } | null;
      user?: {__typename?: 'ConsumerCartUser'; id: string; fullName?: string | null} | null;
    } | null;
    userErrors: Array<{__typename: 'ValidationError'; message: string; path: Array<string>}>;
  } | null;
};

export type ConsumerCartUpdateFreeTablewareMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Array<ConsumerCartFreeTablewareItemUpdateInput> | ConsumerCartFreeTablewareItemUpdateInput;
}>;

export type ConsumerCartUpdateFreeTablewareMutation = {
  __typename?: 'Mutation';
  consumerCartUpdateFreeTableware?: {
    __typename?: 'ConsumerCartUpdateFreeTablewarePayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      approvalDeadline?: string | null;
      currentUserAccessScopes: Array<InvitationAccessScope>;
      currentUserIsOwner: boolean;
      cutoffTime?: string | null;
      defaultTipExperimentVariant: string;
      experience: ConsumerCartExperience;
      formattedOrderNumber?: string | null;
      hasPunchout: boolean;
      isMissingDessert: boolean;
      isMissingDrinks: boolean;
      isModifiable?: boolean | null;
      isModification: boolean;
      isPunchoutEdit: boolean;
      modificationCutoffTime?: string | null;
      qualifiesForFreeDelivery: boolean;
      tippingAllowed: boolean;
      utensilsSelection: UtensilsSelectionEnum;
      authorizedUsers: Array<{
        __typename?: 'ConsumerCartAuthorizedUser';
        id: string;
        name: string;
        remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
      ezRewards: {
        __typename?: 'ConsumerCartEzRewards';
        bonusPointsEarnable: number;
        payableWithEzRewards: boolean;
        pointsEarnable: number;
        pointsToApply: number;
        maxDeductible: {
          __typename?: 'ConsumerCartDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
      };
      groupOrder?: {
        __typename?: 'GroupOrder';
        eventDate?: string | null;
        eventTime?: string | null;
        invitationUrl: string;
        ownerName: string;
        caterer: {__typename?: 'Caterer'; id: string; name: string};
        perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      items: Array<{
        __typename?: 'ConsumerCartItem';
        id: string;
        menuItemUuid?: string | null;
        name?: string | null;
        productCatalog?: ProductCatalog | null;
        quantity: number;
        serves?: number | null;
        size: string;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        options: Array<{
          __typename?: 'ConsumerCartItemOption';
          id: string;
          menuOptionUuid?: string | null;
          prefixLabel?: string | null;
          minimumChoicesAllowed?: number | null;
          maximumChoicesAllowed?: number | null;
          choices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            isGlutenFree: boolean;
            menuChoiceUuid?: string | null;
            name: string;
            subQuantityPercentage?: number | null;
          }>;
        }>;
        shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
        total: {__typename?: 'Money'; currency: Currency; subunits: number};
      }>;
      lineItems: Array<
        | {
            __typename?: 'DeliveryFeeLineItem';
            id: string;
            isThirdPartyDeliveryOnly: boolean;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'GenericLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          }
        | {
            __typename?: 'PromoLineItem';
            id: string;
            name: string;
            type?: ConsumerCartLineItemTypeEnum | null;
            cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            promoApplicationStatus: {
              __typename?: 'PromoApplicationStatus';
              id?: string | null;
              isSuccessfullyApplied: boolean;
              missingRequirements: string;
            };
          }
      >;
      orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
      pricePerHead: {
        __typename?: 'ConsumerCartPricePerHead';
        customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
        foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
      subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      freeTablewareItems: Array<{
        __typename?: 'ConsumerCartFreeTablewareItem';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
      tableware: {
        __typename?: 'ConsumerCartTableware';
        id: string;
        specialInstructions?: string | null;
        tablewareChoices: Array<{
          __typename?: 'ConsumerCartTablewareChoice';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
      };
      tip: {
        __typename?: 'ConsumerCartTip';
        percentage?: number | null;
        fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      };
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      promoCode?: {
        __typename?: 'PromoCode';
        id: string;
        code: string;
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          discountAmount?: number | null;
        };
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type CorpAccountAcceptInviteMutationVariables = Exact<{
  inviteId: Scalars['UUID']['input'];
  inviteToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type CorpAccountAcceptInviteMutation = {
  __typename?: 'Mutation';
  corpAccountAcceptInvite?: {
    __typename?: 'CorpAccountAcceptInvitePayload';
    redirectTo?: string | null;
    invite?: {__typename?: 'CorpInvite'; id: string} | null;
    userErrors: Array<
      | {__typename?: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename?: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type CorpAccountRejectInviteMutationVariables = Exact<{
  inviteId: Scalars['UUID']['input'];
  inviteToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type CorpAccountRejectInviteMutation = {
  __typename?: 'Mutation';
  corpAccountRejectInvite?: {
    __typename?: 'CorpAccountRejectInvitePayload';
    invite?: {__typename?: 'CorpInvite'; id: string} | null;
    userErrors: Array<
      | {__typename?: 'EntityNotFound'; message: string; path: Array<string>}
      | {__typename?: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type CreateFulfillmentDetailFromAddressMutationVariables = Exact<{
  input: FulfillmentDetailCreateInput;
}>;

export type CreateFulfillmentDetailFromAddressMutation = {
  __typename?: 'Mutation';
  fulfillmentDetailCreate?: {
    __typename?: 'FulfillmentDetailCreatePayload';
    fulfillmentDetail?: {__typename?: 'FulfillmentDetail'; id: string} | null;
  } | null;
};

export type CreateFulfillmentDetailMutationVariables = Exact<{
  input: FulfillmentDetailCreateInput;
}>;

export type CreateFulfillmentDetailMutation = {
  __typename?: 'Mutation';
  fulfillmentDetailCreate?: {
    __typename?: 'FulfillmentDetailCreatePayload';
    fulfillmentDetail?: {
      __typename?: 'FulfillmentDetail';
      id: string;
      editable: boolean;
      eventAt?: string | null;
      eventLocalTime?: string | null;
      eventName?: string | null;
      eventOn?: string | null;
      headcount?: number | null;
      strategy: FulfillmentDetailStrategy;
      address: {
        __typename?: 'Address';
        id: string;
        name?: string | null;
        street: string;
        city: string;
        state: string;
        zip?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        fullAddress: string;
        metropolitanStatisticalArea?: string | null;
        timeZoneIdentifier: string;
      };
      corpAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        uuid: string;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        collectsAllEzRewards: boolean;
        logoIconUrl?: string | null;
        deliverySettings?: {
          __typename?: 'DeliverySettings';
          deliveryFeeCapEnabled: boolean;
          deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        } | null;
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type CreateLegalRequestUploadUrlMutationVariables = Exact<{
  filename: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;

export type CreateLegalRequestUploadUrlMutation = {
  __typename?: 'Mutation';
  createLegalRequestUploadUrl?: {
    __typename?: 'CreateLegalRequestUploadUrlPayload';
    uploadUrl: string;
  } | null;
};

export type CreditCardAddMutationVariables = Exact<{
  cardholderName: Scalars['String']['input'];
  paymentMethodNonce: Scalars['String']['input'];
  deviceData?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  forterToken?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CreditCardAddSource>;
  makeDefault?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreditCardAddMutation = {
  __typename?: 'Mutation';
  addCreditCard?: {
    __typename?: 'AddCreditCardPayload';
    creditCard: {__typename?: 'CreditCard'; id: string};
  } | null;
};

export type CreditCardDeleteMutationVariables = Exact<{
  creditCardId: Scalars['ID']['input'];
}>;

export type CreditCardDeleteMutation = {
  __typename?: 'Mutation';
  deleteCreditCard?: {__typename?: 'DeleteCreditCardPayload'; success: boolean} | null;
};

export type CreditCardRemoveDefaultMutationVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type CreditCardRemoveDefaultMutation = {
  __typename?: 'Mutation';
  removeDefaultCreditCard?: {
    __typename?: 'RemoveDefaultCreditCardPayload';
    paymentMethods?: Array<
      | {__typename?: 'CreditCard'; id: string; isDefaultCard?: boolean | null}
      | {
          __typename?: 'CreditLine';
          id: string;
          allowedUse: CreditLineAllowedUse;
          isDefault?: boolean | null;
        }
      | null
    > | null;
  } | null;
};

export type CreditCardSetAsDefaultMutationVariables = Exact<{
  creditCardId: Scalars['ID']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type CreditCardSetAsDefaultMutation = {
  __typename?: 'Mutation';
  setAsDefaultCreditCard?: {
    __typename?: 'SetAsDefaultCreditCardPayload';
    creditCard: {__typename?: 'CreditCard'; id: string; isDefaultCard?: boolean | null};
    paymentMethods?: Array<
      | {__typename?: 'CreditCard'; id: string; isDefaultCard?: boolean | null}
      | {
          __typename?: 'CreditLine';
          id: string;
          allowedUse: CreditLineAllowedUse;
          isDefault?: boolean | null;
        }
      | null
    > | null;
  } | null;
};

export type ShareCreditCardMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
  shareTargets: Array<ShareTarget> | ShareTarget;
  shareWithAll?: InputMaybe<Scalars['Boolean']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ShareCreditCardMutation = {
  __typename?: 'Mutation';
  shareCreditCard?: {
    __typename?: 'ShareCreditCardPayload';
    success: boolean;
    creditCard: {
      __typename?: 'CreditCard';
      id: string;
      isSharedWithCorpAccount?: boolean | null;
      sharedWithCount?: number | null;
      usersSharedWith?: Array<{
        __typename?: 'PaymentShareUser';
        id: string;
        fullName: string;
      } | null> | null;
      departmentsSharedWith?: Array<{
        __typename?: 'CorporateDepartment';
        id: string;
        name?: string | null;
      } | null> | null;
    };
  } | null;
};

export type CreditCardUpdateMutationVariables = Exact<{
  cardholderName: Scalars['String']['input'];
  creditCardId: Scalars['ID']['input'];
  expMonth?: InputMaybe<Scalars['Int']['input']>;
  expYear?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CreditCardUpdateMutation = {
  __typename?: 'Mutation';
  updateCreditCard?: {
    __typename?: 'UpdateCreditCardPayload';
    creditCard: {
      __typename?: 'CreditCard';
      id: string;
      cardholderName: string;
      cardType?: CardType | null;
      isDefaultCard?: boolean | null;
      expMonth?: number | null;
      expYear?: number | null;
      last4?: string | null;
    };
    paymentMethods: Array<
      | {__typename?: 'CreditCard'; id: string; isDefaultCard?: boolean | null}
      | {__typename?: 'CreditLine'}
    >;
  } | null;
};

export type CreditCardUpdateWithNonceMutationVariables = Exact<{
  cardholderName: Scalars['String']['input'];
  creditCardId: Scalars['ID']['input'];
  deviceData?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  paymentMethodNonce?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreditCardUpdateWithNonceMutation = {
  __typename?: 'Mutation';
  updateCreditCard?: {
    __typename?: 'UpdateCreditCardPayload';
    creditCard: {
      __typename?: 'CreditCard';
      id: string;
      cardholderName: string;
      cardType?: CardType | null;
      isDefaultCard?: boolean | null;
      isExpired?: boolean | null;
      isExpiringSoon?: boolean | null;
      expMonth?: number | null;
      expYear?: number | null;
      last4?: string | null;
      nickname?: string | null;
    };
    paymentMethods: Array<
      | {
          __typename?: 'CreditCard';
          id: string;
          isDefaultCard?: boolean | null;
          isExpired?: boolean | null;
          isExpiringSoon?: boolean | null;
        }
      | {__typename?: 'CreditLine'}
    >;
  } | null;
};

export type DeleteRecentSearchMutationVariables = Exact<{
  fulfillmentDetailId: Scalars['ID']['input'];
}>;

export type DeleteRecentSearchMutation = {
  __typename?: 'Mutation';
  deleteRecentSearch?: {__typename?: 'DeleteRecentSearchPayload'; success: boolean} | null;
};

export type DirectConnectCancelAllRequestsMutationVariables = Exact<{
  input: CancelAllRequestsInput;
}>;

export type DirectConnectCancelAllRequestsMutation = {
  __typename?: 'Mutation';
  cancelAllRequests?: {
    __typename: 'CancelAllRequestsPayload';
    requests: Array<
      | {__typename: 'OrderItemChangeRequest'; id: string}
      | {__typename: 'TimeChangeRequest'; id: string}
    >;
  } | null;
};

export type DirectConnectRecordDecisionMutationVariables = Exact<{
  input: RecordDecisionInput;
}>;

export type DirectConnectRecordDecisionMutation = {
  __typename?: 'Mutation';
  recordDecision?: {
    __typename?: 'RecordDecisionPayload';
    decision: {
      __typename?: 'DecisionPoint';
      id: string;
      response?: boolean | null;
      responderType: ActorTypes;
      completedAt?: string | null;
    };
  } | null;
};

export type DirectConnectRecordMessageMutationVariables = Exact<{
  input: RecordMessageInput;
}>;

export type DirectConnectRecordMessageMutation = {
  __typename?: 'Mutation';
  recordMessage?: {
    __typename?: 'RecordMessagePayload';
    message: {
      __typename?: 'Message';
      id: string;
      content: string;
      sentByType: ActorTypes;
      sentById: string;
      messageStatus: MessageStatus;
      orderInfo: {
        __typename?: 'OrderInfo';
        id: string;
        brandName: string;
        cpMayRequestChange: boolean;
        custMayStartMessage: boolean;
        eventAt: string;
        isPickup: boolean;
        orderNumber: string;
        userUuid: string;
        activeMessageThread?: {__typename?: 'MessageThread'; id: string} | null;
      };
      request?:
        | {
            __typename?: 'OrderItemChangeRequest';
            id: string;
            orderInfo: {
              __typename?: 'OrderInfo';
              id: string;
              brandName: string;
              cpMayRequestChange: boolean;
              custMayStartMessage: boolean;
              eventAt: string;
              isPickup: boolean;
              orderNumber: string;
              userUuid: string;
              activeMessageThread?: {__typename?: 'MessageThread'; id: string} | null;
            };
          }
        | {
            __typename?: 'TimeChangeRequest';
            id: string;
            orderInfo: {
              __typename?: 'OrderInfo';
              id: string;
              brandName: string;
              cpMayRequestChange: boolean;
              custMayStartMessage: boolean;
              eventAt: string;
              isPickup: boolean;
              orderNumber: string;
              userUuid: string;
              activeMessageThread?: {__typename?: 'MessageThread'; id: string} | null;
            };
          }
        | null;
      failedContentFilters?: Array<{
        __typename?: 'FailedContentFilter';
        filterType: ContentFilterTypes;
      }> | null;
    };
  } | null;
};

export type DismissConcurEnterpriseToastMutationVariables = Exact<{[key: string]: never}>;

export type DismissConcurEnterpriseToastMutation = {
  __typename?: 'Mutation';
  dismissConcurEnterpriseToast?: {
    __typename?: 'DismissEnterpriseToastPayload';
    success: boolean;
  } | null;
};

export type DraftOrderDeleteMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type DraftOrderDeleteMutation = {
  __typename?: 'Mutation';
  deleteDraftOrder?: {__typename?: 'DeleteDraftOrderPayload'; success: boolean} | null;
};

export type EzRewardsEnrollmentMutationVariables = Exact<{
  isEnrolled: Scalars['Boolean']['input'];
}>;

export type EzRewardsEnrollmentMutation = {
  __typename?: 'Mutation';
  toggleEzRewardsEnrollment?: {
    __typename?: 'ToggleEzRewardsEnrollmentPayload';
    consumerAccount: {
      __typename?: 'ConsumerAccount';
      id: string;
      enrolledInEzRewards?: boolean | null;
    };
  } | null;
};

export type FulfillmentDetailUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: FulfillmentDetailUpdateInput;
}>;

export type FulfillmentDetailUpdateMutation = {
  __typename?: 'Mutation';
  fulfillmentDetailUpdate?: {
    __typename?: 'FulfillmentDetailUpdatePayload';
    fulfillmentDetail?: {
      __typename?: 'FulfillmentDetail';
      id: string;
      editable: boolean;
      eventAt?: string | null;
      eventLocalTime?: string | null;
      eventName?: string | null;
      eventOn?: string | null;
      headcount?: number | null;
      strategy: FulfillmentDetailStrategy;
      address: {
        __typename?: 'Address';
        id: string;
        name?: string | null;
        street: string;
        city: string;
        state: string;
        zip?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        fullAddress: string;
        metropolitanStatisticalArea?: string | null;
        timeZoneIdentifier: string;
      };
      corpAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        uuid: string;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        collectsAllEzRewards: boolean;
        logoIconUrl?: string | null;
        deliverySettings?: {
          __typename?: 'DeliverySettings';
          deliveryFeeCapEnabled: boolean;
          deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        } | null;
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityLocked'}
      | {__typename: 'EntityNotFound'}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type NotificationSubscriptionsUpdateMutationVariables = Exact<{
  deliveryUpdate?: InputMaybe<DeliveryUpdateNotificationSubscriptionsInput>;
  catererConfirmation?: InputMaybe<CatererConfirmationNotificationSubscriptionsInput>;
}>;

export type NotificationSubscriptionsUpdateMutation = {
  __typename?: 'Mutation';
  updateNotificationSubscriptions?: {
    __typename?: 'UpdateNotificationSubscriptionsPayload';
    consumerAccount: {
      __typename?: 'ConsumerAccount';
      id: string;
      notificationSubscriptions?: {
        __typename?: 'NotificationSubscriptions';
        deliveryUpdate?: {
          __typename?: 'DeliveryUpdateNotificationSubscriptions';
          txt?: boolean | null;
          email?: boolean | null;
          push?: boolean | null;
        } | null;
        catererConfirmation?: {
          __typename?: 'CatererConfirmationNotificationSubscriptions';
          email?: boolean | null;
        } | null;
      } | null;
    };
  } | null;
};

export type NotifyAdminsOfMissingPaymentMethodMutationVariables = Exact<{
  accountUuid: Scalars['UUID']['input'];
}>;

export type NotifyAdminsOfMissingPaymentMethodMutation = {
  __typename?: 'Mutation';
  notifyAdminsOfMissingPaymentMethod?: {
    __typename?: 'NotifyAdminsOfMissingPaymentMethodPayload';
    success: boolean;
  } | null;
};

export type OrderCancelMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  reason?: InputMaybe<CancelledByReasonEnum>;
  explanation?: InputMaybe<Scalars['String']['input']>;
}>;

export type OrderCancelMutation = {
  __typename?: 'Mutation';
  cancelOrder?: {
    __typename?: 'CancelOrderPayload';
    order: {__typename?: 'Order'; id: string};
  } | null;
};

export type OrderPaymentMethodUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  paymentMethod: PaymentMethodInputType;
  corporateOrderReferenceCodes?: InputMaybe<
    Array<OrderReferenceCodeInput> | OrderReferenceCodeInput
  >;
}>;

export type OrderPaymentMethodUpdateMutation = {
  __typename?: 'Mutation';
  orderPaymentMethodUpdate?: {
    __typename?: 'OrderPaymentMethodUpdatePayload';
    order?: {
      __typename?: 'Order';
      id: string;
      isMissingRequiredFullAuth: boolean;
      paymentMethod?:
        | {
            __typename: 'CreditCard';
            id: string;
            cardholderName: string;
            cardType?: CardType | null;
            expMonth?: number | null;
            expYear?: number | null;
            isDefaultCard?: boolean | null;
            last4?: string | null;
            missingZipCode: boolean;
            nickname?: string | null;
            zip?: string | null;
          }
        | {
            __typename: 'CreditLine';
            id: string;
            allowedUse: CreditLineAllowedUse;
            corpAccountName?: string | null;
          }
        | null;
      corporateOrderReferenceCodes?: Array<{
        __typename?: 'OrderReferenceCode';
        id: string;
        name: string;
        value?: string | null;
        corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
      }> | null;
      corporateReferenceCodes: Array<{
        __typename?: 'CorporateReferenceCode';
        id: string;
        active: boolean;
        currentValue?: string | null;
        name: string;
        procurement: boolean;
        required: boolean;
        requiresCreditLine: boolean;
        type: CorpCustomCheckoutFieldEntry;
        values: Array<string>;
      }>;
    } | null;
    userErrors: Array<
      | {__typename: 'PaymentAuthorizationError'; message: string; path: Array<string>}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type PersonalInformationUpdateMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email2?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<UserIndustryEnum>;
}>;

export type PersonalInformationUpdateMutation = {
  __typename?: 'Mutation';
  updatePersonalInfo?: {
    __typename?: 'UpdatePersonalInfoPayload';
    consumerAccount: {
      __typename?: 'ConsumerAccount';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      email: string;
      email2?: string | null;
      mobilePhoneLastTwo?: string | null;
      officePhoneLastTwo?: string | null;
      companyName?: string | null;
      jobTitle?: string | null;
      industry?: UserIndustryEnum | null;
      hasCompletedProfile: boolean;
    };
  } | null;
};

export type EzRewardsPointsRedeemMutationVariables = Exact<{
  amount: Scalars['Int']['input'];
}>;

export type EzRewardsPointsRedeemMutation = {
  __typename?: 'Mutation';
  redeemEzRewardsPoints?: {
    __typename?: 'RedeemEzRewardsPointsPayload';
    ezRewardsAccount: {__typename?: 'EzRewardsAccount'; id: string; balance?: number | null};
  } | null;
};

export type ReferFriendsMutationVariables = Exact<{
  emails: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;

export type ReferFriendsMutation = {
  __typename?: 'Mutation';
  referFriends?: {
    __typename?: 'ReferFriendsPayload';
    success: boolean;
    message?: string | null;
    responses?: Array<{
      __typename?: 'ReferralResponse';
      email: string;
      error?: string | null;
      status: ReferralAttemptStatus;
    }> | null;
  } | null;
};

export type ReorderFulfillmentDetailCreateMutationVariables = Exact<{
  input: FulfillmentDetailCreateInput;
}>;

export type ReorderFulfillmentDetailCreateMutation = {
  __typename?: 'Mutation';
  fulfillmentDetailCreate?: {
    __typename?: 'FulfillmentDetailCreatePayload';
    fulfillmentDetail?: {__typename?: 'FulfillmentDetail'; id: string} | null;
  } | null;
};

export type RequestTwoFactorAuthenticationCodeMutationVariables = Exact<{
  verificationMethod?: InputMaybe<TwoFactorVerificationMethod>;
}>;

export type RequestTwoFactorAuthenticationCodeMutation = {
  __typename?: 'Mutation';
  requestTwoFactorAuthenticationCode?: {
    __typename?: 'RequestTwoFactorAuthenticationCodePayload';
    success: boolean;
  } | null;
};

export type ResendVerificationEmailMutationVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ResendVerificationEmailMutation = {
  __typename?: 'Mutation';
  resendVerificationEmail?: {
    __typename?: 'ResendVerificationEmailPayload';
    success: boolean;
  } | null;
};

export type ReviewCreateMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  rating: StarRating;
  text: Scalars['String']['input'];
  deliveryTimeFeedback?: InputMaybe<DeliveryTimeFeedback>;
  deliveryProfessionalismFeedback?: InputMaybe<DeliveryProfessionalismFeedback>;
  penName: Scalars['String']['input'];
}>;

export type ReviewCreateMutation = {
  __typename?: 'Mutation';
  reviewOrder?: {__typename?: 'ReviewOrderPayload'; success: boolean; message: string} | null;
};

export type SaveRecentSearchMutationVariables = Exact<{
  fulfillmentDetailId: Scalars['ID']['input'];
  filter: RecentSearchParams;
}>;

export type SaveRecentSearchMutation = {
  __typename?: 'Mutation';
  saveRecentSearch?: {__typename?: 'SaveRecentSearchPayload'; success: boolean} | null;
};

export type SearchCreateMutationVariables = Exact<{
  input: FulfillmentDetailCreateInput;
}>;

export type SearchCreateMutation = {
  __typename?: 'Mutation';
  fulfillmentDetailCreate?: {
    __typename?: 'FulfillmentDetailCreatePayload';
    fulfillmentDetail?: {__typename?: 'FulfillmentDetail'; id: string} | null;
    userErrors: Array<
      | {__typename: 'EntityNotFound'}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type SendIosAppLinkMutationVariables = Exact<{
  source: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;

export type SendIosAppLinkMutation = {
  __typename?: 'Mutation';
  sendIosAppLink?: {
    __typename?: 'SendIosAppLinkPayload';
    message?: string | null;
    success: boolean;
  } | null;
};

export type SendReferralReminderMutationVariables = Exact<{
  referralId: Scalars['ID']['input'];
}>;

export type SendReferralReminderMutation = {
  __typename?: 'Mutation';
  sendReferralReminder?: {
    __typename?: 'SendReferralReminderPayload';
    referral: {
      __typename?: 'Referral';
      id: string;
      reminder?: {
        __typename?: 'ReferralReminder';
        id: string;
        type?: ReferralReminderTypeEnum | null;
        status?: ReferralReminderStatusTypeEnum | null;
      } | null;
    };
  } | null;
};

export type SendResetPasswordEmailMutationVariables = Exact<{[key: string]: never}>;

export type SendResetPasswordEmailMutation = {
  __typename?: 'Mutation';
  sendResetPasswordEmail?: {
    __typename?: 'SendResetPasswordEmailPayload';
    success: boolean;
    message: string;
  } | null;
};

export type SendToConcurMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type SendToConcurMutation = {
  __typename?: 'Mutation';
  sendReceiptToConcur?: {__typename?: 'SendReceiptToConcurPayload'; success: boolean} | null;
};

export type SetUserMobilePhoneMutationVariables = Exact<{
  mobilePhone: Scalars['String']['input'];
}>;

export type SetUserMobilePhoneMutation = {
  __typename?: 'Mutation';
  setUserMobilePhone?: {
    __typename?: 'SetUserMobilePhonePayload';
    consumerAccount: {__typename?: 'ConsumerAccount'; id: string; mobilePhone?: string | null};
  } | null;
};

export type SignOutUserMutationVariables = Exact<{[key: string]: never}>;

export type SignOutUserMutation = {
  __typename?: 'Mutation';
  signOutUser?: {
    __typename?: 'SignOutUserPayload';
    success: boolean;
    auth0LogoutUrl?: string | null;
  } | null;
};

export type SubmitContactUsFormMutationVariables = Exact<{
  fullName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;

export type SubmitContactUsFormMutation = {
  __typename?: 'Mutation';
  submitContactUsForm?: {__typename?: 'SubmitContactUsFormPayload'; success: boolean} | null;
};

export type SubmitDiscoveryHomeFeedbackMutationVariables = Exact<{
  rating: HomeFeedbackRating;
  reasons: Array<HomeFeedbackReason> | HomeFeedbackReason;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;

export type SubmitDiscoveryHomeFeedbackMutation = {
  __typename?: 'Mutation';
  submitHomeFeedback?: {__typename?: 'SubmitHomeFeedbackPayload'; success: boolean} | null;
};

export type SubmitFirstOrderFeedbackMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']['input']>;
  rating: StarRating;
  orderId: Scalars['ID']['input'];
}>;

export type SubmitFirstOrderFeedbackMutation = {
  __typename?: 'Mutation';
  submitFirstOrderFeedback?: {
    __typename?: 'SubmitFirstOrderFeedbackPayload';
    success: boolean;
  } | null;
};

export type SubmitLegalRequestMutationVariables = Exact<{
  input: LegalRequestInput;
}>;

export type SubmitLegalRequestMutation = {
  __typename?: 'Mutation';
  submitLegalRequest?: {
    __typename?: 'SubmitLegalRequestPayload';
    success: boolean;
    message?: string | null;
  } | null;
};

export type SubmitSelfReportedFulfillmentIssueMutationVariables = Exact<{
  additionalIssues: Array<AdditionalIssue> | AdditionalIssue;
  deliveryTimeSelection?: InputMaybe<DeliveryTimeSelection>;
  issuesDetailSelectionAdditionalDetails?: InputMaybe<Scalars['String']['input']>;
  issuesSelected: Array<IssueSelection> | IssueSelection;
  loggedInIssuesReviewAdditionalDetails?: InputMaybe<Scalars['String']['input']>;
  natureOfIssue: NatureOfIssue;
  orderId: Scalars['ID']['input'];
  somethingElseField?: InputMaybe<Scalars['String']['input']>;
}>;

export type SubmitSelfReportedFulfillmentIssueMutation = {
  __typename?: 'Mutation';
  submitSelfReportedFulfillmentIssue?: {
    __typename?: 'SubmitSelfReportedFulfillmentIssuePayload';
    success?: boolean | null;
  } | null;
};

export type SubmitSupportCaseMutationVariables = Exact<{
  input: SupportCaseInput;
}>;

export type SubmitSupportCaseMutation = {
  __typename?: 'Mutation';
  submitSupportCase?: {
    __typename?: 'SubmitSupportCasePayload';
    success: boolean;
    message?: SupportCaseFailureReason | null;
  } | null;
};

export type TrackPageViewMutationVariables = Exact<{
  pageName: Scalars['String']['input'];
  url: Scalars['String']['input'];
  referrerUrl: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
  catererId?: InputMaybe<Scalars['ID']['input']>;
  serverResponseTime?: InputMaybe<Scalars['Int']['input']>;
  pageInteractiveTime?: InputMaybe<Scalars['Int']['input']>;
  fulfillmentDetailId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TrackPageViewMutation = {
  __typename?: 'Mutation';
  trackPageView?: {__typename?: 'TrackPageViewPayload'; success: boolean} | null;
};

export type TrackTouchMutationVariables = Exact<{
  url: Scalars['String']['input'];
  referrerUrl?: InputMaybe<Scalars['String']['input']>;
}>;

export type TrackTouchMutation = {
  __typename?: 'Mutation';
  trackTouch?: {__typename?: 'TrackTouchPayload'; success: boolean} | null;
};

export type UpdateCheckoutFulfillmentDetailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  consumerCartId?: InputMaybe<Scalars['ID']['input']>;
  input: FulfillmentDetailUpdateInput;
}>;

export type UpdateCheckoutFulfillmentDetailMutation = {
  __typename?: 'Mutation';
  fulfillmentDetailUpdate?: {
    __typename?: 'FulfillmentDetailUpdatePayload';
    consumerCart?: {
      __typename?: 'ConsumerCart';
      id: string;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      fulfillmentDetail: {
        __typename?: 'FulfillmentDetail';
        id: string;
        deliverySetup: DeliverySetup;
        editable: boolean;
        eventAt?: string | null;
        eventLocalTime?: string | null;
        eventName?: string | null;
        eventOn?: string | null;
        headcount?: number | null;
        strategy: FulfillmentDetailStrategy;
        customerMessages: Array<
          | {
              __typename: 'ConsumerCartItemsNotAvailable';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartItemsPastCutoff';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOrderMayBeDuplicate';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOverCorpSpendingLimit';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'GenericCustomerMessage';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
        >;
        address: {
          __typename?: 'Address';
          id: string;
          deliveryInstructions?: string | null;
          driverAskFor?: string | null;
          phone?: string | null;
          staticMapUrl?: string | null;
          street2?: string | null;
          name?: string | null;
          street: string;
          city: string;
          state: string;
          zip?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          fullAddress: string;
          metropolitanStatisticalArea?: string | null;
          timeZoneIdentifier: string;
        };
        corpAccount?: {
          __typename?: 'CorporateAccount';
          id: string;
          uuid: string;
          isParent?: boolean | null;
          name: string;
          displayName?: string | null;
          collectsAllEzRewards: boolean;
          logoIconUrl?: string | null;
          procurementSettings?: {
            __typename?: 'ProcurementSettings';
            cartEditsEnabled: boolean;
            creditCardPaymentAllowed: boolean;
          } | null;
          deliverySettings?: {
            __typename?: 'DeliverySettings';
            deliveryFeeCapEnabled: boolean;
            deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          } | null;
        } | null;
      };
    } | null;
    userErrors: Array<
      | {__typename: 'EntityLocked'}
      | {__typename: 'EntityNotFound'}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type UpdateOrderCodesMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  orderReferenceCodes?: InputMaybe<
    Array<CreateOrderReferenceCodeInputType> | CreateOrderReferenceCodeInputType
  >;
  corpDeptCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateOrderCodesMutation = {
  __typename?: 'Mutation';
  updateOrderCodes?: {
    __typename?: 'UpdateOrderCodesPayload';
    success: boolean;
    order: {
      __typename?: 'Order';
      id: string;
      hasCorpDeptCode?: boolean | null;
      corporateOrderReferenceCodes?: Array<{
        __typename?: 'OrderReferenceCode';
        id: string;
        value?: string | null;
        corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
      }> | null;
      corporateDepartment?: {
        __typename?: 'CorporateDepartment';
        id: string;
        name?: string | null;
        code?: string | null;
      } | null;
    };
  } | null;
};

export type UpdateSearchFulfillmentDetailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: FulfillmentDetailUpdateInput;
}>;

export type UpdateSearchFulfillmentDetailMutation = {
  __typename?: 'Mutation';
  fulfillmentDetailUpdate?: {
    __typename?: 'FulfillmentDetailUpdatePayload';
    fulfillmentDetail?: {
      __typename?: 'FulfillmentDetail';
      id: string;
      editable: boolean;
      eventAt?: string | null;
      eventLocalTime?: string | null;
      eventName?: string | null;
      eventOn?: string | null;
      headcount?: number | null;
      strategy: FulfillmentDetailStrategy;
      address: {
        __typename?: 'Address';
        id: string;
        name?: string | null;
        street: string;
        city: string;
        state: string;
        zip?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        fullAddress: string;
        metropolitanStatisticalArea?: string | null;
        timeZoneIdentifier: string;
      };
      corpAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        uuid: string;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        collectsAllEzRewards: boolean;
        logoIconUrl?: string | null;
        deliverySettings?: {
          __typename?: 'DeliverySettings';
          deliveryFeeCapEnabled: boolean;
          deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        } | null;
      } | null;
    } | null;
    userErrors: Array<
      | {__typename: 'EntityLocked'}
      | {__typename: 'EntityNotFound'}
      | {__typename: 'ValidationError'; message: string; path: Array<string>}
    >;
  } | null;
};

export type UserConnectionsDisconnectMutationVariables = Exact<{
  userConnectionId: Scalars['UUID']['input'];
}>;

export type UserConnectionsDisconnectMutation = {
  __typename?: 'Mutation';
  userConnectionsDisconnect?: {
    __typename?: 'UserConnectionsDisconnectPayload';
    userErrors: Array<{__typename?: 'EntityNotFound'; message: string; path: Array<string>}>;
  } | null;
};

export type UserConnectionsInviteMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;

export type UserConnectionsInviteMutation = {
  __typename?: 'Mutation';
  userConnectionsInvite?: {
    __typename?: 'UserConnectionInvitationCreatePayload';
    userErrors: Array<{__typename?: 'EntityNotFound'; message: string; path: Array<string>}>;
  } | null;
};

export type UserConnectionInvitationAcceptMutationVariables = Exact<{
  userConnectionInvitationId: Scalars['ID']['input'];
}>;

export type UserConnectionInvitationAcceptMutation = {
  __typename?: 'Mutation';
  userConnectionsAcceptInvite?: {
    __typename?: 'UserConnectionInvitationAcceptPayload';
    userErrors: Array<{__typename?: 'EntityNotFound'; message: string; path: Array<string>}>;
  } | null;
};

export type UserConnectionInvitationIgnoreMutationVariables = Exact<{
  userConnectionInvitationId: Scalars['ID']['input'];
}>;

export type UserConnectionInvitationIgnoreMutation = {
  __typename?: 'Mutation';
  userConnectionsIgnoreInvite?: {
    __typename?: 'UserConnectionInvitationIgnorePayload';
    userErrors: Array<{__typename?: 'EntityNotFound'; message: string; path: Array<string>}>;
  } | null;
};

export type UserConnectionsToggleOrderNotificationsOverrideMutationVariables = Exact<{
  orderId: Scalars['UUID']['input'];
  isSubscribed: Scalars['Boolean']['input'];
}>;

export type UserConnectionsToggleOrderNotificationsOverrideMutation = {
  __typename?: 'Mutation';
  userConnectionsToggleOrderNotificationsOverride?: {
    __typename?: 'UserConnectionsToggleOrderNotificationsOverridePayload';
    userErrors: Array<{__typename?: 'EntityNotFound'; message: string; path: Array<string>}>;
  } | null;
};

export type UserConnectionsToggleOrderNotificationsSubscriptionMutationVariables = Exact<{
  userConnectionId: Scalars['UUID']['input'];
  isSubscribed: Scalars['Boolean']['input'];
}>;

export type UserConnectionsToggleOrderNotificationsSubscriptionMutation = {
  __typename?: 'Mutation';
  userConnectionsToggleOrderNotificationsSubscription?: {
    __typename?: 'UserConnectionsToggleOrderNotificationsSubscriptionPayload';
    userErrors: Array<{__typename?: 'EntityNotFound'; message: string; path: Array<string>}>;
  } | null;
};

export type UserDeleteMutationVariables = Exact<{
  verificationCode: Scalars['String']['input'];
}>;

export type UserDeleteMutation = {
  __typename?: 'Mutation';
  userDelete?: {__typename?: 'UserDeletePayload'; success: boolean} | null;
};

export type UserPasswordUpdateMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type UserPasswordUpdateMutation = {
  __typename?: 'Mutation';
  updateUserPassword?: {__typename?: 'UpdateUserPasswordPayload'; success: boolean} | null;
};

export type VerifyTwoFactorAuthenticationCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type VerifyTwoFactorAuthenticationCodeMutation = {
  __typename?: 'Mutation';
  verifyTwoFactorAuthenticationCode?: {
    __typename?: 'VerifyTwoFactorAuthenticationCodePayload';
    consumerAccount: {
      __typename?: 'ConsumerAccount';
      id: string;
      isCurrentDeviceRecognized?: boolean | null;
    };
  } | null;
};

export type AddressBookPageQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type AddressBookPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      canManageCorpAddresses: boolean;
      addresses?: {
        __typename?: 'AddressConnection';
        totalCount: number;
        nodes?: Array<{
          __typename?: 'Address';
          id: string;
          uuid: string;
          name?: string | null;
          street: string;
          street2?: string | null;
          city: string;
          state: string;
          zip?: string | null;
          fullAddress: string;
          addressBookEntryId?: number | null;
          addressBookEntry?: {
            __typename?: 'AddressBookEntry';
            id: string;
            corporate: boolean;
          } | null;
          orders?: {
            __typename?: 'OrderConnection';
            totalCount: number;
            nodes?: Array<{
              __typename?: 'Order';
              id: string;
              submittedAt?: string | null;
            } | null> | null;
          } | null;
        } | null> | null;
      } | null;
      corpAddresses?: {
        __typename?: 'AddressConnection';
        totalCount: number;
        nodes?: Array<{
          __typename?: 'Address';
          id: string;
          uuid: string;
          name?: string | null;
          street: string;
          street2?: string | null;
          city: string;
          state: string;
          zip?: string | null;
          fullAddress: string;
          addressBookEntryId?: number | null;
          addressBookEntry?: {
            __typename?: 'AddressBookEntry';
            id: string;
            corporate: boolean;
          } | null;
          orders?: {
            __typename?: 'OrderConnection';
            totalCount: number;
            nodes?: Array<{
              __typename?: 'Order';
              id: string;
              submittedAt?: string | null;
            } | null> | null;
          } | null;
        } | null> | null;
      } | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type AddressBookQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AddressFilterEnum>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type AddressBookQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      canManageCorpAddresses: boolean;
      addresses?: {
        __typename?: 'AddressConnection';
        totalCount: number;
        nodes?: Array<{
          __typename?: 'Address';
          id: string;
          uuid: string;
          name?: string | null;
          street: string;
          street2?: string | null;
          city: string;
          state: string;
          zip?: string | null;
          fullAddress: string;
          addressBookEntryId?: number | null;
          addressBookEntry?: {
            __typename?: 'AddressBookEntry';
            id: string;
            corporate: boolean;
          } | null;
          orders?: {
            __typename?: 'OrderConnection';
            totalCount: number;
            nodes?: Array<{
              __typename?: 'Order';
              id: string;
              submittedAt?: string | null;
            } | null> | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type AddressShowPageQueryVariables = Exact<{
  addressId: Scalars['ID']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type AddressShowPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      canManageCorpAddresses: boolean;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  address?: {
    __typename?: 'Address';
    id: string;
    uuid: string;
    name?: string | null;
    street: string;
    street2?: string | null;
    city: string;
    state: string;
    zip?: string | null;
    driverAskFor?: string | null;
    deliveryInstructions?: string | null;
    attendees?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    staticMapUrl?: string | null;
    addressBookEntryId?: number | null;
    addressBookEntry?: {__typename?: 'AddressBookEntry'; id: string; corporate: boolean} | null;
    revision?: {
      __typename?: 'AddressRevision';
      id: string;
      revisionDeltas: Array<{
        __typename?: 'AddressRevisionDelta';
        field: string;
        currentValue?: JSONValue | null;
        newValue?: JSONValue | null;
      }>;
    } | null;
    orders?: {__typename?: 'OrderConnection'; totalCount: number} | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type B2BOnboardingPageQueryVariables = Exact<{
  accountUuid: Scalars['UUID']['input'];
}>;

export type B2BOnboardingPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      email: string;
      firstName?: string | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        verifiedRegisteredCustomerMembershipCount: number;
        availableFeaturesForUser: Array<{
          __typename?: 'CorpAccountFeature';
          name: string;
          priority: number;
          enabled: boolean;
        }>;
      } | null;
    } | null;
  } | null;
};

export type BraintreeTokenQueryVariables = Exact<{[key: string]: never}>;

export type BraintreeTokenQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      braintreeClientToken?: string | null;
    } | null;
  } | null;
};

export type BrandsQueryVariables = Exact<{
  startsWith?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type BrandsQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  brands: {
    __typename?: 'BrandConnection';
    totalCount: number;
    nodes?: Array<{
      __typename?: 'Brand';
      id: string;
      uuid: string;
      name: string;
      urlId: string;
    } | null> | null;
  };
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type CateringMenuAlternateCaterersQueryVariables = Exact<{
  address: CatererSearchAddress;
  eventDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  eventTime?: InputMaybe<Scalars['TimeWithoutZone']['input']>;
  orderType?: InputMaybe<CatererSearchOrderType>;
}>;

export type CateringMenuAlternateCaterersQuery = {
  __typename?: 'Query';
  marketplaceSearchV2: {
    __typename?: 'MarketplaceSearchResults';
    id: string;
    caterers: {
      __typename?: 'CatererSearchConnection';
      id: string;
      nodes?: Array<{
        __typename?: 'CatererSearchResult';
        id: string;
        name: string;
        starRating?: number | null;
        reviewCount: number;
        urlId: string;
        imageSrc?: string | null;
        cacheKey: string;
      } | null> | null;
    };
  };
};

export type CateringMenuCartLookupByFulfillmentQueryVariables = Exact<{
  fulfillmentDetailId: Scalars['ID']['input'];
  filters?: InputMaybe<ConsumerCartFilterInput>;
  catererUrlId?: InputMaybe<Scalars['ID']['input']>;
  experience: ConsumerCartExperience;
}>;

export type CateringMenuCartLookupByFulfillmentQuery = {
  __typename?: 'Query';
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    consumerCarts?: {
      __typename?: 'ConsumerCartConnection';
      nodes?: Array<{
        __typename?: 'ConsumerCart';
        id: string;
        approvalDeadline?: string | null;
        currentUserAccessScopes: Array<InvitationAccessScope>;
        currentUserIsOwner: boolean;
        cutoffTime?: string | null;
        defaultTipExperimentVariant: string;
        experience: ConsumerCartExperience;
        formattedOrderNumber?: string | null;
        hasPunchout: boolean;
        isMissingDessert: boolean;
        isMissingDrinks: boolean;
        isModifiable?: boolean | null;
        isModification: boolean;
        isPunchoutEdit: boolean;
        modificationCutoffTime?: string | null;
        qualifiesForFreeDelivery: boolean;
        tippingAllowed: boolean;
        utensilsSelection: UtensilsSelectionEnum;
        fulfillmentDetail: {__typename?: 'FulfillmentDetail'; id: string};
        authorizedUsers: Array<{
          __typename?: 'ConsumerCartAuthorizedUser';
          id: string;
          name: string;
          remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        }>;
        customerMessages: Array<
          | {
              __typename: 'ConsumerCartItemsNotAvailable';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartItemsPastCutoff';
              code: ConsumerCartCustomerMessageCode;
              message: string;
              pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
            }
          | {
              __typename: 'ConsumerCartOrderMayBeDuplicate';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'ConsumerCartOverCorpSpendingLimit';
              enforce: boolean;
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
          | {
              __typename: 'GenericCustomerMessage';
              code: ConsumerCartCustomerMessageCode;
              message: string;
            }
        >;
        deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
        ezRewards: {
          __typename?: 'ConsumerCartEzRewards';
          bonusPointsEarnable: number;
          payableWithEzRewards: boolean;
          pointsEarnable: number;
          pointsToApply: number;
          maxDeductible: {
            __typename?: 'ConsumerCartDeductibleEzRewards';
            points: number;
            amount: {__typename?: 'Money'; currency: Currency; subunits: number};
          };
        };
        groupOrder?: {
          __typename?: 'GroupOrder';
          eventDate?: string | null;
          eventTime?: string | null;
          invitationUrl: string;
          ownerName: string;
          caterer: {__typename?: 'Caterer'; id: string; name: string};
          perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        } | null;
        items: Array<{
          __typename?: 'ConsumerCartItem';
          id: string;
          menuItemUuid?: string | null;
          name?: string | null;
          productCatalog?: ProductCatalog | null;
          quantity: number;
          serves?: number | null;
          size: string;
          specialInstructions?: string | null;
          vegetarianQuantity?: number | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifiers?: Array<{
                  __typename?: 'Modifier';
                  id: string;
                  name: string;
                  quantity: number;
                  supplierProductId?: string | null;
                  modifiers?: Array<{
                    __typename?: 'Modifier';
                    id: string;
                    name: string;
                    quantity: number;
                    supplierProductId?: string | null;
                    modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                    price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                  }> | null;
                  modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                }> | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          options: Array<{
            __typename?: 'ConsumerCartItemOption';
            id: string;
            menuOptionUuid?: string | null;
            prefixLabel?: string | null;
            minimumChoicesAllowed?: number | null;
            maximumChoicesAllowed?: number | null;
            choices: Array<{
              __typename?: 'ConsumerCartItemOptionChoice';
              id: string;
              isGlutenFree: boolean;
              menuChoiceUuid?: string | null;
              name: string;
              subQuantityPercentage?: number | null;
            }>;
          }>;
          shopper?: {
            __typename?: 'GroupOrderUser';
            id?: string | null;
            name?: string | null;
          } | null;
          total: {__typename?: 'Money'; currency: Currency; subunits: number};
        }>;
        lineItems: Array<
          | {
              __typename?: 'DeliveryFeeLineItem';
              id: string;
              isThirdPartyDeliveryOnly: boolean;
              name: string;
              type?: ConsumerCartLineItemTypeEnum | null;
              cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
              preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            }
          | {
              __typename?: 'GenericLineItem';
              id: string;
              name: string;
              type?: ConsumerCartLineItemTypeEnum | null;
              cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            }
          | {
              __typename?: 'PromoLineItem';
              id: string;
              name: string;
              type?: ConsumerCartLineItemTypeEnum | null;
              cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
              promoApplicationStatus: {
                __typename?: 'PromoApplicationStatus';
                id?: string | null;
                isSuccessfullyApplied: boolean;
                missingRequirements: string;
              };
            }
        >;
        orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
        pricePerHead: {
          __typename?: 'ConsumerCartPricePerHead';
          customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
          customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
          foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
        subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        freeTablewareItems: Array<{
          __typename?: 'ConsumerCartFreeTablewareItem';
          id: string;
          isIncluded: boolean;
          name: string;
        }>;
        tableware: {
          __typename?: 'ConsumerCartTableware';
          id: string;
          specialInstructions?: string | null;
          tablewareChoices: Array<{
            __typename?: 'ConsumerCartTablewareChoice';
            id: string;
            isIncluded: boolean;
            name: string;
          }>;
        };
        tip: {
          __typename?: 'ConsumerCartTip';
          percentage?: number | null;
          fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        };
        preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
        totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
        totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
        promoCode?: {
          __typename?: 'PromoCode';
          id: string;
          code: string;
          promo: {
            __typename?: 'Promo';
            id: string;
            title: string;
            description: string;
            finePrint?: string | null;
            discountAmount?: number | null;
          };
        } | null;
      } | null> | null;
    } | null;
  } | null;
  fulfillmentDetail?: {
    __typename?: 'FulfillmentDetail';
    id: string;
    editable: boolean;
    eventAt?: string | null;
    eventLocalTime?: string | null;
    eventName?: string | null;
    eventOn?: string | null;
    headcount?: number | null;
    strategy: FulfillmentDetailStrategy;
    corpAccount?: {
      __typename?: 'CorporateAccount';
      id: string;
      uuid: string;
      isParent?: boolean | null;
      name: string;
      displayName?: string | null;
      collectsAllEzRewards: boolean;
      logoIconUrl?: string | null;
      procurementSettings?: {__typename?: 'ProcurementSettings'; cartEditsEnabled: boolean} | null;
      deliverySettings?: {
        __typename?: 'DeliverySettings';
        deliveryFeeCapEnabled: boolean;
        deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
    } | null;
    customerMessages: Array<
      | {
          __typename: 'ConsumerCartItemsNotAvailable';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartItemsPastCutoff';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOrderMayBeDuplicate';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOverCorpSpendingLimit';
          enforce: boolean;
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'GenericCustomerMessage';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
    >;
    address: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      street: string;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      fullAddress: string;
      metropolitanStatisticalArea?: string | null;
      timeZoneIdentifier: string;
    };
  } | null;
};

export type CateringMenuCartLookupByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  catererUrlId?: InputMaybe<Scalars['ID']['input']>;
  experience: ConsumerCartExperience;
}>;

export type CateringMenuCartLookupByIdQuery = {
  __typename?: 'Query';
  consumerCart: {
    __typename?: 'ConsumerCart';
    id: string;
    approvalDeadline?: string | null;
    currentUserAccessScopes: Array<InvitationAccessScope>;
    currentUserIsOwner: boolean;
    cutoffTime?: string | null;
    defaultTipExperimentVariant: string;
    experience: ConsumerCartExperience;
    formattedOrderNumber?: string | null;
    hasPunchout: boolean;
    isMissingDessert: boolean;
    isMissingDrinks: boolean;
    isModifiable?: boolean | null;
    isModification: boolean;
    isPunchoutEdit: boolean;
    modificationCutoffTime?: string | null;
    qualifiesForFreeDelivery: boolean;
    tippingAllowed: boolean;
    utensilsSelection: UtensilsSelectionEnum;
    fulfillmentDetail: {
      __typename?: 'FulfillmentDetail';
      id: string;
      editable: boolean;
      eventAt?: string | null;
      eventLocalTime?: string | null;
      eventName?: string | null;
      eventOn?: string | null;
      headcount?: number | null;
      strategy: FulfillmentDetailStrategy;
      corpAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        uuid: string;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        collectsAllEzRewards: boolean;
        logoIconUrl?: string | null;
        procurementSettings?: {
          __typename?: 'ProcurementSettings';
          cartEditsEnabled: boolean;
        } | null;
        deliverySettings?: {
          __typename?: 'DeliverySettings';
          deliveryFeeCapEnabled: boolean;
          deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        } | null;
      } | null;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      address: {
        __typename?: 'Address';
        id: string;
        name?: string | null;
        street: string;
        city: string;
        state: string;
        zip?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        fullAddress: string;
        metropolitanStatisticalArea?: string | null;
        timeZoneIdentifier: string;
      };
    };
    authorizedUsers: Array<{
      __typename?: 'ConsumerCartAuthorizedUser';
      id: string;
      name: string;
      remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    }>;
    customerMessages: Array<
      | {
          __typename: 'ConsumerCartItemsNotAvailable';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartItemsPastCutoff';
          code: ConsumerCartCustomerMessageCode;
          message: string;
          pastCutoffItems: Array<{__typename?: 'ConsumerCartItem'; id: string}>;
        }
      | {
          __typename: 'ConsumerCartOrderMayBeDuplicate';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOverCorpSpendingLimit';
          enforce: boolean;
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'GenericCustomerMessage';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
    >;
    deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
    ezRewards: {
      __typename?: 'ConsumerCartEzRewards';
      bonusPointsEarnable: number;
      payableWithEzRewards: boolean;
      pointsEarnable: number;
      pointsToApply: number;
      maxDeductible: {
        __typename?: 'ConsumerCartDeductibleEzRewards';
        points: number;
        amount: {__typename?: 'Money'; currency: Currency; subunits: number};
      };
    };
    groupOrder?: {
      __typename?: 'GroupOrder';
      eventDate?: string | null;
      eventTime?: string | null;
      invitationUrl: string;
      ownerName: string;
      caterer: {__typename?: 'Caterer'; id: string; name: string};
      perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    } | null;
    items: Array<{
      __typename?: 'ConsumerCartItem';
      id: string;
      menuItemUuid?: string | null;
      name?: string | null;
      productCatalog?: ProductCatalog | null;
      quantity: number;
      serves?: number | null;
      size: string;
      specialInstructions?: string | null;
      vegetarianQuantity?: number | null;
      modifiers?: Array<{
        __typename?: 'Modifier';
        id: string;
        name: string;
        quantity: number;
        supplierProductId?: string | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
        price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      }> | null;
      options: Array<{
        __typename?: 'ConsumerCartItemOption';
        id: string;
        menuOptionUuid?: string | null;
        prefixLabel?: string | null;
        minimumChoicesAllowed?: number | null;
        maximumChoicesAllowed?: number | null;
        choices: Array<{
          __typename?: 'ConsumerCartItemOptionChoice';
          id: string;
          isGlutenFree: boolean;
          menuChoiceUuid?: string | null;
          name: string;
          subQuantityPercentage?: number | null;
        }>;
      }>;
      shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
      total: {__typename?: 'Money'; currency: Currency; subunits: number};
    }>;
    lineItems: Array<
      | {
          __typename?: 'DeliveryFeeLineItem';
          id: string;
          isThirdPartyDeliveryOnly: boolean;
          name: string;
          type?: ConsumerCartLineItemTypeEnum | null;
          cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        }
      | {
          __typename?: 'GenericLineItem';
          id: string;
          name: string;
          type?: ConsumerCartLineItemTypeEnum | null;
          cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        }
      | {
          __typename?: 'PromoLineItem';
          id: string;
          name: string;
          type?: ConsumerCartLineItemTypeEnum | null;
          cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          promoApplicationStatus: {
            __typename?: 'PromoApplicationStatus';
            id?: string | null;
            isSuccessfullyApplied: boolean;
            missingRequirements: string;
          };
        }
    >;
    orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
    pricePerHead: {
      __typename?: 'ConsumerCartPricePerHead';
      customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      customerTotalExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
      foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    };
    subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    freeTablewareItems: Array<{
      __typename?: 'ConsumerCartFreeTablewareItem';
      id: string;
      isIncluded: boolean;
      name: string;
    }>;
    tableware: {
      __typename?: 'ConsumerCartTableware';
      id: string;
      specialInstructions?: string | null;
      tablewareChoices: Array<{
        __typename?: 'ConsumerCartTablewareChoice';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
    };
    tip: {
      __typename?: 'ConsumerCartTip';
      percentage?: number | null;
      fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    };
    preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
    totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
    promoCode?: {
      __typename?: 'PromoCode';
      id: string;
      code: string;
      promo: {
        __typename?: 'Promo';
        id: string;
        title: string;
        description: string;
        finePrint?: string | null;
        discountAmount?: number | null;
      };
    } | null;
  };
};

export type CateringMenuCatererAboutUsQueryVariables = Exact<{
  catererUrlId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CateringMenuCatererAboutUsQuery = {
  __typename?: 'Query';
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    name: string;
    onEzCaterSince?: string | null;
    hasOtherLocations: boolean;
    cancellationFeeDescription?: string | null;
    hideStreetAddress: boolean;
    modificationPolicy: {__typename?: 'ModificationPolicy'; modificationCutoffHours: number};
    brand?: {__typename?: 'Brand'; id: string; description?: string | null; urlId: string} | null;
    storeHours?: {
      __typename?: 'CatererStoreHours';
      deliveryHoursDisplay?: string | null;
      takeoutHoursDisplay?: string | null;
    } | null;
    address?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip?: string | null;
    } | null;
    minimumDeliveryFee: {
      __typename?: 'MinimumDeliveryFee';
      isFixed: boolean;
      amount: {__typename?: 'Money'; currency: Currency; subunits: number};
      minimumOrderSubTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    };
    takeoutMinimum?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
  } | null;
};

export type CateringMenuCatererQueryVariables = Exact<{
  catererUrlId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CateringMenuCatererQuery = {
  __typename?: 'Query';
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    uuid: string;
    urlId: string;
    name: string;
    isSavedCaterer: boolean;
    tippingAllowed: boolean;
    rewardsLevel?: number | null;
    hideSpecialInstructions: boolean;
    hideStreetAddress: boolean;
    starRating?: number | null;
    reviewCount: number;
    shouldShowReviews: boolean;
    lastOrderAt?: string | null;
    hasDeliveryHours: boolean;
    hasTakeoutHours: boolean;
    hasOtherLocations: boolean;
    isReliabilityRockstar: boolean;
    isVisibleInStore: boolean;
    isVisibleInPrivateStore: boolean;
    hasGroupOrderingEnabled: boolean;
    address?: {
      __typename?: 'Address';
      id: string;
      street: string;
      state: string;
      stateName?: string | null;
      city: string;
      zip?: string | null;
      timeZoneIdentifier: string;
      latitude?: number | null;
      longitude?: number | null;
      fullAddress: string;
    } | null;
    brand?: {
      __typename?: 'Brand';
      id: string;
      uuid: string;
      urlId: string;
      logoUrl?: string | null;
      name: string;
      description?: string | null;
      heroImage?: {
        __typename?: 'Image';
        uuid: string;
        desktopHeroUrl?: string | null;
        mobileHeroUrl?: string | null;
        fullImagePath?: string | null;
      } | null;
      customStyle?: {
        __typename?: 'CustomStyle';
        id: string;
        primaryAccentColor?: string | null;
        primaryColor?: string | null;
        secondaryAccentColor?: string | null;
        secondaryColor?: string | null;
      } | null;
      customBranding?: {
        __typename?: 'CustomBranding';
        id: string;
        footerText?: string | null;
      } | null;
    } | null;
    minimumDeliveryFee: {
      __typename?: 'MinimumDeliveryFee';
      isFixed: boolean;
      amount: {__typename?: 'Money'; currency: Currency; subunits: number};
      minimumOrderSubTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    };
    takeoutMinimum?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    publicCatererFulfillmentReportCard?: {
      __typename?: 'PublicCatererFulfillmentReportCard';
      onTimeRating?: number | null;
    } | null;
    advanceNotice?:
      | {__typename: 'DayBeforeCutoffTime'; dayBeforeCutoffTime: number}
      | {__typename: 'LeadTime'; leadTimeInMinutes: number}
      | null;
    cuisineTypes?: Array<{__typename?: 'CatererCuisine'; id: string; name: string}> | null;
    sponsoredPromos?: Array<{
      __typename?: 'Promo';
      id: string;
      title: string;
      name?: string | null;
      discountAmount?: number | null;
      description: string;
      finePrint?: string | null;
      expiresOn?: string | null;
      weekdayOnly: boolean;
      termsAndConditionsUrl?: string | null;
      promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
    }> | null;
    publicTaxonomiesWithTaxons: Array<{
      __typename?: 'CatererTaxonomyWithTaxons';
      taxonomy: PublicTaxonomies;
      taxons: Array<string>;
    }>;
  } | null;
};

export type CateringMenuCatererReviewsQueryVariables = Exact<{
  catererUrlId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CateringMenuCatererReviewsQuery = {
  __typename?: 'Query';
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    name: string;
    reviews?: {
      __typename?: 'PublicReviewConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'PublicReviewEdge';
        node?: {
          __typename?: 'PublicReview';
          id?: string | null;
          text?: string | null;
          rating?: StarRating | null;
          penName?: string | null;
          catererId?: string | null;
          eventAt?: string | null;
          city?: string | null;
          state?: string | null;
        } | null;
      }>;
    } | null;
  } | null;
};

export type CateringMenuEzRewardsModalQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type CateringMenuEzRewardsModalQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      isReviewPending: boolean;
      giftCardRedemptionAllowed?: boolean | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        collectsAllEzRewards: boolean;
      } | null;
    } | null;
  } | null;
  constants?: {
    __typename?: 'Constants';
    ezRewards?: {
      __typename?: 'EzRewardsConstants';
      largestOutstandingUserBalance?: number | null;
    } | null;
  } | null;
};

export type CateringMenuFulfillmentDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  catererUrlId: Scalars['ID']['input'];
  experience: ConsumerCartExperience;
}>;

export type CateringMenuFulfillmentDetailQuery = {
  __typename?: 'Query';
  fulfillmentDetail?: {
    __typename?: 'FulfillmentDetail';
    id: string;
    editable: boolean;
    eventAt?: string | null;
    eventLocalTime?: string | null;
    eventName?: string | null;
    eventOn?: string | null;
    headcount?: number | null;
    strategy: FulfillmentDetailStrategy;
    corpAccount?: {
      __typename?: 'CorporateAccount';
      id: string;
      uuid: string;
      isParent?: boolean | null;
      name: string;
      displayName?: string | null;
      collectsAllEzRewards: boolean;
      logoIconUrl?: string | null;
      procurementSettings?: {__typename?: 'ProcurementSettings'; cartEditsEnabled: boolean} | null;
      deliverySettings?: {
        __typename?: 'DeliverySettings';
        deliveryFeeCapEnabled: boolean;
        deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
    } | null;
    customerMessages: Array<
      | {
          __typename: 'ConsumerCartItemsNotAvailable';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartItemsPastCutoff';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOrderMayBeDuplicate';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOverCorpSpendingLimit';
          enforce: boolean;
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'GenericCustomerMessage';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
    >;
    address: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      street: string;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      fullAddress: string;
      metropolitanStatisticalArea?: string | null;
      timeZoneIdentifier: string;
    };
  } | null;
};

export type CateringMenuOtherLocationsQueryVariables = Exact<{
  catererId: Scalars['ID']['input'];
  address: CatererSearchAddress;
  limit: Scalars['Int']['input'];
  shouldIncludeEzO: Scalars['Boolean']['input'];
  includeDistance: Scalars['Boolean']['input'];
}>;

export type CateringMenuOtherLocationsQuery = {
  __typename?: 'Query';
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    otherLocations?: {
      __typename?: 'CatererConnection';
      nodes?: Array<{
        __typename?: 'Caterer';
        id: string;
        urlId: string;
        hideStreetAddress: boolean;
        address?: {
          __typename?: 'Address';
          id: string;
          city: string;
          street: string;
          state: string;
        } | null;
      } | null> | null;
    };
    otherLocationsWithDistance?: Array<{
      __typename?: 'CatererLocationWithDistance';
      distanceMiles?: number | null;
      caterer: {
        __typename?: 'Caterer';
        id: string;
        uuid: string;
        urlId: string;
        name: string;
        hideStreetAddress: boolean;
        address?: {
          __typename?: 'Address';
          id: string;
          city: string;
          street: string;
          state: string;
        } | null;
      };
    }>;
  } | null;
};

export type CateringMenuPageQueryVariables = Exact<{
  catererUrlId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  channel: ChannelNameEnum;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
  includeMenuevoMenu?: InputMaybe<Scalars['Boolean']['input']>;
  menuevoChannel: MenuChannelInput;
  menuevoDate: Scalars['ISO8601Date']['input'];
}>;

export type CateringMenuPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    uuid: string;
    isVisibleInStore: boolean;
    isVisibleInPrivateStore: boolean;
    urlId: string;
    name: string;
    isSavedCaterer: boolean;
    tippingAllowed: boolean;
    rewardsLevel?: number | null;
    hideSpecialInstructions: boolean;
    hideStreetAddress: boolean;
    starRating?: number | null;
    reviewCount: number;
    shouldShowReviews: boolean;
    lastOrderAt?: string | null;
    hasDeliveryHours: boolean;
    hasTakeoutHours: boolean;
    hasOtherLocations: boolean;
    isReliabilityRockstar: boolean;
    hasGroupOrderingEnabled: boolean;
    onEzCaterSince?: string | null;
    cancellationFeeDescription?: string | null;
    menuForChannel?: {
      __typename?: 'Menu';
      id: string;
      uuid: string;
      serializedMenu?: {
        __typename?: 'SerializedMenu';
        id: string;
        stronglyTypedMenu?: JSONValue | null;
      } | null;
      disclaimers: Array<{__typename?: 'MenuDisclaimer'; key: MenuDisclaimerKey; text: string}>;
      contentSummary: {
        __typename?: 'MenuContentSummary';
        hasDrinks: boolean;
        hasDesserts: boolean;
        hasSides: boolean;
      };
    } | null;
    menuevoMenu?: {
      __typename?: 'MenuevoMenu';
      channel: MenuChannel;
      dietaryFlags: Array<MenuItemDietaryTag>;
      hasIndividuallyPackagedItems: boolean;
      id: string;
      categories: Array<{
        __typename?: 'MenuevoMenuCategory';
        description?: string | null;
        id: string;
        name: string;
        sortIndex: number;
        items: Array<{
          __typename?: 'MenuevoItemSummary';
          description?: string | null;
          id: string;
          imageUrl?: string | null;
          individualWrapStatus?: IndividualWrapStatus | null;
          hasModifierGroups: boolean;
          isPopular: boolean;
          minServes?: number | null;
          name: string;
          salesTaxCode?: string | null;
          servingSize?: number | null;
          sortIndex?: number | null;
          unit?: MenuevoUnit | null;
          advanceNotice?:
            | {__typename: 'CutoffTime'; cutoffTime: number}
            | {__typename: 'LeadTimeInMinutes'; leadTimeInMinutes: number}
            | null;
          calories?: {__typename?: 'CalorieRange'; max?: number | null; min: number} | null;
          dietaryFlags: {
            __typename?: 'DietaryFlags';
            isGlutenFree: boolean;
            isHalal: boolean;
            isKosher: boolean;
            isVegan: boolean;
            isVegetarian: boolean;
          };
          image?: {__typename?: 'MenuevoImage'; desktopUrl?: string | null} | null;
          minPrice: {
            __typename?: 'Money';
            currency: Currency;
            subunits: number;
            subunitsV2: string;
          };
          price: {__typename?: 'Money'; currency: Currency; subunits: number; subunitsV2: string};
          quantityRules?: {
            __typename?: 'MenuevoItemQuantityRules';
            increment: number;
            max?: number | null;
            min: number;
          } | null;
        }>;
      }>;
      freeTablewareItems: Array<{
        __typename?: 'MenuevoFreeTablewareItem';
        id: string;
        name: string;
      }>;
    } | null;
    address?: {
      __typename?: 'Address';
      id: string;
      street: string;
      state: string;
      stateName?: string | null;
      city: string;
      zip?: string | null;
      timeZoneIdentifier: string;
      latitude?: number | null;
      longitude?: number | null;
      fullAddress: string;
    } | null;
    brand?: {
      __typename?: 'Brand';
      id: string;
      uuid: string;
      urlId: string;
      logoUrl?: string | null;
      name: string;
      description?: string | null;
      heroImage?: {
        __typename?: 'Image';
        uuid: string;
        desktopHeroUrl?: string | null;
        mobileHeroUrl?: string | null;
        fullImagePath?: string | null;
      } | null;
      customStyle?: {
        __typename?: 'CustomStyle';
        id: string;
        primaryAccentColor?: string | null;
        primaryColor?: string | null;
        secondaryAccentColor?: string | null;
        secondaryColor?: string | null;
      } | null;
      customBranding?: {
        __typename?: 'CustomBranding';
        id: string;
        footerText?: string | null;
      } | null;
    } | null;
    minimumDeliveryFee: {
      __typename?: 'MinimumDeliveryFee';
      isFixed: boolean;
      amount: {__typename?: 'Money'; currency: Currency; subunits: number};
      minimumOrderSubTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    };
    takeoutMinimum?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    publicCatererFulfillmentReportCard?: {
      __typename?: 'PublicCatererFulfillmentReportCard';
      onTimeRating?: number | null;
    } | null;
    advanceNotice?:
      | {__typename: 'DayBeforeCutoffTime'; dayBeforeCutoffTime: number}
      | {__typename: 'LeadTime'; leadTimeInMinutes: number}
      | null;
    cuisineTypes?: Array<{__typename?: 'CatererCuisine'; id: string; name: string}> | null;
    sponsoredPromos?: Array<{
      __typename?: 'Promo';
      id: string;
      title: string;
      name?: string | null;
      discountAmount?: number | null;
      description: string;
      finePrint?: string | null;
      expiresOn?: string | null;
      weekdayOnly: boolean;
      termsAndConditionsUrl?: string | null;
      promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
    }> | null;
    publicTaxonomiesWithTaxons: Array<{
      __typename?: 'CatererTaxonomyWithTaxons';
      taxonomy: PublicTaxonomies;
      taxons: Array<string>;
    }>;
    modificationPolicy: {__typename?: 'ModificationPolicy'; modificationCutoffHours: number};
    storeHours?: {
      __typename?: 'CatererStoreHours';
      deliveryHoursDisplay?: string | null;
      takeoutHoursDisplay?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  graphExperiments?: {
    __typename?: 'GraphExperiments';
    deliveryFeeExperiment: {
      __typename?: 'DeliveryFeeExperimentVersions';
      v2?: {
        __typename?: 'DeliveryFeeExperimentAssignmentV2';
        flagKey: string;
        allocationKey: string;
        experimentKey: string;
        variation: string;
        pricingModel:
          | {
              __typename: 'CappedDeliveryFeePricingModel';
              cap: {__typename?: 'Money'; subunits: number; currency: Currency};
            }
          | {__typename: 'StandardDeliveryFeePricingModel'};
      } | null;
    };
  } | null;
};

export type CateringMenuQueryVariables = Exact<{
  catererUrlId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  channel: ChannelNameEnum;
  includeMenuevoMenu?: InputMaybe<Scalars['Boolean']['input']>;
  menuevoChannel: MenuChannelInput;
  menuevoDate: Scalars['ISO8601Date']['input'];
}>;

export type CateringMenuQuery = {
  __typename?: 'Query';
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    menuForChannel?: {
      __typename?: 'Menu';
      id: string;
      uuid: string;
      serializedMenu?: {
        __typename?: 'SerializedMenu';
        id: string;
        stronglyTypedMenu?: JSONValue | null;
      } | null;
      contentSummary: {
        __typename?: 'MenuContentSummary';
        hasDrinks: boolean;
        hasDesserts: boolean;
        hasSides: boolean;
      };
      disclaimers: Array<{__typename?: 'MenuDisclaimer'; key: MenuDisclaimerKey; text: string}>;
    } | null;
    menuevoMenu?: {
      __typename?: 'MenuevoMenu';
      channel: MenuChannel;
      dietaryFlags: Array<MenuItemDietaryTag>;
      hasIndividuallyPackagedItems: boolean;
      id: string;
      categories: Array<{
        __typename?: 'MenuevoMenuCategory';
        description?: string | null;
        id: string;
        name: string;
        sortIndex: number;
        items: Array<{
          __typename?: 'MenuevoItemSummary';
          description?: string | null;
          id: string;
          imageUrl?: string | null;
          individualWrapStatus?: IndividualWrapStatus | null;
          hasModifierGroups: boolean;
          isPopular: boolean;
          minServes?: number | null;
          name: string;
          salesTaxCode?: string | null;
          servingSize?: number | null;
          sortIndex?: number | null;
          unit?: MenuevoUnit | null;
          advanceNotice?:
            | {__typename: 'CutoffTime'; cutoffTime: number}
            | {__typename: 'LeadTimeInMinutes'; leadTimeInMinutes: number}
            | null;
          calories?: {__typename?: 'CalorieRange'; max?: number | null; min: number} | null;
          dietaryFlags: {
            __typename?: 'DietaryFlags';
            isGlutenFree: boolean;
            isHalal: boolean;
            isKosher: boolean;
            isVegan: boolean;
            isVegetarian: boolean;
          };
          image?: {__typename?: 'MenuevoImage'; desktopUrl?: string | null} | null;
          minPrice: {
            __typename?: 'Money';
            currency: Currency;
            subunits: number;
            subunitsV2: string;
          };
          price: {__typename?: 'Money'; currency: Currency; subunits: number; subunitsV2: string};
          quantityRules?: {
            __typename?: 'MenuevoItemQuantityRules';
            increment: number;
            max?: number | null;
            min: number;
          } | null;
        }>;
      }>;
      freeTablewareItems: Array<{
        __typename?: 'MenuevoFreeTablewareItem';
        id: string;
        name: string;
      }>;
    } | null;
  } | null;
};

export type CateringMenuSwitchCatererQueryVariables = Exact<{
  catererUrlId?: InputMaybe<Scalars['String']['input']>;
  orderAt: Scalars['DateTime']['input'];
}>;

export type CateringMenuSwitchCatererQuery = {
  __typename?: 'Query';
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    isDeliveryAvailable: boolean;
    isTakeoutAvailable: boolean;
    address?: {
      __typename?: 'Address';
      id: string;
      city: string;
      latitude?: number | null;
      longitude?: number | null;
      state: string;
      street: string;
    } | null;
  } | null;
};

export type CheckoutConsumerCartQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  paymentMethodsLimit: Scalars['Int']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type CheckoutConsumerCartQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  consumerCart: {
    __typename?: 'ConsumerCart';
    id: string;
    isTakeoutAvailable: boolean;
    isTaxExempt: boolean;
    paymentMethodUserId?: string | null;
    taxExemptionCertificateStatus: TaxExemptionCertificateStatus;
    approvalDeadline?: string | null;
    currentUserAccessScopes: Array<InvitationAccessScope>;
    currentUserIsOwner: boolean;
    defaultTipExperimentVariant: string;
    experience: ConsumerCartExperience;
    userCanAccessEzRewards: boolean;
    formattedOrderNumber?: string | null;
    hasPunchout: boolean;
    isMissingDessert: boolean;
    isMissingDrinks: boolean;
    isModification: boolean;
    isPunchoutEdit: boolean;
    qualifiesForFreeDelivery: boolean;
    tippingAllowed: boolean;
    utensilsSelection: UtensilsSelectionEnum;
    requiresProcurementCheckout: boolean;
    brandCommunication: {__typename?: 'BrandCommunication'; canOptIn: boolean};
    caterer: {
      __typename?: 'Caterer';
      id: string;
      name: string;
      tippingAllowed: boolean;
      urlId: string;
      address?: {
        __typename?: 'Address';
        id: string;
        city: string;
        name?: string | null;
        state: string;
        staticMapUrl?: string | null;
        street: string;
        street2?: string | null;
        timeZoneIdentifier: string;
        zip?: string | null;
      } | null;
      brand?: {__typename?: 'Brand'; id: string; logoUrl?: string | null; name: string} | null;
      cancellationPolicy?: {
        __typename?: 'CancellationPolicy';
        cancellationWindowHours: number;
        feePercentage: number;
      } | null;
    };
    customerMessages: Array<
      | {
          __typename: 'ConsumerCartItemsNotAvailable';
          code: ConsumerCartCustomerMessageCode;
          message: string;
          missingItems: Array<{__typename?: 'ConsumerCartItem'; id: string; name?: string | null}>;
          missingChoices: Array<{
            __typename?: 'ConsumerCartItemOptionChoice';
            id: string;
            name: string;
          }>;
        }
      | {
          __typename: 'ConsumerCartItemsPastCutoff';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOrderMayBeDuplicate';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'ConsumerCartOverCorpSpendingLimit';
          enforce: boolean;
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
      | {
          __typename: 'GenericCustomerMessage';
          code: ConsumerCartCustomerMessageCode;
          message: string;
        }
    >;
    fulfillmentDetail: {
      __typename?: 'FulfillmentDetail';
      id: string;
      deliverySetup: DeliverySetup;
      editable: boolean;
      eventAt?: string | null;
      eventLocalTime?: string | null;
      eventName?: string | null;
      eventOn?: string | null;
      headcount?: number | null;
      strategy: FulfillmentDetailStrategy;
      customerMessages: Array<
        | {
            __typename: 'ConsumerCartItemsNotAvailable';
            code: ConsumerCartCustomerMessageCode;
            message: string;
            missingItems: Array<{
              __typename?: 'ConsumerCartItem';
              id: string;
              name?: string | null;
            }>;
            missingChoices: Array<{
              __typename?: 'ConsumerCartItemOptionChoice';
              id: string;
              name: string;
            }>;
          }
        | {
            __typename: 'ConsumerCartItemsPastCutoff';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOrderMayBeDuplicate';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'ConsumerCartOverCorpSpendingLimit';
            enforce: boolean;
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
        | {
            __typename: 'GenericCustomerMessage';
            code: ConsumerCartCustomerMessageCode;
            message: string;
          }
      >;
      address: {
        __typename?: 'Address';
        id: string;
        deliveryInstructions?: string | null;
        driverAskFor?: string | null;
        phone?: string | null;
        staticMapUrl?: string | null;
        street2?: string | null;
        name?: string | null;
        street: string;
        city: string;
        state: string;
        zip?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        fullAddress: string;
        metropolitanStatisticalArea?: string | null;
        timeZoneIdentifier: string;
      };
      corpAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        uuid: string;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        collectsAllEzRewards: boolean;
        logoIconUrl?: string | null;
        procurementSettings?: {
          __typename?: 'ProcurementSettings';
          cartEditsEnabled: boolean;
          creditCardPaymentAllowed: boolean;
        } | null;
        deliverySettings?: {
          __typename?: 'DeliverySettings';
          deliveryFeeCapEnabled: boolean;
          deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        } | null;
      } | null;
    };
    paymentMethod?:
      | {
          __typename: 'CreditCard';
          id: string;
          cardholderName: string;
          cardType?: CardType | null;
          expMonth?: number | null;
          expYear?: number | null;
          isDefaultCard?: boolean | null;
          isExpired?: boolean | null;
          last4?: string | null;
          missingZipCode: boolean;
          nickname?: string | null;
          zip?: string | null;
          sharedBy?: {__typename?: 'ConsumerAccount'; id: string; email: string} | null;
        }
      | {
          __typename: 'CreditLine';
          id: string;
          allowedUse: CreditLineAllowedUse;
          corpAccountName?: string | null;
        }
      | null;
    promoCode?: {
      __typename?: 'PromoCode';
      id: string;
      code: string;
      promo: {
        __typename?: 'Promo';
        id: string;
        description: string;
        discountAmount?: number | null;
        finePrint?: string | null;
        title: string;
      };
    } | null;
    authorizedUsers: Array<{
      __typename?: 'ConsumerCartAuthorizedUser';
      id: string;
      name: string;
      remainingBudget?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    }>;
    corporateOrderReferenceCodes: Array<{
      __typename?: 'OrderReferenceCode';
      id: string;
      name: string;
      value?: string | null;
    }>;
    corporateReferenceCodes: Array<{
      __typename?: 'CorporateReferenceCode';
      id: string;
      active: boolean;
      currentValue?: string | null;
      name: string;
      values: Array<string>;
      required: boolean;
      type: CorpCustomCheckoutFieldEntry;
      requiresCreditLine: boolean;
      procurement: boolean;
    }>;
    deliveryFee: {__typename?: 'Money'; currency: Currency; subunits: number};
    ezRewards: {
      __typename?: 'ConsumerCartEzRewards';
      bonusPointsEarnable: number;
      extraPointsToApply: number;
      payableWithEzRewards: boolean;
      pointsEarnable: number;
      pointsToApply: number;
      combined: {
        __typename?: 'ConsumerCartCombinedEzRewards';
        dollarsToApply: {__typename?: 'Money'; currency: Currency; subunits: number};
        totalRemaining: {
          __typename?: 'ConsumerCartTotalRemainingEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
      };
      maxDeductible: {
        __typename?: 'ConsumerCartDeductibleEzRewards';
        points: number;
        amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        boosted: {
          __typename?: 'ConsumerCartBoostedDeductibleEzRewards';
          points: number;
          amount: {__typename?: 'Money'; currency: Currency; subunits: number};
        };
      };
    };
    groupOrder?: {
      __typename?: 'GroupOrder';
      eventDate?: string | null;
      eventTime?: string | null;
      invitationUrl: string;
      ownerName: string;
      caterer: {__typename?: 'Caterer'; id: string; name: string};
      perPersonBudget?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    } | null;
    items: Array<{
      __typename?: 'ConsumerCartItem';
      id: string;
      menuItemUuid?: string | null;
      productCatalog?: ProductCatalog | null;
      name?: string | null;
      quantity: number;
      serves?: number | null;
      size: string;
      specialInstructions?: string | null;
      vegetarianQuantity?: number | null;
      modifiers?: Array<{
        __typename?: 'Modifier';
        id: string;
        name: string;
        quantity: number;
        supplierProductId?: string | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
        price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      }> | null;
      options: Array<{
        __typename?: 'ConsumerCartItemOption';
        id: string;
        menuOptionUuid?: string | null;
        prefixLabel?: string | null;
        choices: Array<{
          __typename?: 'ConsumerCartItemOptionChoice';
          id: string;
          isGlutenFree: boolean;
          menuChoiceUuid?: string | null;
          name: string;
          subQuantityPercentage?: number | null;
        }>;
      }>;
      shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
      total: {__typename?: 'Money'; currency: Currency; subunits: number};
    }>;
    lineItems: Array<
      | {
          __typename?: 'DeliveryFeeLineItem';
          id: string;
          isThirdPartyDeliveryOnly: boolean;
          name: string;
          type?: ConsumerCartLineItemTypeEnum | null;
          cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          preCapCost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        }
      | {
          __typename?: 'GenericLineItem';
          id: string;
          name: string;
          type?: ConsumerCartLineItemTypeEnum | null;
          cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        }
      | {
          __typename?: 'PromoLineItem';
          id: string;
          name: string;
          type?: ConsumerCartLineItemTypeEnum | null;
          cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          promoApplicationStatus: {
            __typename?: 'PromoApplicationStatus';
            id?: string | null;
            isSuccessfullyApplied: boolean;
            missingRequirements: string;
          };
        }
    >;
    orderMinimum: {__typename?: 'Money'; currency: Currency; subunits: number};
    pricePerHead: {
      __typename?: 'ConsumerCartPricePerHead';
      customerTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      foodTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    };
    subtotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    freeTablewareItems: Array<{
      __typename?: 'ConsumerCartFreeTablewareItem';
      id: string;
      isIncluded: boolean;
      name: string;
    }>;
    tableware: {
      __typename?: 'ConsumerCartTableware';
      id: string;
      specialInstructions?: string | null;
      tablewareChoices: Array<{
        __typename?: 'ConsumerCartTablewareChoice';
        id: string;
        isIncluded: boolean;
        name: string;
      }>;
    };
    tip: {
      __typename?: 'ConsumerCartTip';
      percentage?: number | null;
      fixedAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    };
    preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
    totalDueExcludingTip: {__typename?: 'Money'; currency: Currency; subunits: number};
    user?: {__typename?: 'ConsumerCartUser'; id: string; fullName?: string | null} | null;
  };
  me?: {
    __typename?: 'Identity';
    id: string;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      mobilePhone?: string | null;
      braintreeClientToken?: string | null;
      showSmsOptIn: boolean;
      canManagePaymentMethods: boolean;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      paymentMethods?: {
        __typename?: 'PaymentMethodConnection';
        nodes?: Array<
          | {
              __typename: 'CreditCard';
              id: string;
              cardholderName: string;
              cardType?: CardType | null;
              expMonth?: number | null;
              expYear?: number | null;
              isDefaultCard?: boolean | null;
              last4?: string | null;
              missingZipCode: boolean;
              nickname?: string | null;
              sharedBy?: {__typename?: 'ConsumerAccount'; id: string; email: string} | null;
            }
          | {
              __typename: 'CreditLine';
              id: string;
              allowedUse: CreditLineAllowedUse;
              corpAccountName?: string | null;
            }
          | null
        > | null;
      } | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type CheckoutPaymentMethodsQueryVariables = Exact<{
  paymentMethodsLimit: Scalars['Int']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type CheckoutPaymentMethodsQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      canManagePaymentMethods: boolean;
      paymentMethods?: {
        __typename?: 'PaymentMethodConnection';
        nodes?: Array<
          | {
              __typename: 'CreditCard';
              id: string;
              cardholderName: string;
              cardType?: CardType | null;
              expMonth?: number | null;
              expYear?: number | null;
              isDefaultCard?: boolean | null;
              isExpired?: boolean | null;
              last4?: string | null;
              missingZipCode: boolean;
              nickname?: string | null;
              sharedBy?: {__typename?: 'ConsumerAccount'; id: string; email: string} | null;
            }
          | {
              __typename: 'CreditLine';
              id: string;
              allowedUse: CreditLineAllowedUse;
              corpAccountName?: string | null;
            }
          | null
        > | null;
      } | null;
    } | null;
  } | null;
};

export type ConcurQueryVariables = Exact<{
  eventAfter?: InputMaybe<Scalars['DateTime']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ConcurQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      canAccessConcur: boolean;
      canUpdateCorpPortal: boolean;
      concurLikeliness: ConcurLikeliness;
      concurEnterpriseUserStatus?: ConcurEnterpriseUserStatus | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        concurSettings: {
          __typename?: 'ConcurSettings';
          isEnabled: boolean;
          canEnableRosterSync: boolean;
        };
      } | null;
      concurAccount?: {
        __typename?: 'ConcurAccount';
        id: string;
        areReceiptsAutomated: boolean;
        createdAt: string;
        updatedAt: string;
      } | null;
      recentlyCompletedOrders?: {__typename?: 'OrderConnection'; totalCount: number} | null;
    } | null;
  } | null;
};

export type ConsumerCartOpenInvitationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ConsumerCartOpenInvitationsQuery = {
  __typename?: 'Query';
  consumerCart: {
    __typename?: 'ConsumerCart';
    id: string;
    openInvitations: Array<{
      __typename?: 'ConsumerCartInvitation';
      id: string;
      invitationUrl?: string | null;
      accessScope: Array<InvitationAccessScope>;
    }>;
  };
};

export type ConsumerCartRecommendationsQueryVariables = Exact<{
  orderUuid: Scalars['UUID']['input'];
}>;

export type ConsumerCartRecommendationsQuery = {
  __typename?: 'Query';
  recommendationsForOrder: Array<{
    __typename?: 'Recommendation';
    uuid: string;
    menuItem: {
      __typename?: 'MenuItem';
      id: string;
      uuid: string;
      name: string;
      description?: string | null;
      imageUrl?: string | null;
      isOrHasDessert: boolean;
      isOrHasDrink: boolean;
      sizes?: Array<{
        __typename?: 'MenuItemSize';
        size?: string | null;
        price?: number | null;
        serves?: number | null;
      } | null> | null;
    };
  }>;
};

export type ConsumerCartReorderQueryVariables = Exact<{
  date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
}>;

export type ConsumerCartReorderQuery = {
  __typename?: 'Query';
  consumerCartReorder: {
    __typename?: 'ConsumerCartReOrder';
    id: string;
    items: Array<{
      __typename?: 'ConsumerCartItem';
      id: string;
      menuItemUuid?: string | null;
      name?: string | null;
      productCatalog?: ProductCatalog | null;
      quantity: number;
      serves?: number | null;
      singleItemServes?: number | null;
      size: string;
      sizeLabel?: string | null;
      specialInstructions?: string | null;
      vegetarianQuantity?: number | null;
      total: {__typename?: 'Money'; currency: Currency; subunits: number; subunitsV2: string};
      modifiers?: Array<{
        __typename?: 'Modifier';
        id: string;
        name: string;
        quantity: number;
        supplierProductId?: string | null;
        modifiers?: Array<{
          __typename?: 'Modifier';
          id: string;
          name: string;
          quantity: number;
          supplierProductId?: string | null;
          modifiers?: Array<{
            __typename?: 'Modifier';
            id: string;
            name: string;
            quantity: number;
            supplierProductId?: string | null;
            modifiers?: Array<{
              __typename?: 'Modifier';
              id: string;
              name: string;
              quantity: number;
              supplierProductId?: string | null;
              modifiers?: Array<{
                __typename?: 'Modifier';
                id: string;
                name: string;
                quantity: number;
                supplierProductId?: string | null;
                modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              }> | null;
              modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            }> | null;
            modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          }> | null;
          modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        }> | null;
        modifierGroup: {__typename?: 'ModifierGroup'; id: string; name?: string | null};
        price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      }> | null;
      options: Array<{
        __typename?: 'ConsumerCartItemOption';
        id: string;
        menuOptionUuid?: string | null;
        prefixLabel?: string | null;
        minimumChoicesAllowed?: number | null;
        maximumChoicesAllowed?: number | null;
        choices: Array<{
          __typename?: 'ConsumerCartItemOptionChoice';
          id: string;
          menuChoiceUuid?: string | null;
          name: string;
          hideFromCustomer: boolean;
          isGlutenFree: boolean;
          subQuantityPercentage?: number | null;
          price: {__typename?: 'Money'; currency: Currency; subunits: number; subunitsV2: string};
        }>;
      }>;
    }>;
    address?: {__typename?: 'Address'; id: string; uuid: string} | null;
  };
};

export type ContactUsFormQueryVariables = Exact<{[key: string]: never}>;

export type ContactUsFormQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      fullName?: string | null;
      email: string;
      orders?: {
        __typename?: 'OrderConnection';
        nodes?: Array<{
          __typename?: 'Order';
          id: string;
          uuid: string;
          formattedOrderNumber?: string | null;
          event?: {
            __typename?: 'Event';
            id: string;
            timestamp?: string | null;
            timeZoneOffset?: string | null;
            address?: {__typename?: 'Address'; id: string; nameOrLocation: string} | null;
          } | null;
          caterer?: {__typename?: 'Caterer'; id: string; name: string} | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ContactUsModalQueryVariables = Exact<{[key: string]: never}>;

export type ContactUsModalQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      fullName?: string | null;
      email: string;
      orders?: {
        __typename?: 'OrderConnection';
        nodes?: Array<{
          __typename?: 'Order';
          id: string;
          uuid: string;
          formattedOrderNumber?: string | null;
          event?: {
            __typename?: 'Event';
            id: string;
            timestamp?: string | null;
            timeZoneOffset?: string | null;
            address?: {__typename?: 'Address'; id: string; nameOrLocation: string} | null;
          } | null;
          caterer?: {__typename?: 'Caterer'; id: string; name: string} | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ContinuityCardsQueryVariables = Exact<{[key: string]: never}>;

export type ContinuityCardsQuery = {
  __typename?: 'Query';
  continuityCards: Array<
    | {
        __typename: 'DraftOrderContinuityCard';
        id: string;
        catererName: string;
        itemCount: number;
        cutoffTime?: string | null;
        isGroupOrder: boolean;
        url: string;
        eventAt?: string | null;
        eventName?: string | null;
        strategy: FulfillmentDetailStrategy;
        headcount?: number | null;
        orderTotal: {__typename?: 'Money'; subunits: number};
        image?: {__typename?: 'Image'; uuid: string; desktopHeroUrl?: string | null} | null;
        address?: {
          __typename?: 'Address';
          id: string;
          city: string;
          state: string;
          timeZoneIdentifier: string;
        } | null;
      }
    | {
        __typename: 'SearchContinuityCard';
        id: string;
        keyword?: string | null;
        cuisineOption?: string | null;
        url: string;
        eventAt?: string | null;
        eventName?: string | null;
        strategy: FulfillmentDetailStrategy;
        headcount?: number | null;
        image?: {__typename?: 'Image'; uuid: string; desktopHeroUrl?: string | null} | null;
        address?: {
          __typename?: 'Address';
          id: string;
          city: string;
          state: string;
          timeZoneIdentifier: string;
        } | null;
      }
  >;
};

export type CorporateInvitePageQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
  inviteToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type CorporateInvitePageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      openCorpInvites: Array<{
        __typename?: 'CorpInvite';
        id: string;
        sourceImpliesConsent: boolean;
        sentByUser?: {__typename?: 'CorpInviteSender'; fullName: string} | null;
        corporateAccount: {
          __typename?: 'CorporateAccount';
          id: string;
          name: string;
          displayName?: string | null;
          logoIconUrl?: string | null;
          freeDeliveryThreshold?: number | null;
          verifiedRegisteredCustomerMembershipCount: number;
          familyParent: {__typename?: 'CorporateAccount'; id: string};
          availableFeaturesForUser: Array<{
            __typename?: 'CorpAccountFeature';
            name: string;
            priority: number;
            enabled: boolean;
          }>;
        };
        existingUnrelatedCorpAccount?: {
          __typename?: 'CorporateAccount';
          id: string;
          name: string;
          displayName?: string | null;
        } | null;
      }>;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type CreditCardDeleteConfirmationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type CreditCardDeleteConfirmationQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      creditCard?: {
        __typename?: 'CreditCard';
        id: string;
        deleteConfirmation?: {
          __typename?: 'CreditCardDeleteConfirmation';
          kind: CreditCardDeleteConfirmationKind;
          canDelete: boolean;
          title: string;
          body: string;
          confirmLabel?: string | null;
          cancelLabel: string;
          blockingOrders: Array<{
            __typename?: 'CreditCardBlockingOrder';
            id: string;
            uuid: string;
            orderNumber?: string | null;
            eventAt?: string | null;
            timeZoneIdentifier?: string | null;
            catererName?: string | null;
          }>;
          affectedTeammates: Array<{
            __typename?: 'CreditCardAffectedTeammate';
            fullName?: string | null;
            orderCount: number;
          }>;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CreditCardEditDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CreditCardEditDetailsQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      braintreeClientToken?: string | null;
      creditCard?: {
        __typename?: 'CreditCard';
        id: string;
        cardholderName: string;
        nickname?: string | null;
        cardType?: CardType | null;
        expMonth?: number | null;
        expYear?: number | null;
        last4?: string | null;
        zip?: string | null;
        isDefaultCard?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type ShareCreditCardDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ShareCreditCardDetailsQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        uuid: string;
        name: string;
      } | null;
      creditCard?: {
        __typename?: 'CreditCard';
        id: string;
        cardholderName: string;
        cardType?: CardType | null;
        expMonth?: number | null;
        expYear?: number | null;
        last4?: string | null;
        isSharedWithCorpAccount?: boolean | null;
        usersSharedWith?: Array<{
          __typename?: 'PaymentShareUser';
          id: string;
          fullName: string;
        } | null> | null;
        usersAvailableForSharing?: {
          __typename?: 'PaymentShareUserConnection';
          edges: Array<{
            __typename?: 'PaymentShareUserEdge';
            node?: {__typename?: 'PaymentShareUser'; id: string; fullName: string} | null;
          }>;
        } | null;
        departmentsSharedWith?: Array<{
          __typename?: 'CorporateDepartment';
          id: string;
          name?: string | null;
        } | null> | null;
        departmentsAvailableForSharing?: {
          __typename?: 'CorporateDepartmentConnectionType';
          edges: Array<{
            __typename?: 'CorporateDepartmentEdge';
            node?: {__typename?: 'CorporateDepartment'; id: string; name?: string | null} | null;
          }>;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CuisinesCarouselQueryVariables = Exact<{
  catererId: Scalars['ID']['input'];
  address: CatererSearchAddress;
  eventDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  trackingId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CuisinesCarouselQuery = {
  __typename?: 'Query';
  cuisinesCarousel?: {
    __typename?: 'CuisinesCarousel';
    unfilteredCount: number;
    cards: Array<{__typename?: 'CuisineCard'; cuisine: string; count: number}>;
  } | null;
};

export type DeliveryFeeExperimentQueryVariables = Exact<{[key: string]: never}>;

export type DeliveryFeeExperimentQuery = {
  __typename?: 'Query';
  graphExperiments?: {
    __typename?: 'GraphExperiments';
    deliveryFeeExperiment: {
      __typename?: 'DeliveryFeeExperimentVersions';
      v2?: {
        __typename?: 'DeliveryFeeExperimentAssignmentV2';
        flagKey: string;
        allocationKey: string;
        experimentKey: string;
        variation: string;
        pricingModel:
          | {
              __typename: 'CappedDeliveryFeePricingModel';
              cap: {__typename?: 'Money'; subunits: number; currency: Currency};
            }
          | {__typename: 'StandardDeliveryFeePricingModel'};
      } | null;
    };
  } | null;
};

export type DirectConnectMessagesProviderQueryVariables = Exact<{
  orderUuid: Scalars['ID']['input'];
  readByType?: InputMaybe<ActorTypes>;
}>;

export type DirectConnectMessagesProviderQuery = {
  __typename?: 'Query';
  dcEventHistory: {
    __typename?: 'DcEventHistory';
    events: Array<{
      __typename?: 'DcEvent';
      at: string;
      type: DcEventTypes;
      reference:
        | {__typename?: 'DecisionPoint'}
        | {
            __typename?: 'Message';
            id: string;
            content: string;
            sentByType: ActorTypes;
            sentById: string;
            messageStatus: MessageStatus;
            orderInfo: {
              __typename?: 'OrderInfo';
              id: string;
              brandName: string;
              eventAt: string;
              orderNumber: string;
              userUuid: string;
              isPickup: boolean;
              cpMayRequestChange: boolean;
              custMayStartMessage: boolean;
              activeMessageThread?: {__typename?: 'MessageThread'; id: string} | null;
            };
            request?:
              | {
                  __typename?: 'OrderItemChangeRequest';
                  id: string;
                  orderInfo: {
                    __typename?: 'OrderInfo';
                    id: string;
                    brandName: string;
                    eventAt: string;
                    orderNumber: string;
                    userUuid: string;
                  };
                }
              | {
                  __typename?: 'TimeChangeRequest';
                  id: string;
                  orderInfo: {
                    __typename?: 'OrderInfo';
                    id: string;
                    brandName: string;
                    eventAt: string;
                    orderNumber: string;
                    userUuid: string;
                  };
                }
              | null;
            failedContentFilters?: Array<{
              __typename?: 'FailedContentFilter';
              filterType: ContentFilterTypes;
            }> | null;
          }
        | {
            __typename?: 'OrderItemChangeRequest';
            id: string;
            status: RequestStatus;
            workflowInstanceId?: string | null;
            reason?: string | null;
            orderUuid: string;
            requestedById: string;
            orderInfo: {
              __typename?: 'OrderInfo';
              id: string;
              brandName: string;
              eventAt: string;
              orderNumber: string;
              userUuid: string;
              isPickup: boolean;
              cpMayRequestChange: boolean;
              custMayStartMessage: boolean;
            };
            itemChanges: Array<{
              __typename?: 'ItemChange';
              changeType: OrderItemChangeTypes;
              originalItemJson: string;
              proposedItemJson: string;
              reason?: string | null;
              decisionPoint: {
                __typename?: 'DecisionPoint';
                id: string;
                response?: boolean | null;
                responderType: ActorTypes;
                completedAt?: string | null;
                timeoutAt: string;
              };
            }>;
          }
        | {
            __typename?: 'TimeChangeRequest';
            id: string;
            reason?: string | null;
            status: RequestStatus;
            workflowInstanceId?: string | null;
            originalEventAt: string;
            proposedEventAt: string;
            orderUuid: string;
            requestedById: string;
            orderInfo: {
              __typename?: 'OrderInfo';
              id: string;
              brandName: string;
              eventAt: string;
              eventTimeZone: string;
              orderNumber: string;
              userUuid: string;
              isPickup: boolean;
              cpMayRequestChange: boolean;
              custMayStartMessage: boolean;
            };
            decisionPoints: Array<{
              __typename?: 'DecisionPoint';
              id: string;
              responderType: ActorTypes;
              responderUuid: string;
              response?: boolean | null;
              activatedAt?: string | null;
              completedAt?: string | null;
              timeoutAt: string;
            }>;
          };
    }>;
    lastReadEventIndices: Array<{
      __typename?: 'LastReadDcEventIndex';
      readAt: string;
      readByType: ActorTypes;
    }>;
  };
};

export type DiscoveryRetargetingCardsQueryVariables = Exact<{
  address?: InputMaybe<CatererSearchAddress>;
  eventDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  orderType?: InputMaybe<OrderTypeEnum>;
}>;

export type DiscoveryRetargetingCardsQuery = {
  __typename?: 'Query';
  catererRetargetingCards: Array<{
    __typename?: 'CatererRetargetingCard';
    category: CatererRetargetingCategoryEnum;
    lastActivityAt: string;
    reorderFromOrderUuid?: string | null;
    similarSearchUrl?: string | null;
    caterer: {
      __typename?: 'DiscoveryCaterer';
      id: string;
      legacyId: number;
      brandId: string;
      name: string;
      url: string;
      isSaved: boolean;
      image?: {
        __typename?: 'Image';
        uuid: string;
        desktopHeroUrl?: string | null;
        mobileSearchUrl?: string | null;
      } | null;
    };
  }>;
};

export type EaterConfirmationPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type EaterConfirmationPageQuery = {
  __typename?: 'Query';
  identity?: {__typename?: 'MarketplaceIdentity'; id: string} | null;
  consumerCart: {
    __typename?: 'ConsumerCart';
    id: string;
    currentUserIsOwner: boolean;
    authorizedUsers: Array<{
      __typename?: 'ConsumerCartAuthorizedUser';
      id: string;
      total?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
    }>;
    caterer: {__typename?: 'Caterer'; id: string};
    fulfillmentDetail: {__typename?: 'FulfillmentDetail'; id: string; eventOn?: string | null};
    items: Array<{
      __typename?: 'ConsumerCartItem';
      id: string;
      name?: string | null;
      quantity: number;
      menuItemPreview?: {
        __typename?: 'ConsumerCartMenuItemPreview';
        imageUrl?: string | null;
      } | null;
      shopper?: {__typename?: 'GroupOrderUser'; id?: string | null; name?: string | null} | null;
      total: {__typename?: 'Money'; currency: Currency; subunits: number};
    }>;
  };
};

export type EditAddressPageQueryVariables = Exact<{
  addressBookEntryId: Scalars['ID']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type EditAddressPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  address?: {
    __typename?: 'Address';
    id: string;
    name?: string | null;
    street: string;
    street2?: string | null;
    city: string;
    state: string;
    zip?: string | null;
    phone?: string | null;
    driverAskFor?: string | null;
    deliveryInstructions?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    addressBookEntryId?: number | null;
    addressBookEntry?: {__typename?: 'AddressBookEntry'; id: string; corporate: boolean} | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type EventBarSearchHistoryQueryVariables = Exact<{[key: string]: never}>;

export type EventBarSearchHistoryQuery = {
  __typename?: 'Query';
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    fulfillmentDetails?: {
      __typename?: 'FulfillmentDetailConnection';
      edges: Array<{
        __typename?: 'FulfillmentDetailEdge';
        node?: {
          __typename?: 'FulfillmentDetail';
          id: string;
          eventName?: string | null;
          eventAt?: string | null;
          eventOn?: string | null;
          eventLocalTime?: string | null;
          headcount?: number | null;
          strategy: FulfillmentDetailStrategy;
          address: {
            __typename?: 'Address';
            id: string;
            name?: string | null;
            fullAddress: string;
            city: string;
            state: string;
            street: string;
            zip?: string | null;
            latitude?: number | null;
            longitude?: number | null;
            timeZoneIdentifier: string;
          };
        } | null;
      }>;
    } | null;
  } | null;
};

export type ExpenseReportingPageQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ExpenseReportingPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type EzRewardsActivityQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type EzRewardsActivityQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        activities?: {
          __typename?: 'EzRewardsActivityConnection';
          totalCount: number;
          nodes?: Array<{
            __typename?: 'EzRewardsActivity';
            id: string;
            occurredAt?: string | null;
            note?: string | null;
            amount?: number | null;
            balance?: number | null;
            category?: ActivityCategory | null;
            caterer?: {
              __typename?: 'Caterer';
              id: string;
              isSavedCaterer: boolean;
              name: string;
              urlId: string;
              uuid: string;
              brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
            } | null;
            order?: {
              __typename?: 'Order';
              id: string;
              uuid: string;
              caterer?: {__typename?: 'Caterer'; id: string; urlId: string} | null;
              event?: {
                __typename?: 'Event';
                id: string;
                isTakeout: boolean;
                orderType: OrderTypeEnum;
                timestamp?: string | null;
                timeZoneOffset?: string | null;
                address?: {
                  __typename?: 'Address';
                  id: string;
                  name?: string | null;
                  city: string;
                  street: string;
                  street2?: string | null;
                  state: string;
                  zip?: string | null;
                  deliveryInstructions?: string | null;
                  driverAskFor?: string | null;
                  latitude?: number | null;
                  longitude?: number | null;
                } | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type EzRewardsPageQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type EzRewardsPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  constants?: {
    __typename?: 'Constants';
    ezRewards?: {
      __typename?: 'EzRewardsConstants';
      largestOutstandingUserBalance?: number | null;
      minimumPointsForGiftCardRedemption?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      enrolledInEzRewards?: boolean | null;
      giftCardRedemptionAllowed?: boolean | null;
      isReviewPending: boolean;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type ForceEmailUpdateEligibilityQueryVariables = Exact<{[key: string]: never}>;

export type ForceEmailUpdateEligibilityQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      mustForceEmailUpdate: boolean;
    } | null;
    adminAccount?: {__typename?: 'AdminAccount'; id: string; isMasquerading: boolean} | null;
  } | null;
};

export type ForceEmailUpdatePageQueryVariables = Exact<{[key: string]: never}>;

export type ForceEmailUpdatePageQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      email: string;
      isCurrentDeviceRecognized?: boolean | null;
      mobilePhoneLastTwo?: string | null;
    } | null;
    adminAccount?: {__typename?: 'AdminAccount'; id: string; isMasquerading: boolean} | null;
  } | null;
};

export type GeocodeAddressQueryVariables = Exact<{
  addressString: Scalars['String']['input'];
}>;

export type GeocodeAddressQuery = {
  __typename?: 'Query';
  geocodedAddress: Array<{
    __typename?: 'GeocodedAddressResult';
    street: string;
    street2?: string | null;
    city: string;
    state: string;
    zip?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    timeZoneIdentifier?: string | null;
  }>;
};

export type GeocodeCoordinatesQueryVariables = Exact<{
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}>;

export type GeocodeCoordinatesQuery = {
  __typename?: 'Query';
  geocodedCoordinates: Array<{
    __typename?: 'GeocodedAddressResult';
    street: string;
    street2?: string | null;
    city: string;
    state: string;
    zip?: string | null;
    latitude?: number | null;
    longitude?: number | null;
  }>;
};

export type HomeAccountQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type HomeAccountQuery = {
  __typename?: 'Query';
  constants?: {
    __typename?: 'Constants';
    ezRewards?: {
      __typename?: 'EzRewardsConstants';
      minimumPointsForGiftCardRedemption?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      canAccessEzRewards: boolean;
      giftCardRedemptionAllowed?: boolean | null;
      isCorporate?: boolean | null;
      showInvalidEmailBanner: boolean;
      email: string;
      needsCorporateEmailVerification?: boolean | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
        giftCardRedemptions?: {
          __typename?: 'EzRewardsActivityConnection';
          totalCount: number;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type HomePageDataQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type HomePageDataQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    fulfillmentDetails?: {
      __typename?: 'FulfillmentDetailConnection';
      edges: Array<{
        __typename?: 'FulfillmentDetailEdge';
        node?: {
          __typename?: 'FulfillmentDetail';
          id: string;
          eventAt?: string | null;
          address: {
            __typename?: 'Address';
            id: string;
            street: string;
            street2?: string | null;
            city: string;
            state: string;
            zip?: string | null;
            latitude?: number | null;
            longitude?: number | null;
          };
        } | null;
      }>;
    } | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  constants?: {
    __typename?: 'Constants';
    ezRewards?: {
      __typename?: 'EzRewardsConstants';
      minimumPointsForGiftCardRedemption?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      daysSinceFirstMarketplaceOrder?: number | null;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      giftCardRedemptionAllowed?: boolean | null;
      isCorporate?: boolean | null;
      showInvalidEmailBanner: boolean;
      needsCorporateEmailVerification?: boolean | null;
      openCorpInvites: Array<{
        __typename?: 'CorpInvite';
        id: string;
        corporateAccount: {__typename?: 'CorporateAccount'; id: string};
      }>;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
        giftCardRedemptions?: {
          __typename?: 'EzRewardsActivityConnection';
          totalCount: number;
        } | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type HomePageQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  eventAfter?: InputMaybe<Scalars['DateTime']['input']>;
  includeUserFulfillmentDetails?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentDetailFilters?: InputMaybe<FulfillmentDetailFilterInput>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type HomePageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  constants?: {
    __typename?: 'Constants';
    ezRewards?: {
      __typename?: 'EzRewardsConstants';
      minimumPointsForGiftCardRedemption?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      hasFourPlusStarReview: boolean;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      giftCardRedemptionAllowed?: boolean | null;
      isCorporate?: boolean | null;
      showInvalidEmailBanner: boolean;
      needsCorporateEmailVerification?: boolean | null;
      openCorpInvites: Array<{
        __typename?: 'CorpInvite';
        id: string;
        corporateAccount: {__typename?: 'CorporateAccount'; id: string};
      }>;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
        giftCardRedemptions?: {
          __typename?: 'EzRewardsActivityConnection';
          totalCount: number;
        } | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
      submittedOrders?: {__typename?: 'OrderConnection'; totalCount: number} | null;
      firstOrderDetails: {
        __typename?: 'FirstOrderDetails';
        id: string;
        submittedFeedback: boolean;
        order?: {
          __typename?: 'Order';
          id: string;
          caterer?: {__typename?: 'Caterer'; id: string; name: string} | null;
        } | null;
      };
      recentAddresses?: {
        __typename?: 'AddressConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'AddressEdge';
          node?: {
            __typename?: 'Address';
            id: string;
            uuid: string;
            name?: string | null;
            street: string;
            street2?: string | null;
            city: string;
            state: string;
            zip?: string | null;
            fullAddress: string;
            addressBookEntryId?: number | null;
          } | null;
        }>;
      } | null;
      upcomingOrders?: {
        __typename?: 'OrderConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'OrderEdge';
          node?: {
            __typename?: 'Order';
            id: string;
            uuid: string;
            customerOrderStatus?: {
              __typename?: 'CustomerOrderStatus';
              id: string;
              isDraft: boolean;
              isPendingApproval: boolean;
            } | null;
            caterer?: {
              __typename?: 'Caterer';
              id: string;
              name: string;
              urlId: string;
              address?: {__typename?: 'Address'; id: string; timeZoneIdentifier: string} | null;
            } | null;
            event?: {
              __typename?: 'Event';
              id: string;
              isTakeout: boolean;
              timestamp?: string | null;
              timeZoneIdentifier?: string | null;
              timeZoneOffset?: string | null;
              headcount?: number | null;
              estimatedHeadcount?: number | null;
              address?: {
                __typename?: 'Address';
                id: string;
                name?: string | null;
                street: string;
                timeZoneIdentifier: string;
              } | null;
            } | null;
            corpAccount?: {
              __typename?: 'CorporateAccount';
              id: string;
              uuid: string;
              name: string;
            } | null;
          } | null;
        }>;
      } | null;
      draftOrders?: {__typename?: 'OrderConnection'; totalCount: number} | null;
      receiptOrders?: {__typename?: 'OrderConnection'; totalCount: number} | null;
      recentAddressesByLastUsed?: {
        __typename?: 'AddressConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'AddressEdge';
          node?: {
            __typename?: 'Address';
            id: string;
            city: string;
            latitude?: number | null;
            longitude?: number | null;
            state: string;
            street: string;
            street2?: string | null;
            uuid: string;
            zip?: string | null;
          } | null;
        }>;
      } | null;
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  savedCaterers: {
    __typename?: 'SavedCatererConnection';
    edges: Array<{
      __typename?: 'SavedCatererEdge';
      node?: {
        __typename?: 'Caterer';
        id: string;
        uuid: string;
        name: string;
        isSavedCaterer: boolean;
        isReliabilityRockstar: boolean;
        isNew: boolean;
        urlId: string;
        starRating?: number | null;
        rewardsLevel?: number | null;
        address?: {__typename?: 'Address'; id: string; fullAddress: string} | null;
        minimumDeliveryFee: {
          __typename?: 'MinimumDeliveryFee';
          amount: {__typename?: 'Money'; subunits: number};
        };
        takeoutMinimum?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        brand?: {
          __typename?: 'Brand';
          id: string;
          uuid: string;
          heroImage?: {__typename?: 'Image'; uuid: string; mobileSearchUrl?: string | null} | null;
        } | null;
      } | null;
    }>;
  };
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    fulfillmentDetails?: {
      __typename?: 'FulfillmentDetailConnection';
      edges: Array<{
        __typename?: 'FulfillmentDetailEdge';
        node?: {
          __typename?: 'FulfillmentDetail';
          id: string;
          editable: boolean;
          eventAt?: string | null;
          eventLocalTime?: string | null;
          eventName?: string | null;
          eventOn?: string | null;
          headcount?: number | null;
          strategy: FulfillmentDetailStrategy;
          address: {
            __typename?: 'Address';
            id: string;
            name?: string | null;
            street: string;
            city: string;
            state: string;
            zip?: string | null;
            latitude?: number | null;
            longitude?: number | null;
            fullAddress: string;
            metropolitanStatisticalArea?: string | null;
            timeZoneIdentifier: string;
          };
          corpAccount?: {
            __typename?: 'CorporateAccount';
            id: string;
            uuid: string;
            isParent?: boolean | null;
            name: string;
            displayName?: string | null;
            collectsAllEzRewards: boolean;
            logoIconUrl?: string | null;
            deliverySettings?: {
              __typename?: 'DeliverySettings';
              deliveryFeeCapEnabled: boolean;
              deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            } | null;
          } | null;
        } | null;
      }>;
    } | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  graphExperiments?: {
    __typename?: 'GraphExperiments';
    deliveryFeeExperiment: {
      __typename?: 'DeliveryFeeExperimentVersions';
      v2?: {
        __typename?: 'DeliveryFeeExperimentAssignmentV2';
        flagKey: string;
        allocationKey: string;
        experimentKey: string;
        variation: string;
        pricingModel:
          | {
              __typename: 'CappedDeliveryFeePricingModel';
              cap: {__typename?: 'Money'; subunits: number; currency: Currency};
            }
          | {__typename: 'StandardDeliveryFeePricingModel'};
      } | null;
    };
  } | null;
};

export type IdentityQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type IdentityQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type ItemQuantityRulesQueryVariables = Exact<{
  urlId: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  includeMenuevoMenu?: InputMaybe<Scalars['Boolean']['input']>;
  menuevoDate: Scalars['ISO8601Date']['input'];
}>;

export type ItemQuantityRulesQuery = {
  __typename?: 'Query';
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    orderingMenu?: {
      __typename?: 'OrderingMenu';
      cacheKey: string;
      categories: Array<{
        __typename?: 'OrderingMenuCategory';
        id: string;
        allItems: Array<{
          __typename?: 'OrderingMenuItem';
          id: string;
          sizes: Array<{__typename?: 'OrderingMenuItemSize'; name: string}>;
          quantityRules: {
            __typename?: 'OrderingMenuItemQuantityRules';
            minimumQuantity: number;
            quantities: Array<number>;
            label: {__typename?: 'Noun'; singular: string; plural: string};
          };
        }>;
      }>;
    } | null;
    menuevoMenu?: {
      __typename?: 'MenuevoMenu';
      id: string;
      categories: Array<{
        __typename?: 'MenuevoMenuCategory';
        id: string;
        items: Array<{
          __typename?: 'MenuevoItemSummary';
          id: string;
          unit?: MenuevoUnit | null;
          quantityRules?: {
            __typename?: 'MenuevoItemQuantityRules';
            increment: number;
            max?: number | null;
            min: number;
          } | null;
        }>;
      }>;
    } | null;
  } | null;
};

export type LoggedOutHomePageQueryVariables = Exact<{[key: string]: never}>;

export type LoggedOutHomePageQuery = {
  __typename?: 'Query';
  appStoreReviewCount: number;
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
    fulfillmentDetails?: {
      __typename?: 'FulfillmentDetailConnection';
      edges: Array<{
        __typename?: 'FulfillmentDetailEdge';
        node?: {
          __typename?: 'FulfillmentDetail';
          id: string;
          editable: boolean;
          eventAt?: string | null;
          eventLocalTime?: string | null;
          eventName?: string | null;
          eventOn?: string | null;
          headcount?: number | null;
          strategy: FulfillmentDetailStrategy;
          consumerCarts: Array<{
            __typename?: 'ConsumerCart';
            id: string;
            updatedAt: string;
            caterer: {
              __typename?: 'Caterer';
              id: string;
              name: string;
              urlId: string;
              live: boolean;
              activePauses?: Array<{__typename?: 'CatererPause'; id: string}> | null;
              brand?: {
                __typename?: 'Brand';
                id: string;
                heroImage?: {
                  __typename?: 'Image';
                  uuid: string;
                  mobileSearchUrl?: string | null;
                } | null;
              } | null;
            };
            items: Array<{__typename?: 'ConsumerCartItem'; id: string; quantity: number}>;
            totalDue: {__typename?: 'Money'; subunits: number};
          }>;
          address: {
            __typename?: 'Address';
            id: string;
            name?: string | null;
            street: string;
            city: string;
            state: string;
            zip?: string | null;
            latitude?: number | null;
            longitude?: number | null;
            fullAddress: string;
            metropolitanStatisticalArea?: string | null;
            timeZoneIdentifier: string;
          };
          corpAccount?: {
            __typename?: 'CorporateAccount';
            id: string;
            uuid: string;
            isParent?: boolean | null;
            name: string;
            displayName?: string | null;
            collectsAllEzRewards: boolean;
            logoIconUrl?: string | null;
            deliverySettings?: {
              __typename?: 'DeliverySettings';
              deliveryFeeCapEnabled: boolean;
              deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
            } | null;
          } | null;
        } | null;
      }>;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {__typename?: 'ConsumerAccount'; id: string; email: string} | null;
  } | null;
};

export type MenuDietaryRestrictionsQueryVariables = Exact<{
  menuUuid: Scalars['UUID']['input'];
}>;

export type MenuDietaryRestrictionsQuery = {
  __typename?: 'Query';
  menuDietaryRestrictions: Array<OrderGenerationDietaryRestriction>;
};

export type MenuItemModalQueryVariables = Exact<{
  catererUrlId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  channel: ChannelNameEnum;
  menuItemId: Scalars['ID']['input'];
}>;

export type MenuItemModalQuery = {
  __typename?: 'Query';
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    orderingMenu?: {
      __typename?: 'OrderingMenu';
      cacheKey: string;
      item?: {
        __typename?: 'OrderingMenuItem';
        id: string;
        name: string;
        description: string;
        imageUrl?: string | null;
        fullImagePath?: string | null;
        individualWrapStatus?: IndividualWrapStatus | null;
        usesVolumePricing: boolean;
        canBeQuickAdded: boolean;
        quantityRules: {
          __typename?: 'OrderingMenuItemQuantityRules';
          minimumQuantity: number;
          quantities: Array<number>;
          label: {__typename?: 'Noun'; singular: string; plural: string};
        };
        flags: {
          __typename?: 'OrderingMenuItemFlags';
          canBeVegetarian: boolean;
          hasAward: boolean;
          hasStar: boolean;
          isGlutenFree: boolean;
          isHalal: boolean;
          isHealthy: boolean;
          isKosher: boolean;
          isOrHasDessert: boolean;
          isOrHasDrinks: boolean;
          isOrHasIce: boolean;
          isPopular: boolean;
          isSpicy: boolean;
          isUtensils: boolean;
          isVegan: boolean;
          isVegetarian: boolean;
        };
        sizes: Array<{
          __typename?: 'OrderingMenuItemSize';
          sizeIndex: number;
          name: string;
          numberOfServings?: number | null;
          calories?: {__typename?: 'CalorieRange'; min: number; max?: number | null} | null;
          price:
            | {__typename?: 'Money'; subunits: number; currency: Currency}
            | {
                __typename?: 'VolumePrice';
                maxQuantity: number;
                minQuantity: number;
                price: {__typename?: 'Money'; subunits: number; currency: Currency};
              };
        }>;
        options: Array<{
          __typename?: 'OrderingMenuOption';
          id: string;
          prompt?: string | null;
          maximumAllowedChoices?: number | null;
          minimumAllowedChoices: number;
          choices: Array<{
            __typename?: 'OrderingMenuChoice';
            id: string;
            description?: string | null;
            name: string;
            subQuantityPercentageOptions: Array<number>;
            sizes: Array<{
              __typename?: 'OrderingMenuChoiceSize';
              sizeIndex: number;
              price: {__typename?: 'Money'; subunits: number; currency: Currency};
            }>;
            flags: {
              __typename?: 'OrderingMenuChoiceFlags';
              hasAward: boolean;
              hasStar: boolean;
              isGlutenFree: boolean;
              isHalal: boolean;
              isHealthy: boolean;
              isKosher: boolean;
              isOrHasDessert: boolean;
              isOrHasDrinks: boolean;
              isOrHasIce: boolean;
              isSpicy: boolean;
              isUtensils: boolean;
              isVegan: boolean;
              isVegetarian: boolean;
            };
          }>;
        }>;
      } | null;
    } | null;
  } | null;
};

export type MenuItemOptionsQueryVariables = Exact<{
  urlId: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  itemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type MenuItemOptionsQuery = {
  __typename?: 'Query';
  caterer?: {
    __typename?: 'Caterer';
    id: string;
    orderingMenu?: {
      __typename?: 'OrderingMenu';
      cacheKey: string;
      items: Array<{
        __typename?: 'OrderingMenuItem';
        id: string;
        options: Array<{
          __typename?: 'OrderingMenuOption';
          id: string;
          prompt?: string | null;
          minimumAllowedChoices: number;
          maximumAllowedChoices?: number | null;
        }>;
      }>;
    } | null;
  } | null;
};

export type MenuevoMenuItemQueryVariables = Exact<{
  menuevoMenuItemId: Scalars['ID']['input'];
}>;

export type MenuevoMenuItemQuery = {
  __typename?: 'Query';
  menuevoMenuItem?: {
    __typename?: 'MenuevoItemDetail';
    description?: string | null;
    id: string;
    imageUrl?: string | null;
    individualWrapStatus?: IndividualWrapStatus | null;
    minServes?: number | null;
    name: string;
    salesTaxCode?: string | null;
    sortIndex?: number | null;
    unit?: MenuevoUnit | null;
    advanceNotice?:
      | {__typename?: 'CutoffTime'; cutoffTime: number}
      | {__typename?: 'LeadTimeInMinutes'; leadTimeInMinutes: number}
      | null;
    calories?: {__typename?: 'CalorieRange'; max?: number | null; min: number} | null;
    dietaryFlags: {
      __typename?: 'DietaryFlags';
      isGlutenFree: boolean;
      isHalal: boolean;
      isKosher: boolean;
      isVegan: boolean;
      isVegetarian: boolean;
    };
    image?: {__typename?: 'MenuevoImage'; desktopUrl?: string | null} | null;
    initialSelectionCalories?: {
      __typename?: 'CalorieRange';
      max?: number | null;
      min: number;
    } | null;
    modifierGroups: Array<{
      __typename?: 'MenuevoModifierGroup';
      customerPrompt?: string | null;
      description?: string | null;
      fulfillmentLabel?: string | null;
      id: string;
      maxAggregateQuantity?: number | null;
      maxModifierQuantity?: number | null;
      maxSelections?: number | null;
      minAggregateQuantity?: number | null;
      minModifierQuantity?: number | null;
      minSelections?: number | null;
      name: string;
      sortIndex: number;
      modifiers: Array<{
        __typename?: 'MenuevoModifier';
        defaultQuantity: number;
        description?: string | null;
        id: string;
        name: string;
        preselected?: boolean | null;
        sortIndex: number;
        modifierGroups: Array<{
          __typename?: 'MenuevoModifierGroup';
          customerPrompt?: string | null;
          description?: string | null;
          fulfillmentLabel?: string | null;
          id: string;
          maxAggregateQuantity?: number | null;
          maxModifierQuantity?: number | null;
          maxSelections?: number | null;
          minAggregateQuantity?: number | null;
          minModifierQuantity?: number | null;
          minSelections?: number | null;
          name: string;
          sortIndex: number;
          modifiers: Array<{
            __typename?: 'MenuevoModifier';
            defaultQuantity: number;
            description?: string | null;
            id: string;
            name: string;
            preselected?: boolean | null;
            sortIndex: number;
            modifierGroups: Array<{
              __typename?: 'MenuevoModifierGroup';
              customerPrompt?: string | null;
              description?: string | null;
              fulfillmentLabel?: string | null;
              id: string;
              maxAggregateQuantity?: number | null;
              maxModifierQuantity?: number | null;
              maxSelections?: number | null;
              minAggregateQuantity?: number | null;
              minModifierQuantity?: number | null;
              minSelections?: number | null;
              name: string;
              sortIndex: number;
              modifiers: Array<{
                __typename?: 'MenuevoModifier';
                defaultQuantity: number;
                description?: string | null;
                id: string;
                name: string;
                preselected?: boolean | null;
                sortIndex: number;
                modifierGroups: Array<{
                  __typename?: 'MenuevoModifierGroup';
                  customerPrompt?: string | null;
                  description?: string | null;
                  fulfillmentLabel?: string | null;
                  id: string;
                  maxAggregateQuantity?: number | null;
                  maxModifierQuantity?: number | null;
                  maxSelections?: number | null;
                  minAggregateQuantity?: number | null;
                  minModifierQuantity?: number | null;
                  minSelections?: number | null;
                  name: string;
                  sortIndex: number;
                  modifiers: Array<{
                    __typename?: 'MenuevoModifier';
                    defaultQuantity: number;
                    description?: string | null;
                    id: string;
                    name: string;
                    preselected?: boolean | null;
                    sortIndex: number;
                    modifierGroups: Array<{
                      __typename?: 'MenuevoModifierGroup';
                      customerPrompt?: string | null;
                      description?: string | null;
                      fulfillmentLabel?: string | null;
                      id: string;
                      maxAggregateQuantity?: number | null;
                      maxModifierQuantity?: number | null;
                      maxSelections?: number | null;
                      minAggregateQuantity?: number | null;
                      minModifierQuantity?: number | null;
                      minSelections?: number | null;
                      name: string;
                      sortIndex: number;
                      modifiers: Array<{
                        __typename?: 'MenuevoModifier';
                        defaultQuantity: number;
                        description?: string | null;
                        id: string;
                        name: string;
                        preselected?: boolean | null;
                        sortIndex: number;
                        servings?: {
                          __typename?: 'ServingsRange';
                          max?: number | null;
                          min: number;
                        } | null;
                        calories?: {
                          __typename?: 'CalorieRange';
                          max?: number | null;
                          min: number;
                        } | null;
                        price: {
                          __typename?: 'Money';
                          currency: Currency;
                          subunits: number;
                          subunitsV2: string;
                        };
                      }>;
                    }>;
                    servings?: {
                      __typename?: 'ServingsRange';
                      max?: number | null;
                      min: number;
                    } | null;
                    calories?: {
                      __typename?: 'CalorieRange';
                      max?: number | null;
                      min: number;
                    } | null;
                    price: {
                      __typename?: 'Money';
                      currency: Currency;
                      subunits: number;
                      subunitsV2: string;
                    };
                  }>;
                }>;
                servings?: {__typename?: 'ServingsRange'; max?: number | null; min: number} | null;
                calories?: {__typename?: 'CalorieRange'; max?: number | null; min: number} | null;
                price: {
                  __typename?: 'Money';
                  currency: Currency;
                  subunits: number;
                  subunitsV2: string;
                };
              }>;
            }>;
            servings?: {__typename?: 'ServingsRange'; max?: number | null; min: number} | null;
            calories?: {__typename?: 'CalorieRange'; max?: number | null; min: number} | null;
            price: {__typename?: 'Money'; currency: Currency; subunits: number; subunitsV2: string};
          }>;
        }>;
        servings?: {__typename?: 'ServingsRange'; max?: number | null; min: number} | null;
        calories?: {__typename?: 'CalorieRange'; max?: number | null; min: number} | null;
        price: {__typename?: 'Money'; currency: Currency; subunits: number; subunitsV2: string};
      }>;
    }>;
    price: {__typename?: 'Money'; currency: Currency; subunits: number; subunitsV2: string};
    quantityRules?: {
      __typename?: 'MenuevoItemQuantityRules';
      increment: number;
      max?: number | null;
      min: number;
    } | null;
    servings?: {__typename?: 'ServingsRange'; max?: number | null; min: number} | null;
  } | null;
};

export type NewAddressPageQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type NewAddressPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type OpenOrdersQueryVariables = Exact<{
  excludeModificationCarts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNonEmptyCarts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyFulfillmentDetailsWithCarts?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type OpenOrdersQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      accountIdentifier: string;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    fulfillmentDetails?: {
      __typename?: 'FulfillmentDetailConnection';
      edges: Array<{
        __typename?: 'FulfillmentDetailEdge';
        node?: {
          __typename?: 'FulfillmentDetail';
          id: string;
          eventName?: string | null;
          eventAt?: string | null;
          headcount?: number | null;
          address: {
            __typename?: 'Address';
            id: string;
            name?: string | null;
            fullAddress: string;
            city: string;
            state: string;
            timeZoneIdentifier: string;
          };
          consumerCarts: Array<{
            __typename?: 'ConsumerCart';
            id: string;
            updatedAt: string;
            isModification: boolean;
            items: Array<{
              __typename?: 'ConsumerCartItem';
              id: string;
              name?: string | null;
              quantity: number;
            }>;
            totalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
            caterer: {
              __typename?: 'Caterer';
              id: string;
              urlId: string;
              name: string;
              address?: {__typename?: 'Address'; id: string; city: string; state: string} | null;
              brand?: {
                __typename?: 'Brand';
                id: string;
                heroImage?: {
                  __typename?: 'Image';
                  uuid: string;
                  mobileHeroUrl?: string | null;
                } | null;
              } | null;
            };
          }>;
          corpAccount?: {
            __typename?: 'CorporateAccount';
            id: string;
            uuid: string;
            name: string;
          } | null;
        } | null;
      }>;
    } | null;
  } | null;
};

export type OrderAgainQueryVariables = Exact<{
  catererId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type OrderAgainQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      orders?: {
        __typename?: 'OrderConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'OrderEdge';
          node?: {
            __typename?: 'Order';
            id: string;
            uuid: string;
            caterer?: {
              __typename?: 'Caterer';
              id: string;
              uuid: string;
              name: string;
              isSavedCaterer: boolean;
              isReliabilityRockstar: boolean;
              isNew: boolean;
              urlId: string;
              starRating?: number | null;
              rewardsLevel?: number | null;
              address?: {__typename?: 'Address'; id: string; fullAddress: string} | null;
              minimumDeliveryFee: {
                __typename?: 'MinimumDeliveryFee';
                amount: {__typename?: 'Money'; subunits: number};
              };
              takeoutMinimum?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
              brand?: {
                __typename?: 'Brand';
                id: string;
                uuid: string;
                heroImage?: {
                  __typename?: 'Image';
                  uuid: string;
                  mobileSearchUrl?: string | null;
                } | null;
              } | null;
            } | null;
            cart?: {
              __typename?: 'Cart';
              id: string;
              orderItems: Array<{
                __typename?: 'OrderItem';
                id: string;
                name?: string | null;
                quantity: number;
                size?: string | null;
                sizeIndex?: number | null;
                vegetarianQuantity?: number | null;
                specialInstructions?: string | null;
                menuItem?: {
                  __typename?: 'MenuItem';
                  id: string;
                  uuid: string;
                  isAvailable: boolean;
                  quantityOptions: {
                    __typename?: 'MenuItemQuantityOptions';
                    quantities: Array<number | null>;
                    allowCustomQuantityOver100: boolean;
                    labelPlural: string;
                    label: string;
                  };
                  sizes?: Array<{
                    __typename?: 'MenuItemSize';
                    size?: string | null;
                    number: number;
                    serves?: number | null;
                  } | null> | null;
                } | null;
                optionInputs?: Array<{
                  __typename?: 'OrderItemOption';
                  id: string;
                  catererLabel?: string | null;
                  menuOption?: {__typename?: 'MenuOption'; id: string; uuid: string} | null;
                  choiceInputs: Array<{
                    __typename?: 'OrderItemChoice';
                    id: string;
                    isGlutenFree?: boolean | null;
                    name?: string | null;
                    subQuantityPercentage?: number | null;
                    menuChoice?: {__typename?: 'MenuChoice'; id: string; uuid: string} | null;
                  }>;
                } | null> | null;
              }>;
              pricePerHead: {
                __typename?: 'PricePerHead';
                id: string;
                byCustomerTotal: {__typename?: 'Money'; subunits: number};
              };
            } | null;
            event?: {
              __typename?: 'Event';
              id: string;
              date?: string | null;
              headcount?: number | null;
              address?: {
                __typename?: 'Address';
                id: string;
                street: string;
                street2?: string | null;
                city: string;
                state: string;
                zip?: string | null;
                latitude?: number | null;
                longitude?: number | null;
              } | null;
            } | null;
          } | null;
        }>;
      } | null;
    } | null;
  } | null;
};

export type OrderPlacedPageQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type OrderPlacedPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  nationwideCatererCount: number;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  order?: {
    __typename?: 'Order';
    id: string;
    uuid: string;
    formattedOrderNumber?: string | null;
    isEzOrderingOrder: boolean;
    isStandardGroupOrder: boolean;
    orderSourceType?: OrderSource | null;
    ezRewardsPointsEarnable: number;
    predictedLtv?: number | null;
    isResidentialOrder: boolean;
    orderRank: {
      __typename?: 'OrderRank';
      submittedMarketplace?: number | null;
      submittedEzOrdering?: number | null;
    };
    cart?: {
      __typename?: 'Cart';
      id: string;
      productCatalog: ProductCatalog;
      orderItems: Array<{
        __typename?: 'OrderItem';
        id: string;
        name?: string | null;
        quantity: number;
        menuItemId?: string | null;
        price?: number | null;
        size?: string | null;
        specialInstructions?: string | null;
        serves?: number | null;
        vegetarianQuantity?: number | null;
        groupOrderPersonName?: string | null;
        totalInSubunits?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        orderItemOptions?: Array<{
          __typename?: 'OrderItemOption';
          id: string;
          catererLabel?: string | null;
          itemChoices: Array<{
            __typename?: 'OrderItemChoice';
            id: string;
            name?: string | null;
            price?: number | null;
          }>;
        } | null> | null;
        modifiers?: Array<{
          __typename?: 'LineItemModifier';
          id: string;
          name: string;
          quantity: number;
          modifiers?: Array<{
            __typename?: 'LineItemModifier';
            id: string;
            name: string;
            quantity: number;
            modifiers?: Array<{
              __typename?: 'LineItemModifier';
              id: string;
              name: string;
              quantity: number;
              modifiers?: Array<{
                __typename?: 'LineItemModifier';
                id: string;
                name: string;
                quantity: number;
                modifiers?: Array<{
                  __typename?: 'LineItemModifier';
                  id: string;
                  name: string;
                  quantity: number;
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                  modifierGroup: {
                    __typename?: 'LineItemModifierGroup';
                    id: string;
                    name?: string | null;
                  };
                }> | null;
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                modifierGroup: {
                  __typename?: 'LineItemModifierGroup';
                  id: string;
                  name?: string | null;
                };
              }> | null;
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              modifierGroup: {
                __typename?: 'LineItemModifierGroup';
                id: string;
                name?: string | null;
              };
            }> | null;
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
          }> | null;
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
        }> | null;
      }>;
      lineItems: Array<{
        __typename?: 'LineItem';
        id: string;
        name?: string | null;
        type?: LineItemTypeEnum | null;
        isGratuity: boolean;
        isPromo: boolean;
        cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
    } | null;
    caterer?: {
      __typename?: 'Caterer';
      id: string;
      uuid: string;
      name: string;
      urlId: string;
      isSavedCaterer: boolean;
      starRating?: number | null;
      address?: {
        __typename?: 'Address';
        id: string;
        street: string;
        street2?: string | null;
        city: string;
        state: string;
        zip?: string | null;
        staticMapUrl?: string | null;
      } | null;
      brand?: {
        __typename?: 'Brand';
        id: string;
        uuid: string;
        name: string;
        logoUrl?: string | null;
      } | null;
    } | null;
    customerOrderStatus?: {
      __typename?: 'CustomerOrderStatus';
      id: string;
      isSubmitted?: boolean | null;
      isAccepted?: boolean | null;
      isReconfirmed?: boolean | null;
      isFulfilled?: boolean | null;
      isModifiable?: boolean | null;
      isCancellable?: boolean | null;
      isCancelled?: boolean | null;
      isDraft: boolean;
      isPendingApproval: boolean;
      modificationCutoffTime?: string | null;
    } | null;
    orderCustomer?: {__typename?: 'OrderCustomer'; id: string} | null;
    delivery?: {
      __typename?: 'DmDelivery';
      id: string;
      deliveryEvents: Array<{
        __typename?: 'DmDeliveryEvent';
        id: string;
        eventType: DmDeliveryEventTypes;
      }>;
    } | null;
    event?: {
      __typename?: 'Event';
      id: string;
      timestamp?: string | null;
      timeZoneOffset?: string | null;
      timeZoneIdentifier?: string | null;
      name?: string | null;
      customerProvidedName?: string | null;
      orderType: OrderTypeEnum;
      headcount?: number | null;
      deliverySetup: DeliverySetup;
      address?: {
        __typename?: 'Address';
        id: string;
        fullAddress: string;
        name?: string | null;
        street: string;
        street2?: string | null;
        city: string;
        state: string;
        zip?: string | null;
        phone?: string | null;
        driverAskFor?: string | null;
        deliveryInstructions?: string | null;
        staticMapUrl?: string | null;
      } | null;
    } | null;
    paymentMethod?:
      | {__typename?: 'CreditCard'; id: string; last4?: string | null; cardType?: CardType | null}
      | {__typename?: 'CreditLine'; id: string; corpAccountName?: string | null}
      | null;
    totals?: {
      __typename?: 'OrderTotals';
      tip?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      salesTax: {__typename?: 'Money'; currency: Currency; subunits: number};
      subTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      preDeliveryDiscountDeliveryFee?: {
        __typename?: 'Money';
        currency: Currency;
        subunits: number;
      } | null;
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    } | null;
    corpAccount?: {
      __typename?: 'CorporateAccount';
      id: string;
      deliverySettings?: {
        __typename?: 'DeliverySettings';
        deliveryFeeCapEnabled: boolean;
        deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      procurementSettings?: {__typename?: 'ProcurementSettings'; cartEditsEnabled: boolean} | null;
    } | null;
    tableware: {
      __typename?: 'TablewareSummary';
      includedUtensils: Array<string>;
      omittedUtensils: Array<string>;
      specialInstructions?: string | null;
    };
    cancellationPolicyDisplay?: {
      __typename?: 'OrderCancellationPolicyDisplay';
      hasCancellationFee: boolean;
      feePercentage: number;
      cancelWithoutPenaltyUntil?: string | null;
      cancellationWindowHours: number;
      isWaiverEligible: boolean;
      feeAmount?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      marketplaceStatus: MarketplaceStatusEnum;
      userType: UserTypeEnum;
      referralUrl?: string | null;
      enterpriseLeadEligible: boolean;
      referralCode?: string | null;
      submittedOrdersCount: number;
      daysSinceFirstMarketplaceOrder?: number | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
      assignedPromoCode?: {
        __typename?: 'UserPromoCodeAssignment';
        promo: {
          __typename?: 'Promo';
          id: string;
          title: string;
          description: string;
          finePrint?: string | null;
          termsAndConditionsUrl?: string | null;
        };
      } | null;
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type OrdersCalendarPageQueryVariables = Exact<{
  eventAfter?: InputMaybe<Scalars['DateTime']['input']>;
  eventBefore?: InputMaybe<Scalars['DateTime']['input']>;
  includeOrders: Scalars['Boolean']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type OrdersCalendarPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      orders?: {
        __typename?: 'OrderConnection';
        nodes?: Array<{
          __typename?: 'Order';
          id: string;
          uuid: string;
          formattedOrderNumber?: string | null;
          isEzOrderingOrder: boolean;
          isStandardGroupOrder: boolean;
          corpAccount?: {__typename?: 'CorporateAccount'; id: string; name: string} | null;
          event?: {
            __typename?: 'Event';
            id: string;
            timestamp?: string | null;
            timeZoneOffset?: string | null;
            headcount?: number | null;
            address?: {
              __typename?: 'Address';
              id: string;
              nameOrLocation: string;
              street: string;
              street2?: string | null;
              city: string;
              state: string;
              zip?: string | null;
              latitude?: number | null;
              longitude?: number | null;
            } | null;
          } | null;
          caterer?: {
            __typename?: 'Caterer';
            id: string;
            uuid: string;
            name: string;
            urlId: string;
          } | null;
          customerOrderStatus?: {
            __typename?: 'CustomerOrderStatus';
            id: string;
            currentStatusDisplay: string;
            isCancellable?: boolean | null;
            isDraft: boolean;
            isFulfilled?: boolean | null;
            isModifiable?: boolean | null;
            modificationCutoffTime?: string | null;
            isSubmitted?: boolean | null;
            isPendingApproval: boolean;
          } | null;
          cart?: {
            __typename?: 'Cart';
            id: string;
            orderItems: Array<{__typename?: 'OrderItem'; id: string; belongsToAnyEater: boolean}>;
          } | null;
          cancellationPolicyDisplay?: {
            __typename?: 'OrderCancellationPolicyDisplay';
            hasCancellationFee: boolean;
            feePercentage: number;
            cancelWithoutPenaltyUntil?: string | null;
            cancellationWindowHours: number;
            isWaiverEligible: boolean;
            feeAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          } | null;
        } | null> | null;
      } | null;
      concurAccount?: {
        __typename?: 'ConcurAccount';
        id: string;
        areReceiptsAutomated: boolean;
      } | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type OrdersDropdownQueryVariables = Exact<{
  corpAccountUuids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  includeAllConnections?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type OrdersDropdownQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      scheduledOrderSections: Array<{
        __typename?: 'OrderSection';
        key: OrderSectionKey;
        orders: Array<{
          __typename?: 'Order';
          id: string;
          uuid: string;
          isStandardGroupOrder: boolean;
          delivery?: {
            __typename?: 'DmDelivery';
            id: string;
            estimatedDropoffTime?: string | null;
            tracking?: {__typename?: 'DmDeliveryTracking'; url: string} | null;
            deliveryEvents: Array<{
              __typename?: 'DmDeliveryEvent';
              id: string;
              eventType: DmDeliveryEventTypes;
              time: string;
            }>;
          } | null;
          customerOrderStatus?: {
            __typename?: 'CustomerOrderStatus';
            id: string;
            isFulfilled?: boolean | null;
            isCancelled?: boolean | null;
          } | null;
          caterer?: {
            __typename?: 'Caterer';
            id: string;
            uuid: string;
            urlId: string;
            name: string;
            brand?: {
              __typename?: 'Brand';
              id: string;
              uuid: string;
              heroImage?: {
                __typename?: 'Image';
                uuid: string;
                mobileHeroUrl?: string | null;
              } | null;
            } | null;
            address?: {__typename?: 'Address'; id: string; fullAddress: string} | null;
          } | null;
          event?: {
            __typename?: 'Event';
            id: string;
            timestamp?: string | null;
            timeZoneIdentifier?: string | null;
            timeZoneOffset?: string | null;
            isTakeout: boolean;
            address?: {__typename?: 'Address'; id: string; nameOrLocation: string} | null;
          } | null;
        }>;
      }>;
      completedOrderSections: Array<{
        __typename?: 'OrderSection';
        key: OrderSectionKey;
        orders: Array<{
          __typename?: 'Order';
          id: string;
          canBeReviewed?: boolean | null;
          uuid: string;
          isStandardGroupOrder: boolean;
          review?: {
            __typename?: 'Review';
            id?: string | null;
            rating?: StarRating | null;
            text?: string | null;
            deliveryTimeFeedback?: DeliveryTimeFeedback | null;
            deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
            penName?: string | null;
          } | null;
          orderCustomer?: {__typename?: 'OrderCustomer'; id: string} | null;
          caterer?: {
            __typename?: 'Caterer';
            id: string;
            isSavedCaterer: boolean;
            uuid: string;
            urlId: string;
            name: string;
            brand?: {
              __typename?: 'Brand';
              id: string;
              uuid: string;
              heroImage?: {
                __typename?: 'Image';
                uuid: string;
                mobileHeroUrl?: string | null;
              } | null;
            } | null;
            address?: {__typename?: 'Address'; id: string; fullAddress: string} | null;
          } | null;
          event?: {
            __typename?: 'Event';
            id: string;
            timestamp?: string | null;
            timeZoneIdentifier?: string | null;
            timeZoneOffset?: string | null;
            isTakeout: boolean;
            address?: {
              __typename?: 'Address';
              id: string;
              nameOrLocation: string;
              street: string;
              street2?: string | null;
              city: string;
              state: string;
              zip?: string | null;
              latitude?: number | null;
              longitude?: number | null;
            } | null;
          } | null;
          customerOrderStatus?: {
            __typename?: 'CustomerOrderStatus';
            id: string;
            isFulfilled?: boolean | null;
            isCancelled?: boolean | null;
          } | null;
        }>;
      }>;
      upcomingOrdersCount?: {__typename?: 'OrderConnection'; totalCount: number} | null;
      pastOrdersCount?: {__typename?: 'OrderConnection'; totalCount: number} | null;
    } | null;
  } | null;
};

export type OrdersIndicatorQueryVariables = Exact<{
  corpAccountUuids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  includeAllConnections?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type OrdersIndicatorQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      todayOrderSections: Array<{
        __typename?: 'OrderSection';
        key: OrderSectionKey;
        orders: Array<{__typename?: 'Order'; id: string}>;
      }>;
      completedOrderSections: Array<{
        __typename?: 'OrderSection';
        key: OrderSectionKey;
        orders: Array<{
          __typename?: 'Order';
          id: string;
          canBeReviewed?: boolean | null;
          review?: {__typename?: 'Review'; id?: string | null; rating?: StarRating | null} | null;
          orderCustomer?: {__typename?: 'OrderCustomer'; id: string} | null;
        }>;
      }>;
    } | null;
  } | null;
};

export type OrdersPageQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  filter: OrderStateFilterEnum;
  includeModifiable: Scalars['Boolean']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  userConnectionId?: InputMaybe<Scalars['UUID']['input']>;
  includeAllConnections?: InputMaybe<Scalars['Boolean']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
  selectedAccountUuidsForOrders?: InputMaybe<
    Array<Scalars['UUID']['input']> | Scalars['UUID']['input']
  >;
}>;

export type OrdersPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      isSpecialtyCustomer?: boolean | null;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      orders?: {
        __typename?: 'OrderConnection';
        totalCount: number;
        nodes?: Array<{
          __typename?: 'Order';
          id: string;
          uuid: string;
          isPaymentPending?: boolean | null;
          isEzOrderingOrder: boolean;
          formattedOrderNumber?: string | null;
          canBeReviewed?: boolean | null;
          state?: string | null;
          isStandardGroupOrder: boolean;
          notificationsEnabled: boolean;
          firstOrderReferenceCode?: {
            __typename?: 'OrderReferenceCode';
            id: string;
            value?: string | null;
            corporateReferenceCode?: {
              __typename?: 'CorporateReferenceCode';
              id: string;
              name: string;
            } | null;
          } | null;
          event?: {
            __typename?: 'Event';
            id: string;
            timestamp?: string | null;
            timeZoneOffset?: string | null;
            isTakeout: boolean;
            headcount?: number | null;
            customerProvidedName?: string | null;
            address?: {
              __typename?: 'Address';
              id: string;
              nameOrLocation: string;
              street: string;
              street2?: string | null;
              city: string;
              state: string;
              zip?: string | null;
              latitude?: number | null;
              longitude?: number | null;
            } | null;
          } | null;
          caterer?: {
            __typename?: 'Caterer';
            id: string;
            isSavedCaterer: boolean;
            uuid: string;
            name: string;
            starRating?: number | null;
            urlId: string;
            address?: {__typename?: 'Address'; id: string; fullAddress: string} | null;
            minimumDeliveryFee: {
              __typename?: 'MinimumDeliveryFee';
              amount: {__typename?: 'Money'; subunits: number};
            };
            takeoutMinimum?: {__typename?: 'Money'; subunits: number} | null;
            brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
          } | null;
          customerOrderStatus?: {
            __typename?: 'CustomerOrderStatus';
            id: string;
            currentStatusDisplay: string;
            isCancellable?: boolean | null;
            isCancelled?: boolean | null;
            isDraft: boolean;
            isFulfilled?: boolean | null;
            isModifiable?: boolean | null;
            modificationCutoffTime?: string | null;
            isSubmitted?: boolean | null;
            isPendingApproval: boolean;
          } | null;
          totals?: {
            __typename?: 'OrderTotals';
            customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
          } | null;
          review?: {
            __typename?: 'Review';
            id?: string | null;
            text?: string | null;
            rating?: StarRating | null;
            deliveryTimeFeedback?: DeliveryTimeFeedback | null;
            deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
            penName?: string | null;
          } | null;
          cart?: {
            __typename?: 'Cart';
            id: string;
            orderItems: Array<{__typename?: 'OrderItem'; id: string; belongsToAnyEater: boolean}>;
          } | null;
          corpAccount?: {__typename?: 'CorporateAccount'; id: string; name: string} | null;
          orderCustomer?: {
            __typename?: 'OrderCustomer';
            id: string;
            fullName?: string | null;
          } | null;
          cancellationPolicyDisplay?: {
            __typename?: 'OrderCancellationPolicyDisplay';
            hasCancellationFee: boolean;
            feePercentage: number;
            cancelWithoutPenaltyUntil?: string | null;
            cancellationWindowHours: number;
            isWaiverEligible: boolean;
            feeAmount?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
          } | null;
        } | null> | null;
      } | null;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      concurAccount?: {
        __typename?: 'ConcurAccount';
        id: string;
        areReceiptsAutomated: boolean;
      } | null;
      userConnections: {
        __typename?: 'UserConnectionConnection';
        edges: Array<{
          __typename?: 'UserConnectionEdge';
          node?: {
            __typename?: 'UserConnection';
            id: string;
            connectedUserId: string;
            fullName: string;
          } | null;
        }>;
      };
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type PastOrdersQueryVariables = Exact<{
  addressId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
}>;

export type PastOrdersQuery = {
  __typename?: 'Query';
  address?: {
    __typename?: 'Address';
    id: string;
    pastOrders?: {
      __typename?: 'OrderConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'OrderEdge';
        node?: {
          __typename?: 'Order';
          id: string;
          uuid: string;
          formattedOrderNumber?: string | null;
          canBeReviewed?: boolean | null;
          isPaymentPending?: boolean | null;
          event?: {
            __typename?: 'Event';
            id: string;
            timestamp?: string | null;
            timeZoneOffset?: string | null;
            headcount?: number | null;
            orderType: OrderTypeEnum;
            address?: {
              __typename?: 'Address';
              id: string;
              name?: string | null;
              street: string;
              street2?: string | null;
              city: string;
              state: string;
              zip?: string | null;
              latitude?: number | null;
              longitude?: number | null;
            } | null;
          } | null;
          cart?: {
            __typename?: 'Cart';
            id: string;
            orderItems: Array<{
              __typename?: 'OrderItem';
              id: string;
              name?: string | null;
              quantity: number;
              groupOrderPersonName?: string | null;
            }>;
          } | null;
          totals?: {
            __typename?: 'OrderTotals';
            customerTotalDue: {__typename?: 'Money'; subunits: number};
          } | null;
          caterer?: {
            __typename?: 'Caterer';
            id: string;
            uuid: string;
            name: string;
            urlId: string;
          } | null;
        } | null;
      }>;
    } | null;
  } | null;
};

export type PaymentMethodsPageQueryVariables = Exact<{
  paymentMethodsLimit: Scalars['Int']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type PaymentMethodsPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      isCurrentDeviceRecognized?: boolean | null;
      mobilePhoneLastTwo?: string | null;
      email: string;
      industry?: UserIndustryEnum | null;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      lastName?: string | null;
      isCorporate?: boolean | null;
      canUpdateCorpPortal: boolean;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
      paymentMethods?: {
        __typename?: 'PaymentMethodConnection';
        nodes?: Array<
          | {
              __typename?: 'CreditCard';
              id: string;
              cardType?: CardType | null;
              cardholderName: string;
              expMonth?: number | null;
              expYear?: number | null;
              isDefaultCard?: boolean | null;
              isExpired?: boolean | null;
              isExpiringSoon?: boolean | null;
              last4?: string | null;
              nickname?: string | null;
              missingZipCode: boolean;
              sharedWithCount?: number | null;
              sharedBy?: {
                __typename?: 'ConsumerAccount';
                id: string;
                email: string;
                fullName?: string | null;
              } | null;
            }
          | {
              __typename?: 'CreditLine';
              id: string;
              allowedUse: CreditLineAllowedUse;
              corpAccountName?: string | null;
              isDefault?: boolean | null;
              logoImageUrl?: string | null;
            }
          | null
        > | null;
      } | null;
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type PaymentMethodsQueryVariables = Exact<{
  paymentMethodsLimit: Scalars['Int']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type PaymentMethodsQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    adminAccount?: {__typename?: 'AdminAccount'; id: string} | null;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      email: string;
      firstName?: string | null;
      lastName?: string | null;
      mobilePhone?: string | null;
      isCorporate?: boolean | null;
      corporateAccountVerified: boolean;
      canUpdateCorpPortal: boolean;
      paymentMethods?: {
        __typename?: 'PaymentMethodConnection';
        nodes?: Array<
          | {
              __typename?: 'CreditCard';
              id: string;
              cardType?: CardType | null;
              cardholderName: string;
              expMonth?: number | null;
              expYear?: number | null;
              isDefaultCard?: boolean | null;
              isExpired?: boolean | null;
              isExpiringSoon?: boolean | null;
              last4?: string | null;
              nickname?: string | null;
              missingZipCode: boolean;
              sharedWithCount?: number | null;
              sharedBy?: {
                __typename?: 'ConsumerAccount';
                id: string;
                email: string;
                fullName?: string | null;
              } | null;
            }
          | {
              __typename?: 'CreditLine';
              id: string;
              allowedUse: CreditLineAllowedUse;
              corpAccountName?: string | null;
              isDefault?: boolean | null;
              logoImageUrl?: string | null;
            }
          | null
        > | null;
      } | null;
    } | null;
  } | null;
};

export type PaymentMethodsRootQueryVariables = Exact<{[key: string]: never}>;

export type PaymentMethodsRootQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      isCurrentDeviceRecognized?: boolean | null;
      mobilePhoneLastTwo?: string | null;
      email: string;
    } | null;
    adminAccount?: {__typename?: 'AdminAccount'; id: string; isMasquerading: boolean} | null;
  } | null;
};

export type PdfMenuQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type PdfMenuQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  order?: {
    __typename?: 'Order';
    id: string;
    corpAccountName?: string | null;
    canBeReviewed?: boolean | null;
    formattedOrderNumber?: string | null;
    isStandardGroupOrder: boolean;
    uuid: string;
    approvalDeadline?: string | null;
    caterer?: {
      __typename?: 'Caterer';
      id: string;
      name: string;
      uuid: string;
      urlId: string;
      nickname?: string | null;
      isSavedCaterer: boolean;
      brand?: {
        __typename?: 'Brand';
        id: string;
        logoUrl?: string | null;
        uuid: string;
        name: string;
      } | null;
      address?: {
        __typename?: 'Address';
        id: string;
        name?: string | null;
        city: string;
        street: string;
        street2?: string | null;
        state: string;
        zip?: string | null;
      } | null;
    } | null;
    cart?: {
      __typename?: 'Cart';
      id: string;
      productCatalog: ProductCatalog;
      orderItems: Array<{
        __typename?: 'OrderItem';
        id: string;
        description?: string | null;
        isUtensils: boolean;
        name?: string | null;
        price?: number | null;
        quantity: number;
        size?: string | null;
        sizeLabel?: string | null;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        serves?: number | null;
        groupOrderPersonName?: string | null;
        belongsToAnyEater: boolean;
        dietaryFlags?: {
          __typename?: 'DietaryFlags';
          isVegetarian: boolean;
          isVegan: boolean;
          isGlutenFree: boolean;
          isKosher: boolean;
          isHalal: boolean;
        } | null;
        orderItemOptions?: Array<{
          __typename?: 'OrderItemOption';
          id: string;
          catererLabel?: string | null;
          itemChoices: Array<{
            __typename?: 'OrderItemChoice';
            id: string;
            description?: string | null;
            name?: string | null;
            price?: number | null;
          }>;
        } | null> | null;
        totalInSubunits?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        modifiers?: Array<{
          __typename?: 'LineItemModifier';
          id: string;
          name: string;
          quantity: number;
          modifiers?: Array<{
            __typename?: 'LineItemModifier';
            id: string;
            name: string;
            quantity: number;
            modifiers?: Array<{
              __typename?: 'LineItemModifier';
              id: string;
              name: string;
              quantity: number;
              modifiers?: Array<{
                __typename?: 'LineItemModifier';
                id: string;
                name: string;
                quantity: number;
                modifiers?: Array<{
                  __typename?: 'LineItemModifier';
                  id: string;
                  name: string;
                  quantity: number;
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                  modifierGroup: {
                    __typename?: 'LineItemModifierGroup';
                    id: string;
                    name?: string | null;
                  };
                }> | null;
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                modifierGroup: {
                  __typename?: 'LineItemModifierGroup';
                  id: string;
                  name?: string | null;
                };
              }> | null;
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              modifierGroup: {
                __typename?: 'LineItemModifierGroup';
                id: string;
                name?: string | null;
              };
            }> | null;
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
          }> | null;
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
        }> | null;
      }>;
      lineItems: Array<{
        __typename?: 'LineItem';
        id: string;
        name?: string | null;
        type?: LineItemTypeEnum | null;
        cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      tip: {__typename?: 'Tip'; id: string; amount?: number | null};
    } | null;
    delivery?: {
      __typename?: 'DmDelivery';
      id: string;
      estimatedDropoffTime?: string | null;
      tracking?: {__typename?: 'DmDeliveryTracking'; url: string} | null;
      deliveryEvents: Array<{
        __typename?: 'DmDeliveryEvent';
        id: string;
        eventType: DmDeliveryEventTypes;
        time: string;
      }>;
    } | null;
    review?: {
      __typename?: 'Review';
      id?: string | null;
      text?: string | null;
      rating?: StarRating | null;
      deliveryTimeFeedback?: DeliveryTimeFeedback | null;
      deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
      penName?: string | null;
    } | null;
    tableware: {
      __typename?: 'TablewareSummary';
      specialInstructions?: string | null;
      includedUtensils: Array<string>;
      omittedUtensils: Array<string>;
    };
    corporateOrderReferenceCodes?: Array<{
      __typename?: 'OrderReferenceCode';
      id: string;
      name: string;
      value?: string | null;
      corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
    }> | null;
    corporateReferenceCodes: Array<{
      __typename?: 'CorporateReferenceCode';
      id: string;
      active: boolean;
      name: string;
      required: boolean;
      requiresCreditLine: boolean;
      type: CorpCustomCheckoutFieldEntry;
      values: Array<string>;
      procurement: boolean;
      currentValue?: string | null;
    }>;
    customerOrderStatus?: {
      __typename?: 'CustomerOrderStatus';
      id: string;
      isSubmitted?: boolean | null;
      isDraft: boolean;
      submittedAt?: string | null;
      isAccepted?: boolean | null;
      isReconfirmed?: boolean | null;
      isFulfilled?: boolean | null;
      fulfilledAt?: string | null;
      isCustomerPaymentCaptured?: boolean | null;
      isModifiable?: boolean | null;
      modificationCutoffTime?: string | null;
      isCancellable?: boolean | null;
      isCancelled?: boolean | null;
      cancelledAt?: string | null;
      isPendingApproval: boolean;
    } | null;
    firstOrderReferenceCode?: {
      __typename?: 'OrderReferenceCode';
      id: string;
      value?: string | null;
      corporateReferenceCode?: {
        __typename?: 'CorporateReferenceCode';
        id: string;
        name: string;
      } | null;
    } | null;
    event?: {
      __typename?: 'Event';
      id: string;
      headcount?: number | null;
      customerProvidedName?: string | null;
      deliverySetup: DeliverySetup;
      isTakeout: boolean;
      orderType: OrderTypeEnum;
      timestamp?: string | null;
      timeZoneIdentifier?: string | null;
      timeZoneOffset?: string | null;
      address?: {
        __typename?: 'Address';
        id: string;
        name?: string | null;
        city: string;
        street: string;
        street2?: string | null;
        state: string;
        zip?: string | null;
        deliveryInstructions?: string | null;
        driverAskFor?: string | null;
        phone?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
    } | null;
    totals?: {
      __typename?: 'OrderTotals';
      customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      subTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      preDeliveryDiscountDeliveryFee?: {
        __typename?: 'Money';
        currency: Currency;
        subunits: number;
      } | null;
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type PersonalInformationPageQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type PersonalInformationPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      isCurrentDeviceRecognized?: boolean | null;
      email: string;
      mobilePhoneLastTwo?: string | null;
      industry?: UserIndustryEnum | null;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type PersonalInformationQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type PersonalInformationQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      email2?: string | null;
      mobilePhoneLastTwo?: string | null;
      officePhoneLastTwo?: string | null;
      companyName?: string | null;
      jobTitle?: string | null;
      industry?: UserIndustryEnum | null;
      emailSubscriptionsUrl?: string | null;
      canManageTaxCertificates: boolean;
      email: string;
      fullName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      noncachedemail: string;
      notificationSubscriptions?: {
        __typename?: 'NotificationSubscriptions';
        deliveryUpdate?: {
          __typename?: 'DeliveryUpdateNotificationSubscriptions';
          txt?: boolean | null;
          email?: boolean | null;
          push?: boolean | null;
        } | null;
        catererConfirmation?: {
          __typename?: 'CatererConfirmationNotificationSubscriptions';
          email?: boolean | null;
        } | null;
      } | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type PingQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type PingQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  ping: {__typename?: 'PingPong'; pong?: boolean | null};
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type PopularNearYouQueryVariables = Exact<{
  catererId: Scalars['ID']['input'];
  address: CatererSearchAddress;
  eventDateTime?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type PopularNearYouQuery = {
  __typename?: 'Query';
  popularNearYou?: {
    __typename?: 'PopularNearYou';
    brands: Array<{
      __typename?: 'PopularBrandTile';
      brandName: string;
      catererId: string;
      imageUrl?: string | null;
      urlId: string;
    }>;
  } | null;
};

export type ReceiptsPageQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  eventAfter?: InputMaybe<Scalars['DateTime']['input']>;
  eventBefore?: InputMaybe<Scalars['DateTime']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ReceiptsPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      trackingId: string;
      isCorporate?: boolean | null;
      corpDeptCodesVisible?: boolean | null;
      orders?: {
        __typename?: 'OrderConnection';
        totalCount: number;
        totalCustomerSpend: {__typename?: 'Money'; currency: Currency; subunits: number};
        edges: Array<{
          __typename?: 'OrderEdge';
          node?: {
            __typename?: 'Order';
            id: string;
            uuid: string;
            formattedOrderNumber?: string | null;
            canBeReviewed?: boolean | null;
            isCorporate?: boolean | null;
            isPaymentPending?: boolean | null;
            hasCorpDeptCode?: boolean | null;
            concurOrderStatus?: ConcurOrderStatus | null;
            paidByUserId?: string | null;
            caterer?: {
              __typename?: 'Caterer';
              id: string;
              name: string;
              urlId: string;
              uuid: string;
              isSavedCaterer: boolean;
              brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
            } | null;
            customerOrderStatus?: {
              __typename?: 'CustomerOrderStatus';
              id: string;
              isCancelled?: boolean | null;
              currentStatusDisplay: string;
              isCustomerPaymentCaptured?: boolean | null;
            } | null;
            firstOrderReferenceCode?: {
              __typename?: 'OrderReferenceCode';
              id: string;
              corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
            } | null;
            review?: {
              __typename?: 'Review';
              id?: string | null;
              text?: string | null;
              rating?: StarRating | null;
              deliveryTimeFeedback?: DeliveryTimeFeedback | null;
              deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
              penName?: string | null;
            } | null;
            totals?: {
              __typename?: 'OrderTotals';
              customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
            } | null;
            event?: {
              __typename?: 'Event';
              id: string;
              isTakeout: boolean;
              timestamp?: string | null;
              headcount?: number | null;
              address?: {
                __typename?: 'Address';
                id: string;
                nameOrLocation: string;
                street: string;
                street2?: string | null;
                city: string;
                state: string;
                zip?: string | null;
                latitude?: number | null;
                longitude?: number | null;
              } | null;
            } | null;
            orderReferenceCodes?: Array<{
              __typename?: 'OrderReferenceCode';
              id: string;
              name: string;
              value?: string | null;
              corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
            }> | null;
            corpAccount?: {__typename?: 'CorporateAccount'; id: string; name: string} | null;
            corporateDepartment?: {
              __typename?: 'CorporateDepartment';
              id: string;
              code?: string | null;
            } | null;
          } | null;
        }>;
      } | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        showCorpReferenceCodes?: boolean | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
        corpReferenceCodes?: Array<{
          __typename?: 'CorporateReferenceCode';
          id: string;
          name: string;
          values: Array<string>;
          required: boolean;
        }> | null;
        corpDeptCodes?: Array<{
          __typename?: 'CorporateDepartment';
          id: string;
          name?: string | null;
          code?: string | null;
        }> | null;
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
      concurAccount?: {
        __typename?: 'ConcurAccount';
        id: string;
        areReceiptsAutomated: boolean;
        createdAt: string;
        updatedAt: string;
      } | null;
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type ReceiptsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  eventAfter?: InputMaybe<Scalars['DateTime']['input']>;
  eventBefore?: InputMaybe<Scalars['DateTime']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
  selectedAccountUuidsForOrders?: InputMaybe<
    Array<Scalars['UUID']['input']> | Scalars['UUID']['input']
  >;
}>;

export type ReceiptsQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      email: string;
      trackingId: string;
      canAccessConcur: boolean;
      isCorporate?: boolean | null;
      corpDeptCodesVisible?: boolean | null;
      orders?: {
        __typename?: 'OrderConnection';
        totalCount: number;
        totalCustomerSpend: {__typename?: 'Money'; currency: Currency; subunits: number};
        edges: Array<{
          __typename?: 'OrderEdge';
          node?: {
            __typename?: 'Order';
            id: string;
            uuid: string;
            formattedOrderNumber?: string | null;
            canBeReviewed?: boolean | null;
            isCorporate?: boolean | null;
            isPaymentPending?: boolean | null;
            hasCorpDeptCode?: boolean | null;
            concurOrderStatus?: ConcurOrderStatus | null;
            paidByUserId?: string | null;
            caterer?: {
              __typename?: 'Caterer';
              id: string;
              name: string;
              urlId: string;
              uuid: string;
              isSavedCaterer: boolean;
              brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
            } | null;
            customerOrderStatus?: {
              __typename?: 'CustomerOrderStatus';
              id: string;
              isCancelled?: boolean | null;
              currentStatusDisplay: string;
              isCustomerPaymentCaptured?: boolean | null;
            } | null;
            firstOrderReferenceCode?: {
              __typename?: 'OrderReferenceCode';
              id: string;
              corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
            } | null;
            review?: {
              __typename?: 'Review';
              id?: string | null;
              text?: string | null;
              rating?: StarRating | null;
              deliveryTimeFeedback?: DeliveryTimeFeedback | null;
              deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
              penName?: string | null;
            } | null;
            totals?: {
              __typename?: 'OrderTotals';
              customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
            } | null;
            event?: {
              __typename?: 'Event';
              id: string;
              isTakeout: boolean;
              timestamp?: string | null;
              headcount?: number | null;
              address?: {
                __typename?: 'Address';
                id: string;
                nameOrLocation: string;
                street: string;
                street2?: string | null;
                city: string;
                state: string;
                zip?: string | null;
                latitude?: number | null;
                longitude?: number | null;
              } | null;
            } | null;
            orderReferenceCodes?: Array<{
              __typename?: 'OrderReferenceCode';
              id: string;
              name: string;
              value?: string | null;
              corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
            }> | null;
            corpAccount?: {__typename?: 'CorporateAccount'; id: string; name: string} | null;
            corporateDepartment?: {
              __typename?: 'CorporateDepartment';
              id: string;
              code?: string | null;
            } | null;
          } | null;
        }>;
      } | null;
      concurAccount?: {
        __typename?: 'ConcurAccount';
        id: string;
        areReceiptsAutomated: boolean;
        createdAt: string;
        updatedAt: string;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        showCorpReferenceCodes?: boolean | null;
        corpReferenceCodes?: Array<{
          __typename?: 'CorporateReferenceCode';
          id: string;
          name: string;
          values: Array<string>;
          required: boolean;
        }> | null;
        corpDeptCodes?: Array<{
          __typename?: 'CorporateDepartment';
          id: string;
          name?: string | null;
          code?: string | null;
        }> | null;
      } | null;
      ownedCorporateAccounts?: Array<{__typename?: 'CorpAccount'; id: string}> | null;
    } | null;
  } | null;
};

export type RecommendedDefaultAddressQueryVariables = Exact<{
  useGeoIP?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type RecommendedDefaultAddressQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {__typename?: 'ConsumerAccount'; id: string} | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type ReferAFriendDescriptionQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ReferAFriendDescriptionQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      giftCardRedemptionAllowed?: boolean | null;
      referAFriendEligible: boolean;
      referralUrl?: string | null;
      referralCode?: string | null;
    } | null;
  } | null;
};

export type ReferAFriendPageQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ReferAFriendPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      giftCardRedemptionAllowed?: boolean | null;
      referralUrl?: string | null;
      referralCode?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type ReferralRewardsSummaryQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ReferralRewardsSummaryQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      invitedReferrals: {__typename?: 'ReferralConnection'; totalCount: number};
      joinedReferrals: {__typename?: 'ReferralConnection'; totalCount: number};
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        referralEarnings?: {__typename?: 'EzRewardsActivityConnection'; totalAmount: number} | null;
        friendsWhoOrdered?: {__typename?: 'EzRewardsActivityConnection'; totalCount: number} | null;
      } | null;
    } | null;
  } | null;
};

export type ReferralsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ReferralsQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      referrals: {
        __typename?: 'ReferralConnection';
        totalCount: number;
        nodes?: Array<{
          __typename?: 'Referral';
          id: string;
          email: string;
          date?: string | null;
          status?: ReferralStatusEnum | null;
          reminder?: {
            __typename?: 'ReferralReminder';
            id: string;
            type?: ReferralReminderTypeEnum | null;
            status?: ReferralReminderStatusTypeEnum | null;
          } | null;
        } | null> | null;
      };
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        activities?: {__typename?: 'EzRewardsActivityConnection'; totalAmount: number} | null;
      } | null;
    } | null;
  } | null;
};

export type ReferralsTableQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ReferralsTableQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      referrals: {
        __typename?: 'ReferralConnection';
        totalCount: number;
        nodes?: Array<{
          __typename?: 'Referral';
          id: string;
          email: string;
          date?: string | null;
          status?: ReferralStatusEnum | null;
          pointsEarned?: number | null;
          reminder?: {
            __typename?: 'ReferralReminder';
            id: string;
            type?: ReferralReminderTypeEnum | null;
            status?: ReferralReminderStatusTypeEnum | null;
          } | null;
        } | null> | null;
      };
    } | null;
  } | null;
};

export type ReviewModalQueryVariables = Exact<{[key: string]: never}>;

export type ReviewModalQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      firstName?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type ReviewableOrdersQueryVariables = Exact<{
  ordersLimit?: InputMaybe<Scalars['Int']['input']>;
  selectedAccountUuidsForOrders?: InputMaybe<
    Array<Scalars['UUID']['input']> | Scalars['UUID']['input']
  >;
}>;

export type ReviewableOrdersQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      accountIdentifier: string;
      orders?: {
        __typename?: 'OrderConnection';
        nodes?: Array<{
          __typename?: 'Order';
          id: string;
          uuid: string;
          daysLeftToReview?: number | null;
          isReviewDeadlineApproaching?: boolean | null;
          orderSourceType?: OrderSource | null;
          event?: {
            __typename?: 'Event';
            id: string;
            date?: string | null;
            timestamp?: string | null;
            isTakeout: boolean;
          } | null;
          caterer?: {
            __typename?: 'Caterer';
            id: string;
            uuid: string;
            name: string;
            isSavedCaterer: boolean;
            brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ReviewsForTablesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  selectedAccountUuidsForOrders?: InputMaybe<
    Array<Scalars['UUID']['input']> | Scalars['UUID']['input']
  >;
}>;

export type ReviewsForTablesQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      reviewableOrders?: {
        __typename?: 'OrderConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'OrderEdge';
          node?: {
            __typename?: 'Order';
            id: string;
            uuid: string;
            daysLeftToReview?: number | null;
            isReviewDeadlineApproaching?: boolean | null;
            caterer?: {
              __typename?: 'Caterer';
              id: string;
              isSavedCaterer: boolean;
              uuid: string;
              name: string;
              brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
            } | null;
            review?: {
              __typename?: 'Review';
              id?: string | null;
              text?: string | null;
              rating?: StarRating | null;
              deliveryTimeFeedback?: DeliveryTimeFeedback | null;
              deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
              penName?: string | null;
            } | null;
            event?: {
              __typename?: 'Event';
              id: string;
              timestamp?: string | null;
              isTakeout: boolean;
              address?: {
                __typename?: 'Address';
                id: string;
                name?: string | null;
                city: string;
                state: string;
                nameOrLocation: string;
              } | null;
            } | null;
          } | null;
        }>;
      } | null;
    } | null;
  } | null;
};

export type ReviewsPageQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
  selectedAccountUuidsForOrders?: InputMaybe<
    Array<Scalars['UUID']['input']> | Scalars['UUID']['input']
  >;
}>;

export type ReviewsPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      eligibleForAdditionalEzRewards: boolean;
      enrolledInEzRewards?: boolean | null;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
      reviewableOrders?: {
        __typename?: 'OrderConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'OrderEdge';
          node?: {
            __typename?: 'Order';
            id: string;
            uuid: string;
            daysLeftToReview?: number | null;
            isReviewDeadlineApproaching?: boolean | null;
            caterer?: {
              __typename?: 'Caterer';
              id: string;
              isSavedCaterer: boolean;
              uuid: string;
              name: string;
              brand?: {__typename?: 'Brand'; id: string; uuid: string} | null;
            } | null;
            review?: {
              __typename?: 'Review';
              id?: string | null;
              text?: string | null;
              rating?: StarRating | null;
              deliveryTimeFeedback?: DeliveryTimeFeedback | null;
              deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
              penName?: string | null;
            } | null;
            event?: {
              __typename?: 'Event';
              id: string;
              timestamp?: string | null;
              isTakeout: boolean;
              address?: {
                __typename?: 'Address';
                id: string;
                name?: string | null;
                city: string;
                state: string;
                nameOrLocation: string;
              } | null;
            } | null;
          } | null;
        }>;
      } | null;
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type SavedAddressSearchQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  corpAccountId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SavedAddressSearchQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      addresses?: {
        __typename?: 'AddressConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'AddressEdge';
          node?: {
            __typename?: 'Address';
            id: string;
            name?: string | null;
            fullAddress: string;
            street: string;
            city: string;
            state: string;
            uuid: string;
            addressBookEntryId?: number | null;
            addressBookEntry?: {
              __typename?: 'AddressBookEntry';
              id: string;
              corporate: boolean;
            } | null;
          } | null;
        }>;
      } | null;
    } | null;
  } | null;
};

export type SavedCaterersPageQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type SavedCaterersPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  savedCaterers: {
    __typename?: 'SavedCatererConnection';
    totalCount: number;
    nodes?: Array<{
      __typename?: 'Caterer';
      id: string;
      uuid: string;
      name: string;
      isSavedCaterer: boolean;
      isReliabilityRockstar: boolean;
      isNew: boolean;
      urlId: string;
      starRating?: number | null;
      rewardsLevel?: number | null;
      address?: {__typename?: 'Address'; id: string; fullAddress: string} | null;
      minimumDeliveryFee: {
        __typename?: 'MinimumDeliveryFee';
        amount: {__typename?: 'Money'; subunits: number};
      };
      takeoutMinimum?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      brand?: {
        __typename?: 'Brand';
        id: string;
        uuid: string;
        heroImage?: {__typename?: 'Image'; uuid: string; mobileSearchUrl?: string | null} | null;
      } | null;
    } | null> | null;
  };
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      addresses?: {
        __typename?: 'AddressConnection';
        nodes?: Array<{__typename?: 'Address'; id: string; uuid: string} | null> | null;
      } | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  graphExperiments?: {
    __typename?: 'GraphExperiments';
    deliveryFeeExperiment: {
      __typename?: 'DeliveryFeeExperimentVersions';
      v2?: {
        __typename?: 'DeliveryFeeExperimentAssignmentV2';
        flagKey: string;
        allocationKey: string;
        experimentKey: string;
        variation: string;
        pricingModel:
          | {
              __typename: 'CappedDeliveryFeePricingModel';
              cap: {__typename?: 'Money'; subunits: number; currency: Currency};
            }
          | {__typename: 'StandardDeliveryFeePricingModel'};
      } | null;
    };
  } | null;
};

export type SavedCaterersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SavedCaterersQuery = {
  __typename?: 'Query';
  savedCaterers: {
    __typename?: 'SavedCatererConnection';
    edges: Array<{
      __typename?: 'SavedCatererEdge';
      node?: {
        __typename?: 'Caterer';
        id: string;
        uuid: string;
        name: string;
        isSavedCaterer: boolean;
        isReliabilityRockstar: boolean;
        isNew: boolean;
        urlId: string;
        starRating?: number | null;
        rewardsLevel?: number | null;
        address?: {__typename?: 'Address'; id: string; fullAddress: string} | null;
        minimumDeliveryFee: {
          __typename?: 'MinimumDeliveryFee';
          amount: {__typename?: 'Money'; subunits: number};
        };
        takeoutMinimum?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        brand?: {
          __typename?: 'Brand';
          id: string;
          uuid: string;
          heroImage?: {__typename?: 'Image'; uuid: string; mobileSearchUrl?: string | null} | null;
        } | null;
      } | null;
    }>;
  };
};

export type SearchCollectionQueryVariables = Exact<{
  collectionUuid: Scalars['UUID']['input'];
  address: CatererSearchAddress;
  eventDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  eventTime?: InputMaybe<Scalars['TimeWithoutZone']['input']>;
  orderType?: InputMaybe<CatererSearchOrderType>;
  trackingId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SearchCollectionQuery = {
  __typename?: 'Query';
  marketplaceSearchCollection: {
    __typename?: 'MarketplaceSearchCollection';
    id: string;
    analyticsSearchId: string;
    title: string;
    caterers: Array<{
      __typename?: 'CatererSearchResult';
      id: string;
      uuid: string;
      name: string;
      imageSrc?: string | null;
      urlId: string;
      distance: number;
      isNew: boolean;
      isSavedCaterer: boolean;
      isReliabilityRockstar: boolean;
      priceRating?: number | null;
      starRating?: number | null;
      topsortProductId: string;
      cacheKey: string;
      reviewCount: number;
      variableDeliveryFee?: boolean | null;
      onTimeRating?: number | null;
      lastOrderAt?: string | null;
      latestBrandReviewText?: string | null;
      latestBrandReviewAt?: string | null;
      latestReviewText?: string | null;
      latestReviewAt?: string | null;
      repeatUserRate?: number | null;
      rewardsLevel: number;
      sponsoredPromoTitles?: Array<string | null> | null;
      searchResultBrand: {
        __typename?: 'SearchResultBrand';
        id: string;
        uuid?: string | null;
        logoImageSrc?: string | null;
      };
      slotReservation:
        | {__typename?: 'NoReservation'}
        | {__typename?: 'SponsoredListingReservation'; topsortBidId?: string | null};
      deliveryMinimum: {__typename?: 'Money'; subunits: number; currency: Currency};
      deliveryFee: {__typename?: 'Money'; subunits: number; currency: Currency};
      takeoutMinimum?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
    }>;
  };
};

export type SearchCuisineMetroPageQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type SearchCuisineMetroPageQuery = {
  __typename?: 'Query';
  nationwideCatererCount: number;
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  graphExperiments?: {
    __typename?: 'GraphExperiments';
    deliveryFeeExperiment: {
      __typename?: 'DeliveryFeeExperimentVersions';
      v2?: {
        __typename?: 'DeliveryFeeExperimentAssignmentV2';
        flagKey: string;
        allocationKey: string;
        experimentKey: string;
        variation: string;
        pricingModel:
          | {
              __typename: 'CappedDeliveryFeePricingModel';
              cap: {__typename?: 'Money'; subunits: number; currency: Currency};
            }
          | {__typename: 'StandardDeliveryFeePricingModel'};
      } | null;
    };
  } | null;
};

export type SearchMetroPageQueryVariables = Exact<{
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type SearchMetroPageQuery = {
  __typename?: 'Query';
  nationwideCatererCount: number;
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  graphExperiments?: {
    __typename?: 'GraphExperiments';
    deliveryFeeExperiment: {
      __typename?: 'DeliveryFeeExperimentVersions';
      v2?: {
        __typename?: 'DeliveryFeeExperimentAssignmentV2';
        flagKey: string;
        allocationKey: string;
        experimentKey: string;
        variation: string;
        pricingModel:
          | {
              __typename: 'CappedDeliveryFeePricingModel';
              cap: {__typename?: 'Money'; subunits: number; currency: Currency};
            }
          | {__typename: 'StandardDeliveryFeePricingModel'};
      } | null;
    };
  } | null;
};

export type SearchPageOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  trackOrderUsage?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SearchPageOrderQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  nationwideCatererCount: number;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {__typename?: 'ConsumerAccount'; id: string} | null;
    adminAccount?: {__typename?: 'AdminAccount'; id: string} | null;
  } | null;
  fulfillmentDetail?: {
    __typename?: 'FulfillmentDetail';
    id: string;
    editable: boolean;
    eventAt?: string | null;
    eventLocalTime?: string | null;
    eventName?: string | null;
    eventOn?: string | null;
    headcount?: number | null;
    strategy: FulfillmentDetailStrategy;
    address: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      street: string;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      fullAddress: string;
      metropolitanStatisticalArea?: string | null;
      timeZoneIdentifier: string;
    };
    corpAccount?: {
      __typename?: 'CorporateAccount';
      id: string;
      uuid: string;
      isParent?: boolean | null;
      name: string;
      displayName?: string | null;
      collectsAllEzRewards: boolean;
      logoIconUrl?: string | null;
      deliverySettings?: {
        __typename?: 'DeliverySettings';
        deliveryFeeCapEnabled: boolean;
        deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
    } | null;
  } | null;
};

export type SearchPageQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  trackOrderUsage?: InputMaybe<Scalars['Boolean']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type SearchPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  nationwideCatererCount: number;
  fulfillmentDetail?: {
    __typename?: 'FulfillmentDetail';
    id: string;
    editable: boolean;
    eventAt?: string | null;
    eventLocalTime?: string | null;
    eventName?: string | null;
    eventOn?: string | null;
    headcount?: number | null;
    strategy: FulfillmentDetailStrategy;
    address: {
      __typename?: 'Address';
      id: string;
      name?: string | null;
      street: string;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      fullAddress: string;
      metropolitanStatisticalArea?: string | null;
      timeZoneIdentifier: string;
    };
    corpAccount?: {
      __typename?: 'CorporateAccount';
      id: string;
      uuid: string;
      isParent?: boolean | null;
      name: string;
      displayName?: string | null;
      collectsAllEzRewards: boolean;
      logoIconUrl?: string | null;
      deliverySettings?: {
        __typename?: 'DeliverySettings';
        deliveryFeeCapEnabled: boolean;
        deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  graphExperiments?: {
    __typename?: 'GraphExperiments';
    deliveryFeeExperiment: {
      __typename?: 'DeliveryFeeExperimentVersions';
      v2?: {
        __typename?: 'DeliveryFeeExperimentAssignmentV2';
        flagKey: string;
        allocationKey: string;
        experimentKey: string;
        variation: string;
        pricingModel:
          | {
              __typename: 'CappedDeliveryFeePricingModel';
              cap: {__typename?: 'Money'; subunits: number; currency: Currency};
            }
          | {__typename: 'StandardDeliveryFeePricingModel'};
      } | null;
    };
  } | null;
};

export type SearchQueryVariables = Exact<{
  address: CatererSearchAddress;
  eventDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  eventTime?: InputMaybe<Scalars['TimeWithoutZone']['input']>;
  filter?: InputMaybe<MarketplaceCatererSearchFilter>;
  includeCaterers?: InputMaybe<Scalars['Boolean']['input']>;
  includeCarousels?: InputMaybe<Scalars['Boolean']['input']>;
  includeSponsoredListingsEligibilitySearch?: InputMaybe<Scalars['Boolean']['input']>;
  includeTagline?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderType?: InputMaybe<CatererSearchOrderType>;
  shouldIncludeSponsoredListings?: InputMaybe<Scalars['Boolean']['input']>;
  skipSearchTracking?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SearchQuery = {
  __typename?: 'Query';
  marketplaceSearchV2: {
    __typename?: 'MarketplaceSearchResults';
    id: string;
    analyticsSearchId: string;
    brandHit?: {
      __typename?: 'BrandSearchHit';
      name?: string | null;
      unavailabilityReason?: UnavailabilityReason | null;
      leadTime?: string | null;
      dayBeforeCutoffTime?: string | null;
      caterer?: {
        __typename?: 'CatererSearchResult';
        id: string;
        uuid: string;
        name: string;
        imageSrc?: string | null;
        urlId: string;
        distance: number;
        isNew: boolean;
        isSavedCaterer: boolean;
        isReliabilityRockstar: boolean;
        priceRating?: number | null;
        starRating?: number | null;
        topsortProductId: string;
        cacheKey: string;
        reviewCount: number;
        variableDeliveryFee?: boolean | null;
        onTimeRating?: number | null;
        lastOrderAt?: string | null;
        latestBrandReviewText?: string | null;
        latestBrandReviewAt?: string | null;
        latestReviewText?: string | null;
        latestReviewAt?: string | null;
        repeatUserRate?: number | null;
        rewardsLevel: number;
        sponsoredPromoTitles?: Array<string | null> | null;
        searchResultBrand: {
          __typename?: 'SearchResultBrand';
          id: string;
          uuid?: string | null;
          logoImageSrc?: string | null;
        };
        slotReservation:
          | {__typename?: 'NoReservation'}
          | {__typename?: 'SponsoredListingReservation'; topsortBidId?: string | null};
        deliveryMinimum: {__typename?: 'Money'; subunits: number; currency: Currency};
        deliveryFee: {__typename?: 'Money'; subunits: number; currency: Currency};
        takeoutMinimum?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      } | null;
      operatingSchedule?: {
        __typename?: 'OperatingScheduleOpenClose';
        openTime?: string | null;
        closeTime?: string | null;
      } | null;
    } | null;
    caterers?: {
      __typename?: 'CatererSearchConnection';
      id: string;
      totalCount: number;
      visibleCount: number;
      nodes?: Array<{
        __typename?: 'CatererSearchResult';
        id: string;
        uuid: string;
        name: string;
        imageSrc?: string | null;
        urlId: string;
        distance: number;
        isNew: boolean;
        isSavedCaterer: boolean;
        isReliabilityRockstar: boolean;
        priceRating?: number | null;
        starRating?: number | null;
        topsortProductId: string;
        cacheKey: string;
        reviewCount: number;
        variableDeliveryFee?: boolean | null;
        onTimeRating?: number | null;
        lastOrderAt?: string | null;
        latestBrandReviewText?: string | null;
        latestBrandReviewAt?: string | null;
        latestReviewText?: string | null;
        latestReviewAt?: string | null;
        repeatUserRate?: number | null;
        rewardsLevel: number;
        sponsoredPromoTitles?: Array<string | null> | null;
        searchResultBrand: {
          __typename?: 'SearchResultBrand';
          id: string;
          uuid?: string | null;
          logoImageSrc?: string | null;
        };
        slotReservation:
          | {__typename?: 'NoReservation'}
          | {__typename?: 'SponsoredListingReservation'; topsortBidId?: string | null};
        deliveryMinimum: {__typename?: 'Money'; subunits: number; currency: Currency};
        deliveryFee: {__typename?: 'Money'; subunits: number; currency: Currency};
        takeoutMinimum?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      } | null> | null;
    };
    previouslyEngagedCaterers: Array<{
      __typename?: 'CatererSearchResult';
      cacheKey: string;
      name: string;
      id: string;
      imageSrc?: string | null;
      isReliabilityRockstar: boolean;
      isSavedCaterer: boolean;
      urlId: string;
      uuid: string;
      searchResultBrand: {__typename?: 'SearchResultBrand'; id: string; uuid?: string | null};
      previousEngagement?:
        | {__typename?: 'BrandEngagement'; id: string; lastOrderedFrom?: string | null}
        | {__typename?: 'CatererEngagement'; id: string; lastOrderedFrom?: string | null}
        | {__typename?: 'CorpAccountEngagement'; id: string; lastOrderedFrom?: string | null}
        | null;
    }>;
    catererCarousels?: Array<{
      __typename?: 'CatererCarousel';
      id: string;
      uuid: string;
      name: string;
      tagline?: string;
      title: string;
      carouselType: CarouselType;
      caterers: Array<{
        __typename?: 'CatererSearchResult';
        cacheKey: string;
        id: string;
        imageSrc?: string | null;
        distance: number;
        isReliabilityRockstar: boolean;
        name: string;
        starRating?: number | null;
        urlId: string;
        uuid: string;
        deliveryFee: {__typename?: 'Money'; currency: Currency; subunitsV2: string};
        slotReservation:
          | {__typename: 'NoReservation'}
          | {__typename: 'SponsoredListingReservation'; topsortBidId?: string | null};
      }>;
    }>;
  };
  sponsoredListingsEligibilitySearch?: {
    __typename?: 'MarketplaceSearchResults';
    id: string;
    caterers: {
      __typename?: 'CatererSearchConnection';
      id: string;
      nodes?: Array<{
        __typename?: 'CatererSearchResult';
        id: string;
        cacheKey: string;
        slotReservation:
          | {__typename: 'NoReservation'}
          | {__typename: 'SponsoredListingReservation'; topsortBidId?: string | null};
      } | null> | null;
    };
  };
};

export type SeoMetroNeighborhoodsQueryVariables = Exact<{
  metro: Scalars['String']['input'];
  stateAbbreviation: Scalars['String']['input'];
  catererLimit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SeoMetroNeighborhoodsQuery = {
  __typename?: 'Query';
  seoMetro?: {
    __typename?: 'SeoMetro';
    latitude: number;
    longitude: number;
    name: string;
    state: {__typename?: 'SeoMetroState'; abbreviation: string; name: string};
    neighborhoods: Array<{
      __typename?: 'SeoMetroNeighborhood';
      latitude: number;
      longitude: number;
      locationType: SeoMetroNeighborhoodLocation;
      name: string;
      rank?: number | null;
      caterers?: Array<{__typename?: 'Caterer'; id: string; uuid: string; name: string}> | null;
    }>;
  } | null;
};

export type SimilarCaterersQueryVariables = Exact<{
  address: CatererSearchAddress;
  eventDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  eventTime?: InputMaybe<Scalars['TimeWithoutZone']['input']>;
  orderType?: InputMaybe<CatererSearchOrderType>;
  filter?: InputMaybe<MarketplaceCatererSearchFilter>;
}>;

export type SimilarCaterersQuery = {
  __typename?: 'Query';
  marketplaceSearchV2: {
    __typename?: 'MarketplaceSearchResults';
    id: string;
    caterers: {
      __typename?: 'CatererSearchConnection';
      id: string;
      nodes?: Array<{
        __typename?: 'CatererSearchResult';
        id: string;
        uuid: string;
        name: string;
        starRating?: number | null;
        reviewCount: number;
        isReliabilityRockstar: boolean;
        cacheKey: string;
        urlId: string;
        imageSrc?: string | null;
        variableDeliveryFee?: boolean | null;
        deliveryFee: {__typename?: 'Money'; subunits: number; currency: Currency};
        deliveryMinimum: {__typename?: 'Money'; subunits: number; currency: Currency};
        takeoutMinimum?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        searchResultBrand: {
          __typename?: 'SearchResultBrand';
          id: string;
          uuid?: string | null;
          mobileHeroImageSrc?: string | null;
          imageFullPath?: string | null;
        };
      } | null> | null;
    };
  };
};

export type StoreCampaignQueryVariables = Exact<{[key: string]: never}>;

export type StoreCampaignQuery = {
  __typename?: 'Query';
  activeStoreCampaign?: {
    __typename?: 'StoreCampaign';
    id: string;
    active: boolean;
    title: string;
    description: string;
    startsOn: string;
    endsOn: string;
    features: JSONValue;
    termsAndConditions?: string | null;
    promoCode?: {
      __typename?: 'PromoCode';
      id: string;
      promo: {
        __typename?: 'Promo';
        id: string;
        active: boolean;
        description: string;
        discountAmount?: number | null;
        expiresOn?: string | null;
        finePrint?: string | null;
        termsAndConditionsUrl?: string | null;
        title: string;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      };
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      assignedPromoCode?: {
        __typename?: 'UserPromoCodeAssignment';
        promo: {
          __typename?: 'Promo';
          id: string;
          active: boolean;
          description: string;
          discountAmount?: number | null;
          expiresOn?: string | null;
          finePrint?: string | null;
          termsAndConditionsUrl?: string | null;
          title: string;
          promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
        };
      } | null;
    } | null;
  } | null;
};

export type SubmittedOrdersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  eventAfter: Scalars['DateTime']['input'];
  eventBefore: Scalars['DateTime']['input'];
}>;

export type SubmittedOrdersQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      orders?: {
        __typename?: 'OrderConnection';
        totalCount: number;
        nodes?: Array<{
          __typename?: 'Order';
          id: string;
          formattedOrderNumber?: string | null;
          event?: {
            __typename?: 'Event';
            id: string;
            timestamp?: string | null;
            timeZoneOffset?: string | null;
          } | null;
          caterer?: {__typename?: 'Caterer'; id: string; name: string} | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type SystemMessageQueryVariables = Exact<{[key: string]: never}>;

export type SystemMessageQuery = {
  __typename?: 'Query';
  systemMessage?: {
    __typename?: 'SystemMessage';
    message: string;
    updatedAt: string;
    linkText?: string | null;
    url?: string | null;
  } | null;
};

export type TakeoutAvailableQueryVariables = Exact<{
  orderAt: Scalars['DateTime']['input'];
  catererId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TakeoutAvailableQuery = {
  __typename?: 'Query';
  caterer?: {__typename?: 'Caterer'; id: string; isTakeoutAvailable: boolean} | null;
};

export type TypeaheadSearchQueryVariables = Exact<{
  isPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleZipMetro?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  term: Scalars['String']['input'];
  trackingId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TypeaheadSearchQuery = {
  __typename?: 'Query';
  typeaheadSearch: Array<{
    __typename?: 'TypeaheadResult';
    display: string;
    id: string;
    logoImageId: number;
    type: TypeaheadDocType;
  }>;
};

export type UpcomingOrderCardsQueryVariables = Exact<{[key: string]: never}>;

export type UpcomingOrderCardsQuery = {
  __typename?: 'Query';
  upcomingOrderCards: Array<{
    __typename?: 'UpcomingOrderCard';
    uuid: string;
    status: UpcomingOrderStatusEnum;
    isLate: boolean;
    type: OrderTypeEnum;
    trackingUrl?: string | null;
    url: string;
    eventAt: string;
    estimatedArrivalAt?: string | null;
    address: {
      __typename?: 'Address';
      id: string;
      nameOrLocation: string;
      timeZoneIdentifier: string;
    };
    caterer: {
      __typename?: 'DiscoveryCaterer';
      id: string;
      name: string;
      logoUrl?: string | null;
      address?: {__typename?: 'Address'; id: string; street: string} | null;
      image?: {__typename?: 'Image'; uuid: string; mobileHeroUrl?: string | null} | null;
    };
  }>;
};

export type UserConnectionsAllAccountMembersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UserConnectionsAllAccountMembersQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      potentialUserConnections: {
        __typename?: 'PotentialUserConnectionConnection';
        edges: Array<{
          __typename?: 'PotentialUserConnectionEdge';
          node?: {
            __typename?: 'PotentialUserConnection';
            id: string;
            email: string;
            fullName: string;
            initials: string;
            isPending: boolean;
            isConnected: boolean;
            uuid: string;
          } | null;
        }>;
      };
    } | null;
  } | null;
};

export type UserConnectionsPageQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type UserConnectionsPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      userConnections: {
        __typename?: 'UserConnectionConnection';
        edges: Array<{
          __typename?: 'UserConnectionEdge';
          node?: {
            __typename?: 'UserConnection';
            id: string;
            connectedUserId: string;
            email: string;
            fullName: string;
            initials: string;
            subscribedToOrderNotifications: boolean;
          } | null;
        }>;
      };
      potentialUserConnections: {
        __typename?: 'PotentialUserConnectionConnection';
        edges: Array<{
          __typename?: 'PotentialUserConnectionEdge';
          node?: {
            __typename?: 'PotentialUserConnection';
            id: string;
            email: string;
            fullName: string;
            initials: string;
            isPending: boolean;
            isConnected: boolean;
            uuid: string;
          } | null;
        }>;
      };
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type UserConnectionsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;

export type UserConnectionsQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      corporateAccount?: {__typename?: 'CorporateAccount'; id: string} | null;
      userConnections: {
        __typename?: 'UserConnectionConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'UserConnectionEdge';
          node?: {
            __typename?: 'UserConnection';
            id: string;
            connectedUserId: string;
            email: string;
            fullName: string;
            initials: string;
            subscribedToOrderNotifications: boolean;
          } | null;
        }>;
      };
    } | null;
  } | null;
};

export type UserConnectionsRequestsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UserConnectionsRequestsQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      pendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        edges: Array<{
          __typename?: 'UserConnectionInvitationEdge';
          node?: {
            __typename?: 'UserConnectionInvitation';
            id: string;
            initiatingUserId: string;
            email: string;
            fullName: string;
            initials: string;
          } | null;
        }>;
      };
    } | null;
  } | null;
};

export type UserEventsHistoryQueryVariables = Exact<{
  userUuid: Scalars['ID']['input'];
}>;

export type UserEventsHistoryQuery = {
  __typename?: 'Query';
  userDcEventHistories: Array<{
    __typename?: 'DcEventHistory';
    orderUuid: string;
    events: Array<{
      __typename?: 'DcEvent';
      at: string;
      type: DcEventTypes;
      reference:
        | {
            __typename?: 'DecisionPoint';
            id: string;
            responderType: ActorTypes;
            responderUuid: string;
          }
        | {
            __typename?: 'Message';
            id: string;
            content: string;
            sentByType: ActorTypes;
            sentById: string;
            reviewedAt?: string | null;
            orderInfo: {__typename?: 'OrderInfo'; id: string; brandName: string};
            request?:
              | {
                  __typename?: 'OrderItemChangeRequest';
                  id: string;
                  orderInfo: {
                    __typename?: 'OrderInfo';
                    id: string;
                    brandName: string;
                    eventAt: string;
                    orderNumber: string;
                    userUuid: string;
                  };
                }
              | {
                  __typename?: 'TimeChangeRequest';
                  id: string;
                  orderInfo: {
                    __typename?: 'OrderInfo';
                    id: string;
                    brandName: string;
                    eventAt: string;
                    orderNumber: string;
                    userUuid: string;
                  };
                }
              | null;
          }
        | {
            __typename?: 'OrderItemChangeRequest';
            id: string;
            status: RequestStatus;
            requestedById: string;
            orderInfo: {
              __typename?: 'OrderInfo';
              id: string;
              brandName: string;
              eventAt: string;
              orderNumber: string;
              userUuid: string;
            };
            itemChanges: Array<{
              __typename?: 'ItemChange';
              changeType: OrderItemChangeTypes;
              originalItemJson: string;
              proposedItemJson: string;
              reason?: string | null;
              decisionPoint: {
                __typename?: 'DecisionPoint';
                id: string;
                response?: boolean | null;
                responderType: ActorTypes;
              };
            }>;
          }
        | {
            __typename?: 'TimeChangeRequest';
            id: string;
            reason?: string | null;
            status: RequestStatus;
            originalEventAt: string;
            proposedEventAt: string;
            requestedById: string;
            orderInfo: {
              __typename?: 'OrderInfo';
              id: string;
              brandName: string;
              eventAt: string;
              orderNumber: string;
              userUuid: string;
            };
            decisionPoints: Array<{
              __typename?: 'DecisionPoint';
              id: string;
              responderType: ActorTypes;
              responderUuid: string;
              response?: boolean | null;
              activatedAt?: string | null;
              completedAt?: string | null;
            }>;
          };
    }>;
    lastReadEventIndices: Array<{
      __typename?: 'LastReadDcEventIndex';
      readAt: string;
      readByType: ActorTypes;
    }>;
  }>;
};

export type ViewOrderPageQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  accountUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type ViewOrderPageQuery = {
  __typename?: 'Query';
  currentUserTrackingId: string;
  currentUserHashedTrackingId: string;
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    intercomToken?: string | null;
    recommendedDefaultAddress?: {
      __typename?: 'GeocodedAddressResult';
      street: string;
      street2?: string | null;
      city: string;
      state: string;
      zip?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
  order?: {
    __typename?: 'Order';
    id: string;
    corpAccountName?: string | null;
    notificationsEnabled: boolean;
    isMissingRequiredFullAuth: boolean;
    isEzOrderingOrder: boolean;
    hasPunchout: boolean;
    canBeReviewed?: boolean | null;
    formattedOrderNumber?: string | null;
    isStandardGroupOrder: boolean;
    uuid: string;
    approvalDeadline?: string | null;
    corpAccount?: {
      __typename?: 'CorporateAccount';
      id: string;
      deliverySettings?: {
        __typename?: 'DeliverySettings';
        deliveryFeeCapEnabled: boolean;
        deliveryFeeCap?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      } | null;
      procurementSettings?: {
        __typename?: 'ProcurementSettings';
        cartEditsEnabled: boolean;
        creditCardPaymentAllowed: boolean;
      } | null;
    } | null;
    orderCustomer?: {__typename?: 'OrderCustomer'; id: string; firstName?: string | null} | null;
    paymentMethod?:
      | {
          __typename?: 'CreditCard';
          id: string;
          last4?: string | null;
          cardholderName: string;
          missingZipCode: boolean;
          cardType?: CardType | null;
        }
      | {
          __typename?: 'CreditLine';
          id: string;
          allowedUse: CreditLineAllowedUse;
          corpAccountName?: string | null;
        }
      | null;
    cancellationPolicyDisplay?: {
      __typename?: 'OrderCancellationPolicyDisplay';
      hasCancellationFee: boolean;
      feePercentage: number;
      cancelWithoutPenaltyUntil?: string | null;
      cancellationWindowHours: number;
      isWaiverEligible: boolean;
      feeAmount?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
    } | null;
    delivery?: {
      __typename?: 'DmDelivery';
      id: string;
      estimatedDropoffTime?: string | null;
      tracking?: {__typename?: 'DmDeliveryTracking'; url: string} | null;
      deliveryEvents: Array<{
        __typename?: 'DmDeliveryEvent';
        id: string;
        eventType: DmDeliveryEventTypes;
        time: string;
      }>;
    } | null;
    review?: {
      __typename?: 'Review';
      id?: string | null;
      text?: string | null;
      rating?: StarRating | null;
      deliveryTimeFeedback?: DeliveryTimeFeedback | null;
      deliveryProfessionalismFeedback?: DeliveryProfessionalismFeedback | null;
      penName?: string | null;
    } | null;
    tableware: {
      __typename?: 'TablewareSummary';
      specialInstructions?: string | null;
      includedUtensils: Array<string>;
      omittedUtensils: Array<string>;
    };
    corporateOrderReferenceCodes?: Array<{
      __typename?: 'OrderReferenceCode';
      id: string;
      name: string;
      value?: string | null;
      corporateReferenceCode?: {__typename?: 'CorporateReferenceCode'; id: string} | null;
    }> | null;
    corporateReferenceCodes: Array<{
      __typename?: 'CorporateReferenceCode';
      id: string;
      active: boolean;
      name: string;
      required: boolean;
      requiresCreditLine: boolean;
      type: CorpCustomCheckoutFieldEntry;
      values: Array<string>;
      procurement: boolean;
      currentValue?: string | null;
    }>;
    cart?: {
      __typename?: 'Cart';
      id: string;
      productCatalog: ProductCatalog;
      lineItems: Array<{
        __typename?: 'LineItem';
        id: string;
        name?: string | null;
        type?: LineItemTypeEnum | null;
        cost?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
      }>;
      orderItems: Array<{
        __typename?: 'OrderItem';
        id: string;
        name?: string | null;
        price?: number | null;
        quantity: number;
        size?: string | null;
        sizeLabel?: string | null;
        specialInstructions?: string | null;
        vegetarianQuantity?: number | null;
        serves?: number | null;
        groupOrderPersonName?: string | null;
        belongsToAnyEater: boolean;
        totalInSubunits?: {__typename?: 'Money'; currency: Currency; subunits: number} | null;
        orderItemOptions?: Array<{
          __typename?: 'OrderItemOption';
          id: string;
          catererLabel?: string | null;
          itemChoices: Array<{
            __typename?: 'OrderItemChoice';
            id: string;
            name?: string | null;
            price?: number | null;
          }>;
        } | null> | null;
        modifiers?: Array<{
          __typename?: 'LineItemModifier';
          id: string;
          name: string;
          quantity: number;
          modifiers?: Array<{
            __typename?: 'LineItemModifier';
            id: string;
            name: string;
            quantity: number;
            modifiers?: Array<{
              __typename?: 'LineItemModifier';
              id: string;
              name: string;
              quantity: number;
              modifiers?: Array<{
                __typename?: 'LineItemModifier';
                id: string;
                name: string;
                quantity: number;
                modifiers?: Array<{
                  __typename?: 'LineItemModifier';
                  id: string;
                  name: string;
                  quantity: number;
                  price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                  modifierGroup: {
                    __typename?: 'LineItemModifierGroup';
                    id: string;
                    name?: string | null;
                  };
                }> | null;
                price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
                modifierGroup: {
                  __typename?: 'LineItemModifierGroup';
                  id: string;
                  name?: string | null;
                };
              }> | null;
              price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
              modifierGroup: {
                __typename?: 'LineItemModifierGroup';
                id: string;
                name?: string | null;
              };
            }> | null;
            price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
            modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
          }> | null;
          price?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
          modifierGroup: {__typename?: 'LineItemModifierGroup'; id: string; name?: string | null};
        }> | null;
      }>;
      tip: {__typename?: 'Tip'; id: string; amount?: number | null};
    } | null;
    caterer?: {
      __typename?: 'Caterer';
      id: string;
      uuid: string;
      name: string;
      urlId: string;
      nickname?: string | null;
      isSavedCaterer: boolean;
      address?: {
        __typename?: 'Address';
        id: string;
        name?: string | null;
        city: string;
        street: string;
        street2?: string | null;
        state: string;
        zip?: string | null;
      } | null;
      brand?: {
        __typename?: 'Brand';
        id: string;
        uuid: string;
        name: string;
        logoUrl?: string | null;
      } | null;
    } | null;
    customerOrderStatus?: {
      __typename?: 'CustomerOrderStatus';
      id: string;
      isSubmitted?: boolean | null;
      isDraft: boolean;
      submittedAt?: string | null;
      isAccepted?: boolean | null;
      isReconfirmed?: boolean | null;
      isFulfilled?: boolean | null;
      fulfilledAt?: string | null;
      isCustomerPaymentCaptured?: boolean | null;
      isModifiable?: boolean | null;
      modificationCutoffTime?: string | null;
      isCancellable?: boolean | null;
      isCancelled?: boolean | null;
      cancelledAt?: string | null;
      isPendingApproval: boolean;
    } | null;
    firstOrderReferenceCode?: {
      __typename?: 'OrderReferenceCode';
      id: string;
      value?: string | null;
      corporateReferenceCode?: {
        __typename?: 'CorporateReferenceCode';
        id: string;
        name: string;
      } | null;
    } | null;
    event?: {
      __typename?: 'Event';
      id: string;
      headcount?: number | null;
      customerProvidedName?: string | null;
      deliverySetup: DeliverySetup;
      isTakeout: boolean;
      orderType: OrderTypeEnum;
      timestamp?: string | null;
      timeZoneIdentifier?: string | null;
      timeZoneOffset?: string | null;
      address?: {
        __typename?: 'Address';
        id: string;
        name?: string | null;
        city: string;
        street: string;
        street2?: string | null;
        state: string;
        zip?: string | null;
        deliveryInstructions?: string | null;
        driverAskFor?: string | null;
        phone?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
    } | null;
    totals?: {
      __typename?: 'OrderTotals';
      customerTotalDue: {__typename?: 'Money'; currency: Currency; subunits: number};
      subTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
      preDeliveryDiscountDeliveryFee?: {
        __typename?: 'Money';
        currency: Currency;
        subunits: number;
      } | null;
      preDeliveryDiscountTotal: {__typename?: 'Money'; currency: Currency; subunits: number};
    } | null;
  } | null;
  me?: {
    __typename?: 'Identity';
    id: string;
    consumerAccount?: {
      __typename?: 'ConsumerAccount';
      id: string;
      industry?: UserIndustryEnum | null;
      email: string;
      fullName?: string | null;
      firstName?: string | null;
      registrationStatus?: UserRegistrationStatusEnum | null;
      shouldLoadFullstory: boolean;
      canAccessCorpPortal: boolean;
      canManagePaymentMethods: boolean;
      canAccessConcur: boolean;
      identityId: string;
      canEarnEzRewards: boolean;
      canEarnReferralRewards?: boolean | null;
      enrolledInEzRewards?: boolean | null;
      corporateAccountVerified: boolean;
      canAccessEzRewards: boolean;
      mobilePhone?: string | null;
      hasLoggedIntoAndroidApp: boolean;
      hasLoggedIntoIpadApp: boolean;
      hasLoggedIntoIphoneApp: boolean;
      hasPlacedMarketplaceOrder: boolean;
      referAFriendEligible: boolean;
      recentlyReferred: boolean;
      referredByFirstName?: string | null;
      ezRewardsAccount?: {
        __typename?: 'EzRewardsAccount';
        id: string;
        balance?: number | null;
      } | null;
      corporateAccount?: {
        __typename?: 'CorporateAccount';
        id: string;
        isCharitable: boolean;
        isParent?: boolean | null;
        name: string;
        displayName?: string | null;
        channelPartnerLogoUrl?: string | null;
        uuid: string;
        hasFreeDeliveryEnabled: boolean;
        freeDeliveryThreshold?: number | null;
        logoIconUrl?: string | null;
        concurSettings: {__typename?: 'ConcurSettings'; shouldShowConcurEnterpriseToast: boolean};
      } | null;
      corporateAccounts: Array<{
        __typename?: 'CorporateAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        uuid: string;
        logoIconUrl?: string | null;
      }>;
      ownedCorporateAccounts?: Array<{
        __typename?: 'CorpAccount';
        id: string;
        name: string;
        displayName?: string | null;
        isParent?: boolean | null;
        logoIconUrl?: string | null;
      }> | null;
      referralPromo?: {
        __typename?: 'Promo';
        id: string;
        title: string;
        name?: string | null;
        discountAmount?: number | null;
        orderMinimum?: number | null;
        description: string;
        finePrint?: string | null;
        expiresOn?: string | null;
        weekdayOnly: boolean;
        termsAndConditionsUrl?: string | null;
        promoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      } | null;
      referralPromoCode?: {__typename?: 'PromoCode'; id: string; code: string} | null;
      totalPendingUserConnectionInvitations: {
        __typename?: 'UserConnectionInvitationConnection';
        totalCount: number;
      };
    } | null;
    adminAccount?: {
      __typename?: 'AdminAccount';
      id: string;
      isMasquerading: boolean;
      email?: string | null;
    } | null;
  } | null;
};

export type WebChatIdentityTokenQueryVariables = Exact<{[key: string]: never}>;

export type WebChatIdentityTokenQuery = {
  __typename?: 'Query';
  identity?: {
    __typename?: 'MarketplaceIdentity';
    id: string;
    webChatIdentityToken?: string | null;
  } | null;
};

export type ZeroSearchResultsSearchQueryVariables = Exact<{
  address: CatererSearchAddress;
  eventDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  eventTime?: InputMaybe<Scalars['TimeWithoutZone']['input']>;
  filters: Array<FilteredCatererListInput> | FilteredCatererListInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderType?: InputMaybe<CatererSearchOrderType>;
  skipSearchTracking?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ZeroSearchResultsSearchQuery = {
  __typename?: 'Query';
  marketplaceSearchV2: {
    __typename?: 'MarketplaceSearchResults';
    id: string;
    analyticsSearchId: string;
    caterers: {
      __typename?: 'CatererSearchConnection';
      id: string;
      visibleCount: number;
      nodes?: Array<{
        __typename?: 'CatererSearchResult';
        id: string;
        uuid: string;
        name: string;
        imageSrc?: string | null;
        urlId: string;
        distance: number;
        isNew: boolean;
        isSavedCaterer: boolean;
        isReliabilityRockstar: boolean;
        priceRating?: number | null;
        starRating?: number | null;
        topsortProductId: string;
        cacheKey: string;
        reviewCount: number;
        variableDeliveryFee?: boolean | null;
        onTimeRating?: number | null;
        lastOrderAt?: string | null;
        latestBrandReviewText?: string | null;
        latestBrandReviewAt?: string | null;
        latestReviewText?: string | null;
        latestReviewAt?: string | null;
        repeatUserRate?: number | null;
        rewardsLevel: number;
        sponsoredPromoTitles?: Array<string | null> | null;
        searchResultBrand: {
          __typename?: 'SearchResultBrand';
          id: string;
          uuid?: string | null;
          logoImageSrc?: string | null;
        };
        slotReservation:
          | {__typename?: 'NoReservation'}
          | {__typename?: 'SponsoredListingReservation'; topsortBidId?: string | null};
        deliveryMinimum: {__typename?: 'Money'; subunits: number; currency: Currency};
        deliveryFee: {__typename?: 'Money'; subunits: number; currency: Currency};
        takeoutMinimum?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
      } | null> | null;
    };
    filteredCaterers: Array<{
      __typename?: 'FilteredCatererList';
      id: string;
      caterers: {
        __typename?: 'FilteredCaterersConnection';
        id: string;
        visibleCount: number;
        nodes?: Array<{
          __typename?: 'CatererSearchResult';
          id: string;
          uuid: string;
          name: string;
          imageSrc?: string | null;
          urlId: string;
          distance: number;
          isNew: boolean;
          isSavedCaterer: boolean;
          isReliabilityRockstar: boolean;
          priceRating?: number | null;
          starRating?: number | null;
          topsortProductId: string;
          cacheKey: string;
          reviewCount: number;
          variableDeliveryFee?: boolean | null;
          onTimeRating?: number | null;
          lastOrderAt?: string | null;
          latestBrandReviewText?: string | null;
          latestBrandReviewAt?: string | null;
          latestReviewText?: string | null;
          latestReviewAt?: string | null;
          repeatUserRate?: number | null;
          rewardsLevel: number;
          sponsoredPromoTitles?: Array<string | null> | null;
          searchResultBrand: {
            __typename?: 'SearchResultBrand';
            id: string;
            uuid?: string | null;
            logoImageSrc?: string | null;
          };
          slotReservation:
            | {__typename?: 'NoReservation'}
            | {__typename?: 'SponsoredListingReservation'; topsortBidId?: string | null};
          deliveryMinimum: {__typename?: 'Money'; subunits: number; currency: Currency};
          deliveryFee: {__typename?: 'Money'; subunits: number; currency: Currency};
          takeoutMinimum?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        } | null> | null;
      };
    }>;
    rockstarCuratedList: {
      __typename?: 'CuratedList';
      caterers: {
        __typename?: 'CatererSearchCuratedListConnection';
        id: string;
        visibleCount: number;
        nodes?: Array<{
          __typename?: 'CatererSearchResult';
          id: string;
          uuid: string;
          name: string;
          imageSrc?: string | null;
          urlId: string;
          distance: number;
          isNew: boolean;
          isSavedCaterer: boolean;
          isReliabilityRockstar: boolean;
          priceRating?: number | null;
          starRating?: number | null;
          topsortProductId: string;
          cacheKey: string;
          reviewCount: number;
          variableDeliveryFee?: boolean | null;
          onTimeRating?: number | null;
          lastOrderAt?: string | null;
          latestBrandReviewText?: string | null;
          latestBrandReviewAt?: string | null;
          latestReviewText?: string | null;
          latestReviewAt?: string | null;
          repeatUserRate?: number | null;
          rewardsLevel: number;
          sponsoredPromoTitles?: Array<string | null> | null;
          searchResultBrand: {
            __typename?: 'SearchResultBrand';
            id: string;
            uuid?: string | null;
            logoImageSrc?: string | null;
          };
          slotReservation:
            | {__typename?: 'NoReservation'}
            | {__typename?: 'SponsoredListingReservation'; topsortBidId?: string | null};
          deliveryMinimum: {__typename?: 'Money'; subunits: number; currency: Currency};
          deliveryFee: {__typename?: 'Money'; subunits: number; currency: Currency};
          takeoutMinimum?: {__typename?: 'Money'; subunits: number; currency: Currency} | null;
        } | null> | null;
      };
    };
  };
};

export const AddressBookAddressFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressBookAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'street'}},
          {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
          {kind: 'Field', name: {kind: 'Name', value: 'addressBookEntryId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'addressBookEntry'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'corporate'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '1'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'SUBMITTED_NOT_CANCELLED'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortDirection'},
                value: {kind: 'EnumValue', value: 'DESC'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'nodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'submittedAt'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CateringMenuAboutUsCatererFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuAboutUsCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'onEzCaterSince'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasOtherLocations'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationFeeDescription'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modificationPolicy'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffHours'}}],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hideStreetAddress'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'storeHours'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryHoursDisplay'}},
                {kind: 'Field', name: {kind: 'Name', value: 'takeoutHoursDisplay'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'isFixed'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'minimumOrderSubTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CateringMenuCatererFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stateName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'heroImage'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'desktopHeroUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobileHeroUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullImagePath'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customStyle'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'primaryAccentColor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'primaryColor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'secondaryAccentColor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'secondaryColor'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customBranding'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'footerText'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'isFixed'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'minimumOrderSubTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hideSpecialInstructions'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hideStreetAddress'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'shouldShowReviews'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasDeliveryHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasTakeoutHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasOtherLocations'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicCatererFulfillmentReportCard'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'onTimeRating'}}],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'advanceNotice'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DayBeforeCutoffTime'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'dayBeforeCutoffTime'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LeadTime'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'leadTimeInMinutes'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isVisibleInStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isVisibleInPrivateStore'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cuisineTypes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sponsoredPromos'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promoCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicTaxonomiesWithTaxons'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'taxonomy'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxons'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasGroupOrderingEnabled'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CateringMenuConsumerCartAndFulfillmentDetailLookupFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartAndFulfillmentDetailLookupFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ConsumerCartModifierFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CateringMenuConsumerCartFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CateringMenuConsumerCartPastCutoffFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FulfillmentDetailFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CateringMenuFulfillmentDetailWithMessagesFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailWithMessagesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererUrlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'experience'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CateringMenuOtherLocationsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuOtherLocationsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hideStreetAddress'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CateringMenuOtherLocationsWithDistanceFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuOtherLocationsWithDistanceFragment'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'CatererLocationWithDistance'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'distanceMiles'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hideStreetAddress'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CheckoutPageFulfillmentDetailFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'staticMapUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'creditCardPaymentAllowed'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CheckoutConsumerCartFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'currentValue'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderId'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'requiresCreditLine'}},
                {kind: 'Field', name: {kind: 'Name', value: 'procurement'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsNotAvailable'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'missingItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'missingChoices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userCanAccessEzRewards'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'combined'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'dollarsToApply'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totalRemaining'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'amount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'extraPointsToApply'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'boosted'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'amount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerMessages'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'stage'},
                      value: {kind: 'EnumValue', value: 'CHECKOUT'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ConsumerCartItemsNotAvailable'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'missingItems'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'missingChoices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'user'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'requiresProcurementCheckout'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'staticMapUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'creditCardPaymentAllowed'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CheckoutWalkthroughFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutWalkthroughFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'currentValue'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderId'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'requiresCreditLine'}},
                {kind: 'Field', name: {kind: 'Name', value: 'procurement'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corpAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'procurementSettings'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'creditCardPaymentAllowed'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
                {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerMessages'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'stage'},
                      value: {kind: 'EnumValue', value: 'CHECKOUT'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CreditCard'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CreditLine'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'paymentMethodUserId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {kind: 'Field', name: {kind: 'Name', value: 'requiresProcurementCheckout'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ConsumerHasSubmittedOrderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerHasSubmittedOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'submittedOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'SUBMITTED'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '1'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ConsumerReferralFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerReferralFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'giftCardRedemptionAllowed'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ContactUsModalOrderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactUsModalOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ContactUsOrderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactUsOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DeliveryDetailsFulfillmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DeliveryDetailsFulfillment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerMessages'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'stage'},
                      value: {kind: 'EnumValue', value: 'CHECKOUT'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DeliveryFeeExperimentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'graphExperiments'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryFeeExperiment'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'v2'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'flagKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allocationKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'experimentKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'variation'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'pricingModel'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CappedDeliveryFeePricingModel'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cap'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'currency'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DraftCartTrackingFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DraftCartTrackingFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ContinuityCardFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContinuityCardFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContinuityCard'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'url'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'image'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'desktopHeroUrl'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DraftOrderContinuityCardFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DraftOrderContinuityCardFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'DraftOrderContinuityCard'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContinuityCardFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'catererName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'itemCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isGroupOrder'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContinuityCardFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContinuityCard'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'url'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'image'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'desktopHeroUrl'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FirstOrderDetailsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FirstOrderDetailsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'firstOrderDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'submittedFeedback'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'order'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'caterer'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ForceEmailUpdateFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ForceEmailUpdateFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isCurrentDeviceRecognized'}},
          {kind: 'Field', name: {kind: 'Name', value: 'mobilePhoneLastTwo'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetMoreOutOfEzCaterConstantsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConstantsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Constants'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minimumPointsForGiftCardRedemption'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetMoreOutOfEzCaterConsumerAccountFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConsumerAccountFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'giftCardRedemptionAllowed'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewardsAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                {
                  kind: 'Field',
                  alias: {kind: 'Name', value: 'giftCardRedemptions'},
                  name: {kind: 'Name', value: 'activities'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'categories'},
                      value: {kind: 'EnumValue', value: 'USED_ON_GIFT_CARD'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InvalidEmailBannerFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'InvalidEmailBannerFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'showInvalidEmailBanner'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ResendVerificationEmailFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ResendVerificationEmailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'needsCorporateEmailVerification'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HomeBannersConsumerAccountFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'HomeBannersConsumerAccountFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'InvalidEmailBannerFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ResendVerificationEmailFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'InvalidEmailBannerFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'showInvalidEmailBanner'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ResendVerificationEmailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'needsCorporateEmailVerification'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TrackingIdentityFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const IdentityRecommendedAddressFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const IdentityFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const JumpBackInCartFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'JumpBackInCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'live'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'activePauses'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'heroImage'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'mobileSearchUrl'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const JumpBackInFulfillmentDetailFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'JumpBackInFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCarts'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filters'},
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'onlyNonEmptyCarts'},
                      value: {kind: 'BooleanValue', value: true},
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'JumpBackInCartFragment'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'JumpBackInCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'live'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'activePauses'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'heroImage'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'mobileSearchUrl'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MenuevoModifierFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MenuevoModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MenuevoModifier'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'defaultQuantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'preselected'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'servings'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                {kind: 'Field', name: {kind: 'Name', value: 'min'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'sortIndex'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'calories'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                {kind: 'Field', name: {kind: 'Name', value: 'min'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunitsV2'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MenuevoModifierGroupFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MenuevoModifierGroupFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MenuevoModifierGroup'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'customerPrompt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fulfillmentLabel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'maxAggregateQuantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'maxModifierQuantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'maxSelections'}},
          {kind: 'Field', name: {kind: 'Name', value: 'minAggregateQuantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'minModifierQuantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'minSelections'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sortIndex'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OrderCardFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderCardFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isStandardGroupOrder'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'heroImage'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'mobileHeroUrl'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const LineItemModifierFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'LineItemModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LineItemModifier'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CartFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cart'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'lineItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'sizeLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'groupOrderPersonName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'belongsToAnyEater'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totalInSubunits'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orderItemOptions'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'catererLabel'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'itemChoices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'LineItemModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'LineItemModifierFragment',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'modifiers'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'LineItemModifierFragment',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'LineItemModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LineItemModifier'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CatererFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CustomerOrderStatusFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CustomerOrderStatusFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSubmitted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'submittedAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isAccepted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isReconfirmed'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fulfilledAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCustomerPaymentCaptured'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancellable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cancelledAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FirstOrderReferenceCodeFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FirstOrderReferenceCodeFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'firstOrderReferenceCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corporateReferenceCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const EventFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'EventFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'customerProvidedName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderType'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'perspective'},
                      value: {kind: 'EnumValue', value: 'CUSTOMER'},
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TotalsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TotalsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totals'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalDue'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'subTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountDeliveryFee'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OrderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isStandardGroupOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'delivery'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'estimatedDropoffTime'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tracking'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'url'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryEvents'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'eventType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'time'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'review'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'includedUtensils'}},
                {kind: 'Field', name: {kind: 'Name', value: 'omittedUtensils'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corporateReferenceCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                {kind: 'Field', name: {kind: 'Name', value: 'requiresCreditLine'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                {kind: 'Field', name: {kind: 'Name', value: 'procurement'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'currentValue'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderId'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
                    },
                  ],
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CartFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CatererFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CustomerOrderStatusFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FirstOrderReferenceCodeFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'EventFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TotalsFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'LineItemModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LineItemModifier'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cart'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'lineItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'sizeLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'groupOrderPersonName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'belongsToAnyEater'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totalInSubunits'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orderItemOptions'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'catererLabel'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'itemChoices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'LineItemModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'LineItemModifierFragment',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'modifiers'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'LineItemModifierFragment',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CustomerOrderStatusFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSubmitted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'submittedAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isAccepted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isReconfirmed'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fulfilledAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCustomerPaymentCaptured'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancellable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cancelledAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FirstOrderReferenceCodeFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'firstOrderReferenceCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corporateReferenceCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'EventFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'customerProvidedName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderType'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'perspective'},
                      value: {kind: 'EnumValue', value: 'CUSTOMER'},
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TotalsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totals'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalDue'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'subTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountDeliveryFee'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OrderPlacedConsumerFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderPlacedConsumerFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'marketplaceStatus'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralUrl'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'canEarnReferralRewards'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'enterpriseLeadEligible'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'canAccessEzRewards'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'submittedOrdersCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'daysSinceFirstMarketplaceOrder'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'assignedPromoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OrderCancellationPolicyDisplayFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'OrderCancellationPolicyDisplay'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'hasCancellationFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'feePercentage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'feeAmount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cancelWithoutPenaltyUntil'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationWindowHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isWaiverEligible'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OrderPlacedOrderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderPlacedOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isEzOrderingOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isStandardGroupOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderSourceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'ezRewardsPointsEarnable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'predictedLtv'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderRank'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'submittedMarketplace'}},
                {kind: 'Field', name: {kind: 'Name', value: 'submittedEzOrdering'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cart'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'menuItemId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'groupOrderPersonName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totalInSubunits'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orderItemOptions'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'catererLabel'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'itemChoices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'LineItemModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'LineItemModifierFragment',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'modifiers'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'LineItemModifierFragment',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'lineItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isGratuity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isPromo'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'staticMapUrl'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'width'},
                            value: {kind: 'IntValue', value: '1024'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'height'},
                            value: {kind: 'IntValue', value: '240'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'marker'},
                            value: {kind: 'BooleanValue', value: false},
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSubmitted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isAccepted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isReconfirmed'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancellable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
                {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderCustomer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'delivery'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryEvents'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'eventType'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'customerProvidedName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'orderType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'staticMapUrl'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'width'},
                            value: {kind: 'IntValue', value: '1024'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'height'},
                            value: {kind: 'IntValue', value: '240'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'marker'},
                            value: {kind: 'BooleanValue', value: false},
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CreditCard'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CreditLine'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'corpAccountName'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totals'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'salesTax'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'subTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalDue'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountDeliveryFee'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'includedUtensils'}},
                {kind: 'Field', name: {kind: 'Name', value: 'omittedUtensils'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isResidentialOrder'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cancellationPolicyDisplay'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'LineItemModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LineItemModifier'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'OrderCancellationPolicyDisplay'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'hasCancellationFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'feePercentage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'feeAmount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cancelWithoutPenaltyUntil'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationWindowHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isWaiverEligible'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OrdersTableOrderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrdersTableOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPaymentPending'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isEzOrderingOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isStandardGroupOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'notificationsEnabled'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'firstOrderReferenceCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corporateReferenceCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'customerProvidedName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'minimumDeliveryFee'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'takeoutMinimum'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currentStatusDisplay'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancellable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'isModifiable'},
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'include'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {
                            kind: 'Variable',
                            name: {kind: 'Name', value: 'includeModifiable'},
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modificationCutoffTime'},
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'include'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {
                            kind: 'Variable',
                            name: {kind: 'Name', value: 'includeModifiable'},
                          },
                        },
                      ],
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'isSubmitted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totals'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalDue'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'review'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cart'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'belongsToAnyEater'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderCustomer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cancellationPolicyDisplay'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'OrderCancellationPolicyDisplay'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'hasCancellationFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'feePercentage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'feeAmount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cancelWithoutPenaltyUntil'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationWindowHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isWaiverEligible'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PaymentMethodsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canUpdateCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'paymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'paymentMethodsLimit'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CreditCard'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cardholderName'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isDefaultCard'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isExpired'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isExpiringSoon'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'missingZipCode'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'sharedBy'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'fullName'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'sharedWithCount'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CreditLine'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'corpAccountName'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isDefault'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'logoImageUrl'},
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PaymentMethodsRootFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodsRootFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCurrentDeviceRecognized'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhoneLastTwo'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PreviouslyEngagedCaterersFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PreviouslyEngagedCaterersFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchResult'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'imageSrc'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'searchResultBrand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'previousEngagement'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'BrandEngagement'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastOrderedFrom'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'CatererEngagement'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastOrderedFrom'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'CorpAccountEngagement'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastOrderedFrom'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ReceiptsQueryConsumerAccountFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReceiptsQueryConsumerAccountFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'concurAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'areReceiptsAutomated'}},
                {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'canAccessConcur'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'corpDeptCodesVisible'},
            name: {kind: 'Name', value: 'corpCodesVisible'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'showCorpReferenceCodes'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corpReferenceCodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corpDeptCodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ownedCorporateAccounts'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ReceiptsQueryOrderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReceiptsQueryOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'OrderConnection'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalCustomerSpend'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'edges'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'node'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isPaymentPending'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasCorpDeptCode'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'caterer'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'brand'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'customerOrderStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'currentStatusDisplay'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'isCustomerPaymentCaptured'},
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'concurOrderStatus'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'firstOrderReferenceCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateReferenceCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'paidByUserId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'review'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'},
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totals'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'customerTotalDue'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'event'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'address'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'orderReferenceCodes'},
                        name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateReferenceCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corpAccount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateDepartment'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const RecentAddressesFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'RecentAddressesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'recentAddresses'},
            name: {kind: 'Name', value: 'addresses'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '4'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortBy'},
                value: {kind: 'EnumValue', value: 'UPDATED_AT'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortDirection'},
                value: {kind: 'EnumValue', value: 'DESC'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'addressBookEntryId'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const RecommendedDefaultAddressFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'RecommendedDefaultAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'GeocodedAddressResult'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'street'}},
          {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
          {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const RecommendedOrdersRecentAddressesFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'RecommendedOrdersRecentAddressesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'recentAddressesByLastUsed'},
            name: {kind: 'Name', value: 'addresses'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '1'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortBy'},
                value: {kind: 'EnumValue', value: 'LAST_USED_AT'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortDirection'},
                value: {kind: 'EnumValue', value: 'DESC'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ReviewableOrderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReviewableOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'daysLeftToReview'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReviewDeadlineApproaching'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'review'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ReviewableOrdersFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReviewableOrdersFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'reviewableOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'offset'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'REVIEWABLE'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'corpAccountUuids'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ReviewableOrderFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReviewableOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'daysLeftToReview'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReviewDeadlineApproaching'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'review'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SavedCatererFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SavedCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isNew'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'heroImage'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobileSearchUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SearchContinuityCardFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SearchContinuityCardFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SearchContinuityCard'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContinuityCardFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'keyword'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cuisineOption'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContinuityCardFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContinuityCard'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'url'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'image'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'desktopHeroUrl'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SearchPageFulfillmentDetailFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SearchPageFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SearchResultFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SearchResultFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchResult'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'searchResultBrand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoImageSrc'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'imageSrc'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'distance'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isNew'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'priceRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'slotReservation'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'SponsoredListingReservation'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'topsortBidId'}}],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'topsortProductId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'variableDeliveryFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'onTimeRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestBrandReviewText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestBrandReviewAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestReviewText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestReviewAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'repeatUserRate'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sponsoredPromoTitles'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const UpcomingOrderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UpcomingOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'estimatedHeadcount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const UpcomingOrdersFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UpcomingOrdersFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'upcomingOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'UPCOMING_AND_DRAFTS'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventAfter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '10'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'UpcomingOrderFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'draftOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'DRAFT'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '100'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
            },
          },
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'receiptOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'RECEIPT'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '100'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UpcomingOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'estimatedHeadcount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AddressBookEntryCreateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'AddressBookEntryCreate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'street1'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'city'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'state'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'zip'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'name'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'street2'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'latitude'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Float'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'longitude'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Float'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'driverAskFor'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'deliveryInstructions'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'phone'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'geocoder'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'geocodePrecision'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createNewAddressBookEntry'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'street1'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'street1'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'city'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'city'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'state'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'state'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'zip'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'zip'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'name'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'name'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'street2'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'street2'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'latitude'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'latitude'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'longitude'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'longitude'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'driverAskFor'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'driverAskFor'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'deliveryInstructions'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'deliveryInstructions'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'phone'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'phone'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'geocoder'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'geocoder'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'geocodePrecision'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'geocodePrecision'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'staticMapUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'addressBookEntryId'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'proposedAddresses'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'geocoder'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'geocodePrecision'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddressBookEntryCreateMutationFn = Apollo.MutationFunction<
  AddressBookEntryCreateMutation,
  AddressBookEntryCreateMutationVariables
>;

/**
 * __useAddressBookEntryCreateMutation__
 *
 * To run a mutation, you first call `useAddressBookEntryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressBookEntryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressBookEntryCreateMutation, { data, loading, error }] = useAddressBookEntryCreateMutation({
 *   variables: {
 *      street1: // value for 'street1'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      name: // value for 'name'
 *      street2: // value for 'street2'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      driverAskFor: // value for 'driverAskFor'
 *      deliveryInstructions: // value for 'deliveryInstructions'
 *      phone: // value for 'phone'
 *      geocoder: // value for 'geocoder'
 *      geocodePrecision: // value for 'geocodePrecision'
 *   },
 * });
 */
export function useAddressBookEntryCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddressBookEntryCreateMutation,
    AddressBookEntryCreateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    AddressBookEntryCreateMutation,
    AddressBookEntryCreateMutationVariables
  >(AddressBookEntryCreateDocument, options);
}
export type AddressBookEntryCreateMutationHookResult = ReturnType<
  typeof useAddressBookEntryCreateMutation
>;
export type AddressBookEntryCreateMutationResult =
  Apollo.MutationResult<AddressBookEntryCreateMutation>;
export type AddressBookEntryCreateMutationOptions = Apollo.BaseMutationOptions<
  AddressBookEntryCreateMutation,
  AddressBookEntryCreateMutationVariables
>;
export const AddressBookEntryCreateFromRevisionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'AddressBookEntryCreateFromRevision'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'revisedAddressId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createNewAddressBookEntryFromRevision'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'addressId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'revisedAddressId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'revisedAddressId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddressBookEntryCreateFromRevisionMutationFn = Apollo.MutationFunction<
  AddressBookEntryCreateFromRevisionMutation,
  AddressBookEntryCreateFromRevisionMutationVariables
>;

/**
 * __useAddressBookEntryCreateFromRevisionMutation__
 *
 * To run a mutation, you first call `useAddressBookEntryCreateFromRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressBookEntryCreateFromRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressBookEntryCreateFromRevisionMutation, { data, loading, error }] = useAddressBookEntryCreateFromRevisionMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      revisedAddressId: // value for 'revisedAddressId'
 *   },
 * });
 */
export function useAddressBookEntryCreateFromRevisionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddressBookEntryCreateFromRevisionMutation,
    AddressBookEntryCreateFromRevisionMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    AddressBookEntryCreateFromRevisionMutation,
    AddressBookEntryCreateFromRevisionMutationVariables
  >(AddressBookEntryCreateFromRevisionDocument, options);
}
export type AddressBookEntryCreateFromRevisionMutationHookResult = ReturnType<
  typeof useAddressBookEntryCreateFromRevisionMutation
>;
export type AddressBookEntryCreateFromRevisionMutationResult =
  Apollo.MutationResult<AddressBookEntryCreateFromRevisionMutation>;
export type AddressBookEntryCreateFromRevisionMutationOptions = Apollo.BaseMutationOptions<
  AddressBookEntryCreateFromRevisionMutation,
  AddressBookEntryCreateFromRevisionMutationVariables
>;
export const AddressBookEntryDeleteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'AddressBookEntryDelete'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteAddressBookEntry'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'addressId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddressBookEntryDeleteMutationFn = Apollo.MutationFunction<
  AddressBookEntryDeleteMutation,
  AddressBookEntryDeleteMutationVariables
>;

/**
 * __useAddressBookEntryDeleteMutation__
 *
 * To run a mutation, you first call `useAddressBookEntryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressBookEntryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressBookEntryDeleteMutation, { data, loading, error }] = useAddressBookEntryDeleteMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useAddressBookEntryDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddressBookEntryDeleteMutation,
    AddressBookEntryDeleteMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    AddressBookEntryDeleteMutation,
    AddressBookEntryDeleteMutationVariables
  >(AddressBookEntryDeleteDocument, options);
}
export type AddressBookEntryDeleteMutationHookResult = ReturnType<
  typeof useAddressBookEntryDeleteMutation
>;
export type AddressBookEntryDeleteMutationResult =
  Apollo.MutationResult<AddressBookEntryDeleteMutation>;
export type AddressBookEntryDeleteMutationOptions = Apollo.BaseMutationOptions<
  AddressBookEntryDeleteMutation,
  AddressBookEntryDeleteMutationVariables
>;
export const AddressBookEntryUpdateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'AddressBookEntryUpdate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'name'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'street'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'city'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'state'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'zip'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'street2'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'driverAskFor'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'deliveryInstructions'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'skipGeocoding'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'phone'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateAddress'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'addressId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'name'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'name'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'street'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'street'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'street2'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'street2'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'city'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'city'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'state'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'state'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'zip'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'zip'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'driverAskFor'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'driverAskFor'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'deliveryInstructions'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'deliveryInstructions'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'skipGeocoding'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'skipGeocoding'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'phone'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'phone'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'addressBookEntryId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'revision'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'revisionDeltas'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'field'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'currentValue'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'newValue'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'proposedAddresses'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddressBookEntryUpdateMutationFn = Apollo.MutationFunction<
  AddressBookEntryUpdateMutation,
  AddressBookEntryUpdateMutationVariables
>;

/**
 * __useAddressBookEntryUpdateMutation__
 *
 * To run a mutation, you first call `useAddressBookEntryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressBookEntryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressBookEntryUpdateMutation, { data, loading, error }] = useAddressBookEntryUpdateMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      name: // value for 'name'
 *      street: // value for 'street'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      street2: // value for 'street2'
 *      driverAskFor: // value for 'driverAskFor'
 *      deliveryInstructions: // value for 'deliveryInstructions'
 *      skipGeocoding: // value for 'skipGeocoding'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useAddressBookEntryUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddressBookEntryUpdateMutation,
    AddressBookEntryUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    AddressBookEntryUpdateMutation,
    AddressBookEntryUpdateMutationVariables
  >(AddressBookEntryUpdateDocument, options);
}
export type AddressBookEntryUpdateMutationHookResult = ReturnType<
  typeof useAddressBookEntryUpdateMutation
>;
export type AddressBookEntryUpdateMutationResult =
  Apollo.MutationResult<AddressBookEntryUpdateMutation>;
export type AddressBookEntryUpdateMutationOptions = Apollo.BaseMutationOptions<
  AddressBookEntryUpdateMutation,
  AddressBookEntryUpdateMutationVariables
>;
export const AddressRevisionAcceptDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'AddressRevisionAccept'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'revisedAddressId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'acceptAddressRevisions'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'addressId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'revisedAddressId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'revisedAddressId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddressRevisionAcceptMutationFn = Apollo.MutationFunction<
  AddressRevisionAcceptMutation,
  AddressRevisionAcceptMutationVariables
>;

/**
 * __useAddressRevisionAcceptMutation__
 *
 * To run a mutation, you first call `useAddressRevisionAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressRevisionAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressRevisionAcceptMutation, { data, loading, error }] = useAddressRevisionAcceptMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      revisedAddressId: // value for 'revisedAddressId'
 *   },
 * });
 */
export function useAddressRevisionAcceptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddressRevisionAcceptMutation,
    AddressRevisionAcceptMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<AddressRevisionAcceptMutation, AddressRevisionAcceptMutationVariables>(
    AddressRevisionAcceptDocument,
    options,
  );
}
export type AddressRevisionAcceptMutationHookResult = ReturnType<
  typeof useAddressRevisionAcceptMutation
>;
export type AddressRevisionAcceptMutationResult =
  Apollo.MutationResult<AddressRevisionAcceptMutation>;
export type AddressRevisionAcceptMutationOptions = Apollo.BaseMutationOptions<
  AddressRevisionAcceptMutation,
  AddressRevisionAcceptMutationVariables
>;
export const AddressRevisionRejectDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'AddressRevisionReject'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'rejectAddressRevision'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'addressId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddressRevisionRejectMutationFn = Apollo.MutationFunction<
  AddressRevisionRejectMutation,
  AddressRevisionRejectMutationVariables
>;

/**
 * __useAddressRevisionRejectMutation__
 *
 * To run a mutation, you first call `useAddressRevisionRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressRevisionRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressRevisionRejectMutation, { data, loading, error }] = useAddressRevisionRejectMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useAddressRevisionRejectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddressRevisionRejectMutation,
    AddressRevisionRejectMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<AddressRevisionRejectMutation, AddressRevisionRejectMutationVariables>(
    AddressRevisionRejectDocument,
    options,
  );
}
export type AddressRevisionRejectMutationHookResult = ReturnType<
  typeof useAddressRevisionRejectMutation
>;
export type AddressRevisionRejectMutationResult =
  Apollo.MutationResult<AddressRevisionRejectMutation>;
export type AddressRevisionRejectMutationOptions = Apollo.BaseMutationOptions<
  AddressRevisionRejectMutation,
  AddressRevisionRejectMutationVariables
>;
export const AllDraftOrdersDeleteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'AllDraftOrdersDelete'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteAllDraftOrders'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AllDraftOrdersDeleteMutationFn = Apollo.MutationFunction<
  AllDraftOrdersDeleteMutation,
  AllDraftOrdersDeleteMutationVariables
>;

/**
 * __useAllDraftOrdersDeleteMutation__
 *
 * To run a mutation, you first call `useAllDraftOrdersDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllDraftOrdersDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allDraftOrdersDeleteMutation, { data, loading, error }] = useAllDraftOrdersDeleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useAllDraftOrdersDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AllDraftOrdersDeleteMutation,
    AllDraftOrdersDeleteMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<AllDraftOrdersDeleteMutation, AllDraftOrdersDeleteMutationVariables>(
    AllDraftOrdersDeleteDocument,
    options,
  );
}
export type AllDraftOrdersDeleteMutationHookResult = ReturnType<
  typeof useAllDraftOrdersDeleteMutation
>;
export type AllDraftOrdersDeleteMutationResult =
  Apollo.MutationResult<AllDraftOrdersDeleteMutation>;
export type AllDraftOrdersDeleteMutationOptions = Apollo.BaseMutationOptions<
  AllDraftOrdersDeleteMutation,
  AllDraftOrdersDeleteMutationVariables
>;
export const AutomatedReceiptsToggleDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'AutomatedReceiptsToggle'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'areReceiptsAutomated'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'toggleConcurAutomatedReceipts'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'areReceiptsAutomated'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'areReceiptsAutomated'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'concurAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'areReceiptsAutomated'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AutomatedReceiptsToggleMutationFn = Apollo.MutationFunction<
  AutomatedReceiptsToggleMutation,
  AutomatedReceiptsToggleMutationVariables
>;

/**
 * __useAutomatedReceiptsToggleMutation__
 *
 * To run a mutation, you first call `useAutomatedReceiptsToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutomatedReceiptsToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [automatedReceiptsToggleMutation, { data, loading, error }] = useAutomatedReceiptsToggleMutation({
 *   variables: {
 *      areReceiptsAutomated: // value for 'areReceiptsAutomated'
 *   },
 * });
 */
export function useAutomatedReceiptsToggleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AutomatedReceiptsToggleMutation,
    AutomatedReceiptsToggleMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    AutomatedReceiptsToggleMutation,
    AutomatedReceiptsToggleMutationVariables
  >(AutomatedReceiptsToggleDocument, options);
}
export type AutomatedReceiptsToggleMutationHookResult = ReturnType<
  typeof useAutomatedReceiptsToggleMutation
>;
export type AutomatedReceiptsToggleMutationResult =
  Apollo.MutationResult<AutomatedReceiptsToggleMutation>;
export type AutomatedReceiptsToggleMutationOptions = Apollo.BaseMutationOptions<
  AutomatedReceiptsToggleMutation,
  AutomatedReceiptsToggleMutationVariables
>;
export const CatererSaveDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CatererSave'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'brandId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'catererSave'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'brandId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'brandId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'ezRewardsPointsGiven'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CatererSaveMutationFn = Apollo.MutationFunction<
  CatererSaveMutation,
  CatererSaveMutationVariables
>;

/**
 * __useCatererSaveMutation__
 *
 * To run a mutation, you first call `useCatererSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatererSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catererSaveMutation, { data, loading, error }] = useCatererSaveMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      catererId: // value for 'catererId'
 *   },
 * });
 */
export function useCatererSaveMutation(
  baseOptions?: Apollo.MutationHookOptions<CatererSaveMutation, CatererSaveMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CatererSaveMutation, CatererSaveMutationVariables>(
    CatererSaveDocument,
    options,
  );
}
export type CatererSaveMutationHookResult = ReturnType<typeof useCatererSaveMutation>;
export type CatererSaveMutationResult = Apollo.MutationResult<CatererSaveMutation>;
export type CatererSaveMutationOptions = Apollo.BaseMutationOptions<
  CatererSaveMutation,
  CatererSaveMutationVariables
>;
export const CatererUnsaveDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CatererUnsave'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'brandId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'catererUnsave'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'brandId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'brandId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CatererUnsaveMutationFn = Apollo.MutationFunction<
  CatererUnsaveMutation,
  CatererUnsaveMutationVariables
>;

/**
 * __useCatererUnsaveMutation__
 *
 * To run a mutation, you first call `useCatererUnsaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatererUnsaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catererUnsaveMutation, { data, loading, error }] = useCatererUnsaveMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      catererId: // value for 'catererId'
 *   },
 * });
 */
export function useCatererUnsaveMutation(
  baseOptions?: Apollo.MutationHookOptions<CatererUnsaveMutation, CatererUnsaveMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CatererUnsaveMutation, CatererUnsaveMutationVariables>(
    CatererUnsaveDocument,
    options,
  );
}
export type CatererUnsaveMutationHookResult = ReturnType<typeof useCatererUnsaveMutation>;
export type CatererUnsaveMutationResult = Apollo.MutationResult<CatererUnsaveMutation>;
export type CatererUnsaveMutationOptions = Apollo.BaseMutationOptions<
  CatererUnsaveMutation,
  CatererUnsaveMutationVariables
>;
export const ConsumerCartAddItemsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartAddItems'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartAddItemInput'}},
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartExperience'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartAddItems'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'fulfillmentDetail'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'customerMessages'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'stage'},
                                  value: {kind: 'EnumValue', value: 'MENU'},
                                },
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'experience'},
                                  value: {
                                    kind: 'Variable',
                                    name: {kind: 'Name', value: 'experience'},
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'ConsumerCartOverCorpSpendingLimit',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'enforce'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartAddItemsMutationFn = Apollo.MutationFunction<
  ConsumerCartAddItemsMutation,
  ConsumerCartAddItemsMutationVariables
>;

/**
 * __useConsumerCartAddItemsMutation__
 *
 * To run a mutation, you first call `useConsumerCartAddItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartAddItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartAddItemsMutation, { data, loading, error }] = useConsumerCartAddItemsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      experience: // value for 'experience'
 *   },
 * });
 */
export function useConsumerCartAddItemsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartAddItemsMutation,
    ConsumerCartAddItemsMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ConsumerCartAddItemsMutation, ConsumerCartAddItemsMutationVariables>(
    ConsumerCartAddItemsDocument,
    options,
  );
}
export type ConsumerCartAddItemsMutationHookResult = ReturnType<
  typeof useConsumerCartAddItemsMutation
>;
export type ConsumerCartAddItemsMutationResult =
  Apollo.MutationResult<ConsumerCartAddItemsMutation>;
export type ConsumerCartAddItemsMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartAddItemsMutation,
  ConsumerCartAddItemsMutationVariables
>;
export const CateringMenuConsumerCartAndFulfillmentDetailCreateMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartAndFulfillmentDetailCreateMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {kind: 'Name', value: 'ConsumerCartAndFulfillmentDetailCreateInput'},
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartExperience'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartAndFulfillmentDetailCreate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'fulfillmentDetail'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'CateringMenuFulfillmentDetailWithMessagesFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailWithMessagesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererUrlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'experience'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CateringMenuConsumerCartAndFulfillmentDetailCreateMutationMutationFn =
  Apollo.MutationFunction<
    CateringMenuConsumerCartAndFulfillmentDetailCreateMutation,
    CateringMenuConsumerCartAndFulfillmentDetailCreateMutationVariables
  >;

/**
 * __useCateringMenuConsumerCartAndFulfillmentDetailCreateMutation__
 *
 * To run a mutation, you first call `useCateringMenuConsumerCartAndFulfillmentDetailCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuConsumerCartAndFulfillmentDetailCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cateringMenuConsumerCartAndFulfillmentDetailCreateMutation, { data, loading, error }] = useCateringMenuConsumerCartAndFulfillmentDetailCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      catererId: // value for 'catererId'
 *      catererUrlId: // value for 'catererUrlId'
 *      experience: // value for 'experience'
 *   },
 * });
 */
export function useCateringMenuConsumerCartAndFulfillmentDetailCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CateringMenuConsumerCartAndFulfillmentDetailCreateMutation,
    CateringMenuConsumerCartAndFulfillmentDetailCreateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CateringMenuConsumerCartAndFulfillmentDetailCreateMutation,
    CateringMenuConsumerCartAndFulfillmentDetailCreateMutationVariables
  >(CateringMenuConsumerCartAndFulfillmentDetailCreateMutationDocument, options);
}
export type CateringMenuConsumerCartAndFulfillmentDetailCreateMutationHookResult = ReturnType<
  typeof useCateringMenuConsumerCartAndFulfillmentDetailCreateMutation
>;
export type CateringMenuConsumerCartAndFulfillmentDetailCreateMutationMutationResult =
  Apollo.MutationResult<CateringMenuConsumerCartAndFulfillmentDetailCreateMutation>;
export type CateringMenuConsumerCartAndFulfillmentDetailCreateMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CateringMenuConsumerCartAndFulfillmentDetailCreateMutation,
    CateringMenuConsumerCartAndFulfillmentDetailCreateMutationVariables
  >;
export const CateringMenuConsumerCartCreateMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartCreateMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartCreateInput'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartCreate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'fulfillmentDetailId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'fulfillmentDetail'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CateringMenuConsumerCartCreateMutationMutationFn = Apollo.MutationFunction<
  CateringMenuConsumerCartCreateMutation,
  CateringMenuConsumerCartCreateMutationVariables
>;

/**
 * __useCateringMenuConsumerCartCreateMutation__
 *
 * To run a mutation, you first call `useCateringMenuConsumerCartCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuConsumerCartCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cateringMenuConsumerCartCreateMutation, { data, loading, error }] = useCateringMenuConsumerCartCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      catererId: // value for 'catererId'
 *      fulfillmentDetailId: // value for 'fulfillmentDetailId'
 *   },
 * });
 */
export function useCateringMenuConsumerCartCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CateringMenuConsumerCartCreateMutation,
    CateringMenuConsumerCartCreateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CateringMenuConsumerCartCreateMutation,
    CateringMenuConsumerCartCreateMutationVariables
  >(CateringMenuConsumerCartCreateMutationDocument, options);
}
export type CateringMenuConsumerCartCreateMutationHookResult = ReturnType<
  typeof useCateringMenuConsumerCartCreateMutation
>;
export type CateringMenuConsumerCartCreateMutationMutationResult =
  Apollo.MutationResult<CateringMenuConsumerCartCreateMutation>;
export type CateringMenuConsumerCartCreateMutationMutationOptions = Apollo.BaseMutationOptions<
  CateringMenuConsumerCartCreateMutation,
  CateringMenuConsumerCartCreateMutationVariables
>;
export const ConsumerCartRemoveItemsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartRemoveItems'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: {kind: 'Name', value: 'ConsumerCartRemoveItemInput'},
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartRemoveItems'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartRemoveItemsMutationFn = Apollo.MutationFunction<
  ConsumerCartRemoveItemsMutation,
  ConsumerCartRemoveItemsMutationVariables
>;

/**
 * __useConsumerCartRemoveItemsMutation__
 *
 * To run a mutation, you first call `useConsumerCartRemoveItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartRemoveItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartRemoveItemsMutation, { data, loading, error }] = useConsumerCartRemoveItemsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerCartRemoveItemsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartRemoveItemsMutation,
    ConsumerCartRemoveItemsMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartRemoveItemsMutation,
    ConsumerCartRemoveItemsMutationVariables
  >(ConsumerCartRemoveItemsDocument, options);
}
export type ConsumerCartRemoveItemsMutationHookResult = ReturnType<
  typeof useConsumerCartRemoveItemsMutation
>;
export type ConsumerCartRemoveItemsMutationResult =
  Apollo.MutationResult<ConsumerCartRemoveItemsMutation>;
export type ConsumerCartRemoveItemsMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartRemoveItemsMutation,
  ConsumerCartRemoveItemsMutationVariables
>;
export const ConsumerCartUpdateItemsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartUpdateItems'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: {kind: 'Name', value: 'ConsumerCartUpdateItemInput'},
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartUpdateItems'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartUpdateItemsMutationFn = Apollo.MutationFunction<
  ConsumerCartUpdateItemsMutation,
  ConsumerCartUpdateItemsMutationVariables
>;

/**
 * __useConsumerCartUpdateItemsMutation__
 *
 * To run a mutation, you first call `useConsumerCartUpdateItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartUpdateItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartUpdateItemsMutation, { data, loading, error }] = useConsumerCartUpdateItemsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerCartUpdateItemsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartUpdateItemsMutation,
    ConsumerCartUpdateItemsMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartUpdateItemsMutation,
    ConsumerCartUpdateItemsMutationVariables
  >(ConsumerCartUpdateItemsDocument, options);
}
export type ConsumerCartUpdateItemsMutationHookResult = ReturnType<
  typeof useConsumerCartUpdateItemsMutation
>;
export type ConsumerCartUpdateItemsMutationResult =
  Apollo.MutationResult<ConsumerCartUpdateItemsMutation>;
export type ConsumerCartUpdateItemsMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartUpdateItemsMutation,
  ConsumerCartUpdateItemsMutationVariables
>;
export const CateringMenuFulfillmentDetailCreateMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailCreateMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetailCreateInput'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartExperience'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetailCreate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CateringMenuFulfillmentDetailWithMessagesFragment',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailWithMessagesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererUrlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'experience'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CateringMenuFulfillmentDetailCreateMutationMutationFn = Apollo.MutationFunction<
  CateringMenuFulfillmentDetailCreateMutation,
  CateringMenuFulfillmentDetailCreateMutationVariables
>;

/**
 * __useCateringMenuFulfillmentDetailCreateMutation__
 *
 * To run a mutation, you first call `useCateringMenuFulfillmentDetailCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuFulfillmentDetailCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cateringMenuFulfillmentDetailCreateMutation, { data, loading, error }] = useCateringMenuFulfillmentDetailCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      catererUrlId: // value for 'catererUrlId'
 *      experience: // value for 'experience'
 *   },
 * });
 */
export function useCateringMenuFulfillmentDetailCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CateringMenuFulfillmentDetailCreateMutation,
    CateringMenuFulfillmentDetailCreateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CateringMenuFulfillmentDetailCreateMutation,
    CateringMenuFulfillmentDetailCreateMutationVariables
  >(CateringMenuFulfillmentDetailCreateMutationDocument, options);
}
export type CateringMenuFulfillmentDetailCreateMutationHookResult = ReturnType<
  typeof useCateringMenuFulfillmentDetailCreateMutation
>;
export type CateringMenuFulfillmentDetailCreateMutationMutationResult =
  Apollo.MutationResult<CateringMenuFulfillmentDetailCreateMutation>;
export type CateringMenuFulfillmentDetailCreateMutationMutationOptions = Apollo.BaseMutationOptions<
  CateringMenuFulfillmentDetailCreateMutation,
  CateringMenuFulfillmentDetailCreateMutationVariables
>;
export const CateringMenuFulfillmentDetailUpdateMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailUpdateMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'consumerCartId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetailUpdateInput'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartExperience'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetailUpdate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'consumerCartId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'consumerCartId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CateringMenuFulfillmentDetailWithMessagesFragment',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailWithMessagesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererUrlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'experience'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CateringMenuFulfillmentDetailUpdateMutationMutationFn = Apollo.MutationFunction<
  CateringMenuFulfillmentDetailUpdateMutation,
  CateringMenuFulfillmentDetailUpdateMutationVariables
>;

/**
 * __useCateringMenuFulfillmentDetailUpdateMutation__
 *
 * To run a mutation, you first call `useCateringMenuFulfillmentDetailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuFulfillmentDetailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cateringMenuFulfillmentDetailUpdateMutation, { data, loading, error }] = useCateringMenuFulfillmentDetailUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      consumerCartId: // value for 'consumerCartId'
 *      input: // value for 'input'
 *      catererUrlId: // value for 'catererUrlId'
 *      experience: // value for 'experience'
 *   },
 * });
 */
export function useCateringMenuFulfillmentDetailUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CateringMenuFulfillmentDetailUpdateMutation,
    CateringMenuFulfillmentDetailUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CateringMenuFulfillmentDetailUpdateMutation,
    CateringMenuFulfillmentDetailUpdateMutationVariables
  >(CateringMenuFulfillmentDetailUpdateMutationDocument, options);
}
export type CateringMenuFulfillmentDetailUpdateMutationHookResult = ReturnType<
  typeof useCateringMenuFulfillmentDetailUpdateMutation
>;
export type CateringMenuFulfillmentDetailUpdateMutationMutationResult =
  Apollo.MutationResult<CateringMenuFulfillmentDetailUpdateMutation>;
export type CateringMenuFulfillmentDetailUpdateMutationMutationOptions = Apollo.BaseMutationOptions<
  CateringMenuFulfillmentDetailUpdateMutation,
  CateringMenuFulfillmentDetailUpdateMutationVariables
>;
export const CheckoutConsumerCartUpdateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CheckoutConsumerCartUpdate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartUpdateInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartUpdate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CheckoutConsumerCartFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'staticMapUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'creditCardPaymentAllowed'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'currentValue'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderId'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'requiresCreditLine'}},
                {kind: 'Field', name: {kind: 'Name', value: 'procurement'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsNotAvailable'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'missingItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'missingChoices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userCanAccessEzRewards'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'combined'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'dollarsToApply'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totalRemaining'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'amount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'extraPointsToApply'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'boosted'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'amount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerMessages'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'stage'},
                      value: {kind: 'EnumValue', value: 'CHECKOUT'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ConsumerCartItemsNotAvailable'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'missingItems'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'missingChoices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'user'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'requiresProcurementCheckout'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CheckoutConsumerCartUpdateMutationFn = Apollo.MutationFunction<
  CheckoutConsumerCartUpdateMutation,
  CheckoutConsumerCartUpdateMutationVariables
>;

/**
 * __useCheckoutConsumerCartUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutConsumerCartUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutConsumerCartUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutConsumerCartUpdateMutation, { data, loading, error }] = useCheckoutConsumerCartUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckoutConsumerCartUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckoutConsumerCartUpdateMutation,
    CheckoutConsumerCartUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CheckoutConsumerCartUpdateMutation,
    CheckoutConsumerCartUpdateMutationVariables
  >(CheckoutConsumerCartUpdateDocument, options);
}
export type CheckoutConsumerCartUpdateMutationHookResult = ReturnType<
  typeof useCheckoutConsumerCartUpdateMutation
>;
export type CheckoutConsumerCartUpdateMutationResult =
  Apollo.MutationResult<CheckoutConsumerCartUpdateMutation>;
export type CheckoutConsumerCartUpdateMutationOptions = Apollo.BaseMutationOptions<
  CheckoutConsumerCartUpdateMutation,
  CheckoutConsumerCartUpdateMutationVariables
>;
export const ConcurDisconnectDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConcurDisconnect'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'disconnectFromConcur'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConcurDisconnectMutationFn = Apollo.MutationFunction<
  ConcurDisconnectMutation,
  ConcurDisconnectMutationVariables
>;

/**
 * __useConcurDisconnectMutation__
 *
 * To run a mutation, you first call `useConcurDisconnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConcurDisconnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [concurDisconnectMutation, { data, loading, error }] = useConcurDisconnectMutation({
 *   variables: {
 *   },
 * });
 */
export function useConcurDisconnectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConcurDisconnectMutation,
    ConcurDisconnectMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ConcurDisconnectMutation, ConcurDisconnectMutationVariables>(
    ConcurDisconnectDocument,
    options,
  );
}
export type ConcurDisconnectMutationHookResult = ReturnType<typeof useConcurDisconnectMutation>;
export type ConcurDisconnectMutationResult = Apollo.MutationResult<ConcurDisconnectMutation>;
export type ConcurDisconnectMutationOptions = Apollo.BaseMutationOptions<
  ConcurDisconnectMutation,
  ConcurDisconnectMutationVariables
>;
export const ConsumerCartAttachPunchoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartAttachPunchout'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'cartId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'punchoutId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartAttachPunchout'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'cartId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'cartId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'punchoutId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'punchoutId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartAttachPunchoutMutationFn = Apollo.MutationFunction<
  ConsumerCartAttachPunchoutMutation,
  ConsumerCartAttachPunchoutMutationVariables
>;

/**
 * __useConsumerCartAttachPunchoutMutation__
 *
 * To run a mutation, you first call `useConsumerCartAttachPunchoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartAttachPunchoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartAttachPunchoutMutation, { data, loading, error }] = useConsumerCartAttachPunchoutMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      punchoutId: // value for 'punchoutId'
 *   },
 * });
 */
export function useConsumerCartAttachPunchoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartAttachPunchoutMutation,
    ConsumerCartAttachPunchoutMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartAttachPunchoutMutation,
    ConsumerCartAttachPunchoutMutationVariables
  >(ConsumerCartAttachPunchoutDocument, options);
}
export type ConsumerCartAttachPunchoutMutationHookResult = ReturnType<
  typeof useConsumerCartAttachPunchoutMutation
>;
export type ConsumerCartAttachPunchoutMutationResult =
  Apollo.MutationResult<ConsumerCartAttachPunchoutMutation>;
export type ConsumerCartAttachPunchoutMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartAttachPunchoutMutation,
  ConsumerCartAttachPunchoutMutationVariables
>;
export const ConsumerCartDeleteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartDelete'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'consumerCartDeleteId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartDelete'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'consumerCartDeleteId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartDeleteMutationFn = Apollo.MutationFunction<
  ConsumerCartDeleteMutation,
  ConsumerCartDeleteMutationVariables
>;

/**
 * __useConsumerCartDeleteMutation__
 *
 * To run a mutation, you first call `useConsumerCartDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartDeleteMutation, { data, loading, error }] = useConsumerCartDeleteMutation({
 *   variables: {
 *      consumerCartDeleteId: // value for 'consumerCartDeleteId'
 *   },
 * });
 */
export function useConsumerCartDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartDeleteMutation,
    ConsumerCartDeleteMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ConsumerCartDeleteMutation, ConsumerCartDeleteMutationVariables>(
    ConsumerCartDeleteDocument,
    options,
  );
}
export type ConsumerCartDeleteMutationHookResult = ReturnType<typeof useConsumerCartDeleteMutation>;
export type ConsumerCartDeleteMutationResult = Apollo.MutationResult<ConsumerCartDeleteMutation>;
export type ConsumerCartDeleteMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartDeleteMutation,
  ConsumerCartDeleteMutationVariables
>;
export const ConsumerCartFinalizeModificationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartFinalizeModification'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'cartId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'forterToken'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartFinalizeModification'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'cartId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'forterToken'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'forterToken'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'order'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CheckoutError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartFinalizeModificationMutationFn = Apollo.MutationFunction<
  ConsumerCartFinalizeModificationMutation,
  ConsumerCartFinalizeModificationMutationVariables
>;

/**
 * __useConsumerCartFinalizeModificationMutation__
 *
 * To run a mutation, you first call `useConsumerCartFinalizeModificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartFinalizeModificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartFinalizeModificationMutation, { data, loading, error }] = useConsumerCartFinalizeModificationMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      forterToken: // value for 'forterToken'
 *   },
 * });
 */
export function useConsumerCartFinalizeModificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartFinalizeModificationMutation,
    ConsumerCartFinalizeModificationMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartFinalizeModificationMutation,
    ConsumerCartFinalizeModificationMutationVariables
  >(ConsumerCartFinalizeModificationDocument, options);
}
export type ConsumerCartFinalizeModificationMutationHookResult = ReturnType<
  typeof useConsumerCartFinalizeModificationMutation
>;
export type ConsumerCartFinalizeModificationMutationResult =
  Apollo.MutationResult<ConsumerCartFinalizeModificationMutation>;
export type ConsumerCartFinalizeModificationMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartFinalizeModificationMutation,
  ConsumerCartFinalizeModificationMutationVariables
>;
export const ConsumerCartGenerateInviteToPayLinkDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartGenerateInviteToPayLink'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'consumerCartId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NamedType',
            name: {kind: 'Name', value: 'ConsumerCartInviteUserToPayInput'},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartInviteUserToPay'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'consumerCartId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'consumerCartId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCartInvitation'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartGenerateInviteToPayLinkMutationFn = Apollo.MutationFunction<
  ConsumerCartGenerateInviteToPayLinkMutation,
  ConsumerCartGenerateInviteToPayLinkMutationVariables
>;

/**
 * __useConsumerCartGenerateInviteToPayLinkMutation__
 *
 * To run a mutation, you first call `useConsumerCartGenerateInviteToPayLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartGenerateInviteToPayLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartGenerateInviteToPayLinkMutation, { data, loading, error }] = useConsumerCartGenerateInviteToPayLinkMutation({
 *   variables: {
 *      consumerCartId: // value for 'consumerCartId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerCartGenerateInviteToPayLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartGenerateInviteToPayLinkMutation,
    ConsumerCartGenerateInviteToPayLinkMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartGenerateInviteToPayLinkMutation,
    ConsumerCartGenerateInviteToPayLinkMutationVariables
  >(ConsumerCartGenerateInviteToPayLinkDocument, options);
}
export type ConsumerCartGenerateInviteToPayLinkMutationHookResult = ReturnType<
  typeof useConsumerCartGenerateInviteToPayLinkMutation
>;
export type ConsumerCartGenerateInviteToPayLinkMutationResult =
  Apollo.MutationResult<ConsumerCartGenerateInviteToPayLinkMutation>;
export type ConsumerCartGenerateInviteToPayLinkMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartGenerateInviteToPayLinkMutation,
  ConsumerCartGenerateInviteToPayLinkMutationVariables
>;
export const ConsumerCartGroupOrderUpsertDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartGroupOrderUpsert'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartGroupOrderInput'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartGroupOrderUpsert'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'groupOrder'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'caterer'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'perPersonBudget'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartGroupOrderUpsertMutationFn = Apollo.MutationFunction<
  ConsumerCartGroupOrderUpsertMutation,
  ConsumerCartGroupOrderUpsertMutationVariables
>;

/**
 * __useConsumerCartGroupOrderUpsertMutation__
 *
 * To run a mutation, you first call `useConsumerCartGroupOrderUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartGroupOrderUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartGroupOrderUpsertMutation, { data, loading, error }] = useConsumerCartGroupOrderUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerCartGroupOrderUpsertMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartGroupOrderUpsertMutation,
    ConsumerCartGroupOrderUpsertMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartGroupOrderUpsertMutation,
    ConsumerCartGroupOrderUpsertMutationVariables
  >(ConsumerCartGroupOrderUpsertDocument, options);
}
export type ConsumerCartGroupOrderUpsertMutationHookResult = ReturnType<
  typeof useConsumerCartGroupOrderUpsertMutation
>;
export type ConsumerCartGroupOrderUpsertMutationResult =
  Apollo.MutationResult<ConsumerCartGroupOrderUpsertMutation>;
export type ConsumerCartGroupOrderUpsertMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartGroupOrderUpsertMutation,
  ConsumerCartGroupOrderUpsertMutationVariables
>;
export const ConsumerCartInvitationAcceptDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartInvitationAccept'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accessCode'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartInvitationAccept'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accessCode'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accessCode'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartInvitationAcceptMutationFn = Apollo.MutationFunction<
  ConsumerCartInvitationAcceptMutation,
  ConsumerCartInvitationAcceptMutationVariables
>;

/**
 * __useConsumerCartInvitationAcceptMutation__
 *
 * To run a mutation, you first call `useConsumerCartInvitationAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartInvitationAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartInvitationAcceptMutation, { data, loading, error }] = useConsumerCartInvitationAcceptMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accessCode: // value for 'accessCode'
 *   },
 * });
 */
export function useConsumerCartInvitationAcceptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartInvitationAcceptMutation,
    ConsumerCartInvitationAcceptMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartInvitationAcceptMutation,
    ConsumerCartInvitationAcceptMutationVariables
  >(ConsumerCartInvitationAcceptDocument, options);
}
export type ConsumerCartInvitationAcceptMutationHookResult = ReturnType<
  typeof useConsumerCartInvitationAcceptMutation
>;
export type ConsumerCartInvitationAcceptMutationResult =
  Apollo.MutationResult<ConsumerCartInvitationAcceptMutation>;
export type ConsumerCartInvitationAcceptMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartInvitationAcceptMutation,
  ConsumerCartInvitationAcceptMutationVariables
>;
export const ConsumerCartModificationCreateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartModificationCreate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartModificationCreate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'fulfillmentDetail'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartModificationCreateMutationFn = Apollo.MutationFunction<
  ConsumerCartModificationCreateMutation,
  ConsumerCartModificationCreateMutationVariables
>;

/**
 * __useConsumerCartModificationCreateMutation__
 *
 * To run a mutation, you first call `useConsumerCartModificationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartModificationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartModificationCreateMutation, { data, loading, error }] = useConsumerCartModificationCreateMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useConsumerCartModificationCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartModificationCreateMutation,
    ConsumerCartModificationCreateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartModificationCreateMutation,
    ConsumerCartModificationCreateMutationVariables
  >(ConsumerCartModificationCreateDocument, options);
}
export type ConsumerCartModificationCreateMutationHookResult = ReturnType<
  typeof useConsumerCartModificationCreateMutation
>;
export type ConsumerCartModificationCreateMutationResult =
  Apollo.MutationResult<ConsumerCartModificationCreateMutation>;
export type ConsumerCartModificationCreateMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartModificationCreateMutation,
  ConsumerCartModificationCreateMutationVariables
>;
export const ConsumerCartModificationDeleteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartModificationDelete'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartModificationDelete'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'parentOrderId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartModificationDeleteMutationFn = Apollo.MutationFunction<
  ConsumerCartModificationDeleteMutation,
  ConsumerCartModificationDeleteMutationVariables
>;

/**
 * __useConsumerCartModificationDeleteMutation__
 *
 * To run a mutation, you first call `useConsumerCartModificationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartModificationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartModificationDeleteMutation, { data, loading, error }] = useConsumerCartModificationDeleteMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useConsumerCartModificationDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartModificationDeleteMutation,
    ConsumerCartModificationDeleteMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartModificationDeleteMutation,
    ConsumerCartModificationDeleteMutationVariables
  >(ConsumerCartModificationDeleteDocument, options);
}
export type ConsumerCartModificationDeleteMutationHookResult = ReturnType<
  typeof useConsumerCartModificationDeleteMutation
>;
export type ConsumerCartModificationDeleteMutationResult =
  Apollo.MutationResult<ConsumerCartModificationDeleteMutation>;
export type ConsumerCartModificationDeleteMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartModificationDeleteMutation,
  ConsumerCartModificationDeleteMutationVariables
>;
export const ConsumerCartPaymentMethodUpdateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartPaymentMethodUpdate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {kind: 'Name', value: 'ConsumerCartPaymentMethodUpdateInput'},
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartExperience'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartPaymentMethodUpdate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateReferenceCodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'currentValue'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'orderId'},
                                  value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                                },
                              ],
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'requiresCreditLine'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'procurement'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'customerMessages'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'enforce'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'fulfillmentDetail'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'customerMessages'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'stage'},
                                  value: {kind: 'EnumValue', value: 'CHECKOUT'},
                                },
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'catererUrlId'},
                                  value: {
                                    kind: 'Variable',
                                    name: {kind: 'Name', value: 'catererUrlId'},
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'experience'},
                                  value: {
                                    kind: 'Variable',
                                    name: {kind: 'Name', value: 'experience'},
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'paymentMethod'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'CreditCard'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'CreditLine'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'corpAccountName'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartPaymentMethodUpdateMutationFn = Apollo.MutationFunction<
  ConsumerCartPaymentMethodUpdateMutation,
  ConsumerCartPaymentMethodUpdateMutationVariables
>;

/**
 * __useConsumerCartPaymentMethodUpdateMutation__
 *
 * To run a mutation, you first call `useConsumerCartPaymentMethodUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartPaymentMethodUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartPaymentMethodUpdateMutation, { data, loading, error }] = useConsumerCartPaymentMethodUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      catererUrlId: // value for 'catererUrlId'
 *      experience: // value for 'experience'
 *   },
 * });
 */
export function useConsumerCartPaymentMethodUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartPaymentMethodUpdateMutation,
    ConsumerCartPaymentMethodUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartPaymentMethodUpdateMutation,
    ConsumerCartPaymentMethodUpdateMutationVariables
  >(ConsumerCartPaymentMethodUpdateDocument, options);
}
export type ConsumerCartPaymentMethodUpdateMutationHookResult = ReturnType<
  typeof useConsumerCartPaymentMethodUpdateMutation
>;
export type ConsumerCartPaymentMethodUpdateMutationResult =
  Apollo.MutationResult<ConsumerCartPaymentMethodUpdateMutation>;
export type ConsumerCartPaymentMethodUpdateMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartPaymentMethodUpdateMutation,
  ConsumerCartPaymentMethodUpdateMutationVariables
>;
export const ConsumerCartSubmitMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartSubmitMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'marketingSmsOptin'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'brandCommunicationOptIn'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'forterToken'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartSubmit'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'marketingSmsOptin'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'marketingSmsOptin'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'brandCommunicationOptIn'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'brandCommunicationOptIn'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'forterToken'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'forterToken'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'order'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CheckoutError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartSubmitMutationMutationFn = Apollo.MutationFunction<
  ConsumerCartSubmitMutation,
  ConsumerCartSubmitMutationVariables
>;

/**
 * __useConsumerCartSubmitMutation__
 *
 * To run a mutation, you first call `useConsumerCartSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartSubmitMutation, { data, loading, error }] = useConsumerCartSubmitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      marketingSmsOptin: // value for 'marketingSmsOptin'
 *      brandCommunicationOptIn: // value for 'brandCommunicationOptIn'
 *      forterToken: // value for 'forterToken'
 *   },
 * });
 */
export function useConsumerCartSubmitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartSubmitMutation,
    ConsumerCartSubmitMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ConsumerCartSubmitMutation, ConsumerCartSubmitMutationVariables>(
    ConsumerCartSubmitMutationDocument,
    options,
  );
}
export type ConsumerCartSubmitMutationHookResult = ReturnType<typeof useConsumerCartSubmitMutation>;
export type ConsumerCartSubmitMutationMutationResult =
  Apollo.MutationResult<ConsumerCartSubmitMutation>;
export type ConsumerCartSubmitMutationMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartSubmitMutation,
  ConsumerCartSubmitMutationVariables
>;
export const ConsumerCartUpdateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartUpdate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartUpdateInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartUpdate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartUpdateMutationFn = Apollo.MutationFunction<
  ConsumerCartUpdateMutation,
  ConsumerCartUpdateMutationVariables
>;

/**
 * __useConsumerCartUpdateMutation__
 *
 * To run a mutation, you first call `useConsumerCartUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartUpdateMutation, { data, loading, error }] = useConsumerCartUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerCartUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartUpdateMutation,
    ConsumerCartUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ConsumerCartUpdateMutation, ConsumerCartUpdateMutationVariables>(
    ConsumerCartUpdateDocument,
    options,
  );
}
export type ConsumerCartUpdateMutationHookResult = ReturnType<typeof useConsumerCartUpdateMutation>;
export type ConsumerCartUpdateMutationResult = Apollo.MutationResult<ConsumerCartUpdateMutation>;
export type ConsumerCartUpdateMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartUpdateMutation,
  ConsumerCartUpdateMutationVariables
>;
export const ConsumerCartUpdateEzRewardsPointsToApplyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartUpdateEzRewardsPointsToApply'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {kind: 'Name', value: 'ConsumerCartUpdateEzRewardsPointsToApplyInput'},
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartUpdateEzRewardsPointsToApply'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CheckoutConsumerCartFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'staticMapUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'creditCardPaymentAllowed'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'currentValue'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderId'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'requiresCreditLine'}},
                {kind: 'Field', name: {kind: 'Name', value: 'procurement'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsNotAvailable'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'missingItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'missingChoices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userCanAccessEzRewards'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'combined'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'dollarsToApply'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totalRemaining'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'amount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'extraPointsToApply'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'boosted'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'amount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerMessages'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'stage'},
                      value: {kind: 'EnumValue', value: 'CHECKOUT'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ConsumerCartItemsNotAvailable'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'missingItems'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'missingChoices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'user'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'requiresProcurementCheckout'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartUpdateEzRewardsPointsToApplyMutationFn = Apollo.MutationFunction<
  ConsumerCartUpdateEzRewardsPointsToApplyMutation,
  ConsumerCartUpdateEzRewardsPointsToApplyMutationVariables
>;

/**
 * __useConsumerCartUpdateEzRewardsPointsToApplyMutation__
 *
 * To run a mutation, you first call `useConsumerCartUpdateEzRewardsPointsToApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartUpdateEzRewardsPointsToApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartUpdateEzRewardsPointsToApplyMutation, { data, loading, error }] = useConsumerCartUpdateEzRewardsPointsToApplyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerCartUpdateEzRewardsPointsToApplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartUpdateEzRewardsPointsToApplyMutation,
    ConsumerCartUpdateEzRewardsPointsToApplyMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartUpdateEzRewardsPointsToApplyMutation,
    ConsumerCartUpdateEzRewardsPointsToApplyMutationVariables
  >(ConsumerCartUpdateEzRewardsPointsToApplyDocument, options);
}
export type ConsumerCartUpdateEzRewardsPointsToApplyMutationHookResult = ReturnType<
  typeof useConsumerCartUpdateEzRewardsPointsToApplyMutation
>;
export type ConsumerCartUpdateEzRewardsPointsToApplyMutationResult =
  Apollo.MutationResult<ConsumerCartUpdateEzRewardsPointsToApplyMutation>;
export type ConsumerCartUpdateEzRewardsPointsToApplyMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartUpdateEzRewardsPointsToApplyMutation,
  ConsumerCartUpdateEzRewardsPointsToApplyMutationVariables
>;
export const ConsumerCartUpdateFreeTablewareDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ConsumerCartUpdateFreeTableware'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: {kind: 'Name', value: 'ConsumerCartFreeTablewareItemUpdateInput'},
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCartUpdateFreeTableware'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'EntityNotFound'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ConsumerCartUpdateFreeTablewareMutationFn = Apollo.MutationFunction<
  ConsumerCartUpdateFreeTablewareMutation,
  ConsumerCartUpdateFreeTablewareMutationVariables
>;

/**
 * __useConsumerCartUpdateFreeTablewareMutation__
 *
 * To run a mutation, you first call `useConsumerCartUpdateFreeTablewareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartUpdateFreeTablewareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCartUpdateFreeTablewareMutation, { data, loading, error }] = useConsumerCartUpdateFreeTablewareMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerCartUpdateFreeTablewareMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsumerCartUpdateFreeTablewareMutation,
    ConsumerCartUpdateFreeTablewareMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ConsumerCartUpdateFreeTablewareMutation,
    ConsumerCartUpdateFreeTablewareMutationVariables
  >(ConsumerCartUpdateFreeTablewareDocument, options);
}
export type ConsumerCartUpdateFreeTablewareMutationHookResult = ReturnType<
  typeof useConsumerCartUpdateFreeTablewareMutation
>;
export type ConsumerCartUpdateFreeTablewareMutationResult =
  Apollo.MutationResult<ConsumerCartUpdateFreeTablewareMutation>;
export type ConsumerCartUpdateFreeTablewareMutationOptions = Apollo.BaseMutationOptions<
  ConsumerCartUpdateFreeTablewareMutation,
  ConsumerCartUpdateFreeTablewareMutationVariables
>;
export const CorpAccountAcceptInviteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CorpAccountAcceptInvite'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'inviteId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'inviteToken'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccountAcceptInvite'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'inviteId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'inviteId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'inviteToken'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'inviteToken'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'invite'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'redirectTo'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CorpAccountAcceptInviteMutationFn = Apollo.MutationFunction<
  CorpAccountAcceptInviteMutation,
  CorpAccountAcceptInviteMutationVariables
>;

/**
 * __useCorpAccountAcceptInviteMutation__
 *
 * To run a mutation, you first call `useCorpAccountAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorpAccountAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [corpAccountAcceptInviteMutation, { data, loading, error }] = useCorpAccountAcceptInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useCorpAccountAcceptInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CorpAccountAcceptInviteMutation,
    CorpAccountAcceptInviteMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CorpAccountAcceptInviteMutation,
    CorpAccountAcceptInviteMutationVariables
  >(CorpAccountAcceptInviteDocument, options);
}
export type CorpAccountAcceptInviteMutationHookResult = ReturnType<
  typeof useCorpAccountAcceptInviteMutation
>;
export type CorpAccountAcceptInviteMutationResult =
  Apollo.MutationResult<CorpAccountAcceptInviteMutation>;
export type CorpAccountAcceptInviteMutationOptions = Apollo.BaseMutationOptions<
  CorpAccountAcceptInviteMutation,
  CorpAccountAcceptInviteMutationVariables
>;
export const CorpAccountRejectInviteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CorpAccountRejectInvite'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'inviteId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'inviteToken'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccountRejectInvite'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'inviteId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'inviteId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'inviteToken'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'inviteToken'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'invite'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CorpAccountRejectInviteMutationFn = Apollo.MutationFunction<
  CorpAccountRejectInviteMutation,
  CorpAccountRejectInviteMutationVariables
>;

/**
 * __useCorpAccountRejectInviteMutation__
 *
 * To run a mutation, you first call `useCorpAccountRejectInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorpAccountRejectInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [corpAccountRejectInviteMutation, { data, loading, error }] = useCorpAccountRejectInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useCorpAccountRejectInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CorpAccountRejectInviteMutation,
    CorpAccountRejectInviteMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CorpAccountRejectInviteMutation,
    CorpAccountRejectInviteMutationVariables
  >(CorpAccountRejectInviteDocument, options);
}
export type CorpAccountRejectInviteMutationHookResult = ReturnType<
  typeof useCorpAccountRejectInviteMutation
>;
export type CorpAccountRejectInviteMutationResult =
  Apollo.MutationResult<CorpAccountRejectInviteMutation>;
export type CorpAccountRejectInviteMutationOptions = Apollo.BaseMutationOptions<
  CorpAccountRejectInviteMutation,
  CorpAccountRejectInviteMutationVariables
>;
export const CreateFulfillmentDetailFromAddressDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateFulfillmentDetailFromAddress'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetailCreateInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetailCreate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateFulfillmentDetailFromAddressMutationFn = Apollo.MutationFunction<
  CreateFulfillmentDetailFromAddressMutation,
  CreateFulfillmentDetailFromAddressMutationVariables
>;

/**
 * __useCreateFulfillmentDetailFromAddressMutation__
 *
 * To run a mutation, you first call `useCreateFulfillmentDetailFromAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFulfillmentDetailFromAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFulfillmentDetailFromAddressMutation, { data, loading, error }] = useCreateFulfillmentDetailFromAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFulfillmentDetailFromAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFulfillmentDetailFromAddressMutation,
    CreateFulfillmentDetailFromAddressMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreateFulfillmentDetailFromAddressMutation,
    CreateFulfillmentDetailFromAddressMutationVariables
  >(CreateFulfillmentDetailFromAddressDocument, options);
}
export type CreateFulfillmentDetailFromAddressMutationHookResult = ReturnType<
  typeof useCreateFulfillmentDetailFromAddressMutation
>;
export type CreateFulfillmentDetailFromAddressMutationResult =
  Apollo.MutationResult<CreateFulfillmentDetailFromAddressMutation>;
export type CreateFulfillmentDetailFromAddressMutationOptions = Apollo.BaseMutationOptions<
  CreateFulfillmentDetailFromAddressMutation,
  CreateFulfillmentDetailFromAddressMutationVariables
>;
export const CreateFulfillmentDetailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateFulfillmentDetail'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetailCreateInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetailCreate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateFulfillmentDetailMutationFn = Apollo.MutationFunction<
  CreateFulfillmentDetailMutation,
  CreateFulfillmentDetailMutationVariables
>;

/**
 * __useCreateFulfillmentDetailMutation__
 *
 * To run a mutation, you first call `useCreateFulfillmentDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFulfillmentDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFulfillmentDetailMutation, { data, loading, error }] = useCreateFulfillmentDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFulfillmentDetailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFulfillmentDetailMutation,
    CreateFulfillmentDetailMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreateFulfillmentDetailMutation,
    CreateFulfillmentDetailMutationVariables
  >(CreateFulfillmentDetailDocument, options);
}
export type CreateFulfillmentDetailMutationHookResult = ReturnType<
  typeof useCreateFulfillmentDetailMutation
>;
export type CreateFulfillmentDetailMutationResult =
  Apollo.MutationResult<CreateFulfillmentDetailMutation>;
export type CreateFulfillmentDetailMutationOptions = Apollo.BaseMutationOptions<
  CreateFulfillmentDetailMutation,
  CreateFulfillmentDetailMutationVariables
>;
export const CreateLegalRequestUploadUrlDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreateLegalRequestUploadUrl'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filename'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'contentType'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'createLegalRequestUploadUrl'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filename'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filename'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'contentType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'contentType'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'uploadUrl'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateLegalRequestUploadUrlMutationFn = Apollo.MutationFunction<
  CreateLegalRequestUploadUrlMutation,
  CreateLegalRequestUploadUrlMutationVariables
>;

/**
 * __useCreateLegalRequestUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateLegalRequestUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLegalRequestUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLegalRequestUploadUrlMutation, { data, loading, error }] = useCreateLegalRequestUploadUrlMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useCreateLegalRequestUploadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLegalRequestUploadUrlMutation,
    CreateLegalRequestUploadUrlMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreateLegalRequestUploadUrlMutation,
    CreateLegalRequestUploadUrlMutationVariables
  >(CreateLegalRequestUploadUrlDocument, options);
}
export type CreateLegalRequestUploadUrlMutationHookResult = ReturnType<
  typeof useCreateLegalRequestUploadUrlMutation
>;
export type CreateLegalRequestUploadUrlMutationResult =
  Apollo.MutationResult<CreateLegalRequestUploadUrlMutation>;
export type CreateLegalRequestUploadUrlMutationOptions = Apollo.BaseMutationOptions<
  CreateLegalRequestUploadUrlMutation,
  CreateLegalRequestUploadUrlMutationVariables
>;
export const CreditCardAddDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreditCardAdd'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'cardholderName'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethodNonce'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'deviceData'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'nickname'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'forterToken'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'source'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'CreditCardAddSource'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'makeDefault'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'addCreditCard'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'cardholderName'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'cardholderName'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'paymentMethodNonce'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethodNonce'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'deviceData'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'deviceData'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'nickname'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'nickname'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'forterToken'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'forterToken'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'source'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'source'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'makeDefault'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'makeDefault'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'creditCard'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreditCardAddMutationFn = Apollo.MutationFunction<
  CreditCardAddMutation,
  CreditCardAddMutationVariables
>;

/**
 * __useCreditCardAddMutation__
 *
 * To run a mutation, you first call `useCreditCardAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreditCardAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creditCardAddMutation, { data, loading, error }] = useCreditCardAddMutation({
 *   variables: {
 *      cardholderName: // value for 'cardholderName'
 *      paymentMethodNonce: // value for 'paymentMethodNonce'
 *      deviceData: // value for 'deviceData'
 *      nickname: // value for 'nickname'
 *      forterToken: // value for 'forterToken'
 *      source: // value for 'source'
 *      makeDefault: // value for 'makeDefault'
 *   },
 * });
 */
export function useCreditCardAddMutation(
  baseOptions?: Apollo.MutationHookOptions<CreditCardAddMutation, CreditCardAddMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CreditCardAddMutation, CreditCardAddMutationVariables>(
    CreditCardAddDocument,
    options,
  );
}
export type CreditCardAddMutationHookResult = ReturnType<typeof useCreditCardAddMutation>;
export type CreditCardAddMutationResult = Apollo.MutationResult<CreditCardAddMutation>;
export type CreditCardAddMutationOptions = Apollo.BaseMutationOptions<
  CreditCardAddMutation,
  CreditCardAddMutationVariables
>;
export const CreditCardDeleteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreditCardDelete'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'creditCardId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteCreditCard'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'creditCardId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'creditCardId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreditCardDeleteMutationFn = Apollo.MutationFunction<
  CreditCardDeleteMutation,
  CreditCardDeleteMutationVariables
>;

/**
 * __useCreditCardDeleteMutation__
 *
 * To run a mutation, you first call `useCreditCardDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreditCardDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creditCardDeleteMutation, { data, loading, error }] = useCreditCardDeleteMutation({
 *   variables: {
 *      creditCardId: // value for 'creditCardId'
 *   },
 * });
 */
export function useCreditCardDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreditCardDeleteMutation,
    CreditCardDeleteMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CreditCardDeleteMutation, CreditCardDeleteMutationVariables>(
    CreditCardDeleteDocument,
    options,
  );
}
export type CreditCardDeleteMutationHookResult = ReturnType<typeof useCreditCardDeleteMutation>;
export type CreditCardDeleteMutationResult = Apollo.MutationResult<CreditCardDeleteMutation>;
export type CreditCardDeleteMutationOptions = Apollo.BaseMutationOptions<
  CreditCardDeleteMutation,
  CreditCardDeleteMutationVariables
>;
export const CreditCardRemoveDefaultDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreditCardRemoveDefault'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'removeDefaultCreditCard'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'paymentMethods'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CreditCard'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CreditLine'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isDefault'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreditCardRemoveDefaultMutationFn = Apollo.MutationFunction<
  CreditCardRemoveDefaultMutation,
  CreditCardRemoveDefaultMutationVariables
>;

/**
 * __useCreditCardRemoveDefaultMutation__
 *
 * To run a mutation, you first call `useCreditCardRemoveDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreditCardRemoveDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creditCardRemoveDefaultMutation, { data, loading, error }] = useCreditCardRemoveDefaultMutation({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useCreditCardRemoveDefaultMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreditCardRemoveDefaultMutation,
    CreditCardRemoveDefaultMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreditCardRemoveDefaultMutation,
    CreditCardRemoveDefaultMutationVariables
  >(CreditCardRemoveDefaultDocument, options);
}
export type CreditCardRemoveDefaultMutationHookResult = ReturnType<
  typeof useCreditCardRemoveDefaultMutation
>;
export type CreditCardRemoveDefaultMutationResult =
  Apollo.MutationResult<CreditCardRemoveDefaultMutation>;
export type CreditCardRemoveDefaultMutationOptions = Apollo.BaseMutationOptions<
  CreditCardRemoveDefaultMutation,
  CreditCardRemoveDefaultMutationVariables
>;
export const CreditCardSetAsDefaultDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreditCardSetAsDefault'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'creditCardId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'setAsDefaultCreditCard'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'creditCardId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'creditCardId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'creditCard'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'paymentMethods'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CreditCard'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CreditLine'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isDefault'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreditCardSetAsDefaultMutationFn = Apollo.MutationFunction<
  CreditCardSetAsDefaultMutation,
  CreditCardSetAsDefaultMutationVariables
>;

/**
 * __useCreditCardSetAsDefaultMutation__
 *
 * To run a mutation, you first call `useCreditCardSetAsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreditCardSetAsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creditCardSetAsDefaultMutation, { data, loading, error }] = useCreditCardSetAsDefaultMutation({
 *   variables: {
 *      creditCardId: // value for 'creditCardId'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useCreditCardSetAsDefaultMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreditCardSetAsDefaultMutation,
    CreditCardSetAsDefaultMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreditCardSetAsDefaultMutation,
    CreditCardSetAsDefaultMutationVariables
  >(CreditCardSetAsDefaultDocument, options);
}
export type CreditCardSetAsDefaultMutationHookResult = ReturnType<
  typeof useCreditCardSetAsDefaultMutation
>;
export type CreditCardSetAsDefaultMutationResult =
  Apollo.MutationResult<CreditCardSetAsDefaultMutation>;
export type CreditCardSetAsDefaultMutationOptions = Apollo.BaseMutationOptions<
  CreditCardSetAsDefaultMutation,
  CreditCardSetAsDefaultMutationVariables
>;
export const ShareCreditCardDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ShareCreditCard'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethodId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'shareTargets'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {kind: 'NamedType', name: {kind: 'Name', value: 'ShareTarget'}},
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'shareWithAll'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'shareCreditCard'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'paymentMethodId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethodId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'shareTargets'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'shareTargets'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'shareWithAll'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'shareWithAll'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'success'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'creditCard'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isSharedWithCorpAccount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'sharedWithCount'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'usersSharedWith'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'departmentsSharedWith'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ShareCreditCardMutationFn = Apollo.MutationFunction<
  ShareCreditCardMutation,
  ShareCreditCardMutationVariables
>;

/**
 * __useShareCreditCardMutation__
 *
 * To run a mutation, you first call `useShareCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareCreditCardMutation, { data, loading, error }] = useShareCreditCardMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *      shareTargets: // value for 'shareTargets'
 *      shareWithAll: // value for 'shareWithAll'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useShareCreditCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShareCreditCardMutation,
    ShareCreditCardMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ShareCreditCardMutation, ShareCreditCardMutationVariables>(
    ShareCreditCardDocument,
    options,
  );
}
export type ShareCreditCardMutationHookResult = ReturnType<typeof useShareCreditCardMutation>;
export type ShareCreditCardMutationResult = Apollo.MutationResult<ShareCreditCardMutation>;
export type ShareCreditCardMutationOptions = Apollo.BaseMutationOptions<
  ShareCreditCardMutation,
  ShareCreditCardMutationVariables
>;
export const CreditCardUpdateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreditCardUpdate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'cardholderName'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'creditCardId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'expMonth'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'expYear'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateCreditCard'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'cardholderName'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'cardholderName'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'creditCardId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'creditCardId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'expMonth'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'expMonth'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'expYear'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'expYear'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'creditCard'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'paymentMethods'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CreditCard'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreditCardUpdateMutationFn = Apollo.MutationFunction<
  CreditCardUpdateMutation,
  CreditCardUpdateMutationVariables
>;

/**
 * __useCreditCardUpdateMutation__
 *
 * To run a mutation, you first call `useCreditCardUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreditCardUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creditCardUpdateMutation, { data, loading, error }] = useCreditCardUpdateMutation({
 *   variables: {
 *      cardholderName: // value for 'cardholderName'
 *      creditCardId: // value for 'creditCardId'
 *      expMonth: // value for 'expMonth'
 *      expYear: // value for 'expYear'
 *   },
 * });
 */
export function useCreditCardUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreditCardUpdateMutation,
    CreditCardUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<CreditCardUpdateMutation, CreditCardUpdateMutationVariables>(
    CreditCardUpdateDocument,
    options,
  );
}
export type CreditCardUpdateMutationHookResult = ReturnType<typeof useCreditCardUpdateMutation>;
export type CreditCardUpdateMutationResult = Apollo.MutationResult<CreditCardUpdateMutation>;
export type CreditCardUpdateMutationOptions = Apollo.BaseMutationOptions<
  CreditCardUpdateMutation,
  CreditCardUpdateMutationVariables
>;
export const CreditCardUpdateWithNonceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'CreditCardUpdateWithNonce'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'cardholderName'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'creditCardId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'deviceData'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'nickname'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethodNonce'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateCreditCard'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'cardholderName'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'cardholderName'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'creditCardId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'creditCardId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'deviceData'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'deviceData'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'nickname'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'nickname'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'paymentMethodNonce'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethodNonce'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'creditCard'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isExpired'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isExpiringSoon'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'paymentMethods'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CreditCard'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isExpired'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isExpiringSoon'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreditCardUpdateWithNonceMutationFn = Apollo.MutationFunction<
  CreditCardUpdateWithNonceMutation,
  CreditCardUpdateWithNonceMutationVariables
>;

/**
 * __useCreditCardUpdateWithNonceMutation__
 *
 * To run a mutation, you first call `useCreditCardUpdateWithNonceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreditCardUpdateWithNonceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creditCardUpdateWithNonceMutation, { data, loading, error }] = useCreditCardUpdateWithNonceMutation({
 *   variables: {
 *      cardholderName: // value for 'cardholderName'
 *      creditCardId: // value for 'creditCardId'
 *      deviceData: // value for 'deviceData'
 *      nickname: // value for 'nickname'
 *      paymentMethodNonce: // value for 'paymentMethodNonce'
 *   },
 * });
 */
export function useCreditCardUpdateWithNonceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreditCardUpdateWithNonceMutation,
    CreditCardUpdateWithNonceMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    CreditCardUpdateWithNonceMutation,
    CreditCardUpdateWithNonceMutationVariables
  >(CreditCardUpdateWithNonceDocument, options);
}
export type CreditCardUpdateWithNonceMutationHookResult = ReturnType<
  typeof useCreditCardUpdateWithNonceMutation
>;
export type CreditCardUpdateWithNonceMutationResult =
  Apollo.MutationResult<CreditCardUpdateWithNonceMutation>;
export type CreditCardUpdateWithNonceMutationOptions = Apollo.BaseMutationOptions<
  CreditCardUpdateWithNonceMutation,
  CreditCardUpdateWithNonceMutationVariables
>;
export const DeleteRecentSearchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DeleteRecentSearch'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteRecentSearch'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'fulfillmentDetailId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteRecentSearchMutationFn = Apollo.MutationFunction<
  DeleteRecentSearchMutation,
  DeleteRecentSearchMutationVariables
>;

/**
 * __useDeleteRecentSearchMutation__
 *
 * To run a mutation, you first call `useDeleteRecentSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecentSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecentSearchMutation, { data, loading, error }] = useDeleteRecentSearchMutation({
 *   variables: {
 *      fulfillmentDetailId: // value for 'fulfillmentDetailId'
 *   },
 * });
 */
export function useDeleteRecentSearchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRecentSearchMutation,
    DeleteRecentSearchMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<DeleteRecentSearchMutation, DeleteRecentSearchMutationVariables>(
    DeleteRecentSearchDocument,
    options,
  );
}
export type DeleteRecentSearchMutationHookResult = ReturnType<typeof useDeleteRecentSearchMutation>;
export type DeleteRecentSearchMutationResult = Apollo.MutationResult<DeleteRecentSearchMutation>;
export type DeleteRecentSearchMutationOptions = Apollo.BaseMutationOptions<
  DeleteRecentSearchMutation,
  DeleteRecentSearchMutationVariables
>;
export const DirectConnectCancelAllRequestsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DirectConnectCancelAllRequests'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CancelAllRequestsInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cancelAllRequests'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'requests'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DirectConnectCancelAllRequestsMutationFn = Apollo.MutationFunction<
  DirectConnectCancelAllRequestsMutation,
  DirectConnectCancelAllRequestsMutationVariables
>;

/**
 * __useDirectConnectCancelAllRequestsMutation__
 *
 * To run a mutation, you first call `useDirectConnectCancelAllRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectConnectCancelAllRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directConnectCancelAllRequestsMutation, { data, loading, error }] = useDirectConnectCancelAllRequestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDirectConnectCancelAllRequestsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DirectConnectCancelAllRequestsMutation,
    DirectConnectCancelAllRequestsMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    DirectConnectCancelAllRequestsMutation,
    DirectConnectCancelAllRequestsMutationVariables
  >(DirectConnectCancelAllRequestsDocument, options);
}
export type DirectConnectCancelAllRequestsMutationHookResult = ReturnType<
  typeof useDirectConnectCancelAllRequestsMutation
>;
export type DirectConnectCancelAllRequestsMutationResult =
  Apollo.MutationResult<DirectConnectCancelAllRequestsMutation>;
export type DirectConnectCancelAllRequestsMutationOptions = Apollo.BaseMutationOptions<
  DirectConnectCancelAllRequestsMutation,
  DirectConnectCancelAllRequestsMutationVariables
>;
export const DirectConnectRecordDecisionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DirectConnectRecordDecision'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'RecordDecisionInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'recordDecision'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'decision'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'response'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'responderType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'completedAt'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DirectConnectRecordDecisionMutationFn = Apollo.MutationFunction<
  DirectConnectRecordDecisionMutation,
  DirectConnectRecordDecisionMutationVariables
>;

/**
 * __useDirectConnectRecordDecisionMutation__
 *
 * To run a mutation, you first call `useDirectConnectRecordDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectConnectRecordDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directConnectRecordDecisionMutation, { data, loading, error }] = useDirectConnectRecordDecisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDirectConnectRecordDecisionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DirectConnectRecordDecisionMutation,
    DirectConnectRecordDecisionMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    DirectConnectRecordDecisionMutation,
    DirectConnectRecordDecisionMutationVariables
  >(DirectConnectRecordDecisionDocument, options);
}
export type DirectConnectRecordDecisionMutationHookResult = ReturnType<
  typeof useDirectConnectRecordDecisionMutation
>;
export type DirectConnectRecordDecisionMutationResult =
  Apollo.MutationResult<DirectConnectRecordDecisionMutation>;
export type DirectConnectRecordDecisionMutationOptions = Apollo.BaseMutationOptions<
  DirectConnectRecordDecisionMutation,
  DirectConnectRecordDecisionMutationVariables
>;
export const DirectConnectRecordMessageDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DirectConnectRecordMessage'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'RecordMessageInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'recordMessage'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'message'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'content'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'sentByType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'sentById'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orderInfo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'activeMessageThread'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'brandName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cpMayRequestChange'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'custMayStartMessage'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isPickup'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderNumber'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'userUuid'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'request'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'orderInfo'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'activeMessageThread'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'brandName'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'cpMayRequestChange'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'custMayStartMessage'},
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isPickup'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'orderNumber'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'userUuid'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'messageStatus'},
                        name: {kind: 'Name', value: 'status'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'failedContentFilters'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'filterType'}}],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DirectConnectRecordMessageMutationFn = Apollo.MutationFunction<
  DirectConnectRecordMessageMutation,
  DirectConnectRecordMessageMutationVariables
>;

/**
 * __useDirectConnectRecordMessageMutation__
 *
 * To run a mutation, you first call `useDirectConnectRecordMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectConnectRecordMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directConnectRecordMessageMutation, { data, loading, error }] = useDirectConnectRecordMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDirectConnectRecordMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DirectConnectRecordMessageMutation,
    DirectConnectRecordMessageMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    DirectConnectRecordMessageMutation,
    DirectConnectRecordMessageMutationVariables
  >(DirectConnectRecordMessageDocument, options);
}
export type DirectConnectRecordMessageMutationHookResult = ReturnType<
  typeof useDirectConnectRecordMessageMutation
>;
export type DirectConnectRecordMessageMutationResult =
  Apollo.MutationResult<DirectConnectRecordMessageMutation>;
export type DirectConnectRecordMessageMutationOptions = Apollo.BaseMutationOptions<
  DirectConnectRecordMessageMutation,
  DirectConnectRecordMessageMutationVariables
>;
export const DismissConcurEnterpriseToastDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DismissConcurEnterpriseToast'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'dismissConcurEnterpriseToast'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DismissConcurEnterpriseToastMutationFn = Apollo.MutationFunction<
  DismissConcurEnterpriseToastMutation,
  DismissConcurEnterpriseToastMutationVariables
>;

/**
 * __useDismissConcurEnterpriseToastMutation__
 *
 * To run a mutation, you first call `useDismissConcurEnterpriseToastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissConcurEnterpriseToastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissConcurEnterpriseToastMutation, { data, loading, error }] = useDismissConcurEnterpriseToastMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissConcurEnterpriseToastMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DismissConcurEnterpriseToastMutation,
    DismissConcurEnterpriseToastMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    DismissConcurEnterpriseToastMutation,
    DismissConcurEnterpriseToastMutationVariables
  >(DismissConcurEnterpriseToastDocument, options);
}
export type DismissConcurEnterpriseToastMutationHookResult = ReturnType<
  typeof useDismissConcurEnterpriseToastMutation
>;
export type DismissConcurEnterpriseToastMutationResult =
  Apollo.MutationResult<DismissConcurEnterpriseToastMutation>;
export type DismissConcurEnterpriseToastMutationOptions = Apollo.BaseMutationOptions<
  DismissConcurEnterpriseToastMutation,
  DismissConcurEnterpriseToastMutationVariables
>;
export const DraftOrderDeleteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'DraftOrderDelete'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deleteDraftOrder'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DraftOrderDeleteMutationFn = Apollo.MutationFunction<
  DraftOrderDeleteMutation,
  DraftOrderDeleteMutationVariables
>;

/**
 * __useDraftOrderDeleteMutation__
 *
 * To run a mutation, you first call `useDraftOrderDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftOrderDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftOrderDeleteMutation, { data, loading, error }] = useDraftOrderDeleteMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useDraftOrderDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DraftOrderDeleteMutation,
    DraftOrderDeleteMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<DraftOrderDeleteMutation, DraftOrderDeleteMutationVariables>(
    DraftOrderDeleteDocument,
    options,
  );
}
export type DraftOrderDeleteMutationHookResult = ReturnType<typeof useDraftOrderDeleteMutation>;
export type DraftOrderDeleteMutationResult = Apollo.MutationResult<DraftOrderDeleteMutation>;
export type DraftOrderDeleteMutationOptions = Apollo.BaseMutationOptions<
  DraftOrderDeleteMutation,
  DraftOrderDeleteMutationVariables
>;
export const EzRewardsEnrollmentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'EzRewardsEnrollment'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'isEnrolled'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'toggleEzRewardsEnrollment'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'isEnrolled'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'isEnrolled'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EzRewardsEnrollmentMutationFn = Apollo.MutationFunction<
  EzRewardsEnrollmentMutation,
  EzRewardsEnrollmentMutationVariables
>;

/**
 * __useEzRewardsEnrollmentMutation__
 *
 * To run a mutation, you first call `useEzRewardsEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEzRewardsEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ezRewardsEnrollmentMutation, { data, loading, error }] = useEzRewardsEnrollmentMutation({
 *   variables: {
 *      isEnrolled: // value for 'isEnrolled'
 *   },
 * });
 */
export function useEzRewardsEnrollmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EzRewardsEnrollmentMutation,
    EzRewardsEnrollmentMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<EzRewardsEnrollmentMutation, EzRewardsEnrollmentMutationVariables>(
    EzRewardsEnrollmentDocument,
    options,
  );
}
export type EzRewardsEnrollmentMutationHookResult = ReturnType<
  typeof useEzRewardsEnrollmentMutation
>;
export type EzRewardsEnrollmentMutationResult = Apollo.MutationResult<EzRewardsEnrollmentMutation>;
export type EzRewardsEnrollmentMutationOptions = Apollo.BaseMutationOptions<
  EzRewardsEnrollmentMutation,
  EzRewardsEnrollmentMutationVariables
>;
export const FulfillmentDetailUpdateMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'FulfillmentDetailUpdateMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetailUpdateInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetailUpdate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type FulfillmentDetailUpdateMutationMutationFn = Apollo.MutationFunction<
  FulfillmentDetailUpdateMutation,
  FulfillmentDetailUpdateMutationVariables
>;

/**
 * __useFulfillmentDetailUpdateMutation__
 *
 * To run a mutation, you first call `useFulfillmentDetailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentDetailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fulfillmentDetailUpdateMutation, { data, loading, error }] = useFulfillmentDetailUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFulfillmentDetailUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FulfillmentDetailUpdateMutation,
    FulfillmentDetailUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    FulfillmentDetailUpdateMutation,
    FulfillmentDetailUpdateMutationVariables
  >(FulfillmentDetailUpdateMutationDocument, options);
}
export type FulfillmentDetailUpdateMutationHookResult = ReturnType<
  typeof useFulfillmentDetailUpdateMutation
>;
export type FulfillmentDetailUpdateMutationMutationResult =
  Apollo.MutationResult<FulfillmentDetailUpdateMutation>;
export type FulfillmentDetailUpdateMutationMutationOptions = Apollo.BaseMutationOptions<
  FulfillmentDetailUpdateMutation,
  FulfillmentDetailUpdateMutationVariables
>;
export const NotificationSubscriptionsUpdateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'NotificationSubscriptionsUpdate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'deliveryUpdate'}},
          type: {
            kind: 'NamedType',
            name: {kind: 'Name', value: 'DeliveryUpdateNotificationSubscriptionsInput'},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererConfirmation'}},
          type: {
            kind: 'NamedType',
            name: {kind: 'Name', value: 'CatererConfirmationNotificationSubscriptionsInput'},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateNotificationSubscriptions'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'deliveryUpdate'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'deliveryUpdate'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererConfirmation'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererConfirmation'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'notificationSubscriptions'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'deliveryUpdate'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'txt'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'push'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'catererConfirmation'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'email'}}],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type NotificationSubscriptionsUpdateMutationFn = Apollo.MutationFunction<
  NotificationSubscriptionsUpdateMutation,
  NotificationSubscriptionsUpdateMutationVariables
>;

/**
 * __useNotificationSubscriptionsUpdate__
 *
 * To run a mutation, you first call `useNotificationSubscriptionsUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationSubscriptionsUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationSubscriptionsUpdate, { data, loading, error }] = useNotificationSubscriptionsUpdate({
 *   variables: {
 *      deliveryUpdate: // value for 'deliveryUpdate'
 *      catererConfirmation: // value for 'catererConfirmation'
 *   },
 * });
 */
export function useNotificationSubscriptionsUpdate(
  baseOptions?: Apollo.MutationHookOptions<
    NotificationSubscriptionsUpdateMutation,
    NotificationSubscriptionsUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    NotificationSubscriptionsUpdateMutation,
    NotificationSubscriptionsUpdateMutationVariables
  >(NotificationSubscriptionsUpdateDocument, options);
}
export type NotificationSubscriptionsUpdateHookResult = ReturnType<
  typeof useNotificationSubscriptionsUpdate
>;
export type NotificationSubscriptionsUpdateMutationResult =
  Apollo.MutationResult<NotificationSubscriptionsUpdateMutation>;
export type NotificationSubscriptionsUpdateMutationOptions = Apollo.BaseMutationOptions<
  NotificationSubscriptionsUpdateMutation,
  NotificationSubscriptionsUpdateMutationVariables
>;
export const NotifyAdminsOfMissingPaymentMethodDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'NotifyAdminsOfMissingPaymentMethod'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'notifyAdminsOfMissingPaymentMethod'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type NotifyAdminsOfMissingPaymentMethodMutationFn = Apollo.MutationFunction<
  NotifyAdminsOfMissingPaymentMethodMutation,
  NotifyAdminsOfMissingPaymentMethodMutationVariables
>;

/**
 * __useNotifyAdminsOfMissingPaymentMethodMutation__
 *
 * To run a mutation, you first call `useNotifyAdminsOfMissingPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyAdminsOfMissingPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyAdminsOfMissingPaymentMethodMutation, { data, loading, error }] = useNotifyAdminsOfMissingPaymentMethodMutation({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useNotifyAdminsOfMissingPaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NotifyAdminsOfMissingPaymentMethodMutation,
    NotifyAdminsOfMissingPaymentMethodMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    NotifyAdminsOfMissingPaymentMethodMutation,
    NotifyAdminsOfMissingPaymentMethodMutationVariables
  >(NotifyAdminsOfMissingPaymentMethodDocument, options);
}
export type NotifyAdminsOfMissingPaymentMethodMutationHookResult = ReturnType<
  typeof useNotifyAdminsOfMissingPaymentMethodMutation
>;
export type NotifyAdminsOfMissingPaymentMethodMutationResult =
  Apollo.MutationResult<NotifyAdminsOfMissingPaymentMethodMutation>;
export type NotifyAdminsOfMissingPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  NotifyAdminsOfMissingPaymentMethodMutation,
  NotifyAdminsOfMissingPaymentMethodMutationVariables
>;
export const OrderCancelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'OrderCancel'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'reason'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'CancelledByReasonEnum'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'explanation'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cancelOrder'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'reason'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'reason'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'explanation'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'explanation'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'order'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type OrderCancelMutationFn = Apollo.MutationFunction<
  OrderCancelMutation,
  OrderCancelMutationVariables
>;

/**
 * __useOrderCancelMutation__
 *
 * To run a mutation, you first call `useOrderCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCancelMutation, { data, loading, error }] = useOrderCancelMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      reason: // value for 'reason'
 *      explanation: // value for 'explanation'
 *   },
 * });
 */
export function useOrderCancelMutation(
  baseOptions?: Apollo.MutationHookOptions<OrderCancelMutation, OrderCancelMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<OrderCancelMutation, OrderCancelMutationVariables>(
    OrderCancelDocument,
    options,
  );
}
export type OrderCancelMutationHookResult = ReturnType<typeof useOrderCancelMutation>;
export type OrderCancelMutationResult = Apollo.MutationResult<OrderCancelMutation>;
export type OrderCancelMutationOptions = Apollo.BaseMutationOptions<
  OrderCancelMutation,
  OrderCancelMutationVariables
>;
export const OrderPaymentMethodUpdateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'OrderPaymentMethodUpdate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethod'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'PaymentMethodInputType'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'corporateOrderReferenceCodes'}},
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'OrderReferenceCodeInput'}},
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderPaymentMethodUpdate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'paymentMethod'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethod'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'order'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMissingRequiredFullAuth'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'paymentMethod'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'CreditCard'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'missingZipCode'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'CreditLine'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'corpAccountName'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateReferenceCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateReferenceCodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'currentValue'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'orderId'},
                                  value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                                },
                              ],
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'procurement'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'requiresCreditLine'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'PaymentAuthorizationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type OrderPaymentMethodUpdateMutationFn = Apollo.MutationFunction<
  OrderPaymentMethodUpdateMutation,
  OrderPaymentMethodUpdateMutationVariables
>;

/**
 * __useOrderPaymentMethodUpdateMutation__
 *
 * To run a mutation, you first call `useOrderPaymentMethodUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderPaymentMethodUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderPaymentMethodUpdateMutation, { data, loading, error }] = useOrderPaymentMethodUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentMethod: // value for 'paymentMethod'
 *      corporateOrderReferenceCodes: // value for 'corporateOrderReferenceCodes'
 *   },
 * });
 */
export function useOrderPaymentMethodUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrderPaymentMethodUpdateMutation,
    OrderPaymentMethodUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    OrderPaymentMethodUpdateMutation,
    OrderPaymentMethodUpdateMutationVariables
  >(OrderPaymentMethodUpdateDocument, options);
}
export type OrderPaymentMethodUpdateMutationHookResult = ReturnType<
  typeof useOrderPaymentMethodUpdateMutation
>;
export type OrderPaymentMethodUpdateMutationResult =
  Apollo.MutationResult<OrderPaymentMethodUpdateMutation>;
export type OrderPaymentMethodUpdateMutationOptions = Apollo.BaseMutationOptions<
  OrderPaymentMethodUpdateMutation,
  OrderPaymentMethodUpdateMutationVariables
>;
export const PersonalInformationUpdateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'PersonalInformationUpdate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'firstName'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'lastName'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'email'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'email2'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'mobilePhone'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'officePhone'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'companyName'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'jobTitle'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'industry'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UserIndustryEnum'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updatePersonalInfo'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'firstName'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'firstName'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'lastName'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'lastName'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'email'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'email'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'email2'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'email2'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'mobilePhone'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'mobilePhone'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'officePhone'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'officePhone'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'companyName'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'companyName'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'jobTitle'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'jobTitle'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'industry'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'industry'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhoneLastTwo'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'officePhoneLastTwo'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'jobTitle'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasCompletedProfile'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PersonalInformationUpdateMutationFn = Apollo.MutationFunction<
  PersonalInformationUpdateMutation,
  PersonalInformationUpdateMutationVariables
>;

/**
 * __usePersonalInformationUpdateMutation__
 *
 * To run a mutation, you first call `usePersonalInformationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonalInformationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personalInformationUpdateMutation, { data, loading, error }] = usePersonalInformationUpdateMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      email2: // value for 'email2'
 *      mobilePhone: // value for 'mobilePhone'
 *      officePhone: // value for 'officePhone'
 *      companyName: // value for 'companyName'
 *      jobTitle: // value for 'jobTitle'
 *      industry: // value for 'industry'
 *   },
 * });
 */
export function usePersonalInformationUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PersonalInformationUpdateMutation,
    PersonalInformationUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    PersonalInformationUpdateMutation,
    PersonalInformationUpdateMutationVariables
  >(PersonalInformationUpdateDocument, options);
}
export type PersonalInformationUpdateMutationHookResult = ReturnType<
  typeof usePersonalInformationUpdateMutation
>;
export type PersonalInformationUpdateMutationResult =
  Apollo.MutationResult<PersonalInformationUpdateMutation>;
export type PersonalInformationUpdateMutationOptions = Apollo.BaseMutationOptions<
  PersonalInformationUpdateMutation,
  PersonalInformationUpdateMutationVariables
>;
export const EzRewardsPointsRedeemDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'EzRewardsPointsRedeem'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'amount'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'redeemEzRewardsPoints'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'amount'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'amount'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'ezRewardsAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EzRewardsPointsRedeemMutationFn = Apollo.MutationFunction<
  EzRewardsPointsRedeemMutation,
  EzRewardsPointsRedeemMutationVariables
>;

/**
 * __useEzRewardsPointsRedeemMutation__
 *
 * To run a mutation, you first call `useEzRewardsPointsRedeemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEzRewardsPointsRedeemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ezRewardsPointsRedeemMutation, { data, loading, error }] = useEzRewardsPointsRedeemMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useEzRewardsPointsRedeemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EzRewardsPointsRedeemMutation,
    EzRewardsPointsRedeemMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<EzRewardsPointsRedeemMutation, EzRewardsPointsRedeemMutationVariables>(
    EzRewardsPointsRedeemDocument,
    options,
  );
}
export type EzRewardsPointsRedeemMutationHookResult = ReturnType<
  typeof useEzRewardsPointsRedeemMutation
>;
export type EzRewardsPointsRedeemMutationResult =
  Apollo.MutationResult<EzRewardsPointsRedeemMutation>;
export type EzRewardsPointsRedeemMutationOptions = Apollo.BaseMutationOptions<
  EzRewardsPointsRedeemMutation,
  EzRewardsPointsRedeemMutationVariables
>;
export const ReferFriendsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ReferFriends'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'emails'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'referFriends'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'emails'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'emails'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'success'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'responses'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'error'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ReferFriendsMutationFn = Apollo.MutationFunction<
  ReferFriendsMutation,
  ReferFriendsMutationVariables
>;

/**
 * __useReferFriendsMutation__
 *
 * To run a mutation, you first call `useReferFriendsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReferFriendsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referFriendsMutation, { data, loading, error }] = useReferFriendsMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useReferFriendsMutation(
  baseOptions?: Apollo.MutationHookOptions<ReferFriendsMutation, ReferFriendsMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ReferFriendsMutation, ReferFriendsMutationVariables>(
    ReferFriendsDocument,
    options,
  );
}
export type ReferFriendsMutationHookResult = ReturnType<typeof useReferFriendsMutation>;
export type ReferFriendsMutationResult = Apollo.MutationResult<ReferFriendsMutation>;
export type ReferFriendsMutationOptions = Apollo.BaseMutationOptions<
  ReferFriendsMutation,
  ReferFriendsMutationVariables
>;
export const ReorderFulfillmentDetailCreateMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ReorderFulfillmentDetailCreateMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetailCreateInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetailCreate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ReorderFulfillmentDetailCreateMutationMutationFn = Apollo.MutationFunction<
  ReorderFulfillmentDetailCreateMutation,
  ReorderFulfillmentDetailCreateMutationVariables
>;

/**
 * __useReorderFulfillmentDetailCreateMutation__
 *
 * To run a mutation, you first call `useReorderFulfillmentDetailCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderFulfillmentDetailCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderFulfillmentDetailCreateMutation, { data, loading, error }] = useReorderFulfillmentDetailCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderFulfillmentDetailCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderFulfillmentDetailCreateMutation,
    ReorderFulfillmentDetailCreateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ReorderFulfillmentDetailCreateMutation,
    ReorderFulfillmentDetailCreateMutationVariables
  >(ReorderFulfillmentDetailCreateMutationDocument, options);
}
export type ReorderFulfillmentDetailCreateMutationHookResult = ReturnType<
  typeof useReorderFulfillmentDetailCreateMutation
>;
export type ReorderFulfillmentDetailCreateMutationMutationResult =
  Apollo.MutationResult<ReorderFulfillmentDetailCreateMutation>;
export type ReorderFulfillmentDetailCreateMutationMutationOptions = Apollo.BaseMutationOptions<
  ReorderFulfillmentDetailCreateMutation,
  ReorderFulfillmentDetailCreateMutationVariables
>;
export const RequestTwoFactorAuthenticationCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'RequestTwoFactorAuthenticationCode'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'verificationMethod'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'TwoFactorVerificationMethod'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'requestTwoFactorAuthenticationCode'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'verificationMethod'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'verificationMethod'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RequestTwoFactorAuthenticationCodeMutationFn = Apollo.MutationFunction<
  RequestTwoFactorAuthenticationCodeMutation,
  RequestTwoFactorAuthenticationCodeMutationVariables
>;

/**
 * __useRequestTwoFactorAuthenticationCodeMutation__
 *
 * To run a mutation, you first call `useRequestTwoFactorAuthenticationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTwoFactorAuthenticationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTwoFactorAuthenticationCodeMutation, { data, loading, error }] = useRequestTwoFactorAuthenticationCodeMutation({
 *   variables: {
 *      verificationMethod: // value for 'verificationMethod'
 *   },
 * });
 */
export function useRequestTwoFactorAuthenticationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestTwoFactorAuthenticationCodeMutation,
    RequestTwoFactorAuthenticationCodeMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    RequestTwoFactorAuthenticationCodeMutation,
    RequestTwoFactorAuthenticationCodeMutationVariables
  >(RequestTwoFactorAuthenticationCodeDocument, options);
}
export type RequestTwoFactorAuthenticationCodeMutationHookResult = ReturnType<
  typeof useRequestTwoFactorAuthenticationCodeMutation
>;
export type RequestTwoFactorAuthenticationCodeMutationResult =
  Apollo.MutationResult<RequestTwoFactorAuthenticationCodeMutation>;
export type RequestTwoFactorAuthenticationCodeMutationOptions = Apollo.BaseMutationOptions<
  RequestTwoFactorAuthenticationCodeMutation,
  RequestTwoFactorAuthenticationCodeMutationVariables
>;
export const ResendVerificationEmailMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ResendVerificationEmailMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'resendVerificationEmail'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResendVerificationEmailMutationMutationFn = Apollo.MutationFunction<
  ResendVerificationEmailMutation,
  ResendVerificationEmailMutationVariables
>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendVerificationEmailMutation,
    ResendVerificationEmailMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    ResendVerificationEmailMutation,
    ResendVerificationEmailMutationVariables
  >(ResendVerificationEmailMutationDocument, options);
}
export type ResendVerificationEmailMutationHookResult = ReturnType<
  typeof useResendVerificationEmailMutation
>;
export type ResendVerificationEmailMutationMutationResult =
  Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationMutationOptions = Apollo.BaseMutationOptions<
  ResendVerificationEmailMutation,
  ResendVerificationEmailMutationVariables
>;
export const ReviewCreateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'ReviewCreate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'rating'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'StarRating'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'text'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DeliveryTimeFeedback'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'},
          },
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DeliveryProfessionalismFeedback'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'penName'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'reviewOrder'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'rating'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'rating'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'text'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'text'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'deliveryTimeFeedback'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'},
                },
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'penName'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'penName'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'success'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ReviewCreateMutationFn = Apollo.MutationFunction<
  ReviewCreateMutation,
  ReviewCreateMutationVariables
>;

/**
 * __useReviewCreateMutation__
 *
 * To run a mutation, you first call `useReviewCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewCreateMutation, { data, loading, error }] = useReviewCreateMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      rating: // value for 'rating'
 *      text: // value for 'text'
 *      deliveryTimeFeedback: // value for 'deliveryTimeFeedback'
 *      deliveryProfessionalismFeedback: // value for 'deliveryProfessionalismFeedback'
 *      penName: // value for 'penName'
 *   },
 * });
 */
export function useReviewCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<ReviewCreateMutation, ReviewCreateMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<ReviewCreateMutation, ReviewCreateMutationVariables>(
    ReviewCreateDocument,
    options,
  );
}
export type ReviewCreateMutationHookResult = ReturnType<typeof useReviewCreateMutation>;
export type ReviewCreateMutationResult = Apollo.MutationResult<ReviewCreateMutation>;
export type ReviewCreateMutationOptions = Apollo.BaseMutationOptions<
  ReviewCreateMutation,
  ReviewCreateMutationVariables
>;
export const SaveRecentSearchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SaveRecentSearch'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'RecentSearchParams'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'saveRecentSearch'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'fulfillmentDetailId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SaveRecentSearchMutationFn = Apollo.MutationFunction<
  SaveRecentSearchMutation,
  SaveRecentSearchMutationVariables
>;

/**
 * __useSaveRecentSearchMutation__
 *
 * To run a mutation, you first call `useSaveRecentSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRecentSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRecentSearchMutation, { data, loading, error }] = useSaveRecentSearchMutation({
 *   variables: {
 *      fulfillmentDetailId: // value for 'fulfillmentDetailId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSaveRecentSearchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveRecentSearchMutation,
    SaveRecentSearchMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SaveRecentSearchMutation, SaveRecentSearchMutationVariables>(
    SaveRecentSearchDocument,
    options,
  );
}
export type SaveRecentSearchMutationHookResult = ReturnType<typeof useSaveRecentSearchMutation>;
export type SaveRecentSearchMutationResult = Apollo.MutationResult<SaveRecentSearchMutation>;
export type SaveRecentSearchMutationOptions = Apollo.BaseMutationOptions<
  SaveRecentSearchMutation,
  SaveRecentSearchMutationVariables
>;
export const SearchCreateMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SearchCreateMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetailCreateInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetailCreate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SearchCreateMutationMutationFn = Apollo.MutationFunction<
  SearchCreateMutation,
  SearchCreateMutationVariables
>;

/**
 * __useSearchCreateMutation__
 *
 * To run a mutation, you first call `useSearchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchCreateMutation, { data, loading, error }] = useSearchCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<SearchCreateMutation, SearchCreateMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SearchCreateMutation, SearchCreateMutationVariables>(
    SearchCreateMutationDocument,
    options,
  );
}
export type SearchCreateMutationHookResult = ReturnType<typeof useSearchCreateMutation>;
export type SearchCreateMutationMutationResult = Apollo.MutationResult<SearchCreateMutation>;
export type SearchCreateMutationMutationOptions = Apollo.BaseMutationOptions<
  SearchCreateMutation,
  SearchCreateMutationVariables
>;
export const SendIosAppLinkDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SendIosAppLink'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'source'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'phoneNumber'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sendIosAppLink'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'source'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'source'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'phoneNumber'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'phoneNumber'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {kind: 'Field', name: {kind: 'Name', value: 'success'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendIosAppLinkMutationFn = Apollo.MutationFunction<
  SendIosAppLinkMutation,
  SendIosAppLinkMutationVariables
>;

/**
 * __useSendIosAppLinkMutation__
 *
 * To run a mutation, you first call `useSendIosAppLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendIosAppLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendIosAppLinkMutation, { data, loading, error }] = useSendIosAppLinkMutation({
 *   variables: {
 *      source: // value for 'source'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useSendIosAppLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<SendIosAppLinkMutation, SendIosAppLinkMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SendIosAppLinkMutation, SendIosAppLinkMutationVariables>(
    SendIosAppLinkDocument,
    options,
  );
}
export type SendIosAppLinkMutationHookResult = ReturnType<typeof useSendIosAppLinkMutation>;
export type SendIosAppLinkMutationResult = Apollo.MutationResult<SendIosAppLinkMutation>;
export type SendIosAppLinkMutationOptions = Apollo.BaseMutationOptions<
  SendIosAppLinkMutation,
  SendIosAppLinkMutationVariables
>;
export const SendReferralReminderDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SendReferralReminder'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'referralId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sendReferralReminder'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'referralId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'referralId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'referral'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'reminder'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendReferralReminderMutationFn = Apollo.MutationFunction<
  SendReferralReminderMutation,
  SendReferralReminderMutationVariables
>;

/**
 * __useSendReferralReminderMutation__
 *
 * To run a mutation, you first call `useSendReferralReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReferralReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReferralReminderMutation, { data, loading, error }] = useSendReferralReminderMutation({
 *   variables: {
 *      referralId: // value for 'referralId'
 *   },
 * });
 */
export function useSendReferralReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendReferralReminderMutation,
    SendReferralReminderMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SendReferralReminderMutation, SendReferralReminderMutationVariables>(
    SendReferralReminderDocument,
    options,
  );
}
export type SendReferralReminderMutationHookResult = ReturnType<
  typeof useSendReferralReminderMutation
>;
export type SendReferralReminderMutationResult =
  Apollo.MutationResult<SendReferralReminderMutation>;
export type SendReferralReminderMutationOptions = Apollo.BaseMutationOptions<
  SendReferralReminderMutation,
  SendReferralReminderMutationVariables
>;
export const SendResetPasswordEmailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SendResetPasswordEmail'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sendResetPasswordEmail'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'success'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendResetPasswordEmailMutationFn = Apollo.MutationFunction<
  SendResetPasswordEmailMutation,
  SendResetPasswordEmailMutationVariables
>;

/**
 * __useSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordEmailMutation, { data, loading, error }] = useSendResetPasswordEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendResetPasswordEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendResetPasswordEmailMutation,
    SendResetPasswordEmailMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    SendResetPasswordEmailMutation,
    SendResetPasswordEmailMutationVariables
  >(SendResetPasswordEmailDocument, options);
}
export type SendResetPasswordEmailMutationHookResult = ReturnType<
  typeof useSendResetPasswordEmailMutation
>;
export type SendResetPasswordEmailMutationResult =
  Apollo.MutationResult<SendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<
  SendResetPasswordEmailMutation,
  SendResetPasswordEmailMutationVariables
>;
export const SendToConcurDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SendToConcur'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sendReceiptToConcur'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendToConcurMutationFn = Apollo.MutationFunction<
  SendToConcurMutation,
  SendToConcurMutationVariables
>;

/**
 * __useSendToConcurMutation__
 *
 * To run a mutation, you first call `useSendToConcurMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendToConcurMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendToConcurMutation, { data, loading, error }] = useSendToConcurMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendToConcurMutation(
  baseOptions?: Apollo.MutationHookOptions<SendToConcurMutation, SendToConcurMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SendToConcurMutation, SendToConcurMutationVariables>(
    SendToConcurDocument,
    options,
  );
}
export type SendToConcurMutationHookResult = ReturnType<typeof useSendToConcurMutation>;
export type SendToConcurMutationResult = Apollo.MutationResult<SendToConcurMutation>;
export type SendToConcurMutationOptions = Apollo.BaseMutationOptions<
  SendToConcurMutation,
  SendToConcurMutationVariables
>;
export const SetUserMobilePhoneDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SetUserMobilePhone'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'mobilePhone'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'setUserMobilePhone'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'mobilePhone'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'mobilePhone'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetUserMobilePhoneMutationFn = Apollo.MutationFunction<
  SetUserMobilePhoneMutation,
  SetUserMobilePhoneMutationVariables
>;

/**
 * __useSetUserMobilePhoneMutation__
 *
 * To run a mutation, you first call `useSetUserMobilePhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserMobilePhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserMobilePhoneMutation, { data, loading, error }] = useSetUserMobilePhoneMutation({
 *   variables: {
 *      mobilePhone: // value for 'mobilePhone'
 *   },
 * });
 */
export function useSetUserMobilePhoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetUserMobilePhoneMutation,
    SetUserMobilePhoneMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SetUserMobilePhoneMutation, SetUserMobilePhoneMutationVariables>(
    SetUserMobilePhoneDocument,
    options,
  );
}
export type SetUserMobilePhoneMutationHookResult = ReturnType<typeof useSetUserMobilePhoneMutation>;
export type SetUserMobilePhoneMutationResult = Apollo.MutationResult<SetUserMobilePhoneMutation>;
export type SetUserMobilePhoneMutationOptions = Apollo.BaseMutationOptions<
  SetUserMobilePhoneMutation,
  SetUserMobilePhoneMutationVariables
>;
export const SignOutUserMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SignOutUserMutation'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'signOutUser'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'success'}},
                {kind: 'Field', name: {kind: 'Name', value: 'auth0LogoutUrl'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SignOutUserMutationMutationFn = Apollo.MutationFunction<
  SignOutUserMutation,
  SignOutUserMutationVariables
>;

/**
 * __useSignOutUserMutation__
 *
 * To run a mutation, you first call `useSignOutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutUserMutation, { data, loading, error }] = useSignOutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutUserMutation(
  baseOptions?: Apollo.MutationHookOptions<SignOutUserMutation, SignOutUserMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SignOutUserMutation, SignOutUserMutationVariables>(
    SignOutUserMutationDocument,
    options,
  );
}
export type SignOutUserMutationHookResult = ReturnType<typeof useSignOutUserMutation>;
export type SignOutUserMutationMutationResult = Apollo.MutationResult<SignOutUserMutation>;
export type SignOutUserMutationMutationOptions = Apollo.BaseMutationOptions<
  SignOutUserMutation,
  SignOutUserMutationVariables
>;
export const SubmitContactUsFormMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SubmitContactUsFormMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'fullName'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'email'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'message'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'submitContactUsForm'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'fullName'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'fullName'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'email'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'email'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'message'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'message'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitContactUsFormMutationMutationFn = Apollo.MutationFunction<
  SubmitContactUsFormMutation,
  SubmitContactUsFormMutationVariables
>;

/**
 * __useSubmitContactUsFormMutation__
 *
 * To run a mutation, you first call `useSubmitContactUsFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitContactUsFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitContactUsFormMutation, { data, loading, error }] = useSubmitContactUsFormMutation({
 *   variables: {
 *      fullName: // value for 'fullName'
 *      email: // value for 'email'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSubmitContactUsFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitContactUsFormMutation,
    SubmitContactUsFormMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SubmitContactUsFormMutation, SubmitContactUsFormMutationVariables>(
    SubmitContactUsFormMutationDocument,
    options,
  );
}
export type SubmitContactUsFormMutationHookResult = ReturnType<
  typeof useSubmitContactUsFormMutation
>;
export type SubmitContactUsFormMutationMutationResult =
  Apollo.MutationResult<SubmitContactUsFormMutation>;
export type SubmitContactUsFormMutationMutationOptions = Apollo.BaseMutationOptions<
  SubmitContactUsFormMutation,
  SubmitContactUsFormMutationVariables
>;
export const SubmitDiscoveryHomeFeedbackMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SubmitDiscoveryHomeFeedbackMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'rating'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'HomeFeedbackRating'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'reasons'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {kind: 'NamedType', name: {kind: 'Name', value: 'HomeFeedbackReason'}},
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'comment'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'submitHomeFeedback'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'rating'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'rating'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'reasons'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'reasons'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'comment'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'comment'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitDiscoveryHomeFeedbackMutationMutationFn = Apollo.MutationFunction<
  SubmitDiscoveryHomeFeedbackMutation,
  SubmitDiscoveryHomeFeedbackMutationVariables
>;

/**
 * __useSubmitDiscoveryHomeFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitDiscoveryHomeFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDiscoveryHomeFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDiscoveryHomeFeedbackMutation, { data, loading, error }] = useSubmitDiscoveryHomeFeedbackMutation({
 *   variables: {
 *      rating: // value for 'rating'
 *      reasons: // value for 'reasons'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSubmitDiscoveryHomeFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitDiscoveryHomeFeedbackMutation,
    SubmitDiscoveryHomeFeedbackMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    SubmitDiscoveryHomeFeedbackMutation,
    SubmitDiscoveryHomeFeedbackMutationVariables
  >(SubmitDiscoveryHomeFeedbackMutationDocument, options);
}
export type SubmitDiscoveryHomeFeedbackMutationHookResult = ReturnType<
  typeof useSubmitDiscoveryHomeFeedbackMutation
>;
export type SubmitDiscoveryHomeFeedbackMutationMutationResult =
  Apollo.MutationResult<SubmitDiscoveryHomeFeedbackMutation>;
export type SubmitDiscoveryHomeFeedbackMutationMutationOptions = Apollo.BaseMutationOptions<
  SubmitDiscoveryHomeFeedbackMutation,
  SubmitDiscoveryHomeFeedbackMutationVariables
>;
export const SubmitFirstOrderFeedbackMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SubmitFirstOrderFeedbackMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'text'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'rating'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'StarRating'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'submitFirstOrderFeedback'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'text'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'text'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'rating'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'rating'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitFirstOrderFeedbackMutationMutationFn = Apollo.MutationFunction<
  SubmitFirstOrderFeedbackMutation,
  SubmitFirstOrderFeedbackMutationVariables
>;

/**
 * __useSubmitFirstOrderFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitFirstOrderFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFirstOrderFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFirstOrderFeedbackMutation, { data, loading, error }] = useSubmitFirstOrderFeedbackMutation({
 *   variables: {
 *      text: // value for 'text'
 *      rating: // value for 'rating'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSubmitFirstOrderFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitFirstOrderFeedbackMutation,
    SubmitFirstOrderFeedbackMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    SubmitFirstOrderFeedbackMutation,
    SubmitFirstOrderFeedbackMutationVariables
  >(SubmitFirstOrderFeedbackMutationDocument, options);
}
export type SubmitFirstOrderFeedbackMutationHookResult = ReturnType<
  typeof useSubmitFirstOrderFeedbackMutation
>;
export type SubmitFirstOrderFeedbackMutationMutationResult =
  Apollo.MutationResult<SubmitFirstOrderFeedbackMutation>;
export type SubmitFirstOrderFeedbackMutationMutationOptions = Apollo.BaseMutationOptions<
  SubmitFirstOrderFeedbackMutation,
  SubmitFirstOrderFeedbackMutationVariables
>;
export const SubmitLegalRequestDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SubmitLegalRequest'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'LegalRequestInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'submitLegalRequest'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'success'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitLegalRequestMutationFn = Apollo.MutationFunction<
  SubmitLegalRequestMutation,
  SubmitLegalRequestMutationVariables
>;

/**
 * __useSubmitLegalRequestMutation__
 *
 * To run a mutation, you first call `useSubmitLegalRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLegalRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLegalRequestMutation, { data, loading, error }] = useSubmitLegalRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitLegalRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitLegalRequestMutation,
    SubmitLegalRequestMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SubmitLegalRequestMutation, SubmitLegalRequestMutationVariables>(
    SubmitLegalRequestDocument,
    options,
  );
}
export type SubmitLegalRequestMutationHookResult = ReturnType<typeof useSubmitLegalRequestMutation>;
export type SubmitLegalRequestMutationResult = Apollo.MutationResult<SubmitLegalRequestMutation>;
export type SubmitLegalRequestMutationOptions = Apollo.BaseMutationOptions<
  SubmitLegalRequestMutation,
  SubmitLegalRequestMutationVariables
>;
export const SubmitSelfReportedFulfillmentIssueDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SubmitSelfReportedFulfillmentIssue'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'additionalIssues'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {kind: 'NamedType', name: {kind: 'Name', value: 'AdditionalIssue'}},
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'deliveryTimeSelection'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DeliveryTimeSelection'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'issuesDetailSelectionAdditionalDetails'},
          },
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'issuesSelected'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {kind: 'NamedType', name: {kind: 'Name', value: 'IssueSelection'}},
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'loggedInIssuesReviewAdditionalDetails'},
          },
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'natureOfIssue'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'NatureOfIssue'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'somethingElseField'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'submitSelfReportedFulfillmentIssue'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'fulfillmentIssue'},
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'additionalIssues'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'additionalIssues'}},
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'deliveryTimeSelection'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'deliveryTimeSelection'},
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'issuesDetailSelectionAdditionalDetails'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'issuesDetailSelectionAdditionalDetails'},
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'issuesSelected'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'issuesSelected'}},
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'loggedInIssuesReviewAdditionalDetails'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'loggedInIssuesReviewAdditionalDetails'},
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'natureOfIssue'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'natureOfIssue'}},
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'orderId'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
                    },
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'somethingElseField'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'somethingElseField'}},
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitSelfReportedFulfillmentIssueMutationFn = Apollo.MutationFunction<
  SubmitSelfReportedFulfillmentIssueMutation,
  SubmitSelfReportedFulfillmentIssueMutationVariables
>;

/**
 * __useSubmitSelfReportedFulfillmentIssueMutation__
 *
 * To run a mutation, you first call `useSubmitSelfReportedFulfillmentIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSelfReportedFulfillmentIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSelfReportedFulfillmentIssueMutation, { data, loading, error }] = useSubmitSelfReportedFulfillmentIssueMutation({
 *   variables: {
 *      additionalIssues: // value for 'additionalIssues'
 *      deliveryTimeSelection: // value for 'deliveryTimeSelection'
 *      issuesDetailSelectionAdditionalDetails: // value for 'issuesDetailSelectionAdditionalDetails'
 *      issuesSelected: // value for 'issuesSelected'
 *      loggedInIssuesReviewAdditionalDetails: // value for 'loggedInIssuesReviewAdditionalDetails'
 *      natureOfIssue: // value for 'natureOfIssue'
 *      orderId: // value for 'orderId'
 *      somethingElseField: // value for 'somethingElseField'
 *   },
 * });
 */
export function useSubmitSelfReportedFulfillmentIssueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitSelfReportedFulfillmentIssueMutation,
    SubmitSelfReportedFulfillmentIssueMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    SubmitSelfReportedFulfillmentIssueMutation,
    SubmitSelfReportedFulfillmentIssueMutationVariables
  >(SubmitSelfReportedFulfillmentIssueDocument, options);
}
export type SubmitSelfReportedFulfillmentIssueMutationHookResult = ReturnType<
  typeof useSubmitSelfReportedFulfillmentIssueMutation
>;
export type SubmitSelfReportedFulfillmentIssueMutationResult =
  Apollo.MutationResult<SubmitSelfReportedFulfillmentIssueMutation>;
export type SubmitSelfReportedFulfillmentIssueMutationOptions = Apollo.BaseMutationOptions<
  SubmitSelfReportedFulfillmentIssueMutation,
  SubmitSelfReportedFulfillmentIssueMutationVariables
>;
export const SubmitSupportCaseDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'SubmitSupportCase'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'SupportCaseInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'submitSupportCase'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'success'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitSupportCaseMutationFn = Apollo.MutationFunction<
  SubmitSupportCaseMutation,
  SubmitSupportCaseMutationVariables
>;

/**
 * __useSubmitSupportCaseMutation__
 *
 * To run a mutation, you first call `useSubmitSupportCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSupportCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSupportCaseMutation, { data, loading, error }] = useSubmitSupportCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSupportCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitSupportCaseMutation,
    SubmitSupportCaseMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SubmitSupportCaseMutation, SubmitSupportCaseMutationVariables>(
    SubmitSupportCaseDocument,
    options,
  );
}
export type SubmitSupportCaseMutationHookResult = ReturnType<typeof useSubmitSupportCaseMutation>;
export type SubmitSupportCaseMutationResult = Apollo.MutationResult<SubmitSupportCaseMutation>;
export type SubmitSupportCaseMutationOptions = Apollo.BaseMutationOptions<
  SubmitSupportCaseMutation,
  SubmitSupportCaseMutationVariables
>;
export const TrackPageViewDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'TrackPageView'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'pageName'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'url'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'referrerUrl'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'serverResponseTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'pageInteractiveTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trackPageView'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'pageName'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'pageName'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'url'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'url'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'referrerUrl'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'referrerUrl'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'serverResponseTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'serverResponseTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'pageInteractiveTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'pageInteractiveTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'fulfillmentDetailId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TrackPageViewMutationFn = Apollo.MutationFunction<
  TrackPageViewMutation,
  TrackPageViewMutationVariables
>;

/**
 * __useTrackPageViewMutation__
 *
 * To run a mutation, you first call `useTrackPageViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackPageViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackPageViewMutation, { data, loading, error }] = useTrackPageViewMutation({
 *   variables: {
 *      pageName: // value for 'pageName'
 *      url: // value for 'url'
 *      referrerUrl: // value for 'referrerUrl'
 *      orderId: // value for 'orderId'
 *      catererId: // value for 'catererId'
 *      serverResponseTime: // value for 'serverResponseTime'
 *      pageInteractiveTime: // value for 'pageInteractiveTime'
 *      fulfillmentDetailId: // value for 'fulfillmentDetailId'
 *   },
 * });
 */
export function useTrackPageViewMutation(
  baseOptions?: Apollo.MutationHookOptions<TrackPageViewMutation, TrackPageViewMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<TrackPageViewMutation, TrackPageViewMutationVariables>(
    TrackPageViewDocument,
    options,
  );
}
export type TrackPageViewMutationHookResult = ReturnType<typeof useTrackPageViewMutation>;
export type TrackPageViewMutationResult = Apollo.MutationResult<TrackPageViewMutation>;
export type TrackPageViewMutationOptions = Apollo.BaseMutationOptions<
  TrackPageViewMutation,
  TrackPageViewMutationVariables
>;
export const TrackTouchMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'TrackTouchMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'url'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'referrerUrl'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'trackTouch'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'url'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'url'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'referrerUrl'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'referrerUrl'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TrackTouchMutationMutationFn = Apollo.MutationFunction<
  TrackTouchMutation,
  TrackTouchMutationVariables
>;

/**
 * __useTrackTouchMutation__
 *
 * To run a mutation, you first call `useTrackTouchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackTouchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackTouchMutation, { data, loading, error }] = useTrackTouchMutation({
 *   variables: {
 *      url: // value for 'url'
 *      referrerUrl: // value for 'referrerUrl'
 *   },
 * });
 */
export function useTrackTouchMutation(
  baseOptions?: Apollo.MutationHookOptions<TrackTouchMutation, TrackTouchMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<TrackTouchMutation, TrackTouchMutationVariables>(
    TrackTouchMutationDocument,
    options,
  );
}
export type TrackTouchMutationHookResult = ReturnType<typeof useTrackTouchMutation>;
export type TrackTouchMutationMutationResult = Apollo.MutationResult<TrackTouchMutation>;
export type TrackTouchMutationMutationOptions = Apollo.BaseMutationOptions<
  TrackTouchMutation,
  TrackTouchMutationVariables
>;
export const UpdateCheckoutFulfillmentDetailMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateCheckoutFulfillmentDetailMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'consumerCartId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetailUpdateInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetailUpdate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'consumerCartId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'consumerCartId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'customerMessages'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'enforce'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'fulfillmentDetail'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'customerMessages'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'stage'},
                                  value: {kind: 'EnumValue', value: 'CHECKOUT'},
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'staticMapUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'creditCardPaymentAllowed'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateCheckoutFulfillmentDetailMutationMutationFn = Apollo.MutationFunction<
  UpdateCheckoutFulfillmentDetailMutation,
  UpdateCheckoutFulfillmentDetailMutationVariables
>;

/**
 * __useUpdateCheckoutFulfillmentDetailMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutFulfillmentDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutFulfillmentDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutFulfillmentDetailMutation, { data, loading, error }] = useUpdateCheckoutFulfillmentDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      consumerCartId: // value for 'consumerCartId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCheckoutFulfillmentDetailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCheckoutFulfillmentDetailMutation,
    UpdateCheckoutFulfillmentDetailMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdateCheckoutFulfillmentDetailMutation,
    UpdateCheckoutFulfillmentDetailMutationVariables
  >(UpdateCheckoutFulfillmentDetailMutationDocument, options);
}
export type UpdateCheckoutFulfillmentDetailMutationHookResult = ReturnType<
  typeof useUpdateCheckoutFulfillmentDetailMutation
>;
export type UpdateCheckoutFulfillmentDetailMutationMutationResult =
  Apollo.MutationResult<UpdateCheckoutFulfillmentDetailMutation>;
export type UpdateCheckoutFulfillmentDetailMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateCheckoutFulfillmentDetailMutation,
  UpdateCheckoutFulfillmentDetailMutationVariables
>;
export const UpdateOrderCodesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateOrderCodes'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderReferenceCodes'}},
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: {kind: 'Name', value: 'CreateOrderReferenceCodeInputType'},
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'corpDeptCode'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateOrderCodes'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderReferenceCodes'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderReferenceCodes'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'corpDeptCode'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'corpDeptCode'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'success'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'order'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasCorpDeptCode'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateReferenceCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateDepartment'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateOrderCodesMutationFn = Apollo.MutationFunction<
  UpdateOrderCodesMutation,
  UpdateOrderCodesMutationVariables
>;

/**
 * __useUpdateOrderCodesMutation__
 *
 * To run a mutation, you first call `useUpdateOrderCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderCodesMutation, { data, loading, error }] = useUpdateOrderCodesMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      orderReferenceCodes: // value for 'orderReferenceCodes'
 *      corpDeptCode: // value for 'corpDeptCode'
 *   },
 * });
 */
export function useUpdateOrderCodesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrderCodesMutation,
    UpdateOrderCodesMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UpdateOrderCodesMutation, UpdateOrderCodesMutationVariables>(
    UpdateOrderCodesDocument,
    options,
  );
}
export type UpdateOrderCodesMutationHookResult = ReturnType<typeof useUpdateOrderCodesMutation>;
export type UpdateOrderCodesMutationResult = Apollo.MutationResult<UpdateOrderCodesMutation>;
export type UpdateOrderCodesMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrderCodesMutation,
  UpdateOrderCodesMutationVariables
>;
export const UpdateSearchFulfillmentDetailMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UpdateSearchFulfillmentDetailMutation'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetailUpdateInput'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetailUpdate'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'input'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'SearchPageFulfillmentDetailFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ValidationError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SearchPageFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateSearchFulfillmentDetailMutationMutationFn = Apollo.MutationFunction<
  UpdateSearchFulfillmentDetailMutation,
  UpdateSearchFulfillmentDetailMutationVariables
>;

/**
 * __useUpdateSearchFulfillmentDetailMutation__
 *
 * To run a mutation, you first call `useUpdateSearchFulfillmentDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSearchFulfillmentDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSearchFulfillmentDetailMutation, { data, loading, error }] = useUpdateSearchFulfillmentDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSearchFulfillmentDetailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSearchFulfillmentDetailMutation,
    UpdateSearchFulfillmentDetailMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UpdateSearchFulfillmentDetailMutation,
    UpdateSearchFulfillmentDetailMutationVariables
  >(UpdateSearchFulfillmentDetailMutationDocument, options);
}
export type UpdateSearchFulfillmentDetailMutationHookResult = ReturnType<
  typeof useUpdateSearchFulfillmentDetailMutation
>;
export type UpdateSearchFulfillmentDetailMutationMutationResult =
  Apollo.MutationResult<UpdateSearchFulfillmentDetailMutation>;
export type UpdateSearchFulfillmentDetailMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateSearchFulfillmentDetailMutation,
  UpdateSearchFulfillmentDetailMutationVariables
>;
export const UserConnectionsDisconnectDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UserConnectionsDisconnect'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'userConnectionId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'userConnectionsDisconnect'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'userConnectionId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'userConnectionId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UserConnectionsDisconnectMutationFn = Apollo.MutationFunction<
  UserConnectionsDisconnectMutation,
  UserConnectionsDisconnectMutationVariables
>;

/**
 * __useUserConnectionsDisconnectMutation__
 *
 * To run a mutation, you first call `useUserConnectionsDisconnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionsDisconnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userConnectionsDisconnectMutation, { data, loading, error }] = useUserConnectionsDisconnectMutation({
 *   variables: {
 *      userConnectionId: // value for 'userConnectionId'
 *   },
 * });
 */
export function useUserConnectionsDisconnectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserConnectionsDisconnectMutation,
    UserConnectionsDisconnectMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UserConnectionsDisconnectMutation,
    UserConnectionsDisconnectMutationVariables
  >(UserConnectionsDisconnectDocument, options);
}
export type UserConnectionsDisconnectMutationHookResult = ReturnType<
  typeof useUserConnectionsDisconnectMutation
>;
export type UserConnectionsDisconnectMutationResult =
  Apollo.MutationResult<UserConnectionsDisconnectMutation>;
export type UserConnectionsDisconnectMutationOptions = Apollo.BaseMutationOptions<
  UserConnectionsDisconnectMutation,
  UserConnectionsDisconnectMutationVariables
>;
export const UserConnectionsInviteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UserConnectionsInvite'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'userId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'userConnectionsInvite'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'userId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'userId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UserConnectionsInviteMutationFn = Apollo.MutationFunction<
  UserConnectionsInviteMutation,
  UserConnectionsInviteMutationVariables
>;

/**
 * __useUserConnectionsInviteMutation__
 *
 * To run a mutation, you first call `useUserConnectionsInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionsInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userConnectionsInviteMutation, { data, loading, error }] = useUserConnectionsInviteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserConnectionsInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserConnectionsInviteMutation,
    UserConnectionsInviteMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UserConnectionsInviteMutation, UserConnectionsInviteMutationVariables>(
    UserConnectionsInviteDocument,
    options,
  );
}
export type UserConnectionsInviteMutationHookResult = ReturnType<
  typeof useUserConnectionsInviteMutation
>;
export type UserConnectionsInviteMutationResult =
  Apollo.MutationResult<UserConnectionsInviteMutation>;
export type UserConnectionsInviteMutationOptions = Apollo.BaseMutationOptions<
  UserConnectionsInviteMutation,
  UserConnectionsInviteMutationVariables
>;
export const UserConnectionInvitationAcceptDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UserConnectionInvitationAccept'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'userConnectionInvitationId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'userConnectionsAcceptInvite'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'userConnectionInvitationId'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'userConnectionInvitationId'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UserConnectionInvitationAcceptMutationFn = Apollo.MutationFunction<
  UserConnectionInvitationAcceptMutation,
  UserConnectionInvitationAcceptMutationVariables
>;

/**
 * __useUserConnectionInvitationAcceptMutation__
 *
 * To run a mutation, you first call `useUserConnectionInvitationAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionInvitationAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userConnectionInvitationAcceptMutation, { data, loading, error }] = useUserConnectionInvitationAcceptMutation({
 *   variables: {
 *      userConnectionInvitationId: // value for 'userConnectionInvitationId'
 *   },
 * });
 */
export function useUserConnectionInvitationAcceptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserConnectionInvitationAcceptMutation,
    UserConnectionInvitationAcceptMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UserConnectionInvitationAcceptMutation,
    UserConnectionInvitationAcceptMutationVariables
  >(UserConnectionInvitationAcceptDocument, options);
}
export type UserConnectionInvitationAcceptMutationHookResult = ReturnType<
  typeof useUserConnectionInvitationAcceptMutation
>;
export type UserConnectionInvitationAcceptMutationResult =
  Apollo.MutationResult<UserConnectionInvitationAcceptMutation>;
export type UserConnectionInvitationAcceptMutationOptions = Apollo.BaseMutationOptions<
  UserConnectionInvitationAcceptMutation,
  UserConnectionInvitationAcceptMutationVariables
>;
export const UserConnectionInvitationIgnoreDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UserConnectionInvitationIgnore'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'userConnectionInvitationId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'userConnectionsIgnoreInvite'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'userConnectionInvitationId'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'userConnectionInvitationId'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UserConnectionInvitationIgnoreMutationFn = Apollo.MutationFunction<
  UserConnectionInvitationIgnoreMutation,
  UserConnectionInvitationIgnoreMutationVariables
>;

/**
 * __useUserConnectionInvitationIgnoreMutation__
 *
 * To run a mutation, you first call `useUserConnectionInvitationIgnoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionInvitationIgnoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userConnectionInvitationIgnoreMutation, { data, loading, error }] = useUserConnectionInvitationIgnoreMutation({
 *   variables: {
 *      userConnectionInvitationId: // value for 'userConnectionInvitationId'
 *   },
 * });
 */
export function useUserConnectionInvitationIgnoreMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserConnectionInvitationIgnoreMutation,
    UserConnectionInvitationIgnoreMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UserConnectionInvitationIgnoreMutation,
    UserConnectionInvitationIgnoreMutationVariables
  >(UserConnectionInvitationIgnoreDocument, options);
}
export type UserConnectionInvitationIgnoreMutationHookResult = ReturnType<
  typeof useUserConnectionInvitationIgnoreMutation
>;
export type UserConnectionInvitationIgnoreMutationResult =
  Apollo.MutationResult<UserConnectionInvitationIgnoreMutation>;
export type UserConnectionInvitationIgnoreMutationOptions = Apollo.BaseMutationOptions<
  UserConnectionInvitationIgnoreMutation,
  UserConnectionInvitationIgnoreMutationVariables
>;
export const UserConnectionsToggleOrderNotificationsOverrideDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UserConnectionsToggleOrderNotificationsOverride'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'isSubscribed'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'userConnectionsToggleOrderNotificationsOverride'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'isSubscribed'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'isSubscribed'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UserConnectionsToggleOrderNotificationsOverrideMutationFn = Apollo.MutationFunction<
  UserConnectionsToggleOrderNotificationsOverrideMutation,
  UserConnectionsToggleOrderNotificationsOverrideMutationVariables
>;

/**
 * __useUserConnectionsToggleOrderNotificationsOverrideMutation__
 *
 * To run a mutation, you first call `useUserConnectionsToggleOrderNotificationsOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionsToggleOrderNotificationsOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userConnectionsToggleOrderNotificationsOverrideMutation, { data, loading, error }] = useUserConnectionsToggleOrderNotificationsOverrideMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      isSubscribed: // value for 'isSubscribed'
 *   },
 * });
 */
export function useUserConnectionsToggleOrderNotificationsOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserConnectionsToggleOrderNotificationsOverrideMutation,
    UserConnectionsToggleOrderNotificationsOverrideMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UserConnectionsToggleOrderNotificationsOverrideMutation,
    UserConnectionsToggleOrderNotificationsOverrideMutationVariables
  >(UserConnectionsToggleOrderNotificationsOverrideDocument, options);
}
export type UserConnectionsToggleOrderNotificationsOverrideMutationHookResult = ReturnType<
  typeof useUserConnectionsToggleOrderNotificationsOverrideMutation
>;
export type UserConnectionsToggleOrderNotificationsOverrideMutationResult =
  Apollo.MutationResult<UserConnectionsToggleOrderNotificationsOverrideMutation>;
export type UserConnectionsToggleOrderNotificationsOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    UserConnectionsToggleOrderNotificationsOverrideMutation,
    UserConnectionsToggleOrderNotificationsOverrideMutationVariables
  >;
export const UserConnectionsToggleOrderNotificationsSubscriptionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UserConnectionsToggleOrderNotificationsSubscription'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'userConnectionId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'isSubscribed'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'userConnectionsToggleOrderNotificationsSubscription'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'userConnectionId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'userConnectionId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'isSubscribed'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'isSubscribed'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'userErrors'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'UserError'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'path'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UserConnectionsToggleOrderNotificationsSubscriptionMutationFn = Apollo.MutationFunction<
  UserConnectionsToggleOrderNotificationsSubscriptionMutation,
  UserConnectionsToggleOrderNotificationsSubscriptionMutationVariables
>;

/**
 * __useUserConnectionsToggleOrderNotificationsSubscription__
 *
 * To run a mutation, you first call `useUserConnectionsToggleOrderNotificationsSubscription` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionsToggleOrderNotificationsSubscription` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userConnectionsToggleOrderNotificationsSubscription, { data, loading, error }] = useUserConnectionsToggleOrderNotificationsSubscription({
 *   variables: {
 *      userConnectionId: // value for 'userConnectionId'
 *      isSubscribed: // value for 'isSubscribed'
 *   },
 * });
 */
export function useUserConnectionsToggleOrderNotificationsSubscription(
  baseOptions?: Apollo.MutationHookOptions<
    UserConnectionsToggleOrderNotificationsSubscriptionMutation,
    UserConnectionsToggleOrderNotificationsSubscriptionMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    UserConnectionsToggleOrderNotificationsSubscriptionMutation,
    UserConnectionsToggleOrderNotificationsSubscriptionMutationVariables
  >(UserConnectionsToggleOrderNotificationsSubscriptionDocument, options);
}
export type UserConnectionsToggleOrderNotificationsSubscriptionHookResult = ReturnType<
  typeof useUserConnectionsToggleOrderNotificationsSubscription
>;
export type UserConnectionsToggleOrderNotificationsSubscriptionMutationResult =
  Apollo.MutationResult<UserConnectionsToggleOrderNotificationsSubscriptionMutation>;
export type UserConnectionsToggleOrderNotificationsSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    UserConnectionsToggleOrderNotificationsSubscriptionMutation,
    UserConnectionsToggleOrderNotificationsSubscriptionMutationVariables
  >;
export const UserDeleteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UserDelete'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'verificationCode'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'userDelete'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'code'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'verificationCode'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UserDeleteMutationFn = Apollo.MutationFunction<
  UserDeleteMutation,
  UserDeleteMutationVariables
>;

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useUserDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<UserDeleteMutation, UserDeleteMutationVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UserDeleteMutation, UserDeleteMutationVariables>(
    UserDeleteDocument,
    options,
  );
}
export type UserDeleteMutationHookResult = ReturnType<typeof useUserDeleteMutation>;
export type UserDeleteMutationResult = Apollo.MutationResult<UserDeleteMutation>;
export type UserDeleteMutationOptions = Apollo.BaseMutationOptions<
  UserDeleteMutation,
  UserDeleteMutationVariables
>;
export const UserPasswordUpdateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'UserPasswordUpdate'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'currentPassword'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'password'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'updateUserPassword'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'currentPassword'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'currentPassword'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'password'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'password'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'success'}}],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UserPasswordUpdateMutationFn = Apollo.MutationFunction<
  UserPasswordUpdateMutation,
  UserPasswordUpdateMutationVariables
>;

/**
 * __useUserPasswordUpdateMutation__
 *
 * To run a mutation, you first call `useUserPasswordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPasswordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPasswordUpdateMutation, { data, loading, error }] = useUserPasswordUpdateMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUserPasswordUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserPasswordUpdateMutation,
    UserPasswordUpdateMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<UserPasswordUpdateMutation, UserPasswordUpdateMutationVariables>(
    UserPasswordUpdateDocument,
    options,
  );
}
export type UserPasswordUpdateMutationHookResult = ReturnType<typeof useUserPasswordUpdateMutation>;
export type UserPasswordUpdateMutationResult = Apollo.MutationResult<UserPasswordUpdateMutation>;
export type UserPasswordUpdateMutationOptions = Apollo.BaseMutationOptions<
  UserPasswordUpdateMutation,
  UserPasswordUpdateMutationVariables
>;
export const VerifyTwoFactorAuthenticationCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'VerifyTwoFactorAuthenticationCode'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'code'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'verifyTwoFactorAuthenticationCode'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'code'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'code'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCurrentDeviceRecognized'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type VerifyTwoFactorAuthenticationCodeMutationFn = Apollo.MutationFunction<
  VerifyTwoFactorAuthenticationCodeMutation,
  VerifyTwoFactorAuthenticationCodeMutationVariables
>;

/**
 * __useVerifyTwoFactorAuthenticationCodeMutation__
 *
 * To run a mutation, you first call `useVerifyTwoFactorAuthenticationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTwoFactorAuthenticationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTwoFactorAuthenticationCodeMutation, { data, loading, error }] = useVerifyTwoFactorAuthenticationCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyTwoFactorAuthenticationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyTwoFactorAuthenticationCodeMutation,
    VerifyTwoFactorAuthenticationCodeMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<
    VerifyTwoFactorAuthenticationCodeMutation,
    VerifyTwoFactorAuthenticationCodeMutationVariables
  >(VerifyTwoFactorAuthenticationCodeDocument, options);
}
export type VerifyTwoFactorAuthenticationCodeMutationHookResult = ReturnType<
  typeof useVerifyTwoFactorAuthenticationCodeMutation
>;
export type VerifyTwoFactorAuthenticationCodeMutationResult =
  Apollo.MutationResult<VerifyTwoFactorAuthenticationCodeMutation>;
export type VerifyTwoFactorAuthenticationCodeMutationOptions = Apollo.BaseMutationOptions<
  VerifyTwoFactorAuthenticationCodeMutation,
  VerifyTwoFactorAuthenticationCodeMutationVariables
>;
export const AddressBookPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AddressBookPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'canManageCorpAddresses'},
                        name: {kind: 'Name', value: 'canUpdateCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'addresses'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'searchString'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'CONSUMER_ACCOUNT'},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'AddressBookAddressFragment'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'corpAddresses'},
                        name: {kind: 'Name', value: 'addresses'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'searchString'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'CORPORATE_ACCOUNT'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'AddressBookAddressFragment'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressBookAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'street'}},
          {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
          {kind: 'Field', name: {kind: 'Name', value: 'addressBookEntryId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'addressBookEntry'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'corporate'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '1'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'SUBMITTED_NOT_CANCELLED'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortDirection'},
                value: {kind: 'EnumValue', value: 'DESC'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'nodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'submittedAt'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAddressBookPageQuery__
 *
 * To run a query within a React component, call `useAddressBookPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressBookPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressBookPageQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useAddressBookPageQuery(
  baseOptions?: Apollo.QueryHookOptions<AddressBookPageQuery, AddressBookPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<AddressBookPageQuery, AddressBookPageQueryVariables>(
    AddressBookPageQueryDocument,
    options,
  );
}
export function useAddressBookPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AddressBookPageQuery, AddressBookPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<AddressBookPageQuery, AddressBookPageQueryVariables>(
    AddressBookPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useAddressBookPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AddressBookPageQuery,
    AddressBookPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AddressBookPageQuery, AddressBookPageQueryVariables>;
export function useAddressBookPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AddressBookPageQuery, AddressBookPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<AddressBookPageQuery | undefined, AddressBookPageQueryVariables>;
export function useAddressBookPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AddressBookPageQuery, AddressBookPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<AddressBookPageQuery, AddressBookPageQueryVariables>(
    AddressBookPageQueryDocument,
    options,
  );
}
export type AddressBookPageQueryHookResult = ReturnType<typeof useAddressBookPageQuery>;
export type AddressBookPageQueryLazyQueryHookResult = ReturnType<
  typeof useAddressBookPageQueryLazyQuery
>;
export type AddressBookPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useAddressBookPageQuerySuspenseQuery
>;
export type AddressBookPageQueryQueryResult = Apollo.QueryResult<
  AddressBookPageQuery,
  AddressBookPageQueryVariables
>;
export const AddressBookQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AddressBookQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'AddressFilterEnum'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'canManageCorpAddresses'},
                        name: {kind: 'Name', value: 'canUpdateCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'addresses'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'searchString'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'AddressBookAddressFragment'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'AddressBookAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Address'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'street'}},
          {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
          {kind: 'Field', name: {kind: 'Name', value: 'addressBookEntryId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'addressBookEntry'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'corporate'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '1'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'SUBMITTED_NOT_CANCELLED'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortDirection'},
                value: {kind: 'EnumValue', value: 'DESC'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'nodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'submittedAt'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAddressBookQuery__
 *
 * To run a query within a React component, call `useAddressBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressBookQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      filter: // value for 'filter'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useAddressBookQuery(
  baseOptions?: Apollo.QueryHookOptions<AddressBookQuery, AddressBookQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<AddressBookQuery, AddressBookQueryVariables>(
    AddressBookQueryDocument,
    options,
  );
}
export function useAddressBookQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AddressBookQuery, AddressBookQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<AddressBookQuery, AddressBookQueryVariables>(
    AddressBookQueryDocument,
    options,
  );
}
// @ts-ignore
export function useAddressBookQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AddressBookQuery, AddressBookQueryVariables>,
): Apollo.UseSuspenseQueryResult<AddressBookQuery, AddressBookQueryVariables>;
export function useAddressBookQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddressBookQuery, AddressBookQueryVariables>,
): Apollo.UseSuspenseQueryResult<AddressBookQuery | undefined, AddressBookQueryVariables>;
export function useAddressBookQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddressBookQuery, AddressBookQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<AddressBookQuery, AddressBookQueryVariables>(
    AddressBookQueryDocument,
    options,
  );
}
export type AddressBookQueryHookResult = ReturnType<typeof useAddressBookQuery>;
export type AddressBookQueryLazyQueryHookResult = ReturnType<typeof useAddressBookQueryLazyQuery>;
export type AddressBookQuerySuspenseQueryHookResult = ReturnType<
  typeof useAddressBookQuerySuspenseQuery
>;
export type AddressBookQueryQueryResult = Apollo.QueryResult<
  AddressBookQuery,
  AddressBookQueryVariables
>;
export const AddressShowPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'AddressShowPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'canManageCorpAddresses'},
                        name: {kind: 'Name', value: 'canUpdateCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'addressBookEntryId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'attendees'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'staticMapUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'addressBookEntryId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'addressBookEntry'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'corporate'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'revision'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'revisionDeltas'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'field'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'currentValue'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'newValue'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orders'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'limit'},
                      value: {kind: 'IntValue', value: '30'},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filter'},
                      value: {kind: 'EnumValue', value: 'SUBMITTED_NOT_CANCELLED'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAddressShowPageQuery__
 *
 * To run a query within a React component, call `useAddressShowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressShowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressShowPageQuery({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useAddressShowPageQuery(
  baseOptions: Apollo.QueryHookOptions<AddressShowPageQuery, AddressShowPageQueryVariables> &
    ({variables: AddressShowPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<AddressShowPageQuery, AddressShowPageQueryVariables>(
    AddressShowPageQueryDocument,
    options,
  );
}
export function useAddressShowPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AddressShowPageQuery, AddressShowPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<AddressShowPageQuery, AddressShowPageQueryVariables>(
    AddressShowPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useAddressShowPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AddressShowPageQuery,
    AddressShowPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AddressShowPageQuery, AddressShowPageQueryVariables>;
export function useAddressShowPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AddressShowPageQuery, AddressShowPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<AddressShowPageQuery | undefined, AddressShowPageQueryVariables>;
export function useAddressShowPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AddressShowPageQuery, AddressShowPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<AddressShowPageQuery, AddressShowPageQueryVariables>(
    AddressShowPageQueryDocument,
    options,
  );
}
export type AddressShowPageQueryHookResult = ReturnType<typeof useAddressShowPageQuery>;
export type AddressShowPageQueryLazyQueryHookResult = ReturnType<
  typeof useAddressShowPageQueryLazyQuery
>;
export type AddressShowPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useAddressShowPageQuerySuspenseQuery
>;
export type AddressShowPageQueryQueryResult = Apollo.QueryResult<
  AddressShowPageQuery,
  AddressShowPageQueryVariables
>;
export const B2BOnboardingPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'B2BOnboardingPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'verifiedRegisteredCustomerMembershipCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'availableFeaturesForUser'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'priority'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useB2BOnboardingPageQuery__
 *
 * To run a query within a React component, call `useB2BOnboardingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useB2BOnboardingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useB2BOnboardingPageQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useB2BOnboardingPageQuery(
  baseOptions: Apollo.QueryHookOptions<B2BOnboardingPageQuery, B2BOnboardingPageQueryVariables> &
    ({variables: B2BOnboardingPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<B2BOnboardingPageQuery, B2BOnboardingPageQueryVariables>(
    B2BOnboardingPageQueryDocument,
    options,
  );
}
export function useB2BOnboardingPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    B2BOnboardingPageQuery,
    B2BOnboardingPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<B2BOnboardingPageQuery, B2BOnboardingPageQueryVariables>(
    B2BOnboardingPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useB2BOnboardingPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    B2BOnboardingPageQuery,
    B2BOnboardingPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<B2BOnboardingPageQuery, B2BOnboardingPageQueryVariables>;
export function useB2BOnboardingPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<B2BOnboardingPageQuery, B2BOnboardingPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  B2BOnboardingPageQuery | undefined,
  B2BOnboardingPageQueryVariables
>;
export function useB2BOnboardingPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<B2BOnboardingPageQuery, B2BOnboardingPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<B2BOnboardingPageQuery, B2BOnboardingPageQueryVariables>(
    B2BOnboardingPageQueryDocument,
    options,
  );
}
export type B2BOnboardingPageQueryHookResult = ReturnType<typeof useB2BOnboardingPageQuery>;
export type B2BOnboardingPageQueryLazyQueryHookResult = ReturnType<
  typeof useB2BOnboardingPageQueryLazyQuery
>;
export type B2BOnboardingPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useB2BOnboardingPageQuerySuspenseQuery
>;
export type B2BOnboardingPageQueryQueryResult = Apollo.QueryResult<
  B2BOnboardingPageQuery,
  B2BOnboardingPageQueryVariables
>;
export const BraintreeTokenQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'BraintreeTokenQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'braintreeClientToken'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useBraintreeTokenQuery__
 *
 * To run a query within a React component, call `useBraintreeTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useBraintreeTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBraintreeTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useBraintreeTokenQuery(
  baseOptions?: Apollo.QueryHookOptions<BraintreeTokenQuery, BraintreeTokenQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<BraintreeTokenQuery, BraintreeTokenQueryVariables>(
    BraintreeTokenQueryDocument,
    options,
  );
}
export function useBraintreeTokenQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BraintreeTokenQuery, BraintreeTokenQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<BraintreeTokenQuery, BraintreeTokenQueryVariables>(
    BraintreeTokenQueryDocument,
    options,
  );
}
// @ts-ignore
export function useBraintreeTokenQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<BraintreeTokenQuery, BraintreeTokenQueryVariables>,
): Apollo.UseSuspenseQueryResult<BraintreeTokenQuery, BraintreeTokenQueryVariables>;
export function useBraintreeTokenQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BraintreeTokenQuery, BraintreeTokenQueryVariables>,
): Apollo.UseSuspenseQueryResult<BraintreeTokenQuery | undefined, BraintreeTokenQueryVariables>;
export function useBraintreeTokenQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BraintreeTokenQuery, BraintreeTokenQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<BraintreeTokenQuery, BraintreeTokenQueryVariables>(
    BraintreeTokenQueryDocument,
    options,
  );
}
export type BraintreeTokenQueryHookResult = ReturnType<typeof useBraintreeTokenQuery>;
export type BraintreeTokenQueryLazyQueryHookResult = ReturnType<
  typeof useBraintreeTokenQueryLazyQuery
>;
export type BraintreeTokenQuerySuspenseQueryHookResult = ReturnType<
  typeof useBraintreeTokenQuerySuspenseQuery
>;
export type BraintreeTokenQueryQueryResult = Apollo.QueryResult<
  BraintreeTokenQuery,
  BraintreeTokenQueryVariables
>;
export const BrandsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'BrandsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'startsWith'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brands'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'startsWith'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'startsWith'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'offset'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'nodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useBrandsQuery__
 *
 * To run a query within a React component, call `useBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsQuery({
 *   variables: {
 *      startsWith: // value for 'startsWith'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useBrandsQuery(
  baseOptions?: Apollo.QueryHookOptions<BrandsQuery, BrandsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<BrandsQuery, BrandsQueryVariables>(BrandsQueryDocument, options);
}
export function useBrandsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BrandsQuery, BrandsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<BrandsQuery, BrandsQueryVariables>(BrandsQueryDocument, options);
}
// @ts-ignore
export function useBrandsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<BrandsQuery, BrandsQueryVariables>,
): Apollo.UseSuspenseQueryResult<BrandsQuery, BrandsQueryVariables>;
export function useBrandsQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandsQuery, BrandsQueryVariables>,
): Apollo.UseSuspenseQueryResult<BrandsQuery | undefined, BrandsQueryVariables>;
export function useBrandsQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandsQuery, BrandsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<BrandsQuery, BrandsQueryVariables>(BrandsQueryDocument, options);
}
export type BrandsQueryHookResult = ReturnType<typeof useBrandsQuery>;
export type BrandsQueryLazyQueryHookResult = ReturnType<typeof useBrandsQueryLazyQuery>;
export type BrandsQuerySuspenseQueryHookResult = ReturnType<typeof useBrandsQuerySuspenseQuery>;
export type BrandsQueryQueryResult = Apollo.QueryResult<BrandsQuery, BrandsQueryVariables>;
export const CateringMenuAlternateCaterersQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuAlternateCaterersQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchAddress'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'TimeWithoutZone'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchOrderType'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'marketplaceSearchV2'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'address'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventDateTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'skipSearchTracking'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterers'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'limit'},
                      value: {kind: 'IntValue', value: '3'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'nodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'reviewCount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'imageSrc'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuAlternateCaterersQuery__
 *
 * To run a query within a React component, call `useCateringMenuAlternateCaterersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuAlternateCaterersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuAlternateCaterersQuery({
 *   variables: {
 *      address: // value for 'address'
 *      eventDateTime: // value for 'eventDateTime'
 *      eventTime: // value for 'eventTime'
 *      orderType: // value for 'orderType'
 *   },
 * });
 */
export function useCateringMenuAlternateCaterersQuery(
  baseOptions: Apollo.QueryHookOptions<
    CateringMenuAlternateCaterersQuery,
    CateringMenuAlternateCaterersQueryVariables
  > &
    ({variables: CateringMenuAlternateCaterersQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    CateringMenuAlternateCaterersQuery,
    CateringMenuAlternateCaterersQueryVariables
  >(CateringMenuAlternateCaterersQueryDocument, options);
}
export function useCateringMenuAlternateCaterersQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CateringMenuAlternateCaterersQuery,
    CateringMenuAlternateCaterersQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CateringMenuAlternateCaterersQuery,
    CateringMenuAlternateCaterersQueryVariables
  >(CateringMenuAlternateCaterersQueryDocument, options);
}
// @ts-ignore
export function useCateringMenuAlternateCaterersQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuAlternateCaterersQuery,
    CateringMenuAlternateCaterersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuAlternateCaterersQuery,
  CateringMenuAlternateCaterersQueryVariables
>;
export function useCateringMenuAlternateCaterersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuAlternateCaterersQuery,
        CateringMenuAlternateCaterersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuAlternateCaterersQuery | undefined,
  CateringMenuAlternateCaterersQueryVariables
>;
export function useCateringMenuAlternateCaterersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuAlternateCaterersQuery,
        CateringMenuAlternateCaterersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    CateringMenuAlternateCaterersQuery,
    CateringMenuAlternateCaterersQueryVariables
  >(CateringMenuAlternateCaterersQueryDocument, options);
}
export type CateringMenuAlternateCaterersQueryHookResult = ReturnType<
  typeof useCateringMenuAlternateCaterersQuery
>;
export type CateringMenuAlternateCaterersQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuAlternateCaterersQueryLazyQuery
>;
export type CateringMenuAlternateCaterersQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuAlternateCaterersQuerySuspenseQuery
>;
export type CateringMenuAlternateCaterersQueryQueryResult = Apollo.QueryResult<
  CateringMenuAlternateCaterersQuery,
  CateringMenuAlternateCaterersQueryVariables
>;
export const CateringMenuCartLookupByFulfillmentQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuCartLookupByFulfillmentQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filters'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartFilterInput'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartExperience'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerCarts'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filters'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'filters'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'first'},
                      value: {kind: 'IntValue', value: '1'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'nodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
                            },
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'CateringMenuConsumerCartPastCutoffFragment',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'fulfillmentDetail'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailWithMessagesFragment'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailWithMessagesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererUrlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'experience'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuCartLookupByFulfillmentQuery__
 *
 * To run a query within a React component, call `useCateringMenuCartLookupByFulfillmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuCartLookupByFulfillmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuCartLookupByFulfillmentQuery({
 *   variables: {
 *      fulfillmentDetailId: // value for 'fulfillmentDetailId'
 *      filters: // value for 'filters'
 *      catererUrlId: // value for 'catererUrlId'
 *      experience: // value for 'experience'
 *   },
 * });
 */
export function useCateringMenuCartLookupByFulfillmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    CateringMenuCartLookupByFulfillmentQuery,
    CateringMenuCartLookupByFulfillmentQueryVariables
  > &
    (
      | {variables: CateringMenuCartLookupByFulfillmentQueryVariables; skip?: boolean}
      | {skip: boolean}
    ),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    CateringMenuCartLookupByFulfillmentQuery,
    CateringMenuCartLookupByFulfillmentQueryVariables
  >(CateringMenuCartLookupByFulfillmentQueryDocument, options);
}
export function useCateringMenuCartLookupByFulfillmentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CateringMenuCartLookupByFulfillmentQuery,
    CateringMenuCartLookupByFulfillmentQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CateringMenuCartLookupByFulfillmentQuery,
    CateringMenuCartLookupByFulfillmentQueryVariables
  >(CateringMenuCartLookupByFulfillmentQueryDocument, options);
}
// @ts-ignore
export function useCateringMenuCartLookupByFulfillmentQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuCartLookupByFulfillmentQuery,
    CateringMenuCartLookupByFulfillmentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuCartLookupByFulfillmentQuery,
  CateringMenuCartLookupByFulfillmentQueryVariables
>;
export function useCateringMenuCartLookupByFulfillmentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuCartLookupByFulfillmentQuery,
        CateringMenuCartLookupByFulfillmentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuCartLookupByFulfillmentQuery | undefined,
  CateringMenuCartLookupByFulfillmentQueryVariables
>;
export function useCateringMenuCartLookupByFulfillmentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuCartLookupByFulfillmentQuery,
        CateringMenuCartLookupByFulfillmentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    CateringMenuCartLookupByFulfillmentQuery,
    CateringMenuCartLookupByFulfillmentQueryVariables
  >(CateringMenuCartLookupByFulfillmentQueryDocument, options);
}
export type CateringMenuCartLookupByFulfillmentQueryHookResult = ReturnType<
  typeof useCateringMenuCartLookupByFulfillmentQuery
>;
export type CateringMenuCartLookupByFulfillmentQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuCartLookupByFulfillmentQueryLazyQuery
>;
export type CateringMenuCartLookupByFulfillmentQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuCartLookupByFulfillmentQuerySuspenseQuery
>;
export type CateringMenuCartLookupByFulfillmentQueryQueryResult = Apollo.QueryResult<
  CateringMenuCartLookupByFulfillmentQuery,
  CateringMenuCartLookupByFulfillmentQueryVariables
>;
export const CateringMenuCartLookupByIdQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuCartLookupByIdQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartExperience'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCart'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
                },
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CateringMenuFulfillmentDetailWithMessagesFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalExcludingTip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuConsumerCartPastCutoffFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsPastCutoff'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pastCutoffItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailWithMessagesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererUrlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'experience'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuCartLookupByIdQuery__
 *
 * To run a query within a React component, call `useCateringMenuCartLookupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuCartLookupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuCartLookupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      catererUrlId: // value for 'catererUrlId'
 *      experience: // value for 'experience'
 *   },
 * });
 */
export function useCateringMenuCartLookupByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    CateringMenuCartLookupByIdQuery,
    CateringMenuCartLookupByIdQueryVariables
  > &
    ({variables: CateringMenuCartLookupByIdQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CateringMenuCartLookupByIdQuery, CateringMenuCartLookupByIdQueryVariables>(
    CateringMenuCartLookupByIdQueryDocument,
    options,
  );
}
export function useCateringMenuCartLookupByIdQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CateringMenuCartLookupByIdQuery,
    CateringMenuCartLookupByIdQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CateringMenuCartLookupByIdQuery,
    CateringMenuCartLookupByIdQueryVariables
  >(CateringMenuCartLookupByIdQueryDocument, options);
}
// @ts-ignore
export function useCateringMenuCartLookupByIdQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuCartLookupByIdQuery,
    CateringMenuCartLookupByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuCartLookupByIdQuery,
  CateringMenuCartLookupByIdQueryVariables
>;
export function useCateringMenuCartLookupByIdQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuCartLookupByIdQuery,
        CateringMenuCartLookupByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuCartLookupByIdQuery | undefined,
  CateringMenuCartLookupByIdQueryVariables
>;
export function useCateringMenuCartLookupByIdQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuCartLookupByIdQuery,
        CateringMenuCartLookupByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    CateringMenuCartLookupByIdQuery,
    CateringMenuCartLookupByIdQueryVariables
  >(CateringMenuCartLookupByIdQueryDocument, options);
}
export type CateringMenuCartLookupByIdQueryHookResult = ReturnType<
  typeof useCateringMenuCartLookupByIdQuery
>;
export type CateringMenuCartLookupByIdQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuCartLookupByIdQueryLazyQuery
>;
export type CateringMenuCartLookupByIdQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuCartLookupByIdQuerySuspenseQuery
>;
export type CateringMenuCartLookupByIdQueryQueryResult = Apollo.QueryResult<
  CateringMenuCartLookupByIdQuery,
  CateringMenuCartLookupByIdQueryVariables
>;
export const CateringMenuCatererAboutUsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuCatererAboutUsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'urlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CateringMenuAboutUsCatererFragment'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuAboutUsCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'onEzCaterSince'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasOtherLocations'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationFeeDescription'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modificationPolicy'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffHours'}}],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hideStreetAddress'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'storeHours'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryHoursDisplay'}},
                {kind: 'Field', name: {kind: 'Name', value: 'takeoutHoursDisplay'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'isFixed'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'minimumOrderSubTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuCatererAboutUsQuery__
 *
 * To run a query within a React component, call `useCateringMenuCatererAboutUsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuCatererAboutUsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuCatererAboutUsQuery({
 *   variables: {
 *      catererUrlId: // value for 'catererUrlId'
 *   },
 * });
 */
export function useCateringMenuCatererAboutUsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CateringMenuCatererAboutUsQuery,
    CateringMenuCatererAboutUsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CateringMenuCatererAboutUsQuery, CateringMenuCatererAboutUsQueryVariables>(
    CateringMenuCatererAboutUsQueryDocument,
    options,
  );
}
export function useCateringMenuCatererAboutUsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CateringMenuCatererAboutUsQuery,
    CateringMenuCatererAboutUsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CateringMenuCatererAboutUsQuery,
    CateringMenuCatererAboutUsQueryVariables
  >(CateringMenuCatererAboutUsQueryDocument, options);
}
// @ts-ignore
export function useCateringMenuCatererAboutUsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuCatererAboutUsQuery,
    CateringMenuCatererAboutUsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuCatererAboutUsQuery,
  CateringMenuCatererAboutUsQueryVariables
>;
export function useCateringMenuCatererAboutUsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuCatererAboutUsQuery,
        CateringMenuCatererAboutUsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuCatererAboutUsQuery | undefined,
  CateringMenuCatererAboutUsQueryVariables
>;
export function useCateringMenuCatererAboutUsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuCatererAboutUsQuery,
        CateringMenuCatererAboutUsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    CateringMenuCatererAboutUsQuery,
    CateringMenuCatererAboutUsQueryVariables
  >(CateringMenuCatererAboutUsQueryDocument, options);
}
export type CateringMenuCatererAboutUsQueryHookResult = ReturnType<
  typeof useCateringMenuCatererAboutUsQuery
>;
export type CateringMenuCatererAboutUsQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuCatererAboutUsQueryLazyQuery
>;
export type CateringMenuCatererAboutUsQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuCatererAboutUsQuerySuspenseQuery
>;
export type CateringMenuCatererAboutUsQueryQueryResult = Apollo.QueryResult<
  CateringMenuCatererAboutUsQuery,
  CateringMenuCatererAboutUsQueryVariables
>;
export const CateringMenuCatererQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuCatererQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'urlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CateringMenuCatererFragment'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stateName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'heroImage'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'desktopHeroUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobileHeroUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullImagePath'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customStyle'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'primaryAccentColor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'primaryColor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'secondaryAccentColor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'secondaryColor'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customBranding'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'footerText'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'isFixed'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'minimumOrderSubTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hideSpecialInstructions'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hideStreetAddress'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'shouldShowReviews'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasDeliveryHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasTakeoutHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasOtherLocations'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicCatererFulfillmentReportCard'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'onTimeRating'}}],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'advanceNotice'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DayBeforeCutoffTime'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'dayBeforeCutoffTime'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LeadTime'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'leadTimeInMinutes'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isVisibleInStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isVisibleInPrivateStore'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cuisineTypes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sponsoredPromos'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promoCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicTaxonomiesWithTaxons'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'taxonomy'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxons'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasGroupOrderingEnabled'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuCatererQuery__
 *
 * To run a query within a React component, call `useCateringMenuCatererQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuCatererQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuCatererQuery({
 *   variables: {
 *      catererUrlId: // value for 'catererUrlId'
 *   },
 * });
 */
export function useCateringMenuCatererQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CateringMenuCatererQuery,
    CateringMenuCatererQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CateringMenuCatererQuery, CateringMenuCatererQueryVariables>(
    CateringMenuCatererQueryDocument,
    options,
  );
}
export function useCateringMenuCatererQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CateringMenuCatererQuery,
    CateringMenuCatererQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CateringMenuCatererQuery, CateringMenuCatererQueryVariables>(
    CateringMenuCatererQueryDocument,
    options,
  );
}
// @ts-ignore
export function useCateringMenuCatererQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuCatererQuery,
    CateringMenuCatererQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CateringMenuCatererQuery, CateringMenuCatererQueryVariables>;
export function useCateringMenuCatererQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CateringMenuCatererQuery, CateringMenuCatererQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  CateringMenuCatererQuery | undefined,
  CateringMenuCatererQueryVariables
>;
export function useCateringMenuCatererQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CateringMenuCatererQuery, CateringMenuCatererQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CateringMenuCatererQuery, CateringMenuCatererQueryVariables>(
    CateringMenuCatererQueryDocument,
    options,
  );
}
export type CateringMenuCatererQueryHookResult = ReturnType<typeof useCateringMenuCatererQuery>;
export type CateringMenuCatererQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuCatererQueryLazyQuery
>;
export type CateringMenuCatererQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuCatererQuerySuspenseQuery
>;
export type CateringMenuCatererQueryQueryResult = Apollo.QueryResult<
  CateringMenuCatererQuery,
  CateringMenuCatererQueryVariables
>;
export const CateringMenuCatererReviewsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuCatererReviewsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'urlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'reviews'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'offset'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'limit'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'edges'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'node'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'catererId'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuCatererReviewsQuery__
 *
 * To run a query within a React component, call `useCateringMenuCatererReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuCatererReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuCatererReviewsQuery({
 *   variables: {
 *      catererUrlId: // value for 'catererUrlId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCateringMenuCatererReviewsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CateringMenuCatererReviewsQuery,
    CateringMenuCatererReviewsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CateringMenuCatererReviewsQuery, CateringMenuCatererReviewsQueryVariables>(
    CateringMenuCatererReviewsQueryDocument,
    options,
  );
}
export function useCateringMenuCatererReviewsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CateringMenuCatererReviewsQuery,
    CateringMenuCatererReviewsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CateringMenuCatererReviewsQuery,
    CateringMenuCatererReviewsQueryVariables
  >(CateringMenuCatererReviewsQueryDocument, options);
}
// @ts-ignore
export function useCateringMenuCatererReviewsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuCatererReviewsQuery,
    CateringMenuCatererReviewsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuCatererReviewsQuery,
  CateringMenuCatererReviewsQueryVariables
>;
export function useCateringMenuCatererReviewsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuCatererReviewsQuery,
        CateringMenuCatererReviewsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuCatererReviewsQuery | undefined,
  CateringMenuCatererReviewsQueryVariables
>;
export function useCateringMenuCatererReviewsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuCatererReviewsQuery,
        CateringMenuCatererReviewsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    CateringMenuCatererReviewsQuery,
    CateringMenuCatererReviewsQueryVariables
  >(CateringMenuCatererReviewsQueryDocument, options);
}
export type CateringMenuCatererReviewsQueryHookResult = ReturnType<
  typeof useCateringMenuCatererReviewsQuery
>;
export type CateringMenuCatererReviewsQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuCatererReviewsQueryLazyQuery
>;
export type CateringMenuCatererReviewsQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuCatererReviewsQuerySuspenseQuery
>;
export type CateringMenuCatererReviewsQueryQueryResult = Apollo.QueryResult<
  CateringMenuCatererReviewsQuery,
  CateringMenuCatererReviewsQueryVariables
>;
export const CateringMenuEzRewardsModalQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuEzRewardsModalQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isReviewPending'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'giftCardRedemptionAllowed'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'constants'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'ezRewards'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'largestOutstandingUserBalance'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuEzRewardsModalQuery__
 *
 * To run a query within a React component, call `useCateringMenuEzRewardsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuEzRewardsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuEzRewardsModalQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useCateringMenuEzRewardsModalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CateringMenuEzRewardsModalQuery,
    CateringMenuEzRewardsModalQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CateringMenuEzRewardsModalQuery, CateringMenuEzRewardsModalQueryVariables>(
    CateringMenuEzRewardsModalQueryDocument,
    options,
  );
}
export function useCateringMenuEzRewardsModalQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CateringMenuEzRewardsModalQuery,
    CateringMenuEzRewardsModalQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CateringMenuEzRewardsModalQuery,
    CateringMenuEzRewardsModalQueryVariables
  >(CateringMenuEzRewardsModalQueryDocument, options);
}
// @ts-ignore
export function useCateringMenuEzRewardsModalQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuEzRewardsModalQuery,
    CateringMenuEzRewardsModalQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuEzRewardsModalQuery,
  CateringMenuEzRewardsModalQueryVariables
>;
export function useCateringMenuEzRewardsModalQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuEzRewardsModalQuery,
        CateringMenuEzRewardsModalQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuEzRewardsModalQuery | undefined,
  CateringMenuEzRewardsModalQueryVariables
>;
export function useCateringMenuEzRewardsModalQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuEzRewardsModalQuery,
        CateringMenuEzRewardsModalQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    CateringMenuEzRewardsModalQuery,
    CateringMenuEzRewardsModalQueryVariables
  >(CateringMenuEzRewardsModalQueryDocument, options);
}
export type CateringMenuEzRewardsModalQueryHookResult = ReturnType<
  typeof useCateringMenuEzRewardsModalQuery
>;
export type CateringMenuEzRewardsModalQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuEzRewardsModalQueryLazyQuery
>;
export type CateringMenuEzRewardsModalQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuEzRewardsModalQuerySuspenseQuery
>;
export type CateringMenuEzRewardsModalQueryQueryResult = Apollo.QueryResult<
  CateringMenuEzRewardsModalQuery,
  CateringMenuEzRewardsModalQueryVariables
>;
export const CateringMenuFulfillmentDetailQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCartExperience'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailWithMessagesFragment'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuFulfillmentDetailWithMessagesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stage'},
                value: {kind: 'EnumValue', value: 'MENU'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererUrlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'experience'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'experience'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuFulfillmentDetailQuery__
 *
 * To run a query within a React component, call `useCateringMenuFulfillmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuFulfillmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuFulfillmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      catererUrlId: // value for 'catererUrlId'
 *      experience: // value for 'experience'
 *   },
 * });
 */
export function useCateringMenuFulfillmentDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    CateringMenuFulfillmentDetailQuery,
    CateringMenuFulfillmentDetailQueryVariables
  > &
    ({variables: CateringMenuFulfillmentDetailQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    CateringMenuFulfillmentDetailQuery,
    CateringMenuFulfillmentDetailQueryVariables
  >(CateringMenuFulfillmentDetailQueryDocument, options);
}
export function useCateringMenuFulfillmentDetailQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CateringMenuFulfillmentDetailQuery,
    CateringMenuFulfillmentDetailQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CateringMenuFulfillmentDetailQuery,
    CateringMenuFulfillmentDetailQueryVariables
  >(CateringMenuFulfillmentDetailQueryDocument, options);
}
// @ts-ignore
export function useCateringMenuFulfillmentDetailQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuFulfillmentDetailQuery,
    CateringMenuFulfillmentDetailQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuFulfillmentDetailQuery,
  CateringMenuFulfillmentDetailQueryVariables
>;
export function useCateringMenuFulfillmentDetailQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuFulfillmentDetailQuery,
        CateringMenuFulfillmentDetailQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuFulfillmentDetailQuery | undefined,
  CateringMenuFulfillmentDetailQueryVariables
>;
export function useCateringMenuFulfillmentDetailQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuFulfillmentDetailQuery,
        CateringMenuFulfillmentDetailQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    CateringMenuFulfillmentDetailQuery,
    CateringMenuFulfillmentDetailQueryVariables
  >(CateringMenuFulfillmentDetailQueryDocument, options);
}
export type CateringMenuFulfillmentDetailQueryHookResult = ReturnType<
  typeof useCateringMenuFulfillmentDetailQuery
>;
export type CateringMenuFulfillmentDetailQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuFulfillmentDetailQueryLazyQuery
>;
export type CateringMenuFulfillmentDetailQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuFulfillmentDetailQuerySuspenseQuery
>;
export type CateringMenuFulfillmentDetailQueryQueryResult = Apollo.QueryResult<
  CateringMenuFulfillmentDetailQuery,
  CateringMenuFulfillmentDetailQueryVariables
>;
export const CateringMenuOtherLocationsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuOtherLocationsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchAddress'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'shouldIncludeEzO'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeDistance'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'otherLocations'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'address'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'limit'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'shouldIncludeEzo'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'shouldIncludeEzO'}},
                    },
                  ],
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'skip'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {kind: 'Variable', name: {kind: 'Name', value: 'includeDistance'}},
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'nodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'CateringMenuOtherLocationsFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'otherLocationsWithDistance'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'address'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'limit'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                    },
                  ],
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'include'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {kind: 'Variable', name: {kind: 'Name', value: 'includeDistance'}},
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CateringMenuOtherLocationsWithDistanceFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuOtherLocationsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hideStreetAddress'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuOtherLocationsWithDistanceFragment'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'CatererLocationWithDistance'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'distanceMiles'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hideStreetAddress'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuOtherLocationsQuery__
 *
 * To run a query within a React component, call `useCateringMenuOtherLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuOtherLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuOtherLocationsQuery({
 *   variables: {
 *      catererId: // value for 'catererId'
 *      address: // value for 'address'
 *      limit: // value for 'limit'
 *      shouldIncludeEzO: // value for 'shouldIncludeEzO'
 *      includeDistance: // value for 'includeDistance'
 *   },
 * });
 */
export function useCateringMenuOtherLocationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CateringMenuOtherLocationsQuery,
    CateringMenuOtherLocationsQueryVariables
  > &
    ({variables: CateringMenuOtherLocationsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CateringMenuOtherLocationsQuery, CateringMenuOtherLocationsQueryVariables>(
    CateringMenuOtherLocationsQueryDocument,
    options,
  );
}
export function useCateringMenuOtherLocationsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CateringMenuOtherLocationsQuery,
    CateringMenuOtherLocationsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CateringMenuOtherLocationsQuery,
    CateringMenuOtherLocationsQueryVariables
  >(CateringMenuOtherLocationsQueryDocument, options);
}
// @ts-ignore
export function useCateringMenuOtherLocationsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuOtherLocationsQuery,
    CateringMenuOtherLocationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuOtherLocationsQuery,
  CateringMenuOtherLocationsQueryVariables
>;
export function useCateringMenuOtherLocationsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuOtherLocationsQuery,
        CateringMenuOtherLocationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuOtherLocationsQuery | undefined,
  CateringMenuOtherLocationsQueryVariables
>;
export function useCateringMenuOtherLocationsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuOtherLocationsQuery,
        CateringMenuOtherLocationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    CateringMenuOtherLocationsQuery,
    CateringMenuOtherLocationsQueryVariables
  >(CateringMenuOtherLocationsQueryDocument, options);
}
export type CateringMenuOtherLocationsQueryHookResult = ReturnType<
  typeof useCateringMenuOtherLocationsQuery
>;
export type CateringMenuOtherLocationsQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuOtherLocationsQueryLazyQuery
>;
export type CateringMenuOtherLocationsQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuOtherLocationsQuerySuspenseQuery
>;
export type CateringMenuOtherLocationsQueryQueryResult = Apollo.QueryResult<
  CateringMenuOtherLocationsQuery,
  CateringMenuOtherLocationsQueryVariables
>;
export const CateringMenuPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Date'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'channel'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ChannelNameEnum'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeMenuevoMenu'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoChannel'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'MenuChannelInput'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoDate'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ISO8601Date'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'urlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isVisibleInStore'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isVisibleInPrivateStore'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'menuForChannel'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'date'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'channelName'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'channel'}},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'serializedMenu'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'stronglyTypedMenu'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'disclaimers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'contentSummary'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'hasDrinks'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasDesserts'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasSides'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'menuevoMenu'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'channel'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoChannel'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'date'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoDate'}},
                    },
                  ],
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'include'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {
                            kind: 'Variable',
                            name: {kind: 'Name', value: 'includeMenuevoMenu'},
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'categories'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'items'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'advanceNotice'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {kind: 'Name', value: 'CutoffTime'},
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'cutoffTime'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {kind: 'Name', value: 'LeadTimeInMinutes'},
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'leadTimeInMinutes'},
                                              },
                                            ],
                                          },
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'calories'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'min'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'dietaryFlags'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isGlutenFree'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isHalal'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isKosher'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isVegan'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isVegetarian'},
                                        },
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'image'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'desktopUrl'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'imageUrl'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'individualWrapStatus'},
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'hasModifierGroups'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isPopular'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'minPrice'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'subunitsV2'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'minServes'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'price'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'subunitsV2'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'quantityRules'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'increment'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'min'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'salesTaxCode'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'servingSize'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'sortIndex'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'unit'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'sortIndex'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'channel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dietaryFlags'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'freeTablewareItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasIndividuallyPackagedItems'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CateringMenuCatererFragment'},
                },
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CateringMenuAboutUsCatererFragment'},
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'stateName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'heroImage'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'desktopHeroUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobileHeroUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullImagePath'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customStyle'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'primaryAccentColor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'primaryColor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'secondaryAccentColor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'secondaryColor'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customBranding'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'footerText'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'isFixed'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'minimumOrderSubTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hideSpecialInstructions'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hideStreetAddress'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'shouldShowReviews'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasDeliveryHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasTakeoutHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasOtherLocations'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicCatererFulfillmentReportCard'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'onTimeRating'}}],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'advanceNotice'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DayBeforeCutoffTime'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'dayBeforeCutoffTime'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LeadTime'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'leadTimeInMinutes'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isVisibleInStore'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isVisibleInPrivateStore'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cuisineTypes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'sponsoredPromos'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promoCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'publicTaxonomiesWithTaxons'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'taxonomy'}},
                {kind: 'Field', name: {kind: 'Name', value: 'taxons'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasGroupOrderingEnabled'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CateringMenuAboutUsCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'onEzCaterSince'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasOtherLocations'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationFeeDescription'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modificationPolicy'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffHours'}}],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hideStreetAddress'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'storeHours'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryHoursDisplay'}},
                {kind: 'Field', name: {kind: 'Name', value: 'takeoutHoursDisplay'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'isFixed'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'minimumOrderSubTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'graphExperiments'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryFeeExperiment'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'v2'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'flagKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allocationKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'experimentKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'variation'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'pricingModel'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CappedDeliveryFeePricingModel'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cap'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'currency'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuPageQuery__
 *
 * To run a query within a React component, call `useCateringMenuPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuPageQuery({
 *   variables: {
 *      catererUrlId: // value for 'catererUrlId'
 *      date: // value for 'date'
 *      channel: // value for 'channel'
 *      accountUuid: // value for 'accountUuid'
 *      includeMenuevoMenu: // value for 'includeMenuevoMenu'
 *      menuevoChannel: // value for 'menuevoChannel'
 *      menuevoDate: // value for 'menuevoDate'
 *   },
 * });
 */
export function useCateringMenuPageQuery(
  baseOptions: Apollo.QueryHookOptions<CateringMenuPageQuery, CateringMenuPageQueryVariables> &
    ({variables: CateringMenuPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CateringMenuPageQuery, CateringMenuPageQueryVariables>(
    CateringMenuPageQueryDocument,
    options,
  );
}
export function useCateringMenuPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CateringMenuPageQuery, CateringMenuPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CateringMenuPageQuery, CateringMenuPageQueryVariables>(
    CateringMenuPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useCateringMenuPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuPageQuery,
    CateringMenuPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CateringMenuPageQuery, CateringMenuPageQueryVariables>;
export function useCateringMenuPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CateringMenuPageQuery, CateringMenuPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<CateringMenuPageQuery | undefined, CateringMenuPageQueryVariables>;
export function useCateringMenuPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CateringMenuPageQuery, CateringMenuPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CateringMenuPageQuery, CateringMenuPageQueryVariables>(
    CateringMenuPageQueryDocument,
    options,
  );
}
export type CateringMenuPageQueryHookResult = ReturnType<typeof useCateringMenuPageQuery>;
export type CateringMenuPageQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuPageQueryLazyQuery
>;
export type CateringMenuPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuPageQuerySuspenseQuery
>;
export type CateringMenuPageQueryQueryResult = Apollo.QueryResult<
  CateringMenuPageQuery,
  CateringMenuPageQueryVariables
>;
export const CateringMenuQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Date'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'channel'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ChannelNameEnum'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeMenuevoMenu'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoChannel'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'MenuChannelInput'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoDate'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ISO8601Date'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'urlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'menuForChannel'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'date'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'channelName'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'channel'}},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'serializedMenu'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'stronglyTypedMenu'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'contentSummary'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'hasDrinks'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasDesserts'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasSides'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'disclaimers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'menuevoMenu'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'channel'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoChannel'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'date'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoDate'}},
                    },
                  ],
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'include'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {
                            kind: 'Variable',
                            name: {kind: 'Name', value: 'includeMenuevoMenu'},
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'categories'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'items'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'advanceNotice'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {kind: 'Name', value: 'CutoffTime'},
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'cutoffTime'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {kind: 'Name', value: 'LeadTimeInMinutes'},
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'leadTimeInMinutes'},
                                              },
                                            ],
                                          },
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'calories'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'min'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'dietaryFlags'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isGlutenFree'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isHalal'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isKosher'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isVegan'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isVegetarian'},
                                        },
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'image'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'desktopUrl'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'imageUrl'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'individualWrapStatus'},
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'hasModifierGroups'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isPopular'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'minPrice'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'subunitsV2'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'minServes'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'price'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'subunitsV2'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'quantityRules'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'increment'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'min'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'salesTaxCode'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'servingSize'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'sortIndex'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'unit'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'sortIndex'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'channel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dietaryFlags'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'freeTablewareItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasIndividuallyPackagedItems'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuQuery__
 *
 * To run a query within a React component, call `useCateringMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuQuery({
 *   variables: {
 *      catererUrlId: // value for 'catererUrlId'
 *      date: // value for 'date'
 *      channel: // value for 'channel'
 *      includeMenuevoMenu: // value for 'includeMenuevoMenu'
 *      menuevoChannel: // value for 'menuevoChannel'
 *      menuevoDate: // value for 'menuevoDate'
 *   },
 * });
 */
export function useCateringMenuQuery(
  baseOptions: Apollo.QueryHookOptions<CateringMenuQuery, CateringMenuQueryVariables> &
    ({variables: CateringMenuQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CateringMenuQuery, CateringMenuQueryVariables>(
    CateringMenuQueryDocument,
    options,
  );
}
export function useCateringMenuQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CateringMenuQuery, CateringMenuQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CateringMenuQuery, CateringMenuQueryVariables>(
    CateringMenuQueryDocument,
    options,
  );
}
// @ts-ignore
export function useCateringMenuQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CateringMenuQuery, CateringMenuQueryVariables>,
): Apollo.UseSuspenseQueryResult<CateringMenuQuery, CateringMenuQueryVariables>;
export function useCateringMenuQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CateringMenuQuery, CateringMenuQueryVariables>,
): Apollo.UseSuspenseQueryResult<CateringMenuQuery | undefined, CateringMenuQueryVariables>;
export function useCateringMenuQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CateringMenuQuery, CateringMenuQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CateringMenuQuery, CateringMenuQueryVariables>(
    CateringMenuQueryDocument,
    options,
  );
}
export type CateringMenuQueryHookResult = ReturnType<typeof useCateringMenuQuery>;
export type CateringMenuQueryLazyQueryHookResult = ReturnType<typeof useCateringMenuQueryLazyQuery>;
export type CateringMenuQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuQuerySuspenseQuery
>;
export type CateringMenuQueryQueryResult = Apollo.QueryResult<
  CateringMenuQuery,
  CateringMenuQueryVariables
>;
export const CateringMenuSwitchCatererQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CateringMenuSwitchCatererQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderAt'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'urlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'isDeliveryAvailable'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderAt'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'orderAt'}},
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'isTakeoutAvailable'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderAt'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'orderAt'}},
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCateringMenuSwitchCatererQuery__
 *
 * To run a query within a React component, call `useCateringMenuSwitchCatererQuery` and pass it any options that fit your needs.
 * When your component renders, `useCateringMenuSwitchCatererQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringMenuSwitchCatererQuery({
 *   variables: {
 *      catererUrlId: // value for 'catererUrlId'
 *      orderAt: // value for 'orderAt'
 *   },
 * });
 */
export function useCateringMenuSwitchCatererQuery(
  baseOptions: Apollo.QueryHookOptions<
    CateringMenuSwitchCatererQuery,
    CateringMenuSwitchCatererQueryVariables
  > &
    ({variables: CateringMenuSwitchCatererQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CateringMenuSwitchCatererQuery, CateringMenuSwitchCatererQueryVariables>(
    CateringMenuSwitchCatererQueryDocument,
    options,
  );
}
export function useCateringMenuSwitchCatererQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CateringMenuSwitchCatererQuery,
    CateringMenuSwitchCatererQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CateringMenuSwitchCatererQuery,
    CateringMenuSwitchCatererQueryVariables
  >(CateringMenuSwitchCatererQueryDocument, options);
}
// @ts-ignore
export function useCateringMenuSwitchCatererQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CateringMenuSwitchCatererQuery,
    CateringMenuSwitchCatererQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuSwitchCatererQuery,
  CateringMenuSwitchCatererQueryVariables
>;
export function useCateringMenuSwitchCatererQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuSwitchCatererQuery,
        CateringMenuSwitchCatererQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CateringMenuSwitchCatererQuery | undefined,
  CateringMenuSwitchCatererQueryVariables
>;
export function useCateringMenuSwitchCatererQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CateringMenuSwitchCatererQuery,
        CateringMenuSwitchCatererQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    CateringMenuSwitchCatererQuery,
    CateringMenuSwitchCatererQueryVariables
  >(CateringMenuSwitchCatererQueryDocument, options);
}
export type CateringMenuSwitchCatererQueryHookResult = ReturnType<
  typeof useCateringMenuSwitchCatererQuery
>;
export type CateringMenuSwitchCatererQueryLazyQueryHookResult = ReturnType<
  typeof useCateringMenuSwitchCatererQueryLazyQuery
>;
export type CateringMenuSwitchCatererQuerySuspenseQueryHookResult = ReturnType<
  typeof useCateringMenuSwitchCatererQuerySuspenseQuery
>;
export type CateringMenuSwitchCatererQueryQueryResult = Apollo.QueryResult<
  CateringMenuSwitchCatererQuery,
  CateringMenuSwitchCatererQueryVariables
>;
export const CheckoutConsumerCartQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CheckoutConsumerCartQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethodsLimit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCart'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CheckoutConsumerCartFragment'},
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brandCommunication'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'canOptIn'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'address'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'staticMapUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'brand'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cancellationPolicy'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'cancellationWindowHours'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'feePercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerMessages'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'customerMessages'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'stage'},
                            value: {kind: 'EnumValue', value: 'CHECKOUT'},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'ConsumerCartItemsNotAvailable'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'missingItems'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'missingChoices'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeoutAvailable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTaxExempt'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'paymentMethod'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CreditCard'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isExpired'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingZipCode'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'sharedBy'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CreditLine'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'corpAccountName'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'paymentMethodUserId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promoCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'taxExemptionCertificateStatus'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'braintreeClientToken'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'showSmsOptIn'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'paymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'paymentMethodsLimit'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CreditCard'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cardholderName'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isDefaultCard'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'missingZipCode'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'sharedBy'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CreditLine'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'corpAccountName'},
                                        },
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'staticMapUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'creditCardPaymentAllowed'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CheckoutConsumerCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'authorizedUsers'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'remainingBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'currentValue'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderId'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'requiresCreditLine'}},
                {kind: 'Field', name: {kind: 'Name', value: 'procurement'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserAccessScopes'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerMessages'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartItemsNotAvailable'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'missingItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'missingChoices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'defaultTipExperimentVariant'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'experience'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userCanAccessEzRewards'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'bonusPointsEarnable'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'combined'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'dollarsToApply'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totalRemaining'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'amount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'extraPointsToApply'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'maxDeductible'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'boosted'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'amount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'points'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'payableWithEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsEarnable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'pointsToApply'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'CheckoutPageFulfillmentDetailFragment'},
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerMessages'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'stage'},
                      value: {kind: 'EnumValue', value: 'CHECKOUT'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ConsumerCartItemsNotAvailable'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'missingItems'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'missingChoices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'ConsumerCartOverCorpSpendingLimit'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'enforce'}}],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'groupOrder'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'eventDate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'ownerName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'perPersonBudget'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDessert'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isMissingDrinks'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPunchoutEdit'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifiers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'options'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'choices'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subQuantityPercentage'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'shopper'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'total'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'lineItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'GenericLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'DeliveryFeeLineItem'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isThirdPartyDeliveryOnly'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preCapCost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'PromoLineItem'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promoApplicationStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSuccessfullyApplied'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingRequirements'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'pricePerHead'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'foodTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'qualifiesForFreeDelivery'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'subtotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'freeTablewareItems'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tablewareChoices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isIncluded'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fixedAmount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'percentage'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDueExcludingTip'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'tippingAllowed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'utensilsSelection'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'promoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'user'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'requiresProcurementCheckout'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCheckoutConsumerCartQuery__
 *
 * To run a query within a React component, call `useCheckoutConsumerCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutConsumerCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutConsumerCartQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paymentMethodsLimit: // value for 'paymentMethodsLimit'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useCheckoutConsumerCartQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckoutConsumerCartQuery,
    CheckoutConsumerCartQueryVariables
  > &
    ({variables: CheckoutConsumerCartQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CheckoutConsumerCartQuery, CheckoutConsumerCartQueryVariables>(
    CheckoutConsumerCartQueryDocument,
    options,
  );
}
export function useCheckoutConsumerCartQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckoutConsumerCartQuery,
    CheckoutConsumerCartQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CheckoutConsumerCartQuery, CheckoutConsumerCartQueryVariables>(
    CheckoutConsumerCartQueryDocument,
    options,
  );
}
// @ts-ignore
export function useCheckoutConsumerCartQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckoutConsumerCartQuery,
    CheckoutConsumerCartQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CheckoutConsumerCartQuery, CheckoutConsumerCartQueryVariables>;
export function useCheckoutConsumerCartQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckoutConsumerCartQuery,
        CheckoutConsumerCartQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckoutConsumerCartQuery | undefined,
  CheckoutConsumerCartQueryVariables
>;
export function useCheckoutConsumerCartQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckoutConsumerCartQuery,
        CheckoutConsumerCartQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CheckoutConsumerCartQuery, CheckoutConsumerCartQueryVariables>(
    CheckoutConsumerCartQueryDocument,
    options,
  );
}
export type CheckoutConsumerCartQueryHookResult = ReturnType<typeof useCheckoutConsumerCartQuery>;
export type CheckoutConsumerCartQueryLazyQueryHookResult = ReturnType<
  typeof useCheckoutConsumerCartQueryLazyQuery
>;
export type CheckoutConsumerCartQuerySuspenseQueryHookResult = ReturnType<
  typeof useCheckoutConsumerCartQuerySuspenseQuery
>;
export type CheckoutConsumerCartQueryQueryResult = Apollo.QueryResult<
  CheckoutConsumerCartQuery,
  CheckoutConsumerCartQueryVariables
>;
export const CheckoutPaymentMethodsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CheckoutPaymentMethodsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethodsLimit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'paymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'paymentMethodsLimit'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CreditCard'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cardholderName'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isDefaultCard'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isExpired'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'missingZipCode'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'sharedBy'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CreditLine'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'corpAccountName'},
                                        },
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCheckoutPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useCheckoutPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPaymentMethodsQuery({
 *   variables: {
 *      paymentMethodsLimit: // value for 'paymentMethodsLimit'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useCheckoutPaymentMethodsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckoutPaymentMethodsQuery,
    CheckoutPaymentMethodsQueryVariables
  > &
    ({variables: CheckoutPaymentMethodsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CheckoutPaymentMethodsQuery, CheckoutPaymentMethodsQueryVariables>(
    CheckoutPaymentMethodsQueryDocument,
    options,
  );
}
export function useCheckoutPaymentMethodsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckoutPaymentMethodsQuery,
    CheckoutPaymentMethodsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CheckoutPaymentMethodsQuery, CheckoutPaymentMethodsQueryVariables>(
    CheckoutPaymentMethodsQueryDocument,
    options,
  );
}
// @ts-ignore
export function useCheckoutPaymentMethodsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckoutPaymentMethodsQuery,
    CheckoutPaymentMethodsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CheckoutPaymentMethodsQuery, CheckoutPaymentMethodsQueryVariables>;
export function useCheckoutPaymentMethodsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckoutPaymentMethodsQuery,
        CheckoutPaymentMethodsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckoutPaymentMethodsQuery | undefined,
  CheckoutPaymentMethodsQueryVariables
>;
export function useCheckoutPaymentMethodsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckoutPaymentMethodsQuery,
        CheckoutPaymentMethodsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CheckoutPaymentMethodsQuery, CheckoutPaymentMethodsQueryVariables>(
    CheckoutPaymentMethodsQueryDocument,
    options,
  );
}
export type CheckoutPaymentMethodsQueryHookResult = ReturnType<
  typeof useCheckoutPaymentMethodsQuery
>;
export type CheckoutPaymentMethodsQueryLazyQueryHookResult = ReturnType<
  typeof useCheckoutPaymentMethodsQueryLazyQuery
>;
export type CheckoutPaymentMethodsQuerySuspenseQueryHookResult = ReturnType<
  typeof useCheckoutPaymentMethodsQuerySuspenseQuery
>;
export type CheckoutPaymentMethodsQueryQueryResult = Apollo.QueryResult<
  CheckoutPaymentMethodsQuery,
  CheckoutPaymentMethodsQueryVariables
>;
export const ConcurQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ConcurQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canUpdateCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'isEnabled'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'canEnableRosterSync'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'concurLikeliness'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'concurEnterpriseUserStatus'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'concurAccount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'areReceiptsAutomated'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'recentlyCompletedOrders'},
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'RECEIPT'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'eventAfter'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConcurQuery__
 *
 * To run a query within a React component, call `useConcurQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcurQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcurQuery({
 *   variables: {
 *      eventAfter: // value for 'eventAfter'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useConcurQuery(
  baseOptions?: Apollo.QueryHookOptions<ConcurQuery, ConcurQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ConcurQuery, ConcurQueryVariables>(ConcurQueryDocument, options);
}
export function useConcurQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ConcurQuery, ConcurQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ConcurQuery, ConcurQueryVariables>(ConcurQueryDocument, options);
}
// @ts-ignore
export function useConcurQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ConcurQuery, ConcurQueryVariables>,
): Apollo.UseSuspenseQueryResult<ConcurQuery, ConcurQueryVariables>;
export function useConcurQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConcurQuery, ConcurQueryVariables>,
): Apollo.UseSuspenseQueryResult<ConcurQuery | undefined, ConcurQueryVariables>;
export function useConcurQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConcurQuery, ConcurQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ConcurQuery, ConcurQueryVariables>(ConcurQueryDocument, options);
}
export type ConcurQueryHookResult = ReturnType<typeof useConcurQuery>;
export type ConcurQueryLazyQueryHookResult = ReturnType<typeof useConcurQueryLazyQuery>;
export type ConcurQuerySuspenseQueryHookResult = ReturnType<typeof useConcurQuerySuspenseQuery>;
export type ConcurQueryQueryResult = Apollo.QueryResult<ConcurQuery, ConcurQueryVariables>;
export const ConsumerCartOpenInvitationsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ConsumerCartOpenInvitationsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCart'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'openInvitations'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'invitationUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accessScope'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConsumerCartOpenInvitationsQuery__
 *
 * To run a query within a React component, call `useConsumerCartOpenInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartOpenInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerCartOpenInvitationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsumerCartOpenInvitationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConsumerCartOpenInvitationsQuery,
    ConsumerCartOpenInvitationsQueryVariables
  > &
    ({variables: ConsumerCartOpenInvitationsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    ConsumerCartOpenInvitationsQuery,
    ConsumerCartOpenInvitationsQueryVariables
  >(ConsumerCartOpenInvitationsQueryDocument, options);
}
export function useConsumerCartOpenInvitationsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsumerCartOpenInvitationsQuery,
    ConsumerCartOpenInvitationsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    ConsumerCartOpenInvitationsQuery,
    ConsumerCartOpenInvitationsQueryVariables
  >(ConsumerCartOpenInvitationsQueryDocument, options);
}
// @ts-ignore
export function useConsumerCartOpenInvitationsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConsumerCartOpenInvitationsQuery,
    ConsumerCartOpenInvitationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ConsumerCartOpenInvitationsQuery,
  ConsumerCartOpenInvitationsQueryVariables
>;
export function useConsumerCartOpenInvitationsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConsumerCartOpenInvitationsQuery,
        ConsumerCartOpenInvitationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ConsumerCartOpenInvitationsQuery | undefined,
  ConsumerCartOpenInvitationsQueryVariables
>;
export function useConsumerCartOpenInvitationsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConsumerCartOpenInvitationsQuery,
        ConsumerCartOpenInvitationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    ConsumerCartOpenInvitationsQuery,
    ConsumerCartOpenInvitationsQueryVariables
  >(ConsumerCartOpenInvitationsQueryDocument, options);
}
export type ConsumerCartOpenInvitationsQueryHookResult = ReturnType<
  typeof useConsumerCartOpenInvitationsQuery
>;
export type ConsumerCartOpenInvitationsQueryLazyQueryHookResult = ReturnType<
  typeof useConsumerCartOpenInvitationsQueryLazyQuery
>;
export type ConsumerCartOpenInvitationsQuerySuspenseQueryHookResult = ReturnType<
  typeof useConsumerCartOpenInvitationsQuerySuspenseQuery
>;
export type ConsumerCartOpenInvitationsQueryQueryResult = Apollo.QueryResult<
  ConsumerCartOpenInvitationsQuery,
  ConsumerCartOpenInvitationsQueryVariables
>;
export const ConsumerCartRecommendationsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ConsumerCartRecommendations'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderUuid'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'recommendationsForOrder'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'menuItem'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'imageUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isOrHasDessert'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isOrHasDrink'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'sizes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConsumerCartRecommendationsQuery__
 *
 * To run a query within a React component, call `useConsumerCartRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerCartRecommendationsQuery({
 *   variables: {
 *      orderUuid: // value for 'orderUuid'
 *   },
 * });
 */
export function useConsumerCartRecommendationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConsumerCartRecommendationsQuery,
    ConsumerCartRecommendationsQueryVariables
  > &
    ({variables: ConsumerCartRecommendationsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    ConsumerCartRecommendationsQuery,
    ConsumerCartRecommendationsQueryVariables
  >(ConsumerCartRecommendationsDocument, options);
}
export function useConsumerCartRecommendationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsumerCartRecommendationsQuery,
    ConsumerCartRecommendationsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    ConsumerCartRecommendationsQuery,
    ConsumerCartRecommendationsQueryVariables
  >(ConsumerCartRecommendationsDocument, options);
}
// @ts-ignore
export function useConsumerCartRecommendationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConsumerCartRecommendationsQuery,
    ConsumerCartRecommendationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ConsumerCartRecommendationsQuery,
  ConsumerCartRecommendationsQueryVariables
>;
export function useConsumerCartRecommendationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConsumerCartRecommendationsQuery,
        ConsumerCartRecommendationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ConsumerCartRecommendationsQuery | undefined,
  ConsumerCartRecommendationsQueryVariables
>;
export function useConsumerCartRecommendationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConsumerCartRecommendationsQuery,
        ConsumerCartRecommendationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    ConsumerCartRecommendationsQuery,
    ConsumerCartRecommendationsQueryVariables
  >(ConsumerCartRecommendationsDocument, options);
}
export type ConsumerCartRecommendationsQueryHookResult = ReturnType<
  typeof useConsumerCartRecommendationsQuery
>;
export type ConsumerCartRecommendationsLazyQueryHookResult = ReturnType<
  typeof useConsumerCartRecommendationsLazyQuery
>;
export type ConsumerCartRecommendationsSuspenseQueryHookResult = ReturnType<
  typeof useConsumerCartRecommendationsSuspenseQuery
>;
export type ConsumerCartRecommendationsQueryResult = Apollo.QueryResult<
  ConsumerCartRecommendationsQuery,
  ConsumerCartRecommendationsQueryVariables
>;
export const ConsumerCartReorderDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ConsumerCartReorder'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Date'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'consumerCartReorder'},
            name: {kind: 'Name', value: 'consumerCartReOrder'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'date'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'menuItemUuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'singleItemServes'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'sizeLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'total'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunitsV2'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ConsumerCartModifierFragment',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'ConsumerCartModifierFragment',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'modifiers'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'ConsumerCartModifierFragment',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'options'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'menuOptionUuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'prefixLabel'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'minimumChoicesAllowed'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'maximumChoicesAllowed'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'choices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'menuChoiceUuid'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'hideFromCustomer'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'subQuantityPercentage'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'price'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'subunitsV2'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerCartModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ModifierInterface'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'supplierProductId'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConsumerCartReorderQuery__
 *
 * To run a query within a React component, call `useConsumerCartReorderQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerCartReorderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerCartReorderQuery({
 *   variables: {
 *      date: // value for 'date'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsumerCartReorderQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConsumerCartReorderQuery,
    ConsumerCartReorderQueryVariables
  > &
    ({variables: ConsumerCartReorderQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ConsumerCartReorderQuery, ConsumerCartReorderQueryVariables>(
    ConsumerCartReorderDocument,
    options,
  );
}
export function useConsumerCartReorderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsumerCartReorderQuery,
    ConsumerCartReorderQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ConsumerCartReorderQuery, ConsumerCartReorderQueryVariables>(
    ConsumerCartReorderDocument,
    options,
  );
}
// @ts-ignore
export function useConsumerCartReorderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConsumerCartReorderQuery,
    ConsumerCartReorderQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ConsumerCartReorderQuery, ConsumerCartReorderQueryVariables>;
export function useConsumerCartReorderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConsumerCartReorderQuery, ConsumerCartReorderQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ConsumerCartReorderQuery | undefined,
  ConsumerCartReorderQueryVariables
>;
export function useConsumerCartReorderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConsumerCartReorderQuery, ConsumerCartReorderQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ConsumerCartReorderQuery, ConsumerCartReorderQueryVariables>(
    ConsumerCartReorderDocument,
    options,
  );
}
export type ConsumerCartReorderQueryHookResult = ReturnType<typeof useConsumerCartReorderQuery>;
export type ConsumerCartReorderLazyQueryHookResult = ReturnType<
  typeof useConsumerCartReorderLazyQuery
>;
export type ConsumerCartReorderSuspenseQueryHookResult = ReturnType<
  typeof useConsumerCartReorderSuspenseQuery
>;
export type ConsumerCartReorderQueryResult = Apollo.QueryResult<
  ConsumerCartReorderQuery,
  ConsumerCartReorderQueryVariables
>;
export const ContactUsFormQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ContactUsFormQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'IntValue', value: '30'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'SUBMITTED'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'sortDirection'},
                            value: {kind: 'EnumValue', value: 'DESC'},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ContactUsOrderFragment'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactUsOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useContactUsFormQuery__
 *
 * To run a query within a React component, call `useContactUsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactUsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactUsFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactUsFormQuery(
  baseOptions?: Apollo.QueryHookOptions<ContactUsFormQuery, ContactUsFormQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ContactUsFormQuery, ContactUsFormQueryVariables>(
    ContactUsFormQueryDocument,
    options,
  );
}
export function useContactUsFormQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactUsFormQuery, ContactUsFormQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ContactUsFormQuery, ContactUsFormQueryVariables>(
    ContactUsFormQueryDocument,
    options,
  );
}
// @ts-ignore
export function useContactUsFormQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactUsFormQuery, ContactUsFormQueryVariables>,
): Apollo.UseSuspenseQueryResult<ContactUsFormQuery, ContactUsFormQueryVariables>;
export function useContactUsFormQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContactUsFormQuery, ContactUsFormQueryVariables>,
): Apollo.UseSuspenseQueryResult<ContactUsFormQuery | undefined, ContactUsFormQueryVariables>;
export function useContactUsFormQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContactUsFormQuery, ContactUsFormQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ContactUsFormQuery, ContactUsFormQueryVariables>(
    ContactUsFormQueryDocument,
    options,
  );
}
export type ContactUsFormQueryHookResult = ReturnType<typeof useContactUsFormQuery>;
export type ContactUsFormQueryLazyQueryHookResult = ReturnType<
  typeof useContactUsFormQueryLazyQuery
>;
export type ContactUsFormQuerySuspenseQueryHookResult = ReturnType<
  typeof useContactUsFormQuerySuspenseQuery
>;
export type ContactUsFormQueryQueryResult = Apollo.QueryResult<
  ContactUsFormQuery,
  ContactUsFormQueryVariables
>;
export const ContactUsModalQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ContactUsModalQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'IntValue', value: '30'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'SUBMITTED'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'sortDirection'},
                            value: {kind: 'EnumValue', value: 'DESC'},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'ContactUsModalOrderFragment'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContactUsModalOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useContactUsModalQuery__
 *
 * To run a query within a React component, call `useContactUsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactUsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactUsModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactUsModalQuery(
  baseOptions?: Apollo.QueryHookOptions<ContactUsModalQuery, ContactUsModalQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ContactUsModalQuery, ContactUsModalQueryVariables>(
    ContactUsModalQueryDocument,
    options,
  );
}
export function useContactUsModalQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContactUsModalQuery, ContactUsModalQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ContactUsModalQuery, ContactUsModalQueryVariables>(
    ContactUsModalQueryDocument,
    options,
  );
}
// @ts-ignore
export function useContactUsModalQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ContactUsModalQuery, ContactUsModalQueryVariables>,
): Apollo.UseSuspenseQueryResult<ContactUsModalQuery, ContactUsModalQueryVariables>;
export function useContactUsModalQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContactUsModalQuery, ContactUsModalQueryVariables>,
): Apollo.UseSuspenseQueryResult<ContactUsModalQuery | undefined, ContactUsModalQueryVariables>;
export function useContactUsModalQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContactUsModalQuery, ContactUsModalQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ContactUsModalQuery, ContactUsModalQueryVariables>(
    ContactUsModalQueryDocument,
    options,
  );
}
export type ContactUsModalQueryHookResult = ReturnType<typeof useContactUsModalQuery>;
export type ContactUsModalQueryLazyQueryHookResult = ReturnType<
  typeof useContactUsModalQueryLazyQuery
>;
export type ContactUsModalQuerySuspenseQueryHookResult = ReturnType<
  typeof useContactUsModalQuerySuspenseQuery
>;
export type ContactUsModalQueryQueryResult = Apollo.QueryResult<
  ContactUsModalQuery,
  ContactUsModalQueryVariables
>;
export const ContinuityCardsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ContinuityCardsQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'continuityCards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'DraftOrderContinuityCardFragment'},
                },
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'SearchContinuityCardFragment'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ContinuityCardFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ContinuityCard'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'url'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'image'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'desktopHeroUrl'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DraftOrderContinuityCardFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'DraftOrderContinuityCard'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContinuityCardFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'catererName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'itemCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderTotal'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isGroupOrder'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SearchContinuityCardFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'SearchContinuityCard'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ContinuityCardFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'keyword'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cuisineOption'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useContinuityCardsQuery__
 *
 * To run a query within a React component, call `useContinuityCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContinuityCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContinuityCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContinuityCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<ContinuityCardsQuery, ContinuityCardsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ContinuityCardsQuery, ContinuityCardsQueryVariables>(
    ContinuityCardsQueryDocument,
    options,
  );
}
export function useContinuityCardsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContinuityCardsQuery, ContinuityCardsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ContinuityCardsQuery, ContinuityCardsQueryVariables>(
    ContinuityCardsQueryDocument,
    options,
  );
}
// @ts-ignore
export function useContinuityCardsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContinuityCardsQuery,
    ContinuityCardsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ContinuityCardsQuery, ContinuityCardsQueryVariables>;
export function useContinuityCardsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContinuityCardsQuery, ContinuityCardsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ContinuityCardsQuery | undefined, ContinuityCardsQueryVariables>;
export function useContinuityCardsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContinuityCardsQuery, ContinuityCardsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ContinuityCardsQuery, ContinuityCardsQueryVariables>(
    ContinuityCardsQueryDocument,
    options,
  );
}
export type ContinuityCardsQueryHookResult = ReturnType<typeof useContinuityCardsQuery>;
export type ContinuityCardsQueryLazyQueryHookResult = ReturnType<
  typeof useContinuityCardsQueryLazyQuery
>;
export type ContinuityCardsQuerySuspenseQueryHookResult = ReturnType<
  typeof useContinuityCardsQuerySuspenseQuery
>;
export type ContinuityCardsQueryQueryResult = Apollo.QueryResult<
  ContinuityCardsQuery,
  ContinuityCardsQueryVariables
>;
export const CorporateInvitePageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CorporateInvitePageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'inviteToken'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'openCorpInvites'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'inviteToken'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'inviteToken'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'sourceImpliesConsent'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'sentByUser'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateAccount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'freeDeliveryThreshold'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'verifiedRegisteredCustomerMembershipCount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'familyParent'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'availableFeaturesForUser'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'priority'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'enabled'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'existingUnrelatedCorpAccount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCorporateInvitePageQuery__
 *
 * To run a query within a React component, call `useCorporateInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorporateInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorporateInvitePageQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useCorporateInvitePageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CorporateInvitePageQuery,
    CorporateInvitePageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CorporateInvitePageQuery, CorporateInvitePageQueryVariables>(
    CorporateInvitePageQueryDocument,
    options,
  );
}
export function useCorporateInvitePageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CorporateInvitePageQuery,
    CorporateInvitePageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CorporateInvitePageQuery, CorporateInvitePageQueryVariables>(
    CorporateInvitePageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useCorporateInvitePageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CorporateInvitePageQuery,
    CorporateInvitePageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CorporateInvitePageQuery, CorporateInvitePageQueryVariables>;
export function useCorporateInvitePageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CorporateInvitePageQuery, CorporateInvitePageQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  CorporateInvitePageQuery | undefined,
  CorporateInvitePageQueryVariables
>;
export function useCorporateInvitePageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CorporateInvitePageQuery, CorporateInvitePageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CorporateInvitePageQuery, CorporateInvitePageQueryVariables>(
    CorporateInvitePageQueryDocument,
    options,
  );
}
export type CorporateInvitePageQueryHookResult = ReturnType<typeof useCorporateInvitePageQuery>;
export type CorporateInvitePageQueryLazyQueryHookResult = ReturnType<
  typeof useCorporateInvitePageQueryLazyQuery
>;
export type CorporateInvitePageQuerySuspenseQueryHookResult = ReturnType<
  typeof useCorporateInvitePageQuerySuspenseQuery
>;
export type CorporateInvitePageQueryQueryResult = Apollo.QueryResult<
  CorporateInvitePageQuery,
  CorporateInvitePageQueryVariables
>;
export const CreditCardDeleteConfirmationQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CreditCardDeleteConfirmationQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'creditCard'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'id'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'deleteConfirmation'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'kind'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'canDelete'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'body'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'confirmLabel'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'cancelLabel'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'blockingOrders'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'orderNumber'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'timeZoneIdentifier'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'catererName'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'affectedTeammates'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'orderCount'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCreditCardDeleteConfirmationQuery__
 *
 * To run a query within a React component, call `useCreditCardDeleteConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditCardDeleteConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditCardDeleteConfirmationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useCreditCardDeleteConfirmationQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreditCardDeleteConfirmationQuery,
    CreditCardDeleteConfirmationQueryVariables
  > &
    ({variables: CreditCardDeleteConfirmationQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    CreditCardDeleteConfirmationQuery,
    CreditCardDeleteConfirmationQueryVariables
  >(CreditCardDeleteConfirmationQueryDocument, options);
}
export function useCreditCardDeleteConfirmationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreditCardDeleteConfirmationQuery,
    CreditCardDeleteConfirmationQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    CreditCardDeleteConfirmationQuery,
    CreditCardDeleteConfirmationQueryVariables
  >(CreditCardDeleteConfirmationQueryDocument, options);
}
// @ts-ignore
export function useCreditCardDeleteConfirmationQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CreditCardDeleteConfirmationQuery,
    CreditCardDeleteConfirmationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CreditCardDeleteConfirmationQuery,
  CreditCardDeleteConfirmationQueryVariables
>;
export function useCreditCardDeleteConfirmationQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreditCardDeleteConfirmationQuery,
        CreditCardDeleteConfirmationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CreditCardDeleteConfirmationQuery | undefined,
  CreditCardDeleteConfirmationQueryVariables
>;
export function useCreditCardDeleteConfirmationQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreditCardDeleteConfirmationQuery,
        CreditCardDeleteConfirmationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    CreditCardDeleteConfirmationQuery,
    CreditCardDeleteConfirmationQueryVariables
  >(CreditCardDeleteConfirmationQueryDocument, options);
}
export type CreditCardDeleteConfirmationQueryHookResult = ReturnType<
  typeof useCreditCardDeleteConfirmationQuery
>;
export type CreditCardDeleteConfirmationQueryLazyQueryHookResult = ReturnType<
  typeof useCreditCardDeleteConfirmationQueryLazyQuery
>;
export type CreditCardDeleteConfirmationQuerySuspenseQueryHookResult = ReturnType<
  typeof useCreditCardDeleteConfirmationQuerySuspenseQuery
>;
export type CreditCardDeleteConfirmationQueryQueryResult = Apollo.QueryResult<
  CreditCardDeleteConfirmationQuery,
  CreditCardDeleteConfirmationQueryVariables
>;
export const CreditCardEditDetailsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CreditCardEditDetailsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'braintreeClientToken'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'creditCard'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'id'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isDefaultCard'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCreditCardEditDetailsQuery__
 *
 * To run a query within a React component, call `useCreditCardEditDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditCardEditDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditCardEditDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreditCardEditDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreditCardEditDetailsQuery,
    CreditCardEditDetailsQueryVariables
  > &
    ({variables: CreditCardEditDetailsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CreditCardEditDetailsQuery, CreditCardEditDetailsQueryVariables>(
    CreditCardEditDetailsQueryDocument,
    options,
  );
}
export function useCreditCardEditDetailsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreditCardEditDetailsQuery,
    CreditCardEditDetailsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CreditCardEditDetailsQuery, CreditCardEditDetailsQueryVariables>(
    CreditCardEditDetailsQueryDocument,
    options,
  );
}
// @ts-ignore
export function useCreditCardEditDetailsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CreditCardEditDetailsQuery,
    CreditCardEditDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CreditCardEditDetailsQuery, CreditCardEditDetailsQueryVariables>;
export function useCreditCardEditDetailsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreditCardEditDetailsQuery,
        CreditCardEditDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CreditCardEditDetailsQuery | undefined,
  CreditCardEditDetailsQueryVariables
>;
export function useCreditCardEditDetailsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreditCardEditDetailsQuery,
        CreditCardEditDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CreditCardEditDetailsQuery, CreditCardEditDetailsQueryVariables>(
    CreditCardEditDetailsQueryDocument,
    options,
  );
}
export type CreditCardEditDetailsQueryHookResult = ReturnType<typeof useCreditCardEditDetailsQuery>;
export type CreditCardEditDetailsQueryLazyQueryHookResult = ReturnType<
  typeof useCreditCardEditDetailsQueryLazyQuery
>;
export type CreditCardEditDetailsQuerySuspenseQueryHookResult = ReturnType<
  typeof useCreditCardEditDetailsQuerySuspenseQuery
>;
export type CreditCardEditDetailsQueryQueryResult = Apollo.QueryResult<
  CreditCardEditDetailsQuery,
  CreditCardEditDetailsQueryVariables
>;
export const ShareCreditCardDetailsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ShareCreditCardDetails'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'creditCard'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'id'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSharedWithCorpAccount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'usersSharedWith'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'usersAvailableForSharing'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'limit'},
                                  value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'edges'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'node'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'fullName'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'departmentsSharedWith'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'departmentsAvailableForSharing'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'limit'},
                                  value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'edges'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'node'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useShareCreditCardDetailsQuery__
 *
 * To run a query within a React component, call `useShareCreditCardDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareCreditCardDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareCreditCardDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useShareCreditCardDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShareCreditCardDetailsQuery,
    ShareCreditCardDetailsQueryVariables
  > &
    ({variables: ShareCreditCardDetailsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ShareCreditCardDetailsQuery, ShareCreditCardDetailsQueryVariables>(
    ShareCreditCardDetailsDocument,
    options,
  );
}
export function useShareCreditCardDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShareCreditCardDetailsQuery,
    ShareCreditCardDetailsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ShareCreditCardDetailsQuery, ShareCreditCardDetailsQueryVariables>(
    ShareCreditCardDetailsDocument,
    options,
  );
}
// @ts-ignore
export function useShareCreditCardDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ShareCreditCardDetailsQuery,
    ShareCreditCardDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ShareCreditCardDetailsQuery, ShareCreditCardDetailsQueryVariables>;
export function useShareCreditCardDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShareCreditCardDetailsQuery,
        ShareCreditCardDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ShareCreditCardDetailsQuery | undefined,
  ShareCreditCardDetailsQueryVariables
>;
export function useShareCreditCardDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShareCreditCardDetailsQuery,
        ShareCreditCardDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ShareCreditCardDetailsQuery, ShareCreditCardDetailsQueryVariables>(
    ShareCreditCardDetailsDocument,
    options,
  );
}
export type ShareCreditCardDetailsQueryHookResult = ReturnType<
  typeof useShareCreditCardDetailsQuery
>;
export type ShareCreditCardDetailsLazyQueryHookResult = ReturnType<
  typeof useShareCreditCardDetailsLazyQuery
>;
export type ShareCreditCardDetailsSuspenseQueryHookResult = ReturnType<
  typeof useShareCreditCardDetailsSuspenseQuery
>;
export type ShareCreditCardDetailsQueryResult = Apollo.QueryResult<
  ShareCreditCardDetailsQuery,
  ShareCreditCardDetailsQueryVariables
>;
export const CuisinesCarouselQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'CuisinesCarouselQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchAddress'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cuisinesCarousel'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'address'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventDateTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'trackingId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'cards'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'cuisine'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'count'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'unfilteredCount'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCuisinesCarouselQuery__
 *
 * To run a query within a React component, call `useCuisinesCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useCuisinesCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCuisinesCarouselQuery({
 *   variables: {
 *      catererId: // value for 'catererId'
 *      address: // value for 'address'
 *      eventDateTime: // value for 'eventDateTime'
 *      trackingId: // value for 'trackingId'
 *   },
 * });
 */
export function useCuisinesCarouselQuery(
  baseOptions: Apollo.QueryHookOptions<CuisinesCarouselQuery, CuisinesCarouselQueryVariables> &
    ({variables: CuisinesCarouselQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<CuisinesCarouselQuery, CuisinesCarouselQueryVariables>(
    CuisinesCarouselQueryDocument,
    options,
  );
}
export function useCuisinesCarouselQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CuisinesCarouselQuery, CuisinesCarouselQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<CuisinesCarouselQuery, CuisinesCarouselQueryVariables>(
    CuisinesCarouselQueryDocument,
    options,
  );
}
// @ts-ignore
export function useCuisinesCarouselQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CuisinesCarouselQuery,
    CuisinesCarouselQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CuisinesCarouselQuery, CuisinesCarouselQueryVariables>;
export function useCuisinesCarouselQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CuisinesCarouselQuery, CuisinesCarouselQueryVariables>,
): Apollo.UseSuspenseQueryResult<CuisinesCarouselQuery | undefined, CuisinesCarouselQueryVariables>;
export function useCuisinesCarouselQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CuisinesCarouselQuery, CuisinesCarouselQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<CuisinesCarouselQuery, CuisinesCarouselQueryVariables>(
    CuisinesCarouselQueryDocument,
    options,
  );
}
export type CuisinesCarouselQueryHookResult = ReturnType<typeof useCuisinesCarouselQuery>;
export type CuisinesCarouselQueryLazyQueryHookResult = ReturnType<
  typeof useCuisinesCarouselQueryLazyQuery
>;
export type CuisinesCarouselQuerySuspenseQueryHookResult = ReturnType<
  typeof useCuisinesCarouselQuerySuspenseQuery
>;
export type CuisinesCarouselQueryQueryResult = Apollo.QueryResult<
  CuisinesCarouselQuery,
  CuisinesCarouselQueryVariables
>;
export const DeliveryFeeExperimentQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'DeliveryFeeExperimentQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'graphExperiments'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryFeeExperiment'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'v2'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'flagKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allocationKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'experimentKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'variation'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'pricingModel'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CappedDeliveryFeePricingModel'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cap'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'currency'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useDeliveryFeeExperimentQuery__
 *
 * To run a query within a React component, call `useDeliveryFeeExperimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryFeeExperimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryFeeExperimentQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeliveryFeeExperimentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DeliveryFeeExperimentQuery,
    DeliveryFeeExperimentQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<DeliveryFeeExperimentQuery, DeliveryFeeExperimentQueryVariables>(
    DeliveryFeeExperimentQueryDocument,
    options,
  );
}
export function useDeliveryFeeExperimentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeliveryFeeExperimentQuery,
    DeliveryFeeExperimentQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<DeliveryFeeExperimentQuery, DeliveryFeeExperimentQueryVariables>(
    DeliveryFeeExperimentQueryDocument,
    options,
  );
}
// @ts-ignore
export function useDeliveryFeeExperimentQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DeliveryFeeExperimentQuery,
    DeliveryFeeExperimentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DeliveryFeeExperimentQuery, DeliveryFeeExperimentQueryVariables>;
export function useDeliveryFeeExperimentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DeliveryFeeExperimentQuery,
        DeliveryFeeExperimentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DeliveryFeeExperimentQuery | undefined,
  DeliveryFeeExperimentQueryVariables
>;
export function useDeliveryFeeExperimentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DeliveryFeeExperimentQuery,
        DeliveryFeeExperimentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<DeliveryFeeExperimentQuery, DeliveryFeeExperimentQueryVariables>(
    DeliveryFeeExperimentQueryDocument,
    options,
  );
}
export type DeliveryFeeExperimentQueryHookResult = ReturnType<typeof useDeliveryFeeExperimentQuery>;
export type DeliveryFeeExperimentQueryLazyQueryHookResult = ReturnType<
  typeof useDeliveryFeeExperimentQueryLazyQuery
>;
export type DeliveryFeeExperimentQuerySuspenseQueryHookResult = ReturnType<
  typeof useDeliveryFeeExperimentQuerySuspenseQuery
>;
export type DeliveryFeeExperimentQueryQueryResult = Apollo.QueryResult<
  DeliveryFeeExperimentQuery,
  DeliveryFeeExperimentQueryVariables
>;
export const DirectConnectMessagesProviderQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'DirectConnectMessagesProviderQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderUuid'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'readByType'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ActorTypes'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'dcEventHistory'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderUuid'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'readByType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'readByType'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'events'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'at'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'reference'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'Message'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'content'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'sentByType'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'sentById'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'orderInfo'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'activeMessageThread'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                            ],
                                          },
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'brandName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'orderNumber'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'userUuid'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isPickup'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cpMayRequestChange'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'custMayStartMessage'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'request'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'orderInfo'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'brandName'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'eventAt'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'orderNumber'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'userUuid'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: {kind: 'Name', value: 'messageStatus'},
                                    name: {kind: 'Name', value: 'status'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'failedContentFilters'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'filterType'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'TimeChangeRequest'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'reason'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'workflowInstanceId'},
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'originalEventAt'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'proposedEventAt'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'orderUuid'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'requestedById'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'orderInfo'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'brandName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'eventTimeZone'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'orderNumber'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'userUuid'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isPickup'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cpMayRequestChange'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'custMayStartMessage'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'decisionPoints'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'responderType'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'responderUuid'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'response'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'completedAt'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'timeoutAt'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'OrderItemChangeRequest'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'workflowInstanceId'},
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'reason'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'orderInfo'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'brandName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'orderNumber'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'userUuid'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isPickup'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cpMayRequestChange'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'custMayStartMessage'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'itemChanges'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'changeType'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'decisionPoint'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'response'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'responderType'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'completedAt'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'timeoutAt'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'originalItemJson'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'proposedItemJson'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'reason'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'orderUuid'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'requestedById'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'lastReadEventIndices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'readAt'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'readByType'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useDirectConnectMessagesProviderQuery__
 *
 * To run a query within a React component, call `useDirectConnectMessagesProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectConnectMessagesProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectConnectMessagesProviderQuery({
 *   variables: {
 *      orderUuid: // value for 'orderUuid'
 *      readByType: // value for 'readByType'
 *   },
 * });
 */
export function useDirectConnectMessagesProviderQuery(
  baseOptions: Apollo.QueryHookOptions<
    DirectConnectMessagesProviderQuery,
    DirectConnectMessagesProviderQueryVariables
  > &
    ({variables: DirectConnectMessagesProviderQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    DirectConnectMessagesProviderQuery,
    DirectConnectMessagesProviderQueryVariables
  >(DirectConnectMessagesProviderQueryDocument, options);
}
export function useDirectConnectMessagesProviderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DirectConnectMessagesProviderQuery,
    DirectConnectMessagesProviderQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    DirectConnectMessagesProviderQuery,
    DirectConnectMessagesProviderQueryVariables
  >(DirectConnectMessagesProviderQueryDocument, options);
}
// @ts-ignore
export function useDirectConnectMessagesProviderQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DirectConnectMessagesProviderQuery,
    DirectConnectMessagesProviderQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DirectConnectMessagesProviderQuery,
  DirectConnectMessagesProviderQueryVariables
>;
export function useDirectConnectMessagesProviderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DirectConnectMessagesProviderQuery,
        DirectConnectMessagesProviderQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DirectConnectMessagesProviderQuery | undefined,
  DirectConnectMessagesProviderQueryVariables
>;
export function useDirectConnectMessagesProviderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DirectConnectMessagesProviderQuery,
        DirectConnectMessagesProviderQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    DirectConnectMessagesProviderQuery,
    DirectConnectMessagesProviderQueryVariables
  >(DirectConnectMessagesProviderQueryDocument, options);
}
export type DirectConnectMessagesProviderQueryHookResult = ReturnType<
  typeof useDirectConnectMessagesProviderQuery
>;
export type DirectConnectMessagesProviderQueryLazyQueryHookResult = ReturnType<
  typeof useDirectConnectMessagesProviderQueryLazyQuery
>;
export type DirectConnectMessagesProviderQuerySuspenseQueryHookResult = ReturnType<
  typeof useDirectConnectMessagesProviderQuerySuspenseQuery
>;
export type DirectConnectMessagesProviderQueryQueryResult = Apollo.QueryResult<
  DirectConnectMessagesProviderQuery,
  DirectConnectMessagesProviderQueryVariables
>;
export const DiscoveryRetargetingCardsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'DiscoveryRetargetingCardsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchAddress'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'OrderTypeEnum'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'catererRetargetingCards'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'address'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventDateTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                {kind: 'Field', name: {kind: 'Name', value: 'lastActivityAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'reorderFromOrderUuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'similarSearchUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'legacyId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'brandId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isSaved'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'image'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'desktopHeroUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'mobileSearchUrl'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useDiscoveryRetargetingCardsQuery__
 *
 * To run a query within a React component, call `useDiscoveryRetargetingCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoveryRetargetingCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoveryRetargetingCardsQuery({
 *   variables: {
 *      address: // value for 'address'
 *      eventDateTime: // value for 'eventDateTime'
 *      orderType: // value for 'orderType'
 *   },
 * });
 */
export function useDiscoveryRetargetingCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DiscoveryRetargetingCardsQuery,
    DiscoveryRetargetingCardsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<DiscoveryRetargetingCardsQuery, DiscoveryRetargetingCardsQueryVariables>(
    DiscoveryRetargetingCardsQueryDocument,
    options,
  );
}
export function useDiscoveryRetargetingCardsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscoveryRetargetingCardsQuery,
    DiscoveryRetargetingCardsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    DiscoveryRetargetingCardsQuery,
    DiscoveryRetargetingCardsQueryVariables
  >(DiscoveryRetargetingCardsQueryDocument, options);
}
// @ts-ignore
export function useDiscoveryRetargetingCardsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DiscoveryRetargetingCardsQuery,
    DiscoveryRetargetingCardsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DiscoveryRetargetingCardsQuery,
  DiscoveryRetargetingCardsQueryVariables
>;
export function useDiscoveryRetargetingCardsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DiscoveryRetargetingCardsQuery,
        DiscoveryRetargetingCardsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DiscoveryRetargetingCardsQuery | undefined,
  DiscoveryRetargetingCardsQueryVariables
>;
export function useDiscoveryRetargetingCardsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DiscoveryRetargetingCardsQuery,
        DiscoveryRetargetingCardsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    DiscoveryRetargetingCardsQuery,
    DiscoveryRetargetingCardsQueryVariables
  >(DiscoveryRetargetingCardsQueryDocument, options);
}
export type DiscoveryRetargetingCardsQueryHookResult = ReturnType<
  typeof useDiscoveryRetargetingCardsQuery
>;
export type DiscoveryRetargetingCardsQueryLazyQueryHookResult = ReturnType<
  typeof useDiscoveryRetargetingCardsQueryLazyQuery
>;
export type DiscoveryRetargetingCardsQuerySuspenseQueryHookResult = ReturnType<
  typeof useDiscoveryRetargetingCardsQuerySuspenseQuery
>;
export type DiscoveryRetargetingCardsQueryQueryResult = Apollo.QueryResult<
  DiscoveryRetargetingCardsQuery,
  DiscoveryRetargetingCardsQueryVariables
>;
export const EaterConfirmationPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'EaterConfirmationPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCart'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currentUserIsOwner'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'authorizedUsers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'total'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetail'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'items'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'menuItemPreview'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'imageUrl'}}],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'shopper'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'total'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEaterConfirmationPageQuery__
 *
 * To run a query within a React component, call `useEaterConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEaterConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEaterConfirmationPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEaterConfirmationPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    EaterConfirmationPageQuery,
    EaterConfirmationPageQueryVariables
  > &
    ({variables: EaterConfirmationPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<EaterConfirmationPageQuery, EaterConfirmationPageQueryVariables>(
    EaterConfirmationPageQueryDocument,
    options,
  );
}
export function useEaterConfirmationPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EaterConfirmationPageQuery,
    EaterConfirmationPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<EaterConfirmationPageQuery, EaterConfirmationPageQueryVariables>(
    EaterConfirmationPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useEaterConfirmationPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EaterConfirmationPageQuery,
    EaterConfirmationPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EaterConfirmationPageQuery, EaterConfirmationPageQueryVariables>;
export function useEaterConfirmationPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EaterConfirmationPageQuery,
        EaterConfirmationPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EaterConfirmationPageQuery | undefined,
  EaterConfirmationPageQueryVariables
>;
export function useEaterConfirmationPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EaterConfirmationPageQuery,
        EaterConfirmationPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<EaterConfirmationPageQuery, EaterConfirmationPageQueryVariables>(
    EaterConfirmationPageQueryDocument,
    options,
  );
}
export type EaterConfirmationPageQueryHookResult = ReturnType<typeof useEaterConfirmationPageQuery>;
export type EaterConfirmationPageQueryLazyQueryHookResult = ReturnType<
  typeof useEaterConfirmationPageQueryLazyQuery
>;
export type EaterConfirmationPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useEaterConfirmationPageQuerySuspenseQuery
>;
export type EaterConfirmationPageQueryQueryResult = Apollo.QueryResult<
  EaterConfirmationPageQuery,
  EaterConfirmationPageQueryVariables
>;
export const EditAddressPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'EditAddressPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'addressBookEntryId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'addressBookEntryId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'addressBookEntryId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'addressBookEntryId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'addressBookEntry'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'corporate'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEditAddressPageQuery__
 *
 * To run a query within a React component, call `useEditAddressPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAddressPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAddressPageQuery({
 *   variables: {
 *      addressBookEntryId: // value for 'addressBookEntryId'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useEditAddressPageQuery(
  baseOptions: Apollo.QueryHookOptions<EditAddressPageQuery, EditAddressPageQueryVariables> &
    ({variables: EditAddressPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<EditAddressPageQuery, EditAddressPageQueryVariables>(
    EditAddressPageQueryDocument,
    options,
  );
}
export function useEditAddressPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EditAddressPageQuery, EditAddressPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<EditAddressPageQuery, EditAddressPageQueryVariables>(
    EditAddressPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useEditAddressPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EditAddressPageQuery,
    EditAddressPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EditAddressPageQuery, EditAddressPageQueryVariables>;
export function useEditAddressPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EditAddressPageQuery, EditAddressPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<EditAddressPageQuery | undefined, EditAddressPageQueryVariables>;
export function useEditAddressPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EditAddressPageQuery, EditAddressPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<EditAddressPageQuery, EditAddressPageQueryVariables>(
    EditAddressPageQueryDocument,
    options,
  );
}
export type EditAddressPageQueryHookResult = ReturnType<typeof useEditAddressPageQuery>;
export type EditAddressPageQueryLazyQueryHookResult = ReturnType<
  typeof useEditAddressPageQueryLazyQuery
>;
export type EditAddressPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useEditAddressPageQuerySuspenseQuery
>;
export type EditAddressPageQueryQueryResult = Apollo.QueryResult<
  EditAddressPageQuery,
  EditAddressPageQueryVariables
>;
export const EventBarSearchHistoryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'EventBarSearchHistory'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetails'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'first'},
                      value: {kind: 'IntValue', value: '10'},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filters'},
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: {kind: 'Name', value: 'onlyGeocodedAddresses'},
                            value: {kind: 'BooleanValue', value: true},
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'edges'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'node'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'address'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'timeZoneIdentifier'},
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventBarSearchHistoryQuery__
 *
 * To run a query within a React component, call `useEventBarSearchHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventBarSearchHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventBarSearchHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventBarSearchHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EventBarSearchHistoryQuery,
    EventBarSearchHistoryQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<EventBarSearchHistoryQuery, EventBarSearchHistoryQueryVariables>(
    EventBarSearchHistoryDocument,
    options,
  );
}
export function useEventBarSearchHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EventBarSearchHistoryQuery,
    EventBarSearchHistoryQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<EventBarSearchHistoryQuery, EventBarSearchHistoryQueryVariables>(
    EventBarSearchHistoryDocument,
    options,
  );
}
// @ts-ignore
export function useEventBarSearchHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EventBarSearchHistoryQuery,
    EventBarSearchHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EventBarSearchHistoryQuery, EventBarSearchHistoryQueryVariables>;
export function useEventBarSearchHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventBarSearchHistoryQuery,
        EventBarSearchHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EventBarSearchHistoryQuery | undefined,
  EventBarSearchHistoryQueryVariables
>;
export function useEventBarSearchHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EventBarSearchHistoryQuery,
        EventBarSearchHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<EventBarSearchHistoryQuery, EventBarSearchHistoryQueryVariables>(
    EventBarSearchHistoryDocument,
    options,
  );
}
export type EventBarSearchHistoryQueryHookResult = ReturnType<typeof useEventBarSearchHistoryQuery>;
export type EventBarSearchHistoryLazyQueryHookResult = ReturnType<
  typeof useEventBarSearchHistoryLazyQuery
>;
export type EventBarSearchHistorySuspenseQueryHookResult = ReturnType<
  typeof useEventBarSearchHistorySuspenseQuery
>;
export type EventBarSearchHistoryQueryResult = Apollo.QueryResult<
  EventBarSearchHistoryQuery,
  EventBarSearchHistoryQueryVariables
>;
export const ExpenseReportingPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ExpenseReportingPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useExpenseReportingPageQuery__
 *
 * To run a query within a React component, call `useExpenseReportingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseReportingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseReportingPageQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useExpenseReportingPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExpenseReportingPageQuery,
    ExpenseReportingPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ExpenseReportingPageQuery, ExpenseReportingPageQueryVariables>(
    ExpenseReportingPageQueryDocument,
    options,
  );
}
export function useExpenseReportingPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExpenseReportingPageQuery,
    ExpenseReportingPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ExpenseReportingPageQuery, ExpenseReportingPageQueryVariables>(
    ExpenseReportingPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useExpenseReportingPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExpenseReportingPageQuery,
    ExpenseReportingPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExpenseReportingPageQuery, ExpenseReportingPageQueryVariables>;
export function useExpenseReportingPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExpenseReportingPageQuery,
        ExpenseReportingPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExpenseReportingPageQuery | undefined,
  ExpenseReportingPageQueryVariables
>;
export function useExpenseReportingPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExpenseReportingPageQuery,
        ExpenseReportingPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ExpenseReportingPageQuery, ExpenseReportingPageQueryVariables>(
    ExpenseReportingPageQueryDocument,
    options,
  );
}
export type ExpenseReportingPageQueryHookResult = ReturnType<typeof useExpenseReportingPageQuery>;
export type ExpenseReportingPageQueryLazyQueryHookResult = ReturnType<
  typeof useExpenseReportingPageQueryLazyQuery
>;
export type ExpenseReportingPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useExpenseReportingPageQuerySuspenseQuery
>;
export type ExpenseReportingPageQueryQueryResult = Apollo.QueryResult<
  ExpenseReportingPageQuery,
  ExpenseReportingPageQueryVariables
>;
export const EzRewardsActivityQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'EzRewardsActivityQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'activities'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'offset'},
                                  value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                                },
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'limit'},
                                  value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'nodes'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'occurredAt'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'note'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'category'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'caterer'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'brand'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'id'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'uuid'},
                                                    },
                                                  ],
                                                },
                                              },
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isSavedCaterer'},
                                              },
                                              {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'order'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'caterer'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'id'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'urlId'},
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'event'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'id'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'isTakeout'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'orderType'},
                                                      arguments: [
                                                        {
                                                          kind: 'Argument',
                                                          name: {
                                                            kind: 'Name',
                                                            value: 'perspective',
                                                          },
                                                          value: {
                                                            kind: 'EnumValue',
                                                            value: 'CUSTOMER',
                                                          },
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'timestamp'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'timeZoneOffset'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'address'},
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'id'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'name'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'city'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'street'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'street2'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'state'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'zip'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'deliveryInstructions',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'driverAskFor',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'latitude'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'longitude',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEzRewardsActivityQuery__
 *
 * To run a query within a React component, call `useEzRewardsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEzRewardsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEzRewardsActivityQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useEzRewardsActivityQuery(
  baseOptions?: Apollo.QueryHookOptions<EzRewardsActivityQuery, EzRewardsActivityQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<EzRewardsActivityQuery, EzRewardsActivityQueryVariables>(
    EzRewardsActivityQueryDocument,
    options,
  );
}
export function useEzRewardsActivityQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EzRewardsActivityQuery,
    EzRewardsActivityQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<EzRewardsActivityQuery, EzRewardsActivityQueryVariables>(
    EzRewardsActivityQueryDocument,
    options,
  );
}
// @ts-ignore
export function useEzRewardsActivityQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EzRewardsActivityQuery,
    EzRewardsActivityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EzRewardsActivityQuery, EzRewardsActivityQueryVariables>;
export function useEzRewardsActivityQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EzRewardsActivityQuery, EzRewardsActivityQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  EzRewardsActivityQuery | undefined,
  EzRewardsActivityQueryVariables
>;
export function useEzRewardsActivityQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EzRewardsActivityQuery, EzRewardsActivityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<EzRewardsActivityQuery, EzRewardsActivityQueryVariables>(
    EzRewardsActivityQueryDocument,
    options,
  );
}
export type EzRewardsActivityQueryHookResult = ReturnType<typeof useEzRewardsActivityQuery>;
export type EzRewardsActivityQueryLazyQueryHookResult = ReturnType<
  typeof useEzRewardsActivityQueryLazyQuery
>;
export type EzRewardsActivityQuerySuspenseQueryHookResult = ReturnType<
  typeof useEzRewardsActivityQuerySuspenseQuery
>;
export type EzRewardsActivityQueryQueryResult = Apollo.QueryResult<
  EzRewardsActivityQuery,
  EzRewardsActivityQueryVariables
>;
export const EzRewardsPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'EzRewardsPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'constants'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'ezRewards'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'largestOutstandingUserBalance'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'minimumPointsForGiftCardRedemption'},
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'giftCardRedemptionAllowed'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'isReviewPending'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEzRewardsPageQuery__
 *
 * To run a query within a React component, call `useEzRewardsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEzRewardsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEzRewardsPageQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useEzRewardsPageQuery(
  baseOptions?: Apollo.QueryHookOptions<EzRewardsPageQuery, EzRewardsPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<EzRewardsPageQuery, EzRewardsPageQueryVariables>(
    EzRewardsPageQueryDocument,
    options,
  );
}
export function useEzRewardsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EzRewardsPageQuery, EzRewardsPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<EzRewardsPageQuery, EzRewardsPageQueryVariables>(
    EzRewardsPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useEzRewardsPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<EzRewardsPageQuery, EzRewardsPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<EzRewardsPageQuery, EzRewardsPageQueryVariables>;
export function useEzRewardsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EzRewardsPageQuery, EzRewardsPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<EzRewardsPageQuery | undefined, EzRewardsPageQueryVariables>;
export function useEzRewardsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EzRewardsPageQuery, EzRewardsPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<EzRewardsPageQuery, EzRewardsPageQueryVariables>(
    EzRewardsPageQueryDocument,
    options,
  );
}
export type EzRewardsPageQueryHookResult = ReturnType<typeof useEzRewardsPageQuery>;
export type EzRewardsPageQueryLazyQueryHookResult = ReturnType<
  typeof useEzRewardsPageQueryLazyQuery
>;
export type EzRewardsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useEzRewardsPageQuerySuspenseQuery
>;
export type EzRewardsPageQueryQueryResult = Apollo.QueryResult<
  EzRewardsPageQuery,
  EzRewardsPageQueryVariables
>;
export const ForceEmailUpdateEligibilityQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ForceEmailUpdateEligibilityQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mustForceEmailUpdate'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useForceEmailUpdateEligibilityQuery__
 *
 * To run a query within a React component, call `useForceEmailUpdateEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useForceEmailUpdateEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForceEmailUpdateEligibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useForceEmailUpdateEligibilityQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ForceEmailUpdateEligibilityQuery,
    ForceEmailUpdateEligibilityQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    ForceEmailUpdateEligibilityQuery,
    ForceEmailUpdateEligibilityQueryVariables
  >(ForceEmailUpdateEligibilityQueryDocument, options);
}
export function useForceEmailUpdateEligibilityQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ForceEmailUpdateEligibilityQuery,
    ForceEmailUpdateEligibilityQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    ForceEmailUpdateEligibilityQuery,
    ForceEmailUpdateEligibilityQueryVariables
  >(ForceEmailUpdateEligibilityQueryDocument, options);
}
// @ts-ignore
export function useForceEmailUpdateEligibilityQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ForceEmailUpdateEligibilityQuery,
    ForceEmailUpdateEligibilityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ForceEmailUpdateEligibilityQuery,
  ForceEmailUpdateEligibilityQueryVariables
>;
export function useForceEmailUpdateEligibilityQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ForceEmailUpdateEligibilityQuery,
        ForceEmailUpdateEligibilityQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ForceEmailUpdateEligibilityQuery | undefined,
  ForceEmailUpdateEligibilityQueryVariables
>;
export function useForceEmailUpdateEligibilityQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ForceEmailUpdateEligibilityQuery,
        ForceEmailUpdateEligibilityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    ForceEmailUpdateEligibilityQuery,
    ForceEmailUpdateEligibilityQueryVariables
  >(ForceEmailUpdateEligibilityQueryDocument, options);
}
export type ForceEmailUpdateEligibilityQueryHookResult = ReturnType<
  typeof useForceEmailUpdateEligibilityQuery
>;
export type ForceEmailUpdateEligibilityQueryLazyQueryHookResult = ReturnType<
  typeof useForceEmailUpdateEligibilityQueryLazyQuery
>;
export type ForceEmailUpdateEligibilityQuerySuspenseQueryHookResult = ReturnType<
  typeof useForceEmailUpdateEligibilityQuerySuspenseQuery
>;
export type ForceEmailUpdateEligibilityQueryQueryResult = Apollo.QueryResult<
  ForceEmailUpdateEligibilityQuery,
  ForceEmailUpdateEligibilityQueryVariables
>;
export const ForceEmailUpdatePageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ForceEmailUpdatePageQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ForceEmailUpdateFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ForceEmailUpdateFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isCurrentDeviceRecognized'}},
          {kind: 'Field', name: {kind: 'Name', value: 'mobilePhoneLastTwo'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useForceEmailUpdatePageQuery__
 *
 * To run a query within a React component, call `useForceEmailUpdatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useForceEmailUpdatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForceEmailUpdatePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useForceEmailUpdatePageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ForceEmailUpdatePageQuery,
    ForceEmailUpdatePageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ForceEmailUpdatePageQuery, ForceEmailUpdatePageQueryVariables>(
    ForceEmailUpdatePageQueryDocument,
    options,
  );
}
export function useForceEmailUpdatePageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ForceEmailUpdatePageQuery,
    ForceEmailUpdatePageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ForceEmailUpdatePageQuery, ForceEmailUpdatePageQueryVariables>(
    ForceEmailUpdatePageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useForceEmailUpdatePageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ForceEmailUpdatePageQuery,
    ForceEmailUpdatePageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ForceEmailUpdatePageQuery, ForceEmailUpdatePageQueryVariables>;
export function useForceEmailUpdatePageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ForceEmailUpdatePageQuery,
        ForceEmailUpdatePageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ForceEmailUpdatePageQuery | undefined,
  ForceEmailUpdatePageQueryVariables
>;
export function useForceEmailUpdatePageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ForceEmailUpdatePageQuery,
        ForceEmailUpdatePageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ForceEmailUpdatePageQuery, ForceEmailUpdatePageQueryVariables>(
    ForceEmailUpdatePageQueryDocument,
    options,
  );
}
export type ForceEmailUpdatePageQueryHookResult = ReturnType<typeof useForceEmailUpdatePageQuery>;
export type ForceEmailUpdatePageQueryLazyQueryHookResult = ReturnType<
  typeof useForceEmailUpdatePageQueryLazyQuery
>;
export type ForceEmailUpdatePageQuerySuspenseQueryHookResult = ReturnType<
  typeof useForceEmailUpdatePageQuerySuspenseQuery
>;
export type ForceEmailUpdatePageQueryQueryResult = Apollo.QueryResult<
  ForceEmailUpdatePageQuery,
  ForceEmailUpdatePageQueryVariables
>;
export const GeocodeAddressQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'GeocodeAddressQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'addressString'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'geocodedAddress'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'addressString'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'addressString'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGeocodeAddressQuery__
 *
 * To run a query within a React component, call `useGeocodeAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeocodeAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeocodeAddressQuery({
 *   variables: {
 *      addressString: // value for 'addressString'
 *   },
 * });
 */
export function useGeocodeAddressQuery(
  baseOptions: Apollo.QueryHookOptions<GeocodeAddressQuery, GeocodeAddressQueryVariables> &
    ({variables: GeocodeAddressQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<GeocodeAddressQuery, GeocodeAddressQueryVariables>(
    GeocodeAddressQueryDocument,
    options,
  );
}
export function useGeocodeAddressQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GeocodeAddressQuery, GeocodeAddressQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<GeocodeAddressQuery, GeocodeAddressQueryVariables>(
    GeocodeAddressQueryDocument,
    options,
  );
}
// @ts-ignore
export function useGeocodeAddressQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GeocodeAddressQuery, GeocodeAddressQueryVariables>,
): Apollo.UseSuspenseQueryResult<GeocodeAddressQuery, GeocodeAddressQueryVariables>;
export function useGeocodeAddressQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GeocodeAddressQuery, GeocodeAddressQueryVariables>,
): Apollo.UseSuspenseQueryResult<GeocodeAddressQuery | undefined, GeocodeAddressQueryVariables>;
export function useGeocodeAddressQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GeocodeAddressQuery, GeocodeAddressQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<GeocodeAddressQuery, GeocodeAddressQueryVariables>(
    GeocodeAddressQueryDocument,
    options,
  );
}
export type GeocodeAddressQueryHookResult = ReturnType<typeof useGeocodeAddressQuery>;
export type GeocodeAddressQueryLazyQueryHookResult = ReturnType<
  typeof useGeocodeAddressQueryLazyQuery
>;
export type GeocodeAddressQuerySuspenseQueryHookResult = ReturnType<
  typeof useGeocodeAddressQuerySuspenseQuery
>;
export type GeocodeAddressQueryQueryResult = Apollo.QueryResult<
  GeocodeAddressQuery,
  GeocodeAddressQueryVariables
>;
export const GeocodeCoordinatesQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'GeocodeCoordinatesQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'latitude'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Float'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'longitude'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Float'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'geocodedCoordinates'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'latitude'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'latitude'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'longitude'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'longitude'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGeocodeCoordinatesQuery__
 *
 * To run a query within a React component, call `useGeocodeCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeocodeCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeocodeCoordinatesQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useGeocodeCoordinatesQuery(
  baseOptions: Apollo.QueryHookOptions<GeocodeCoordinatesQuery, GeocodeCoordinatesQueryVariables> &
    ({variables: GeocodeCoordinatesQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<GeocodeCoordinatesQuery, GeocodeCoordinatesQueryVariables>(
    GeocodeCoordinatesQueryDocument,
    options,
  );
}
export function useGeocodeCoordinatesQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GeocodeCoordinatesQuery,
    GeocodeCoordinatesQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<GeocodeCoordinatesQuery, GeocodeCoordinatesQueryVariables>(
    GeocodeCoordinatesQueryDocument,
    options,
  );
}
// @ts-ignore
export function useGeocodeCoordinatesQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GeocodeCoordinatesQuery,
    GeocodeCoordinatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GeocodeCoordinatesQuery, GeocodeCoordinatesQueryVariables>;
export function useGeocodeCoordinatesQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GeocodeCoordinatesQuery, GeocodeCoordinatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GeocodeCoordinatesQuery | undefined,
  GeocodeCoordinatesQueryVariables
>;
export function useGeocodeCoordinatesQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GeocodeCoordinatesQuery, GeocodeCoordinatesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<GeocodeCoordinatesQuery, GeocodeCoordinatesQueryVariables>(
    GeocodeCoordinatesQueryDocument,
    options,
  );
}
export type GeocodeCoordinatesQueryHookResult = ReturnType<typeof useGeocodeCoordinatesQuery>;
export type GeocodeCoordinatesQueryLazyQueryHookResult = ReturnType<
  typeof useGeocodeCoordinatesQueryLazyQuery
>;
export type GeocodeCoordinatesQuerySuspenseQueryHookResult = ReturnType<
  typeof useGeocodeCoordinatesQuerySuspenseQuery
>;
export type GeocodeCoordinatesQueryQueryResult = Apollo.QueryResult<
  GeocodeCoordinatesQuery,
  GeocodeCoordinatesQueryVariables
>;
export const HomeAccountQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'HomeAccountQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'constants'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConstantsFragment'},
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConsumerAccountFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'HomeBannersConsumerAccountFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'InvalidEmailBannerFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'showInvalidEmailBanner'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ResendVerificationEmailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'needsCorporateEmailVerification'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConstantsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Constants'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minimumPointsForGiftCardRedemption'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConsumerAccountFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'giftCardRedemptionAllowed'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewardsAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                {
                  kind: 'Field',
                  alias: {kind: 'Name', value: 'giftCardRedemptions'},
                  name: {kind: 'Name', value: 'activities'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'categories'},
                      value: {kind: 'EnumValue', value: 'USED_ON_GIFT_CARD'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'HomeBannersConsumerAccountFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'InvalidEmailBannerFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ResendVerificationEmailFragment'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHomeAccountQuery__
 *
 * To run a query within a React component, call `useHomeAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeAccountQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useHomeAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<HomeAccountQuery, HomeAccountQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<HomeAccountQuery, HomeAccountQueryVariables>(
    HomeAccountQueryDocument,
    options,
  );
}
export function useHomeAccountQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HomeAccountQuery, HomeAccountQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<HomeAccountQuery, HomeAccountQueryVariables>(
    HomeAccountQueryDocument,
    options,
  );
}
// @ts-ignore
export function useHomeAccountQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<HomeAccountQuery, HomeAccountQueryVariables>,
): Apollo.UseSuspenseQueryResult<HomeAccountQuery, HomeAccountQueryVariables>;
export function useHomeAccountQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeAccountQuery, HomeAccountQueryVariables>,
): Apollo.UseSuspenseQueryResult<HomeAccountQuery | undefined, HomeAccountQueryVariables>;
export function useHomeAccountQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeAccountQuery, HomeAccountQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<HomeAccountQuery, HomeAccountQueryVariables>(
    HomeAccountQueryDocument,
    options,
  );
}
export type HomeAccountQueryHookResult = ReturnType<typeof useHomeAccountQuery>;
export type HomeAccountQueryLazyQueryHookResult = ReturnType<typeof useHomeAccountQueryLazyQuery>;
export type HomeAccountQuerySuspenseQueryHookResult = ReturnType<
  typeof useHomeAccountQuerySuspenseQuery
>;
export type HomeAccountQueryQueryResult = Apollo.QueryResult<
  HomeAccountQuery,
  HomeAccountQueryVariables
>;
export const HomePageDataQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'HomePageDataQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetails'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'first'},
                      value: {kind: 'IntValue', value: '10'},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filters'},
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: {kind: 'Name', value: 'onlyGeocodedAddresses'},
                            value: {kind: 'BooleanValue', value: true},
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'edges'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'node'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'address'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'constants'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConstantsFragment'},
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'daysSinceFirstMarketplaceOrder'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'openCorpInvites'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateAccount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConsumerAccountFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'HomeBannersConsumerAccountFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'InvalidEmailBannerFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'showInvalidEmailBanner'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ResendVerificationEmailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'needsCorporateEmailVerification'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConstantsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Constants'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minimumPointsForGiftCardRedemption'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConsumerAccountFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'giftCardRedemptionAllowed'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewardsAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                {
                  kind: 'Field',
                  alias: {kind: 'Name', value: 'giftCardRedemptions'},
                  name: {kind: 'Name', value: 'activities'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'categories'},
                      value: {kind: 'EnumValue', value: 'USED_ON_GIFT_CARD'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'HomeBannersConsumerAccountFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'InvalidEmailBannerFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ResendVerificationEmailFragment'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHomePageDataQuery__
 *
 * To run a query within a React component, call `useHomePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageDataQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useHomePageDataQuery(
  baseOptions?: Apollo.QueryHookOptions<HomePageDataQuery, HomePageDataQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<HomePageDataQuery, HomePageDataQueryVariables>(
    HomePageDataQueryDocument,
    options,
  );
}
export function useHomePageDataQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HomePageDataQuery, HomePageDataQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<HomePageDataQuery, HomePageDataQueryVariables>(
    HomePageDataQueryDocument,
    options,
  );
}
// @ts-ignore
export function useHomePageDataQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<HomePageDataQuery, HomePageDataQueryVariables>,
): Apollo.UseSuspenseQueryResult<HomePageDataQuery, HomePageDataQueryVariables>;
export function useHomePageDataQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HomePageDataQuery, HomePageDataQueryVariables>,
): Apollo.UseSuspenseQueryResult<HomePageDataQuery | undefined, HomePageDataQueryVariables>;
export function useHomePageDataQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HomePageDataQuery, HomePageDataQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<HomePageDataQuery, HomePageDataQueryVariables>(
    HomePageDataQueryDocument,
    options,
  );
}
export type HomePageDataQueryHookResult = ReturnType<typeof useHomePageDataQuery>;
export type HomePageDataQueryLazyQueryHookResult = ReturnType<typeof useHomePageDataQueryLazyQuery>;
export type HomePageDataQuerySuspenseQueryHookResult = ReturnType<
  typeof useHomePageDataQuerySuspenseQuery
>;
export type HomePageDataQueryQueryResult = Apollo.QueryResult<
  HomePageDataQuery,
  HomePageDataQueryVariables
>;
export const HomePageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'HomePageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'after'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'before'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'first'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'last'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'includeUserFulfillmentDetails'},
          },
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'fulfillmentDetailFilters'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetailFilterInput'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'constants'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConstantsFragment'},
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasFourPlusStarReview'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'openCorpInvites'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateAccount'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerHasSubmittedOrderFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'FirstOrderDetailsFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConsumerAccountFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'RecentAddressesFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'InvalidEmailBannerFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ResendVerificationEmailFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'UpcomingOrdersFragment'},
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'RecommendedOrdersRecentAddressesFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'savedCaterers'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'after'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'after'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'first'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'first'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'before'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'before'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'last'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'last'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'SavedCatererFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            directives: [
              {
                kind: 'Directive',
                name: {kind: 'Name', value: 'include'},
                arguments: [
                  {
                    kind: 'Argument',
                    name: {kind: 'Name', value: 'if'},
                    value: {
                      kind: 'Variable',
                      name: {kind: 'Name', value: 'includeUserFulfillmentDetails'},
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetails'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filters'},
                      value: {
                        kind: 'Variable',
                        name: {kind: 'Name', value: 'fulfillmentDetailFilters'},
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'edges'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'node'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UpcomingOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'estimatedHeadcount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConstantsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Constants'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'minimumPointsForGiftCardRedemption'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerHasSubmittedOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'submittedOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'SUBMITTED'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '1'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FirstOrderDetailsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'firstOrderDetails'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'submittedFeedback'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'order'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'caterer'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'GetMoreOutOfEzCaterConsumerAccountFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'giftCardRedemptionAllowed'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ezRewardsAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                {
                  kind: 'Field',
                  alias: {kind: 'Name', value: 'giftCardRedemptions'},
                  name: {kind: 'Name', value: 'activities'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'categories'},
                      value: {kind: 'EnumValue', value: 'USED_ON_GIFT_CARD'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'RecentAddressesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'recentAddresses'},
            name: {kind: 'Name', value: 'addresses'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '4'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortBy'},
                value: {kind: 'EnumValue', value: 'UPDATED_AT'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortDirection'},
                value: {kind: 'EnumValue', value: 'DESC'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'addressBookEntryId'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'InvalidEmailBannerFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'showInvalidEmailBanner'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ResendVerificationEmailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'needsCorporateEmailVerification'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'UpcomingOrdersFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'upcomingOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'UPCOMING_AND_DRAFTS'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventAfter'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '10'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'UpcomingOrderFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'draftOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'DRAFT'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '100'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
            },
          },
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'receiptOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'RECEIPT'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '100'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'RecommendedOrdersRecentAddressesFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'recentAddressesByLastUsed'},
            name: {kind: 'Name', value: 'addresses'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'IntValue', value: '1'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortBy'},
                value: {kind: 'EnumValue', value: 'LAST_USED_AT'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'sortDirection'},
                value: {kind: 'EnumValue', value: 'DESC'},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SavedCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isNew'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'heroImage'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobileSearchUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'graphExperiments'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryFeeExperiment'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'v2'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'flagKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allocationKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'experimentKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'variation'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'pricingModel'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CappedDeliveryFeePricingModel'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cap'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'currency'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHomePageQuery__
 *
 * To run a query within a React component, call `useHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      eventAfter: // value for 'eventAfter'
 *      includeUserFulfillmentDetails: // value for 'includeUserFulfillmentDetails'
 *      fulfillmentDetailFilters: // value for 'fulfillmentDetailFilters'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useHomePageQuery(
  baseOptions?: Apollo.QueryHookOptions<HomePageQuery, HomePageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<HomePageQuery, HomePageQueryVariables>(HomePageQueryDocument, options);
}
export function useHomePageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HomePageQuery, HomePageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<HomePageQuery, HomePageQueryVariables>(HomePageQueryDocument, options);
}
// @ts-ignore
export function useHomePageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<HomePageQuery, HomePageQueryVariables>,
): Apollo.UseSuspenseQueryResult<HomePageQuery, HomePageQueryVariables>;
export function useHomePageQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomePageQuery, HomePageQueryVariables>,
): Apollo.UseSuspenseQueryResult<HomePageQuery | undefined, HomePageQueryVariables>;
export function useHomePageQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomePageQuery, HomePageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<HomePageQuery, HomePageQueryVariables>(
    HomePageQueryDocument,
    options,
  );
}
export type HomePageQueryHookResult = ReturnType<typeof useHomePageQuery>;
export type HomePageQueryLazyQueryHookResult = ReturnType<typeof useHomePageQueryLazyQuery>;
export type HomePageQuerySuspenseQueryHookResult = ReturnType<typeof useHomePageQuerySuspenseQuery>;
export type HomePageQueryQueryResult = Apollo.QueryResult<HomePageQuery, HomePageQueryVariables>;
export const IdentityQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'IdentityQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useIdentityQuery__
 *
 * To run a query within a React component, call `useIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useIdentityQuery(
  baseOptions?: Apollo.QueryHookOptions<IdentityQuery, IdentityQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<IdentityQuery, IdentityQueryVariables>(IdentityQueryDocument, options);
}
export function useIdentityQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IdentityQuery, IdentityQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<IdentityQuery, IdentityQueryVariables>(IdentityQueryDocument, options);
}
// @ts-ignore
export function useIdentityQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IdentityQuery, IdentityQueryVariables>,
): Apollo.UseSuspenseQueryResult<IdentityQuery, IdentityQueryVariables>;
export function useIdentityQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityQuery, IdentityQueryVariables>,
): Apollo.UseSuspenseQueryResult<IdentityQuery | undefined, IdentityQueryVariables>;
export function useIdentityQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityQuery, IdentityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<IdentityQuery, IdentityQueryVariables>(
    IdentityQueryDocument,
    options,
  );
}
export type IdentityQueryHookResult = ReturnType<typeof useIdentityQuery>;
export type IdentityQueryLazyQueryHookResult = ReturnType<typeof useIdentityQueryLazyQuery>;
export type IdentityQuerySuspenseQueryHookResult = ReturnType<typeof useIdentityQuerySuspenseQuery>;
export type IdentityQueryQueryResult = Apollo.QueryResult<IdentityQuery, IdentityQueryVariables>;
export const ItemQuantityRulesQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ItemQuantityRulesQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'urlId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Date'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeMenuevoMenu'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoDate'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ISO8601Date'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'urlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'urlId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderingMenu'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'channel'},
                      value: {kind: 'EnumValue', value: 'MARKETPLACE'},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'date'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'categories'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'allItems'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'sizes'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'quantityRules'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'label'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'singular'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'plural'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'minimumQuantity'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'quantities'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'menuevoMenu'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'channel'},
                      value: {kind: 'EnumValue', value: 'MARKETPLACE'},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'date'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoDate'}},
                    },
                  ],
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'include'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {
                            kind: 'Variable',
                            name: {kind: 'Name', value: 'includeMenuevoMenu'},
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'categories'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'items'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'quantityRules'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'increment'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'min'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'unit'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useItemQuantityRulesQuery__
 *
 * To run a query within a React component, call `useItemQuantityRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemQuantityRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemQuantityRulesQuery({
 *   variables: {
 *      urlId: // value for 'urlId'
 *      date: // value for 'date'
 *      includeMenuevoMenu: // value for 'includeMenuevoMenu'
 *      menuevoDate: // value for 'menuevoDate'
 *   },
 * });
 */
export function useItemQuantityRulesQuery(
  baseOptions: Apollo.QueryHookOptions<ItemQuantityRulesQuery, ItemQuantityRulesQueryVariables> &
    ({variables: ItemQuantityRulesQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ItemQuantityRulesQuery, ItemQuantityRulesQueryVariables>(
    ItemQuantityRulesQueryDocument,
    options,
  );
}
export function useItemQuantityRulesQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ItemQuantityRulesQuery,
    ItemQuantityRulesQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ItemQuantityRulesQuery, ItemQuantityRulesQueryVariables>(
    ItemQuantityRulesQueryDocument,
    options,
  );
}
// @ts-ignore
export function useItemQuantityRulesQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ItemQuantityRulesQuery,
    ItemQuantityRulesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ItemQuantityRulesQuery, ItemQuantityRulesQueryVariables>;
export function useItemQuantityRulesQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ItemQuantityRulesQuery, ItemQuantityRulesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ItemQuantityRulesQuery | undefined,
  ItemQuantityRulesQueryVariables
>;
export function useItemQuantityRulesQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ItemQuantityRulesQuery, ItemQuantityRulesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ItemQuantityRulesQuery, ItemQuantityRulesQueryVariables>(
    ItemQuantityRulesQueryDocument,
    options,
  );
}
export type ItemQuantityRulesQueryHookResult = ReturnType<typeof useItemQuantityRulesQuery>;
export type ItemQuantityRulesQueryLazyQueryHookResult = ReturnType<
  typeof useItemQuantityRulesQueryLazyQuery
>;
export type ItemQuantityRulesQuerySuspenseQueryHookResult = ReturnType<
  typeof useItemQuantityRulesQuerySuspenseQuery
>;
export type ItemQuantityRulesQueryQueryResult = Apollo.QueryResult<
  ItemQuantityRulesQuery,
  ItemQuantityRulesQueryVariables
>;
export const LoggedOutHomePageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'LoggedOutHomePageQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'useGeoip'},
                      value: {kind: 'BooleanValue', value: true},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'RecommendedDefaultAddressFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetails'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'edges'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'node'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'JumpBackInFulfillmentDetailFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'appStoreReviewCount'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'JumpBackInCartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'live'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'activePauses'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'heroImage'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'mobileSearchUrl'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalDue'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'RecommendedDefaultAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'GeocodedAddressResult'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'street'}},
          {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
          {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'JumpBackInFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'consumerCarts'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filters'},
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'onlyNonEmptyCarts'},
                      value: {kind: 'BooleanValue', value: true},
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'JumpBackInCartFragment'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useLoggedOutHomePageQuery__
 *
 * To run a query within a React component, call `useLoggedOutHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedOutHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedOutHomePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoggedOutHomePageQuery(
  baseOptions?: Apollo.QueryHookOptions<LoggedOutHomePageQuery, LoggedOutHomePageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<LoggedOutHomePageQuery, LoggedOutHomePageQueryVariables>(
    LoggedOutHomePageQueryDocument,
    options,
  );
}
export function useLoggedOutHomePageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoggedOutHomePageQuery,
    LoggedOutHomePageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<LoggedOutHomePageQuery, LoggedOutHomePageQueryVariables>(
    LoggedOutHomePageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useLoggedOutHomePageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoggedOutHomePageQuery,
    LoggedOutHomePageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoggedOutHomePageQuery, LoggedOutHomePageQueryVariables>;
export function useLoggedOutHomePageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoggedOutHomePageQuery, LoggedOutHomePageQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  LoggedOutHomePageQuery | undefined,
  LoggedOutHomePageQueryVariables
>;
export function useLoggedOutHomePageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoggedOutHomePageQuery, LoggedOutHomePageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<LoggedOutHomePageQuery, LoggedOutHomePageQueryVariables>(
    LoggedOutHomePageQueryDocument,
    options,
  );
}
export type LoggedOutHomePageQueryHookResult = ReturnType<typeof useLoggedOutHomePageQuery>;
export type LoggedOutHomePageQueryLazyQueryHookResult = ReturnType<
  typeof useLoggedOutHomePageQueryLazyQuery
>;
export type LoggedOutHomePageQuerySuspenseQueryHookResult = ReturnType<
  typeof useLoggedOutHomePageQuerySuspenseQuery
>;
export type LoggedOutHomePageQueryQueryResult = Apollo.QueryResult<
  LoggedOutHomePageQuery,
  LoggedOutHomePageQueryVariables
>;
export const MenuDietaryRestrictionsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'MenuDietaryRestrictionsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'menuUuid'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'menuDietaryRestrictions'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'menuUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'menuUuid'}},
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMenuDietaryRestrictionsQuery__
 *
 * To run a query within a React component, call `useMenuDietaryRestrictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuDietaryRestrictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuDietaryRestrictionsQuery({
 *   variables: {
 *      menuUuid: // value for 'menuUuid'
 *   },
 * });
 */
export function useMenuDietaryRestrictionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MenuDietaryRestrictionsQuery,
    MenuDietaryRestrictionsQueryVariables
  > &
    ({variables: MenuDietaryRestrictionsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<MenuDietaryRestrictionsQuery, MenuDietaryRestrictionsQueryVariables>(
    MenuDietaryRestrictionsQueryDocument,
    options,
  );
}
export function useMenuDietaryRestrictionsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MenuDietaryRestrictionsQuery,
    MenuDietaryRestrictionsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<MenuDietaryRestrictionsQuery, MenuDietaryRestrictionsQueryVariables>(
    MenuDietaryRestrictionsQueryDocument,
    options,
  );
}
// @ts-ignore
export function useMenuDietaryRestrictionsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MenuDietaryRestrictionsQuery,
    MenuDietaryRestrictionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MenuDietaryRestrictionsQuery,
  MenuDietaryRestrictionsQueryVariables
>;
export function useMenuDietaryRestrictionsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MenuDietaryRestrictionsQuery,
        MenuDietaryRestrictionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MenuDietaryRestrictionsQuery | undefined,
  MenuDietaryRestrictionsQueryVariables
>;
export function useMenuDietaryRestrictionsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MenuDietaryRestrictionsQuery,
        MenuDietaryRestrictionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    MenuDietaryRestrictionsQuery,
    MenuDietaryRestrictionsQueryVariables
  >(MenuDietaryRestrictionsQueryDocument, options);
}
export type MenuDietaryRestrictionsQueryHookResult = ReturnType<
  typeof useMenuDietaryRestrictionsQuery
>;
export type MenuDietaryRestrictionsQueryLazyQueryHookResult = ReturnType<
  typeof useMenuDietaryRestrictionsQueryLazyQuery
>;
export type MenuDietaryRestrictionsQuerySuspenseQueryHookResult = ReturnType<
  typeof useMenuDietaryRestrictionsQuerySuspenseQuery
>;
export type MenuDietaryRestrictionsQueryQueryResult = Apollo.QueryResult<
  MenuDietaryRestrictionsQuery,
  MenuDietaryRestrictionsQueryVariables
>;
export const MenuItemModalQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'MenuItemModalQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Date'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'channel'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'ChannelNameEnum'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'menuItemId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'urlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererUrlId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderingMenu'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'date'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'channel'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'channel'}},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'item'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'id'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'menuItemId'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'imageUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'fullImagePath'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'individualWrapStatus'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'usesVolumePricing'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'canBeQuickAdded'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'quantityRules'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'minimumQuantity'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'label'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'singular'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'plural'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'quantities'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'flags'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'canBeVegetarian'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'hasAward'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'hasStar'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isHalal'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isHealthy'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isKosher'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isOrHasDessert'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isOrHasDrinks'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isOrHasIce'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isPopular'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isSpicy'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isUtensils'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isVegan'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isVegetarian'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'sizes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'sizeIndex'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'numberOfServings'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'calories'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'min'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'price'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {kind: 'Name', value: 'Money'},
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'currency'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {kind: 'Name', value: 'VolumePrice'},
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'maxQuantity'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'minQuantity'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'price'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'subunits'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'currency'},
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'options'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'prompt'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'maximumAllowedChoices'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'minimumAllowedChoices'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'choices'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'sizes'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'sizeIndex'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'price'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'subunits'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'currency'},
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'subQuantityPercentageOptions',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'flags'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'hasAward'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'hasStar'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isGlutenFree'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isHalal'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isHealthy'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isKosher'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isOrHasDessert'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isOrHasDrinks'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isOrHasIce'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isSpicy'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isUtensils'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isVegan'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'isVegetarian'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMenuItemModalQuery__
 *
 * To run a query within a React component, call `useMenuItemModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuItemModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuItemModalQuery({
 *   variables: {
 *      catererUrlId: // value for 'catererUrlId'
 *      date: // value for 'date'
 *      channel: // value for 'channel'
 *      menuItemId: // value for 'menuItemId'
 *   },
 * });
 */
export function useMenuItemModalQuery(
  baseOptions: Apollo.QueryHookOptions<MenuItemModalQuery, MenuItemModalQueryVariables> &
    ({variables: MenuItemModalQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<MenuItemModalQuery, MenuItemModalQueryVariables>(
    MenuItemModalQueryDocument,
    options,
  );
}
export function useMenuItemModalQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MenuItemModalQuery, MenuItemModalQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<MenuItemModalQuery, MenuItemModalQueryVariables>(
    MenuItemModalQueryDocument,
    options,
  );
}
// @ts-ignore
export function useMenuItemModalQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MenuItemModalQuery, MenuItemModalQueryVariables>,
): Apollo.UseSuspenseQueryResult<MenuItemModalQuery, MenuItemModalQueryVariables>;
export function useMenuItemModalQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MenuItemModalQuery, MenuItemModalQueryVariables>,
): Apollo.UseSuspenseQueryResult<MenuItemModalQuery | undefined, MenuItemModalQueryVariables>;
export function useMenuItemModalQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MenuItemModalQuery, MenuItemModalQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<MenuItemModalQuery, MenuItemModalQueryVariables>(
    MenuItemModalQueryDocument,
    options,
  );
}
export type MenuItemModalQueryHookResult = ReturnType<typeof useMenuItemModalQuery>;
export type MenuItemModalQueryLazyQueryHookResult = ReturnType<
  typeof useMenuItemModalQueryLazyQuery
>;
export type MenuItemModalQuerySuspenseQueryHookResult = ReturnType<
  typeof useMenuItemModalQuerySuspenseQuery
>;
export type MenuItemModalQueryQueryResult = Apollo.QueryResult<
  MenuItemModalQuery,
  MenuItemModalQueryVariables
>;
export const MenuItemOptionsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'MenuItemOptionsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'urlId'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Date'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'itemIds'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'urlId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'urlId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderingMenu'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'channel'},
                      value: {kind: 'EnumValue', value: 'MARKETPLACE'},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'date'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'date'}},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'items'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'ids'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'itemIds'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'options'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'prompt'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'minimumAllowedChoices'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'maximumAllowedChoices'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMenuItemOptionsQuery__
 *
 * To run a query within a React component, call `useMenuItemOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuItemOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuItemOptionsQuery({
 *   variables: {
 *      urlId: // value for 'urlId'
 *      date: // value for 'date'
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function useMenuItemOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<MenuItemOptionsQuery, MenuItemOptionsQueryVariables> &
    ({variables: MenuItemOptionsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<MenuItemOptionsQuery, MenuItemOptionsQueryVariables>(
    MenuItemOptionsQueryDocument,
    options,
  );
}
export function useMenuItemOptionsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MenuItemOptionsQuery, MenuItemOptionsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<MenuItemOptionsQuery, MenuItemOptionsQueryVariables>(
    MenuItemOptionsQueryDocument,
    options,
  );
}
// @ts-ignore
export function useMenuItemOptionsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MenuItemOptionsQuery,
    MenuItemOptionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MenuItemOptionsQuery, MenuItemOptionsQueryVariables>;
export function useMenuItemOptionsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MenuItemOptionsQuery, MenuItemOptionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MenuItemOptionsQuery | undefined, MenuItemOptionsQueryVariables>;
export function useMenuItemOptionsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MenuItemOptionsQuery, MenuItemOptionsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<MenuItemOptionsQuery, MenuItemOptionsQueryVariables>(
    MenuItemOptionsQueryDocument,
    options,
  );
}
export type MenuItemOptionsQueryHookResult = ReturnType<typeof useMenuItemOptionsQuery>;
export type MenuItemOptionsQueryLazyQueryHookResult = ReturnType<
  typeof useMenuItemOptionsQueryLazyQuery
>;
export type MenuItemOptionsQuerySuspenseQueryHookResult = ReturnType<
  typeof useMenuItemOptionsQuerySuspenseQuery
>;
export type MenuItemOptionsQueryQueryResult = Apollo.QueryResult<
  MenuItemOptionsQuery,
  MenuItemOptionsQueryVariables
>;
export const MenuevoMenuItemQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'MenuevoMenuItemQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoMenuItemId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'menuevoMenuItem'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'menuevoMenuItemId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'advanceNotice'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CutoffTime'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'cutoffTime'}}],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'LeadTimeInMinutes'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'leadTimeInMinutes'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'calories'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'min'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'dietaryFlags'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isHalal'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isKosher'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isVegan'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isVegetarian'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'image'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'desktopUrl'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'imageUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'individualWrapStatus'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'initialSelectionCalories'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'min'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'minServes'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modifierGroups'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'MenuevoModifierGroupFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'MenuevoModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifierGroups'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'MenuevoModifierGroupFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {kind: 'Name', value: 'MenuevoModifierFragment'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifierGroups'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'MenuevoModifierGroupFragment',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'modifiers'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'MenuevoModifierFragment',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'modifierGroups'},
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'MenuevoModifierGroupFragment',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'modifiers',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'FragmentSpread',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'MenuevoModifierFragment',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'modifierGroups',
                                                                  },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: {
                                                                          kind: 'Name',
                                                                          value:
                                                                            'MenuevoModifierGroupFragment',
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: {
                                                                          kind: 'Name',
                                                                          value: 'modifiers',
                                                                        },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            {
                                                                              kind: 'FragmentSpread',
                                                                              name: {
                                                                                kind: 'Name',
                                                                                value:
                                                                                  'MenuevoModifierFragment',
                                                                              },
                                                                            },
                                                                          ],
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'price'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunitsV2'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'quantityRules'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'increment'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'min'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'salesTaxCode'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'servings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'min'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'sortIndex'}},
                {kind: 'Field', name: {kind: 'Name', value: 'unit'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MenuevoModifierGroupFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MenuevoModifierGroup'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'customerPrompt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'fulfillmentLabel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'maxAggregateQuantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'maxModifierQuantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'maxSelections'}},
          {kind: 'Field', name: {kind: 'Name', value: 'minAggregateQuantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'minModifierQuantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'minSelections'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sortIndex'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'MenuevoModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'MenuevoModifier'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'defaultQuantity'}},
          {kind: 'Field', name: {kind: 'Name', value: 'description'}},
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'preselected'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'servings'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                {kind: 'Field', name: {kind: 'Name', value: 'min'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'sortIndex'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'calories'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'max'}},
                {kind: 'Field', name: {kind: 'Name', value: 'min'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunitsV2'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMenuevoMenuItemQuery__
 *
 * To run a query within a React component, call `useMenuevoMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuevoMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuevoMenuItemQuery({
 *   variables: {
 *      menuevoMenuItemId: // value for 'menuevoMenuItemId'
 *   },
 * });
 */
export function useMenuevoMenuItemQuery(
  baseOptions: Apollo.QueryHookOptions<MenuevoMenuItemQuery, MenuevoMenuItemQueryVariables> &
    ({variables: MenuevoMenuItemQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<MenuevoMenuItemQuery, MenuevoMenuItemQueryVariables>(
    MenuevoMenuItemQueryDocument,
    options,
  );
}
export function useMenuevoMenuItemQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MenuevoMenuItemQuery, MenuevoMenuItemQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<MenuevoMenuItemQuery, MenuevoMenuItemQueryVariables>(
    MenuevoMenuItemQueryDocument,
    options,
  );
}
// @ts-ignore
export function useMenuevoMenuItemQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MenuevoMenuItemQuery,
    MenuevoMenuItemQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MenuevoMenuItemQuery, MenuevoMenuItemQueryVariables>;
export function useMenuevoMenuItemQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MenuevoMenuItemQuery, MenuevoMenuItemQueryVariables>,
): Apollo.UseSuspenseQueryResult<MenuevoMenuItemQuery | undefined, MenuevoMenuItemQueryVariables>;
export function useMenuevoMenuItemQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MenuevoMenuItemQuery, MenuevoMenuItemQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<MenuevoMenuItemQuery, MenuevoMenuItemQueryVariables>(
    MenuevoMenuItemQueryDocument,
    options,
  );
}
export type MenuevoMenuItemQueryHookResult = ReturnType<typeof useMenuevoMenuItemQuery>;
export type MenuevoMenuItemQueryLazyQueryHookResult = ReturnType<
  typeof useMenuevoMenuItemQueryLazyQuery
>;
export type MenuevoMenuItemQuerySuspenseQueryHookResult = ReturnType<
  typeof useMenuevoMenuItemQuerySuspenseQuery
>;
export type MenuevoMenuItemQueryQueryResult = Apollo.QueryResult<
  MenuevoMenuItemQuery,
  MenuevoMenuItemQueryVariables
>;
export const NewAddressPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'NewAddressPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useNewAddressPageQuery__
 *
 * To run a query within a React component, call `useNewAddressPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewAddressPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewAddressPageQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useNewAddressPageQuery(
  baseOptions?: Apollo.QueryHookOptions<NewAddressPageQuery, NewAddressPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<NewAddressPageQuery, NewAddressPageQueryVariables>(
    NewAddressPageQueryDocument,
    options,
  );
}
export function useNewAddressPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NewAddressPageQuery, NewAddressPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<NewAddressPageQuery, NewAddressPageQueryVariables>(
    NewAddressPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useNewAddressPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<NewAddressPageQuery, NewAddressPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<NewAddressPageQuery, NewAddressPageQueryVariables>;
export function useNewAddressPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NewAddressPageQuery, NewAddressPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<NewAddressPageQuery | undefined, NewAddressPageQueryVariables>;
export function useNewAddressPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NewAddressPageQuery, NewAddressPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<NewAddressPageQuery, NewAddressPageQueryVariables>(
    NewAddressPageQueryDocument,
    options,
  );
}
export type NewAddressPageQueryHookResult = ReturnType<typeof useNewAddressPageQuery>;
export type NewAddressPageQueryLazyQueryHookResult = ReturnType<
  typeof useNewAddressPageQueryLazyQuery
>;
export type NewAddressPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useNewAddressPageQuerySuspenseQuery
>;
export type NewAddressPageQueryQueryResult = Apollo.QueryResult<
  NewAddressPageQuery,
  NewAddressPageQueryVariables
>;
export const OpenOrdersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'openOrders'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'excludeModificationCarts'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'onlyNonEmptyCarts'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: true},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'onlyFulfillmentDetailsWithCarts'},
          },
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accountIdentifier'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'fulfillmentDetails'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filters'},
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: {kind: 'Name', value: 'onlyNonEmptyCarts'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'onlyNonEmptyCarts'},
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {kind: 'Name', value: 'onlyFulfillmentDetailsWithCarts'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'onlyFulfillmentDetailsWithCarts'},
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {kind: 'Name', value: 'excludeModificationCarts'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'excludeModificationCarts'},
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'edges'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'node'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'address'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'timeZoneIdentifier'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'consumerCarts'},
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: {kind: 'Name', value: 'filters'},
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: {
                                                kind: 'Name',
                                                value: 'excludeModificationCarts',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'excludeModificationCarts',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'items'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'quantity'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'totalDue'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'currency'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'caterer'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'address'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'id'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'city'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'state'},
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'brand'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'id'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'heroImage'},
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'uuid'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'mobileHeroUrl',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
                                        {
                                          kind: 'FragmentSpread',
                                          name: {kind: 'Name', value: 'DraftCartTrackingFragment'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'corpAccount'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DraftCartTrackingFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerCart'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isModification'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'items'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOpenOrdersQuery__
 *
 * To run a query within a React component, call `useOpenOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenOrdersQuery({
 *   variables: {
 *      excludeModificationCarts: // value for 'excludeModificationCarts'
 *      onlyNonEmptyCarts: // value for 'onlyNonEmptyCarts'
 *      onlyFulfillmentDetailsWithCarts: // value for 'onlyFulfillmentDetailsWithCarts'
 *   },
 * });
 */
export function useOpenOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<OpenOrdersQuery, OpenOrdersQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<OpenOrdersQuery, OpenOrdersQueryVariables>(OpenOrdersDocument, options);
}
export function useOpenOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OpenOrdersQuery, OpenOrdersQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<OpenOrdersQuery, OpenOrdersQueryVariables>(
    OpenOrdersDocument,
    options,
  );
}
// @ts-ignore
export function useOpenOrdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<OpenOrdersQuery, OpenOrdersQueryVariables>,
): Apollo.UseSuspenseQueryResult<OpenOrdersQuery, OpenOrdersQueryVariables>;
export function useOpenOrdersSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenOrdersQuery, OpenOrdersQueryVariables>,
): Apollo.UseSuspenseQueryResult<OpenOrdersQuery | undefined, OpenOrdersQueryVariables>;
export function useOpenOrdersSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenOrdersQuery, OpenOrdersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<OpenOrdersQuery, OpenOrdersQueryVariables>(
    OpenOrdersDocument,
    options,
  );
}
export type OpenOrdersQueryHookResult = ReturnType<typeof useOpenOrdersQuery>;
export type OpenOrdersLazyQueryHookResult = ReturnType<typeof useOpenOrdersLazyQuery>;
export type OpenOrdersSuspenseQueryHookResult = ReturnType<typeof useOpenOrdersSuspenseQuery>;
export type OpenOrdersQueryResult = Apollo.QueryResult<OpenOrdersQuery, OpenOrdersQueryVariables>;
export const OrderAgainQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'OrderAgainQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          defaultValue: {kind: 'IntValue', value: '20'},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'PAST'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'catererId'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'edges'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'node'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'caterer'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {kind: 'Name', value: 'SavedCatererFragment'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cart'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'orderItems'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'id'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'name'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'quantity'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'size'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'sizeIndex'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'vegetarianQuantity',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'specialInstructions',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'menuItem'},
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'id'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'uuid'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'isAvailable',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'quantityOptions',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'quantities',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'allowCustomQuantityOver100',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'labelPlural',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'label',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'sizes'},
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'size',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'number',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'serves',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      alias: {kind: 'Name', value: 'optionInputs'},
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'orderItemOptions',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'id'},
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'menuOption',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {kind: 'Name', value: 'id'},
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'uuid',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            alias: {
                                                              kind: 'Name',
                                                              value: 'choiceInputs',
                                                            },
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'itemChoices',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {kind: 'Name', value: 'id'},
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'isGlutenFree',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'name',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'subQuantityPercentage',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'menuChoice',
                                                                  },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: {
                                                                          kind: 'Name',
                                                                          value: 'id',
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: {
                                                                          kind: 'Name',
                                                                          value: 'uuid',
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'catererLabel',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'pricePerHead'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'id'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'byCustomerTotal',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {kind: 'Name', value: 'subunits'},
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'event'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'headcount'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'address'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'id'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'street'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'street2'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'city'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'state'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'zip'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'latitude'},
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {kind: 'Name', value: 'longitude'},
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SavedCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isNew'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'heroImage'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobileSearchUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOrderAgainQuery__
 *
 * To run a query within a React component, call `useOrderAgainQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderAgainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderAgainQuery({
 *   variables: {
 *      catererId: // value for 'catererId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOrderAgainQuery(
  baseOptions?: Apollo.QueryHookOptions<OrderAgainQuery, OrderAgainQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<OrderAgainQuery, OrderAgainQueryVariables>(
    OrderAgainQueryDocument,
    options,
  );
}
export function useOrderAgainQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrderAgainQuery, OrderAgainQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<OrderAgainQuery, OrderAgainQueryVariables>(
    OrderAgainQueryDocument,
    options,
  );
}
// @ts-ignore
export function useOrderAgainQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<OrderAgainQuery, OrderAgainQueryVariables>,
): Apollo.UseSuspenseQueryResult<OrderAgainQuery, OrderAgainQueryVariables>;
export function useOrderAgainQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAgainQuery, OrderAgainQueryVariables>,
): Apollo.UseSuspenseQueryResult<OrderAgainQuery | undefined, OrderAgainQueryVariables>;
export function useOrderAgainQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAgainQuery, OrderAgainQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<OrderAgainQuery, OrderAgainQueryVariables>(
    OrderAgainQueryDocument,
    options,
  );
}
export type OrderAgainQueryHookResult = ReturnType<typeof useOrderAgainQuery>;
export type OrderAgainQueryLazyQueryHookResult = ReturnType<typeof useOrderAgainQueryLazyQuery>;
export type OrderAgainQuerySuspenseQueryHookResult = ReturnType<
  typeof useOrderAgainQuerySuspenseQuery
>;
export type OrderAgainQueryQueryResult = Apollo.QueryResult<
  OrderAgainQuery,
  OrderAgainQueryVariables
>;
export const OrderPlacedPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'OrderPlacedPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'nationwideCatererCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'order'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'OrderPlacedOrderFragment'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'OrderPlacedConsumerFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'LineItemModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LineItemModifier'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'OrderCancellationPolicyDisplay'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'hasCancellationFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'feePercentage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'feeAmount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cancelWithoutPenaltyUntil'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationWindowHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isWaiverEligible'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderPlacedOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isEzOrderingOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isStandardGroupOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'orderSourceType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'ezRewardsPointsEarnable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'predictedLtv'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderRank'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'submittedMarketplace'}},
                {kind: 'Field', name: {kind: 'Name', value: 'submittedEzOrdering'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cart'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'menuItemId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'groupOrderPersonName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totalInSubunits'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orderItemOptions'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'catererLabel'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'itemChoices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'LineItemModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'LineItemModifierFragment',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'modifiers'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'LineItemModifierFragment',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'lineItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isGratuity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isPromo'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'staticMapUrl'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'width'},
                            value: {kind: 'IntValue', value: '1024'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'height'},
                            value: {kind: 'IntValue', value: '240'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'marker'},
                            value: {kind: 'BooleanValue', value: false},
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSubmitted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isAccepted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isReconfirmed'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancellable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
                {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderCustomer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'delivery'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryEvents'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'eventType'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'customerProvidedName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'orderType'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'staticMapUrl'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'width'},
                            value: {kind: 'IntValue', value: '1024'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'height'},
                            value: {kind: 'IntValue', value: '240'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'marker'},
                            value: {kind: 'BooleanValue', value: false},
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'paymentMethod'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CreditCard'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CreditLine'}},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'corpAccountName'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totals'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'salesTax'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'subTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalDue'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountDeliveryFee'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'procurementSettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'includedUtensils'}},
                {kind: 'Field', name: {kind: 'Name', value: 'omittedUtensils'}},
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isResidentialOrder'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cancellationPolicyDisplay'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderPlacedConsumerFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'marketplaceStatus'}},
          {kind: 'Field', name: {kind: 'Name', value: 'userType'}},
          {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralUrl'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'canEarnReferralRewards'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'enterpriseLeadEligible'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
          {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'canAccessEzRewards'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'submittedOrdersCount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'daysSinceFirstMarketplaceOrder'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'assignedPromoCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promo'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOrderPlacedPageQuery__
 *
 * To run a query within a React component, call `useOrderPlacedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPlacedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPlacedPageQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useOrderPlacedPageQuery(
  baseOptions: Apollo.QueryHookOptions<OrderPlacedPageQuery, OrderPlacedPageQueryVariables> &
    ({variables: OrderPlacedPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<OrderPlacedPageQuery, OrderPlacedPageQueryVariables>(
    OrderPlacedPageQueryDocument,
    options,
  );
}
export function useOrderPlacedPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrderPlacedPageQuery, OrderPlacedPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<OrderPlacedPageQuery, OrderPlacedPageQueryVariables>(
    OrderPlacedPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useOrderPlacedPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrderPlacedPageQuery,
    OrderPlacedPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OrderPlacedPageQuery, OrderPlacedPageQueryVariables>;
export function useOrderPlacedPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrderPlacedPageQuery, OrderPlacedPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<OrderPlacedPageQuery | undefined, OrderPlacedPageQueryVariables>;
export function useOrderPlacedPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrderPlacedPageQuery, OrderPlacedPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<OrderPlacedPageQuery, OrderPlacedPageQueryVariables>(
    OrderPlacedPageQueryDocument,
    options,
  );
}
export type OrderPlacedPageQueryHookResult = ReturnType<typeof useOrderPlacedPageQuery>;
export type OrderPlacedPageQueryLazyQueryHookResult = ReturnType<
  typeof useOrderPlacedPageQueryLazyQuery
>;
export type OrderPlacedPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useOrderPlacedPageQuerySuspenseQuery
>;
export type OrderPlacedPageQueryQueryResult = Apollo.QueryResult<
  OrderPlacedPageQuery,
  OrderPlacedPageQueryVariables
>;
export const OrdersCalendarPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'OrdersCalendarPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventBefore'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeOrders'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'ALL'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'eventAfter'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'eventBefore'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'eventBefore'}},
                          },
                        ],
                        directives: [
                          {
                            kind: 'Directive',
                            name: {kind: 'Name', value: 'include'},
                            arguments: [
                              {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'if'},
                                value: {
                                  kind: 'Variable',
                                  name: {kind: 'Name', value: 'includeOrders'},
                                },
                              },
                            ],
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'formattedOrderNumber'},
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'isEzOrderingOrder'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'isStandardGroupOrder'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'corpAccount'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'event'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'timeZoneOffset'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'address'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'nameOrLocation'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'street'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'street2'},
                                              },
                                              {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'latitude'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'longitude'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'caterer'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'customerOrderStatus'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'currentStatusDisplay'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isCancellable'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isModifiable'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modificationCutoffTime'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isSubmitted'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isPendingApproval'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'cart'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'orderItems'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'belongsToAnyEater'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'cancellationPolicyDisplay'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'OrderCancellationPolicyDisplayFragment',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'concurAccount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'areReceiptsAutomated'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'OrderCancellationPolicyDisplay'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'hasCancellationFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'feePercentage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'feeAmount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cancelWithoutPenaltyUntil'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationWindowHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isWaiverEligible'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOrdersCalendarPageQuery__
 *
 * To run a query within a React component, call `useOrdersCalendarPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersCalendarPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersCalendarPageQuery({
 *   variables: {
 *      eventAfter: // value for 'eventAfter'
 *      eventBefore: // value for 'eventBefore'
 *      includeOrders: // value for 'includeOrders'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useOrdersCalendarPageQuery(
  baseOptions: Apollo.QueryHookOptions<OrdersCalendarPageQuery, OrdersCalendarPageQueryVariables> &
    ({variables: OrdersCalendarPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<OrdersCalendarPageQuery, OrdersCalendarPageQueryVariables>(
    OrdersCalendarPageQueryDocument,
    options,
  );
}
export function useOrdersCalendarPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrdersCalendarPageQuery,
    OrdersCalendarPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<OrdersCalendarPageQuery, OrdersCalendarPageQueryVariables>(
    OrdersCalendarPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useOrdersCalendarPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrdersCalendarPageQuery,
    OrdersCalendarPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OrdersCalendarPageQuery, OrdersCalendarPageQueryVariables>;
export function useOrdersCalendarPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrdersCalendarPageQuery, OrdersCalendarPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  OrdersCalendarPageQuery | undefined,
  OrdersCalendarPageQueryVariables
>;
export function useOrdersCalendarPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrdersCalendarPageQuery, OrdersCalendarPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<OrdersCalendarPageQuery, OrdersCalendarPageQueryVariables>(
    OrdersCalendarPageQueryDocument,
    options,
  );
}
export type OrdersCalendarPageQueryHookResult = ReturnType<typeof useOrdersCalendarPageQuery>;
export type OrdersCalendarPageQueryLazyQueryHookResult = ReturnType<
  typeof useOrdersCalendarPageQueryLazyQuery
>;
export type OrdersCalendarPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useOrdersCalendarPageQuerySuspenseQuery
>;
export type OrdersCalendarPageQueryQueryResult = Apollo.QueryResult<
  OrdersCalendarPageQuery,
  OrdersCalendarPageQueryVariables
>;
export const OrdersDropdownQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'OrdersDropdownQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'corpAccountUuids'}},
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeAllConnections'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'scheduledOrderSections'},
                        name: {kind: 'Name', value: 'orderSections'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'mode'},
                            value: {kind: 'EnumValue', value: 'SCHEDULED'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'corpAccountUuids'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'corpAccountUuids'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'includeAllConnections'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'includeAllConnections'},
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'orders'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'OrderCardFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'delivery'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'estimatedDropoffTime'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'tracking'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'deliveryEvents'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'eventType'},
                                              },
                                              {kind: 'Field', name: {kind: 'Name', value: 'time'}},
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'completedOrderSections'},
                        name: {kind: 'Name', value: 'orderSections'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'mode'},
                            value: {kind: 'EnumValue', value: 'COMPLETED'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'corpAccountUuids'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'corpAccountUuids'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'includeAllConnections'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'includeAllConnections'},
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'orders'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'OrderCardFragment'},
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'review'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'deliveryTimeFeedback'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'deliveryProfessionalismFeedback',
                                          },
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'orderCustomer'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'caterer'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isSavedCaterer'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'event'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'address'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'street'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'street2'},
                                              },
                                              {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'latitude'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'longitude'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'upcomingOrdersCount'},
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'UPCOMING'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'IntValue', value: '1'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'corpAccountUuids'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'corpAccountUuids'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'includeAllConnections'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'includeAllConnections'},
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'pastOrdersCount'},
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'PAST'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'IntValue', value: '1'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'corpAccountUuids'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'corpAccountUuids'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'includeAllConnections'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'includeAllConnections'},
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderCardFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isStandardGroupOrder'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'heroImage'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'mobileHeroUrl'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOrdersDropdownQuery__
 *
 * To run a query within a React component, call `useOrdersDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersDropdownQuery({
 *   variables: {
 *      corpAccountUuids: // value for 'corpAccountUuids'
 *      includeAllConnections: // value for 'includeAllConnections'
 *   },
 * });
 */
export function useOrdersDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<OrdersDropdownQuery, OrdersDropdownQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<OrdersDropdownQuery, OrdersDropdownQueryVariables>(
    OrdersDropdownQueryDocument,
    options,
  );
}
export function useOrdersDropdownQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrdersDropdownQuery, OrdersDropdownQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<OrdersDropdownQuery, OrdersDropdownQueryVariables>(
    OrdersDropdownQueryDocument,
    options,
  );
}
// @ts-ignore
export function useOrdersDropdownQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<OrdersDropdownQuery, OrdersDropdownQueryVariables>,
): Apollo.UseSuspenseQueryResult<OrdersDropdownQuery, OrdersDropdownQueryVariables>;
export function useOrdersDropdownQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrdersDropdownQuery, OrdersDropdownQueryVariables>,
): Apollo.UseSuspenseQueryResult<OrdersDropdownQuery | undefined, OrdersDropdownQueryVariables>;
export function useOrdersDropdownQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrdersDropdownQuery, OrdersDropdownQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<OrdersDropdownQuery, OrdersDropdownQueryVariables>(
    OrdersDropdownQueryDocument,
    options,
  );
}
export type OrdersDropdownQueryHookResult = ReturnType<typeof useOrdersDropdownQuery>;
export type OrdersDropdownQueryLazyQueryHookResult = ReturnType<
  typeof useOrdersDropdownQueryLazyQuery
>;
export type OrdersDropdownQuerySuspenseQueryHookResult = ReturnType<
  typeof useOrdersDropdownQuerySuspenseQuery
>;
export type OrdersDropdownQueryQueryResult = Apollo.QueryResult<
  OrdersDropdownQuery,
  OrdersDropdownQueryVariables
>;
export const OrdersIndicatorQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'OrdersIndicatorQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'corpAccountUuids'}},
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeAllConnections'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'todayOrderSections'},
                        name: {kind: 'Name', value: 'orderSections'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'mode'},
                            value: {kind: 'EnumValue', value: 'SCHEDULED'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'keys'},
                            value: {
                              kind: 'ListValue',
                              values: [{kind: 'EnumValue', value: 'TODAY'}],
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'corpAccountUuids'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'corpAccountUuids'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'includeAllConnections'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'includeAllConnections'},
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'orders'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'completedOrderSections'},
                        name: {kind: 'Name', value: 'orderSections'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'mode'},
                            value: {kind: 'EnumValue', value: 'COMPLETED'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'corpAccountUuids'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'corpAccountUuids'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'includeAllConnections'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'includeAllConnections'},
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'orders'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'review'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'orderCustomer'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOrdersIndicatorQuery__
 *
 * To run a query within a React component, call `useOrdersIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersIndicatorQuery({
 *   variables: {
 *      corpAccountUuids: // value for 'corpAccountUuids'
 *      includeAllConnections: // value for 'includeAllConnections'
 *   },
 * });
 */
export function useOrdersIndicatorQuery(
  baseOptions?: Apollo.QueryHookOptions<OrdersIndicatorQuery, OrdersIndicatorQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<OrdersIndicatorQuery, OrdersIndicatorQueryVariables>(
    OrdersIndicatorQueryDocument,
    options,
  );
}
export function useOrdersIndicatorQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrdersIndicatorQuery, OrdersIndicatorQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<OrdersIndicatorQuery, OrdersIndicatorQueryVariables>(
    OrdersIndicatorQueryDocument,
    options,
  );
}
// @ts-ignore
export function useOrdersIndicatorQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrdersIndicatorQuery,
    OrdersIndicatorQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OrdersIndicatorQuery, OrdersIndicatorQueryVariables>;
export function useOrdersIndicatorQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrdersIndicatorQuery, OrdersIndicatorQueryVariables>,
): Apollo.UseSuspenseQueryResult<OrdersIndicatorQuery | undefined, OrdersIndicatorQueryVariables>;
export function useOrdersIndicatorQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OrdersIndicatorQuery, OrdersIndicatorQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<OrdersIndicatorQuery, OrdersIndicatorQueryVariables>(
    OrdersIndicatorQueryDocument,
    options,
  );
}
export type OrdersIndicatorQueryHookResult = ReturnType<typeof useOrdersIndicatorQuery>;
export type OrdersIndicatorQueryLazyQueryHookResult = ReturnType<
  typeof useOrdersIndicatorQueryLazyQuery
>;
export type OrdersIndicatorQuerySuspenseQueryHookResult = ReturnType<
  typeof useOrdersIndicatorQuerySuspenseQuery
>;
export type OrdersIndicatorQueryQueryResult = Apollo.QueryResult<
  OrdersIndicatorQuery,
  OrdersIndicatorQueryVariables
>;
export const OrdersPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'OrdersPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'OrderStateFilterEnum'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeModifiable'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'sortDirection'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'SortDirection'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'userConnectionId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeAllConnections'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isSpecialtyCustomer'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'sortDirection'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'sortDirection'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'searchString'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'userConnectionId'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'userConnectionId'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'includeAllConnections'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'includeAllConnections'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'corpAccountUuids'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'OrdersTableOrderFragment'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'concurAccount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'areReceiptsAutomated'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'userConnections'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'edges'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'node'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'connectedUserId'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'OrderCancellationPolicyDisplay'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'hasCancellationFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'feePercentage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'feeAmount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cancelWithoutPenaltyUntil'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationWindowHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isWaiverEligible'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrdersTableOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isPaymentPending'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isEzOrderingOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isStandardGroupOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'notificationsEnabled'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'firstOrderReferenceCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corporateReferenceCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'customerProvidedName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'minimumDeliveryFee'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'amount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'takeoutMinimum'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currentStatusDisplay'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancellable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'isModifiable'},
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'include'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {
                            kind: 'Variable',
                            name: {kind: 'Name', value: 'includeModifiable'},
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'modificationCutoffTime'},
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'include'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {
                            kind: 'Variable',
                            name: {kind: 'Name', value: 'includeModifiable'},
                          },
                        },
                      ],
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'isSubmitted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totals'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalDue'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'review'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cart'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'belongsToAnyEater'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'orderCustomer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cancellationPolicyDisplay'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOrdersPageQuery__
 *
 * To run a query within a React component, call `useOrdersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersPageQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      includeModifiable: // value for 'includeModifiable'
 *      searchString: // value for 'searchString'
 *      sortDirection: // value for 'sortDirection'
 *      userConnectionId: // value for 'userConnectionId'
 *      includeAllConnections: // value for 'includeAllConnections'
 *      accountUuid: // value for 'accountUuid'
 *      selectedAccountUuidsForOrders: // value for 'selectedAccountUuidsForOrders'
 *   },
 * });
 */
export function useOrdersPageQuery(
  baseOptions: Apollo.QueryHookOptions<OrdersPageQuery, OrdersPageQueryVariables> &
    ({variables: OrdersPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<OrdersPageQuery, OrdersPageQueryVariables>(
    OrdersPageQueryDocument,
    options,
  );
}
export function useOrdersPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrdersPageQuery, OrdersPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<OrdersPageQuery, OrdersPageQueryVariables>(
    OrdersPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useOrdersPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<OrdersPageQuery, OrdersPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<OrdersPageQuery, OrdersPageQueryVariables>;
export function useOrdersPageQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersPageQuery, OrdersPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<OrdersPageQuery | undefined, OrdersPageQueryVariables>;
export function useOrdersPageQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersPageQuery, OrdersPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<OrdersPageQuery, OrdersPageQueryVariables>(
    OrdersPageQueryDocument,
    options,
  );
}
export type OrdersPageQueryHookResult = ReturnType<typeof useOrdersPageQuery>;
export type OrdersPageQueryLazyQueryHookResult = ReturnType<typeof useOrdersPageQueryLazyQuery>;
export type OrdersPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useOrdersPageQuerySuspenseQuery
>;
export type OrdersPageQueryQueryResult = Apollo.QueryResult<
  OrdersPageQuery,
  OrdersPageQueryVariables
>;
export const PastOrdersQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PastOrdersQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'addressId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  alias: {kind: 'Name', value: 'pastOrders'},
                  name: {kind: 'Name', value: 'orders'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'offset'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'limit'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filter'},
                      value: {kind: 'EnumValue', value: 'SUBMITTED_NOT_CANCELLED'},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'sortDirection'},
                      value: {kind: 'EnumValue', value: 'DESC'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'edges'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'node'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'formattedOrderNumber'},
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isPaymentPending'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'event'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'timeZoneOffset'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'orderType'},
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {kind: 'Name', value: 'perspective'},
                                              value: {kind: 'EnumValue', value: 'CUSTOMER'},
                                            },
                                          ],
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'address'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'street'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'street2'},
                                              },
                                              {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'latitude'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'longitude'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'cart'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'orderItems'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'quantity'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'groupOrderPersonName'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'totals'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'customerTotalDue'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'caterer'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePastOrdersQuery__
 *
 * To run a query within a React component, call `usePastOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastOrdersQuery({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePastOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<PastOrdersQuery, PastOrdersQueryVariables> &
    ({variables: PastOrdersQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PastOrdersQuery, PastOrdersQueryVariables>(
    PastOrdersQueryDocument,
    options,
  );
}
export function usePastOrdersQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PastOrdersQuery, PastOrdersQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PastOrdersQuery, PastOrdersQueryVariables>(
    PastOrdersQueryDocument,
    options,
  );
}
// @ts-ignore
export function usePastOrdersQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PastOrdersQuery, PastOrdersQueryVariables>,
): Apollo.UseSuspenseQueryResult<PastOrdersQuery, PastOrdersQueryVariables>;
export function usePastOrdersQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PastOrdersQuery, PastOrdersQueryVariables>,
): Apollo.UseSuspenseQueryResult<PastOrdersQuery | undefined, PastOrdersQueryVariables>;
export function usePastOrdersQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PastOrdersQuery, PastOrdersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PastOrdersQuery, PastOrdersQueryVariables>(
    PastOrdersQueryDocument,
    options,
  );
}
export type PastOrdersQueryHookResult = ReturnType<typeof usePastOrdersQuery>;
export type PastOrdersQueryLazyQueryHookResult = ReturnType<typeof usePastOrdersQueryLazyQuery>;
export type PastOrdersQuerySuspenseQueryHookResult = ReturnType<
  typeof usePastOrdersQuerySuspenseQuery
>;
export type PastOrdersQueryQueryResult = Apollo.QueryResult<
  PastOrdersQuery,
  PastOrdersQueryVariables
>;
export const PaymentMethodsPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PaymentMethodsPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethodsLimit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodsRootFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodsFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodsRootFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCurrentDeviceRecognized'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhoneLastTwo'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canUpdateCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'paymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'paymentMethodsLimit'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CreditCard'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cardholderName'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isDefaultCard'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isExpired'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isExpiringSoon'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'missingZipCode'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'sharedBy'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'fullName'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'sharedWithCount'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CreditLine'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'corpAccountName'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isDefault'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'logoImageUrl'},
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePaymentMethodsPageQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsPageQuery({
 *   variables: {
 *      paymentMethodsLimit: // value for 'paymentMethodsLimit'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function usePaymentMethodsPageQuery(
  baseOptions: Apollo.QueryHookOptions<PaymentMethodsPageQuery, PaymentMethodsPageQueryVariables> &
    ({variables: PaymentMethodsPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PaymentMethodsPageQuery, PaymentMethodsPageQueryVariables>(
    PaymentMethodsPageQueryDocument,
    options,
  );
}
export function usePaymentMethodsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentMethodsPageQuery,
    PaymentMethodsPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PaymentMethodsPageQuery, PaymentMethodsPageQueryVariables>(
    PaymentMethodsPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function usePaymentMethodsPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaymentMethodsPageQuery,
    PaymentMethodsPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PaymentMethodsPageQuery, PaymentMethodsPageQueryVariables>;
export function usePaymentMethodsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PaymentMethodsPageQuery, PaymentMethodsPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  PaymentMethodsPageQuery | undefined,
  PaymentMethodsPageQueryVariables
>;
export function usePaymentMethodsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PaymentMethodsPageQuery, PaymentMethodsPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PaymentMethodsPageQuery, PaymentMethodsPageQueryVariables>(
    PaymentMethodsPageQueryDocument,
    options,
  );
}
export type PaymentMethodsPageQueryHookResult = ReturnType<typeof usePaymentMethodsPageQuery>;
export type PaymentMethodsPageQueryLazyQueryHookResult = ReturnType<
  typeof usePaymentMethodsPageQueryLazyQuery
>;
export type PaymentMethodsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof usePaymentMethodsPageQuerySuspenseQuery
>;
export type PaymentMethodsPageQueryQueryResult = Apollo.QueryResult<
  PaymentMethodsPageQuery,
  PaymentMethodsPageQueryVariables
>;
export const PaymentMethodsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PaymentMethodsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'paymentMethodsLimit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodsFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canUpdateCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'paymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'paymentMethodsLimit'},
                            },
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CreditCard'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cardholderName'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'expMonth'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'expYear'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isDefaultCard'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isExpired'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isExpiringSoon'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'missingZipCode'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'sharedBy'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'fullName'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'sharedWithCount'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CreditLine'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'corpAccountName'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'isDefault'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'logoImageUrl'},
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *      paymentMethodsLimit: // value for 'paymentMethodsLimit'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function usePaymentMethodsQuery(
  baseOptions: Apollo.QueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables> &
    ({variables: PaymentMethodsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(
    PaymentMethodsQueryDocument,
    options,
  );
}
export function usePaymentMethodsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(
    PaymentMethodsQueryDocument,
    options,
  );
}
// @ts-ignore
export function usePaymentMethodsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>,
): Apollo.UseSuspenseQueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export function usePaymentMethodsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>,
): Apollo.UseSuspenseQueryResult<PaymentMethodsQuery | undefined, PaymentMethodsQueryVariables>;
export function usePaymentMethodsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(
    PaymentMethodsQueryDocument,
    options,
  );
}
export type PaymentMethodsQueryHookResult = ReturnType<typeof usePaymentMethodsQuery>;
export type PaymentMethodsQueryLazyQueryHookResult = ReturnType<
  typeof usePaymentMethodsQueryLazyQuery
>;
export type PaymentMethodsQuerySuspenseQueryHookResult = ReturnType<
  typeof usePaymentMethodsQuerySuspenseQuery
>;
export type PaymentMethodsQueryQueryResult = Apollo.QueryResult<
  PaymentMethodsQuery,
  PaymentMethodsQueryVariables
>;
export const PaymentMethodsRootQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PaymentMethodsRootQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'PaymentMethodsRootFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PaymentMethodsRootFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCurrentDeviceRecognized'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhoneLastTwo'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePaymentMethodsRootQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsRootQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsRootQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodsRootQuery(
  baseOptions?: Apollo.QueryHookOptions<PaymentMethodsRootQuery, PaymentMethodsRootQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PaymentMethodsRootQuery, PaymentMethodsRootQueryVariables>(
    PaymentMethodsRootQueryDocument,
    options,
  );
}
export function usePaymentMethodsRootQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentMethodsRootQuery,
    PaymentMethodsRootQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PaymentMethodsRootQuery, PaymentMethodsRootQueryVariables>(
    PaymentMethodsRootQueryDocument,
    options,
  );
}
// @ts-ignore
export function usePaymentMethodsRootQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaymentMethodsRootQuery,
    PaymentMethodsRootQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PaymentMethodsRootQuery, PaymentMethodsRootQueryVariables>;
export function usePaymentMethodsRootQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PaymentMethodsRootQuery, PaymentMethodsRootQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  PaymentMethodsRootQuery | undefined,
  PaymentMethodsRootQueryVariables
>;
export function usePaymentMethodsRootQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PaymentMethodsRootQuery, PaymentMethodsRootQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PaymentMethodsRootQuery, PaymentMethodsRootQueryVariables>(
    PaymentMethodsRootQueryDocument,
    options,
  );
}
export type PaymentMethodsRootQueryHookResult = ReturnType<typeof usePaymentMethodsRootQuery>;
export type PaymentMethodsRootQueryLazyQueryHookResult = ReturnType<
  typeof usePaymentMethodsRootQueryLazyQuery
>;
export type PaymentMethodsRootQuerySuspenseQueryHookResult = ReturnType<
  typeof usePaymentMethodsRootQuerySuspenseQuery
>;
export type PaymentMethodsRootQueryQueryResult = Apollo.QueryResult<
  PaymentMethodsRootQuery,
  PaymentMethodsRootQueryVariables
>;
export const PdfMenuQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PdfMenuQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'order'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'corpAccountName'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'brand'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'OrderFragment'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'cart'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orderItems'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isUtensils'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'dietaryFlags'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'isVegetarian'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isVegan'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isGlutenFree'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isKosher'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'isHalal'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'orderItemOptions'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'itemChoices'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'LineItemModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LineItemModifier'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cart'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'lineItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'sizeLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'groupOrderPersonName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'belongsToAnyEater'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totalInSubunits'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orderItemOptions'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'catererLabel'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'itemChoices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'LineItemModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'LineItemModifierFragment',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'modifiers'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'LineItemModifierFragment',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CustomerOrderStatusFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSubmitted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'submittedAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isAccepted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isReconfirmed'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fulfilledAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCustomerPaymentCaptured'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancellable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cancelledAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FirstOrderReferenceCodeFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'firstOrderReferenceCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corporateReferenceCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'EventFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'customerProvidedName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderType'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'perspective'},
                      value: {kind: 'EnumValue', value: 'CUSTOMER'},
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TotalsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totals'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalDue'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'subTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountDeliveryFee'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isStandardGroupOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'delivery'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'estimatedDropoffTime'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tracking'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'url'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryEvents'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'eventType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'time'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'review'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'includedUtensils'}},
                {kind: 'Field', name: {kind: 'Name', value: 'omittedUtensils'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corporateReferenceCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                {kind: 'Field', name: {kind: 'Name', value: 'requiresCreditLine'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                {kind: 'Field', name: {kind: 'Name', value: 'procurement'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'currentValue'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderId'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
                    },
                  ],
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CartFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CatererFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CustomerOrderStatusFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FirstOrderReferenceCodeFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'EventFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TotalsFragment'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePdfMenuQuery__
 *
 * To run a query within a React component, call `usePdfMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfMenuQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function usePdfMenuQuery(
  baseOptions: Apollo.QueryHookOptions<PdfMenuQuery, PdfMenuQueryVariables> &
    ({variables: PdfMenuQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PdfMenuQuery, PdfMenuQueryVariables>(PdfMenuQueryDocument, options);
}
export function usePdfMenuQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PdfMenuQuery, PdfMenuQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PdfMenuQuery, PdfMenuQueryVariables>(PdfMenuQueryDocument, options);
}
// @ts-ignore
export function usePdfMenuQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PdfMenuQuery, PdfMenuQueryVariables>,
): Apollo.UseSuspenseQueryResult<PdfMenuQuery, PdfMenuQueryVariables>;
export function usePdfMenuQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdfMenuQuery, PdfMenuQueryVariables>,
): Apollo.UseSuspenseQueryResult<PdfMenuQuery | undefined, PdfMenuQueryVariables>;
export function usePdfMenuQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdfMenuQuery, PdfMenuQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PdfMenuQuery, PdfMenuQueryVariables>(
    PdfMenuQueryDocument,
    options,
  );
}
export type PdfMenuQueryHookResult = ReturnType<typeof usePdfMenuQuery>;
export type PdfMenuQueryLazyQueryHookResult = ReturnType<typeof usePdfMenuQueryLazyQuery>;
export type PdfMenuQuerySuspenseQueryHookResult = ReturnType<typeof usePdfMenuQuerySuspenseQuery>;
export type PdfMenuQueryQueryResult = Apollo.QueryResult<PdfMenuQuery, PdfMenuQueryVariables>;
export const PersonalInformationPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PersonalInformationPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCurrentDeviceRecognized'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhoneLastTwo'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePersonalInformationPageQuery__
 *
 * To run a query within a React component, call `usePersonalInformationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalInformationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalInformationPageQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function usePersonalInformationPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PersonalInformationPageQuery,
    PersonalInformationPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PersonalInformationPageQuery, PersonalInformationPageQueryVariables>(
    PersonalInformationPageQueryDocument,
    options,
  );
}
export function usePersonalInformationPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PersonalInformationPageQuery,
    PersonalInformationPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PersonalInformationPageQuery, PersonalInformationPageQueryVariables>(
    PersonalInformationPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function usePersonalInformationPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PersonalInformationPageQuery,
    PersonalInformationPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PersonalInformationPageQuery,
  PersonalInformationPageQueryVariables
>;
export function usePersonalInformationPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PersonalInformationPageQuery,
        PersonalInformationPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PersonalInformationPageQuery | undefined,
  PersonalInformationPageQueryVariables
>;
export function usePersonalInformationPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PersonalInformationPageQuery,
        PersonalInformationPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    PersonalInformationPageQuery,
    PersonalInformationPageQueryVariables
  >(PersonalInformationPageQueryDocument, options);
}
export type PersonalInformationPageQueryHookResult = ReturnType<
  typeof usePersonalInformationPageQuery
>;
export type PersonalInformationPageQueryLazyQueryHookResult = ReturnType<
  typeof usePersonalInformationPageQueryLazyQuery
>;
export type PersonalInformationPageQuerySuspenseQueryHookResult = ReturnType<
  typeof usePersonalInformationPageQuerySuspenseQuery
>;
export type PersonalInformationPageQueryQueryResult = Apollo.QueryResult<
  PersonalInformationPageQuery,
  PersonalInformationPageQueryVariables
>;
export const PersonalInformationQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PersonalInformationQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastName'}},
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'noncachedemail'},
                        name: {kind: 'Name', value: 'email'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'cached'},
                            value: {kind: 'BooleanValue', value: false},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'email2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhoneLastTwo'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'officePhoneLastTwo'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'companyName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'jobTitle'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'emailSubscriptionsUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'canManageTaxCertificates'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'notificationSubscriptions'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'deliveryUpdate'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'txt'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'push'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'catererConfirmation'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'email'}}],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePersonalInformationQuery__
 *
 * To run a query within a React component, call `usePersonalInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalInformationQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function usePersonalInformationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PersonalInformationQuery,
    PersonalInformationQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PersonalInformationQuery, PersonalInformationQueryVariables>(
    PersonalInformationQueryDocument,
    options,
  );
}
export function usePersonalInformationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PersonalInformationQuery,
    PersonalInformationQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PersonalInformationQuery, PersonalInformationQueryVariables>(
    PersonalInformationQueryDocument,
    options,
  );
}
// @ts-ignore
export function usePersonalInformationQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PersonalInformationQuery,
    PersonalInformationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PersonalInformationQuery, PersonalInformationQueryVariables>;
export function usePersonalInformationQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PersonalInformationQuery, PersonalInformationQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  PersonalInformationQuery | undefined,
  PersonalInformationQueryVariables
>;
export function usePersonalInformationQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PersonalInformationQuery, PersonalInformationQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PersonalInformationQuery, PersonalInformationQueryVariables>(
    PersonalInformationQueryDocument,
    options,
  );
}
export type PersonalInformationQueryHookResult = ReturnType<typeof usePersonalInformationQuery>;
export type PersonalInformationQueryLazyQueryHookResult = ReturnType<
  typeof usePersonalInformationQueryLazyQuery
>;
export type PersonalInformationQuerySuspenseQueryHookResult = ReturnType<
  typeof usePersonalInformationQuerySuspenseQuery
>;
export type PersonalInformationQueryQueryResult = Apollo.QueryResult<
  PersonalInformationQuery,
  PersonalInformationQueryVariables
>;
export const PingQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PingQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ping'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'pong'}}],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePingQuery__
 *
 * To run a query within a React component, call `usePingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function usePingQuery(baseOptions?: Apollo.QueryHookOptions<PingQuery, PingQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PingQuery, PingQueryVariables>(PingQueryDocument, options);
}
export function usePingQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PingQuery, PingQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PingQuery, PingQueryVariables>(PingQueryDocument, options);
}
// @ts-ignore
export function usePingQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PingQuery, PingQueryVariables>,
): Apollo.UseSuspenseQueryResult<PingQuery, PingQueryVariables>;
export function usePingQuerySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PingQuery, PingQueryVariables>,
): Apollo.UseSuspenseQueryResult<PingQuery | undefined, PingQueryVariables>;
export function usePingQuerySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PingQuery, PingQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PingQuery, PingQueryVariables>(PingQueryDocument, options);
}
export type PingQueryHookResult = ReturnType<typeof usePingQuery>;
export type PingQueryLazyQueryHookResult = ReturnType<typeof usePingQueryLazyQuery>;
export type PingQuerySuspenseQueryHookResult = ReturnType<typeof usePingQuerySuspenseQuery>;
export type PingQueryQueryResult = Apollo.QueryResult<PingQuery, PingQueryVariables>;
export const PopularNearYouQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'PopularNearYouQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchAddress'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'popularNearYou'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'catererId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'address'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventDateTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brands'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'brandName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'catererId'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'imageUrl'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePopularNearYouQuery__
 *
 * To run a query within a React component, call `usePopularNearYouQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularNearYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularNearYouQuery({
 *   variables: {
 *      catererId: // value for 'catererId'
 *      address: // value for 'address'
 *      eventDateTime: // value for 'eventDateTime'
 *   },
 * });
 */
export function usePopularNearYouQuery(
  baseOptions: Apollo.QueryHookOptions<PopularNearYouQuery, PopularNearYouQueryVariables> &
    ({variables: PopularNearYouQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<PopularNearYouQuery, PopularNearYouQueryVariables>(
    PopularNearYouQueryDocument,
    options,
  );
}
export function usePopularNearYouQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PopularNearYouQuery, PopularNearYouQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<PopularNearYouQuery, PopularNearYouQueryVariables>(
    PopularNearYouQueryDocument,
    options,
  );
}
// @ts-ignore
export function usePopularNearYouQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PopularNearYouQuery, PopularNearYouQueryVariables>,
): Apollo.UseSuspenseQueryResult<PopularNearYouQuery, PopularNearYouQueryVariables>;
export function usePopularNearYouQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PopularNearYouQuery, PopularNearYouQueryVariables>,
): Apollo.UseSuspenseQueryResult<PopularNearYouQuery | undefined, PopularNearYouQueryVariables>;
export function usePopularNearYouQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PopularNearYouQuery, PopularNearYouQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<PopularNearYouQuery, PopularNearYouQueryVariables>(
    PopularNearYouQueryDocument,
    options,
  );
}
export type PopularNearYouQueryHookResult = ReturnType<typeof usePopularNearYouQuery>;
export type PopularNearYouQueryLazyQueryHookResult = ReturnType<
  typeof usePopularNearYouQueryLazyQuery
>;
export type PopularNearYouQuerySuspenseQueryHookResult = ReturnType<
  typeof usePopularNearYouQuerySuspenseQuery
>;
export type PopularNearYouQueryQueryResult = Apollo.QueryResult<
  PopularNearYouQuery,
  PopularNearYouQueryVariables
>;
export const ReceiptsPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReceiptsPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventBefore'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ReceiptsQueryConsumerAccountFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'RECEIPT'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'searchString'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'eventAfter'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'eventBefore'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'eventBefore'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ReceiptsQueryOrderFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReceiptsQueryConsumerAccountFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'concurAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'areReceiptsAutomated'}},
                {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'canAccessConcur'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'corpDeptCodesVisible'},
            name: {kind: 'Name', value: 'corpCodesVisible'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'showCorpReferenceCodes'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corpReferenceCodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corpDeptCodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ownedCorporateAccounts'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReceiptsQueryOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'OrderConnection'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalCustomerSpend'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'edges'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'node'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isPaymentPending'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasCorpDeptCode'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'caterer'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'brand'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'customerOrderStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'currentStatusDisplay'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'isCustomerPaymentCaptured'},
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'concurOrderStatus'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'firstOrderReferenceCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateReferenceCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'paidByUserId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'review'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'},
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totals'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'customerTotalDue'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'event'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'address'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'orderReferenceCodes'},
                        name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateReferenceCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corpAccount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateDepartment'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReceiptsPageQuery__
 *
 * To run a query within a React component, call `useReceiptsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceiptsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceiptsPageQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      eventAfter: // value for 'eventAfter'
 *      eventBefore: // value for 'eventBefore'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useReceiptsPageQuery(
  baseOptions: Apollo.QueryHookOptions<ReceiptsPageQuery, ReceiptsPageQueryVariables> &
    ({variables: ReceiptsPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReceiptsPageQuery, ReceiptsPageQueryVariables>(
    ReceiptsPageQueryDocument,
    options,
  );
}
export function useReceiptsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReceiptsPageQuery, ReceiptsPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReceiptsPageQuery, ReceiptsPageQueryVariables>(
    ReceiptsPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useReceiptsPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReceiptsPageQuery, ReceiptsPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReceiptsPageQuery, ReceiptsPageQueryVariables>;
export function useReceiptsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReceiptsPageQuery, ReceiptsPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReceiptsPageQuery | undefined, ReceiptsPageQueryVariables>;
export function useReceiptsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReceiptsPageQuery, ReceiptsPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ReceiptsPageQuery, ReceiptsPageQueryVariables>(
    ReceiptsPageQueryDocument,
    options,
  );
}
export type ReceiptsPageQueryHookResult = ReturnType<typeof useReceiptsPageQuery>;
export type ReceiptsPageQueryLazyQueryHookResult = ReturnType<typeof useReceiptsPageQueryLazyQuery>;
export type ReceiptsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useReceiptsPageQuerySuspenseQuery
>;
export type ReceiptsPageQueryQueryResult = Apollo.QueryResult<
  ReceiptsPageQuery,
  ReceiptsPageQueryVariables
>;
export const ReceiptsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReceiptsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventBefore'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          defaultValue: {kind: 'NullValue'},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ReceiptsQueryConsumerAccountFragment'},
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'RECEIPT'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'searchString'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'eventAfter'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'eventBefore'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'eventBefore'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'corpAccountUuids'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ReceiptsQueryOrderFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReceiptsQueryConsumerAccountFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'email'}},
          {kind: 'Field', name: {kind: 'Name', value: 'trackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'concurAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'areReceiptsAutomated'}},
                {kind: 'Field', name: {kind: 'Name', value: 'createdAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'canAccessConcur'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'corpDeptCodesVisible'},
            name: {kind: 'Name', value: 'corpCodesVisible'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateAccount'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'showCorpReferenceCodes'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corpReferenceCodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corpDeptCodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'ownedCorporateAccounts'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReceiptsQueryOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'OrderConnection'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totalCustomerSpend'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'edges'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'node'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isCorporate'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isPaymentPending'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasCorpDeptCode'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'caterer'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'brand'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'customerOrderStatus'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'currentStatusDisplay'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'isCustomerPaymentCaptured'},
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'concurOrderStatus'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'firstOrderReferenceCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateReferenceCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'paidByUserId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'review'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'},
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totals'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'customerTotalDue'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'event'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'address'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'orderReferenceCodes'},
                        name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'corporateReferenceCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corpAccount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateDepartment'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReceiptsQuery__
 *
 * To run a query within a React component, call `useReceiptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceiptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceiptsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      eventAfter: // value for 'eventAfter'
 *      eventBefore: // value for 'eventBefore'
 *      accountUuid: // value for 'accountUuid'
 *      selectedAccountUuidsForOrders: // value for 'selectedAccountUuidsForOrders'
 *   },
 * });
 */
export function useReceiptsQuery(
  baseOptions: Apollo.QueryHookOptions<ReceiptsQuery, ReceiptsQueryVariables> &
    ({variables: ReceiptsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReceiptsQuery, ReceiptsQueryVariables>(ReceiptsQueryDocument, options);
}
export function useReceiptsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReceiptsQuery, ReceiptsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReceiptsQuery, ReceiptsQueryVariables>(ReceiptsQueryDocument, options);
}
// @ts-ignore
export function useReceiptsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReceiptsQuery, ReceiptsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReceiptsQuery, ReceiptsQueryVariables>;
export function useReceiptsQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReceiptsQuery, ReceiptsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReceiptsQuery | undefined, ReceiptsQueryVariables>;
export function useReceiptsQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReceiptsQuery, ReceiptsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ReceiptsQuery, ReceiptsQueryVariables>(
    ReceiptsQueryDocument,
    options,
  );
}
export type ReceiptsQueryHookResult = ReturnType<typeof useReceiptsQuery>;
export type ReceiptsQueryLazyQueryHookResult = ReturnType<typeof useReceiptsQueryLazyQuery>;
export type ReceiptsQuerySuspenseQueryHookResult = ReturnType<typeof useReceiptsQuerySuspenseQuery>;
export type ReceiptsQueryQueryResult = Apollo.QueryResult<ReceiptsQuery, ReceiptsQueryVariables>;
export const RecommendedDefaultAddressQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'RecommendedDefaultAddressQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'useGeoIP'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: true},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'useGeoip'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'useGeoIP'}},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'RecommendedDefaultAddressFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'RecommendedDefaultAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'GeocodedAddressResult'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'street'}},
          {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
          {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRecommendedDefaultAddressQuery__
 *
 * To run a query within a React component, call `useRecommendedDefaultAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedDefaultAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedDefaultAddressQuery({
 *   variables: {
 *      useGeoIP: // value for 'useGeoIP'
 *   },
 * });
 */
export function useRecommendedDefaultAddressQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecommendedDefaultAddressQuery,
    RecommendedDefaultAddressQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<RecommendedDefaultAddressQuery, RecommendedDefaultAddressQueryVariables>(
    RecommendedDefaultAddressQueryDocument,
    options,
  );
}
export function useRecommendedDefaultAddressQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecommendedDefaultAddressQuery,
    RecommendedDefaultAddressQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    RecommendedDefaultAddressQuery,
    RecommendedDefaultAddressQueryVariables
  >(RecommendedDefaultAddressQueryDocument, options);
}
// @ts-ignore
export function useRecommendedDefaultAddressQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecommendedDefaultAddressQuery,
    RecommendedDefaultAddressQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecommendedDefaultAddressQuery,
  RecommendedDefaultAddressQueryVariables
>;
export function useRecommendedDefaultAddressQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendedDefaultAddressQuery,
        RecommendedDefaultAddressQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecommendedDefaultAddressQuery | undefined,
  RecommendedDefaultAddressQueryVariables
>;
export function useRecommendedDefaultAddressQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendedDefaultAddressQuery,
        RecommendedDefaultAddressQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    RecommendedDefaultAddressQuery,
    RecommendedDefaultAddressQueryVariables
  >(RecommendedDefaultAddressQueryDocument, options);
}
export type RecommendedDefaultAddressQueryHookResult = ReturnType<
  typeof useRecommendedDefaultAddressQuery
>;
export type RecommendedDefaultAddressQueryLazyQueryHookResult = ReturnType<
  typeof useRecommendedDefaultAddressQueryLazyQuery
>;
export type RecommendedDefaultAddressQuerySuspenseQueryHookResult = ReturnType<
  typeof useRecommendedDefaultAddressQuerySuspenseQuery
>;
export type RecommendedDefaultAddressQueryQueryResult = Apollo.QueryResult<
  RecommendedDefaultAddressQuery,
  RecommendedDefaultAddressQueryVariables
>;
export const ReferAFriendDescriptionQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReferAFriendDescriptionQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerReferralFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerReferralFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'giftCardRedemptionAllowed'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReferAFriendDescriptionQuery__
 *
 * To run a query within a React component, call `useReferAFriendDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferAFriendDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferAFriendDescriptionQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useReferAFriendDescriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ReferAFriendDescriptionQuery,
    ReferAFriendDescriptionQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReferAFriendDescriptionQuery, ReferAFriendDescriptionQueryVariables>(
    ReferAFriendDescriptionQueryDocument,
    options,
  );
}
export function useReferAFriendDescriptionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReferAFriendDescriptionQuery,
    ReferAFriendDescriptionQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReferAFriendDescriptionQuery, ReferAFriendDescriptionQueryVariables>(
    ReferAFriendDescriptionQueryDocument,
    options,
  );
}
// @ts-ignore
export function useReferAFriendDescriptionQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReferAFriendDescriptionQuery,
    ReferAFriendDescriptionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ReferAFriendDescriptionQuery,
  ReferAFriendDescriptionQueryVariables
>;
export function useReferAFriendDescriptionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReferAFriendDescriptionQuery,
        ReferAFriendDescriptionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ReferAFriendDescriptionQuery | undefined,
  ReferAFriendDescriptionQueryVariables
>;
export function useReferAFriendDescriptionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReferAFriendDescriptionQuery,
        ReferAFriendDescriptionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    ReferAFriendDescriptionQuery,
    ReferAFriendDescriptionQueryVariables
  >(ReferAFriendDescriptionQueryDocument, options);
}
export type ReferAFriendDescriptionQueryHookResult = ReturnType<
  typeof useReferAFriendDescriptionQuery
>;
export type ReferAFriendDescriptionQueryLazyQueryHookResult = ReturnType<
  typeof useReferAFriendDescriptionQueryLazyQuery
>;
export type ReferAFriendDescriptionQuerySuspenseQueryHookResult = ReturnType<
  typeof useReferAFriendDescriptionQuerySuspenseQuery
>;
export type ReferAFriendDescriptionQueryQueryResult = Apollo.QueryResult<
  ReferAFriendDescriptionQuery,
  ReferAFriendDescriptionQueryVariables
>;
export const ReferAFriendPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReferAFriendPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ConsumerReferralFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ConsumerReferralFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'giftCardRedemptionAllowed'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'accountUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
              },
            ],
          },
          {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralUrl'}},
          {kind: 'Field', name: {kind: 'Name', value: 'referralCode'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReferAFriendPageQuery__
 *
 * To run a query within a React component, call `useReferAFriendPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferAFriendPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferAFriendPageQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useReferAFriendPageQuery(
  baseOptions?: Apollo.QueryHookOptions<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>(
    ReferAFriendPageQueryDocument,
    options,
  );
}
export function useReferAFriendPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>(
    ReferAFriendPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useReferAFriendPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReferAFriendPageQuery,
    ReferAFriendPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>;
export function useReferAFriendPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReferAFriendPageQuery | undefined, ReferAFriendPageQueryVariables>;
export function useReferAFriendPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ReferAFriendPageQuery, ReferAFriendPageQueryVariables>(
    ReferAFriendPageQueryDocument,
    options,
  );
}
export type ReferAFriendPageQueryHookResult = ReturnType<typeof useReferAFriendPageQuery>;
export type ReferAFriendPageQueryLazyQueryHookResult = ReturnType<
  typeof useReferAFriendPageQueryLazyQuery
>;
export type ReferAFriendPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useReferAFriendPageQuerySuspenseQuery
>;
export type ReferAFriendPageQueryQueryResult = Apollo.QueryResult<
  ReferAFriendPageQuery,
  ReferAFriendPageQueryVariables
>;
export const ReferralRewardsSummaryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReferralRewardsSummary'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'invitedReferrals'},
                        name: {kind: 'Name', value: 'referrals'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'status'},
                            value: {kind: 'EnumValue', value: 'INVITED'},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'joinedReferrals'},
                        name: {kind: 'Name', value: 'referrals'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'status'},
                            value: {kind: 'EnumValue', value: 'JOINED'},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              alias: {kind: 'Name', value: 'referralEarnings'},
                              name: {kind: 'Name', value: 'activities'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'categories'},
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {kind: 'EnumValue', value: 'GIVEN_FOR_REFERRAL'},
                                      {kind: 'EnumValue', value: 'GIVEN_FOR_ORDER_THRU_REFERRAL'},
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'totalAmount'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              alias: {kind: 'Name', value: 'friendsWhoOrdered'},
                              name: {kind: 'Name', value: 'activities'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'categories'},
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {kind: 'EnumValue', value: 'GIVEN_FOR_ORDER_THRU_REFERRAL'},
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReferralRewardsSummaryQuery__
 *
 * To run a query within a React component, call `useReferralRewardsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralRewardsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralRewardsSummaryQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useReferralRewardsSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ReferralRewardsSummaryQuery,
    ReferralRewardsSummaryQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReferralRewardsSummaryQuery, ReferralRewardsSummaryQueryVariables>(
    ReferralRewardsSummaryDocument,
    options,
  );
}
export function useReferralRewardsSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReferralRewardsSummaryQuery,
    ReferralRewardsSummaryQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReferralRewardsSummaryQuery, ReferralRewardsSummaryQueryVariables>(
    ReferralRewardsSummaryDocument,
    options,
  );
}
// @ts-ignore
export function useReferralRewardsSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReferralRewardsSummaryQuery,
    ReferralRewardsSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ReferralRewardsSummaryQuery, ReferralRewardsSummaryQueryVariables>;
export function useReferralRewardsSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReferralRewardsSummaryQuery,
        ReferralRewardsSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ReferralRewardsSummaryQuery | undefined,
  ReferralRewardsSummaryQueryVariables
>;
export function useReferralRewardsSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReferralRewardsSummaryQuery,
        ReferralRewardsSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ReferralRewardsSummaryQuery, ReferralRewardsSummaryQueryVariables>(
    ReferralRewardsSummaryDocument,
    options,
  );
}
export type ReferralRewardsSummaryQueryHookResult = ReturnType<
  typeof useReferralRewardsSummaryQuery
>;
export type ReferralRewardsSummaryLazyQueryHookResult = ReturnType<
  typeof useReferralRewardsSummaryLazyQuery
>;
export type ReferralRewardsSummarySuspenseQueryHookResult = ReturnType<
  typeof useReferralRewardsSummarySuspenseQuery
>;
export type ReferralRewardsSummaryQueryResult = Apollo.QueryResult<
  ReferralRewardsSummaryQuery,
  ReferralRewardsSummaryQueryVariables
>;
export const ReferralsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReferralsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referrals'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'reminder'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'activities'},
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {kind: 'Name', value: 'categories'},
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {kind: 'EnumValue', value: 'GIVEN_FOR_REFERRAL'},
                                      {kind: 'EnumValue', value: 'GIVEN_FOR_ORDER_THRU_REFERRAL'},
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'totalAmount'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReferralsQuery__
 *
 * To run a query within a React component, call `useReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useReferralsQuery(
  baseOptions?: Apollo.QueryHookOptions<ReferralsQuery, ReferralsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReferralsQuery, ReferralsQueryVariables>(ReferralsQueryDocument, options);
}
export function useReferralsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReferralsQuery, ReferralsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReferralsQuery, ReferralsQueryVariables>(
    ReferralsQueryDocument,
    options,
  );
}
// @ts-ignore
export function useReferralsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReferralsQuery, ReferralsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReferralsQuery, ReferralsQueryVariables>;
export function useReferralsQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferralsQuery, ReferralsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReferralsQuery | undefined, ReferralsQueryVariables>;
export function useReferralsQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferralsQuery, ReferralsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ReferralsQuery, ReferralsQueryVariables>(
    ReferralsQueryDocument,
    options,
  );
}
export type ReferralsQueryHookResult = ReturnType<typeof useReferralsQuery>;
export type ReferralsQueryLazyQueryHookResult = ReturnType<typeof useReferralsQueryLazyQuery>;
export type ReferralsQuerySuspenseQueryHookResult = ReturnType<
  typeof useReferralsQuerySuspenseQuery
>;
export type ReferralsQueryQueryResult = Apollo.QueryResult<ReferralsQuery, ReferralsQueryVariables>;
export const ReferralsTableQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReferralsTableQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referrals'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'pointsEarned'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'reminder'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReferralsTableQuery__
 *
 * To run a query within a React component, call `useReferralsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralsTableQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useReferralsTableQuery(
  baseOptions?: Apollo.QueryHookOptions<ReferralsTableQuery, ReferralsTableQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReferralsTableQuery, ReferralsTableQueryVariables>(
    ReferralsTableQueryDocument,
    options,
  );
}
export function useReferralsTableQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReferralsTableQuery, ReferralsTableQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReferralsTableQuery, ReferralsTableQueryVariables>(
    ReferralsTableQueryDocument,
    options,
  );
}
// @ts-ignore
export function useReferralsTableQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReferralsTableQuery, ReferralsTableQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReferralsTableQuery, ReferralsTableQueryVariables>;
export function useReferralsTableQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReferralsTableQuery, ReferralsTableQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReferralsTableQuery | undefined, ReferralsTableQueryVariables>;
export function useReferralsTableQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReferralsTableQuery, ReferralsTableQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ReferralsTableQuery, ReferralsTableQueryVariables>(
    ReferralsTableQueryDocument,
    options,
  );
}
export type ReferralsTableQueryHookResult = ReturnType<typeof useReferralsTableQuery>;
export type ReferralsTableQueryLazyQueryHookResult = ReturnType<
  typeof useReferralsTableQueryLazyQuery
>;
export type ReferralsTableQuerySuspenseQueryHookResult = ReturnType<
  typeof useReferralsTableQuerySuspenseQuery
>;
export type ReferralsTableQueryQueryResult = Apollo.QueryResult<
  ReferralsTableQuery,
  ReferralsTableQueryVariables
>;
export const ReviewModalQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReviewModalQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'RecommendedDefaultAddressFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'RecommendedDefaultAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'GeocodedAddressResult'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'street'}},
          {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
          {kind: 'Field', name: {kind: 'Name', value: 'city'}},
          {kind: 'Field', name: {kind: 'Name', value: 'state'}},
          {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
          {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReviewModalQuery__
 *
 * To run a query within a React component, call `useReviewModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useReviewModalQuery(
  baseOptions?: Apollo.QueryHookOptions<ReviewModalQuery, ReviewModalQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReviewModalQuery, ReviewModalQueryVariables>(
    ReviewModalQueryDocument,
    options,
  );
}
export function useReviewModalQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReviewModalQuery, ReviewModalQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReviewModalQuery, ReviewModalQueryVariables>(
    ReviewModalQueryDocument,
    options,
  );
}
// @ts-ignore
export function useReviewModalQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewModalQuery, ReviewModalQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReviewModalQuery, ReviewModalQueryVariables>;
export function useReviewModalQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewModalQuery, ReviewModalQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReviewModalQuery | undefined, ReviewModalQueryVariables>;
export function useReviewModalQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewModalQuery, ReviewModalQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ReviewModalQuery, ReviewModalQueryVariables>(
    ReviewModalQueryDocument,
    options,
  );
}
export type ReviewModalQueryHookResult = ReturnType<typeof useReviewModalQuery>;
export type ReviewModalQueryLazyQueryHookResult = ReturnType<typeof useReviewModalQueryLazyQuery>;
export type ReviewModalQuerySuspenseQueryHookResult = ReturnType<
  typeof useReviewModalQuerySuspenseQuery
>;
export type ReviewModalQueryQueryResult = Apollo.QueryResult<
  ReviewModalQuery,
  ReviewModalQueryVariables
>;
export const ReviewableOrdersQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReviewableOrdersQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'ordersLimit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'accountIdentifier'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'ordersLimit'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'PENDING_REVIEW'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'corpAccountUuids'},
                            value: {
                              kind: 'Variable',
                              name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'daysLeftToReview'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'isReviewDeadlineApproaching'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'event'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'caterer'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'isSavedCaterer'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'brand'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'orderSourceType'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReviewableOrdersQuery__
 *
 * To run a query within a React component, call `useReviewableOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewableOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewableOrdersQuery({
 *   variables: {
 *      ordersLimit: // value for 'ordersLimit'
 *      selectedAccountUuidsForOrders: // value for 'selectedAccountUuidsForOrders'
 *   },
 * });
 */
export function useReviewableOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<ReviewableOrdersQuery, ReviewableOrdersQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReviewableOrdersQuery, ReviewableOrdersQueryVariables>(
    ReviewableOrdersQueryDocument,
    options,
  );
}
export function useReviewableOrdersQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReviewableOrdersQuery, ReviewableOrdersQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReviewableOrdersQuery, ReviewableOrdersQueryVariables>(
    ReviewableOrdersQueryDocument,
    options,
  );
}
// @ts-ignore
export function useReviewableOrdersQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReviewableOrdersQuery,
    ReviewableOrdersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ReviewableOrdersQuery, ReviewableOrdersQueryVariables>;
export function useReviewableOrdersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReviewableOrdersQuery, ReviewableOrdersQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReviewableOrdersQuery | undefined, ReviewableOrdersQueryVariables>;
export function useReviewableOrdersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReviewableOrdersQuery, ReviewableOrdersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ReviewableOrdersQuery, ReviewableOrdersQueryVariables>(
    ReviewableOrdersQueryDocument,
    options,
  );
}
export type ReviewableOrdersQueryHookResult = ReturnType<typeof useReviewableOrdersQuery>;
export type ReviewableOrdersQueryLazyQueryHookResult = ReturnType<
  typeof useReviewableOrdersQueryLazyQuery
>;
export type ReviewableOrdersQuerySuspenseQueryHookResult = ReturnType<
  typeof useReviewableOrdersQuerySuspenseQuery
>;
export type ReviewableOrdersQueryQueryResult = Apollo.QueryResult<
  ReviewableOrdersQuery,
  ReviewableOrdersQueryVariables
>;
export const ReviewsForTablesQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReviewsForTablesQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ReviewableOrdersFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReviewableOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'daysLeftToReview'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReviewDeadlineApproaching'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'review'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReviewableOrdersFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'reviewableOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'offset'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'REVIEWABLE'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'corpAccountUuids'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ReviewableOrderFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReviewsForTablesQuery__
 *
 * To run a query within a React component, call `useReviewsForTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsForTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsForTablesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      selectedAccountUuidsForOrders: // value for 'selectedAccountUuidsForOrders'
 *   },
 * });
 */
export function useReviewsForTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<ReviewsForTablesQuery, ReviewsForTablesQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReviewsForTablesQuery, ReviewsForTablesQueryVariables>(
    ReviewsForTablesQueryDocument,
    options,
  );
}
export function useReviewsForTablesQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReviewsForTablesQuery, ReviewsForTablesQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReviewsForTablesQuery, ReviewsForTablesQueryVariables>(
    ReviewsForTablesQueryDocument,
    options,
  );
}
// @ts-ignore
export function useReviewsForTablesQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReviewsForTablesQuery,
    ReviewsForTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ReviewsForTablesQuery, ReviewsForTablesQueryVariables>;
export function useReviewsForTablesQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReviewsForTablesQuery, ReviewsForTablesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReviewsForTablesQuery | undefined, ReviewsForTablesQueryVariables>;
export function useReviewsForTablesQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReviewsForTablesQuery, ReviewsForTablesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ReviewsForTablesQuery, ReviewsForTablesQueryVariables>(
    ReviewsForTablesQueryDocument,
    options,
  );
}
export type ReviewsForTablesQueryHookResult = ReturnType<typeof useReviewsForTablesQuery>;
export type ReviewsForTablesQueryLazyQueryHookResult = ReturnType<
  typeof useReviewsForTablesQueryLazyQuery
>;
export type ReviewsForTablesQuerySuspenseQueryHookResult = ReturnType<
  typeof useReviewsForTablesQuerySuspenseQuery
>;
export type ReviewsForTablesQueryQueryResult = Apollo.QueryResult<
  ReviewsForTablesQuery,
  ReviewsForTablesQueryVariables
>;
export const ReviewsPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ReviewsPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'eligibleForAdditionalEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'ReviewableOrdersFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReviewableOrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'daysLeftToReview'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReviewDeadlineApproaching'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'review'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'ReviewableOrdersFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ConsumerAccount'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'reviewableOrders'},
            name: {kind: 'Name', value: 'orders'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'offset'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'filter'},
                value: {kind: 'EnumValue', value: 'REVIEWABLE'},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'corpAccountUuids'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'selectedAccountUuidsForOrders'},
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'ReviewableOrderFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useReviewsPageQuery__
 *
 * To run a query within a React component, call `useReviewsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsPageQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      accountUuid: // value for 'accountUuid'
 *      selectedAccountUuidsForOrders: // value for 'selectedAccountUuidsForOrders'
 *   },
 * });
 */
export function useReviewsPageQuery(
  baseOptions?: Apollo.QueryHookOptions<ReviewsPageQuery, ReviewsPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ReviewsPageQuery, ReviewsPageQueryVariables>(
    ReviewsPageQueryDocument,
    options,
  );
}
export function useReviewsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReviewsPageQuery, ReviewsPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ReviewsPageQuery, ReviewsPageQueryVariables>(
    ReviewsPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useReviewsPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewsPageQuery, ReviewsPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReviewsPageQuery, ReviewsPageQueryVariables>;
export function useReviewsPageQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewsPageQuery, ReviewsPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReviewsPageQuery | undefined, ReviewsPageQueryVariables>;
export function useReviewsPageQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewsPageQuery, ReviewsPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ReviewsPageQuery, ReviewsPageQueryVariables>(
    ReviewsPageQueryDocument,
    options,
  );
}
export type ReviewsPageQueryHookResult = ReturnType<typeof useReviewsPageQuery>;
export type ReviewsPageQueryLazyQueryHookResult = ReturnType<typeof useReviewsPageQueryLazyQuery>;
export type ReviewsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useReviewsPageQuerySuspenseQuery
>;
export type ReviewsPageQueryQueryResult = Apollo.QueryResult<
  ReviewsPageQuery,
  ReviewsPageQueryVariables
>;
export const SavedAddressSearchQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SavedAddressSearchQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'corpAccountId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'addresses'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'searchString'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'sortBy'},
                            value: {kind: 'EnumValue', value: 'LAST_USED_AT'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'sortDirection'},
                            value: {kind: 'EnumValue', value: 'DESC'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'corpAccountId'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'corpAccountId'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'edges'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'node'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'addressBookEntryId'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'addressBookEntry'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'corporate'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSavedAddressSearchQuery__
 *
 * To run a query within a React component, call `useSavedAddressSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedAddressSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedAddressSearchQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      corpAccountId: // value for 'corpAccountId'
 *   },
 * });
 */
export function useSavedAddressSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<SavedAddressSearchQuery, SavedAddressSearchQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SavedAddressSearchQuery, SavedAddressSearchQueryVariables>(
    SavedAddressSearchQueryDocument,
    options,
  );
}
export function useSavedAddressSearchQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SavedAddressSearchQuery,
    SavedAddressSearchQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SavedAddressSearchQuery, SavedAddressSearchQueryVariables>(
    SavedAddressSearchQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSavedAddressSearchQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SavedAddressSearchQuery,
    SavedAddressSearchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SavedAddressSearchQuery, SavedAddressSearchQueryVariables>;
export function useSavedAddressSearchQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SavedAddressSearchQuery, SavedAddressSearchQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  SavedAddressSearchQuery | undefined,
  SavedAddressSearchQueryVariables
>;
export function useSavedAddressSearchQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SavedAddressSearchQuery, SavedAddressSearchQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SavedAddressSearchQuery, SavedAddressSearchQueryVariables>(
    SavedAddressSearchQueryDocument,
    options,
  );
}
export type SavedAddressSearchQueryHookResult = ReturnType<typeof useSavedAddressSearchQuery>;
export type SavedAddressSearchQueryLazyQueryHookResult = ReturnType<
  typeof useSavedAddressSearchQueryLazyQuery
>;
export type SavedAddressSearchQuerySuspenseQueryHookResult = ReturnType<
  typeof useSavedAddressSearchQuerySuspenseQuery
>;
export type SavedAddressSearchQueryQueryResult = Apollo.QueryResult<
  SavedAddressSearchQuery,
  SavedAddressSearchQueryVariables
>;
export const SavedCaterersPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SavedCaterersPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'savedCaterers'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'limit'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'offset'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'nodes'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SavedCatererFragment'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'addresses'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'IntValue', value: '0'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'IntValue', value: '1'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'sortBy'},
                            value: {kind: 'EnumValue', value: 'LAST_USED_AT'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'sortDirection'},
                            value: {kind: 'EnumValue', value: 'DESC'},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SavedCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isNew'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'heroImage'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobileSearchUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'graphExperiments'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryFeeExperiment'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'v2'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'flagKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allocationKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'experimentKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'variation'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'pricingModel'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CappedDeliveryFeePricingModel'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cap'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'currency'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSavedCaterersPageQuery__
 *
 * To run a query within a React component, call `useSavedCaterersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedCaterersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedCaterersPageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useSavedCaterersPageQuery(
  baseOptions?: Apollo.QueryHookOptions<SavedCaterersPageQuery, SavedCaterersPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SavedCaterersPageQuery, SavedCaterersPageQueryVariables>(
    SavedCaterersPageQueryDocument,
    options,
  );
}
export function useSavedCaterersPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SavedCaterersPageQuery,
    SavedCaterersPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SavedCaterersPageQuery, SavedCaterersPageQueryVariables>(
    SavedCaterersPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSavedCaterersPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SavedCaterersPageQuery,
    SavedCaterersPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SavedCaterersPageQuery, SavedCaterersPageQueryVariables>;
export function useSavedCaterersPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SavedCaterersPageQuery, SavedCaterersPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  SavedCaterersPageQuery | undefined,
  SavedCaterersPageQueryVariables
>;
export function useSavedCaterersPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SavedCaterersPageQuery, SavedCaterersPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SavedCaterersPageQuery, SavedCaterersPageQueryVariables>(
    SavedCaterersPageQueryDocument,
    options,
  );
}
export type SavedCaterersPageQueryHookResult = ReturnType<typeof useSavedCaterersPageQuery>;
export type SavedCaterersPageQueryLazyQueryHookResult = ReturnType<
  typeof useSavedCaterersPageQueryLazyQuery
>;
export type SavedCaterersPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useSavedCaterersPageQuerySuspenseQuery
>;
export type SavedCaterersPageQueryQueryResult = Apollo.QueryResult<
  SavedCaterersPageQuery,
  SavedCaterersPageQueryVariables
>;
export const SavedCaterersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SavedCaterers'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'after'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'before'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'first'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'last'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'savedCaterers'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'after'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'after'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'first'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'first'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'before'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'before'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'last'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'last'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'edges'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'node'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'SavedCatererFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SavedCatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Caterer'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'minimumDeliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'amount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'subunits'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isNew'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'brand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'heroImage'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'mobileSearchUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSavedCaterersQuery__
 *
 * To run a query within a React component, call `useSavedCaterersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedCaterersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedCaterersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useSavedCaterersQuery(
  baseOptions?: Apollo.QueryHookOptions<SavedCaterersQuery, SavedCaterersQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SavedCaterersQuery, SavedCaterersQueryVariables>(
    SavedCaterersDocument,
    options,
  );
}
export function useSavedCaterersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SavedCaterersQuery, SavedCaterersQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SavedCaterersQuery, SavedCaterersQueryVariables>(
    SavedCaterersDocument,
    options,
  );
}
// @ts-ignore
export function useSavedCaterersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SavedCaterersQuery, SavedCaterersQueryVariables>,
): Apollo.UseSuspenseQueryResult<SavedCaterersQuery, SavedCaterersQueryVariables>;
export function useSavedCaterersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SavedCaterersQuery, SavedCaterersQueryVariables>,
): Apollo.UseSuspenseQueryResult<SavedCaterersQuery | undefined, SavedCaterersQueryVariables>;
export function useSavedCaterersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SavedCaterersQuery, SavedCaterersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SavedCaterersQuery, SavedCaterersQueryVariables>(
    SavedCaterersDocument,
    options,
  );
}
export type SavedCaterersQueryHookResult = ReturnType<typeof useSavedCaterersQuery>;
export type SavedCaterersLazyQueryHookResult = ReturnType<typeof useSavedCaterersLazyQuery>;
export type SavedCaterersSuspenseQueryHookResult = ReturnType<typeof useSavedCaterersSuspenseQuery>;
export type SavedCaterersQueryResult = Apollo.QueryResult<
  SavedCaterersQuery,
  SavedCaterersQueryVariables
>;
export const SearchCollectionQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SearchCollectionQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'collectionUuid'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchAddress'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'TimeWithoutZone'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchOrderType'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'marketplaceSearchCollection'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'collectionUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'collectionUuid'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'address'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventDateTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'trackingId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'analyticsSearchId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'FragmentSpread', name: {kind: 'Name', value: 'SearchResultFragment'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SearchResultFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchResult'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'searchResultBrand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoImageSrc'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'imageSrc'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'distance'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isNew'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'priceRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'slotReservation'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'SponsoredListingReservation'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'topsortBidId'}}],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'topsortProductId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'variableDeliveryFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'onTimeRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestBrandReviewText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestBrandReviewAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestReviewText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestReviewAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'repeatUserRate'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sponsoredPromoTitles'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSearchCollectionQuery__
 *
 * To run a query within a React component, call `useSearchCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCollectionQuery({
 *   variables: {
 *      collectionUuid: // value for 'collectionUuid'
 *      address: // value for 'address'
 *      eventDateTime: // value for 'eventDateTime'
 *      eventTime: // value for 'eventTime'
 *      orderType: // value for 'orderType'
 *      trackingId: // value for 'trackingId'
 *   },
 * });
 */
export function useSearchCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<SearchCollectionQuery, SearchCollectionQueryVariables> &
    ({variables: SearchCollectionQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SearchCollectionQuery, SearchCollectionQueryVariables>(
    SearchCollectionQueryDocument,
    options,
  );
}
export function useSearchCollectionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchCollectionQuery, SearchCollectionQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SearchCollectionQuery, SearchCollectionQueryVariables>(
    SearchCollectionQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSearchCollectionQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchCollectionQuery,
    SearchCollectionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchCollectionQuery, SearchCollectionQueryVariables>;
export function useSearchCollectionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchCollectionQuery, SearchCollectionQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchCollectionQuery | undefined, SearchCollectionQueryVariables>;
export function useSearchCollectionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchCollectionQuery, SearchCollectionQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SearchCollectionQuery, SearchCollectionQueryVariables>(
    SearchCollectionQueryDocument,
    options,
  );
}
export type SearchCollectionQueryHookResult = ReturnType<typeof useSearchCollectionQuery>;
export type SearchCollectionQueryLazyQueryHookResult = ReturnType<
  typeof useSearchCollectionQueryLazyQuery
>;
export type SearchCollectionQuerySuspenseQueryHookResult = ReturnType<
  typeof useSearchCollectionQuerySuspenseQuery
>;
export type SearchCollectionQueryQueryResult = Apollo.QueryResult<
  SearchCollectionQuery,
  SearchCollectionQueryVariables
>;
export const SearchCuisineMetroPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SearchCuisineMetroPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'nationwideCatererCount'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'graphExperiments'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryFeeExperiment'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'v2'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'flagKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allocationKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'experimentKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'variation'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'pricingModel'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CappedDeliveryFeePricingModel'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cap'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'currency'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSearchCuisineMetroPageQuery__
 *
 * To run a query within a React component, call `useSearchCuisineMetroPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCuisineMetroPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCuisineMetroPageQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useSearchCuisineMetroPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchCuisineMetroPageQuery,
    SearchCuisineMetroPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SearchCuisineMetroPageQuery, SearchCuisineMetroPageQueryVariables>(
    SearchCuisineMetroPageQueryDocument,
    options,
  );
}
export function useSearchCuisineMetroPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchCuisineMetroPageQuery,
    SearchCuisineMetroPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SearchCuisineMetroPageQuery, SearchCuisineMetroPageQueryVariables>(
    SearchCuisineMetroPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSearchCuisineMetroPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchCuisineMetroPageQuery,
    SearchCuisineMetroPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchCuisineMetroPageQuery, SearchCuisineMetroPageQueryVariables>;
export function useSearchCuisineMetroPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchCuisineMetroPageQuery,
        SearchCuisineMetroPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchCuisineMetroPageQuery | undefined,
  SearchCuisineMetroPageQueryVariables
>;
export function useSearchCuisineMetroPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchCuisineMetroPageQuery,
        SearchCuisineMetroPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SearchCuisineMetroPageQuery, SearchCuisineMetroPageQueryVariables>(
    SearchCuisineMetroPageQueryDocument,
    options,
  );
}
export type SearchCuisineMetroPageQueryHookResult = ReturnType<
  typeof useSearchCuisineMetroPageQuery
>;
export type SearchCuisineMetroPageQueryLazyQueryHookResult = ReturnType<
  typeof useSearchCuisineMetroPageQueryLazyQuery
>;
export type SearchCuisineMetroPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useSearchCuisineMetroPageQuerySuspenseQuery
>;
export type SearchCuisineMetroPageQueryQueryResult = Apollo.QueryResult<
  SearchCuisineMetroPageQuery,
  SearchCuisineMetroPageQueryVariables
>;
export const SearchMetroPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SearchMetroPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'}},
          {kind: 'Field', name: {kind: 'Name', value: 'nationwideCatererCount'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'graphExperiments'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryFeeExperiment'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'v2'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'flagKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allocationKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'experimentKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'variation'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'pricingModel'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CappedDeliveryFeePricingModel'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cap'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'currency'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSearchMetroPageQuery__
 *
 * To run a query within a React component, call `useSearchMetroPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMetroPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMetroPageQuery({
 *   variables: {
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useSearchMetroPageQuery(
  baseOptions?: Apollo.QueryHookOptions<SearchMetroPageQuery, SearchMetroPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SearchMetroPageQuery, SearchMetroPageQueryVariables>(
    SearchMetroPageQueryDocument,
    options,
  );
}
export function useSearchMetroPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchMetroPageQuery, SearchMetroPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SearchMetroPageQuery, SearchMetroPageQueryVariables>(
    SearchMetroPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSearchMetroPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchMetroPageQuery,
    SearchMetroPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchMetroPageQuery, SearchMetroPageQueryVariables>;
export function useSearchMetroPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchMetroPageQuery, SearchMetroPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchMetroPageQuery | undefined, SearchMetroPageQueryVariables>;
export function useSearchMetroPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchMetroPageQuery, SearchMetroPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SearchMetroPageQuery, SearchMetroPageQueryVariables>(
    SearchMetroPageQueryDocument,
    options,
  );
}
export type SearchMetroPageQueryHookResult = ReturnType<typeof useSearchMetroPageQuery>;
export type SearchMetroPageQueryLazyQueryHookResult = ReturnType<
  typeof useSearchMetroPageQueryLazyQuery
>;
export type SearchMetroPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useSearchMetroPageQuerySuspenseQuery
>;
export type SearchMetroPageQueryQueryResult = Apollo.QueryResult<
  SearchMetroPageQuery,
  SearchMetroPageQueryVariables
>;
export const SearchPageOrderQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SearchPageOrderQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'trackOrderUsage'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'trackOrderUsage'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'trackOrderUsage'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'SearchPageFulfillmentDetailFragment'},
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'nationwideCatererCount'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SearchPageFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSearchPageOrderQuery__
 *
 * To run a query within a React component, call `useSearchPageOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPageOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPageOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      trackOrderUsage: // value for 'trackOrderUsage'
 *   },
 * });
 */
export function useSearchPageOrderQuery(
  baseOptions: Apollo.QueryHookOptions<SearchPageOrderQuery, SearchPageOrderQueryVariables> &
    ({variables: SearchPageOrderQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SearchPageOrderQuery, SearchPageOrderQueryVariables>(
    SearchPageOrderQueryDocument,
    options,
  );
}
export function useSearchPageOrderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchPageOrderQuery, SearchPageOrderQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SearchPageOrderQuery, SearchPageOrderQueryVariables>(
    SearchPageOrderQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSearchPageOrderQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchPageOrderQuery,
    SearchPageOrderQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchPageOrderQuery, SearchPageOrderQueryVariables>;
export function useSearchPageOrderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchPageOrderQuery, SearchPageOrderQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchPageOrderQuery | undefined, SearchPageOrderQueryVariables>;
export function useSearchPageOrderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchPageOrderQuery, SearchPageOrderQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SearchPageOrderQuery, SearchPageOrderQueryVariables>(
    SearchPageOrderQueryDocument,
    options,
  );
}
export type SearchPageOrderQueryHookResult = ReturnType<typeof useSearchPageOrderQuery>;
export type SearchPageOrderQueryLazyQueryHookResult = ReturnType<
  typeof useSearchPageOrderQueryLazyQuery
>;
export type SearchPageOrderQuerySuspenseQueryHookResult = ReturnType<
  typeof useSearchPageOrderQuerySuspenseQuery
>;
export type SearchPageOrderQueryQueryResult = Apollo.QueryResult<
  SearchPageOrderQuery,
  SearchPageOrderQueryVariables
>;
export const SearchPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SearchPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'trackOrderUsage'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'nationwideCatererCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'fulfillmentDetail'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'trackOrderUsage'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'trackOrderUsage'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'FragmentSpread',
                  name: {kind: 'Name', value: 'SearchPageFulfillmentDetailFragment'},
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'address'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fullAddress'}},
                {kind: 'Field', name: {kind: 'Name', value: 'metropolitanStatisticalArea'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corpAccount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'collectsAllEzRewards'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliverySettings'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliveryFeeCap'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'editable'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventLocalTime'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventName'}},
          {kind: 'Field', name: {kind: 'Name', value: 'eventOn'}},
          {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
          {kind: 'Field', name: {kind: 'Name', value: 'strategy'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SearchPageFulfillmentDetailFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'FulfillmentDetail'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FulfillmentDetailFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'DeliveryFeeExperimentFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'graphExperiments'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryFeeExperiment'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'v2'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'flagKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allocationKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'experimentKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'variation'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'pricingModel'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'CappedDeliveryFeePricingModel'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'cap'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'subunits'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'currency'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSearchPageQuery__
 *
 * To run a query within a React component, call `useSearchPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPageQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      trackOrderUsage: // value for 'trackOrderUsage'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useSearchPageQuery(
  baseOptions: Apollo.QueryHookOptions<SearchPageQuery, SearchPageQueryVariables> &
    ({variables: SearchPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SearchPageQuery, SearchPageQueryVariables>(
    SearchPageQueryDocument,
    options,
  );
}
export function useSearchPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchPageQuery, SearchPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SearchPageQuery, SearchPageQueryVariables>(
    SearchPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSearchPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SearchPageQuery, SearchPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchPageQuery, SearchPageQueryVariables>;
export function useSearchPageQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPageQuery, SearchPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchPageQuery | undefined, SearchPageQueryVariables>;
export function useSearchPageQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPageQuery, SearchPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SearchPageQuery, SearchPageQueryVariables>(
    SearchPageQueryDocument,
    options,
  );
}
export type SearchPageQueryHookResult = ReturnType<typeof useSearchPageQuery>;
export type SearchPageQueryLazyQueryHookResult = ReturnType<typeof useSearchPageQueryLazyQuery>;
export type SearchPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useSearchPageQuerySuspenseQuery
>;
export type SearchPageQueryQueryResult = Apollo.QueryResult<
  SearchPageQuery,
  SearchPageQueryVariables
>;
export const SearchQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SearchQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchAddress'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'TimeWithoutZone'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'MarketplaceCatererSearchFilter'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeCaterers'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: true},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeCarousels'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'includeSponsoredListingsEligibilitySearch'},
          },
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'includeTagline'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: true},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchOrderType'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: {kind: 'Name', value: 'shouldIncludeSponsoredListings'},
          },
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'skipSearchTracking'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'marketplaceSearchV2'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'address'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventDateTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'shouldIncludeSponsoredListings'},
                value: {
                  kind: 'Variable',
                  name: {kind: 'Name', value: 'shouldIncludeSponsoredListings'},
                },
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'skipSearchTracking'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'skipSearchTracking'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'trackingId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'analyticsSearchId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brandHit'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'caterer'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'SearchResultFragment'},
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'unavailabilityReason'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'leadTime'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'dayBeforeCutoffTime'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'operatingSchedule'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'openTime'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'closeTime'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterers'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filter'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'limit'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'offset'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                    },
                  ],
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'include'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {kind: 'Variable', name: {kind: 'Name', value: 'includeCaterers'}},
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'visibleCount'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'nodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'SearchResultFragment'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'previouslyEngagedCaterers'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'PreviouslyEngagedCaterersFragment'},
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'catererCarousels'},
                  directives: [
                    {
                      kind: 'Directive',
                      name: {kind: 'Name', value: 'include'},
                      arguments: [
                        {
                          kind: 'Argument',
                          name: {kind: 'Name', value: 'if'},
                          value: {
                            kind: 'Variable',
                            name: {kind: 'Name', value: 'includeCarousels'},
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'caterers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'imageSrc'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'distance'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'deliveryFee'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunitsV2'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'slotReservation'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'SponsoredListingReservation'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'topsortBidId'},
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'tagline'},
                        directives: [
                          {
                            kind: 'Directive',
                            name: {kind: 'Name', value: 'include'},
                            arguments: [
                              {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'if'},
                                value: {
                                  kind: 'Variable',
                                  name: {kind: 'Name', value: 'includeTagline'},
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'carouselType'}},
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: {kind: 'Name', value: 'sponsoredListingsEligibilitySearch'},
            name: {kind: 'Name', value: 'marketplaceSearchV2'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'address'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventDateTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'shouldIncludeSponsoredListings'},
                value: {kind: 'BooleanValue', value: true},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'skipSearchTracking'},
                value: {kind: 'BooleanValue', value: true},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'trackingId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: {kind: 'Name', value: 'include'},
                arguments: [
                  {
                    kind: 'Argument',
                    name: {kind: 'Name', value: 'if'},
                    value: {
                      kind: 'Variable',
                      name: {kind: 'Name', value: 'includeSponsoredListingsEligibilitySearch'},
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterers'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filter'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'limit'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'offset'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'nodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'slotReservation'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {kind: 'Name', value: 'SponsoredListingReservation'},
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'topsortBidId'},
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SearchResultFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchResult'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'searchResultBrand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoImageSrc'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'imageSrc'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'distance'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isNew'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'priceRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'slotReservation'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'SponsoredListingReservation'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'topsortBidId'}}],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'topsortProductId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'variableDeliveryFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'onTimeRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestBrandReviewText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestBrandReviewAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestReviewText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestReviewAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'repeatUserRate'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sponsoredPromoTitles'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'PreviouslyEngagedCaterersFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchResult'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'imageSrc'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'searchResultBrand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'previousEngagement'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'BrandEngagement'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastOrderedFrom'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'CatererEngagement'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastOrderedFrom'}},
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'CorpAccountEngagement'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'lastOrderedFrom'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      address: // value for 'address'
 *      eventDateTime: // value for 'eventDateTime'
 *      eventTime: // value for 'eventTime'
 *      filter: // value for 'filter'
 *      includeCaterers: // value for 'includeCaterers'
 *      includeCarousels: // value for 'includeCarousels'
 *      includeSponsoredListingsEligibilitySearch: // value for 'includeSponsoredListingsEligibilitySearch'
 *      includeTagline: // value for 'includeTagline'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderType: // value for 'orderType'
 *      shouldIncludeSponsoredListings: // value for 'shouldIncludeSponsoredListings'
 *      skipSearchTracking: // value for 'skipSearchTracking'
 *      trackingId: // value for 'trackingId'
 *   },
 * });
 */
export function useSearchQuery(
  baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables> &
    ({variables: SearchQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchQueryDocument, options);
}
export function useSearchQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchQueryDocument, options);
}
// @ts-ignore
export function useSearchQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchQuery, SearchQueryVariables>;
export function useSearchQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchQuery | undefined, SearchQueryVariables>;
export function useSearchQuerySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchQueryDocument, options);
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchQueryLazyQueryHookResult = ReturnType<typeof useSearchQueryLazyQuery>;
export type SearchQuerySuspenseQueryHookResult = ReturnType<typeof useSearchQuerySuspenseQuery>;
export type SearchQueryQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const SeoMetroNeighborhoodsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SeoMetroNeighborhoodsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'metro'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'stateAbbreviation'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererLimit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'seoMetro'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'metro'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'metro'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'stateAbbreviation'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'stateAbbreviation'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'state'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'abbreviation'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'neighborhoods'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'locationType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'rank'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'caterers'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'catererLimit'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSeoMetroNeighborhoodsQuery__
 *
 * To run a query within a React component, call `useSeoMetroNeighborhoodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoMetroNeighborhoodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoMetroNeighborhoodsQuery({
 *   variables: {
 *      metro: // value for 'metro'
 *      stateAbbreviation: // value for 'stateAbbreviation'
 *      catererLimit: // value for 'catererLimit'
 *   },
 * });
 */
export function useSeoMetroNeighborhoodsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SeoMetroNeighborhoodsQuery,
    SeoMetroNeighborhoodsQueryVariables
  > &
    ({variables: SeoMetroNeighborhoodsQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SeoMetroNeighborhoodsQuery, SeoMetroNeighborhoodsQueryVariables>(
    SeoMetroNeighborhoodsQueryDocument,
    options,
  );
}
export function useSeoMetroNeighborhoodsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SeoMetroNeighborhoodsQuery,
    SeoMetroNeighborhoodsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SeoMetroNeighborhoodsQuery, SeoMetroNeighborhoodsQueryVariables>(
    SeoMetroNeighborhoodsQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSeoMetroNeighborhoodsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SeoMetroNeighborhoodsQuery,
    SeoMetroNeighborhoodsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SeoMetroNeighborhoodsQuery, SeoMetroNeighborhoodsQueryVariables>;
export function useSeoMetroNeighborhoodsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SeoMetroNeighborhoodsQuery,
        SeoMetroNeighborhoodsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SeoMetroNeighborhoodsQuery | undefined,
  SeoMetroNeighborhoodsQueryVariables
>;
export function useSeoMetroNeighborhoodsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SeoMetroNeighborhoodsQuery,
        SeoMetroNeighborhoodsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SeoMetroNeighborhoodsQuery, SeoMetroNeighborhoodsQueryVariables>(
    SeoMetroNeighborhoodsQueryDocument,
    options,
  );
}
export type SeoMetroNeighborhoodsQueryHookResult = ReturnType<typeof useSeoMetroNeighborhoodsQuery>;
export type SeoMetroNeighborhoodsQueryLazyQueryHookResult = ReturnType<
  typeof useSeoMetroNeighborhoodsQueryLazyQuery
>;
export type SeoMetroNeighborhoodsQuerySuspenseQueryHookResult = ReturnType<
  typeof useSeoMetroNeighborhoodsQuerySuspenseQuery
>;
export type SeoMetroNeighborhoodsQueryQueryResult = Apollo.QueryResult<
  SeoMetroNeighborhoodsQuery,
  SeoMetroNeighborhoodsQueryVariables
>;
export const SimilarCaterersQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SimilarCaterersQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchAddress'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'TimeWithoutZone'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchOrderType'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'MarketplaceCatererSearchFilter'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'marketplaceSearchV2'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'address'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventDateTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterers'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filter'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'filter'}},
                    },
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'limit'},
                      value: {kind: 'IntValue', value: '10'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'nodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'reviewCount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'imageSrc'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'deliveryFee'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'variableDeliveryFee'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'deliveryMinimum'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'takeoutMinimum'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'searchResultBrand'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'mobileHeroImageSrc'},
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'imageFullPath'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSimilarCaterersQuery__
 *
 * To run a query within a React component, call `useSimilarCaterersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarCaterersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarCaterersQuery({
 *   variables: {
 *      address: // value for 'address'
 *      eventDateTime: // value for 'eventDateTime'
 *      eventTime: // value for 'eventTime'
 *      orderType: // value for 'orderType'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSimilarCaterersQuery(
  baseOptions: Apollo.QueryHookOptions<SimilarCaterersQuery, SimilarCaterersQueryVariables> &
    ({variables: SimilarCaterersQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SimilarCaterersQuery, SimilarCaterersQueryVariables>(
    SimilarCaterersQueryDocument,
    options,
  );
}
export function useSimilarCaterersQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SimilarCaterersQuery, SimilarCaterersQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SimilarCaterersQuery, SimilarCaterersQueryVariables>(
    SimilarCaterersQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSimilarCaterersQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SimilarCaterersQuery,
    SimilarCaterersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SimilarCaterersQuery, SimilarCaterersQueryVariables>;
export function useSimilarCaterersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SimilarCaterersQuery, SimilarCaterersQueryVariables>,
): Apollo.UseSuspenseQueryResult<SimilarCaterersQuery | undefined, SimilarCaterersQueryVariables>;
export function useSimilarCaterersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SimilarCaterersQuery, SimilarCaterersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SimilarCaterersQuery, SimilarCaterersQueryVariables>(
    SimilarCaterersQueryDocument,
    options,
  );
}
export type SimilarCaterersQueryHookResult = ReturnType<typeof useSimilarCaterersQuery>;
export type SimilarCaterersQueryLazyQueryHookResult = ReturnType<
  typeof useSimilarCaterersQueryLazyQuery
>;
export type SimilarCaterersQuerySuspenseQueryHookResult = ReturnType<
  typeof useSimilarCaterersQuerySuspenseQuery
>;
export type SimilarCaterersQueryQueryResult = Apollo.QueryResult<
  SimilarCaterersQuery,
  SimilarCaterersQueryVariables
>;
export const StoreCampaignQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'StoreCampaignQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'activeStoreCampaign'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                {kind: 'Field', name: {kind: 'Name', value: 'startsOn'}},
                {kind: 'Field', name: {kind: 'Name', value: 'endsOn'}},
                {kind: 'Field', name: {kind: 'Name', value: 'features'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'promoCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'promo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditions'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'assignedPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promo'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'promoCode'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'termsAndConditionsUrl'},
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useStoreCampaignQuery__
 *
 * To run a query within a React component, call `useStoreCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreCampaignQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreCampaignQuery(
  baseOptions?: Apollo.QueryHookOptions<StoreCampaignQuery, StoreCampaignQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<StoreCampaignQuery, StoreCampaignQueryVariables>(
    StoreCampaignQueryDocument,
    options,
  );
}
export function useStoreCampaignQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StoreCampaignQuery, StoreCampaignQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<StoreCampaignQuery, StoreCampaignQueryVariables>(
    StoreCampaignQueryDocument,
    options,
  );
}
// @ts-ignore
export function useStoreCampaignQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<StoreCampaignQuery, StoreCampaignQueryVariables>,
): Apollo.UseSuspenseQueryResult<StoreCampaignQuery, StoreCampaignQueryVariables>;
export function useStoreCampaignQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StoreCampaignQuery, StoreCampaignQueryVariables>,
): Apollo.UseSuspenseQueryResult<StoreCampaignQuery | undefined, StoreCampaignQueryVariables>;
export function useStoreCampaignQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StoreCampaignQuery, StoreCampaignQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<StoreCampaignQuery, StoreCampaignQueryVariables>(
    StoreCampaignQueryDocument,
    options,
  );
}
export type StoreCampaignQueryHookResult = ReturnType<typeof useStoreCampaignQuery>;
export type StoreCampaignQueryLazyQueryHookResult = ReturnType<
  typeof useStoreCampaignQueryLazyQuery
>;
export type StoreCampaignQuerySuspenseQueryHookResult = ReturnType<
  typeof useStoreCampaignQuerySuspenseQuery
>;
export type StoreCampaignQueryQueryResult = Apollo.QueryResult<
  StoreCampaignQuery,
  StoreCampaignQueryVariables
>;
export const SubmittedOrdersQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SubmittedOrdersQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventBefore'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orders'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'eventAfter'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'eventAfter'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'eventBefore'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'eventBefore'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'filter'},
                            value: {kind: 'EnumValue', value: 'SUBMITTED_NOT_CANCELLED'},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'sortDirection'},
                            value: {kind: 'EnumValue', value: 'DESC'},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'event'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'timeZoneOffset'},
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'caterer'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'formattedOrderNumber'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSubmittedOrdersQuery__
 *
 * To run a query within a React component, call `useSubmittedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      eventAfter: // value for 'eventAfter'
 *      eventBefore: // value for 'eventBefore'
 *   },
 * });
 */
export function useSubmittedOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<SubmittedOrdersQuery, SubmittedOrdersQueryVariables> &
    ({variables: SubmittedOrdersQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>(
    SubmittedOrdersQueryDocument,
    options,
  );
}
export function useSubmittedOrdersQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>(
    SubmittedOrdersQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSubmittedOrdersQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SubmittedOrdersQuery,
    SubmittedOrdersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>;
export function useSubmittedOrdersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>,
): Apollo.UseSuspenseQueryResult<SubmittedOrdersQuery | undefined, SubmittedOrdersQueryVariables>;
export function useSubmittedOrdersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>(
    SubmittedOrdersQueryDocument,
    options,
  );
}
export type SubmittedOrdersQueryHookResult = ReturnType<typeof useSubmittedOrdersQuery>;
export type SubmittedOrdersQueryLazyQueryHookResult = ReturnType<
  typeof useSubmittedOrdersQueryLazyQuery
>;
export type SubmittedOrdersQuerySuspenseQueryHookResult = ReturnType<
  typeof useSubmittedOrdersQuerySuspenseQuery
>;
export type SubmittedOrdersQueryQueryResult = Apollo.QueryResult<
  SubmittedOrdersQuery,
  SubmittedOrdersQueryVariables
>;
export const SystemMessageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'SystemMessageQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'systemMessage'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                {kind: 'Field', name: {kind: 'Name', value: 'updatedAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'linkText'}},
                {kind: 'Field', name: {kind: 'Name', value: 'url'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSystemMessageQuery__
 *
 * To run a query within a React component, call `useSystemMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemMessageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemMessageQuery(
  baseOptions?: Apollo.QueryHookOptions<SystemMessageQuery, SystemMessageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SystemMessageQuery, SystemMessageQueryVariables>(
    SystemMessageQueryDocument,
    options,
  );
}
export function useSystemMessageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SystemMessageQuery, SystemMessageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SystemMessageQuery, SystemMessageQueryVariables>(
    SystemMessageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useSystemMessageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SystemMessageQuery, SystemMessageQueryVariables>,
): Apollo.UseSuspenseQueryResult<SystemMessageQuery, SystemMessageQueryVariables>;
export function useSystemMessageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SystemMessageQuery, SystemMessageQueryVariables>,
): Apollo.UseSuspenseQueryResult<SystemMessageQuery | undefined, SystemMessageQueryVariables>;
export function useSystemMessageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SystemMessageQuery, SystemMessageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<SystemMessageQuery, SystemMessageQueryVariables>(
    SystemMessageQueryDocument,
    options,
  );
}
export type SystemMessageQueryHookResult = ReturnType<typeof useSystemMessageQuery>;
export type SystemMessageQueryLazyQueryHookResult = ReturnType<
  typeof useSystemMessageQueryLazyQuery
>;
export type SystemMessageQuerySuspenseQueryHookResult = ReturnType<
  typeof useSystemMessageQuerySuspenseQuery
>;
export type SystemMessageQueryQueryResult = Apollo.QueryResult<
  SystemMessageQuery,
  SystemMessageQueryVariables
>;
export const TakeoutAvailableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'TakeoutAvailable'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderAt'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'catererId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'isTakeoutAvailable'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderAt'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'orderAt'}},
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTakeoutAvailableQuery__
 *
 * To run a query within a React component, call `useTakeoutAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakeoutAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakeoutAvailableQuery({
 *   variables: {
 *      orderAt: // value for 'orderAt'
 *      catererId: // value for 'catererId'
 *   },
 * });
 */
export function useTakeoutAvailableQuery(
  baseOptions: Apollo.QueryHookOptions<TakeoutAvailableQuery, TakeoutAvailableQueryVariables> &
    ({variables: TakeoutAvailableQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<TakeoutAvailableQuery, TakeoutAvailableQueryVariables>(
    TakeoutAvailableDocument,
    options,
  );
}
export function useTakeoutAvailableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TakeoutAvailableQuery, TakeoutAvailableQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<TakeoutAvailableQuery, TakeoutAvailableQueryVariables>(
    TakeoutAvailableDocument,
    options,
  );
}
// @ts-ignore
export function useTakeoutAvailableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TakeoutAvailableQuery,
    TakeoutAvailableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TakeoutAvailableQuery, TakeoutAvailableQueryVariables>;
export function useTakeoutAvailableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TakeoutAvailableQuery, TakeoutAvailableQueryVariables>,
): Apollo.UseSuspenseQueryResult<TakeoutAvailableQuery | undefined, TakeoutAvailableQueryVariables>;
export function useTakeoutAvailableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TakeoutAvailableQuery, TakeoutAvailableQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<TakeoutAvailableQuery, TakeoutAvailableQueryVariables>(
    TakeoutAvailableDocument,
    options,
  );
}
export type TakeoutAvailableQueryHookResult = ReturnType<typeof useTakeoutAvailableQuery>;
export type TakeoutAvailableLazyQueryHookResult = ReturnType<typeof useTakeoutAvailableLazyQuery>;
export type TakeoutAvailableSuspenseQueryHookResult = ReturnType<
  typeof useTakeoutAvailableSuspenseQuery
>;
export type TakeoutAvailableQueryResult = Apollo.QueryResult<
  TakeoutAvailableQuery,
  TakeoutAvailableQueryVariables
>;
export const TypeaheadSearchQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'TypeaheadSearchQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'isPreciseAddress'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'isSingleZipMetro'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: false},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'latitude'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Float'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'longitude'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'Float'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'term'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'typeaheadSearch'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'isPreciseAddress'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'isPreciseAddress'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'isSingleZipMetro'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'isSingleZipMetro'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'latitude'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'latitude'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'longitude'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'longitude'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'term'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'term'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'trackingId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'display'}},
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoImageId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTypeaheadSearchQuery__
 *
 * To run a query within a React component, call `useTypeaheadSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTypeaheadSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTypeaheadSearchQuery({
 *   variables: {
 *      isPreciseAddress: // value for 'isPreciseAddress'
 *      isSingleZipMetro: // value for 'isSingleZipMetro'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      term: // value for 'term'
 *      trackingId: // value for 'trackingId'
 *   },
 * });
 */
export function useTypeaheadSearchQuery(
  baseOptions: Apollo.QueryHookOptions<TypeaheadSearchQuery, TypeaheadSearchQueryVariables> &
    ({variables: TypeaheadSearchQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<TypeaheadSearchQuery, TypeaheadSearchQueryVariables>(
    TypeaheadSearchQueryDocument,
    options,
  );
}
export function useTypeaheadSearchQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TypeaheadSearchQuery, TypeaheadSearchQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<TypeaheadSearchQuery, TypeaheadSearchQueryVariables>(
    TypeaheadSearchQueryDocument,
    options,
  );
}
// @ts-ignore
export function useTypeaheadSearchQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TypeaheadSearchQuery,
    TypeaheadSearchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TypeaheadSearchQuery, TypeaheadSearchQueryVariables>;
export function useTypeaheadSearchQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TypeaheadSearchQuery, TypeaheadSearchQueryVariables>,
): Apollo.UseSuspenseQueryResult<TypeaheadSearchQuery | undefined, TypeaheadSearchQueryVariables>;
export function useTypeaheadSearchQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TypeaheadSearchQuery, TypeaheadSearchQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<TypeaheadSearchQuery, TypeaheadSearchQueryVariables>(
    TypeaheadSearchQueryDocument,
    options,
  );
}
export type TypeaheadSearchQueryHookResult = ReturnType<typeof useTypeaheadSearchQuery>;
export type TypeaheadSearchQueryLazyQueryHookResult = ReturnType<
  typeof useTypeaheadSearchQueryLazyQuery
>;
export type TypeaheadSearchQuerySuspenseQueryHookResult = ReturnType<
  typeof useTypeaheadSearchQuerySuspenseQuery
>;
export type TypeaheadSearchQueryQueryResult = Apollo.QueryResult<
  TypeaheadSearchQuery,
  TypeaheadSearchQueryVariables
>;
export const UpcomingOrderCardsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'UpcomingOrderCardsQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'upcomingOrderCards'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isLate'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'trackingUrl'}},
                {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'estimatedArrivalAt'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'nameOrLocation'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'address'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'image'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'mobileHeroUrl'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useUpcomingOrderCardsQuery__
 *
 * To run a query within a React component, call `useUpcomingOrderCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingOrderCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingOrderCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpcomingOrderCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<UpcomingOrderCardsQuery, UpcomingOrderCardsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<UpcomingOrderCardsQuery, UpcomingOrderCardsQueryVariables>(
    UpcomingOrderCardsQueryDocument,
    options,
  );
}
export function useUpcomingOrderCardsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpcomingOrderCardsQuery,
    UpcomingOrderCardsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<UpcomingOrderCardsQuery, UpcomingOrderCardsQueryVariables>(
    UpcomingOrderCardsQueryDocument,
    options,
  );
}
// @ts-ignore
export function useUpcomingOrderCardsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UpcomingOrderCardsQuery,
    UpcomingOrderCardsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UpcomingOrderCardsQuery, UpcomingOrderCardsQueryVariables>;
export function useUpcomingOrderCardsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UpcomingOrderCardsQuery, UpcomingOrderCardsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  UpcomingOrderCardsQuery | undefined,
  UpcomingOrderCardsQueryVariables
>;
export function useUpcomingOrderCardsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UpcomingOrderCardsQuery, UpcomingOrderCardsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<UpcomingOrderCardsQuery, UpcomingOrderCardsQueryVariables>(
    UpcomingOrderCardsQueryDocument,
    options,
  );
}
export type UpcomingOrderCardsQueryHookResult = ReturnType<typeof useUpcomingOrderCardsQuery>;
export type UpcomingOrderCardsQueryLazyQueryHookResult = ReturnType<
  typeof useUpcomingOrderCardsQueryLazyQuery
>;
export type UpcomingOrderCardsQuerySuspenseQueryHookResult = ReturnType<
  typeof useUpcomingOrderCardsQuerySuspenseQuery
>;
export type UpcomingOrderCardsQueryQueryResult = Apollo.QueryResult<
  UpcomingOrderCardsQuery,
  UpcomingOrderCardsQueryVariables
>;
export const UserConnectionsAllAccountMembersQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'UserConnectionsAllAccountMembersQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'potentialUserConnections'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'edges'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'node'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'initials'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isPending'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isConnected'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useUserConnectionsAllAccountMembersQuery__
 *
 * To run a query within a React component, call `useUserConnectionsAllAccountMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionsAllAccountMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserConnectionsAllAccountMembersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserConnectionsAllAccountMembersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserConnectionsAllAccountMembersQuery,
    UserConnectionsAllAccountMembersQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<
    UserConnectionsAllAccountMembersQuery,
    UserConnectionsAllAccountMembersQueryVariables
  >(UserConnectionsAllAccountMembersQueryDocument, options);
}
export function useUserConnectionsAllAccountMembersQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserConnectionsAllAccountMembersQuery,
    UserConnectionsAllAccountMembersQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<
    UserConnectionsAllAccountMembersQuery,
    UserConnectionsAllAccountMembersQueryVariables
  >(UserConnectionsAllAccountMembersQueryDocument, options);
}
// @ts-ignore
export function useUserConnectionsAllAccountMembersQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserConnectionsAllAccountMembersQuery,
    UserConnectionsAllAccountMembersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  UserConnectionsAllAccountMembersQuery,
  UserConnectionsAllAccountMembersQueryVariables
>;
export function useUserConnectionsAllAccountMembersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserConnectionsAllAccountMembersQuery,
        UserConnectionsAllAccountMembersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserConnectionsAllAccountMembersQuery | undefined,
  UserConnectionsAllAccountMembersQueryVariables
>;
export function useUserConnectionsAllAccountMembersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserConnectionsAllAccountMembersQuery,
        UserConnectionsAllAccountMembersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    UserConnectionsAllAccountMembersQuery,
    UserConnectionsAllAccountMembersQueryVariables
  >(UserConnectionsAllAccountMembersQueryDocument, options);
}
export type UserConnectionsAllAccountMembersQueryHookResult = ReturnType<
  typeof useUserConnectionsAllAccountMembersQuery
>;
export type UserConnectionsAllAccountMembersQueryLazyQueryHookResult = ReturnType<
  typeof useUserConnectionsAllAccountMembersQueryLazyQuery
>;
export type UserConnectionsAllAccountMembersQuerySuspenseQueryHookResult = ReturnType<
  typeof useUserConnectionsAllAccountMembersQuerySuspenseQuery
>;
export type UserConnectionsAllAccountMembersQueryQueryResult = Apollo.QueryResult<
  UserConnectionsAllAccountMembersQuery,
  UserConnectionsAllAccountMembersQueryVariables
>;
export const UserConnectionsPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'UserConnectionsPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'userConnections'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'edges'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'node'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'connectedUserId'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'initials'}},
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'subscribedToOrderNotifications',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'potentialUserConnections'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'edges'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'node'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'initials'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isPending'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'isConnected'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useUserConnectionsPageQuery__
 *
 * To run a query within a React component, call `useUserConnectionsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserConnectionsPageQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useUserConnectionsPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserConnectionsPageQuery,
    UserConnectionsPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<UserConnectionsPageQuery, UserConnectionsPageQueryVariables>(
    UserConnectionsPageQueryDocument,
    options,
  );
}
export function useUserConnectionsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserConnectionsPageQuery,
    UserConnectionsPageQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<UserConnectionsPageQuery, UserConnectionsPageQueryVariables>(
    UserConnectionsPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useUserConnectionsPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserConnectionsPageQuery,
    UserConnectionsPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UserConnectionsPageQuery, UserConnectionsPageQueryVariables>;
export function useUserConnectionsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserConnectionsPageQuery, UserConnectionsPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  UserConnectionsPageQuery | undefined,
  UserConnectionsPageQueryVariables
>;
export function useUserConnectionsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserConnectionsPageQuery, UserConnectionsPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<UserConnectionsPageQuery, UserConnectionsPageQueryVariables>(
    UserConnectionsPageQueryDocument,
    options,
  );
}
export type UserConnectionsPageQueryHookResult = ReturnType<typeof useUserConnectionsPageQuery>;
export type UserConnectionsPageQueryLazyQueryHookResult = ReturnType<
  typeof useUserConnectionsPageQueryLazyQuery
>;
export type UserConnectionsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useUserConnectionsPageQuerySuspenseQuery
>;
export type UserConnectionsPageQueryQueryResult = Apollo.QueryResult<
  UserConnectionsPageQuery,
  UserConnectionsPageQueryVariables
>;
export const UserConnectionsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'UserConnectionsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'userConnections'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'searchString'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'searchString'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'totalCount'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'edges'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'node'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'connectedUserId'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'initials'}},
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'subscribedToOrderNotifications',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useUserConnectionsQuery__
 *
 * To run a query within a React component, call `useUserConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserConnectionsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useUserConnectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<UserConnectionsQuery, UserConnectionsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<UserConnectionsQuery, UserConnectionsQueryVariables>(
    UserConnectionsQueryDocument,
    options,
  );
}
export function useUserConnectionsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserConnectionsQuery, UserConnectionsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<UserConnectionsQuery, UserConnectionsQueryVariables>(
    UserConnectionsQueryDocument,
    options,
  );
}
// @ts-ignore
export function useUserConnectionsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserConnectionsQuery,
    UserConnectionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UserConnectionsQuery, UserConnectionsQueryVariables>;
export function useUserConnectionsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserConnectionsQuery, UserConnectionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserConnectionsQuery | undefined, UserConnectionsQueryVariables>;
export function useUserConnectionsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserConnectionsQuery, UserConnectionsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<UserConnectionsQuery, UserConnectionsQueryVariables>(
    UserConnectionsQueryDocument,
    options,
  );
}
export type UserConnectionsQueryHookResult = ReturnType<typeof useUserConnectionsQuery>;
export type UserConnectionsQueryLazyQueryHookResult = ReturnType<
  typeof useUserConnectionsQueryLazyQuery
>;
export type UserConnectionsQuerySuspenseQueryHookResult = ReturnType<
  typeof useUserConnectionsQuerySuspenseQuery
>;
export type UserConnectionsQueryQueryResult = Apollo.QueryResult<
  UserConnectionsQuery,
  UserConnectionsQueryVariables
>;
export const UserConnectionsRequestsQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'UserConnectionsRequestsQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'offset'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'offset'}},
                          },
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'edges'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'node'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'initiatingUserId'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'initials'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useUserConnectionsRequestsQuery__
 *
 * To run a query within a React component, call `useUserConnectionsRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserConnectionsRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserConnectionsRequestsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserConnectionsRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserConnectionsRequestsQuery,
    UserConnectionsRequestsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<UserConnectionsRequestsQuery, UserConnectionsRequestsQueryVariables>(
    UserConnectionsRequestsQueryDocument,
    options,
  );
}
export function useUserConnectionsRequestsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserConnectionsRequestsQuery,
    UserConnectionsRequestsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<UserConnectionsRequestsQuery, UserConnectionsRequestsQueryVariables>(
    UserConnectionsRequestsQueryDocument,
    options,
  );
}
// @ts-ignore
export function useUserConnectionsRequestsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserConnectionsRequestsQuery,
    UserConnectionsRequestsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  UserConnectionsRequestsQuery,
  UserConnectionsRequestsQueryVariables
>;
export function useUserConnectionsRequestsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserConnectionsRequestsQuery,
        UserConnectionsRequestsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserConnectionsRequestsQuery | undefined,
  UserConnectionsRequestsQueryVariables
>;
export function useUserConnectionsRequestsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserConnectionsRequestsQuery,
        UserConnectionsRequestsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    UserConnectionsRequestsQuery,
    UserConnectionsRequestsQueryVariables
  >(UserConnectionsRequestsQueryDocument, options);
}
export type UserConnectionsRequestsQueryHookResult = ReturnType<
  typeof useUserConnectionsRequestsQuery
>;
export type UserConnectionsRequestsQueryLazyQueryHookResult = ReturnType<
  typeof useUserConnectionsRequestsQueryLazyQuery
>;
export type UserConnectionsRequestsQuerySuspenseQueryHookResult = ReturnType<
  typeof useUserConnectionsRequestsQuerySuspenseQuery
>;
export type UserConnectionsRequestsQueryQueryResult = Apollo.QueryResult<
  UserConnectionsRequestsQuery,
  UserConnectionsRequestsQueryVariables
>;
export const UserEventsHistoryQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'UserEventsHistoryQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'userUuid'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'userDcEventHistories'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'userUuid'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'userUuid'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'events'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'at'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'reference'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'DecisionPoint'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'responderType'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'responderUuid'}},
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'Message'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'content'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'sentByType'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'sentById'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'orderInfo'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'brandName'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'reviewedAt'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'request'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'orderInfo'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'brandName'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'eventAt'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'orderNumber'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'userUuid'},
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'TimeChangeRequest'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'orderInfo'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'brandName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'orderNumber'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'userUuid'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'reason'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'originalEventAt'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'proposedEventAt'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'requestedById'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'decisionPoints'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'responderType'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'responderUuid'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'response'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'activatedAt'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'completedAt'}},
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {kind: 'Name', value: 'OrderItemChangeRequest'},
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'status'}},
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'orderInfo'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'brandName'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'eventAt'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'orderNumber'}},
                                        {kind: 'Field', name: {kind: 'Name', value: 'userUuid'}},
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'itemChanges'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {kind: 'Field', name: {kind: 'Name', value: 'changeType'}},
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'decisionPoint'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'response'},
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'responderType'},
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'originalItemJson'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'proposedItemJson'},
                                        },
                                        {kind: 'Field', name: {kind: 'Name', value: 'reason'}},
                                      ],
                                    },
                                  },
                                  {kind: 'Field', name: {kind: 'Name', value: 'requestedById'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'lastReadEventIndices'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'readAt'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'readByType'}},
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'orderUuid'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useUserEventsHistoryQuery__
 *
 * To run a query within a React component, call `useUserEventsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEventsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEventsHistoryQuery({
 *   variables: {
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useUserEventsHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<UserEventsHistoryQuery, UserEventsHistoryQueryVariables> &
    ({variables: UserEventsHistoryQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<UserEventsHistoryQuery, UserEventsHistoryQueryVariables>(
    UserEventsHistoryQueryDocument,
    options,
  );
}
export function useUserEventsHistoryQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserEventsHistoryQuery,
    UserEventsHistoryQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<UserEventsHistoryQuery, UserEventsHistoryQueryVariables>(
    UserEventsHistoryQueryDocument,
    options,
  );
}
// @ts-ignore
export function useUserEventsHistoryQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserEventsHistoryQuery,
    UserEventsHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UserEventsHistoryQuery, UserEventsHistoryQueryVariables>;
export function useUserEventsHistoryQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserEventsHistoryQuery, UserEventsHistoryQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  UserEventsHistoryQuery | undefined,
  UserEventsHistoryQueryVariables
>;
export function useUserEventsHistoryQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserEventsHistoryQuery, UserEventsHistoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<UserEventsHistoryQuery, UserEventsHistoryQueryVariables>(
    UserEventsHistoryQueryDocument,
    options,
  );
}
export type UserEventsHistoryQueryHookResult = ReturnType<typeof useUserEventsHistoryQuery>;
export type UserEventsHistoryQueryLazyQueryHookResult = ReturnType<
  typeof useUserEventsHistoryQueryLazyQuery
>;
export type UserEventsHistoryQuerySuspenseQueryHookResult = ReturnType<
  typeof useUserEventsHistoryQuerySuspenseQuery
>;
export type UserEventsHistoryQueryQueryResult = Apollo.QueryResult<
  UserEventsHistoryQuery,
  UserEventsHistoryQueryVariables
>;
export const ViewOrderPageQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ViewOrderPageQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
          type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'UUID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'IdentityFragment'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'order'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'id'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corpAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'deliverySettings'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'deliveryFeeCap'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'deliveryFeeCapEnabled'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'procurementSettings'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'cartEditsEnabled'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'creditCardPaymentAllowed'},
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'Field', name: {kind: 'Name', value: 'corpAccountName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'notificationsEnabled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isMissingRequiredFullAuth'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isEzOrderingOrder'}},
                {kind: 'Field', name: {kind: 'Name', value: 'hasPunchout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderCustomer'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'paymentMethod'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CreditCard'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'last4'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cardholderName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'missingZipCode'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'cardType'}},
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {kind: 'Name', value: 'CreditLine'},
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'allowedUse'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'corpAccountName'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'OrderFragment'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'cancellationPolicyDisplay'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TrackingIdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'recommendedDefaultAddress'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'LineItemModifierFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'LineItemModifier'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'price'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'modifierGroup'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CartFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'cart'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'productCatalog'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'lineItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'cost'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderItems'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'quantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'size'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'sizeLabel'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'vegetarianQuantity'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'serves'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'groupOrderPersonName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'belongsToAnyEater'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'totalInSubunits'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'orderItemOptions'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'catererLabel'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'itemChoices'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'price'}},
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'modifiers'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'LineItemModifierFragment'},
                            },
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'modifiers'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                  },
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'modifiers'},
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {kind: 'Name', value: 'LineItemModifierFragment'},
                                        },
                                        {
                                          kind: 'Field',
                                          name: {kind: 'Name', value: 'modifiers'},
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'LineItemModifierFragment',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {kind: 'Name', value: 'modifiers'},
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'LineItemModifierFragment',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tip'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'amount'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CatererFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'caterer'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
                {kind: 'Field', name: {kind: 'Name', value: 'nickname'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'brand'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'logoUrl'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'CustomerOrderStatusFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'customerOrderStatus'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isSubmitted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isDraft'}},
                {kind: 'Field', name: {kind: 'Name', value: 'submittedAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isAccepted'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isReconfirmed'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isFulfilled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'fulfilledAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCustomerPaymentCaptured'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isModifiable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'modificationCutoffTime'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancellable'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isCancelled'}},
                {kind: 'Field', name: {kind: 'Name', value: 'cancelledAt'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isPendingApproval'}},
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'FirstOrderReferenceCodeFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'firstOrderReferenceCode'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corporateReferenceCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'EventFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'event'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'headcount'}},
                {kind: 'Field', name: {kind: 'Name', value: 'customerProvidedName'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliverySetup'}},
                {kind: 'Field', name: {kind: 'Name', value: 'isTakeout'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'orderType'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'perspective'},
                      value: {kind: 'EnumValue', value: 'CUSTOMER'},
                    },
                  ],
                },
                {kind: 'Field', name: {kind: 'Name', value: 'timestamp'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneIdentifier'}},
                {kind: 'Field', name: {kind: 'Name', value: 'timeZoneOffset'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'address'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'city'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'street2'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'state'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'zip'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'deliveryInstructions'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'driverAskFor'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'phone'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'latitude'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'longitude'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'TotalsFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'totals'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'customerTotalDue'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'subTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountDeliveryFee'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'preDeliveryDiscountTotal'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'IdentityFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Query'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserTrackingId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'currentUserHashedTrackingId'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'intercomToken'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'me'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'allowUnauthenticated'},
                value: {kind: 'BooleanValue', value: true},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'consumerAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'industry'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'fullName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'firstName'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'registrationStatus'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'shouldLoadFullstory'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessCorpPortal'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canManagePaymentMethods'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessConcur'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'identityId'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canEarnReferralRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'enrolledInEzRewards'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccountVerified'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'canAccessEzRewards'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ezRewardsAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'balance'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'mobilePhone'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccount'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'accountUuid'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'accountUuid'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isCharitable'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'channelPartnerLogoUrl'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'hasFreeDeliveryEnabled'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'freeDeliveryThreshold'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'concurSettings'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'shouldShowConcurEnterpriseToast'},
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'corporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoAndroidApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIpadApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasLoggedIntoIphoneApp'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'hasPlacedMarketplaceOrder'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ownedCorporateAccounts'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'displayName'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'isParent'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'logoIconUrl'}},
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'referAFriendEligible'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'recentlyReferred'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'referredByFirstName'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromo'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'discountAmount'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'orderMinimum'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'description'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'finePrint'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'expiresOn'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'weekdayOnly'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'promoCode'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'termsAndConditionsUrl'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'referralPromoCode'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {kind: 'Field', name: {kind: 'Name', value: 'code'}},
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'totalPendingUserConnectionInvitations'},
                        name: {kind: 'Name', value: 'pendingUserConnectionInvitations'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{kind: 'Field', name: {kind: 'Name', value: 'totalCount'}}],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'adminAccount'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'isMasquerading'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TrackingIdentityFragment'}},
          {
            kind: 'FragmentSpread',
            name: {kind: 'Name', value: 'IdentityRecommendedAddressFragment'},
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'Order'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {kind: 'Field', name: {kind: 'Name', value: 'canBeReviewed'}},
          {kind: 'Field', name: {kind: 'Name', value: 'formattedOrderNumber'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isStandardGroupOrder'}},
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'delivery'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'estimatedDropoffTime'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'tracking'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'url'}}],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'deliveryEvents'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'eventType'}},
                      {kind: 'Field', name: {kind: 'Name', value: 'time'}},
                    ],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'approvalDeadline'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'review'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'text'}},
                {kind: 'Field', name: {kind: 'Name', value: 'rating'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryTimeFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'deliveryProfessionalismFeedback'}},
                {kind: 'Field', name: {kind: 'Name', value: 'penName'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'tableware'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'specialInstructions'}},
                {kind: 'Field', name: {kind: 'Name', value: 'includedUtensils'}},
                {kind: 'Field', name: {kind: 'Name', value: 'omittedUtensils'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateOrderReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'corporateReferenceCode'},
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'id'}}],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'corporateReferenceCodes'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'active'}},
                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                {kind: 'Field', name: {kind: 'Name', value: 'required'}},
                {kind: 'Field', name: {kind: 'Name', value: 'requiresCreditLine'}},
                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                {kind: 'Field', name: {kind: 'Name', value: 'values'}},
                {kind: 'Field', name: {kind: 'Name', value: 'procurement'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'currentValue'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'orderId'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'orderId'}},
                    },
                  ],
                },
              ],
            },
          },
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CartFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CatererFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CustomerOrderStatusFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'FirstOrderReferenceCodeFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'EventFragment'}},
          {kind: 'FragmentSpread', name: {kind: 'Name', value: 'TotalsFragment'}},
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'OrderCancellationPolicyDisplayFragment'},
      typeCondition: {
        kind: 'NamedType',
        name: {kind: 'Name', value: 'OrderCancellationPolicyDisplay'},
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'hasCancellationFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'feePercentage'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'feeAmount'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'cancelWithoutPenaltyUntil'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cancellationWindowHours'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isWaiverEligible'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useViewOrderPageQuery__
 *
 * To run a query within a React component, call `useViewOrderPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewOrderPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewOrderPageQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      accountUuid: // value for 'accountUuid'
 *   },
 * });
 */
export function useViewOrderPageQuery(
  baseOptions: Apollo.QueryHookOptions<ViewOrderPageQuery, ViewOrderPageQueryVariables> &
    ({variables: ViewOrderPageQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ViewOrderPageQuery, ViewOrderPageQueryVariables>(
    ViewOrderPageQueryDocument,
    options,
  );
}
export function useViewOrderPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ViewOrderPageQuery, ViewOrderPageQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ViewOrderPageQuery, ViewOrderPageQueryVariables>(
    ViewOrderPageQueryDocument,
    options,
  );
}
// @ts-ignore
export function useViewOrderPageQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ViewOrderPageQuery, ViewOrderPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<ViewOrderPageQuery, ViewOrderPageQueryVariables>;
export function useViewOrderPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ViewOrderPageQuery, ViewOrderPageQueryVariables>,
): Apollo.UseSuspenseQueryResult<ViewOrderPageQuery | undefined, ViewOrderPageQueryVariables>;
export function useViewOrderPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ViewOrderPageQuery, ViewOrderPageQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<ViewOrderPageQuery, ViewOrderPageQueryVariables>(
    ViewOrderPageQueryDocument,
    options,
  );
}
export type ViewOrderPageQueryHookResult = ReturnType<typeof useViewOrderPageQuery>;
export type ViewOrderPageQueryLazyQueryHookResult = ReturnType<
  typeof useViewOrderPageQueryLazyQuery
>;
export type ViewOrderPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useViewOrderPageQuerySuspenseQuery
>;
export type ViewOrderPageQueryQueryResult = Apollo.QueryResult<
  ViewOrderPageQuery,
  ViewOrderPageQueryVariables
>;
export const WebChatIdentityTokenQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'WebChatIdentityTokenQuery'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'identity'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'webChatIdentityToken'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebChatIdentityTokenQuery__
 *
 * To run a query within a React component, call `useWebChatIdentityTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebChatIdentityTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebChatIdentityTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebChatIdentityTokenQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WebChatIdentityTokenQuery,
    WebChatIdentityTokenQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<WebChatIdentityTokenQuery, WebChatIdentityTokenQueryVariables>(
    WebChatIdentityTokenQueryDocument,
    options,
  );
}
export function useWebChatIdentityTokenQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WebChatIdentityTokenQuery,
    WebChatIdentityTokenQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<WebChatIdentityTokenQuery, WebChatIdentityTokenQueryVariables>(
    WebChatIdentityTokenQueryDocument,
    options,
  );
}
// @ts-ignore
export function useWebChatIdentityTokenQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WebChatIdentityTokenQuery,
    WebChatIdentityTokenQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<WebChatIdentityTokenQuery, WebChatIdentityTokenQueryVariables>;
export function useWebChatIdentityTokenQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WebChatIdentityTokenQuery,
        WebChatIdentityTokenQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WebChatIdentityTokenQuery | undefined,
  WebChatIdentityTokenQueryVariables
>;
export function useWebChatIdentityTokenQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WebChatIdentityTokenQuery,
        WebChatIdentityTokenQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<WebChatIdentityTokenQuery, WebChatIdentityTokenQueryVariables>(
    WebChatIdentityTokenQueryDocument,
    options,
  );
}
export type WebChatIdentityTokenQueryHookResult = ReturnType<typeof useWebChatIdentityTokenQuery>;
export type WebChatIdentityTokenQueryLazyQueryHookResult = ReturnType<
  typeof useWebChatIdentityTokenQueryLazyQuery
>;
export type WebChatIdentityTokenQuerySuspenseQueryHookResult = ReturnType<
  typeof useWebChatIdentityTokenQuerySuspenseQuery
>;
export type WebChatIdentityTokenQueryQueryResult = Apollo.QueryResult<
  WebChatIdentityTokenQuery,
  WebChatIdentityTokenQueryVariables
>;
export const ZeroSearchResultsSearchQueryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {kind: 'Name', value: 'ZeroSearchResultsSearchQuery'},
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
          type: {
            kind: 'NonNullType',
            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchAddress'}},
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'DateTime'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'TimeWithoutZone'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'filters'}},
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {kind: 'NamedType', name: {kind: 'Name', value: 'FilteredCatererListInput'}},
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchOrderType'}},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'skipSearchTracking'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
          defaultValue: {kind: 'BooleanValue', value: true},
        },
        {
          kind: 'VariableDefinition',
          variable: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
          type: {kind: 'NamedType', name: {kind: 'Name', value: 'ID'}},
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'marketplaceSearchV2'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'address'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'address'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventDateTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventDateTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'eventTime'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'eventTime'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'orderType'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'orderType'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'skipSearchTracking'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'skipSearchTracking'}},
              },
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'trackingId'},
                value: {kind: 'Variable', name: {kind: 'Name', value: 'trackingId'}},
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'analyticsSearchId'}},
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'caterers'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'limit'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'nodes'},
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'FragmentSpread',
                              name: {kind: 'Name', value: 'SearchResultFragment'},
                            },
                          ],
                        },
                      },
                      {kind: 'Field', name: {kind: 'Name', value: 'visibleCount'}},
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {kind: 'Name', value: 'filteredCaterers'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'filters'},
                      value: {kind: 'Variable', name: {kind: 'Name', value: 'filters'}},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'caterers'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'SearchResultFragment'},
                                  },
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'visibleCount'}},
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: {kind: 'Name', value: 'rockstarCuratedList'},
                  name: {kind: 'Name', value: 'curatedList'},
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {kind: 'Name', value: 'listType'},
                      value: {kind: 'EnumValue', value: 'RELIABILITY_ROCKSTAR'},
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'caterers'},
                        arguments: [
                          {
                            kind: 'Argument',
                            name: {kind: 'Name', value: 'limit'},
                            value: {kind: 'Variable', name: {kind: 'Name', value: 'limit'}},
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                            {
                              kind: 'Field',
                              name: {kind: 'Name', value: 'nodes'},
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                  {
                                    kind: 'FragmentSpread',
                                    name: {kind: 'Name', value: 'SearchResultFragment'},
                                  },
                                ],
                              },
                            },
                            {kind: 'Field', name: {kind: 'Name', value: 'visibleCount'}},
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {kind: 'Name', value: 'SearchResultFragment'},
      typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CatererSearchResult'}},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {kind: 'Field', name: {kind: 'Name', value: 'id'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'searchResultBrand'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                {kind: 'Field', name: {kind: 'Name', value: 'logoImageSrc'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
          {kind: 'Field', name: {kind: 'Name', value: 'name'}},
          {kind: 'Field', name: {kind: 'Name', value: 'imageSrc'}},
          {kind: 'Field', name: {kind: 'Name', value: 'urlId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'distance'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isNew'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isSavedCaterer'}},
          {kind: 'Field', name: {kind: 'Name', value: 'isReliabilityRockstar'}},
          {kind: 'Field', name: {kind: 'Name', value: 'priceRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'starRating'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'slotReservation'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {kind: 'Name', value: 'SponsoredListingReservation'},
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{kind: 'Field', name: {kind: 'Name', value: 'topsortBidId'}}],
                  },
                },
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'topsortProductId'}},
          {kind: 'Field', name: {kind: 'Name', value: 'cacheKey'}},
          {kind: 'Field', name: {kind: 'Name', value: 'reviewCount'}},
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'deliveryFee'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'takeoutMinimum'},
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: 'subunits'}},
                {kind: 'Field', name: {kind: 'Name', value: 'currency'}},
              ],
            },
          },
          {kind: 'Field', name: {kind: 'Name', value: 'variableDeliveryFee'}},
          {kind: 'Field', name: {kind: 'Name', value: 'onTimeRating'}},
          {kind: 'Field', name: {kind: 'Name', value: 'lastOrderAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestBrandReviewText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestBrandReviewAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestReviewText'}},
          {kind: 'Field', name: {kind: 'Name', value: 'latestReviewAt'}},
          {kind: 'Field', name: {kind: 'Name', value: 'repeatUserRate'}},
          {kind: 'Field', name: {kind: 'Name', value: 'rewardsLevel'}},
          {kind: 'Field', name: {kind: 'Name', value: 'sponsoredPromoTitles'}},
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useZeroSearchResultsSearchQuery__
 *
 * To run a query within a React component, call `useZeroSearchResultsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useZeroSearchResultsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZeroSearchResultsSearchQuery({
 *   variables: {
 *      address: // value for 'address'
 *      eventDateTime: // value for 'eventDateTime'
 *      eventTime: // value for 'eventTime'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      orderType: // value for 'orderType'
 *      skipSearchTracking: // value for 'skipSearchTracking'
 *      trackingId: // value for 'trackingId'
 *   },
 * });
 */
export function useZeroSearchResultsSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    ZeroSearchResultsSearchQuery,
    ZeroSearchResultsSearchQueryVariables
  > &
    ({variables: ZeroSearchResultsSearchQueryVariables; skip?: boolean} | {skip: boolean}),
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<ZeroSearchResultsSearchQuery, ZeroSearchResultsSearchQueryVariables>(
    ZeroSearchResultsSearchQueryDocument,
    options,
  );
}
export function useZeroSearchResultsSearchQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZeroSearchResultsSearchQuery,
    ZeroSearchResultsSearchQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<ZeroSearchResultsSearchQuery, ZeroSearchResultsSearchQueryVariables>(
    ZeroSearchResultsSearchQueryDocument,
    options,
  );
}
// @ts-ignore
export function useZeroSearchResultsSearchQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ZeroSearchResultsSearchQuery,
    ZeroSearchResultsSearchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ZeroSearchResultsSearchQuery,
  ZeroSearchResultsSearchQueryVariables
>;
export function useZeroSearchResultsSearchQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZeroSearchResultsSearchQuery,
        ZeroSearchResultsSearchQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ZeroSearchResultsSearchQuery | undefined,
  ZeroSearchResultsSearchQueryVariables
>;
export function useZeroSearchResultsSearchQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ZeroSearchResultsSearchQuery,
        ZeroSearchResultsSearchQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions};
  return Apollo.useSuspenseQuery<
    ZeroSearchResultsSearchQuery,
    ZeroSearchResultsSearchQueryVariables
  >(ZeroSearchResultsSearchQueryDocument, options);
}
export type ZeroSearchResultsSearchQueryHookResult = ReturnType<
  typeof useZeroSearchResultsSearchQuery
>;
export type ZeroSearchResultsSearchQueryLazyQueryHookResult = ReturnType<
  typeof useZeroSearchResultsSearchQueryLazyQuery
>;
export type ZeroSearchResultsSearchQuerySuspenseQueryHookResult = ReturnType<
  typeof useZeroSearchResultsSearchQuerySuspenseQuery
>;
export type ZeroSearchResultsSearchQueryQueryResult = Apollo.QueryResult<
  ZeroSearchResultsSearchQuery,
  ZeroSearchResultsSearchQueryVariables
>;
